(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8iuUi", function(module, exports) {

$parcel$export(module.exports, "html", () => html);
$parcel$export(module.exports, "xml", () => xml);
$parcel$export(module.exports, "text", () => text);
$parcel$export(module.exports, "parseHTML", () => parseHTML);
$parcel$export(module.exports, "root", () => root);
$parcel$export(module.exports, "contains", () => contains);
$parcel$export(module.exports, "merge", () => merge);
parcelRequire("a45mF");
var $dzgAU = parcelRequire("dzgAU");

var $hAHiP = parcelRequire("hAHiP");
/**
 * Helper function to render a DOM.
 *
 * @param that - Cheerio instance to render.
 * @param dom - The DOM to render. Defaults to `that`'s root.
 * @param options - Options for rendering.
 * @returns The rendered document.
 */ function render(that, dom, options) {
    if (!that) return '';
    return that(dom !== null && dom !== void 0 ? dom : that._root.children, null, undefined, options).toString();
}
/**
 * Checks if a passed object is an options object.
 *
 * @param dom - Object to check if it is an options object.
 * @returns Whether the object is an options object.
 */ function isOptions(dom, options) {
    return !options && typeof dom === 'object' && dom != null && !('length' in dom) && !('type' in dom);
}
function html(dom, options) {
    /*
     * Be flexible about parameters, sometimes we call html(),
     * with options as only parameter
     * check dom argument for dom element specific properties
     * assume there is no 'length' or 'type' properties in the options object
     */ const toRender = isOptions(dom) ? (options = dom, undefined) : dom;
    /*
     * Sometimes `$.html()` is used without preloading html,
     * so fallback non-existing options to the default ones.
     */ const opts = {
        ...(0, $hAHiP.default),
        ...this === null || this === void 0 ? void 0 : this._options,
        ...(0, $hAHiP.flatten)(options !== null && options !== void 0 ? options : {})
    };
    return render(this, toRender, opts);
}
function xml(dom) {
    const options = {
        ...this._options,
        xmlMode: true
    };
    return render(this, dom, options);
}
function text(elements) {
    const elems = elements ? elements : this ? this.root() : [];
    let ret = '';
    for(let i = 0; i < elems.length; i++)ret += (0, $dzgAU.textContent)(elems[i]);
    return ret;
}
function parseHTML(data, context, keepScripts = typeof context === 'boolean' ? context : false) {
    if (!data || typeof data !== 'string') return null;
    if (typeof context === 'boolean') keepScripts = context;
    const parsed = this.load(data, (0, $hAHiP.default), false);
    if (!keepScripts) parsed('script').remove();
    /*
     * The `children` array is used by Cheerio internally to group elements that
     * share the same parents. When nodes created through `parseHTML` are
     * inserted into previously-existing DOM structures, they will be removed
     * from the `children` array. The results of `parseHTML` should remain
     * constant across these operations, so a shallow copy should be returned.
     */ return parsed.root()[0].children.slice();
}
function root() {
    return this(this._root);
}
function contains(container, contained) {
    // According to the jQuery API, an element does not "contain" itself
    if (contained === container) return false;
    /*
     * Step up the descendants, stopping when the root element is reached
     * (signaled by `.parent` returning a reference to the same object)
     */ let next = contained;
    while(next && next !== next.parent){
        next = next.parent;
        if (next === container) return true;
    }
    return false;
}
function merge(arr1, arr2) {
    if (!isArrayLike(arr1) || !isArrayLike(arr2)) return;
    let newLength = arr1.length;
    const len = +arr2.length;
    for(let i = 0; i < len; i++)arr1[newLength++] = arr2[i];
    arr1.length = newLength;
    return arr1;
}
/**
 * Checks if an object is array-like.
 *
 * @param item - Item to check.
 * @returns Indicates if the item is array-like.
 */ function isArrayLike(item) {
    if (Array.isArray(item)) return true;
    if (typeof item !== 'object' || !Object.prototype.hasOwnProperty.call(item, 'length') || typeof item.length !== 'number' || item.length < 0) return false;
    for(let i = 0; i < item.length; i++){
        if (!(i in item)) return false;
    }
    return true;
}

});
parcelRegister("a45mF", function(module, exports) {

$parcel$export(module.exports, "isTag", () => (parcelRequire("k9MHs")).isTag);
$parcel$export(module.exports, "isCDATA", () => (parcelRequire("k9MHs")).isCDATA);
$parcel$export(module.exports, "isText", () => (parcelRequire("k9MHs")).isText);
$parcel$export(module.exports, "isComment", () => (parcelRequire("k9MHs")).isComment);
$parcel$export(module.exports, "isDocument", () => (parcelRequire("k9MHs")).isDocument);
$parcel$export(module.exports, "hasChildren", () => (parcelRequire("k9MHs")).hasChildren);

var $dzgAU = parcelRequire("dzgAU");

var $8DVmQ = parcelRequire("8DVmQ");

var $itbnG = parcelRequire("itbnG");

var $8YbwJ = parcelRequire("8YbwJ");

var $0bNle = parcelRequire("0bNle");

var $7fM7F = parcelRequire("7fM7F");

var $iG8B0 = parcelRequire("iG8B0");
parcelRequire("273yd");
var $k9MHs = parcelRequire("k9MHs");
$parcel$exportWildcard(module.exports, $dzgAU);
$parcel$exportWildcard(module.exports, $8DVmQ);
$parcel$exportWildcard(module.exports, $itbnG);
$parcel$exportWildcard(module.exports, $8YbwJ);
$parcel$exportWildcard(module.exports, $0bNle);
$parcel$exportWildcard(module.exports, $7fM7F);
$parcel$exportWildcard(module.exports, $iG8B0);

});
parcelRegister("dzgAU", function(module, exports) {

$parcel$export(module.exports, "getOuterHTML", () => $9e0b6a8a33e671ae$export$39484b727cc2f324);
$parcel$export(module.exports, "getInnerHTML", () => $9e0b6a8a33e671ae$export$7ed15b4d2218408);
$parcel$export(module.exports, "getText", () => $9e0b6a8a33e671ae$export$c72d34660a162238);
$parcel$export(module.exports, "textContent", () => $9e0b6a8a33e671ae$export$e0e0794250e9118f);
$parcel$export(module.exports, "innerText", () => $9e0b6a8a33e671ae$export$5864bc2a45f1eb81);
parcelRequire("273yd");
var $k9MHs = parcelRequire("k9MHs");

var $iwhG6 = parcelRequire("iwhG6");

var $1RLFx = parcelRequire("1RLFx");
function $9e0b6a8a33e671ae$export$39484b727cc2f324(node, options) {
    return (0, $iwhG6.default)(node, options);
}
function $9e0b6a8a33e671ae$export$7ed15b4d2218408(node, options) {
    return (0, $k9MHs.hasChildren)(node) ? node.children.map((node)=>$9e0b6a8a33e671ae$export$39484b727cc2f324(node, options)).join("") : "";
}
function $9e0b6a8a33e671ae$export$c72d34660a162238(node) {
    if (Array.isArray(node)) return node.map($9e0b6a8a33e671ae$export$c72d34660a162238).join("");
    if ((0, $k9MHs.isTag)(node)) return node.name === "br" ? "\n" : $9e0b6a8a33e671ae$export$c72d34660a162238(node.children);
    if ((0, $k9MHs.isCDATA)(node)) return $9e0b6a8a33e671ae$export$c72d34660a162238(node.children);
    if ((0, $k9MHs.isText)(node)) return node.data;
    return "";
}
function $9e0b6a8a33e671ae$export$e0e0794250e9118f(node) {
    if (Array.isArray(node)) return node.map($9e0b6a8a33e671ae$export$e0e0794250e9118f).join("");
    if ((0, $k9MHs.hasChildren)(node) && !(0, $k9MHs.isComment)(node)) return $9e0b6a8a33e671ae$export$e0e0794250e9118f(node.children);
    if ((0, $k9MHs.isText)(node)) return node.data;
    return "";
}
function $9e0b6a8a33e671ae$export$5864bc2a45f1eb81(node) {
    if (Array.isArray(node)) return node.map($9e0b6a8a33e671ae$export$5864bc2a45f1eb81).join("");
    if ((0, $k9MHs.hasChildren)(node) && (node.type === (0, $1RLFx.ElementType).Tag || (0, $k9MHs.isCDATA)(node))) return $9e0b6a8a33e671ae$export$5864bc2a45f1eb81(node.children);
    if ((0, $k9MHs.isText)(node)) return node.data;
    return "";
}

});
parcelRegister("273yd", function(module, exports) {
$parcel$export(module.exports, "CDATA", () => (parcelRequire("k9MHs")).CDATA);
$parcel$export(module.exports, "cloneNode", () => (parcelRequire("k9MHs")).cloneNode);
$parcel$export(module.exports, "Comment", () => (parcelRequire("k9MHs")).Comment);
$parcel$export(module.exports, "Document", () => (parcelRequire("k9MHs")).Document);
$parcel$export(module.exports, "Element", () => (parcelRequire("k9MHs")).Element);
$parcel$export(module.exports, "hasChildren", () => (parcelRequire("k9MHs")).hasChildren);
$parcel$export(module.exports, "isCDATA", () => (parcelRequire("k9MHs")).isCDATA);
$parcel$export(module.exports, "isComment", () => (parcelRequire("k9MHs")).isComment);
$parcel$export(module.exports, "isDirective", () => (parcelRequire("k9MHs")).isDirective);
$parcel$export(module.exports, "isDocument", () => (parcelRequire("k9MHs")).isDocument);
$parcel$export(module.exports, "isTag", () => (parcelRequire("k9MHs")).isTag);
$parcel$export(module.exports, "isText", () => (parcelRequire("k9MHs")).isText);
$parcel$export(module.exports, "ProcessingInstruction", () => (parcelRequire("k9MHs")).ProcessingInstruction);
$parcel$export(module.exports, "Text", () => (parcelRequire("k9MHs")).Text);

$parcel$export(module.exports, "DomHandler", () => $189efd556b5722e0$export$ff8ccbac9225de62);

var $1RLFx = parcelRequire("1RLFx");

var $k9MHs = parcelRequire("k9MHs");
// Default options
const $189efd556b5722e0$var$defaultOpts = {
    withStartIndices: false,
    withEndIndices: false,
    xmlMode: false
};
class $189efd556b5722e0$export$ff8ccbac9225de62 {
    /**
     * @param callback Called once parsing has completed.
     * @param options Settings for the handler.
     * @param elementCB Callback whenever a tag is closed.
     */ constructor(callback, options, elementCB){
        /** The elements of the DOM */ this.dom = [];
        /** The root element for the DOM */ this.root = new (0, $k9MHs.Document)(this.dom);
        /** Indicated whether parsing has been completed. */ this.done = false;
        /** Stack of open tags. */ this.tagStack = [
            this.root
        ];
        /** A data node that is still being written to. */ this.lastNode = null;
        /** Reference to the parser instance. Used for location information. */ this.parser = null;
        // Make it possible to skip arguments, for backwards-compatibility
        if (typeof options === "function") {
            elementCB = options;
            options = $189efd556b5722e0$var$defaultOpts;
        }
        if (typeof callback === "object") {
            options = callback;
            callback = undefined;
        }
        this.callback = callback !== null && callback !== void 0 ? callback : null;
        this.options = options !== null && options !== void 0 ? options : $189efd556b5722e0$var$defaultOpts;
        this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
    }
    onparserinit(parser) {
        this.parser = parser;
    }
    // Resets the handler back to starting state
    onreset() {
        this.dom = [];
        this.root = new (0, $k9MHs.Document)(this.dom);
        this.done = false;
        this.tagStack = [
            this.root
        ];
        this.lastNode = null;
        this.parser = null;
    }
    // Signals the handler that parsing is done
    onend() {
        if (this.done) return;
        this.done = true;
        this.parser = null;
        this.handleCallback(null);
    }
    onerror(error) {
        this.handleCallback(error);
    }
    onclosetag() {
        this.lastNode = null;
        const elem = this.tagStack.pop();
        if (this.options.withEndIndices) elem.endIndex = this.parser.endIndex;
        if (this.elementCB) this.elementCB(elem);
    }
    onopentag(name, attribs) {
        const type = this.options.xmlMode ? (0, $1RLFx.ElementType).Tag : undefined;
        const element = new (0, $k9MHs.Element)(name, attribs, undefined, type);
        this.addNode(element);
        this.tagStack.push(element);
    }
    ontext(data) {
        const { lastNode: lastNode } = this;
        if (lastNode && lastNode.type === (0, $1RLFx.ElementType).Text) {
            lastNode.data += data;
            if (this.options.withEndIndices) lastNode.endIndex = this.parser.endIndex;
        } else {
            const node = new (0, $k9MHs.Text)(data);
            this.addNode(node);
            this.lastNode = node;
        }
    }
    oncomment(data) {
        if (this.lastNode && this.lastNode.type === (0, $1RLFx.ElementType).Comment) {
            this.lastNode.data += data;
            return;
        }
        const node = new (0, $k9MHs.Comment)(data);
        this.addNode(node);
        this.lastNode = node;
    }
    oncommentend() {
        this.lastNode = null;
    }
    oncdatastart() {
        const text = new (0, $k9MHs.Text)("");
        const node = new (0, $k9MHs.CDATA)([
            text
        ]);
        this.addNode(node);
        text.parent = node;
        this.lastNode = text;
    }
    oncdataend() {
        this.lastNode = null;
    }
    onprocessinginstruction(name, data) {
        const node = new (0, $k9MHs.ProcessingInstruction)(name, data);
        this.addNode(node);
    }
    handleCallback(error) {
        if (typeof this.callback === "function") this.callback(error, this.dom);
        else if (error) throw error;
    }
    addNode(node) {
        const parent = this.tagStack[this.tagStack.length - 1];
        const previousSibling = parent.children[parent.children.length - 1];
        if (this.options.withStartIndices) node.startIndex = this.parser.startIndex;
        if (this.options.withEndIndices) node.endIndex = this.parser.endIndex;
        parent.children.push(node);
        if (previousSibling) {
            node.prev = previousSibling;
            previousSibling.next = node;
        }
        node.parent = parent;
        this.lastNode = null;
    }
}
var $189efd556b5722e0$export$2e2bcd8739ae039 = $189efd556b5722e0$export$ff8ccbac9225de62;

});
parcelRegister("1RLFx", function(module, exports) {

$parcel$export(module.exports, "ElementType", () => $15bfb7bf4e445d41$export$b992dc138d950e31);
$parcel$export(module.exports, "isTag", () => $15bfb7bf4e445d41$export$3bf645f08efe3292);
$parcel$export(module.exports, "Root", () => $15bfb7bf4e445d41$export$be92b6f5f03c0fe9);
$parcel$export(module.exports, "Text", () => $15bfb7bf4e445d41$export$5f1af8db9871e1d6);
$parcel$export(module.exports, "Directive", () => $15bfb7bf4e445d41$export$befdefbdce210f91);
$parcel$export(module.exports, "Comment", () => $15bfb7bf4e445d41$export$4d299b491347818a);
$parcel$export(module.exports, "Script", () => $15bfb7bf4e445d41$export$2f8b47a141e57afc);
$parcel$export(module.exports, "Style", () => $15bfb7bf4e445d41$export$d9e45bc13d335801);
$parcel$export(module.exports, "Tag", () => $15bfb7bf4e445d41$export$3288d34c523a1192);
$parcel$export(module.exports, "CDATA", () => $15bfb7bf4e445d41$export$1f8b8f7e5c763232);
$parcel$export(module.exports, "Doctype", () => $15bfb7bf4e445d41$export$31b44af36ff2c60f);
/** Types of elements found in htmlparser2's DOM */ var $15bfb7bf4e445d41$export$b992dc138d950e31;
(function(ElementType) {
    /** Type for the root element of a document */ ElementType["Root"] = "root";
    /** Type for Text */ ElementType["Text"] = "text";
    /** Type for <? ... ?> */ ElementType["Directive"] = "directive";
    /** Type for <!-- ... --> */ ElementType["Comment"] = "comment";
    /** Type for <script> tags */ ElementType["Script"] = "script";
    /** Type for <style> tags */ ElementType["Style"] = "style";
    /** Type for Any tag */ ElementType["Tag"] = "tag";
    /** Type for <![CDATA[ ... ]]> */ ElementType["CDATA"] = "cdata";
    /** Type for <!doctype ...> */ ElementType["Doctype"] = "doctype";
})($15bfb7bf4e445d41$export$b992dc138d950e31 || ($15bfb7bf4e445d41$export$b992dc138d950e31 = {}));
function $15bfb7bf4e445d41$export$3bf645f08efe3292(elem) {
    return elem.type === $15bfb7bf4e445d41$export$b992dc138d950e31.Tag || elem.type === $15bfb7bf4e445d41$export$b992dc138d950e31.Script || elem.type === $15bfb7bf4e445d41$export$b992dc138d950e31.Style;
}
const $15bfb7bf4e445d41$export$be92b6f5f03c0fe9 = $15bfb7bf4e445d41$export$b992dc138d950e31.Root;
const $15bfb7bf4e445d41$export$5f1af8db9871e1d6 = $15bfb7bf4e445d41$export$b992dc138d950e31.Text;
const $15bfb7bf4e445d41$export$befdefbdce210f91 = $15bfb7bf4e445d41$export$b992dc138d950e31.Directive;
const $15bfb7bf4e445d41$export$4d299b491347818a = $15bfb7bf4e445d41$export$b992dc138d950e31.Comment;
const $15bfb7bf4e445d41$export$2f8b47a141e57afc = $15bfb7bf4e445d41$export$b992dc138d950e31.Script;
const $15bfb7bf4e445d41$export$d9e45bc13d335801 = $15bfb7bf4e445d41$export$b992dc138d950e31.Style;
const $15bfb7bf4e445d41$export$3288d34c523a1192 = $15bfb7bf4e445d41$export$b992dc138d950e31.Tag;
const $15bfb7bf4e445d41$export$1f8b8f7e5c763232 = $15bfb7bf4e445d41$export$b992dc138d950e31.CDATA;
const $15bfb7bf4e445d41$export$31b44af36ff2c60f = $15bfb7bf4e445d41$export$b992dc138d950e31.Doctype;

});

parcelRegister("k9MHs", function(module, exports) {

$parcel$export(module.exports, "cloneNode", () => $eaca6cb3463b95ab$export$ae8e35ea29ddac22);
$parcel$export(module.exports, "Text", () => $eaca6cb3463b95ab$export$5f1af8db9871e1d6);
$parcel$export(module.exports, "Comment", () => $eaca6cb3463b95ab$export$4d299b491347818a);
$parcel$export(module.exports, "ProcessingInstruction", () => $eaca6cb3463b95ab$export$9269dce19ee35e96);
$parcel$export(module.exports, "CDATA", () => $eaca6cb3463b95ab$export$1f8b8f7e5c763232);
$parcel$export(module.exports, "Document", () => $eaca6cb3463b95ab$export$b34a105447964f9f);
$parcel$export(module.exports, "Element", () => $eaca6cb3463b95ab$export$db77ccec0bb4ccac);
$parcel$export(module.exports, "isTag", () => $eaca6cb3463b95ab$export$3bf645f08efe3292);
$parcel$export(module.exports, "isCDATA", () => $eaca6cb3463b95ab$export$c2d65aed98d39b56);
$parcel$export(module.exports, "isText", () => $eaca6cb3463b95ab$export$1879817ac5c922b7);
$parcel$export(module.exports, "isComment", () => $eaca6cb3463b95ab$export$3ab01370f5e64ac8);
$parcel$export(module.exports, "isDirective", () => $eaca6cb3463b95ab$export$4b5d79f26e0e3ad5);
$parcel$export(module.exports, "isDocument", () => $eaca6cb3463b95ab$export$62858bae88b53fd0);
$parcel$export(module.exports, "hasChildren", () => $eaca6cb3463b95ab$export$bd5ff50f0e53d41c);

var $1RLFx = parcelRequire("1RLFx");
class $eaca6cb3463b95ab$export$85c928794f8d04d4 {
    constructor(){
        /** Parent of the node */ this.parent = null;
        /** Previous sibling */ this.prev = null;
        /** Next sibling */ this.next = null;
        /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */ this.startIndex = null;
        /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */ this.endIndex = null;
    }
    // Read-write aliases for properties
    /**
     * Same as {@link parent}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get parentNode() {
        return this.parent;
    }
    set parentNode(parent) {
        this.parent = parent;
    }
    /**
     * Same as {@link prev}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get previousSibling() {
        return this.prev;
    }
    set previousSibling(prev) {
        this.prev = prev;
    }
    /**
     * Same as {@link next}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get nextSibling() {
        return this.next;
    }
    set nextSibling(next) {
        this.next = next;
    }
    /**
     * Clone this node, and optionally its children.
     *
     * @param recursive Clone child nodes as well.
     * @returns A clone of the node.
     */ cloneNode(recursive = false) {
        return $eaca6cb3463b95ab$export$ae8e35ea29ddac22(this, recursive);
    }
}
class $eaca6cb3463b95ab$export$c3569d91cd44d357 extends $eaca6cb3463b95ab$export$85c928794f8d04d4 {
    /**
     * @param data The content of the data node
     */ constructor(data){
        super();
        this.data = data;
    }
    /**
     * Same as {@link data}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get nodeValue() {
        return this.data;
    }
    set nodeValue(data) {
        this.data = data;
    }
}
class $eaca6cb3463b95ab$export$5f1af8db9871e1d6 extends $eaca6cb3463b95ab$export$c3569d91cd44d357 {
    constructor(){
        super(...arguments);
        this.type = (0, $1RLFx.ElementType).Text;
    }
    get nodeType() {
        return 3;
    }
}
class $eaca6cb3463b95ab$export$4d299b491347818a extends $eaca6cb3463b95ab$export$c3569d91cd44d357 {
    constructor(){
        super(...arguments);
        this.type = (0, $1RLFx.ElementType).Comment;
    }
    get nodeType() {
        return 8;
    }
}
class $eaca6cb3463b95ab$export$9269dce19ee35e96 extends $eaca6cb3463b95ab$export$c3569d91cd44d357 {
    constructor(name, data){
        super(data);
        this.name = name;
        this.type = (0, $1RLFx.ElementType).Directive;
    }
    get nodeType() {
        return 1;
    }
}
class $eaca6cb3463b95ab$export$62be934f90997196 extends $eaca6cb3463b95ab$export$85c928794f8d04d4 {
    /**
     * @param children Children of the node. Only certain node types can have children.
     */ constructor(children){
        super();
        this.children = children;
    }
    // Aliases
    /** First child of the node. */ get firstChild() {
        var _a;
        return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
    }
    /** Last child of the node. */ get lastChild() {
        return this.children.length > 0 ? this.children[this.children.length - 1] : null;
    }
    /**
     * Same as {@link children}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get childNodes() {
        return this.children;
    }
    set childNodes(children) {
        this.children = children;
    }
}
class $eaca6cb3463b95ab$export$1f8b8f7e5c763232 extends $eaca6cb3463b95ab$export$62be934f90997196 {
    constructor(){
        super(...arguments);
        this.type = (0, $1RLFx.ElementType).CDATA;
    }
    get nodeType() {
        return 4;
    }
}
class $eaca6cb3463b95ab$export$b34a105447964f9f extends $eaca6cb3463b95ab$export$62be934f90997196 {
    constructor(){
        super(...arguments);
        this.type = (0, $1RLFx.ElementType).Root;
    }
    get nodeType() {
        return 9;
    }
}
class $eaca6cb3463b95ab$export$db77ccec0bb4ccac extends $eaca6cb3463b95ab$export$62be934f90997196 {
    /**
     * @param name Name of the tag, eg. `div`, `span`.
     * @param attribs Object mapping attribute names to attribute values.
     * @param children Children of the node.
     */ constructor(name, attribs, children = [], type = name === "script" ? (0, $1RLFx.ElementType).Script : name === "style" ? (0, $1RLFx.ElementType).Style : (0, $1RLFx.ElementType).Tag){
        super(children);
        this.name = name;
        this.attribs = attribs;
        this.type = type;
    }
    get nodeType() {
        return 1;
    }
    // DOM Level 1 aliases
    /**
     * Same as {@link name}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get tagName() {
        return this.name;
    }
    set tagName(name) {
        this.name = name;
    }
    get attributes() {
        return Object.keys(this.attribs).map((name)=>{
            var _a, _b;
            return {
                name: name,
                value: this.attribs[name],
                namespace: (_a = this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
                prefix: (_b = this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name]
            };
        });
    }
}
function $eaca6cb3463b95ab$export$3bf645f08efe3292(node) {
    return (0, $1RLFx.isTag)(node);
}
function $eaca6cb3463b95ab$export$c2d65aed98d39b56(node) {
    return node.type === (0, $1RLFx.ElementType).CDATA;
}
function $eaca6cb3463b95ab$export$1879817ac5c922b7(node) {
    return node.type === (0, $1RLFx.ElementType).Text;
}
function $eaca6cb3463b95ab$export$3ab01370f5e64ac8(node) {
    return node.type === (0, $1RLFx.ElementType).Comment;
}
function $eaca6cb3463b95ab$export$4b5d79f26e0e3ad5(node) {
    return node.type === (0, $1RLFx.ElementType).Directive;
}
function $eaca6cb3463b95ab$export$62858bae88b53fd0(node) {
    return node.type === (0, $1RLFx.ElementType).Root;
}
function $eaca6cb3463b95ab$export$bd5ff50f0e53d41c(node) {
    return Object.prototype.hasOwnProperty.call(node, "children");
}
function $eaca6cb3463b95ab$export$ae8e35ea29ddac22(node, recursive = false) {
    let result;
    if ($eaca6cb3463b95ab$export$1879817ac5c922b7(node)) result = new $eaca6cb3463b95ab$export$5f1af8db9871e1d6(node.data);
    else if ($eaca6cb3463b95ab$export$3ab01370f5e64ac8(node)) result = new $eaca6cb3463b95ab$export$4d299b491347818a(node.data);
    else if ($eaca6cb3463b95ab$export$3bf645f08efe3292(node)) {
        const children = recursive ? $eaca6cb3463b95ab$var$cloneChildren(node.children) : [];
        const clone = new $eaca6cb3463b95ab$export$db77ccec0bb4ccac(node.name, {
            ...node.attribs
        }, children);
        children.forEach((child)=>child.parent = clone);
        if (node.namespace != null) clone.namespace = node.namespace;
        if (node["x-attribsNamespace"]) clone["x-attribsNamespace"] = {
            ...node["x-attribsNamespace"]
        };
        if (node["x-attribsPrefix"]) clone["x-attribsPrefix"] = {
            ...node["x-attribsPrefix"]
        };
        result = clone;
    } else if ($eaca6cb3463b95ab$export$c2d65aed98d39b56(node)) {
        const children = recursive ? $eaca6cb3463b95ab$var$cloneChildren(node.children) : [];
        const clone = new $eaca6cb3463b95ab$export$1f8b8f7e5c763232(children);
        children.forEach((child)=>child.parent = clone);
        result = clone;
    } else if ($eaca6cb3463b95ab$export$62858bae88b53fd0(node)) {
        const children = recursive ? $eaca6cb3463b95ab$var$cloneChildren(node.children) : [];
        const clone = new $eaca6cb3463b95ab$export$b34a105447964f9f(children);
        children.forEach((child)=>child.parent = clone);
        if (node["x-mode"]) clone["x-mode"] = node["x-mode"];
        result = clone;
    } else if ($eaca6cb3463b95ab$export$4b5d79f26e0e3ad5(node)) {
        const instruction = new $eaca6cb3463b95ab$export$9269dce19ee35e96(node.name, node.data);
        if (node["x-name"] != null) {
            instruction["x-name"] = node["x-name"];
            instruction["x-publicId"] = node["x-publicId"];
            instruction["x-systemId"] = node["x-systemId"];
        }
        result = instruction;
    } else throw new Error(`Not implemented yet: ${node.type}`);
    result.startIndex = node.startIndex;
    result.endIndex = node.endIndex;
    if (node.sourceCodeLocation != null) result.sourceCodeLocation = node.sourceCodeLocation;
    return result;
}
function $eaca6cb3463b95ab$var$cloneChildren(childs) {
    const children = childs.map((child)=>$eaca6cb3463b95ab$export$ae8e35ea29ddac22(child, true));
    for(let i = 1; i < children.length; i++){
        children[i].prev = children[i - 1];
        children[i - 1].next = children[i];
    }
    return children;
}

});


parcelRegister("iwhG6", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7b8eda7d7d18f5c$export$2e2bcd8739ae039);
/*
 * Module dependencies
 */ 
var $1RLFx = parcelRequire("1RLFx");
parcelRequire("cAp4G");
var $i7QF4 = parcelRequire("i7QF4");

var $lxSNE = parcelRequire("lxSNE");
const $d7b8eda7d7d18f5c$var$unencodedElements = new Set([
    "style",
    "script",
    "xmp",
    "iframe",
    "noembed",
    "noframes",
    "plaintext",
    "noscript"
]);
function $d7b8eda7d7d18f5c$var$replaceQuotes(value) {
    return value.replace(/"/g, "&quot;");
}
/**
 * Format attributes
 */ function $d7b8eda7d7d18f5c$var$formatAttributes(attributes, opts) {
    var _a;
    if (!attributes) return;
    const encode = ((_a = opts.encodeEntities) !== null && _a !== void 0 ? _a : opts.decodeEntities) === false ? $d7b8eda7d7d18f5c$var$replaceQuotes : opts.xmlMode || opts.encodeEntities !== "utf8" ? (0, $i7QF4.encodeXML) : (0, $i7QF4.escapeAttribute);
    return Object.keys(attributes).map((key)=>{
        var _a, _b;
        const value = (_a = attributes[key]) !== null && _a !== void 0 ? _a : "";
        if (opts.xmlMode === "foreign") /* Fix up mixed-case attribute names */ key = (_b = (0, $lxSNE.attributeNames).get(key)) !== null && _b !== void 0 ? _b : key;
        if (!opts.emptyAttrs && !opts.xmlMode && value === "") return key;
        return `${key}="${encode(value)}"`;
    }).join(" ");
}
/**
 * Self-enclosing tags
 */ const $d7b8eda7d7d18f5c$var$singleTag = new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
]);
function $d7b8eda7d7d18f5c$export$b3890eb0ae9dca99(node, options = {}) {
    const nodes = "length" in node ? node : [
        node
    ];
    let output = "";
    for(let i = 0; i < nodes.length; i++)output += $d7b8eda7d7d18f5c$var$renderNode(nodes[i], options);
    return output;
}
var $d7b8eda7d7d18f5c$export$2e2bcd8739ae039 = $d7b8eda7d7d18f5c$export$b3890eb0ae9dca99;
function $d7b8eda7d7d18f5c$var$renderNode(node, options) {
    switch(node.type){
        case $1RLFx.Root:
            return $d7b8eda7d7d18f5c$export$b3890eb0ae9dca99(node.children, options);
        // @ts-expect-error We don't use `Doctype` yet
        case $1RLFx.Doctype:
        case $1RLFx.Directive:
            return $d7b8eda7d7d18f5c$var$renderDirective(node);
        case $1RLFx.Comment:
            return $d7b8eda7d7d18f5c$var$renderComment(node);
        case $1RLFx.CDATA:
            return $d7b8eda7d7d18f5c$var$renderCdata(node);
        case $1RLFx.Script:
        case $1RLFx.Style:
        case $1RLFx.Tag:
            return $d7b8eda7d7d18f5c$var$renderTag(node, options);
        case $1RLFx.Text:
            return $d7b8eda7d7d18f5c$var$renderText(node, options);
    }
}
const $d7b8eda7d7d18f5c$var$foreignModeIntegrationPoints = new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignObject",
    "desc",
    "title"
]);
const $d7b8eda7d7d18f5c$var$foreignElements = new Set([
    "svg",
    "math"
]);
function $d7b8eda7d7d18f5c$var$renderTag(elem, opts) {
    var _a;
    // Handle SVG / MathML in HTML
    if (opts.xmlMode === "foreign") {
        /* Fix up mixed-case element names */ elem.name = (_a = (0, $lxSNE.elementNames).get(elem.name)) !== null && _a !== void 0 ? _a : elem.name;
        /* Exit foreign mode at integration points */ if (elem.parent && $d7b8eda7d7d18f5c$var$foreignModeIntegrationPoints.has(elem.parent.name)) opts = {
            ...opts,
            xmlMode: false
        };
    }
    if (!opts.xmlMode && $d7b8eda7d7d18f5c$var$foreignElements.has(elem.name)) opts = {
        ...opts,
        xmlMode: "foreign"
    };
    let tag = `<${elem.name}`;
    const attribs = $d7b8eda7d7d18f5c$var$formatAttributes(elem.attribs, opts);
    if (attribs) tag += ` ${attribs}`;
    if (elem.children.length === 0 && (opts.xmlMode ? opts.selfClosingTags !== false : opts.selfClosingTags && $d7b8eda7d7d18f5c$var$singleTag.has(elem.name))) {
        if (!opts.xmlMode) tag += " ";
        tag += "/>";
    } else {
        tag += ">";
        if (elem.children.length > 0) tag += $d7b8eda7d7d18f5c$export$b3890eb0ae9dca99(elem.children, opts);
        if (opts.xmlMode || !$d7b8eda7d7d18f5c$var$singleTag.has(elem.name)) tag += `</${elem.name}>`;
    }
    return tag;
}
function $d7b8eda7d7d18f5c$var$renderDirective(elem) {
    return `<${elem.data}>`;
}
function $d7b8eda7d7d18f5c$var$renderText(elem, opts) {
    var _a;
    let data = elem.data || "";
    // If entities weren't decoded, no need to encode them back
    if (((_a = opts.encodeEntities) !== null && _a !== void 0 ? _a : opts.decodeEntities) !== false && !(!opts.xmlMode && elem.parent && $d7b8eda7d7d18f5c$var$unencodedElements.has(elem.parent.name))) data = opts.xmlMode || opts.encodeEntities !== "utf8" ? (0, $i7QF4.encodeXML)(data) : (0, $i7QF4.escapeText)(data);
    return data;
}
function $d7b8eda7d7d18f5c$var$renderCdata(elem) {
    return `<![CDATA[${elem.children[0].data}]]>`;
}
function $d7b8eda7d7d18f5c$var$renderComment(elem) {
    return `<!--${elem.data}-->`;
}

});
parcelRegister("cAp4G", function(module, exports) {

$parcel$export(module.exports, "encodeXML", () => (parcelRequire("i7QF4")).encodeXML);
$parcel$export(module.exports, "escapeAttribute", () => (parcelRequire("i7QF4")).escapeAttribute);
$parcel$export(module.exports, "escapeText", () => (parcelRequire("i7QF4")).escapeText);

var $2vZnL = parcelRequire("2vZnL");

var $6QxPZ = parcelRequire("6QxPZ");

var $i7QF4 = parcelRequire("i7QF4");
var $929c4c22a3253652$export$b8c86583d9718b50;
(function(EntityLevel) {
    /** Support only XML entities. */ EntityLevel[EntityLevel["XML"] = 0] = "XML";
    /** Support HTML entities, which are a superset of XML entities. */ EntityLevel[EntityLevel["HTML"] = 1] = "HTML";
})($929c4c22a3253652$export$b8c86583d9718b50 || ($929c4c22a3253652$export$b8c86583d9718b50 = {}));
var $929c4c22a3253652$export$1851b20d614eb756;
(function(EncodingMode) {
    /**
     * The output is UTF-8 encoded. Only characters that need escaping within
     * XML will be escaped.
     */ EncodingMode[EncodingMode["UTF8"] = 0] = "UTF8";
    /**
     * The output consists only of ASCII characters. Characters that need
     * escaping within HTML, and characters that aren't ASCII characters will
     * be escaped.
     */ EncodingMode[EncodingMode["ASCII"] = 1] = "ASCII";
    /**
     * Encode all characters that have an equivalent entity, as well as all
     * characters that are not ASCII characters.
     */ EncodingMode[EncodingMode["Extensive"] = 2] = "Extensive";
    /**
     * Encode all characters that have to be escaped in HTML attributes,
     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
     */ EncodingMode[EncodingMode["Attribute"] = 3] = "Attribute";
    /**
     * Encode all characters that have to be escaped in HTML text,
     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
     */ EncodingMode[EncodingMode["Text"] = 4] = "Text";
})($929c4c22a3253652$export$1851b20d614eb756 || ($929c4c22a3253652$export$1851b20d614eb756 = {}));
function $929c4c22a3253652$export$2f872c0f2117be69(data, options = $929c4c22a3253652$export$b8c86583d9718b50.XML) {
    const level = typeof options === "number" ? options : options.level;
    if (level === $929c4c22a3253652$export$b8c86583d9718b50.HTML) {
        const mode = typeof options === "object" ? options.mode : undefined;
        return (0, $2vZnL.decodeHTML)(data, mode);
    }
    return (0, $2vZnL.decodeXML)(data);
}
function $929c4c22a3253652$export$c94669f4c7d36be4(data, options = $929c4c22a3253652$export$b8c86583d9718b50.XML) {
    var _a;
    const opts = typeof options === "number" ? {
        level: options
    } : options;
    (_a = opts.mode) !== null && _a !== void 0 ? _a : opts.mode = (0, $2vZnL.DecodingMode).Strict;
    return $929c4c22a3253652$export$2f872c0f2117be69(data, opts);
}
function $929c4c22a3253652$export$c564cdbbe6da493(data, options = $929c4c22a3253652$export$b8c86583d9718b50.XML) {
    const opts = typeof options === "number" ? {
        level: options
    } : options;
    // Mode `UTF8` just escapes XML entities
    if (opts.mode === $929c4c22a3253652$export$1851b20d614eb756.UTF8) return (0, $i7QF4.escapeUTF8)(data);
    if (opts.mode === $929c4c22a3253652$export$1851b20d614eb756.Attribute) return (0, $i7QF4.escapeAttribute)(data);
    if (opts.mode === $929c4c22a3253652$export$1851b20d614eb756.Text) return (0, $i7QF4.escapeText)(data);
    if (opts.level === $929c4c22a3253652$export$b8c86583d9718b50.HTML) {
        if (opts.mode === $929c4c22a3253652$export$1851b20d614eb756.ASCII) return (0, $6QxPZ.encodeNonAsciiHTML)(data);
        return (0, $6QxPZ.encodeHTML)(data);
    }
    // ASCII and Extensive are equivalent
    return (0, $i7QF4.encodeXML)(data);
}

});
parcelRegister("2vZnL", function(module, exports) {

$parcel$export(module.exports, "DecodingMode", () => $1d4e17494442e5eb$export$8c8f129ce60f53c);
$parcel$export(module.exports, "decodeHTML", () => $1d4e17494442e5eb$export$f045cb747ce77a19);
$parcel$export(module.exports, "decodeXML", () => $1d4e17494442e5eb$export$88e3b9643a8bd06e);

var $iedzx = parcelRequire("iedzx");

var $cjXy9 = parcelRequire("cjXy9");

var $1mqh8 = parcelRequire("1mqh8");
var $1d4e17494442e5eb$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["NUM"] = 35] = "NUM";
    CharCodes[CharCodes["SEMI"] = 59] = "SEMI";
    CharCodes[CharCodes["EQUALS"] = 61] = "EQUALS";
    CharCodes[CharCodes["ZERO"] = 48] = "ZERO";
    CharCodes[CharCodes["NINE"] = 57] = "NINE";
    CharCodes[CharCodes["LOWER_A"] = 97] = "LOWER_A";
    CharCodes[CharCodes["LOWER_F"] = 102] = "LOWER_F";
    CharCodes[CharCodes["LOWER_X"] = 120] = "LOWER_X";
    CharCodes[CharCodes["LOWER_Z"] = 122] = "LOWER_Z";
    CharCodes[CharCodes["UPPER_A"] = 65] = "UPPER_A";
    CharCodes[CharCodes["UPPER_F"] = 70] = "UPPER_F";
    CharCodes[CharCodes["UPPER_Z"] = 90] = "UPPER_Z";
})($1d4e17494442e5eb$var$CharCodes || ($1d4e17494442e5eb$var$CharCodes = {}));
/** Bit that needs to be set to convert an upper case ASCII character to lower case */ const $1d4e17494442e5eb$var$TO_LOWER_BIT = 32;
var $1d4e17494442e5eb$export$6a4325c613e0faec;
(function(BinTrieFlags) {
    BinTrieFlags[BinTrieFlags["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
    BinTrieFlags[BinTrieFlags["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
    BinTrieFlags[BinTrieFlags["JUMP_TABLE"] = 127] = "JUMP_TABLE";
})($1d4e17494442e5eb$export$6a4325c613e0faec || ($1d4e17494442e5eb$export$6a4325c613e0faec = {}));
function $1d4e17494442e5eb$var$isNumber(code) {
    return code >= $1d4e17494442e5eb$var$CharCodes.ZERO && code <= $1d4e17494442e5eb$var$CharCodes.NINE;
}
function $1d4e17494442e5eb$var$isHexadecimalCharacter(code) {
    return code >= $1d4e17494442e5eb$var$CharCodes.UPPER_A && code <= $1d4e17494442e5eb$var$CharCodes.UPPER_F || code >= $1d4e17494442e5eb$var$CharCodes.LOWER_A && code <= $1d4e17494442e5eb$var$CharCodes.LOWER_F;
}
function $1d4e17494442e5eb$var$isAsciiAlphaNumeric(code) {
    return code >= $1d4e17494442e5eb$var$CharCodes.UPPER_A && code <= $1d4e17494442e5eb$var$CharCodes.UPPER_Z || code >= $1d4e17494442e5eb$var$CharCodes.LOWER_A && code <= $1d4e17494442e5eb$var$CharCodes.LOWER_Z || $1d4e17494442e5eb$var$isNumber(code);
}
/**
 * Checks if the given character is a valid end character for an entity in an attribute.
 *
 * Attribute values that aren't terminated properly aren't parsed, and shouldn't lead to a parser error.
 * See the example in https://html.spec.whatwg.org/multipage/parsing.html#named-character-reference-state
 */ function $1d4e17494442e5eb$var$isEntityInAttributeInvalidEnd(code) {
    return code === $1d4e17494442e5eb$var$CharCodes.EQUALS || $1d4e17494442e5eb$var$isAsciiAlphaNumeric(code);
}
var $1d4e17494442e5eb$var$EntityDecoderState;
(function(EntityDecoderState) {
    EntityDecoderState[EntityDecoderState["EntityStart"] = 0] = "EntityStart";
    EntityDecoderState[EntityDecoderState["NumericStart"] = 1] = "NumericStart";
    EntityDecoderState[EntityDecoderState["NumericDecimal"] = 2] = "NumericDecimal";
    EntityDecoderState[EntityDecoderState["NumericHex"] = 3] = "NumericHex";
    EntityDecoderState[EntityDecoderState["NamedEntity"] = 4] = "NamedEntity";
})($1d4e17494442e5eb$var$EntityDecoderState || ($1d4e17494442e5eb$var$EntityDecoderState = {}));
var $1d4e17494442e5eb$export$8c8f129ce60f53c;
(function(DecodingMode) {
    /** Entities in text nodes that can end with any character. */ DecodingMode[DecodingMode["Legacy"] = 0] = "Legacy";
    /** Only allow entities terminated with a semicolon. */ DecodingMode[DecodingMode["Strict"] = 1] = "Strict";
    /** Entities in attributes have limitations on ending characters. */ DecodingMode[DecodingMode["Attribute"] = 2] = "Attribute";
})($1d4e17494442e5eb$export$8c8f129ce60f53c || ($1d4e17494442e5eb$export$8c8f129ce60f53c = {}));
class $1d4e17494442e5eb$export$15263a93ff7ec8ba {
    constructor(/** The tree used to decode entities. */ decodeTree, /**
     * The function that is called when a codepoint is decoded.
     *
     * For multi-byte named entities, this will be called multiple times,
     * with the second codepoint, and the same `consumed` value.
     *
     * @param codepoint The decoded codepoint.
     * @param consumed The number of bytes consumed by the decoder.
     */ emitCodePoint, /** An object that is used to produce errors. */ errors){
        this.decodeTree = decodeTree;
        this.emitCodePoint = emitCodePoint;
        this.errors = errors;
        /** The current state of the decoder. */ this.state = $1d4e17494442e5eb$var$EntityDecoderState.EntityStart;
        /** Characters that were consumed while parsing an entity. */ this.consumed = 1;
        /**
         * The result of the entity.
         *
         * Either the result index of a numeric entity, or the codepoint of a
         * numeric entity.
         */ this.result = 0;
        /** The current index in the decode tree. */ this.treeIndex = 0;
        /** The number of characters that were consumed in excess. */ this.excess = 1;
        /** The mode in which the decoder is operating. */ this.decodeMode = $1d4e17494442e5eb$export$8c8f129ce60f53c.Strict;
    }
    /** Resets the instance to make it reusable. */ startEntity(decodeMode) {
        this.decodeMode = decodeMode;
        this.state = $1d4e17494442e5eb$var$EntityDecoderState.EntityStart;
        this.result = 0;
        this.treeIndex = 0;
        this.excess = 1;
        this.consumed = 1;
    }
    /**
     * Write an entity to the decoder. This can be called multiple times with partial entities.
     * If the entity is incomplete, the decoder will return -1.
     *
     * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
     * entity is incomplete, and resume when the next string is written.
     *
     * @param string The string containing the entity (or a continuation of the entity).
     * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ write(str, offset) {
        switch(this.state){
            case $1d4e17494442e5eb$var$EntityDecoderState.EntityStart:
                if (str.charCodeAt(offset) === $1d4e17494442e5eb$var$CharCodes.NUM) {
                    this.state = $1d4e17494442e5eb$var$EntityDecoderState.NumericStart;
                    this.consumed += 1;
                    return this.stateNumericStart(str, offset + 1);
                }
                this.state = $1d4e17494442e5eb$var$EntityDecoderState.NamedEntity;
                return this.stateNamedEntity(str, offset);
            case $1d4e17494442e5eb$var$EntityDecoderState.NumericStart:
                return this.stateNumericStart(str, offset);
            case $1d4e17494442e5eb$var$EntityDecoderState.NumericDecimal:
                return this.stateNumericDecimal(str, offset);
            case $1d4e17494442e5eb$var$EntityDecoderState.NumericHex:
                return this.stateNumericHex(str, offset);
            case $1d4e17494442e5eb$var$EntityDecoderState.NamedEntity:
                return this.stateNamedEntity(str, offset);
        }
    }
    /**
     * Switches between the numeric decimal and hexadecimal states.
     *
     * Equivalent to the `Numeric character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericStart(str, offset) {
        if (offset >= str.length) return -1;
        if ((str.charCodeAt(offset) | $1d4e17494442e5eb$var$TO_LOWER_BIT) === $1d4e17494442e5eb$var$CharCodes.LOWER_X) {
            this.state = $1d4e17494442e5eb$var$EntityDecoderState.NumericHex;
            this.consumed += 1;
            return this.stateNumericHex(str, offset + 1);
        }
        this.state = $1d4e17494442e5eb$var$EntityDecoderState.NumericDecimal;
        return this.stateNumericDecimal(str, offset);
    }
    addToNumericResult(str, start, end, base) {
        if (start !== end) {
            const digitCount = end - start;
            this.result = this.result * Math.pow(base, digitCount) + parseInt(str.substr(start, digitCount), base);
            this.consumed += digitCount;
        }
    }
    /**
     * Parses a hexadecimal numeric entity.
     *
     * Equivalent to the `Hexademical character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericHex(str, offset) {
        const startIdx = offset;
        while(offset < str.length){
            const char = str.charCodeAt(offset);
            if ($1d4e17494442e5eb$var$isNumber(char) || $1d4e17494442e5eb$var$isHexadecimalCharacter(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 16);
                return this.emitNumericEntity(char, 3);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 16);
        return -1;
    }
    /**
     * Parses a decimal numeric entity.
     *
     * Equivalent to the `Decimal character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericDecimal(str, offset) {
        const startIdx = offset;
        while(offset < str.length){
            const char = str.charCodeAt(offset);
            if ($1d4e17494442e5eb$var$isNumber(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 10);
                return this.emitNumericEntity(char, 2);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 10);
        return -1;
    }
    /**
     * Validate and emit a numeric entity.
     *
     * Implements the logic from the `Hexademical character reference start
     * state` and `Numeric character reference end state` in the HTML spec.
     *
     * @param lastCp The last code point of the entity. Used to see if the
     *               entity was terminated with a semicolon.
     * @param expectedLength The minimum number of characters that should be
     *                       consumed. Used to validate that at least one digit
     *                       was consumed.
     * @returns The number of characters that were consumed.
     */ emitNumericEntity(lastCp, expectedLength) {
        var _a;
        // Ensure we consumed at least one digit.
        if (this.consumed <= expectedLength) {
            (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
            return 0;
        }
        // Figure out if this is a legit end of the entity
        if (lastCp === $1d4e17494442e5eb$var$CharCodes.SEMI) this.consumed += 1;
        else if (this.decodeMode === $1d4e17494442e5eb$export$8c8f129ce60f53c.Strict) return 0;
        this.emitCodePoint((0, $1mqh8.replaceCodePoint)(this.result), this.consumed);
        if (this.errors) {
            if (lastCp !== $1d4e17494442e5eb$var$CharCodes.SEMI) this.errors.missingSemicolonAfterCharacterReference();
            this.errors.validateNumericCharacterReference(this.result);
        }
        return this.consumed;
    }
    /**
     * Parses a named entity.
     *
     * Equivalent to the `Named character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNamedEntity(str, offset) {
        const { decodeTree: decodeTree } = this;
        let current = decodeTree[this.treeIndex];
        // The mask is the number of bytes of the value, including the current byte.
        let valueLength = (current & $1d4e17494442e5eb$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
        for(; offset < str.length; offset++, this.excess++){
            const char = str.charCodeAt(offset);
            this.treeIndex = $1d4e17494442e5eb$export$44c08d99945e6276(decodeTree, current, this.treeIndex + Math.max(1, valueLength), char);
            if (this.treeIndex < 0) return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === $1d4e17494442e5eb$export$8c8f129ce60f53c.Attribute && // We shouldn't have consumed any characters after the entity,
            (valueLength === 0 || // And there should be no invalid characters.
            $1d4e17494442e5eb$var$isEntityInAttributeInvalidEnd(char)) ? 0 : this.emitNotTerminatedNamedEntity();
            current = decodeTree[this.treeIndex];
            valueLength = (current & $1d4e17494442e5eb$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
            // If the branch is a value, store it and continue
            if (valueLength !== 0) {
                // If the entity is terminated by a semicolon, we are done.
                if (char === $1d4e17494442e5eb$var$CharCodes.SEMI) return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
                // If we encounter a non-terminated (legacy) entity while parsing strictly, then ignore it.
                if (this.decodeMode !== $1d4e17494442e5eb$export$8c8f129ce60f53c.Strict) {
                    this.result = this.treeIndex;
                    this.consumed += this.excess;
                    this.excess = 0;
                }
            }
        }
        return -1;
    }
    /**
     * Emit a named entity that was not terminated with a semicolon.
     *
     * @returns The number of characters consumed.
     */ emitNotTerminatedNamedEntity() {
        var _a;
        const { result: result, decodeTree: decodeTree } = this;
        const valueLength = (decodeTree[result] & $1d4e17494442e5eb$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
        this.emitNamedEntityData(result, valueLength, this.consumed);
        (_a = this.errors) === null || _a === void 0 || _a.missingSemicolonAfterCharacterReference();
        return this.consumed;
    }
    /**
     * Emit a named entity.
     *
     * @param result The index of the entity in the decode tree.
     * @param valueLength The number of bytes in the entity.
     * @param consumed The number of characters consumed.
     *
     * @returns The number of characters consumed.
     */ emitNamedEntityData(result, valueLength, consumed) {
        const { decodeTree: decodeTree } = this;
        this.emitCodePoint(valueLength === 1 ? decodeTree[result] & ~$1d4e17494442e5eb$export$6a4325c613e0faec.VALUE_LENGTH : decodeTree[result + 1], consumed);
        if (valueLength === 3) // For multi-byte values, we need to emit the second byte.
        this.emitCodePoint(decodeTree[result + 2], consumed);
        return consumed;
    }
    /**
     * Signal to the parser that the end of the input was reached.
     *
     * Remaining data will be emitted and relevant errors will be produced.
     *
     * @returns The number of characters consumed.
     */ end() {
        var _a;
        switch(this.state){
            case $1d4e17494442e5eb$var$EntityDecoderState.NamedEntity:
                // Emit a named entity if we have one.
                return this.result !== 0 && (this.decodeMode !== $1d4e17494442e5eb$export$8c8f129ce60f53c.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
            // Otherwise, emit a numeric entity if we have one.
            case $1d4e17494442e5eb$var$EntityDecoderState.NumericDecimal:
                return this.emitNumericEntity(0, 2);
            case $1d4e17494442e5eb$var$EntityDecoderState.NumericHex:
                return this.emitNumericEntity(0, 3);
            case $1d4e17494442e5eb$var$EntityDecoderState.NumericStart:
                (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
                return 0;
            case $1d4e17494442e5eb$var$EntityDecoderState.EntityStart:
                // Return 0 if we have no entity.
                return 0;
        }
    }
}
/**
 * Creates a function that decodes entities in a string.
 *
 * @param decodeTree The decode tree.
 * @returns A function that decodes entities in a string.
 */ function $1d4e17494442e5eb$var$getDecoder(decodeTree) {
    let ret = "";
    const decoder = new $1d4e17494442e5eb$export$15263a93ff7ec8ba(decodeTree, (str)=>ret += (0, $1mqh8.fromCodePoint)(str));
    return function decodeWithTrie(str, decodeMode) {
        let lastIndex = 0;
        let offset = 0;
        while((offset = str.indexOf("&", offset)) >= 0){
            ret += str.slice(lastIndex, offset);
            decoder.startEntity(decodeMode);
            const len = decoder.write(str, // Skip the "&"
            offset + 1);
            if (len < 0) {
                lastIndex = offset + decoder.end();
                break;
            }
            lastIndex = offset + len;
            // If `len` is 0, skip the current `&` and continue.
            offset = len === 0 ? lastIndex + 1 : lastIndex;
        }
        const result = ret + str.slice(lastIndex);
        // Make sure we don't keep a reference to the final string.
        ret = "";
        return result;
    };
}
function $1d4e17494442e5eb$export$44c08d99945e6276(decodeTree, current, nodeIdx, char) {
    const branchCount = (current & $1d4e17494442e5eb$export$6a4325c613e0faec.BRANCH_LENGTH) >> 7;
    const jumpOffset = current & $1d4e17494442e5eb$export$6a4325c613e0faec.JUMP_TABLE;
    // Case 1: Single branch encoded in jump offset
    if (branchCount === 0) return jumpOffset !== 0 && char === jumpOffset ? nodeIdx : -1;
    // Case 2: Multiple branches encoded in jump table
    if (jumpOffset) {
        const value = char - jumpOffset;
        return value < 0 || value >= branchCount ? -1 : decodeTree[nodeIdx + value] - 1;
    }
    // Case 3: Multiple branches encoded in dictionary
    // Binary search for the character.
    let lo = nodeIdx;
    let hi = lo + branchCount - 1;
    while(lo <= hi){
        const mid = lo + hi >>> 1;
        const midVal = decodeTree[mid];
        if (midVal < char) lo = mid + 1;
        else if (midVal > char) hi = mid - 1;
        else return decodeTree[mid + branchCount];
    }
    return -1;
}
const $1d4e17494442e5eb$var$htmlDecoder = $1d4e17494442e5eb$var$getDecoder((0, $iedzx.default));
const $1d4e17494442e5eb$var$xmlDecoder = $1d4e17494442e5eb$var$getDecoder((0, $cjXy9.default));
function $1d4e17494442e5eb$export$f045cb747ce77a19(str, mode = $1d4e17494442e5eb$export$8c8f129ce60f53c.Legacy) {
    return $1d4e17494442e5eb$var$htmlDecoder(str, mode);
}
function $1d4e17494442e5eb$export$49f5e8089adb006a(str) {
    return $1d4e17494442e5eb$var$htmlDecoder(str, $1d4e17494442e5eb$export$8c8f129ce60f53c.Attribute);
}
function $1d4e17494442e5eb$export$da52f4371b3f37de(str) {
    return $1d4e17494442e5eb$var$htmlDecoder(str, $1d4e17494442e5eb$export$8c8f129ce60f53c.Strict);
}
function $1d4e17494442e5eb$export$88e3b9643a8bd06e(str) {
    return $1d4e17494442e5eb$var$xmlDecoder(str, $1d4e17494442e5eb$export$8c8f129ce60f53c.Strict);
}

});
parcelRegister("iedzx", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4540ff683f7394b$export$2e2bcd8739ae039);
// Generated using scripts/write-decode-map.ts
var $d4540ff683f7394b$export$2e2bcd8739ae039 = new Uint16Array(// prettier-ignore
"\u1d41<\xd5\u0131\u028a\u049d\u057b\u05d0\u0675\u06de\u07a2\u07d6\u080f\u0a4a\u0a91\u0da1\u0e6d\u0f09\u0f26\u10ca\u1228\u12e1\u1415\u149d\u14c3\u14df\u1525\0\0\0\0\0\0\u156b\u16cd\u198d\u1c12\u1ddd\u1f7e\u2060\u21b0\u228d\u23c0\u23fb\u2442\u2824\u2912\u2d08\u2e48\u2fce\u3016\u32ba\u3639\u37ac\u38fe\u3a28\u3a71\u3ae0\u3b2e\u0800EMabcfglmnoprstu\\bfms\x7f\x84\x8b\x90\x95\x98\xa6\xb3\xb9\xc8\xcflig\u803b\xc6\u40c6P\u803b&\u4026cute\u803b\xc1\u40c1reve;\u4102\u0100iyx}rc\u803b\xc2\u40c2;\u4410r;\uc000\ud835\udd04rave\u803b\xc0\u40c0pha;\u4391acr;\u4100d;\u6a53\u0100gp\x9d\xa1on;\u4104f;\uc000\ud835\udd38plyFunction;\u6061ing\u803b\xc5\u40c5\u0100cs\xbe\xc3r;\uc000\ud835\udc9cign;\u6254ilde\u803b\xc3\u40c3ml\u803b\xc4\u40c4\u0400aceforsu\xe5\xfb\xfe\u0117\u011c\u0122\u0127\u012a\u0100cr\xea\xf2kslash;\u6216\u0176\xf6\xf8;\u6ae7ed;\u6306y;\u4411\u0180crt\u0105\u010b\u0114ause;\u6235noullis;\u612ca;\u4392r;\uc000\ud835\udd05pf;\uc000\ud835\udd39eve;\u42d8c\xf2\u0113mpeq;\u624e\u0700HOacdefhilorsu\u014d\u0151\u0156\u0180\u019e\u01a2\u01b5\u01b7\u01ba\u01dc\u0215\u0273\u0278\u027ecy;\u4427PY\u803b\xa9\u40a9\u0180cpy\u015d\u0162\u017aute;\u4106\u0100;i\u0167\u0168\u62d2talDifferentialD;\u6145leys;\u612d\u0200aeio\u0189\u018e\u0194\u0198ron;\u410cdil\u803b\xc7\u40c7rc;\u4108nint;\u6230ot;\u410a\u0100dn\u01a7\u01adilla;\u40b8terDot;\u40b7\xf2\u017fi;\u43a7rcle\u0200DMPT\u01c7\u01cb\u01d1\u01d6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01e2\u01f8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020foubleQuote;\u601duote;\u6019\u0200lnpu\u021e\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6a74\u0180git\u022f\u0236\u023aruent;\u6261nt;\u622fourIntegral;\u622e\u0100fr\u024c\u024e;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6a2fcr;\uc000\ud835\udc9ep\u0100;C\u0284\u0285\u62d3ap;\u624d\u0580DJSZacefios\u02a0\u02ac\u02b0\u02b4\u02b8\u02cb\u02d7\u02e1\u02e6\u0333\u048d\u0100;o\u0179\u02a5trahd;\u6911cy;\u4402cy;\u4405cy;\u440f\u0180grs\u02bf\u02c4\u02c7ger;\u6021r;\u61a1hv;\u6ae4\u0100ay\u02d0\u02d5ron;\u410e;\u4414l\u0100;t\u02dd\u02de\u6207a;\u4394r;\uc000\ud835\udd07\u0100af\u02eb\u0327\u0100cm\u02f0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031ccute;\u40b4o\u0174\u030b\u030d;\u42d9bleAcute;\u42ddrave;\u4060ilde;\u42dcond;\u62c4ferentialD;\u6146\u0470\u033d\0\0\0\u0342\u0354\0\u0405f;\uc000\ud835\udd3b\u0180;DE\u0348\u0349\u034d\u40a8ot;\u60dcqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03cf\u03e2\u03f8ontourIntegra\xec\u0239o\u0274\u0379\0\0\u037b\xbb\u0349nArrow;\u61d3\u0100eo\u0387\u03a4ft\u0180ART\u0390\u0396\u03a1rrow;\u61d0ightArrow;\u61d4e\xe5\u02cang\u0100LR\u03ab\u03c4eft\u0100AR\u03b3\u03b9rrow;\u67f8ightArrow;\u67faightArrow;\u67f9ight\u0100AT\u03d8\u03derrow;\u61d2ee;\u62a8p\u0241\u03e9\0\0\u03efrrow;\u61d1ownArrow;\u61d5erticalBar;\u6225n\u0300ABLRTa\u0412\u042a\u0430\u045e\u047f\u037crrow\u0180;BU\u041d\u041e\u0422\u6193ar;\u6913pArrow;\u61f5reve;\u4311eft\u02d2\u043a\0\u0446\0\u0450ightVector;\u6950eeVector;\u695eector\u0100;B\u0459\u045a\u61bdar;\u6956ight\u01d4\u0467\0\u0471eeVector;\u695fector\u0100;B\u047a\u047b\u61c1ar;\u6957ee\u0100;A\u0486\u0487\u62a4rrow;\u61a7\u0100ct\u0492\u0497r;\uc000\ud835\udc9frok;\u4110\u0800NTacdfglmopqstux\u04bd\u04c0\u04c4\u04cb\u04de\u04e2\u04e7\u04ee\u04f5\u0521\u052f\u0536\u0552\u055d\u0560\u0565G;\u414aH\u803b\xd0\u40d0cute\u803b\xc9\u40c9\u0180aiy\u04d2\u04d7\u04dcron;\u411arc\u803b\xca\u40ca;\u442dot;\u4116r;\uc000\ud835\udd08rave\u803b\xc8\u40c8ement;\u6208\u0100ap\u04fa\u04fecr;\u4112ty\u0253\u0506\0\0\u0512mallSquare;\u65fberySmallSquare;\u65ab\u0100gp\u0526\u052aon;\u4118f;\uc000\ud835\udd3csilon;\u4395u\u0100ai\u053c\u0549l\u0100;T\u0542\u0543\u6a75ilde;\u6242librium;\u61cc\u0100ci\u0557\u055ar;\u6130m;\u6a73a;\u4397ml\u803b\xcb\u40cb\u0100ip\u056a\u056fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058d\u05b2\u05ccy;\u4424r;\uc000\ud835\udd09lled\u0253\u0597\0\0\u05a3mallSquare;\u65fcerySmallSquare;\u65aa\u0370\u05ba\0\u05bf\0\0\u05c4f;\uc000\ud835\udd3dAll;\u6200riertrf;\u6131c\xf2\u05cb\u0600JTabcdfgorst\u05e8\u05ec\u05ef\u05fa\u0600\u0612\u0616\u061b\u061d\u0623\u066c\u0672cy;\u4403\u803b>\u403emma\u0100;d\u05f7\u05f8\u4393;\u43dcreve;\u411e\u0180eiy\u0607\u060c\u0610dil;\u4122rc;\u411c;\u4413ot;\u4120r;\uc000\ud835\udd0a;\u62d9pf;\uc000\ud835\udd3eeater\u0300EFGLST\u0635\u0644\u064e\u0656\u065b\u0666qual\u0100;L\u063e\u063f\u6265ess;\u62dbullEqual;\u6267reater;\u6aa2ess;\u6277lantEqual;\u6a7eilde;\u6273cr;\uc000\ud835\udca2;\u626b\u0400Aacfiosu\u0685\u068b\u0696\u069b\u069e\u06aa\u06be\u06caRDcy;\u442a\u0100ct\u0690\u0694ek;\u42c7;\u405eirc;\u4124r;\u610clbertSpace;\u610b\u01f0\u06af\0\u06b2f;\u610dizontalLine;\u6500\u0100ct\u06c3\u06c5\xf2\u06a9rok;\u4126mp\u0144\u06d0\u06d8ownHum\xf0\u012fqual;\u624f\u0700EJOacdfgmnostu\u06fa\u06fe\u0703\u0707\u070e\u071a\u071e\u0721\u0728\u0744\u0778\u078b\u078f\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803b\xcd\u40cd\u0100iy\u0713\u0718rc\u803b\xce\u40ce;\u4418ot;\u4130r;\u6111rave\u803b\xcc\u40cc\u0180;ap\u0720\u072f\u073f\u0100cg\u0734\u0737r;\u412ainaryI;\u6148lie\xf3\u03dd\u01f4\u0749\0\u0762\u0100;e\u074d\u074e\u622c\u0100gr\u0753\u0758ral;\u622bsection;\u62c2isible\u0100CT\u076c\u0772omma;\u6063imes;\u6062\u0180gpt\u077f\u0783\u0788on;\u412ef;\uc000\ud835\udd40a;\u4399cr;\u6110ilde;\u4128\u01eb\u079a\0\u079ecy;\u4406l\u803b\xcf\u40cf\u0280cfosu\u07ac\u07b7\u07bc\u07c2\u07d0\u0100iy\u07b1\u07b5rc;\u4134;\u4419r;\uc000\ud835\udd0dpf;\uc000\ud835\udd41\u01e3\u07c7\0\u07ccr;\uc000\ud835\udca5rcy;\u4408kcy;\u4404\u0380HJacfos\u07e4\u07e8\u07ec\u07f1\u07fd\u0802\u0808cy;\u4425cy;\u440cppa;\u439a\u0100ey\u07f6\u07fbdil;\u4136;\u441ar;\uc000\ud835\udd0epf;\uc000\ud835\udd42cr;\uc000\ud835\udca6\u0580JTaceflmost\u0825\u0829\u082c\u0850\u0863\u09b3\u09b8\u09c7\u09cd\u0a37\u0a47cy;\u4409\u803b<\u403c\u0280cmnpr\u0837\u083c\u0841\u0844\u084dute;\u4139bda;\u439bg;\u67ealacetrf;\u6112r;\u619e\u0180aey\u0857\u085c\u0861ron;\u413ddil;\u413b;\u441b\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087e\u08a9\u08b1\u08e0\u08e6\u08fc\u092f\u095b\u0390\u096a\u0100nr\u0883\u088fgleBracket;\u67e8row\u0180;BR\u0899\u089a\u089e\u6190ar;\u61e4ightArrow;\u61c6eiling;\u6308o\u01f5\u08b7\0\u08c3bleBracket;\u67e6n\u01d4\u08c8\0\u08d2eeVector;\u6961ector\u0100;B\u08db\u08dc\u61c3ar;\u6959loor;\u630aight\u0100AV\u08ef\u08f5rrow;\u6194ector;\u694e\u0100er\u0901\u0917e\u0180;AV\u0909\u090a\u0910\u62a3rrow;\u61a4ector;\u695aiangle\u0180;BE\u0924\u0925\u0929\u62b2ar;\u69cfqual;\u62b4p\u0180DTV\u0937\u0942\u094cownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61bfar;\u6958ector\u0100;B\u0965\u0966\u61bcar;\u6952ight\xe1\u039cs\u0300EFGLST\u097e\u098b\u0995\u099d\u09a2\u09adqualGreater;\u62daullEqual;\u6266reater;\u6276ess;\u6aa1lantEqual;\u6a7dilde;\u6272r;\uc000\ud835\udd0f\u0100;e\u09bd\u09be\u62d8ftarrow;\u61daidot;\u413f\u0180npw\u09d4\u0a16\u0a1bg\u0200LRlr\u09de\u09f7\u0a02\u0a10eft\u0100AR\u09e6\u09ecrrow;\u67f5ightArrow;\u67f7ightArrow;\u67f6eft\u0100ar\u03b3\u0a0aight\xe1\u03bfight\xe1\u03caf;\uc000\ud835\udd43er\u0100LR\u0a22\u0a2ceftArrow;\u6199ightArrow;\u6198\u0180cht\u0a3e\u0a40\u0a42\xf2\u084c;\u61b0rok;\u4141;\u626a\u0400acefiosu\u0a5a\u0a5d\u0a60\u0a77\u0a7c\u0a85\u0a8b\u0a8ep;\u6905y;\u441c\u0100dl\u0a65\u0a6fiumSpace;\u605flintrf;\u6133r;\uc000\ud835\udd10nusPlus;\u6213pf;\uc000\ud835\udd44c\xf2\u0a76;\u439c\u0480Jacefostu\u0aa3\u0aa7\u0aad\u0ac0\u0b14\u0b19\u0d91\u0d97\u0d9ecy;\u440acute;\u4143\u0180aey\u0ab4\u0ab9\u0aberon;\u4147dil;\u4145;\u441d\u0180gsw\u0ac7\u0af0\u0b0eative\u0180MTV\u0ad3\u0adf\u0ae8ediumSpace;\u600bhi\u0100cn\u0ae6\u0ad8\xeb\u0ad9eryThi\xee\u0ad9ted\u0100GL\u0af8\u0b06reaterGreate\xf2\u0673essLes\xf3\u0a48Line;\u400ar;\uc000\ud835\udd11\u0200Bnpt\u0b22\u0b28\u0b37\u0b3areak;\u6060BreakingSpace;\u40a0f;\u6115\u0680;CDEGHLNPRSTV\u0b55\u0b56\u0b6a\u0b7c\u0ba1\u0beb\u0c04\u0c5e\u0c84\u0ca6\u0cd8\u0d61\u0d85\u6aec\u0100ou\u0b5b\u0b64ngruent;\u6262pCap;\u626doubleVerticalBar;\u6226\u0180lqx\u0b83\u0b8a\u0b9bement;\u6209ual\u0100;T\u0b92\u0b93\u6260ilde;\uc000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0bb6\u0bb7\u0bbd\u0bc9\u0bd3\u0bd8\u0be5\u626fqual;\u6271ullEqual;\uc000\u2267\u0338reater;\uc000\u226b\u0338ess;\u6279lantEqual;\uc000\u2a7e\u0338ilde;\u6275ump\u0144\u0bf2\u0bfdownHump;\uc000\u224e\u0338qual;\uc000\u224f\u0338e\u0100fs\u0c0a\u0c27tTriangle\u0180;BE\u0c1a\u0c1b\u0c21\u62eaar;\uc000\u29cf\u0338qual;\u62ecs\u0300;EGLST\u0c35\u0c36\u0c3c\u0c44\u0c4b\u0c58\u626equal;\u6270reater;\u6278ess;\uc000\u226a\u0338lantEqual;\uc000\u2a7d\u0338ilde;\u6274ested\u0100GL\u0c68\u0c79reaterGreater;\uc000\u2aa2\u0338essLess;\uc000\u2aa1\u0338recedes\u0180;ES\u0c92\u0c93\u0c9b\u6280qual;\uc000\u2aaf\u0338lantEqual;\u62e0\u0100ei\u0cab\u0cb9verseElement;\u620cghtTriangle\u0180;BE\u0ccb\u0ccc\u0cd2\u62ebar;\uc000\u29d0\u0338qual;\u62ed\u0100qu\u0cdd\u0d0cuareSu\u0100bp\u0ce8\u0cf9set\u0100;E\u0cf0\u0cf3\uc000\u228f\u0338qual;\u62e2erset\u0100;E\u0d03\u0d06\uc000\u2290\u0338qual;\u62e3\u0180bcp\u0d13\u0d24\u0d4eset\u0100;E\u0d1b\u0d1e\uc000\u2282\u20d2qual;\u6288ceeds\u0200;EST\u0d32\u0d33\u0d3b\u0d46\u6281qual;\uc000\u2ab0\u0338lantEqual;\u62e1ilde;\uc000\u227f\u0338erset\u0100;E\u0d58\u0d5b\uc000\u2283\u20d2qual;\u6289ilde\u0200;EFT\u0d6e\u0d6f\u0d75\u0d7f\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uc000\ud835\udca9ilde\u803b\xd1\u40d1;\u439d\u0700Eacdfgmoprstuv\u0dbd\u0dc2\u0dc9\u0dd5\u0ddb\u0de0\u0de7\u0dfc\u0e02\u0e20\u0e22\u0e32\u0e3f\u0e44lig;\u4152cute\u803b\xd3\u40d3\u0100iy\u0dce\u0dd3rc\u803b\xd4\u40d4;\u441eblac;\u4150r;\uc000\ud835\udd12rave\u803b\xd2\u40d2\u0180aei\u0dee\u0df2\u0df6cr;\u414cga;\u43a9cron;\u439fpf;\uc000\ud835\udd46enCurly\u0100DQ\u0e0e\u0e1aoubleQuote;\u601cuote;\u6018;\u6a54\u0100cl\u0e27\u0e2cr;\uc000\ud835\udcaaash\u803b\xd8\u40d8i\u016c\u0e37\u0e3cde\u803b\xd5\u40d5es;\u6a37ml\u803b\xd6\u40d6er\u0100BP\u0e4b\u0e60\u0100ar\u0e50\u0e53r;\u603eac\u0100ek\u0e5a\u0e5c;\u63deet;\u63b4arenthesis;\u63dc\u0480acfhilors\u0e7f\u0e87\u0e8a\u0e8f\u0e92\u0e94\u0e9d\u0eb0\u0efcrtialD;\u6202y;\u441fr;\uc000\ud835\udd13i;\u43a6;\u43a0usMinus;\u40b1\u0100ip\u0ea2\u0eadncareplan\xe5\u069df;\u6119\u0200;eio\u0eb9\u0eba\u0ee0\u0ee4\u6abbcedes\u0200;EST\u0ec8\u0ec9\u0ecf\u0eda\u627aqual;\u6aaflantEqual;\u627cilde;\u627eme;\u6033\u0100dp\u0ee9\u0eeeuct;\u620fortion\u0100;a\u0225\u0ef9l;\u621d\u0100ci\u0f01\u0f06r;\uc000\ud835\udcab;\u43a8\u0200Ufos\u0f11\u0f16\u0f1b\u0f1fOT\u803b\"\u4022r;\uc000\ud835\udd14pf;\u611acr;\uc000\ud835\udcac\u0600BEacefhiorsu\u0f3e\u0f43\u0f47\u0f60\u0f73\u0fa7\u0faa\u0fad\u1096\u10a9\u10b4\u10bearr;\u6910G\u803b\xae\u40ae\u0180cnr\u0f4e\u0f53\u0f56ute;\u4154g;\u67ebr\u0100;t\u0f5c\u0f5d\u61a0l;\u6916\u0180aey\u0f67\u0f6c\u0f71ron;\u4158dil;\u4156;\u4420\u0100;v\u0f78\u0f79\u611cerse\u0100EU\u0f82\u0f99\u0100lq\u0f87\u0f8eement;\u620builibrium;\u61cbpEquilibrium;\u696fr\xbb\u0f79o;\u43a1ght\u0400ACDFTUVa\u0fc1\u0feb\u0ff3\u1022\u1028\u105b\u1087\u03d8\u0100nr\u0fc6\u0fd2gleBracket;\u67e9row\u0180;BL\u0fdc\u0fdd\u0fe1\u6192ar;\u61e5eftArrow;\u61c4eiling;\u6309o\u01f5\u0ff9\0\u1005bleBracket;\u67e7n\u01d4\u100a\0\u1014eeVector;\u695dector\u0100;B\u101d\u101e\u61c2ar;\u6955loor;\u630b\u0100er\u102d\u1043e\u0180;AV\u1035\u1036\u103c\u62a2rrow;\u61a6ector;\u695biangle\u0180;BE\u1050\u1051\u1055\u62b3ar;\u69d0qual;\u62b5p\u0180DTV\u1063\u106e\u1078ownVector;\u694feeVector;\u695cector\u0100;B\u1082\u1083\u61bear;\u6954ector\u0100;B\u1091\u1092\u61c0ar;\u6953\u0100pu\u109b\u109ef;\u611dndImplies;\u6970ightarrow;\u61db\u0100ch\u10b9\u10bcr;\u611b;\u61b1leDelayed;\u69f4\u0680HOacfhimoqstu\u10e4\u10f1\u10f7\u10fd\u1119\u111e\u1151\u1156\u1161\u1167\u11b5\u11bb\u11bf\u0100Cc\u10e9\u10eeHcy;\u4429y;\u4428FTcy;\u442ccute;\u415a\u0280;aeiy\u1108\u1109\u110e\u1113\u1117\u6abcron;\u4160dil;\u415erc;\u415c;\u4421r;\uc000\ud835\udd16ort\u0200DLRU\u112a\u1134\u113e\u1149ownArrow\xbb\u041eeftArrow\xbb\u089aightArrow\xbb\u0fddpArrow;\u6191gma;\u43a3allCircle;\u6218pf;\uc000\ud835\udd4a\u0272\u116d\0\0\u1170t;\u621aare\u0200;ISU\u117b\u117c\u1189\u11af\u65a1ntersection;\u6293u\u0100bp\u118f\u119eset\u0100;E\u1197\u1198\u628fqual;\u6291erset\u0100;E\u11a8\u11a9\u6290qual;\u6292nion;\u6294cr;\uc000\ud835\udcaear;\u62c6\u0200bcmp\u11c8\u11db\u1209\u120b\u0100;s\u11cd\u11ce\u62d0et\u0100;E\u11cd\u11d5qual;\u6286\u0100ch\u11e0\u1205eeds\u0200;EST\u11ed\u11ee\u11f4\u11ff\u627bqual;\u6ab0lantEqual;\u627dilde;\u627fTh\xe1\u0f8c;\u6211\u0180;es\u1212\u1213\u1223\u62d1rset\u0100;E\u121c\u121d\u6283qual;\u6287et\xbb\u1213\u0580HRSacfhiors\u123e\u1244\u1249\u1255\u125e\u1271\u1276\u129f\u12c2\u12c8\u12d1ORN\u803b\xde\u40deADE;\u6122\u0100Hc\u124e\u1252cy;\u440by;\u4426\u0100bu\u125a\u125c;\u4009;\u43a4\u0180aey\u1265\u126a\u126fron;\u4164dil;\u4162;\u4422r;\uc000\ud835\udd17\u0100ei\u127b\u1289\u01f2\u1280\0\u1287efore;\u6234a;\u4398\u0100cn\u128e\u1298kSpace;\uc000\u205f\u200aSpace;\u6009lde\u0200;EFT\u12ab\u12ac\u12b2\u12bc\u623cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uc000\ud835\udd4bipleDot;\u60db\u0100ct\u12d6\u12dbr;\uc000\ud835\udcafrok;\u4166\u0ae1\u12f7\u130e\u131a\u1326\0\u132c\u1331\0\0\0\0\0\u1338\u133d\u1377\u1385\0\u13ff\u1404\u140a\u1410\u0100cr\u12fb\u1301ute\u803b\xda\u40dar\u0100;o\u1307\u1308\u619fcir;\u6949r\u01e3\u1313\0\u1316y;\u440eve;\u416c\u0100iy\u131e\u1323rc\u803b\xdb\u40db;\u4423blac;\u4170r;\uc000\ud835\udd18rave\u803b\xd9\u40d9acr;\u416a\u0100di\u1341\u1369er\u0100BP\u1348\u135d\u0100ar\u134d\u1350r;\u405fac\u0100ek\u1357\u1359;\u63dfet;\u63b5arenthesis;\u63ddon\u0100;P\u1370\u1371\u62c3lus;\u628e\u0100gp\u137b\u137fon;\u4172f;\uc000\ud835\udd4c\u0400ADETadps\u1395\u13ae\u13b8\u13c4\u03e8\u13d2\u13d7\u13f3rrow\u0180;BD\u1150\u13a0\u13a4ar;\u6912ownArrow;\u61c5ownArrow;\u6195quilibrium;\u696eee\u0100;A\u13cb\u13cc\u62a5rrow;\u61a5own\xe1\u03f3er\u0100LR\u13de\u13e8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13f9\u13fa\u43d2on;\u43a5ing;\u416ecr;\uc000\ud835\udcb0ilde;\u4168ml\u803b\xdc\u40dc\u0480Dbcdefosv\u1427\u142c\u1430\u1433\u143e\u1485\u148a\u1490\u1496ash;\u62abar;\u6aeby;\u4412ash\u0100;l\u143b\u143c\u62a9;\u6ae6\u0100er\u1443\u1445;\u62c1\u0180bty\u144c\u1450\u147aar;\u6016\u0100;i\u144f\u1455cal\u0200BLST\u1461\u1465\u146a\u1474ar;\u6223ine;\u407ceparator;\u6758ilde;\u6240ThinSpace;\u600ar;\uc000\ud835\udd19pf;\uc000\ud835\udd4dcr;\uc000\ud835\udcb1dash;\u62aa\u0280cefos\u14a7\u14ac\u14b1\u14b6\u14bcirc;\u4174dge;\u62c0r;\uc000\ud835\udd1apf;\uc000\ud835\udd4ecr;\uc000\ud835\udcb2\u0200fios\u14cb\u14d0\u14d2\u14d8r;\uc000\ud835\udd1b;\u439epf;\uc000\ud835\udd4fcr;\uc000\ud835\udcb3\u0480AIUacfosu\u14f1\u14f5\u14f9\u14fd\u1504\u150f\u1514\u151a\u1520cy;\u442fcy;\u4407cy;\u442ecute\u803b\xdd\u40dd\u0100iy\u1509\u150drc;\u4176;\u442br;\uc000\ud835\udd1cpf;\uc000\ud835\udd50cr;\uc000\ud835\udcb4ml;\u4178\u0400Hacdefos\u1535\u1539\u153f\u154b\u154f\u155d\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417d;\u4417ot;\u417b\u01f2\u1554\0\u155boWidt\xe8\u0ad9a;\u4396r;\u6128pf;\u6124cr;\uc000\ud835\udcb5\u0be1\u1583\u158a\u1590\0\u15b0\u15b6\u15bf\0\0\0\0\u15c6\u15db\u15eb\u165f\u166d\0\u1695\u169b\u16b2\u16b9\0\u16becute\u803b\xe1\u40e1reve;\u4103\u0300;Ediuy\u159c\u159d\u15a1\u15a3\u15a8\u15ad\u623e;\uc000\u223e\u0333;\u623frc\u803b\xe2\u40e2te\u80bb\xb4\u0306;\u4430lig\u803b\xe6\u40e6\u0100;r\xb2\u15ba;\uc000\ud835\udd1erave\u803b\xe0\u40e0\u0100ep\u15ca\u15d6\u0100fp\u15cf\u15d4sym;\u6135\xe8\u15d3ha;\u43b1\u0100ap\u15dfc\u0100cl\u15e4\u15e7r;\u4101g;\u6a3f\u0264\u15f0\0\0\u160a\u0280;adsv\u15fa\u15fb\u15ff\u1601\u1607\u6227nd;\u6a55;\u6a5clope;\u6a58;\u6a5a\u0380;elmrsz\u1618\u1619\u161b\u161e\u163f\u164f\u1659\u6220;\u69a4e\xbb\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163a\u163c\u163e;\u69a8;\u69a9;\u69aa;\u69ab;\u69ac;\u69ad;\u69ae;\u69aft\u0100;v\u1645\u1646\u621fb\u0100;d\u164c\u164d\u62be;\u699d\u0100pt\u1654\u1657h;\u6222\xbb\xb9arr;\u637c\u0100gp\u1663\u1667on;\u4105f;\uc000\ud835\udd52\u0380;Eaeiop\u12c1\u167b\u167d\u1682\u1684\u1687\u168a;\u6a70cir;\u6a6f;\u624ad;\u624bs;\u4027rox\u0100;e\u12c1\u1692\xf1\u1683ing\u803b\xe5\u40e5\u0180cty\u16a1\u16a6\u16a8r;\uc000\ud835\udcb6;\u402amp\u0100;e\u12c1\u16af\xf1\u0288ilde\u803b\xe3\u40e3ml\u803b\xe4\u40e4\u0100ci\u16c2\u16c8onin\xf4\u0272nt;\u6a11\u0800Nabcdefiklnoprsu\u16ed\u16f1\u1730\u173c\u1743\u1748\u1778\u177d\u17e0\u17e6\u1839\u1850\u170d\u193d\u1948\u1970ot;\u6aed\u0100cr\u16f6\u171ek\u0200ceps\u1700\u1705\u170d\u1713ong;\u624cpsilon;\u43f6rime;\u6035im\u0100;e\u171a\u171b\u623dq;\u62cd\u0176\u1722\u1726ee;\u62bded\u0100;g\u172c\u172d\u6305e\xbb\u172drk\u0100;t\u135c\u1737brk;\u63b6\u0100oy\u1701\u1741;\u4431quo;\u601e\u0280cmprt\u1753\u175b\u1761\u1764\u1768aus\u0100;e\u010a\u0109ptyv;\u69b0s\xe9\u170cno\xf5\u0113\u0180ahw\u176f\u1771\u1773;\u43b2;\u6136een;\u626cr;\uc000\ud835\udd1fg\u0380costuvw\u178d\u179d\u17b3\u17c1\u17d5\u17db\u17de\u0180aiu\u1794\u1796\u179a\xf0\u0760rc;\u65efp\xbb\u1371\u0180dpt\u17a4\u17a8\u17adot;\u6a00lus;\u6a01imes;\u6a02\u0271\u17b9\0\0\u17becup;\u6a06ar;\u6605riangle\u0100du\u17cd\u17d2own;\u65bdp;\u65b3plus;\u6a04e\xe5\u1444\xe5\u14adarow;\u690d\u0180ako\u17ed\u1826\u1835\u0100cn\u17f2\u1823k\u0180lst\u17fa\u05ab\u1802ozenge;\u69ebriangle\u0200;dlr\u1812\u1813\u1818\u181d\u65b4own;\u65beeft;\u65c2ight;\u65b8k;\u6423\u01b1\u182b\0\u1833\u01b2\u182f\0\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183e\u184d\u0100;q\u1843\u1846\uc000=\u20e5uiv;\uc000\u2261\u20e5t;\u6310\u0200ptwx\u1859\u185e\u1867\u186cf;\uc000\ud835\udd53\u0100;t\u13cb\u1863om\xbb\u13cctie;\u62c8\u0600DHUVbdhmptuv\u1885\u1896\u18aa\u18bb\u18d7\u18db\u18ec\u18ff\u1905\u190a\u1910\u1921\u0200LRlr\u188e\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18a1\u18a2\u18a4\u18a6\u18a8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18b3\u18b5\u18b7\u18b9;\u655d;\u655a;\u655c;\u6559\u0380;HLRhlr\u18ca\u18cb\u18cd\u18cf\u18d1\u18d3\u18d5\u6551;\u656c;\u6563;\u6560;\u656b;\u6562;\u655fox;\u69c9\u0200LRlr\u18e4\u18e6\u18e8\u18ea;\u6555;\u6552;\u6510;\u650c\u0280;DUdu\u06bd\u18f7\u18f9\u18fb\u18fd;\u6565;\u6568;\u652c;\u6534inus;\u629flus;\u629eimes;\u62a0\u0200LRlr\u1919\u191b\u191d\u191f;\u655b;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193b\u6502;\u656a;\u6561;\u655e;\u653c;\u6524;\u651c\u0100ev\u0123\u1942bar\u803b\xa6\u40a6\u0200ceio\u1951\u1956\u195a\u1960r;\uc000\ud835\udcb7mi;\u604fm\u0100;e\u171a\u171cl\u0180;bh\u1968\u1969\u196b\u405c;\u69c5sub;\u67c8\u016c\u1974\u197el\u0100;e\u1979\u197a\u6022t\xbb\u197ap\u0180;Ee\u012f\u1985\u1987;\u6aae\u0100;q\u06dc\u06db\u0ce1\u19a7\0\u19e8\u1a11\u1a15\u1a32\0\u1a37\u1a50\0\0\u1ab4\0\0\u1ac1\0\0\u1b21\u1b2e\u1b4d\u1b52\0\u1bfd\0\u1c0c\u0180cpr\u19ad\u19b2\u19ddute;\u4107\u0300;abcds\u19bf\u19c0\u19c4\u19ca\u19d5\u19d9\u6229nd;\u6a44rcup;\u6a49\u0100au\u19cf\u19d2p;\u6a4bp;\u6a47ot;\u6a40;\uc000\u2229\ufe00\u0100eo\u19e2\u19e5t;\u6041\xee\u0693\u0200aeiu\u19f0\u19fb\u1a01\u1a05\u01f0\u19f5\0\u19f8s;\u6a4don;\u410ddil\u803b\xe7\u40e7rc;\u4109ps\u0100;s\u1a0c\u1a0d\u6a4cm;\u6a50ot;\u410b\u0180dmn\u1a1b\u1a20\u1a26il\u80bb\xb8\u01adptyv;\u69b2t\u8100\xa2;e\u1a2d\u1a2e\u40a2r\xe4\u01b2r;\uc000\ud835\udd20\u0180cei\u1a3d\u1a40\u1a4dy;\u4447ck\u0100;m\u1a47\u1a48\u6713ark\xbb\u1a48;\u43c7r\u0380;Ecefms\u1a5f\u1a60\u1a62\u1a6b\u1aa4\u1aaa\u1aae\u65cb;\u69c3\u0180;el\u1a69\u1a6a\u1a6d\u42c6q;\u6257e\u0261\u1a74\0\0\u1a88rrow\u0100lr\u1a7c\u1a81eft;\u61baight;\u61bb\u0280RSacd\u1a92\u1a94\u1a96\u1a9a\u1a9f\xbb\u0f47;\u64c8st;\u629birc;\u629aash;\u629dnint;\u6a10id;\u6aefcir;\u69c2ubs\u0100;u\u1abb\u1abc\u6663it\xbb\u1abc\u02ec\u1ac7\u1ad4\u1afa\0\u1b0aon\u0100;e\u1acd\u1ace\u403a\u0100;q\xc7\xc6\u026d\u1ad9\0\0\u1ae2a\u0100;t\u1ade\u1adf\u402c;\u4040\u0180;fl\u1ae8\u1ae9\u1aeb\u6201\xee\u1160e\u0100mx\u1af1\u1af6ent\xbb\u1ae9e\xf3\u024d\u01e7\u1afe\0\u1b07\u0100;d\u12bb\u1b02ot;\u6a6dn\xf4\u0246\u0180fry\u1b10\u1b14\u1b17;\uc000\ud835\udd54o\xe4\u0254\u8100\xa9;s\u0155\u1b1dr;\u6117\u0100ao\u1b25\u1b29rr;\u61b5ss;\u6717\u0100cu\u1b32\u1b37r;\uc000\ud835\udcb8\u0100bp\u1b3c\u1b44\u0100;e\u1b41\u1b42\u6acf;\u6ad1\u0100;e\u1b49\u1b4a\u6ad0;\u6ad2dot;\u62ef\u0380delprvw\u1b60\u1b6c\u1b77\u1b82\u1bac\u1bd4\u1bf9arr\u0100lr\u1b68\u1b6a;\u6938;\u6935\u0270\u1b72\0\0\u1b75r;\u62dec;\u62dfarr\u0100;p\u1b7f\u1b80\u61b6;\u693d\u0300;bcdos\u1b8f\u1b90\u1b96\u1ba1\u1ba5\u1ba8\u622arcap;\u6a48\u0100au\u1b9b\u1b9ep;\u6a46p;\u6a4aot;\u628dr;\u6a45;\uc000\u222a\ufe00\u0200alrv\u1bb5\u1bbf\u1bde\u1be3rr\u0100;m\u1bbc\u1bbd\u61b7;\u693cy\u0180evw\u1bc7\u1bd4\u1bd8q\u0270\u1bce\0\0\u1bd2re\xe3\u1b73u\xe3\u1b75ee;\u62ceedge;\u62cfen\u803b\xa4\u40a4earrow\u0100lr\u1bee\u1bf3eft\xbb\u1b80ight\xbb\u1bbde\xe4\u1bdd\u0100ci\u1c01\u1c07onin\xf4\u01f7nt;\u6231lcty;\u632d\u0980AHabcdefhijlorstuwz\u1c38\u1c3b\u1c3f\u1c5d\u1c69\u1c75\u1c8a\u1c9e\u1cac\u1cb7\u1cfb\u1cff\u1d0d\u1d7b\u1d91\u1dab\u1dbb\u1dc6\u1dcdr\xf2\u0381ar;\u6965\u0200glrs\u1c48\u1c4d\u1c52\u1c54ger;\u6020eth;\u6138\xf2\u1133h\u0100;v\u1c5a\u1c5b\u6010\xbb\u090a\u016b\u1c61\u1c67arow;\u690fa\xe3\u0315\u0100ay\u1c6e\u1c73ron;\u410f;\u4434\u0180;ao\u0332\u1c7c\u1c84\u0100gr\u02bf\u1c81r;\u61catseq;\u6a77\u0180glm\u1c91\u1c94\u1c98\u803b\xb0\u40b0ta;\u43b4ptyv;\u69b1\u0100ir\u1ca3\u1ca8sht;\u697f;\uc000\ud835\udd21ar\u0100lr\u1cb3\u1cb5\xbb\u08dc\xbb\u101e\u0280aegsv\u1cc2\u0378\u1cd6\u1cdc\u1ce0m\u0180;os\u0326\u1cca\u1cd4nd\u0100;s\u0326\u1cd1uit;\u6666amma;\u43ddin;\u62f2\u0180;io\u1ce7\u1ce8\u1cf8\u40f7de\u8100\xf7;o\u1ce7\u1cf0ntimes;\u62c7n\xf8\u1cf7cy;\u4452c\u026f\u1d06\0\0\u1d0arn;\u631eop;\u630d\u0280lptuw\u1d18\u1d1d\u1d22\u1d49\u1d55lar;\u4024f;\uc000\ud835\udd55\u0280;emps\u030b\u1d2d\u1d37\u1d3d\u1d42q\u0100;d\u0352\u1d33ot;\u6251inus;\u6238lus;\u6214quare;\u62a1blebarwedg\xe5\xfan\u0180adh\u112e\u1d5d\u1d67ownarrow\xf3\u1c83arpoon\u0100lr\u1d72\u1d76ef\xf4\u1cb4igh\xf4\u1cb6\u0162\u1d7f\u1d85karo\xf7\u0f42\u026f\u1d8a\0\0\u1d8ern;\u631fop;\u630c\u0180cot\u1d98\u1da3\u1da6\u0100ry\u1d9d\u1da1;\uc000\ud835\udcb9;\u4455l;\u69f6rok;\u4111\u0100dr\u1db0\u1db4ot;\u62f1i\u0100;f\u1dba\u1816\u65bf\u0100ah\u1dc0\u1dc3r\xf2\u0429a\xf2\u0fa6angle;\u69a6\u0100ci\u1dd2\u1dd5y;\u445fgrarr;\u67ff\u0900Dacdefglmnopqrstux\u1e01\u1e09\u1e19\u1e38\u0578\u1e3c\u1e49\u1e61\u1e7e\u1ea5\u1eaf\u1ebd\u1ee1\u1f2a\u1f37\u1f44\u1f4e\u1f5a\u0100Do\u1e06\u1d34o\xf4\u1c89\u0100cs\u1e0e\u1e14ute\u803b\xe9\u40e9ter;\u6a6e\u0200aioy\u1e22\u1e27\u1e31\u1e36ron;\u411br\u0100;c\u1e2d\u1e2e\u6256\u803b\xea\u40ealon;\u6255;\u444dot;\u4117\u0100Dr\u1e41\u1e45ot;\u6252;\uc000\ud835\udd22\u0180;rs\u1e50\u1e51\u1e57\u6a9aave\u803b\xe8\u40e8\u0100;d\u1e5c\u1e5d\u6a96ot;\u6a98\u0200;ils\u1e6a\u1e6b\u1e72\u1e74\u6a99nters;\u63e7;\u6113\u0100;d\u1e79\u1e7a\u6a95ot;\u6a97\u0180aps\u1e85\u1e89\u1e97cr;\u4113ty\u0180;sv\u1e92\u1e93\u1e95\u6205et\xbb\u1e93p\u01001;\u1e9d\u1ea4\u0133\u1ea1\u1ea3;\u6004;\u6005\u6003\u0100gs\u1eaa\u1eac;\u414bp;\u6002\u0100gp\u1eb4\u1eb8on;\u4119f;\uc000\ud835\udd56\u0180als\u1ec4\u1ece\u1ed2r\u0100;s\u1eca\u1ecb\u62d5l;\u69e3us;\u6a71i\u0180;lv\u1eda\u1edb\u1edf\u43b5on\xbb\u1edb;\u43f5\u0200csuv\u1eea\u1ef3\u1f0b\u1f23\u0100io\u1eef\u1e31rc\xbb\u1e2e\u0269\u1ef9\0\0\u1efb\xed\u0548ant\u0100gl\u1f02\u1f06tr\xbb\u1e5dess\xbb\u1e7a\u0180aei\u1f12\u1f16\u1f1als;\u403dst;\u625fv\u0100;D\u0235\u1f20D;\u6a78parsl;\u69e5\u0100Da\u1f2f\u1f33ot;\u6253rr;\u6971\u0180cdi\u1f3e\u1f41\u1ef8r;\u612fo\xf4\u0352\u0100ah\u1f49\u1f4b;\u43b7\u803b\xf0\u40f0\u0100mr\u1f53\u1f57l\u803b\xeb\u40ebo;\u60ac\u0180cip\u1f61\u1f64\u1f67l;\u4021s\xf4\u056e\u0100eo\u1f6c\u1f74ctatio\xee\u0559nential\xe5\u0579\u09e1\u1f92\0\u1f9e\0\u1fa1\u1fa7\0\0\u1fc6\u1fcc\0\u1fd3\0\u1fe6\u1fea\u2000\0\u2008\u205allingdotse\xf1\u1e44y;\u4444male;\u6640\u0180ilr\u1fad\u1fb3\u1fc1lig;\u8000\ufb03\u0269\u1fb9\0\0\u1fbdg;\u8000\ufb00ig;\u8000\ufb04;\uc000\ud835\udd23lig;\u8000\ufb01lig;\uc000fj\u0180alt\u1fd9\u1fdc\u1fe1t;\u666dig;\u8000\ufb02ns;\u65b1of;\u4192\u01f0\u1fee\0\u1ff3f;\uc000\ud835\udd57\u0100ak\u05bf\u1ff7\u0100;v\u1ffc\u1ffd\u62d4;\u6ad9artint;\u6a0d\u0100ao\u200c\u2055\u0100cs\u2011\u2052\u03b1\u201a\u2030\u2038\u2045\u2048\0\u2050\u03b2\u2022\u2025\u2027\u202a\u202c\0\u202e\u803b\xbd\u40bd;\u6153\u803b\xbc\u40bc;\u6155;\u6159;\u615b\u01b3\u2034\0\u2036;\u6154;\u6156\u02b4\u203e\u2041\0\0\u2043\u803b\xbe\u40be;\u6157;\u615c5;\u6158\u01b6\u204c\0\u204e;\u615a;\u615d8;\u615el;\u6044wn;\u6322cr;\uc000\ud835\udcbb\u0880Eabcdefgijlnorstv\u2082\u2089\u209f\u20a5\u20b0\u20b4\u20f0\u20f5\u20fa\u20ff\u2103\u2112\u2138\u0317\u213e\u2152\u219e\u0100;l\u064d\u2087;\u6a8c\u0180cmp\u2090\u2095\u209dute;\u41f5ma\u0100;d\u209c\u1cda\u43b3;\u6a86reve;\u411f\u0100iy\u20aa\u20aerc;\u411d;\u4433ot;\u4121\u0200;lqs\u063e\u0642\u20bd\u20c9\u0180;qs\u063e\u064c\u20c4lan\xf4\u0665\u0200;cdl\u0665\u20d2\u20d5\u20e5c;\u6aa9ot\u0100;o\u20dc\u20dd\u6a80\u0100;l\u20e2\u20e3\u6a82;\u6a84\u0100;e\u20ea\u20ed\uc000\u22db\ufe00s;\u6a94r;\uc000\ud835\udd24\u0100;g\u0673\u061bmel;\u6137cy;\u4453\u0200;Eaj\u065a\u210c\u210e\u2110;\u6a92;\u6aa5;\u6aa4\u0200Eaes\u211b\u211d\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6a8arox\xbb\u2124\u0100;q\u212e\u212f\u6a88\u0100;q\u212e\u211bim;\u62e7pf;\uc000\ud835\udd58\u0100ci\u2143\u2146r;\u610am\u0180;el\u066b\u214e\u2150;\u6a8e;\u6a90\u8300>;cdlqr\u05ee\u2160\u216a\u216e\u2173\u2179\u0100ci\u2165\u2167;\u6aa7r;\u6a7aot;\u62d7Par;\u6995uest;\u6a7c\u0280adels\u2184\u216a\u2190\u0656\u219b\u01f0\u2189\0\u218epro\xf8\u209er;\u6978q\u0100lq\u063f\u2196les\xf3\u2088i\xed\u066b\u0100en\u21a3\u21adrtneqq;\uc000\u2269\ufe00\xc5\u21aa\u0500Aabcefkosy\u21c4\u21c7\u21f1\u21f5\u21fa\u2218\u221d\u222f\u2268\u227dr\xf2\u03a0\u0200ilmr\u21d0\u21d4\u21d7\u21dbrs\xf0\u1484f\xbb\u2024il\xf4\u06a9\u0100dr\u21e0\u21e4cy;\u444a\u0180;cw\u08f4\u21eb\u21efir;\u6948;\u61adar;\u610firc;\u4125\u0180alr\u2201\u220e\u2213rts\u0100;u\u2209\u220a\u6665it\xbb\u220alip;\u6026con;\u62b9r;\uc000\ud835\udd25s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223a\u223e\u2243\u225e\u2263rr;\u61fftht;\u623bk\u0100lr\u2249\u2253eftarrow;\u61a9ightarrow;\u61aaf;\uc000\ud835\udd59bar;\u6015\u0180clt\u226f\u2274\u2278r;\uc000\ud835\udcbdas\xe8\u21f4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\xbb\u1c5b\u0ae1\u22a3\0\u22aa\0\u22b8\u22c5\u22ce\0\u22d5\u22f3\0\0\u22f8\u2322\u2367\u2362\u237f\0\u2386\u23aa\u23b4cute\u803b\xed\u40ed\u0180;iy\u0771\u22b0\u22b5rc\u803b\xee\u40ee;\u4438\u0100cx\u22bc\u22bfy;\u4435cl\u803b\xa1\u40a1\u0100fr\u039f\u22c9;\uc000\ud835\udd26rave\u803b\xec\u40ec\u0200;ino\u073e\u22dd\u22e9\u22ee\u0100in\u22e2\u22e6nt;\u6a0ct;\u622dfin;\u69dcta;\u6129lig;\u4133\u0180aop\u22fe\u231a\u231d\u0180cgt\u2305\u2308\u2317r;\u412b\u0180elp\u071f\u230f\u2313in\xe5\u078ear\xf4\u0720h;\u4131f;\u62b7ed;\u41b5\u0280;cfot\u04f4\u232c\u2331\u233d\u2341are;\u6105in\u0100;t\u2338\u2339\u621eie;\u69dddo\xf4\u2319\u0280;celp\u0757\u234c\u2350\u235b\u2361al;\u62ba\u0100gr\u2355\u2359er\xf3\u1563\xe3\u234darhk;\u6a17rod;\u6a3c\u0200cgpt\u236f\u2372\u2376\u237by;\u4451on;\u412ff;\uc000\ud835\udd5aa;\u43b9uest\u803b\xbf\u40bf\u0100ci\u238a\u238fr;\uc000\ud835\udcben\u0280;Edsv\u04f4\u239b\u239d\u23a1\u04f3;\u62f9ot;\u62f5\u0100;v\u23a6\u23a7\u62f4;\u62f3\u0100;i\u0777\u23aelde;\u4129\u01eb\u23b8\0\u23bccy;\u4456l\u803b\xef\u40ef\u0300cfmosu\u23cc\u23d7\u23dc\u23e1\u23e7\u23f5\u0100iy\u23d1\u23d5rc;\u4135;\u4439r;\uc000\ud835\udd27ath;\u4237pf;\uc000\ud835\udd5b\u01e3\u23ec\0\u23f1r;\uc000\ud835\udcbfrcy;\u4458kcy;\u4454\u0400acfghjos\u240b\u2416\u2422\u2427\u242d\u2431\u2435\u243bppa\u0100;v\u2413\u2414\u43ba;\u43f0\u0100ey\u241b\u2420dil;\u4137;\u443ar;\uc000\ud835\udd28reen;\u4138cy;\u4445cy;\u445cpf;\uc000\ud835\udd5ccr;\uc000\ud835\udcc0\u0b80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248d\u2491\u250e\u253d\u255a\u2580\u264e\u265e\u2665\u2679\u267d\u269a\u26b2\u26d8\u275d\u2768\u278b\u27c0\u2801\u2812\u0180art\u2477\u247a\u247cr\xf2\u09c6\xf2\u0395ail;\u691barr;\u690e\u0100;g\u0994\u248b;\u6a8bar;\u6962\u0963\u24a5\0\u24aa\0\u24b1\0\0\0\0\0\u24b5\u24ba\0\u24c6\u24c8\u24cd\0\u24f9ute;\u413amptyv;\u69b4ra\xee\u084cbda;\u43bbg\u0180;dl\u088e\u24c1\u24c3;\u6991\xe5\u088e;\u6a85uo\u803b\xab\u40abr\u0400;bfhlpst\u0899\u24de\u24e6\u24e9\u24eb\u24ee\u24f1\u24f5\u0100;f\u089d\u24e3s;\u691fs;\u691d\xeb\u2252p;\u61abl;\u6939im;\u6973l;\u61a2\u0180;ae\u24ff\u2500\u2504\u6aabil;\u6919\u0100;s\u2509\u250a\u6aad;\uc000\u2aad\ufe00\u0180abr\u2515\u2519\u251drr;\u690crk;\u6772\u0100ak\u2522\u252cc\u0100ek\u2528\u252a;\u407b;\u405b\u0100es\u2531\u2533;\u698bl\u0100du\u2539\u253b;\u698f;\u698d\u0200aeuy\u2546\u254b\u2556\u2558ron;\u413e\u0100di\u2550\u2554il;\u413c\xec\u08b0\xe2\u2529;\u443b\u0200cqrs\u2563\u2566\u256d\u257da;\u6936uo\u0100;r\u0e19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694bh;\u61b2\u0280;fgqs\u258b\u258c\u0989\u25f3\u25ff\u6264t\u0280ahlrt\u2598\u25a4\u25b7\u25c2\u25e8rrow\u0100;t\u0899\u25a1a\xe9\u24f6arpoon\u0100du\u25af\u25b4own\xbb\u045ap\xbb\u0966eftarrows;\u61c7ight\u0180ahs\u25cd\u25d6\u25derrow\u0100;s\u08f4\u08a7arpoon\xf3\u0f98quigarro\xf7\u21f0hreetimes;\u62cb\u0180;qs\u258b\u0993\u25falan\xf4\u09ac\u0280;cdgs\u09ac\u260a\u260d\u261d\u2628c;\u6aa8ot\u0100;o\u2614\u2615\u6a7f\u0100;r\u261a\u261b\u6a81;\u6a83\u0100;e\u2622\u2625\uc000\u22da\ufe00s;\u6a93\u0280adegs\u2633\u2639\u263d\u2649\u264bppro\xf8\u24c6ot;\u62d6q\u0100gq\u2643\u2645\xf4\u0989gt\xf2\u248c\xf4\u099bi\xed\u09b2\u0180ilr\u2655\u08e1\u265asht;\u697c;\uc000\ud835\udd29\u0100;E\u099c\u2663;\u6a91\u0161\u2669\u2676r\u0100du\u25b2\u266e\u0100;l\u0965\u2673;\u696alk;\u6584cy;\u4459\u0280;acht\u0a48\u2688\u268b\u2691\u2696r\xf2\u25c1orne\xf2\u1d08ard;\u696bri;\u65fa\u0100io\u269f\u26a4dot;\u4140ust\u0100;a\u26ac\u26ad\u63b0che\xbb\u26ad\u0200Eaes\u26bb\u26bd\u26c9\u26d4;\u6268p\u0100;p\u26c3\u26c4\u6a89rox\xbb\u26c4\u0100;q\u26ce\u26cf\u6a87\u0100;q\u26ce\u26bbim;\u62e6\u0400abnoptwz\u26e9\u26f4\u26f7\u271a\u272f\u2741\u2747\u2750\u0100nr\u26ee\u26f1g;\u67ecr;\u61fdr\xeb\u08c1g\u0180lmr\u26ff\u270d\u2714eft\u0100ar\u09e6\u2707ight\xe1\u09f2apsto;\u67fcight\xe1\u09fdparrow\u0100lr\u2725\u2729ef\xf4\u24edight;\u61ac\u0180afl\u2736\u2739\u273dr;\u6985;\uc000\ud835\udd5dus;\u6a2dimes;\u6a34\u0161\u274b\u274fst;\u6217\xe1\u134e\u0180;ef\u2757\u2758\u1800\u65cange\xbb\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277c\u2785\u2787r\xf2\u08a8orne\xf2\u1d8car\u0100;d\u0f98\u2783;\u696d;\u600eri;\u62bf\u0300achiqt\u2798\u279d\u0a40\u27a2\u27ae\u27bbquo;\u6039r;\uc000\ud835\udcc1m\u0180;eg\u09b2\u27aa\u27ac;\u6a8d;\u6a8f\u0100bu\u252a\u27b3o\u0100;r\u0e1f\u27b9;\u601arok;\u4142\u8400<;cdhilqr\u082b\u27d2\u2639\u27dc\u27e0\u27e5\u27ea\u27f0\u0100ci\u27d7\u27d9;\u6aa6r;\u6a79re\xe5\u25f2mes;\u62c9arr;\u6976uest;\u6a7b\u0100Pi\u27f5\u27f9ar;\u6996\u0180;ef\u2800\u092d\u181b\u65c3r\u0100du\u2807\u280dshar;\u694ahar;\u6966\u0100en\u2817\u2821rtneqq;\uc000\u2268\ufe00\xc5\u281e\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288e\u2893\u28a0\u28a5\u28a8\u28da\u28e2\u28e4\u0a83\u28f3\u2902Dot;\u623a\u0200clpr\u284e\u2852\u2863\u287dr\u803b\xaf\u40af\u0100et\u2857\u2859;\u6642\u0100;e\u285e\u285f\u6720se\xbb\u285f\u0100;s\u103b\u2868to\u0200;dlu\u103b\u2873\u2877\u287bow\xee\u048cef\xf4\u090f\xf0\u13d1ker;\u65ae\u0100oy\u2887\u288cmma;\u6a29;\u443cash;\u6014asuredangle\xbb\u1626r;\uc000\ud835\udd2ao;\u6127\u0180cdn\u28af\u28b4\u28c9ro\u803b\xb5\u40b5\u0200;acd\u1464\u28bd\u28c0\u28c4s\xf4\u16a7ir;\u6af0ot\u80bb\xb7\u01b5us\u0180;bd\u28d2\u1903\u28d3\u6212\u0100;u\u1d3c\u28d8;\u6a2a\u0163\u28de\u28e1p;\u6adb\xf2\u2212\xf0\u0a81\u0100dp\u28e9\u28eeels;\u62a7f;\uc000\ud835\udd5e\u0100ct\u28f8\u28fdr;\uc000\ud835\udcc2pos\xbb\u159d\u0180;lm\u2909\u290a\u290d\u43bctimap;\u62b8\u0c00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297e\u2989\u2998\u29da\u29e9\u2a15\u2a1a\u2a58\u2a5d\u2a83\u2a95\u2aa4\u2aa8\u2b04\u2b07\u2b44\u2b7f\u2bae\u2c34\u2c67\u2c7c\u2ce9\u0100gt\u2947\u294b;\uc000\u22d9\u0338\u0100;v\u2950\u0bcf\uc000\u226b\u20d2\u0180elt\u295a\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61cdightarrow;\u61ce;\uc000\u22d8\u0338\u0100;v\u297b\u0c47\uc000\u226a\u20d2ightarrow;\u61cf\u0100Dd\u298e\u2993ash;\u62afash;\u62ae\u0280bcnpt\u29a3\u29a7\u29ac\u29b1\u29ccla\xbb\u02deute;\u4144g;\uc000\u2220\u20d2\u0280;Eiop\u0d84\u29bc\u29c0\u29c5\u29c8;\uc000\u2a70\u0338d;\uc000\u224b\u0338s;\u4149ro\xf8\u0d84ur\u0100;a\u29d3\u29d4\u666el\u0100;s\u29d3\u0b38\u01f3\u29df\0\u29e3p\u80bb\xa0\u0b37mp\u0100;e\u0bf9\u0c00\u0280aeouy\u29f4\u29fe\u2a03\u2a10\u2a13\u01f0\u29f9\0\u29fb;\u6a43on;\u4148dil;\u4146ng\u0100;d\u0d7e\u2a0aot;\uc000\u2a6d\u0338p;\u6a42;\u443dash;\u6013\u0380;Aadqsx\u0b92\u2a29\u2a2d\u2a3b\u2a41\u2a45\u2a50rr;\u61d7r\u0100hr\u2a33\u2a36k;\u6924\u0100;o\u13f2\u13f0ot;\uc000\u2250\u0338ui\xf6\u0b63\u0100ei\u2a4a\u2a4ear;\u6928\xed\u0b98ist\u0100;s\u0ba0\u0b9fr;\uc000\ud835\udd2b\u0200Eest\u0bc5\u2a66\u2a79\u2a7c\u0180;qs\u0bbc\u2a6d\u0be1\u0180;qs\u0bbc\u0bc5\u2a74lan\xf4\u0be2i\xed\u0bea\u0100;r\u0bb6\u2a81\xbb\u0bb7\u0180Aap\u2a8a\u2a8d\u2a91r\xf2\u2971rr;\u61aear;\u6af2\u0180;sv\u0f8d\u2a9c\u0f8c\u0100;d\u2aa1\u2aa2\u62fc;\u62facy;\u445a\u0380AEadest\u2ab7\u2aba\u2abe\u2ac2\u2ac5\u2af6\u2af9r\xf2\u2966;\uc000\u2266\u0338rr;\u619ar;\u6025\u0200;fqs\u0c3b\u2ace\u2ae3\u2aeft\u0100ar\u2ad4\u2ad9rro\xf7\u2ac1ightarro\xf7\u2a90\u0180;qs\u0c3b\u2aba\u2aealan\xf4\u0c55\u0100;s\u0c55\u2af4\xbb\u0c36i\xed\u0c5d\u0100;r\u0c35\u2afei\u0100;e\u0c1a\u0c25i\xe4\u0d90\u0100pt\u2b0c\u2b11f;\uc000\ud835\udd5f\u8180\xac;in\u2b19\u2b1a\u2b36\u40acn\u0200;Edv\u0b89\u2b24\u2b28\u2b2e;\uc000\u22f9\u0338ot;\uc000\u22f5\u0338\u01e1\u0b89\u2b33\u2b35;\u62f7;\u62f6i\u0100;v\u0cb8\u2b3c\u01e1\u0cb8\u2b41\u2b43;\u62fe;\u62fd\u0180aor\u2b4b\u2b63\u2b69r\u0200;ast\u0b7b\u2b55\u2b5a\u2b5flle\xec\u0b7bl;\uc000\u2afd\u20e5;\uc000\u2202\u0338lint;\u6a14\u0180;ce\u0c92\u2b70\u2b73u\xe5\u0ca5\u0100;c\u0c98\u2b78\u0100;e\u0c92\u2b7d\xf1\u0c98\u0200Aait\u2b88\u2b8b\u2b9d\u2ba7r\xf2\u2988rr\u0180;cw\u2b94\u2b95\u2b99\u619b;\uc000\u2933\u0338;\uc000\u219d\u0338ghtarrow\xbb\u2b95ri\u0100;e\u0ccb\u0cd6\u0380chimpqu\u2bbd\u2bcd\u2bd9\u2b04\u0b78\u2be4\u2bef\u0200;cer\u0d32\u2bc6\u0d37\u2bc9u\xe5\u0d45;\uc000\ud835\udcc3ort\u026d\u2b05\0\0\u2bd6ar\xe1\u2b56m\u0100;e\u0d6e\u2bdf\u0100;q\u0d74\u0d73su\u0100bp\u2beb\u2bed\xe5\u0cf8\xe5\u0d0b\u0180bcp\u2bf6\u2c11\u2c19\u0200;Ees\u2bff\u2c00\u0d22\u2c04\u6284;\uc000\u2ac5\u0338et\u0100;e\u0d1b\u2c0bq\u0100;q\u0d23\u2c00c\u0100;e\u0d32\u2c17\xf1\u0d38\u0200;Ees\u2c22\u2c23\u0d5f\u2c27\u6285;\uc000\u2ac6\u0338et\u0100;e\u0d58\u2c2eq\u0100;q\u0d60\u2c23\u0200gilr\u2c3d\u2c3f\u2c45\u2c47\xec\u0bd7lde\u803b\xf1\u40f1\xe7\u0c43iangle\u0100lr\u2c52\u2c5ceft\u0100;e\u0c1a\u2c5a\xf1\u0c26ight\u0100;e\u0ccb\u2c65\xf1\u0cd7\u0100;m\u2c6c\u2c6d\u43bd\u0180;es\u2c74\u2c75\u2c79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2c8f\u2c94\u2c99\u2c9e\u2ca3\u2cb0\u2cb6\u2cd3\u2ce3ash;\u62adarr;\u6904p;\uc000\u224d\u20d2ash;\u62ac\u0100et\u2ca8\u2cac;\uc000\u2265\u20d2;\uc000>\u20d2nfin;\u69de\u0180Aet\u2cbd\u2cc1\u2cc5rr;\u6902;\uc000\u2264\u20d2\u0100;r\u2cca\u2ccd\uc000<\u20d2ie;\uc000\u22b4\u20d2\u0100At\u2cd8\u2cdcrr;\u6903rie;\uc000\u22b5\u20d2im;\uc000\u223c\u20d2\u0180Aan\u2cf0\u2cf4\u2d02rr;\u61d6r\u0100hr\u2cfa\u2cfdk;\u6923\u0100;o\u13e7\u13e5ear;\u6927\u1253\u1a95\0\0\0\0\0\0\0\0\0\0\0\0\0\u2d2d\0\u2d38\u2d48\u2d60\u2d65\u2d72\u2d84\u1b07\0\0\u2d8d\u2dab\0\u2dc8\u2dce\0\u2ddc\u2e19\u2e2b\u2e3e\u2e43\u0100cs\u2d31\u1a97ute\u803b\xf3\u40f3\u0100iy\u2d3c\u2d45r\u0100;c\u1a9e\u2d42\u803b\xf4\u40f4;\u443e\u0280abios\u1aa0\u2d52\u2d57\u01c8\u2d5alac;\u4151v;\u6a38old;\u69bclig;\u4153\u0100cr\u2d69\u2d6dir;\u69bf;\uc000\ud835\udd2c\u036f\u2d79\0\0\u2d7c\0\u2d82n;\u42dbave\u803b\xf2\u40f2;\u69c1\u0100bm\u2d88\u0df4ar;\u69b5\u0200acit\u2d95\u2d98\u2da5\u2da8r\xf2\u1a80\u0100ir\u2d9d\u2da0r;\u69beoss;\u69bbn\xe5\u0e52;\u69c0\u0180aei\u2db1\u2db5\u2db9cr;\u414dga;\u43c9\u0180cdn\u2dc0\u2dc5\u01cdron;\u43bf;\u69b6pf;\uc000\ud835\udd60\u0180ael\u2dd4\u2dd7\u01d2r;\u69b7rp;\u69b9\u0380;adiosv\u2dea\u2deb\u2dee\u2e08\u2e0d\u2e10\u2e16\u6228r\xf2\u1a86\u0200;efm\u2df7\u2df8\u2e02\u2e05\u6a5dr\u0100;o\u2dfe\u2dff\u6134f\xbb\u2dff\u803b\xaa\u40aa\u803b\xba\u40bagof;\u62b6r;\u6a56lope;\u6a57;\u6a5b\u0180clo\u2e1f\u2e21\u2e27\xf2\u2e01ash\u803b\xf8\u40f8l;\u6298i\u016c\u2e2f\u2e34de\u803b\xf5\u40f5es\u0100;a\u01db\u2e3as;\u6a36ml\u803b\xf6\u40f6bar;\u633d\u0ae1\u2e5e\0\u2e7d\0\u2e80\u2e9d\0\u2ea2\u2eb9\0\0\u2ecb\u0e9c\0\u2f13\0\0\u2f2b\u2fbc\0\u2fc8r\u0200;ast\u0403\u2e67\u2e72\u0e85\u8100\xb6;l\u2e6d\u2e6e\u40b6le\xec\u0403\u0269\u2e78\0\0\u2e7bm;\u6af3;\u6afdy;\u443fr\u0280cimpt\u2e8b\u2e8f\u2e93\u1865\u2e97nt;\u4025od;\u402eil;\u6030enk;\u6031r;\uc000\ud835\udd2d\u0180imo\u2ea8\u2eb0\u2eb4\u0100;v\u2ead\u2eae\u43c6;\u43d5ma\xf4\u0a76ne;\u660e\u0180;tv\u2ebf\u2ec0\u2ec8\u43c0chfork\xbb\u1ffd;\u43d6\u0100au\u2ecf\u2edfn\u0100ck\u2ed5\u2eddk\u0100;h\u21f4\u2edb;\u610e\xf6\u21f4s\u0480;abcdemst\u2ef3\u2ef4\u1908\u2ef9\u2efd\u2f04\u2f06\u2f0a\u2f0e\u402bcir;\u6a23ir;\u6a22\u0100ou\u1d40\u2f02;\u6a25;\u6a72n\u80bb\xb1\u0e9dim;\u6a26wo;\u6a27\u0180ipu\u2f19\u2f20\u2f25ntint;\u6a15f;\uc000\ud835\udd61nd\u803b\xa3\u40a3\u0500;Eaceinosu\u0ec8\u2f3f\u2f41\u2f44\u2f47\u2f81\u2f89\u2f92\u2f7e\u2fb6;\u6ab3p;\u6ab7u\xe5\u0ed9\u0100;c\u0ece\u2f4c\u0300;acens\u0ec8\u2f59\u2f5f\u2f66\u2f68\u2f7eppro\xf8\u2f43urlye\xf1\u0ed9\xf1\u0ece\u0180aes\u2f6f\u2f76\u2f7approx;\u6ab9qq;\u6ab5im;\u62e8i\xed\u0edfme\u0100;s\u2f88\u0eae\u6032\u0180Eas\u2f78\u2f90\u2f7a\xf0\u2f75\u0180dfp\u0eec\u2f99\u2faf\u0180als\u2fa0\u2fa5\u2faalar;\u632eine;\u6312urf;\u6313\u0100;t\u0efb\u2fb4\xef\u0efbrel;\u62b0\u0100ci\u2fc0\u2fc5r;\uc000\ud835\udcc5;\u43c8ncsp;\u6008\u0300fiopsu\u2fda\u22e2\u2fdf\u2fe5\u2feb\u2ff1r;\uc000\ud835\udd2epf;\uc000\ud835\udd62rime;\u6057cr;\uc000\ud835\udcc6\u0180aeo\u2ff8\u3009\u3013t\u0100ei\u2ffe\u3005rnion\xf3\u06b0nt;\u6a16st\u0100;e\u3010\u3011\u403f\xf1\u1f19\xf4\u0f14\u0a80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30e0\u310e\u312b\u3147\u3162\u3172\u318e\u3206\u3215\u3224\u3229\u3258\u326e\u3272\u3290\u32b0\u32b7\u0180art\u3047\u304a\u304cr\xf2\u10b3\xf2\u03ddail;\u691car\xf2\u1c65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307f\u308f\u3094\u30cc\u0100eu\u306d\u3071;\uc000\u223d\u0331te;\u4155i\xe3\u116emptyv;\u69b3g\u0200;del\u0fd1\u3089\u308b\u308d;\u6992;\u69a5\xe5\u0fd1uo\u803b\xbb\u40bbr\u0580;abcfhlpstw\u0fdc\u30ac\u30af\u30b7\u30b9\u30bc\u30be\u30c0\u30c3\u30c7\u30cap;\u6975\u0100;f\u0fe0\u30b4s;\u6920;\u6933s;\u691e\xeb\u225d\xf0\u272el;\u6945im;\u6974l;\u61a3;\u619d\u0100ai\u30d1\u30d5il;\u691ao\u0100;n\u30db\u30dc\u6236al\xf3\u0f1e\u0180abr\u30e7\u30ea\u30eer\xf2\u17e5rk;\u6773\u0100ak\u30f3\u30fdc\u0100ek\u30f9\u30fb;\u407d;\u405d\u0100es\u3102\u3104;\u698cl\u0100du\u310a\u310c;\u698e;\u6990\u0200aeuy\u3117\u311c\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\xec\u0ff2\xe2\u30fa;\u4440\u0200clqs\u3134\u3137\u313d\u3144a;\u6937dhar;\u6969uo\u0100;r\u020e\u020dh;\u61b3\u0180acg\u314e\u315f\u0f44l\u0200;ips\u0f78\u3158\u315b\u109cn\xe5\u10bbar\xf4\u0fa9t;\u65ad\u0180ilr\u3169\u1023\u316esht;\u697d;\uc000\ud835\udd2f\u0100ao\u3177\u3186r\u0100du\u317d\u317f\xbb\u047b\u0100;l\u1091\u3184;\u696c\u0100;v\u318b\u318c\u43c1;\u43f1\u0180gns\u3195\u31f9\u31fcht\u0300ahlrst\u31a4\u31b0\u31c2\u31d8\u31e4\u31eerrow\u0100;t\u0fdc\u31ada\xe9\u30c8arpoon\u0100du\u31bb\u31bfow\xee\u317ep\xbb\u1092eft\u0100ah\u31ca\u31d0rrow\xf3\u0feaarpoon\xf3\u0551ightarrows;\u61c9quigarro\xf7\u30cbhreetimes;\u62ccg;\u42daingdotse\xf1\u1f32\u0180ahm\u320d\u3210\u3213r\xf2\u0feaa\xf2\u0551;\u600foust\u0100;a\u321e\u321f\u63b1che\xbb\u321fmid;\u6aee\u0200abpt\u3232\u323d\u3240\u3252\u0100nr\u3237\u323ag;\u67edr;\u61fer\xeb\u1003\u0180afl\u3247\u324a\u324er;\u6986;\uc000\ud835\udd63us;\u6a2eimes;\u6a35\u0100ap\u325d\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6a12ar\xf2\u31e3\u0200achq\u327b\u3280\u10bc\u3285quo;\u603ar;\uc000\ud835\udcc7\u0100bu\u30fb\u328ao\u0100;r\u0214\u0213\u0180hir\u3297\u329b\u32a0re\xe5\u31f8mes;\u62cai\u0200;efl\u32aa\u1059\u1821\u32ab\u65b9tri;\u69celuhar;\u6968;\u611e\u0d61\u32d5\u32db\u32df\u332c\u3338\u3371\0\u337a\u33a4\0\0\u33ec\u33f0\0\u3428\u3448\u345a\u34ad\u34b1\u34ca\u34f1\0\u3616\0\0\u3633cute;\u415bqu\xef\u27ba\u0500;Eaceinpsy\u11ed\u32f3\u32f5\u32ff\u3302\u330b\u330f\u331f\u3326\u3329;\u6ab4\u01f0\u32fa\0\u32fc;\u6ab8on;\u4161u\xe5\u11fe\u0100;d\u11f3\u3307il;\u415frc;\u415d\u0180Eas\u3316\u3318\u331b;\u6ab6p;\u6abaim;\u62e9olint;\u6a13i\xed\u1204;\u4441ot\u0180;be\u3334\u1d47\u3335\u62c5;\u6a66\u0380Aacmstx\u3346\u334a\u3357\u335b\u335e\u3363\u336drr;\u61d8r\u0100hr\u3350\u3352\xeb\u2228\u0100;o\u0a36\u0a34t\u803b\xa7\u40a7i;\u403bwar;\u6929m\u0100in\u3369\xf0nu\xf3\xf1t;\u6736r\u0100;o\u3376\u2055\uc000\ud835\udd30\u0200acoy\u3382\u3386\u3391\u33a0rp;\u666f\u0100hy\u338b\u338fcy;\u4449;\u4448rt\u026d\u3399\0\0\u339ci\xe4\u1464ara\xec\u2e6f\u803b\xad\u40ad\u0100gm\u33a8\u33b4ma\u0180;fv\u33b1\u33b2\u33b2\u43c3;\u43c2\u0400;deglnpr\u12ab\u33c5\u33c9\u33ce\u33d6\u33de\u33e1\u33e6ot;\u6a6a\u0100;q\u12b1\u12b0\u0100;E\u33d3\u33d4\u6a9e;\u6aa0\u0100;E\u33db\u33dc\u6a9d;\u6a9fe;\u6246lus;\u6a24arr;\u6972ar\xf2\u113d\u0200aeit\u33f8\u3408\u340f\u3417\u0100ls\u33fd\u3404lsetm\xe9\u336ahp;\u6a33parsl;\u69e4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341c\u341d\u6aaa\u0100;s\u3422\u3423\u6aac;\uc000\u2aac\ufe00\u0180flp\u342e\u3433\u3442tcy;\u444c\u0100;b\u3438\u3439\u402f\u0100;a\u343e\u343f\u69c4r;\u633ff;\uc000\ud835\udd64a\u0100dr\u344d\u0402es\u0100;u\u3454\u3455\u6660it\xbb\u3455\u0180csu\u3460\u3479\u349f\u0100au\u3465\u346fp\u0100;s\u1188\u346b;\uc000\u2293\ufe00p\u0100;s\u11b4\u3475;\uc000\u2294\ufe00u\u0100bp\u347f\u348f\u0180;es\u1197\u119c\u3486et\u0100;e\u1197\u348d\xf1\u119d\u0180;es\u11a8\u11ad\u3496et\u0100;e\u11a8\u349d\xf1\u11ae\u0180;af\u117b\u34a6\u05b0r\u0165\u34ab\u05b1\xbb\u117car\xf2\u1148\u0200cemt\u34b9\u34be\u34c2\u34c5r;\uc000\ud835\udcc8tm\xee\xf1i\xec\u3415ar\xe6\u11be\u0100ar\u34ce\u34d5r\u0100;f\u34d4\u17bf\u6606\u0100an\u34da\u34edight\u0100ep\u34e3\u34eapsilo\xee\u1ee0h\xe9\u2eafs\xbb\u2852\u0280bcmnp\u34fb\u355e\u1209\u358b\u358e\u0480;Edemnprs\u350e\u350f\u3511\u3515\u351e\u3523\u352c\u3531\u3536\u6282;\u6ac5ot;\u6abd\u0100;d\u11da\u351aot;\u6ac3ult;\u6ac1\u0100Ee\u3528\u352a;\u6acb;\u628alus;\u6abfarr;\u6979\u0180eiu\u353d\u3552\u3555t\u0180;en\u350e\u3545\u354bq\u0100;q\u11da\u350feq\u0100;q\u352b\u3528m;\u6ac7\u0100bp\u355a\u355c;\u6ad5;\u6ad3c\u0300;acens\u11ed\u356c\u3572\u3579\u357b\u3326ppro\xf8\u32faurlye\xf1\u11fe\xf1\u11f3\u0180aes\u3582\u3588\u331bppro\xf8\u331aq\xf1\u3317g;\u666a\u0680123;Edehlmnps\u35a9\u35ac\u35af\u121c\u35b2\u35b4\u35c0\u35c9\u35d5\u35da\u35df\u35e8\u35ed\u803b\xb9\u40b9\u803b\xb2\u40b2\u803b\xb3\u40b3;\u6ac6\u0100os\u35b9\u35bct;\u6abeub;\u6ad8\u0100;d\u1222\u35c5ot;\u6ac4s\u0100ou\u35cf\u35d2l;\u67c9b;\u6ad7arr;\u697bult;\u6ac2\u0100Ee\u35e4\u35e6;\u6acc;\u628blus;\u6ac0\u0180eiu\u35f4\u3609\u360ct\u0180;en\u121c\u35fc\u3602q\u0100;q\u1222\u35b2eq\u0100;q\u35e7\u35e4m;\u6ac8\u0100bp\u3611\u3613;\u6ad4;\u6ad6\u0180Aan\u361c\u3620\u362drr;\u61d9r\u0100hr\u3626\u3628\xeb\u222e\u0100;o\u0a2b\u0a29war;\u692alig\u803b\xdf\u40df\u0be1\u3651\u365d\u3660\u12ce\u3673\u3679\0\u367e\u36c2\0\0\0\0\0\u36db\u3703\0\u3709\u376c\0\0\0\u3787\u0272\u3656\0\0\u365bget;\u6316;\u43c4r\xeb\u0e5f\u0180aey\u3666\u366b\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uc000\ud835\udd31\u0200eiko\u3686\u369d\u36b5\u36bc\u01f2\u368b\0\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369b\u43b8ym;\u43d1\u0100cn\u36a2\u36b2k\u0100as\u36a8\u36aeppro\xf8\u12c1im\xbb\u12acs\xf0\u129e\u0100as\u36ba\u36ae\xf0\u12c1rn\u803b\xfe\u40fe\u01ec\u031f\u36c6\u22e7es\u8180\xd7;bd\u36cf\u36d0\u36d8\u40d7\u0100;a\u190f\u36d5r;\u6a31;\u6a30\u0180eps\u36e1\u36e3\u3700\xe1\u2a4d\u0200;bcf\u0486\u36ec\u36f0\u36f4ot;\u6336ir;\u6af1\u0100;o\u36f9\u36fc\uc000\ud835\udd65rk;\u6ada\xe1\u3362rime;\u6034\u0180aip\u370f\u3712\u3764d\xe5\u1248\u0380adempst\u3721\u374d\u3740\u3751\u3757\u375c\u375fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65b5own\xbb\u1dbbeft\u0100;e\u2800\u373e\xf1\u092e;\u625cight\u0100;e\u32aa\u374b\xf1\u105aot;\u65ecinus;\u6a3alus;\u6a39b;\u69cdime;\u6a3bezium;\u63e2\u0180cht\u3772\u377d\u3781\u0100ry\u3777\u377b;\uc000\ud835\udcc9;\u4446cy;\u445brok;\u4167\u0100io\u378b\u378ex\xf4\u1777head\u0100lr\u3797\u37a0eftarro\xf7\u084fightarrow\xbb\u0f5d\u0900AHabcdfghlmoprstuw\u37d0\u37d3\u37d7\u37e4\u37f0\u37fc\u380e\u381c\u3823\u3834\u3851\u385d\u386b\u38a9\u38cc\u38d2\u38ea\u38f6r\xf2\u03edar;\u6963\u0100cr\u37dc\u37e2ute\u803b\xfa\u40fa\xf2\u1150r\u01e3\u37ea\0\u37edy;\u445eve;\u416d\u0100iy\u37f5\u37farc\u803b\xfb\u40fb;\u4443\u0180abh\u3803\u3806\u380br\xf2\u13adlac;\u4171a\xf2\u13c3\u0100ir\u3813\u3818sht;\u697e;\uc000\ud835\udd32rave\u803b\xf9\u40f9\u0161\u3827\u3831r\u0100lr\u382c\u382e\xbb\u0957\xbb\u1083lk;\u6580\u0100ct\u3839\u384d\u026f\u383f\0\0\u384arn\u0100;e\u3845\u3846\u631cr\xbb\u3846op;\u630fri;\u65f8\u0100al\u3856\u385acr;\u416b\u80bb\xa8\u0349\u0100gp\u3862\u3866on;\u4173f;\uc000\ud835\udd66\u0300adhlsu\u114b\u3878\u387d\u1372\u3891\u38a0own\xe1\u13b3arpoon\u0100lr\u3888\u388cef\xf4\u382digh\xf4\u382fi\u0180;hl\u3899\u389a\u389c\u43c5\xbb\u13faon\xbb\u389aparrows;\u61c8\u0180cit\u38b0\u38c4\u38c8\u026f\u38b6\0\0\u38c1rn\u0100;e\u38bc\u38bd\u631dr\xbb\u38bdop;\u630eng;\u416fri;\u65f9cr;\uc000\ud835\udcca\u0180dir\u38d9\u38dd\u38e2ot;\u62f0lde;\u4169i\u0100;f\u3730\u38e8\xbb\u1813\u0100am\u38ef\u38f2r\xf2\u38a8l\u803b\xfc\u40fcangle;\u69a7\u0780ABDacdeflnoprsz\u391c\u391f\u3929\u392d\u39b5\u39b8\u39bd\u39df\u39e4\u39e8\u39f3\u39f9\u39fd\u3a01\u3a20r\xf2\u03f7ar\u0100;v\u3926\u3927\u6ae8;\u6ae9as\xe8\u03e1\u0100nr\u3932\u3937grt;\u699c\u0380eknprst\u34e3\u3946\u394b\u3952\u395d\u3964\u3996app\xe1\u2415othin\xe7\u1e96\u0180hir\u34eb\u2ec8\u3959op\xf4\u2fb5\u0100;h\u13b7\u3962\xef\u318d\u0100iu\u3969\u396dgm\xe1\u33b3\u0100bp\u3972\u3984setneq\u0100;q\u397d\u3980\uc000\u228a\ufe00;\uc000\u2acb\ufe00setneq\u0100;q\u398f\u3992\uc000\u228b\ufe00;\uc000\u2acc\ufe00\u0100hr\u399b\u399fet\xe1\u369ciangle\u0100lr\u39aa\u39afeft\xbb\u0925ight\xbb\u1051y;\u4432ash\xbb\u1036\u0180elr\u39c4\u39d2\u39d7\u0180;be\u2dea\u39cb\u39cfar;\u62bbq;\u625alip;\u62ee\u0100bt\u39dc\u1468a\xf2\u1469r;\uc000\ud835\udd33tr\xe9\u39aesu\u0100bp\u39ef\u39f1\xbb\u0d1c\xbb\u0d59pf;\uc000\ud835\udd67ro\xf0\u0efbtr\xe9\u39b4\u0100cu\u3a06\u3a0br;\uc000\ud835\udccb\u0100bp\u3a10\u3a18n\u0100Ee\u3980\u3a16\xbb\u397en\u0100Ee\u3992\u3a1e\xbb\u3990igzag;\u699a\u0380cefoprs\u3a36\u3a3b\u3a56\u3a5b\u3a54\u3a61\u3a6airc;\u4175\u0100di\u3a40\u3a51\u0100bg\u3a45\u3a49ar;\u6a5fe\u0100;q\u15fa\u3a4f;\u6259erp;\u6118r;\uc000\ud835\udd34pf;\uc000\ud835\udd68\u0100;e\u1479\u3a66at\xe8\u1479cr;\uc000\ud835\udccc\u0ae3\u178e\u3a87\0\u3a8b\0\u3a90\u3a9b\0\0\u3a9d\u3aa8\u3aab\u3aaf\0\0\u3ac3\u3ace\0\u3ad8\u17dc\u17dftr\xe9\u17d1r;\uc000\ud835\udd35\u0100Aa\u3a94\u3a97r\xf2\u03c3r\xf2\u09f6;\u43be\u0100Aa\u3aa1\u3aa4r\xf2\u03b8r\xf2\u09eba\xf0\u2713is;\u62fb\u0180dpt\u17a4\u3ab5\u3abe\u0100fl\u3aba\u17a9;\uc000\ud835\udd69im\xe5\u17b2\u0100Aa\u3ac7\u3acar\xf2\u03cer\xf2\u0a01\u0100cq\u3ad2\u17b8r;\uc000\ud835\udccd\u0100pt\u17d6\u3adcr\xe9\u17d4\u0400acefiosu\u3af0\u3afd\u3b08\u3b0c\u3b11\u3b15\u3b1b\u3b21c\u0100uy\u3af6\u3afbte\u803b\xfd\u40fd;\u444f\u0100iy\u3b02\u3b06rc;\u4177;\u444bn\u803b\xa5\u40a5r;\uc000\ud835\udd36cy;\u4457pf;\uc000\ud835\udd6acr;\uc000\ud835\udcce\u0100cm\u3b26\u3b29y;\u444el\u803b\xff\u40ff\u0500acdefhiosw\u3b42\u3b48\u3b54\u3b58\u3b64\u3b69\u3b6d\u3b74\u3b7a\u3b80cute;\u417a\u0100ay\u3b4d\u3b52ron;\u417e;\u4437ot;\u417c\u0100et\u3b5d\u3b61tr\xe6\u155fa;\u43b6r;\uc000\ud835\udd37cy;\u4436grarr;\u61ddpf;\uc000\ud835\udd6bcr;\uc000\ud835\udccf\u0100jn\u3b85\u3b87;\u600dj;\u600c".split("").map((c)=>c.charCodeAt(0)));

});

parcelRegister("cjXy9", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f8573b78e12f3de$export$2e2bcd8739ae039);
// Generated using scripts/write-decode-map.ts
var $8f8573b78e12f3de$export$2e2bcd8739ae039 = new Uint16Array(// prettier-ignore
"\u0200aglq\t\x15\x18\x1b\u026d\x0f\0\0\x12p;\u4026os;\u4027t;\u403et;\u403cuot;\u4022".split("").map((c)=>c.charCodeAt(0)));

});

parcelRegister("1mqh8", function(module, exports) {

$parcel$export(module.exports, "fromCodePoint", () => $0fdc3a4215784dc1$export$73bfc63873071f74);
$parcel$export(module.exports, "replaceCodePoint", () => $0fdc3a4215784dc1$export$b978ab756102108a);
// Adapted from https://github.com/mathiasbynens/he/blob/36afe179392226cf1b6ccdb16ebbb7a5a844d93a/src/he.js#L106-L134
var $0fdc3a4215784dc1$var$_a;
const $0fdc3a4215784dc1$var$decodeMap = new Map([
    [
        0,
        65533
    ],
    // C1 Unicode control character reference replacements
    [
        128,
        8364
    ],
    [
        130,
        8218
    ],
    [
        131,
        402
    ],
    [
        132,
        8222
    ],
    [
        133,
        8230
    ],
    [
        134,
        8224
    ],
    [
        135,
        8225
    ],
    [
        136,
        710
    ],
    [
        137,
        8240
    ],
    [
        138,
        352
    ],
    [
        139,
        8249
    ],
    [
        140,
        338
    ],
    [
        142,
        381
    ],
    [
        145,
        8216
    ],
    [
        146,
        8217
    ],
    [
        147,
        8220
    ],
    [
        148,
        8221
    ],
    [
        149,
        8226
    ],
    [
        150,
        8211
    ],
    [
        151,
        8212
    ],
    [
        152,
        732
    ],
    [
        153,
        8482
    ],
    [
        154,
        353
    ],
    [
        155,
        8250
    ],
    [
        156,
        339
    ],
    [
        158,
        382
    ],
    [
        159,
        376
    ]
]);
const $0fdc3a4215784dc1$export$73bfc63873071f74 = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
($0fdc3a4215784dc1$var$_a = String.fromCodePoint) !== null && $0fdc3a4215784dc1$var$_a !== void 0 ? $0fdc3a4215784dc1$var$_a : function(codePoint) {
    let output = "";
    if (codePoint > 0xffff) {
        codePoint -= 0x10000;
        output += String.fromCharCode(codePoint >>> 10 & 0x3ff | 0xd800);
        codePoint = 0xdc00 | codePoint & 0x3ff;
    }
    output += String.fromCharCode(codePoint);
    return output;
};
function $0fdc3a4215784dc1$export$b978ab756102108a(codePoint) {
    var _a;
    if (codePoint >= 0xd800 && codePoint <= 0xdfff || codePoint > 0x10ffff) return 0xfffd;
    return (_a = $0fdc3a4215784dc1$var$decodeMap.get(codePoint)) !== null && _a !== void 0 ? _a : codePoint;
}
function $0fdc3a4215784dc1$export$2e2bcd8739ae039(codePoint) {
    return $0fdc3a4215784dc1$export$73bfc63873071f74($0fdc3a4215784dc1$export$b978ab756102108a(codePoint));
}

});


parcelRegister("6QxPZ", function(module, exports) {

$parcel$export(module.exports, "encodeHTML", () => $4fc1d8dbc74f1929$export$f9d6449b9af28dc1);
$parcel$export(module.exports, "encodeNonAsciiHTML", () => $4fc1d8dbc74f1929$export$e6e86c76506f1190);

var $4b7Mz = parcelRequire("4b7Mz");

var $i7QF4 = parcelRequire("i7QF4");
const $4fc1d8dbc74f1929$var$htmlReplacer = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
function $4fc1d8dbc74f1929$export$f9d6449b9af28dc1(data) {
    return $4fc1d8dbc74f1929$var$encodeHTMLTrieRe($4fc1d8dbc74f1929$var$htmlReplacer, data);
}
function $4fc1d8dbc74f1929$export$e6e86c76506f1190(data) {
    return $4fc1d8dbc74f1929$var$encodeHTMLTrieRe((0, $i7QF4.xmlReplacer), data);
}
function $4fc1d8dbc74f1929$var$encodeHTMLTrieRe(regExp, str) {
    let ret = "";
    let lastIdx = 0;
    let match;
    while((match = regExp.exec(str)) !== null){
        const i = match.index;
        ret += str.substring(lastIdx, i);
        const char = str.charCodeAt(i);
        let next = (0, $4b7Mz.default).get(char);
        if (typeof next === "object") {
            // We are in a branch. Try to match the next char.
            if (i + 1 < str.length) {
                const nextChar = str.charCodeAt(i + 1);
                const value = typeof next.n === "number" ? next.n === nextChar ? next.o : undefined : next.n.get(nextChar);
                if (value !== undefined) {
                    ret += value;
                    lastIdx = regExp.lastIndex += 1;
                    continue;
                }
            }
            next = next.v;
        }
        // We might have a tree node without a value; skip and use a numeric entity.
        if (next !== undefined) {
            ret += next;
            lastIdx = i + 1;
        } else {
            const cp = (0, $i7QF4.getCodePoint)(str, i);
            ret += `&#x${cp.toString(16)};`;
            // Increase by 1 if we have a surrogate pair
            lastIdx = regExp.lastIndex += Number(cp !== char);
        }
    }
    return ret + str.substr(lastIdx);
}

});
parcelRegister("4b7Mz", function(module, exports) {

$parcel$export(module.exports, "default", () => $30ae39ed5c434785$export$2e2bcd8739ae039);
// Generated using scripts/write-encode-map.ts
function $30ae39ed5c434785$var$restoreDiff(arr) {
    for(let i = 1; i < arr.length; i++)arr[i][0] += arr[i - 1][0] + 1;
    return arr;
}
var // prettier-ignore
$30ae39ed5c434785$export$2e2bcd8739ae039 = new Map(/* #__PURE__ */ $30ae39ed5c434785$var$restoreDiff([
    [
        9,
        "&Tab;"
    ],
    [
        0,
        "&NewLine;"
    ],
    [
        22,
        "&excl;"
    ],
    [
        0,
        "&quot;"
    ],
    [
        0,
        "&num;"
    ],
    [
        0,
        "&dollar;"
    ],
    [
        0,
        "&percnt;"
    ],
    [
        0,
        "&amp;"
    ],
    [
        0,
        "&apos;"
    ],
    [
        0,
        "&lpar;"
    ],
    [
        0,
        "&rpar;"
    ],
    [
        0,
        "&ast;"
    ],
    [
        0,
        "&plus;"
    ],
    [
        0,
        "&comma;"
    ],
    [
        1,
        "&period;"
    ],
    [
        0,
        "&sol;"
    ],
    [
        10,
        "&colon;"
    ],
    [
        0,
        "&semi;"
    ],
    [
        0,
        {
            v: "&lt;",
            n: 8402,
            o: "&nvlt;"
        }
    ],
    [
        0,
        {
            v: "&equals;",
            n: 8421,
            o: "&bne;"
        }
    ],
    [
        0,
        {
            v: "&gt;",
            n: 8402,
            o: "&nvgt;"
        }
    ],
    [
        0,
        "&quest;"
    ],
    [
        0,
        "&commat;"
    ],
    [
        26,
        "&lbrack;"
    ],
    [
        0,
        "&bsol;"
    ],
    [
        0,
        "&rbrack;"
    ],
    [
        0,
        "&Hat;"
    ],
    [
        0,
        "&lowbar;"
    ],
    [
        0,
        "&DiacriticalGrave;"
    ],
    [
        5,
        {
            n: 106,
            o: "&fjlig;"
        }
    ],
    [
        20,
        "&lbrace;"
    ],
    [
        0,
        "&verbar;"
    ],
    [
        0,
        "&rbrace;"
    ],
    [
        34,
        "&nbsp;"
    ],
    [
        0,
        "&iexcl;"
    ],
    [
        0,
        "&cent;"
    ],
    [
        0,
        "&pound;"
    ],
    [
        0,
        "&curren;"
    ],
    [
        0,
        "&yen;"
    ],
    [
        0,
        "&brvbar;"
    ],
    [
        0,
        "&sect;"
    ],
    [
        0,
        "&die;"
    ],
    [
        0,
        "&copy;"
    ],
    [
        0,
        "&ordf;"
    ],
    [
        0,
        "&laquo;"
    ],
    [
        0,
        "&not;"
    ],
    [
        0,
        "&shy;"
    ],
    [
        0,
        "&circledR;"
    ],
    [
        0,
        "&macr;"
    ],
    [
        0,
        "&deg;"
    ],
    [
        0,
        "&PlusMinus;"
    ],
    [
        0,
        "&sup2;"
    ],
    [
        0,
        "&sup3;"
    ],
    [
        0,
        "&acute;"
    ],
    [
        0,
        "&micro;"
    ],
    [
        0,
        "&para;"
    ],
    [
        0,
        "&centerdot;"
    ],
    [
        0,
        "&cedil;"
    ],
    [
        0,
        "&sup1;"
    ],
    [
        0,
        "&ordm;"
    ],
    [
        0,
        "&raquo;"
    ],
    [
        0,
        "&frac14;"
    ],
    [
        0,
        "&frac12;"
    ],
    [
        0,
        "&frac34;"
    ],
    [
        0,
        "&iquest;"
    ],
    [
        0,
        "&Agrave;"
    ],
    [
        0,
        "&Aacute;"
    ],
    [
        0,
        "&Acirc;"
    ],
    [
        0,
        "&Atilde;"
    ],
    [
        0,
        "&Auml;"
    ],
    [
        0,
        "&angst;"
    ],
    [
        0,
        "&AElig;"
    ],
    [
        0,
        "&Ccedil;"
    ],
    [
        0,
        "&Egrave;"
    ],
    [
        0,
        "&Eacute;"
    ],
    [
        0,
        "&Ecirc;"
    ],
    [
        0,
        "&Euml;"
    ],
    [
        0,
        "&Igrave;"
    ],
    [
        0,
        "&Iacute;"
    ],
    [
        0,
        "&Icirc;"
    ],
    [
        0,
        "&Iuml;"
    ],
    [
        0,
        "&ETH;"
    ],
    [
        0,
        "&Ntilde;"
    ],
    [
        0,
        "&Ograve;"
    ],
    [
        0,
        "&Oacute;"
    ],
    [
        0,
        "&Ocirc;"
    ],
    [
        0,
        "&Otilde;"
    ],
    [
        0,
        "&Ouml;"
    ],
    [
        0,
        "&times;"
    ],
    [
        0,
        "&Oslash;"
    ],
    [
        0,
        "&Ugrave;"
    ],
    [
        0,
        "&Uacute;"
    ],
    [
        0,
        "&Ucirc;"
    ],
    [
        0,
        "&Uuml;"
    ],
    [
        0,
        "&Yacute;"
    ],
    [
        0,
        "&THORN;"
    ],
    [
        0,
        "&szlig;"
    ],
    [
        0,
        "&agrave;"
    ],
    [
        0,
        "&aacute;"
    ],
    [
        0,
        "&acirc;"
    ],
    [
        0,
        "&atilde;"
    ],
    [
        0,
        "&auml;"
    ],
    [
        0,
        "&aring;"
    ],
    [
        0,
        "&aelig;"
    ],
    [
        0,
        "&ccedil;"
    ],
    [
        0,
        "&egrave;"
    ],
    [
        0,
        "&eacute;"
    ],
    [
        0,
        "&ecirc;"
    ],
    [
        0,
        "&euml;"
    ],
    [
        0,
        "&igrave;"
    ],
    [
        0,
        "&iacute;"
    ],
    [
        0,
        "&icirc;"
    ],
    [
        0,
        "&iuml;"
    ],
    [
        0,
        "&eth;"
    ],
    [
        0,
        "&ntilde;"
    ],
    [
        0,
        "&ograve;"
    ],
    [
        0,
        "&oacute;"
    ],
    [
        0,
        "&ocirc;"
    ],
    [
        0,
        "&otilde;"
    ],
    [
        0,
        "&ouml;"
    ],
    [
        0,
        "&div;"
    ],
    [
        0,
        "&oslash;"
    ],
    [
        0,
        "&ugrave;"
    ],
    [
        0,
        "&uacute;"
    ],
    [
        0,
        "&ucirc;"
    ],
    [
        0,
        "&uuml;"
    ],
    [
        0,
        "&yacute;"
    ],
    [
        0,
        "&thorn;"
    ],
    [
        0,
        "&yuml;"
    ],
    [
        0,
        "&Amacr;"
    ],
    [
        0,
        "&amacr;"
    ],
    [
        0,
        "&Abreve;"
    ],
    [
        0,
        "&abreve;"
    ],
    [
        0,
        "&Aogon;"
    ],
    [
        0,
        "&aogon;"
    ],
    [
        0,
        "&Cacute;"
    ],
    [
        0,
        "&cacute;"
    ],
    [
        0,
        "&Ccirc;"
    ],
    [
        0,
        "&ccirc;"
    ],
    [
        0,
        "&Cdot;"
    ],
    [
        0,
        "&cdot;"
    ],
    [
        0,
        "&Ccaron;"
    ],
    [
        0,
        "&ccaron;"
    ],
    [
        0,
        "&Dcaron;"
    ],
    [
        0,
        "&dcaron;"
    ],
    [
        0,
        "&Dstrok;"
    ],
    [
        0,
        "&dstrok;"
    ],
    [
        0,
        "&Emacr;"
    ],
    [
        0,
        "&emacr;"
    ],
    [
        2,
        "&Edot;"
    ],
    [
        0,
        "&edot;"
    ],
    [
        0,
        "&Eogon;"
    ],
    [
        0,
        "&eogon;"
    ],
    [
        0,
        "&Ecaron;"
    ],
    [
        0,
        "&ecaron;"
    ],
    [
        0,
        "&Gcirc;"
    ],
    [
        0,
        "&gcirc;"
    ],
    [
        0,
        "&Gbreve;"
    ],
    [
        0,
        "&gbreve;"
    ],
    [
        0,
        "&Gdot;"
    ],
    [
        0,
        "&gdot;"
    ],
    [
        0,
        "&Gcedil;"
    ],
    [
        1,
        "&Hcirc;"
    ],
    [
        0,
        "&hcirc;"
    ],
    [
        0,
        "&Hstrok;"
    ],
    [
        0,
        "&hstrok;"
    ],
    [
        0,
        "&Itilde;"
    ],
    [
        0,
        "&itilde;"
    ],
    [
        0,
        "&Imacr;"
    ],
    [
        0,
        "&imacr;"
    ],
    [
        2,
        "&Iogon;"
    ],
    [
        0,
        "&iogon;"
    ],
    [
        0,
        "&Idot;"
    ],
    [
        0,
        "&imath;"
    ],
    [
        0,
        "&IJlig;"
    ],
    [
        0,
        "&ijlig;"
    ],
    [
        0,
        "&Jcirc;"
    ],
    [
        0,
        "&jcirc;"
    ],
    [
        0,
        "&Kcedil;"
    ],
    [
        0,
        "&kcedil;"
    ],
    [
        0,
        "&kgreen;"
    ],
    [
        0,
        "&Lacute;"
    ],
    [
        0,
        "&lacute;"
    ],
    [
        0,
        "&Lcedil;"
    ],
    [
        0,
        "&lcedil;"
    ],
    [
        0,
        "&Lcaron;"
    ],
    [
        0,
        "&lcaron;"
    ],
    [
        0,
        "&Lmidot;"
    ],
    [
        0,
        "&lmidot;"
    ],
    [
        0,
        "&Lstrok;"
    ],
    [
        0,
        "&lstrok;"
    ],
    [
        0,
        "&Nacute;"
    ],
    [
        0,
        "&nacute;"
    ],
    [
        0,
        "&Ncedil;"
    ],
    [
        0,
        "&ncedil;"
    ],
    [
        0,
        "&Ncaron;"
    ],
    [
        0,
        "&ncaron;"
    ],
    [
        0,
        "&napos;"
    ],
    [
        0,
        "&ENG;"
    ],
    [
        0,
        "&eng;"
    ],
    [
        0,
        "&Omacr;"
    ],
    [
        0,
        "&omacr;"
    ],
    [
        2,
        "&Odblac;"
    ],
    [
        0,
        "&odblac;"
    ],
    [
        0,
        "&OElig;"
    ],
    [
        0,
        "&oelig;"
    ],
    [
        0,
        "&Racute;"
    ],
    [
        0,
        "&racute;"
    ],
    [
        0,
        "&Rcedil;"
    ],
    [
        0,
        "&rcedil;"
    ],
    [
        0,
        "&Rcaron;"
    ],
    [
        0,
        "&rcaron;"
    ],
    [
        0,
        "&Sacute;"
    ],
    [
        0,
        "&sacute;"
    ],
    [
        0,
        "&Scirc;"
    ],
    [
        0,
        "&scirc;"
    ],
    [
        0,
        "&Scedil;"
    ],
    [
        0,
        "&scedil;"
    ],
    [
        0,
        "&Scaron;"
    ],
    [
        0,
        "&scaron;"
    ],
    [
        0,
        "&Tcedil;"
    ],
    [
        0,
        "&tcedil;"
    ],
    [
        0,
        "&Tcaron;"
    ],
    [
        0,
        "&tcaron;"
    ],
    [
        0,
        "&Tstrok;"
    ],
    [
        0,
        "&tstrok;"
    ],
    [
        0,
        "&Utilde;"
    ],
    [
        0,
        "&utilde;"
    ],
    [
        0,
        "&Umacr;"
    ],
    [
        0,
        "&umacr;"
    ],
    [
        0,
        "&Ubreve;"
    ],
    [
        0,
        "&ubreve;"
    ],
    [
        0,
        "&Uring;"
    ],
    [
        0,
        "&uring;"
    ],
    [
        0,
        "&Udblac;"
    ],
    [
        0,
        "&udblac;"
    ],
    [
        0,
        "&Uogon;"
    ],
    [
        0,
        "&uogon;"
    ],
    [
        0,
        "&Wcirc;"
    ],
    [
        0,
        "&wcirc;"
    ],
    [
        0,
        "&Ycirc;"
    ],
    [
        0,
        "&ycirc;"
    ],
    [
        0,
        "&Yuml;"
    ],
    [
        0,
        "&Zacute;"
    ],
    [
        0,
        "&zacute;"
    ],
    [
        0,
        "&Zdot;"
    ],
    [
        0,
        "&zdot;"
    ],
    [
        0,
        "&Zcaron;"
    ],
    [
        0,
        "&zcaron;"
    ],
    [
        19,
        "&fnof;"
    ],
    [
        34,
        "&imped;"
    ],
    [
        63,
        "&gacute;"
    ],
    [
        65,
        "&jmath;"
    ],
    [
        142,
        "&circ;"
    ],
    [
        0,
        "&caron;"
    ],
    [
        16,
        "&breve;"
    ],
    [
        0,
        "&DiacriticalDot;"
    ],
    [
        0,
        "&ring;"
    ],
    [
        0,
        "&ogon;"
    ],
    [
        0,
        "&DiacriticalTilde;"
    ],
    [
        0,
        "&dblac;"
    ],
    [
        51,
        "&DownBreve;"
    ],
    [
        127,
        "&Alpha;"
    ],
    [
        0,
        "&Beta;"
    ],
    [
        0,
        "&Gamma;"
    ],
    [
        0,
        "&Delta;"
    ],
    [
        0,
        "&Epsilon;"
    ],
    [
        0,
        "&Zeta;"
    ],
    [
        0,
        "&Eta;"
    ],
    [
        0,
        "&Theta;"
    ],
    [
        0,
        "&Iota;"
    ],
    [
        0,
        "&Kappa;"
    ],
    [
        0,
        "&Lambda;"
    ],
    [
        0,
        "&Mu;"
    ],
    [
        0,
        "&Nu;"
    ],
    [
        0,
        "&Xi;"
    ],
    [
        0,
        "&Omicron;"
    ],
    [
        0,
        "&Pi;"
    ],
    [
        0,
        "&Rho;"
    ],
    [
        1,
        "&Sigma;"
    ],
    [
        0,
        "&Tau;"
    ],
    [
        0,
        "&Upsilon;"
    ],
    [
        0,
        "&Phi;"
    ],
    [
        0,
        "&Chi;"
    ],
    [
        0,
        "&Psi;"
    ],
    [
        0,
        "&ohm;"
    ],
    [
        7,
        "&alpha;"
    ],
    [
        0,
        "&beta;"
    ],
    [
        0,
        "&gamma;"
    ],
    [
        0,
        "&delta;"
    ],
    [
        0,
        "&epsi;"
    ],
    [
        0,
        "&zeta;"
    ],
    [
        0,
        "&eta;"
    ],
    [
        0,
        "&theta;"
    ],
    [
        0,
        "&iota;"
    ],
    [
        0,
        "&kappa;"
    ],
    [
        0,
        "&lambda;"
    ],
    [
        0,
        "&mu;"
    ],
    [
        0,
        "&nu;"
    ],
    [
        0,
        "&xi;"
    ],
    [
        0,
        "&omicron;"
    ],
    [
        0,
        "&pi;"
    ],
    [
        0,
        "&rho;"
    ],
    [
        0,
        "&sigmaf;"
    ],
    [
        0,
        "&sigma;"
    ],
    [
        0,
        "&tau;"
    ],
    [
        0,
        "&upsi;"
    ],
    [
        0,
        "&phi;"
    ],
    [
        0,
        "&chi;"
    ],
    [
        0,
        "&psi;"
    ],
    [
        0,
        "&omega;"
    ],
    [
        7,
        "&thetasym;"
    ],
    [
        0,
        "&Upsi;"
    ],
    [
        2,
        "&phiv;"
    ],
    [
        0,
        "&piv;"
    ],
    [
        5,
        "&Gammad;"
    ],
    [
        0,
        "&digamma;"
    ],
    [
        18,
        "&kappav;"
    ],
    [
        0,
        "&rhov;"
    ],
    [
        3,
        "&epsiv;"
    ],
    [
        0,
        "&backepsilon;"
    ],
    [
        10,
        "&IOcy;"
    ],
    [
        0,
        "&DJcy;"
    ],
    [
        0,
        "&GJcy;"
    ],
    [
        0,
        "&Jukcy;"
    ],
    [
        0,
        "&DScy;"
    ],
    [
        0,
        "&Iukcy;"
    ],
    [
        0,
        "&YIcy;"
    ],
    [
        0,
        "&Jsercy;"
    ],
    [
        0,
        "&LJcy;"
    ],
    [
        0,
        "&NJcy;"
    ],
    [
        0,
        "&TSHcy;"
    ],
    [
        0,
        "&KJcy;"
    ],
    [
        1,
        "&Ubrcy;"
    ],
    [
        0,
        "&DZcy;"
    ],
    [
        0,
        "&Acy;"
    ],
    [
        0,
        "&Bcy;"
    ],
    [
        0,
        "&Vcy;"
    ],
    [
        0,
        "&Gcy;"
    ],
    [
        0,
        "&Dcy;"
    ],
    [
        0,
        "&IEcy;"
    ],
    [
        0,
        "&ZHcy;"
    ],
    [
        0,
        "&Zcy;"
    ],
    [
        0,
        "&Icy;"
    ],
    [
        0,
        "&Jcy;"
    ],
    [
        0,
        "&Kcy;"
    ],
    [
        0,
        "&Lcy;"
    ],
    [
        0,
        "&Mcy;"
    ],
    [
        0,
        "&Ncy;"
    ],
    [
        0,
        "&Ocy;"
    ],
    [
        0,
        "&Pcy;"
    ],
    [
        0,
        "&Rcy;"
    ],
    [
        0,
        "&Scy;"
    ],
    [
        0,
        "&Tcy;"
    ],
    [
        0,
        "&Ucy;"
    ],
    [
        0,
        "&Fcy;"
    ],
    [
        0,
        "&KHcy;"
    ],
    [
        0,
        "&TScy;"
    ],
    [
        0,
        "&CHcy;"
    ],
    [
        0,
        "&SHcy;"
    ],
    [
        0,
        "&SHCHcy;"
    ],
    [
        0,
        "&HARDcy;"
    ],
    [
        0,
        "&Ycy;"
    ],
    [
        0,
        "&SOFTcy;"
    ],
    [
        0,
        "&Ecy;"
    ],
    [
        0,
        "&YUcy;"
    ],
    [
        0,
        "&YAcy;"
    ],
    [
        0,
        "&acy;"
    ],
    [
        0,
        "&bcy;"
    ],
    [
        0,
        "&vcy;"
    ],
    [
        0,
        "&gcy;"
    ],
    [
        0,
        "&dcy;"
    ],
    [
        0,
        "&iecy;"
    ],
    [
        0,
        "&zhcy;"
    ],
    [
        0,
        "&zcy;"
    ],
    [
        0,
        "&icy;"
    ],
    [
        0,
        "&jcy;"
    ],
    [
        0,
        "&kcy;"
    ],
    [
        0,
        "&lcy;"
    ],
    [
        0,
        "&mcy;"
    ],
    [
        0,
        "&ncy;"
    ],
    [
        0,
        "&ocy;"
    ],
    [
        0,
        "&pcy;"
    ],
    [
        0,
        "&rcy;"
    ],
    [
        0,
        "&scy;"
    ],
    [
        0,
        "&tcy;"
    ],
    [
        0,
        "&ucy;"
    ],
    [
        0,
        "&fcy;"
    ],
    [
        0,
        "&khcy;"
    ],
    [
        0,
        "&tscy;"
    ],
    [
        0,
        "&chcy;"
    ],
    [
        0,
        "&shcy;"
    ],
    [
        0,
        "&shchcy;"
    ],
    [
        0,
        "&hardcy;"
    ],
    [
        0,
        "&ycy;"
    ],
    [
        0,
        "&softcy;"
    ],
    [
        0,
        "&ecy;"
    ],
    [
        0,
        "&yucy;"
    ],
    [
        0,
        "&yacy;"
    ],
    [
        1,
        "&iocy;"
    ],
    [
        0,
        "&djcy;"
    ],
    [
        0,
        "&gjcy;"
    ],
    [
        0,
        "&jukcy;"
    ],
    [
        0,
        "&dscy;"
    ],
    [
        0,
        "&iukcy;"
    ],
    [
        0,
        "&yicy;"
    ],
    [
        0,
        "&jsercy;"
    ],
    [
        0,
        "&ljcy;"
    ],
    [
        0,
        "&njcy;"
    ],
    [
        0,
        "&tshcy;"
    ],
    [
        0,
        "&kjcy;"
    ],
    [
        1,
        "&ubrcy;"
    ],
    [
        0,
        "&dzcy;"
    ],
    [
        7074,
        "&ensp;"
    ],
    [
        0,
        "&emsp;"
    ],
    [
        0,
        "&emsp13;"
    ],
    [
        0,
        "&emsp14;"
    ],
    [
        1,
        "&numsp;"
    ],
    [
        0,
        "&puncsp;"
    ],
    [
        0,
        "&ThinSpace;"
    ],
    [
        0,
        "&hairsp;"
    ],
    [
        0,
        "&NegativeMediumSpace;"
    ],
    [
        0,
        "&zwnj;"
    ],
    [
        0,
        "&zwj;"
    ],
    [
        0,
        "&lrm;"
    ],
    [
        0,
        "&rlm;"
    ],
    [
        0,
        "&dash;"
    ],
    [
        2,
        "&ndash;"
    ],
    [
        0,
        "&mdash;"
    ],
    [
        0,
        "&horbar;"
    ],
    [
        0,
        "&Verbar;"
    ],
    [
        1,
        "&lsquo;"
    ],
    [
        0,
        "&CloseCurlyQuote;"
    ],
    [
        0,
        "&lsquor;"
    ],
    [
        1,
        "&ldquo;"
    ],
    [
        0,
        "&CloseCurlyDoubleQuote;"
    ],
    [
        0,
        "&bdquo;"
    ],
    [
        1,
        "&dagger;"
    ],
    [
        0,
        "&Dagger;"
    ],
    [
        0,
        "&bull;"
    ],
    [
        2,
        "&nldr;"
    ],
    [
        0,
        "&hellip;"
    ],
    [
        9,
        "&permil;"
    ],
    [
        0,
        "&pertenk;"
    ],
    [
        0,
        "&prime;"
    ],
    [
        0,
        "&Prime;"
    ],
    [
        0,
        "&tprime;"
    ],
    [
        0,
        "&backprime;"
    ],
    [
        3,
        "&lsaquo;"
    ],
    [
        0,
        "&rsaquo;"
    ],
    [
        3,
        "&oline;"
    ],
    [
        2,
        "&caret;"
    ],
    [
        1,
        "&hybull;"
    ],
    [
        0,
        "&frasl;"
    ],
    [
        10,
        "&bsemi;"
    ],
    [
        7,
        "&qprime;"
    ],
    [
        7,
        {
            v: "&MediumSpace;",
            n: 8202,
            o: "&ThickSpace;"
        }
    ],
    [
        0,
        "&NoBreak;"
    ],
    [
        0,
        "&af;"
    ],
    [
        0,
        "&InvisibleTimes;"
    ],
    [
        0,
        "&ic;"
    ],
    [
        72,
        "&euro;"
    ],
    [
        46,
        "&tdot;"
    ],
    [
        0,
        "&DotDot;"
    ],
    [
        37,
        "&complexes;"
    ],
    [
        2,
        "&incare;"
    ],
    [
        4,
        "&gscr;"
    ],
    [
        0,
        "&hamilt;"
    ],
    [
        0,
        "&Hfr;"
    ],
    [
        0,
        "&Hopf;"
    ],
    [
        0,
        "&planckh;"
    ],
    [
        0,
        "&hbar;"
    ],
    [
        0,
        "&imagline;"
    ],
    [
        0,
        "&Ifr;"
    ],
    [
        0,
        "&lagran;"
    ],
    [
        0,
        "&ell;"
    ],
    [
        1,
        "&naturals;"
    ],
    [
        0,
        "&numero;"
    ],
    [
        0,
        "&copysr;"
    ],
    [
        0,
        "&weierp;"
    ],
    [
        0,
        "&Popf;"
    ],
    [
        0,
        "&Qopf;"
    ],
    [
        0,
        "&realine;"
    ],
    [
        0,
        "&real;"
    ],
    [
        0,
        "&reals;"
    ],
    [
        0,
        "&rx;"
    ],
    [
        3,
        "&trade;"
    ],
    [
        1,
        "&integers;"
    ],
    [
        2,
        "&mho;"
    ],
    [
        0,
        "&zeetrf;"
    ],
    [
        0,
        "&iiota;"
    ],
    [
        2,
        "&bernou;"
    ],
    [
        0,
        "&Cayleys;"
    ],
    [
        1,
        "&escr;"
    ],
    [
        0,
        "&Escr;"
    ],
    [
        0,
        "&Fouriertrf;"
    ],
    [
        1,
        "&Mellintrf;"
    ],
    [
        0,
        "&order;"
    ],
    [
        0,
        "&alefsym;"
    ],
    [
        0,
        "&beth;"
    ],
    [
        0,
        "&gimel;"
    ],
    [
        0,
        "&daleth;"
    ],
    [
        12,
        "&CapitalDifferentialD;"
    ],
    [
        0,
        "&dd;"
    ],
    [
        0,
        "&ee;"
    ],
    [
        0,
        "&ii;"
    ],
    [
        10,
        "&frac13;"
    ],
    [
        0,
        "&frac23;"
    ],
    [
        0,
        "&frac15;"
    ],
    [
        0,
        "&frac25;"
    ],
    [
        0,
        "&frac35;"
    ],
    [
        0,
        "&frac45;"
    ],
    [
        0,
        "&frac16;"
    ],
    [
        0,
        "&frac56;"
    ],
    [
        0,
        "&frac18;"
    ],
    [
        0,
        "&frac38;"
    ],
    [
        0,
        "&frac58;"
    ],
    [
        0,
        "&frac78;"
    ],
    [
        49,
        "&larr;"
    ],
    [
        0,
        "&ShortUpArrow;"
    ],
    [
        0,
        "&rarr;"
    ],
    [
        0,
        "&darr;"
    ],
    [
        0,
        "&harr;"
    ],
    [
        0,
        "&updownarrow;"
    ],
    [
        0,
        "&nwarr;"
    ],
    [
        0,
        "&nearr;"
    ],
    [
        0,
        "&LowerRightArrow;"
    ],
    [
        0,
        "&LowerLeftArrow;"
    ],
    [
        0,
        "&nlarr;"
    ],
    [
        0,
        "&nrarr;"
    ],
    [
        1,
        {
            v: "&rarrw;",
            n: 824,
            o: "&nrarrw;"
        }
    ],
    [
        0,
        "&Larr;"
    ],
    [
        0,
        "&Uarr;"
    ],
    [
        0,
        "&Rarr;"
    ],
    [
        0,
        "&Darr;"
    ],
    [
        0,
        "&larrtl;"
    ],
    [
        0,
        "&rarrtl;"
    ],
    [
        0,
        "&LeftTeeArrow;"
    ],
    [
        0,
        "&mapstoup;"
    ],
    [
        0,
        "&map;"
    ],
    [
        0,
        "&DownTeeArrow;"
    ],
    [
        1,
        "&hookleftarrow;"
    ],
    [
        0,
        "&hookrightarrow;"
    ],
    [
        0,
        "&larrlp;"
    ],
    [
        0,
        "&looparrowright;"
    ],
    [
        0,
        "&harrw;"
    ],
    [
        0,
        "&nharr;"
    ],
    [
        1,
        "&lsh;"
    ],
    [
        0,
        "&rsh;"
    ],
    [
        0,
        "&ldsh;"
    ],
    [
        0,
        "&rdsh;"
    ],
    [
        1,
        "&crarr;"
    ],
    [
        0,
        "&cularr;"
    ],
    [
        0,
        "&curarr;"
    ],
    [
        2,
        "&circlearrowleft;"
    ],
    [
        0,
        "&circlearrowright;"
    ],
    [
        0,
        "&leftharpoonup;"
    ],
    [
        0,
        "&DownLeftVector;"
    ],
    [
        0,
        "&RightUpVector;"
    ],
    [
        0,
        "&LeftUpVector;"
    ],
    [
        0,
        "&rharu;"
    ],
    [
        0,
        "&DownRightVector;"
    ],
    [
        0,
        "&dharr;"
    ],
    [
        0,
        "&dharl;"
    ],
    [
        0,
        "&RightArrowLeftArrow;"
    ],
    [
        0,
        "&udarr;"
    ],
    [
        0,
        "&LeftArrowRightArrow;"
    ],
    [
        0,
        "&leftleftarrows;"
    ],
    [
        0,
        "&upuparrows;"
    ],
    [
        0,
        "&rightrightarrows;"
    ],
    [
        0,
        "&ddarr;"
    ],
    [
        0,
        "&leftrightharpoons;"
    ],
    [
        0,
        "&Equilibrium;"
    ],
    [
        0,
        "&nlArr;"
    ],
    [
        0,
        "&nhArr;"
    ],
    [
        0,
        "&nrArr;"
    ],
    [
        0,
        "&DoubleLeftArrow;"
    ],
    [
        0,
        "&DoubleUpArrow;"
    ],
    [
        0,
        "&DoubleRightArrow;"
    ],
    [
        0,
        "&dArr;"
    ],
    [
        0,
        "&DoubleLeftRightArrow;"
    ],
    [
        0,
        "&DoubleUpDownArrow;"
    ],
    [
        0,
        "&nwArr;"
    ],
    [
        0,
        "&neArr;"
    ],
    [
        0,
        "&seArr;"
    ],
    [
        0,
        "&swArr;"
    ],
    [
        0,
        "&lAarr;"
    ],
    [
        0,
        "&rAarr;"
    ],
    [
        1,
        "&zigrarr;"
    ],
    [
        6,
        "&larrb;"
    ],
    [
        0,
        "&rarrb;"
    ],
    [
        15,
        "&DownArrowUpArrow;"
    ],
    [
        7,
        "&loarr;"
    ],
    [
        0,
        "&roarr;"
    ],
    [
        0,
        "&hoarr;"
    ],
    [
        0,
        "&forall;"
    ],
    [
        0,
        "&comp;"
    ],
    [
        0,
        {
            v: "&part;",
            n: 824,
            o: "&npart;"
        }
    ],
    [
        0,
        "&exist;"
    ],
    [
        0,
        "&nexist;"
    ],
    [
        0,
        "&empty;"
    ],
    [
        1,
        "&Del;"
    ],
    [
        0,
        "&Element;"
    ],
    [
        0,
        "&NotElement;"
    ],
    [
        1,
        "&ni;"
    ],
    [
        0,
        "&notni;"
    ],
    [
        2,
        "&prod;"
    ],
    [
        0,
        "&coprod;"
    ],
    [
        0,
        "&sum;"
    ],
    [
        0,
        "&minus;"
    ],
    [
        0,
        "&MinusPlus;"
    ],
    [
        0,
        "&dotplus;"
    ],
    [
        1,
        "&Backslash;"
    ],
    [
        0,
        "&lowast;"
    ],
    [
        0,
        "&compfn;"
    ],
    [
        1,
        "&radic;"
    ],
    [
        2,
        "&prop;"
    ],
    [
        0,
        "&infin;"
    ],
    [
        0,
        "&angrt;"
    ],
    [
        0,
        {
            v: "&ang;",
            n: 8402,
            o: "&nang;"
        }
    ],
    [
        0,
        "&angmsd;"
    ],
    [
        0,
        "&angsph;"
    ],
    [
        0,
        "&mid;"
    ],
    [
        0,
        "&nmid;"
    ],
    [
        0,
        "&DoubleVerticalBar;"
    ],
    [
        0,
        "&NotDoubleVerticalBar;"
    ],
    [
        0,
        "&and;"
    ],
    [
        0,
        "&or;"
    ],
    [
        0,
        {
            v: "&cap;",
            n: 65024,
            o: "&caps;"
        }
    ],
    [
        0,
        {
            v: "&cup;",
            n: 65024,
            o: "&cups;"
        }
    ],
    [
        0,
        "&int;"
    ],
    [
        0,
        "&Int;"
    ],
    [
        0,
        "&iiint;"
    ],
    [
        0,
        "&conint;"
    ],
    [
        0,
        "&Conint;"
    ],
    [
        0,
        "&Cconint;"
    ],
    [
        0,
        "&cwint;"
    ],
    [
        0,
        "&ClockwiseContourIntegral;"
    ],
    [
        0,
        "&awconint;"
    ],
    [
        0,
        "&there4;"
    ],
    [
        0,
        "&becaus;"
    ],
    [
        0,
        "&ratio;"
    ],
    [
        0,
        "&Colon;"
    ],
    [
        0,
        "&dotminus;"
    ],
    [
        1,
        "&mDDot;"
    ],
    [
        0,
        "&homtht;"
    ],
    [
        0,
        {
            v: "&sim;",
            n: 8402,
            o: "&nvsim;"
        }
    ],
    [
        0,
        {
            v: "&backsim;",
            n: 817,
            o: "&race;"
        }
    ],
    [
        0,
        {
            v: "&ac;",
            n: 819,
            o: "&acE;"
        }
    ],
    [
        0,
        "&acd;"
    ],
    [
        0,
        "&VerticalTilde;"
    ],
    [
        0,
        "&NotTilde;"
    ],
    [
        0,
        {
            v: "&eqsim;",
            n: 824,
            o: "&nesim;"
        }
    ],
    [
        0,
        "&sime;"
    ],
    [
        0,
        "&NotTildeEqual;"
    ],
    [
        0,
        "&cong;"
    ],
    [
        0,
        "&simne;"
    ],
    [
        0,
        "&ncong;"
    ],
    [
        0,
        "&ap;"
    ],
    [
        0,
        "&nap;"
    ],
    [
        0,
        "&ape;"
    ],
    [
        0,
        {
            v: "&apid;",
            n: 824,
            o: "&napid;"
        }
    ],
    [
        0,
        "&backcong;"
    ],
    [
        0,
        {
            v: "&asympeq;",
            n: 8402,
            o: "&nvap;"
        }
    ],
    [
        0,
        {
            v: "&bump;",
            n: 824,
            o: "&nbump;"
        }
    ],
    [
        0,
        {
            v: "&bumpe;",
            n: 824,
            o: "&nbumpe;"
        }
    ],
    [
        0,
        {
            v: "&doteq;",
            n: 824,
            o: "&nedot;"
        }
    ],
    [
        0,
        "&doteqdot;"
    ],
    [
        0,
        "&efDot;"
    ],
    [
        0,
        "&erDot;"
    ],
    [
        0,
        "&Assign;"
    ],
    [
        0,
        "&ecolon;"
    ],
    [
        0,
        "&ecir;"
    ],
    [
        0,
        "&circeq;"
    ],
    [
        1,
        "&wedgeq;"
    ],
    [
        0,
        "&veeeq;"
    ],
    [
        1,
        "&triangleq;"
    ],
    [
        2,
        "&equest;"
    ],
    [
        0,
        "&ne;"
    ],
    [
        0,
        {
            v: "&Congruent;",
            n: 8421,
            o: "&bnequiv;"
        }
    ],
    [
        0,
        "&nequiv;"
    ],
    [
        1,
        {
            v: "&le;",
            n: 8402,
            o: "&nvle;"
        }
    ],
    [
        0,
        {
            v: "&ge;",
            n: 8402,
            o: "&nvge;"
        }
    ],
    [
        0,
        {
            v: "&lE;",
            n: 824,
            o: "&nlE;"
        }
    ],
    [
        0,
        {
            v: "&gE;",
            n: 824,
            o: "&ngE;"
        }
    ],
    [
        0,
        {
            v: "&lnE;",
            n: 65024,
            o: "&lvertneqq;"
        }
    ],
    [
        0,
        {
            v: "&gnE;",
            n: 65024,
            o: "&gvertneqq;"
        }
    ],
    [
        0,
        {
            v: "&ll;",
            n: new Map(/* #__PURE__ */ $30ae39ed5c434785$var$restoreDiff([
                [
                    824,
                    "&nLtv;"
                ],
                [
                    7577,
                    "&nLt;"
                ]
            ]))
        }
    ],
    [
        0,
        {
            v: "&gg;",
            n: new Map(/* #__PURE__ */ $30ae39ed5c434785$var$restoreDiff([
                [
                    824,
                    "&nGtv;"
                ],
                [
                    7577,
                    "&nGt;"
                ]
            ]))
        }
    ],
    [
        0,
        "&between;"
    ],
    [
        0,
        "&NotCupCap;"
    ],
    [
        0,
        "&nless;"
    ],
    [
        0,
        "&ngt;"
    ],
    [
        0,
        "&nle;"
    ],
    [
        0,
        "&nge;"
    ],
    [
        0,
        "&lesssim;"
    ],
    [
        0,
        "&GreaterTilde;"
    ],
    [
        0,
        "&nlsim;"
    ],
    [
        0,
        "&ngsim;"
    ],
    [
        0,
        "&LessGreater;"
    ],
    [
        0,
        "&gl;"
    ],
    [
        0,
        "&NotLessGreater;"
    ],
    [
        0,
        "&NotGreaterLess;"
    ],
    [
        0,
        "&pr;"
    ],
    [
        0,
        "&sc;"
    ],
    [
        0,
        "&prcue;"
    ],
    [
        0,
        "&sccue;"
    ],
    [
        0,
        "&PrecedesTilde;"
    ],
    [
        0,
        {
            v: "&scsim;",
            n: 824,
            o: "&NotSucceedsTilde;"
        }
    ],
    [
        0,
        "&NotPrecedes;"
    ],
    [
        0,
        "&NotSucceeds;"
    ],
    [
        0,
        {
            v: "&sub;",
            n: 8402,
            o: "&NotSubset;"
        }
    ],
    [
        0,
        {
            v: "&sup;",
            n: 8402,
            o: "&NotSuperset;"
        }
    ],
    [
        0,
        "&nsub;"
    ],
    [
        0,
        "&nsup;"
    ],
    [
        0,
        "&sube;"
    ],
    [
        0,
        "&supe;"
    ],
    [
        0,
        "&NotSubsetEqual;"
    ],
    [
        0,
        "&NotSupersetEqual;"
    ],
    [
        0,
        {
            v: "&subne;",
            n: 65024,
            o: "&varsubsetneq;"
        }
    ],
    [
        0,
        {
            v: "&supne;",
            n: 65024,
            o: "&varsupsetneq;"
        }
    ],
    [
        1,
        "&cupdot;"
    ],
    [
        0,
        "&UnionPlus;"
    ],
    [
        0,
        {
            v: "&sqsub;",
            n: 824,
            o: "&NotSquareSubset;"
        }
    ],
    [
        0,
        {
            v: "&sqsup;",
            n: 824,
            o: "&NotSquareSuperset;"
        }
    ],
    [
        0,
        "&sqsube;"
    ],
    [
        0,
        "&sqsupe;"
    ],
    [
        0,
        {
            v: "&sqcap;",
            n: 65024,
            o: "&sqcaps;"
        }
    ],
    [
        0,
        {
            v: "&sqcup;",
            n: 65024,
            o: "&sqcups;"
        }
    ],
    [
        0,
        "&CirclePlus;"
    ],
    [
        0,
        "&CircleMinus;"
    ],
    [
        0,
        "&CircleTimes;"
    ],
    [
        0,
        "&osol;"
    ],
    [
        0,
        "&CircleDot;"
    ],
    [
        0,
        "&circledcirc;"
    ],
    [
        0,
        "&circledast;"
    ],
    [
        1,
        "&circleddash;"
    ],
    [
        0,
        "&boxplus;"
    ],
    [
        0,
        "&boxminus;"
    ],
    [
        0,
        "&boxtimes;"
    ],
    [
        0,
        "&dotsquare;"
    ],
    [
        0,
        "&RightTee;"
    ],
    [
        0,
        "&dashv;"
    ],
    [
        0,
        "&DownTee;"
    ],
    [
        0,
        "&bot;"
    ],
    [
        1,
        "&models;"
    ],
    [
        0,
        "&DoubleRightTee;"
    ],
    [
        0,
        "&Vdash;"
    ],
    [
        0,
        "&Vvdash;"
    ],
    [
        0,
        "&VDash;"
    ],
    [
        0,
        "&nvdash;"
    ],
    [
        0,
        "&nvDash;"
    ],
    [
        0,
        "&nVdash;"
    ],
    [
        0,
        "&nVDash;"
    ],
    [
        0,
        "&prurel;"
    ],
    [
        1,
        "&LeftTriangle;"
    ],
    [
        0,
        "&RightTriangle;"
    ],
    [
        0,
        {
            v: "&LeftTriangleEqual;",
            n: 8402,
            o: "&nvltrie;"
        }
    ],
    [
        0,
        {
            v: "&RightTriangleEqual;",
            n: 8402,
            o: "&nvrtrie;"
        }
    ],
    [
        0,
        "&origof;"
    ],
    [
        0,
        "&imof;"
    ],
    [
        0,
        "&multimap;"
    ],
    [
        0,
        "&hercon;"
    ],
    [
        0,
        "&intcal;"
    ],
    [
        0,
        "&veebar;"
    ],
    [
        1,
        "&barvee;"
    ],
    [
        0,
        "&angrtvb;"
    ],
    [
        0,
        "&lrtri;"
    ],
    [
        0,
        "&bigwedge;"
    ],
    [
        0,
        "&bigvee;"
    ],
    [
        0,
        "&bigcap;"
    ],
    [
        0,
        "&bigcup;"
    ],
    [
        0,
        "&diam;"
    ],
    [
        0,
        "&sdot;"
    ],
    [
        0,
        "&sstarf;"
    ],
    [
        0,
        "&divideontimes;"
    ],
    [
        0,
        "&bowtie;"
    ],
    [
        0,
        "&ltimes;"
    ],
    [
        0,
        "&rtimes;"
    ],
    [
        0,
        "&leftthreetimes;"
    ],
    [
        0,
        "&rightthreetimes;"
    ],
    [
        0,
        "&backsimeq;"
    ],
    [
        0,
        "&curlyvee;"
    ],
    [
        0,
        "&curlywedge;"
    ],
    [
        0,
        "&Sub;"
    ],
    [
        0,
        "&Sup;"
    ],
    [
        0,
        "&Cap;"
    ],
    [
        0,
        "&Cup;"
    ],
    [
        0,
        "&fork;"
    ],
    [
        0,
        "&epar;"
    ],
    [
        0,
        "&lessdot;"
    ],
    [
        0,
        "&gtdot;"
    ],
    [
        0,
        {
            v: "&Ll;",
            n: 824,
            o: "&nLl;"
        }
    ],
    [
        0,
        {
            v: "&Gg;",
            n: 824,
            o: "&nGg;"
        }
    ],
    [
        0,
        {
            v: "&leg;",
            n: 65024,
            o: "&lesg;"
        }
    ],
    [
        0,
        {
            v: "&gel;",
            n: 65024,
            o: "&gesl;"
        }
    ],
    [
        2,
        "&cuepr;"
    ],
    [
        0,
        "&cuesc;"
    ],
    [
        0,
        "&NotPrecedesSlantEqual;"
    ],
    [
        0,
        "&NotSucceedsSlantEqual;"
    ],
    [
        0,
        "&NotSquareSubsetEqual;"
    ],
    [
        0,
        "&NotSquareSupersetEqual;"
    ],
    [
        2,
        "&lnsim;"
    ],
    [
        0,
        "&gnsim;"
    ],
    [
        0,
        "&precnsim;"
    ],
    [
        0,
        "&scnsim;"
    ],
    [
        0,
        "&nltri;"
    ],
    [
        0,
        "&NotRightTriangle;"
    ],
    [
        0,
        "&nltrie;"
    ],
    [
        0,
        "&NotRightTriangleEqual;"
    ],
    [
        0,
        "&vellip;"
    ],
    [
        0,
        "&ctdot;"
    ],
    [
        0,
        "&utdot;"
    ],
    [
        0,
        "&dtdot;"
    ],
    [
        0,
        "&disin;"
    ],
    [
        0,
        "&isinsv;"
    ],
    [
        0,
        "&isins;"
    ],
    [
        0,
        {
            v: "&isindot;",
            n: 824,
            o: "&notindot;"
        }
    ],
    [
        0,
        "&notinvc;"
    ],
    [
        0,
        "&notinvb;"
    ],
    [
        1,
        {
            v: "&isinE;",
            n: 824,
            o: "&notinE;"
        }
    ],
    [
        0,
        "&nisd;"
    ],
    [
        0,
        "&xnis;"
    ],
    [
        0,
        "&nis;"
    ],
    [
        0,
        "&notnivc;"
    ],
    [
        0,
        "&notnivb;"
    ],
    [
        6,
        "&barwed;"
    ],
    [
        0,
        "&Barwed;"
    ],
    [
        1,
        "&lceil;"
    ],
    [
        0,
        "&rceil;"
    ],
    [
        0,
        "&LeftFloor;"
    ],
    [
        0,
        "&rfloor;"
    ],
    [
        0,
        "&drcrop;"
    ],
    [
        0,
        "&dlcrop;"
    ],
    [
        0,
        "&urcrop;"
    ],
    [
        0,
        "&ulcrop;"
    ],
    [
        0,
        "&bnot;"
    ],
    [
        1,
        "&profline;"
    ],
    [
        0,
        "&profsurf;"
    ],
    [
        1,
        "&telrec;"
    ],
    [
        0,
        "&target;"
    ],
    [
        5,
        "&ulcorn;"
    ],
    [
        0,
        "&urcorn;"
    ],
    [
        0,
        "&dlcorn;"
    ],
    [
        0,
        "&drcorn;"
    ],
    [
        2,
        "&frown;"
    ],
    [
        0,
        "&smile;"
    ],
    [
        9,
        "&cylcty;"
    ],
    [
        0,
        "&profalar;"
    ],
    [
        7,
        "&topbot;"
    ],
    [
        6,
        "&ovbar;"
    ],
    [
        1,
        "&solbar;"
    ],
    [
        60,
        "&angzarr;"
    ],
    [
        51,
        "&lmoustache;"
    ],
    [
        0,
        "&rmoustache;"
    ],
    [
        2,
        "&OverBracket;"
    ],
    [
        0,
        "&bbrk;"
    ],
    [
        0,
        "&bbrktbrk;"
    ],
    [
        37,
        "&OverParenthesis;"
    ],
    [
        0,
        "&UnderParenthesis;"
    ],
    [
        0,
        "&OverBrace;"
    ],
    [
        0,
        "&UnderBrace;"
    ],
    [
        2,
        "&trpezium;"
    ],
    [
        4,
        "&elinters;"
    ],
    [
        59,
        "&blank;"
    ],
    [
        164,
        "&circledS;"
    ],
    [
        55,
        "&boxh;"
    ],
    [
        1,
        "&boxv;"
    ],
    [
        9,
        "&boxdr;"
    ],
    [
        3,
        "&boxdl;"
    ],
    [
        3,
        "&boxur;"
    ],
    [
        3,
        "&boxul;"
    ],
    [
        3,
        "&boxvr;"
    ],
    [
        7,
        "&boxvl;"
    ],
    [
        7,
        "&boxhd;"
    ],
    [
        7,
        "&boxhu;"
    ],
    [
        7,
        "&boxvh;"
    ],
    [
        19,
        "&boxH;"
    ],
    [
        0,
        "&boxV;"
    ],
    [
        0,
        "&boxdR;"
    ],
    [
        0,
        "&boxDr;"
    ],
    [
        0,
        "&boxDR;"
    ],
    [
        0,
        "&boxdL;"
    ],
    [
        0,
        "&boxDl;"
    ],
    [
        0,
        "&boxDL;"
    ],
    [
        0,
        "&boxuR;"
    ],
    [
        0,
        "&boxUr;"
    ],
    [
        0,
        "&boxUR;"
    ],
    [
        0,
        "&boxuL;"
    ],
    [
        0,
        "&boxUl;"
    ],
    [
        0,
        "&boxUL;"
    ],
    [
        0,
        "&boxvR;"
    ],
    [
        0,
        "&boxVr;"
    ],
    [
        0,
        "&boxVR;"
    ],
    [
        0,
        "&boxvL;"
    ],
    [
        0,
        "&boxVl;"
    ],
    [
        0,
        "&boxVL;"
    ],
    [
        0,
        "&boxHd;"
    ],
    [
        0,
        "&boxhD;"
    ],
    [
        0,
        "&boxHD;"
    ],
    [
        0,
        "&boxHu;"
    ],
    [
        0,
        "&boxhU;"
    ],
    [
        0,
        "&boxHU;"
    ],
    [
        0,
        "&boxvH;"
    ],
    [
        0,
        "&boxVh;"
    ],
    [
        0,
        "&boxVH;"
    ],
    [
        19,
        "&uhblk;"
    ],
    [
        3,
        "&lhblk;"
    ],
    [
        3,
        "&block;"
    ],
    [
        8,
        "&blk14;"
    ],
    [
        0,
        "&blk12;"
    ],
    [
        0,
        "&blk34;"
    ],
    [
        13,
        "&square;"
    ],
    [
        8,
        "&blacksquare;"
    ],
    [
        0,
        "&EmptyVerySmallSquare;"
    ],
    [
        1,
        "&rect;"
    ],
    [
        0,
        "&marker;"
    ],
    [
        2,
        "&fltns;"
    ],
    [
        1,
        "&bigtriangleup;"
    ],
    [
        0,
        "&blacktriangle;"
    ],
    [
        0,
        "&triangle;"
    ],
    [
        2,
        "&blacktriangleright;"
    ],
    [
        0,
        "&rtri;"
    ],
    [
        3,
        "&bigtriangledown;"
    ],
    [
        0,
        "&blacktriangledown;"
    ],
    [
        0,
        "&dtri;"
    ],
    [
        2,
        "&blacktriangleleft;"
    ],
    [
        0,
        "&ltri;"
    ],
    [
        6,
        "&loz;"
    ],
    [
        0,
        "&cir;"
    ],
    [
        32,
        "&tridot;"
    ],
    [
        2,
        "&bigcirc;"
    ],
    [
        8,
        "&ultri;"
    ],
    [
        0,
        "&urtri;"
    ],
    [
        0,
        "&lltri;"
    ],
    [
        0,
        "&EmptySmallSquare;"
    ],
    [
        0,
        "&FilledSmallSquare;"
    ],
    [
        8,
        "&bigstar;"
    ],
    [
        0,
        "&star;"
    ],
    [
        7,
        "&phone;"
    ],
    [
        49,
        "&female;"
    ],
    [
        1,
        "&male;"
    ],
    [
        29,
        "&spades;"
    ],
    [
        2,
        "&clubs;"
    ],
    [
        1,
        "&hearts;"
    ],
    [
        0,
        "&diamondsuit;"
    ],
    [
        3,
        "&sung;"
    ],
    [
        2,
        "&flat;"
    ],
    [
        0,
        "&natural;"
    ],
    [
        0,
        "&sharp;"
    ],
    [
        163,
        "&check;"
    ],
    [
        3,
        "&cross;"
    ],
    [
        8,
        "&malt;"
    ],
    [
        21,
        "&sext;"
    ],
    [
        33,
        "&VerticalSeparator;"
    ],
    [
        25,
        "&lbbrk;"
    ],
    [
        0,
        "&rbbrk;"
    ],
    [
        84,
        "&bsolhsub;"
    ],
    [
        0,
        "&suphsol;"
    ],
    [
        28,
        "&LeftDoubleBracket;"
    ],
    [
        0,
        "&RightDoubleBracket;"
    ],
    [
        0,
        "&lang;"
    ],
    [
        0,
        "&rang;"
    ],
    [
        0,
        "&Lang;"
    ],
    [
        0,
        "&Rang;"
    ],
    [
        0,
        "&loang;"
    ],
    [
        0,
        "&roang;"
    ],
    [
        7,
        "&longleftarrow;"
    ],
    [
        0,
        "&longrightarrow;"
    ],
    [
        0,
        "&longleftrightarrow;"
    ],
    [
        0,
        "&DoubleLongLeftArrow;"
    ],
    [
        0,
        "&DoubleLongRightArrow;"
    ],
    [
        0,
        "&DoubleLongLeftRightArrow;"
    ],
    [
        1,
        "&longmapsto;"
    ],
    [
        2,
        "&dzigrarr;"
    ],
    [
        258,
        "&nvlArr;"
    ],
    [
        0,
        "&nvrArr;"
    ],
    [
        0,
        "&nvHarr;"
    ],
    [
        0,
        "&Map;"
    ],
    [
        6,
        "&lbarr;"
    ],
    [
        0,
        "&bkarow;"
    ],
    [
        0,
        "&lBarr;"
    ],
    [
        0,
        "&dbkarow;"
    ],
    [
        0,
        "&drbkarow;"
    ],
    [
        0,
        "&DDotrahd;"
    ],
    [
        0,
        "&UpArrowBar;"
    ],
    [
        0,
        "&DownArrowBar;"
    ],
    [
        2,
        "&Rarrtl;"
    ],
    [
        2,
        "&latail;"
    ],
    [
        0,
        "&ratail;"
    ],
    [
        0,
        "&lAtail;"
    ],
    [
        0,
        "&rAtail;"
    ],
    [
        0,
        "&larrfs;"
    ],
    [
        0,
        "&rarrfs;"
    ],
    [
        0,
        "&larrbfs;"
    ],
    [
        0,
        "&rarrbfs;"
    ],
    [
        2,
        "&nwarhk;"
    ],
    [
        0,
        "&nearhk;"
    ],
    [
        0,
        "&hksearow;"
    ],
    [
        0,
        "&hkswarow;"
    ],
    [
        0,
        "&nwnear;"
    ],
    [
        0,
        "&nesear;"
    ],
    [
        0,
        "&seswar;"
    ],
    [
        0,
        "&swnwar;"
    ],
    [
        8,
        {
            v: "&rarrc;",
            n: 824,
            o: "&nrarrc;"
        }
    ],
    [
        1,
        "&cudarrr;"
    ],
    [
        0,
        "&ldca;"
    ],
    [
        0,
        "&rdca;"
    ],
    [
        0,
        "&cudarrl;"
    ],
    [
        0,
        "&larrpl;"
    ],
    [
        2,
        "&curarrm;"
    ],
    [
        0,
        "&cularrp;"
    ],
    [
        7,
        "&rarrpl;"
    ],
    [
        2,
        "&harrcir;"
    ],
    [
        0,
        "&Uarrocir;"
    ],
    [
        0,
        "&lurdshar;"
    ],
    [
        0,
        "&ldrushar;"
    ],
    [
        2,
        "&LeftRightVector;"
    ],
    [
        0,
        "&RightUpDownVector;"
    ],
    [
        0,
        "&DownLeftRightVector;"
    ],
    [
        0,
        "&LeftUpDownVector;"
    ],
    [
        0,
        "&LeftVectorBar;"
    ],
    [
        0,
        "&RightVectorBar;"
    ],
    [
        0,
        "&RightUpVectorBar;"
    ],
    [
        0,
        "&RightDownVectorBar;"
    ],
    [
        0,
        "&DownLeftVectorBar;"
    ],
    [
        0,
        "&DownRightVectorBar;"
    ],
    [
        0,
        "&LeftUpVectorBar;"
    ],
    [
        0,
        "&LeftDownVectorBar;"
    ],
    [
        0,
        "&LeftTeeVector;"
    ],
    [
        0,
        "&RightTeeVector;"
    ],
    [
        0,
        "&RightUpTeeVector;"
    ],
    [
        0,
        "&RightDownTeeVector;"
    ],
    [
        0,
        "&DownLeftTeeVector;"
    ],
    [
        0,
        "&DownRightTeeVector;"
    ],
    [
        0,
        "&LeftUpTeeVector;"
    ],
    [
        0,
        "&LeftDownTeeVector;"
    ],
    [
        0,
        "&lHar;"
    ],
    [
        0,
        "&uHar;"
    ],
    [
        0,
        "&rHar;"
    ],
    [
        0,
        "&dHar;"
    ],
    [
        0,
        "&luruhar;"
    ],
    [
        0,
        "&ldrdhar;"
    ],
    [
        0,
        "&ruluhar;"
    ],
    [
        0,
        "&rdldhar;"
    ],
    [
        0,
        "&lharul;"
    ],
    [
        0,
        "&llhard;"
    ],
    [
        0,
        "&rharul;"
    ],
    [
        0,
        "&lrhard;"
    ],
    [
        0,
        "&udhar;"
    ],
    [
        0,
        "&duhar;"
    ],
    [
        0,
        "&RoundImplies;"
    ],
    [
        0,
        "&erarr;"
    ],
    [
        0,
        "&simrarr;"
    ],
    [
        0,
        "&larrsim;"
    ],
    [
        0,
        "&rarrsim;"
    ],
    [
        0,
        "&rarrap;"
    ],
    [
        0,
        "&ltlarr;"
    ],
    [
        1,
        "&gtrarr;"
    ],
    [
        0,
        "&subrarr;"
    ],
    [
        1,
        "&suplarr;"
    ],
    [
        0,
        "&lfisht;"
    ],
    [
        0,
        "&rfisht;"
    ],
    [
        0,
        "&ufisht;"
    ],
    [
        0,
        "&dfisht;"
    ],
    [
        5,
        "&lopar;"
    ],
    [
        0,
        "&ropar;"
    ],
    [
        4,
        "&lbrke;"
    ],
    [
        0,
        "&rbrke;"
    ],
    [
        0,
        "&lbrkslu;"
    ],
    [
        0,
        "&rbrksld;"
    ],
    [
        0,
        "&lbrksld;"
    ],
    [
        0,
        "&rbrkslu;"
    ],
    [
        0,
        "&langd;"
    ],
    [
        0,
        "&rangd;"
    ],
    [
        0,
        "&lparlt;"
    ],
    [
        0,
        "&rpargt;"
    ],
    [
        0,
        "&gtlPar;"
    ],
    [
        0,
        "&ltrPar;"
    ],
    [
        3,
        "&vzigzag;"
    ],
    [
        1,
        "&vangrt;"
    ],
    [
        0,
        "&angrtvbd;"
    ],
    [
        6,
        "&ange;"
    ],
    [
        0,
        "&range;"
    ],
    [
        0,
        "&dwangle;"
    ],
    [
        0,
        "&uwangle;"
    ],
    [
        0,
        "&angmsdaa;"
    ],
    [
        0,
        "&angmsdab;"
    ],
    [
        0,
        "&angmsdac;"
    ],
    [
        0,
        "&angmsdad;"
    ],
    [
        0,
        "&angmsdae;"
    ],
    [
        0,
        "&angmsdaf;"
    ],
    [
        0,
        "&angmsdag;"
    ],
    [
        0,
        "&angmsdah;"
    ],
    [
        0,
        "&bemptyv;"
    ],
    [
        0,
        "&demptyv;"
    ],
    [
        0,
        "&cemptyv;"
    ],
    [
        0,
        "&raemptyv;"
    ],
    [
        0,
        "&laemptyv;"
    ],
    [
        0,
        "&ohbar;"
    ],
    [
        0,
        "&omid;"
    ],
    [
        0,
        "&opar;"
    ],
    [
        1,
        "&operp;"
    ],
    [
        1,
        "&olcross;"
    ],
    [
        0,
        "&odsold;"
    ],
    [
        1,
        "&olcir;"
    ],
    [
        0,
        "&ofcir;"
    ],
    [
        0,
        "&olt;"
    ],
    [
        0,
        "&ogt;"
    ],
    [
        0,
        "&cirscir;"
    ],
    [
        0,
        "&cirE;"
    ],
    [
        0,
        "&solb;"
    ],
    [
        0,
        "&bsolb;"
    ],
    [
        3,
        "&boxbox;"
    ],
    [
        3,
        "&trisb;"
    ],
    [
        0,
        "&rtriltri;"
    ],
    [
        0,
        {
            v: "&LeftTriangleBar;",
            n: 824,
            o: "&NotLeftTriangleBar;"
        }
    ],
    [
        0,
        {
            v: "&RightTriangleBar;",
            n: 824,
            o: "&NotRightTriangleBar;"
        }
    ],
    [
        11,
        "&iinfin;"
    ],
    [
        0,
        "&infintie;"
    ],
    [
        0,
        "&nvinfin;"
    ],
    [
        4,
        "&eparsl;"
    ],
    [
        0,
        "&smeparsl;"
    ],
    [
        0,
        "&eqvparsl;"
    ],
    [
        5,
        "&blacklozenge;"
    ],
    [
        8,
        "&RuleDelayed;"
    ],
    [
        1,
        "&dsol;"
    ],
    [
        9,
        "&bigodot;"
    ],
    [
        0,
        "&bigoplus;"
    ],
    [
        0,
        "&bigotimes;"
    ],
    [
        1,
        "&biguplus;"
    ],
    [
        1,
        "&bigsqcup;"
    ],
    [
        5,
        "&iiiint;"
    ],
    [
        0,
        "&fpartint;"
    ],
    [
        2,
        "&cirfnint;"
    ],
    [
        0,
        "&awint;"
    ],
    [
        0,
        "&rppolint;"
    ],
    [
        0,
        "&scpolint;"
    ],
    [
        0,
        "&npolint;"
    ],
    [
        0,
        "&pointint;"
    ],
    [
        0,
        "&quatint;"
    ],
    [
        0,
        "&intlarhk;"
    ],
    [
        10,
        "&pluscir;"
    ],
    [
        0,
        "&plusacir;"
    ],
    [
        0,
        "&simplus;"
    ],
    [
        0,
        "&plusdu;"
    ],
    [
        0,
        "&plussim;"
    ],
    [
        0,
        "&plustwo;"
    ],
    [
        1,
        "&mcomma;"
    ],
    [
        0,
        "&minusdu;"
    ],
    [
        2,
        "&loplus;"
    ],
    [
        0,
        "&roplus;"
    ],
    [
        0,
        "&Cross;"
    ],
    [
        0,
        "&timesd;"
    ],
    [
        0,
        "&timesbar;"
    ],
    [
        1,
        "&smashp;"
    ],
    [
        0,
        "&lotimes;"
    ],
    [
        0,
        "&rotimes;"
    ],
    [
        0,
        "&otimesas;"
    ],
    [
        0,
        "&Otimes;"
    ],
    [
        0,
        "&odiv;"
    ],
    [
        0,
        "&triplus;"
    ],
    [
        0,
        "&triminus;"
    ],
    [
        0,
        "&tritime;"
    ],
    [
        0,
        "&intprod;"
    ],
    [
        2,
        "&amalg;"
    ],
    [
        0,
        "&capdot;"
    ],
    [
        1,
        "&ncup;"
    ],
    [
        0,
        "&ncap;"
    ],
    [
        0,
        "&capand;"
    ],
    [
        0,
        "&cupor;"
    ],
    [
        0,
        "&cupcap;"
    ],
    [
        0,
        "&capcup;"
    ],
    [
        0,
        "&cupbrcap;"
    ],
    [
        0,
        "&capbrcup;"
    ],
    [
        0,
        "&cupcup;"
    ],
    [
        0,
        "&capcap;"
    ],
    [
        0,
        "&ccups;"
    ],
    [
        0,
        "&ccaps;"
    ],
    [
        2,
        "&ccupssm;"
    ],
    [
        2,
        "&And;"
    ],
    [
        0,
        "&Or;"
    ],
    [
        0,
        "&andand;"
    ],
    [
        0,
        "&oror;"
    ],
    [
        0,
        "&orslope;"
    ],
    [
        0,
        "&andslope;"
    ],
    [
        1,
        "&andv;"
    ],
    [
        0,
        "&orv;"
    ],
    [
        0,
        "&andd;"
    ],
    [
        0,
        "&ord;"
    ],
    [
        1,
        "&wedbar;"
    ],
    [
        6,
        "&sdote;"
    ],
    [
        3,
        "&simdot;"
    ],
    [
        2,
        {
            v: "&congdot;",
            n: 824,
            o: "&ncongdot;"
        }
    ],
    [
        0,
        "&easter;"
    ],
    [
        0,
        "&apacir;"
    ],
    [
        0,
        {
            v: "&apE;",
            n: 824,
            o: "&napE;"
        }
    ],
    [
        0,
        "&eplus;"
    ],
    [
        0,
        "&pluse;"
    ],
    [
        0,
        "&Esim;"
    ],
    [
        0,
        "&Colone;"
    ],
    [
        0,
        "&Equal;"
    ],
    [
        1,
        "&ddotseq;"
    ],
    [
        0,
        "&equivDD;"
    ],
    [
        0,
        "&ltcir;"
    ],
    [
        0,
        "&gtcir;"
    ],
    [
        0,
        "&ltquest;"
    ],
    [
        0,
        "&gtquest;"
    ],
    [
        0,
        {
            v: "&leqslant;",
            n: 824,
            o: "&nleqslant;"
        }
    ],
    [
        0,
        {
            v: "&geqslant;",
            n: 824,
            o: "&ngeqslant;"
        }
    ],
    [
        0,
        "&lesdot;"
    ],
    [
        0,
        "&gesdot;"
    ],
    [
        0,
        "&lesdoto;"
    ],
    [
        0,
        "&gesdoto;"
    ],
    [
        0,
        "&lesdotor;"
    ],
    [
        0,
        "&gesdotol;"
    ],
    [
        0,
        "&lap;"
    ],
    [
        0,
        "&gap;"
    ],
    [
        0,
        "&lne;"
    ],
    [
        0,
        "&gne;"
    ],
    [
        0,
        "&lnap;"
    ],
    [
        0,
        "&gnap;"
    ],
    [
        0,
        "&lEg;"
    ],
    [
        0,
        "&gEl;"
    ],
    [
        0,
        "&lsime;"
    ],
    [
        0,
        "&gsime;"
    ],
    [
        0,
        "&lsimg;"
    ],
    [
        0,
        "&gsiml;"
    ],
    [
        0,
        "&lgE;"
    ],
    [
        0,
        "&glE;"
    ],
    [
        0,
        "&lesges;"
    ],
    [
        0,
        "&gesles;"
    ],
    [
        0,
        "&els;"
    ],
    [
        0,
        "&egs;"
    ],
    [
        0,
        "&elsdot;"
    ],
    [
        0,
        "&egsdot;"
    ],
    [
        0,
        "&el;"
    ],
    [
        0,
        "&eg;"
    ],
    [
        2,
        "&siml;"
    ],
    [
        0,
        "&simg;"
    ],
    [
        0,
        "&simlE;"
    ],
    [
        0,
        "&simgE;"
    ],
    [
        0,
        {
            v: "&LessLess;",
            n: 824,
            o: "&NotNestedLessLess;"
        }
    ],
    [
        0,
        {
            v: "&GreaterGreater;",
            n: 824,
            o: "&NotNestedGreaterGreater;"
        }
    ],
    [
        1,
        "&glj;"
    ],
    [
        0,
        "&gla;"
    ],
    [
        0,
        "&ltcc;"
    ],
    [
        0,
        "&gtcc;"
    ],
    [
        0,
        "&lescc;"
    ],
    [
        0,
        "&gescc;"
    ],
    [
        0,
        "&smt;"
    ],
    [
        0,
        "&lat;"
    ],
    [
        0,
        {
            v: "&smte;",
            n: 65024,
            o: "&smtes;"
        }
    ],
    [
        0,
        {
            v: "&late;",
            n: 65024,
            o: "&lates;"
        }
    ],
    [
        0,
        "&bumpE;"
    ],
    [
        0,
        {
            v: "&PrecedesEqual;",
            n: 824,
            o: "&NotPrecedesEqual;"
        }
    ],
    [
        0,
        {
            v: "&sce;",
            n: 824,
            o: "&NotSucceedsEqual;"
        }
    ],
    [
        2,
        "&prE;"
    ],
    [
        0,
        "&scE;"
    ],
    [
        0,
        "&precneqq;"
    ],
    [
        0,
        "&scnE;"
    ],
    [
        0,
        "&prap;"
    ],
    [
        0,
        "&scap;"
    ],
    [
        0,
        "&precnapprox;"
    ],
    [
        0,
        "&scnap;"
    ],
    [
        0,
        "&Pr;"
    ],
    [
        0,
        "&Sc;"
    ],
    [
        0,
        "&subdot;"
    ],
    [
        0,
        "&supdot;"
    ],
    [
        0,
        "&subplus;"
    ],
    [
        0,
        "&supplus;"
    ],
    [
        0,
        "&submult;"
    ],
    [
        0,
        "&supmult;"
    ],
    [
        0,
        "&subedot;"
    ],
    [
        0,
        "&supedot;"
    ],
    [
        0,
        {
            v: "&subE;",
            n: 824,
            o: "&nsubE;"
        }
    ],
    [
        0,
        {
            v: "&supE;",
            n: 824,
            o: "&nsupE;"
        }
    ],
    [
        0,
        "&subsim;"
    ],
    [
        0,
        "&supsim;"
    ],
    [
        2,
        {
            v: "&subnE;",
            n: 65024,
            o: "&varsubsetneqq;"
        }
    ],
    [
        0,
        {
            v: "&supnE;",
            n: 65024,
            o: "&varsupsetneqq;"
        }
    ],
    [
        2,
        "&csub;"
    ],
    [
        0,
        "&csup;"
    ],
    [
        0,
        "&csube;"
    ],
    [
        0,
        "&csupe;"
    ],
    [
        0,
        "&subsup;"
    ],
    [
        0,
        "&supsub;"
    ],
    [
        0,
        "&subsub;"
    ],
    [
        0,
        "&supsup;"
    ],
    [
        0,
        "&suphsub;"
    ],
    [
        0,
        "&supdsub;"
    ],
    [
        0,
        "&forkv;"
    ],
    [
        0,
        "&topfork;"
    ],
    [
        0,
        "&mlcp;"
    ],
    [
        8,
        "&Dashv;"
    ],
    [
        1,
        "&Vdashl;"
    ],
    [
        0,
        "&Barv;"
    ],
    [
        0,
        "&vBar;"
    ],
    [
        0,
        "&vBarv;"
    ],
    [
        1,
        "&Vbar;"
    ],
    [
        0,
        "&Not;"
    ],
    [
        0,
        "&bNot;"
    ],
    [
        0,
        "&rnmid;"
    ],
    [
        0,
        "&cirmid;"
    ],
    [
        0,
        "&midcir;"
    ],
    [
        0,
        "&topcir;"
    ],
    [
        0,
        "&nhpar;"
    ],
    [
        0,
        "&parsim;"
    ],
    [
        9,
        {
            v: "&parsl;",
            n: 8421,
            o: "&nparsl;"
        }
    ],
    [
        44343,
        {
            n: new Map(/* #__PURE__ */ $30ae39ed5c434785$var$restoreDiff([
                [
                    56476,
                    "&Ascr;"
                ],
                [
                    1,
                    "&Cscr;"
                ],
                [
                    0,
                    "&Dscr;"
                ],
                [
                    2,
                    "&Gscr;"
                ],
                [
                    2,
                    "&Jscr;"
                ],
                [
                    0,
                    "&Kscr;"
                ],
                [
                    2,
                    "&Nscr;"
                ],
                [
                    0,
                    "&Oscr;"
                ],
                [
                    0,
                    "&Pscr;"
                ],
                [
                    0,
                    "&Qscr;"
                ],
                [
                    1,
                    "&Sscr;"
                ],
                [
                    0,
                    "&Tscr;"
                ],
                [
                    0,
                    "&Uscr;"
                ],
                [
                    0,
                    "&Vscr;"
                ],
                [
                    0,
                    "&Wscr;"
                ],
                [
                    0,
                    "&Xscr;"
                ],
                [
                    0,
                    "&Yscr;"
                ],
                [
                    0,
                    "&Zscr;"
                ],
                [
                    0,
                    "&ascr;"
                ],
                [
                    0,
                    "&bscr;"
                ],
                [
                    0,
                    "&cscr;"
                ],
                [
                    0,
                    "&dscr;"
                ],
                [
                    1,
                    "&fscr;"
                ],
                [
                    1,
                    "&hscr;"
                ],
                [
                    0,
                    "&iscr;"
                ],
                [
                    0,
                    "&jscr;"
                ],
                [
                    0,
                    "&kscr;"
                ],
                [
                    0,
                    "&lscr;"
                ],
                [
                    0,
                    "&mscr;"
                ],
                [
                    0,
                    "&nscr;"
                ],
                [
                    1,
                    "&pscr;"
                ],
                [
                    0,
                    "&qscr;"
                ],
                [
                    0,
                    "&rscr;"
                ],
                [
                    0,
                    "&sscr;"
                ],
                [
                    0,
                    "&tscr;"
                ],
                [
                    0,
                    "&uscr;"
                ],
                [
                    0,
                    "&vscr;"
                ],
                [
                    0,
                    "&wscr;"
                ],
                [
                    0,
                    "&xscr;"
                ],
                [
                    0,
                    "&yscr;"
                ],
                [
                    0,
                    "&zscr;"
                ],
                [
                    52,
                    "&Afr;"
                ],
                [
                    0,
                    "&Bfr;"
                ],
                [
                    1,
                    "&Dfr;"
                ],
                [
                    0,
                    "&Efr;"
                ],
                [
                    0,
                    "&Ffr;"
                ],
                [
                    0,
                    "&Gfr;"
                ],
                [
                    2,
                    "&Jfr;"
                ],
                [
                    0,
                    "&Kfr;"
                ],
                [
                    0,
                    "&Lfr;"
                ],
                [
                    0,
                    "&Mfr;"
                ],
                [
                    0,
                    "&Nfr;"
                ],
                [
                    0,
                    "&Ofr;"
                ],
                [
                    0,
                    "&Pfr;"
                ],
                [
                    0,
                    "&Qfr;"
                ],
                [
                    1,
                    "&Sfr;"
                ],
                [
                    0,
                    "&Tfr;"
                ],
                [
                    0,
                    "&Ufr;"
                ],
                [
                    0,
                    "&Vfr;"
                ],
                [
                    0,
                    "&Wfr;"
                ],
                [
                    0,
                    "&Xfr;"
                ],
                [
                    0,
                    "&Yfr;"
                ],
                [
                    1,
                    "&afr;"
                ],
                [
                    0,
                    "&bfr;"
                ],
                [
                    0,
                    "&cfr;"
                ],
                [
                    0,
                    "&dfr;"
                ],
                [
                    0,
                    "&efr;"
                ],
                [
                    0,
                    "&ffr;"
                ],
                [
                    0,
                    "&gfr;"
                ],
                [
                    0,
                    "&hfr;"
                ],
                [
                    0,
                    "&ifr;"
                ],
                [
                    0,
                    "&jfr;"
                ],
                [
                    0,
                    "&kfr;"
                ],
                [
                    0,
                    "&lfr;"
                ],
                [
                    0,
                    "&mfr;"
                ],
                [
                    0,
                    "&nfr;"
                ],
                [
                    0,
                    "&ofr;"
                ],
                [
                    0,
                    "&pfr;"
                ],
                [
                    0,
                    "&qfr;"
                ],
                [
                    0,
                    "&rfr;"
                ],
                [
                    0,
                    "&sfr;"
                ],
                [
                    0,
                    "&tfr;"
                ],
                [
                    0,
                    "&ufr;"
                ],
                [
                    0,
                    "&vfr;"
                ],
                [
                    0,
                    "&wfr;"
                ],
                [
                    0,
                    "&xfr;"
                ],
                [
                    0,
                    "&yfr;"
                ],
                [
                    0,
                    "&zfr;"
                ],
                [
                    0,
                    "&Aopf;"
                ],
                [
                    0,
                    "&Bopf;"
                ],
                [
                    1,
                    "&Dopf;"
                ],
                [
                    0,
                    "&Eopf;"
                ],
                [
                    0,
                    "&Fopf;"
                ],
                [
                    0,
                    "&Gopf;"
                ],
                [
                    1,
                    "&Iopf;"
                ],
                [
                    0,
                    "&Jopf;"
                ],
                [
                    0,
                    "&Kopf;"
                ],
                [
                    0,
                    "&Lopf;"
                ],
                [
                    0,
                    "&Mopf;"
                ],
                [
                    1,
                    "&Oopf;"
                ],
                [
                    3,
                    "&Sopf;"
                ],
                [
                    0,
                    "&Topf;"
                ],
                [
                    0,
                    "&Uopf;"
                ],
                [
                    0,
                    "&Vopf;"
                ],
                [
                    0,
                    "&Wopf;"
                ],
                [
                    0,
                    "&Xopf;"
                ],
                [
                    0,
                    "&Yopf;"
                ],
                [
                    1,
                    "&aopf;"
                ],
                [
                    0,
                    "&bopf;"
                ],
                [
                    0,
                    "&copf;"
                ],
                [
                    0,
                    "&dopf;"
                ],
                [
                    0,
                    "&eopf;"
                ],
                [
                    0,
                    "&fopf;"
                ],
                [
                    0,
                    "&gopf;"
                ],
                [
                    0,
                    "&hopf;"
                ],
                [
                    0,
                    "&iopf;"
                ],
                [
                    0,
                    "&jopf;"
                ],
                [
                    0,
                    "&kopf;"
                ],
                [
                    0,
                    "&lopf;"
                ],
                [
                    0,
                    "&mopf;"
                ],
                [
                    0,
                    "&nopf;"
                ],
                [
                    0,
                    "&oopf;"
                ],
                [
                    0,
                    "&popf;"
                ],
                [
                    0,
                    "&qopf;"
                ],
                [
                    0,
                    "&ropf;"
                ],
                [
                    0,
                    "&sopf;"
                ],
                [
                    0,
                    "&topf;"
                ],
                [
                    0,
                    "&uopf;"
                ],
                [
                    0,
                    "&vopf;"
                ],
                [
                    0,
                    "&wopf;"
                ],
                [
                    0,
                    "&xopf;"
                ],
                [
                    0,
                    "&yopf;"
                ],
                [
                    0,
                    "&zopf;"
                ]
            ]))
        }
    ],
    [
        8906,
        "&fflig;"
    ],
    [
        0,
        "&filig;"
    ],
    [
        0,
        "&fllig;"
    ],
    [
        0,
        "&ffilig;"
    ],
    [
        0,
        "&ffllig;"
    ]
]));

});

parcelRegister("i7QF4", function(module, exports) {

$parcel$export(module.exports, "xmlReplacer", () => $d321bae15adf01a4$export$5699810ce3244ab8);
$parcel$export(module.exports, "getCodePoint", () => $d321bae15adf01a4$export$e02688b8085d016b);
$parcel$export(module.exports, "encodeXML", () => $d321bae15adf01a4$export$18855ec5be97da16);
$parcel$export(module.exports, "escapeUTF8", () => $d321bae15adf01a4$export$9e081872deefdcb0);
$parcel$export(module.exports, "escapeAttribute", () => $d321bae15adf01a4$export$30330f3d5eb70e11);
$parcel$export(module.exports, "escapeText", () => $d321bae15adf01a4$export$96e6fc3a139b2555);
const $d321bae15adf01a4$export$5699810ce3244ab8 = /["&'<>$\x80-\uFFFF]/g;
const $d321bae15adf01a4$var$xmlCodeMap = new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        39,
        "&apos;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ]
]);
const $d321bae15adf01a4$export$e02688b8085d016b = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
String.prototype.codePointAt != null ? (str, index)=>str.codePointAt(index) : (c, index)=>(c.charCodeAt(index) & 0xfc00) === 0xd800 ? (c.charCodeAt(index) - 0xd800) * 0x400 + c.charCodeAt(index + 1) - 0xdc00 + 0x10000 : c.charCodeAt(index);
function $d321bae15adf01a4$export$18855ec5be97da16(str) {
    let ret = "";
    let lastIdx = 0;
    let match;
    while((match = $d321bae15adf01a4$export$5699810ce3244ab8.exec(str)) !== null){
        const i = match.index;
        const char = str.charCodeAt(i);
        const next = $d321bae15adf01a4$var$xmlCodeMap.get(char);
        if (next !== undefined) {
            ret += str.substring(lastIdx, i) + next;
            lastIdx = i + 1;
        } else {
            ret += `${str.substring(lastIdx, i)}&#x${$d321bae15adf01a4$export$e02688b8085d016b(str, i).toString(16)};`;
            // Increase by 1 if we have a surrogate pair
            lastIdx = $d321bae15adf01a4$export$5699810ce3244ab8.lastIndex += Number((char & 0xfc00) === 0xd800);
        }
    }
    return ret + str.substr(lastIdx);
}
const $d321bae15adf01a4$export$4e7f196112fea3c5 = $d321bae15adf01a4$export$18855ec5be97da16;
/**
 * Creates a function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 *
 * @param regex Regular expression to match characters to escape.
 * @param map Map of characters to escape to their entities.
 *
 * @returns Function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 */ function $d321bae15adf01a4$var$getEscaper(regex, map) {
    return function escape(data) {
        let match;
        let lastIdx = 0;
        let result = "";
        while(match = regex.exec(data)){
            if (lastIdx !== match.index) result += data.substring(lastIdx, match.index);
            // We know that this character will be in the map.
            result += map.get(match[0].charCodeAt(0));
            // Every match will be of length 1
            lastIdx = match.index + 1;
        }
        return result + data.substring(lastIdx);
    };
}
const $d321bae15adf01a4$export$9e081872deefdcb0 = $d321bae15adf01a4$var$getEscaper(/[&<>'"]/g, $d321bae15adf01a4$var$xmlCodeMap);
const $d321bae15adf01a4$export$30330f3d5eb70e11 = $d321bae15adf01a4$var$getEscaper(/["&\u00A0]/g, new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));
const $d321bae15adf01a4$export$96e6fc3a139b2555 = $d321bae15adf01a4$var$getEscaper(/[&<>\u00A0]/g, new Map([
    [
        38,
        "&amp;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));

});



parcelRegister("lxSNE", function(module, exports) {

$parcel$export(module.exports, "elementNames", () => $faf7302934dd11cf$export$82b917442d249e05);
$parcel$export(module.exports, "attributeNames", () => $faf7302934dd11cf$export$b4cfbfd90280b005);
const $faf7302934dd11cf$export$82b917442d249e05 = new Map([
    "altGlyph",
    "altGlyphDef",
    "altGlyphItem",
    "animateColor",
    "animateMotion",
    "animateTransform",
    "clipPath",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "foreignObject",
    "glyphRef",
    "linearGradient",
    "radialGradient",
    "textPath"
].map((val)=>[
        val.toLowerCase(),
        val
    ]));
const $faf7302934dd11cf$export$b4cfbfd90280b005 = new Map([
    "definitionURL",
    "attributeName",
    "attributeType",
    "baseFrequency",
    "baseProfile",
    "calcMode",
    "clipPathUnits",
    "diffuseConstant",
    "edgeMode",
    "filterUnits",
    "glyphRef",
    "gradientTransform",
    "gradientUnits",
    "kernelMatrix",
    "kernelUnitLength",
    "keyPoints",
    "keySplines",
    "keyTimes",
    "lengthAdjust",
    "limitingConeAngle",
    "markerHeight",
    "markerUnits",
    "markerWidth",
    "maskContentUnits",
    "maskUnits",
    "numOctaves",
    "pathLength",
    "patternContentUnits",
    "patternTransform",
    "patternUnits",
    "pointsAtX",
    "pointsAtY",
    "pointsAtZ",
    "preserveAlpha",
    "preserveAspectRatio",
    "primitiveUnits",
    "refX",
    "refY",
    "repeatCount",
    "repeatDur",
    "requiredExtensions",
    "requiredFeatures",
    "specularConstant",
    "specularExponent",
    "spreadMethod",
    "startOffset",
    "stdDeviation",
    "stitchTiles",
    "surfaceScale",
    "systemLanguage",
    "tableValues",
    "targetX",
    "targetY",
    "textLength",
    "viewBox",
    "viewTarget",
    "xChannelSelector",
    "yChannelSelector",
    "zoomAndPan"
].map((val)=>[
        val.toLowerCase(),
        val
    ]));

});



parcelRegister("8DVmQ", function(module, exports) {

$parcel$export(module.exports, "getChildren", () => $64ae77367458f2c5$export$f8cf48ee793b41be);
$parcel$export(module.exports, "getParent", () => $64ae77367458f2c5$export$58081aedf094d85b);
$parcel$export(module.exports, "getSiblings", () => $64ae77367458f2c5$export$f312c3733b79ac0d);
$parcel$export(module.exports, "getAttributeValue", () => $64ae77367458f2c5$export$1e335898aa11b111);
$parcel$export(module.exports, "hasAttrib", () => $64ae77367458f2c5$export$aa37f90c17957f38);
$parcel$export(module.exports, "getName", () => $64ae77367458f2c5$export$7d9f7e9c1c02b41e);
$parcel$export(module.exports, "nextElementSibling", () => $64ae77367458f2c5$export$9be3779649ef9cc7);
$parcel$export(module.exports, "prevElementSibling", () => $64ae77367458f2c5$export$c8bafb6e59c0b8e);
parcelRequire("273yd");
var $k9MHs = parcelRequire("k9MHs");
function $64ae77367458f2c5$export$f8cf48ee793b41be(elem) {
    return (0, $k9MHs.hasChildren)(elem) ? elem.children : [];
}
function $64ae77367458f2c5$export$58081aedf094d85b(elem) {
    return elem.parent || null;
}
function $64ae77367458f2c5$export$f312c3733b79ac0d(elem) {
    const parent = $64ae77367458f2c5$export$58081aedf094d85b(elem);
    if (parent != null) return $64ae77367458f2c5$export$f8cf48ee793b41be(parent);
    const siblings = [
        elem
    ];
    let { prev: prev, next: next } = elem;
    while(prev != null){
        siblings.unshift(prev);
        ({ prev: prev } = prev);
    }
    while(next != null){
        siblings.push(next);
        ({ next: next } = next);
    }
    return siblings;
}
function $64ae77367458f2c5$export$1e335898aa11b111(elem, name) {
    var _a;
    return (_a = elem.attribs) === null || _a === void 0 ? void 0 : _a[name];
}
function $64ae77367458f2c5$export$aa37f90c17957f38(elem, name) {
    return elem.attribs != null && Object.prototype.hasOwnProperty.call(elem.attribs, name) && elem.attribs[name] != null;
}
function $64ae77367458f2c5$export$7d9f7e9c1c02b41e(elem) {
    return elem.name;
}
function $64ae77367458f2c5$export$9be3779649ef9cc7(elem) {
    let { next: next } = elem;
    while(next !== null && !(0, $k9MHs.isTag)(next))({ next: next } = next);
    return next;
}
function $64ae77367458f2c5$export$c8bafb6e59c0b8e(elem) {
    let { prev: prev } = elem;
    while(prev !== null && !(0, $k9MHs.isTag)(prev))({ prev: prev } = prev);
    return prev;
}

});

parcelRegister("itbnG", function(module, exports) {

$parcel$export(module.exports, "removeElement", () => $d723c37795dd8712$export$f883456a56996078);
$parcel$export(module.exports, "replaceElement", () => $d723c37795dd8712$export$2dfe578f95754f6a);
$parcel$export(module.exports, "appendChild", () => $d723c37795dd8712$export$1b8e57c9ea42f1d2);
$parcel$export(module.exports, "append", () => $d723c37795dd8712$export$10d8903dec122b9d);
$parcel$export(module.exports, "prependChild", () => $d723c37795dd8712$export$47b51e6d100007bc);
$parcel$export(module.exports, "prepend", () => $d723c37795dd8712$export$68159836694e22c1);
/**
 * Remove an element from the dom
 *
 * @category Manipulation
 * @param elem The element to be removed
 */ function $d723c37795dd8712$export$f883456a56996078(elem) {
    if (elem.prev) elem.prev.next = elem.next;
    if (elem.next) elem.next.prev = elem.prev;
    if (elem.parent) {
        const childs = elem.parent.children;
        const childsIndex = childs.lastIndexOf(elem);
        if (childsIndex >= 0) childs.splice(childsIndex, 1);
    }
    elem.next = null;
    elem.prev = null;
    elem.parent = null;
}
function $d723c37795dd8712$export$2dfe578f95754f6a(elem, replacement) {
    const prev = replacement.prev = elem.prev;
    if (prev) prev.next = replacement;
    const next = replacement.next = elem.next;
    if (next) next.prev = replacement;
    const parent = replacement.parent = elem.parent;
    if (parent) {
        const childs = parent.children;
        childs[childs.lastIndexOf(elem)] = replacement;
        elem.parent = null;
    }
}
function $d723c37795dd8712$export$1b8e57c9ea42f1d2(parent, child) {
    $d723c37795dd8712$export$f883456a56996078(child);
    child.next = null;
    child.parent = parent;
    if (parent.children.push(child) > 1) {
        const sibling = parent.children[parent.children.length - 2];
        sibling.next = child;
        child.prev = sibling;
    } else child.prev = null;
}
function $d723c37795dd8712$export$10d8903dec122b9d(elem, next) {
    $d723c37795dd8712$export$f883456a56996078(next);
    const { parent: parent } = elem;
    const currNext = elem.next;
    next.next = currNext;
    next.prev = elem;
    elem.next = next;
    next.parent = parent;
    if (currNext) {
        currNext.prev = next;
        if (parent) {
            const childs = parent.children;
            childs.splice(childs.lastIndexOf(currNext), 0, next);
        }
    } else if (parent) parent.children.push(next);
}
function $d723c37795dd8712$export$47b51e6d100007bc(parent, child) {
    $d723c37795dd8712$export$f883456a56996078(child);
    child.parent = parent;
    child.prev = null;
    if (parent.children.unshift(child) !== 1) {
        const sibling = parent.children[1];
        sibling.prev = child;
        child.next = sibling;
    } else child.next = null;
}
function $d723c37795dd8712$export$68159836694e22c1(elem, prev) {
    $d723c37795dd8712$export$f883456a56996078(prev);
    const { parent: parent } = elem;
    if (parent) {
        const childs = parent.children;
        childs.splice(childs.indexOf(elem), 0, prev);
    }
    if (elem.prev) elem.prev.next = prev;
    prev.parent = parent;
    prev.prev = elem.prev;
    prev.next = elem;
    elem.prev = prev;
}

});

parcelRegister("8YbwJ", function(module, exports) {

$parcel$export(module.exports, "filter", () => $687cde539852a6be$export$3dea766d36a8935f);
$parcel$export(module.exports, "find", () => $687cde539852a6be$export$71aa6c912b956294);
$parcel$export(module.exports, "findOneChild", () => $687cde539852a6be$export$ac03a862904ce329);
$parcel$export(module.exports, "findOne", () => $687cde539852a6be$export$a541876d5d7daf90);
$parcel$export(module.exports, "existsOne", () => $687cde539852a6be$export$9d99dce58ac4a31b);
$parcel$export(module.exports, "findAll", () => $687cde539852a6be$export$18200ea6c8035394);
parcelRequire("273yd");
var $k9MHs = parcelRequire("k9MHs");
function $687cde539852a6be$export$3dea766d36a8935f(test, node, recurse = true, limit = Infinity) {
    return $687cde539852a6be$export$71aa6c912b956294(test, Array.isArray(node) ? node : [
        node
    ], recurse, limit);
}
function $687cde539852a6be$export$71aa6c912b956294(test, nodes, recurse, limit) {
    const result = [];
    /** Stack of the arrays we are looking at. */ const nodeStack = [
        nodes
    ];
    /** Stack of the indices within the arrays. */ const indexStack = [
        0
    ];
    for(;;){
        // First, check if the current array has any more elements to look at.
        if (indexStack[0] >= nodeStack[0].length) {
            // If we have no more arrays to look at, we are done.
            if (indexStack.length === 1) return result;
            // Otherwise, remove the current array from the stack.
            nodeStack.shift();
            indexStack.shift();
            continue;
        }
        const elem = nodeStack[0][indexStack[0]++];
        if (test(elem)) {
            result.push(elem);
            if (--limit <= 0) return result;
        }
        if (recurse && (0, $k9MHs.hasChildren)(elem) && elem.children.length > 0) {
            /*
             * Add the children to the stack. We are depth-first, so this is
             * the next array we look at.
             */ indexStack.unshift(0);
            nodeStack.unshift(elem.children);
        }
    }
}
function $687cde539852a6be$export$ac03a862904ce329(test, nodes) {
    return nodes.find(test);
}
function $687cde539852a6be$export$a541876d5d7daf90(test, nodes, recurse = true) {
    let elem = null;
    for(let i = 0; i < nodes.length && !elem; i++){
        const node = nodes[i];
        if (!(0, $k9MHs.isTag)(node)) continue;
        else if (test(node)) elem = node;
        else if (recurse && node.children.length > 0) elem = $687cde539852a6be$export$a541876d5d7daf90(test, node.children, true);
    }
    return elem;
}
function $687cde539852a6be$export$9d99dce58ac4a31b(test, nodes) {
    return nodes.some((checked)=>(0, $k9MHs.isTag)(checked) && (test(checked) || $687cde539852a6be$export$9d99dce58ac4a31b(test, checked.children)));
}
function $687cde539852a6be$export$18200ea6c8035394(test, nodes) {
    const result = [];
    const nodeStack = [
        nodes
    ];
    const indexStack = [
        0
    ];
    for(;;){
        if (indexStack[0] >= nodeStack[0].length) {
            if (nodeStack.length === 1) return result;
            // Otherwise, remove the current array from the stack.
            nodeStack.shift();
            indexStack.shift();
            continue;
        }
        const elem = nodeStack[0][indexStack[0]++];
        if (!(0, $k9MHs.isTag)(elem)) continue;
        if (test(elem)) result.push(elem);
        if (elem.children.length > 0) {
            indexStack.unshift(0);
            nodeStack.unshift(elem.children);
        }
    }
}

});

parcelRegister("0bNle", function(module, exports) {

$parcel$export(module.exports, "testElement", () => $00092668d5bc277d$export$7b31db6b5a0b2f32);
$parcel$export(module.exports, "getElements", () => $00092668d5bc277d$export$73eac51a39d6b0eb);
$parcel$export(module.exports, "getElementById", () => $00092668d5bc277d$export$83595b84fc78b9b4);
$parcel$export(module.exports, "getElementsByTagName", () => $00092668d5bc277d$export$af941c3c7c3b40f5);
$parcel$export(module.exports, "getElementsByTagType", () => $00092668d5bc277d$export$f5d981e30be5545b);
parcelRequire("273yd");
var $k9MHs = parcelRequire("k9MHs");

var $8YbwJ = parcelRequire("8YbwJ");
/**
 * A map of functions to check nodes against.
 */ const $00092668d5bc277d$var$Checks = {
    tag_name (name) {
        if (typeof name === "function") return (elem)=>(0, $k9MHs.isTag)(elem) && name(elem.name);
        else if (name === "*") return 0, $k9MHs.isTag;
        return (elem)=>(0, $k9MHs.isTag)(elem) && elem.name === name;
    },
    tag_type (type) {
        if (typeof type === "function") return (elem)=>type(elem.type);
        return (elem)=>elem.type === type;
    },
    tag_contains (data) {
        if (typeof data === "function") return (elem)=>(0, $k9MHs.isText)(elem) && data(elem.data);
        return (elem)=>(0, $k9MHs.isText)(elem) && elem.data === data;
    }
};
/**
 * Returns a function to check whether a node has an attribute with a particular
 * value.
 *
 * @param attrib Attribute to check.
 * @param value Attribute value to look for.
 * @returns A function to check whether the a node has an attribute with a
 *   particular value.
 */ function $00092668d5bc277d$var$getAttribCheck(attrib, value) {
    if (typeof value === "function") return (elem)=>(0, $k9MHs.isTag)(elem) && value(elem.attribs[attrib]);
    return (elem)=>(0, $k9MHs.isTag)(elem) && elem.attribs[attrib] === value;
}
/**
 * Returns a function that returns `true` if either of the input functions
 * returns `true` for a node.
 *
 * @param a First function to combine.
 * @param b Second function to combine.
 * @returns A function taking a node and returning `true` if either of the input
 *   functions returns `true` for the node.
 */ function $00092668d5bc277d$var$combineFuncs(a, b) {
    return (elem)=>a(elem) || b(elem);
}
/**
 * Returns a function that executes all checks in `options` and returns `true`
 * if any of them match a node.
 *
 * @param options An object describing nodes to look for.
 * @returns A function that executes all checks in `options` and returns `true`
 *   if any of them match a node.
 */ function $00092668d5bc277d$var$compileTest(options) {
    const funcs = Object.keys(options).map((key)=>{
        const value = options[key];
        return Object.prototype.hasOwnProperty.call($00092668d5bc277d$var$Checks, key) ? $00092668d5bc277d$var$Checks[key](value) : $00092668d5bc277d$var$getAttribCheck(key, value);
    });
    return funcs.length === 0 ? null : funcs.reduce($00092668d5bc277d$var$combineFuncs);
}
function $00092668d5bc277d$export$7b31db6b5a0b2f32(options, node) {
    const test = $00092668d5bc277d$var$compileTest(options);
    return test ? test(node) : true;
}
function $00092668d5bc277d$export$73eac51a39d6b0eb(options, nodes, recurse, limit = Infinity) {
    const test = $00092668d5bc277d$var$compileTest(options);
    return test ? (0, $8YbwJ.filter)(test, nodes, recurse, limit) : [];
}
function $00092668d5bc277d$export$83595b84fc78b9b4(id, nodes, recurse = true) {
    if (!Array.isArray(nodes)) nodes = [
        nodes
    ];
    return (0, $8YbwJ.findOne)($00092668d5bc277d$var$getAttribCheck("id", id), nodes, recurse);
}
function $00092668d5bc277d$export$af941c3c7c3b40f5(tagName, nodes, recurse = true, limit = Infinity) {
    return (0, $8YbwJ.filter)($00092668d5bc277d$var$Checks["tag_name"](tagName), nodes, recurse, limit);
}
function $00092668d5bc277d$export$f5d981e30be5545b(type, nodes, recurse = true, limit = Infinity) {
    return (0, $8YbwJ.filter)($00092668d5bc277d$var$Checks["tag_type"](type), nodes, recurse, limit);
}

});

parcelRegister("7fM7F", function(module, exports) {

$parcel$export(module.exports, "removeSubsets", () => $547f434c5042a8f2$export$171dc294232ebeef);
$parcel$export(module.exports, "DocumentPosition", () => $547f434c5042a8f2$export$406a59d989e8005a);
$parcel$export(module.exports, "compareDocumentPosition", () => $547f434c5042a8f2$export$17303b8fea718ecc);
$parcel$export(module.exports, "uniqueSort", () => $547f434c5042a8f2$export$1c267319665a7e7e);
parcelRequire("273yd");
var $k9MHs = parcelRequire("k9MHs");
function $547f434c5042a8f2$export$171dc294232ebeef(nodes) {
    let idx = nodes.length;
    /*
     * Check if each node (or one of its ancestors) is already contained in the
     * array.
     */ while(--idx >= 0){
        const node = nodes[idx];
        /*
         * Remove the node if it is not unique.
         * We are going through the array from the end, so we only
         * have to check nodes that preceed the node under consideration in the array.
         */ if (idx > 0 && nodes.lastIndexOf(node, idx - 1) >= 0) {
            nodes.splice(idx, 1);
            continue;
        }
        for(let ancestor = node.parent; ancestor; ancestor = ancestor.parent)if (nodes.includes(ancestor)) {
            nodes.splice(idx, 1);
            break;
        }
    }
    return nodes;
}
var $547f434c5042a8f2$export$406a59d989e8005a;
(function(DocumentPosition) {
    DocumentPosition[DocumentPosition["DISCONNECTED"] = 1] = "DISCONNECTED";
    DocumentPosition[DocumentPosition["PRECEDING"] = 2] = "PRECEDING";
    DocumentPosition[DocumentPosition["FOLLOWING"] = 4] = "FOLLOWING";
    DocumentPosition[DocumentPosition["CONTAINS"] = 8] = "CONTAINS";
    DocumentPosition[DocumentPosition["CONTAINED_BY"] = 16] = "CONTAINED_BY";
})($547f434c5042a8f2$export$406a59d989e8005a || ($547f434c5042a8f2$export$406a59d989e8005a = {}));
function $547f434c5042a8f2$export$17303b8fea718ecc(nodeA, nodeB) {
    const aParents = [];
    const bParents = [];
    if (nodeA === nodeB) return 0;
    let current = (0, $k9MHs.hasChildren)(nodeA) ? nodeA : nodeA.parent;
    while(current){
        aParents.unshift(current);
        current = current.parent;
    }
    current = (0, $k9MHs.hasChildren)(nodeB) ? nodeB : nodeB.parent;
    while(current){
        bParents.unshift(current);
        current = current.parent;
    }
    const maxIdx = Math.min(aParents.length, bParents.length);
    let idx = 0;
    while(idx < maxIdx && aParents[idx] === bParents[idx])idx++;
    if (idx === 0) return $547f434c5042a8f2$export$406a59d989e8005a.DISCONNECTED;
    const sharedParent = aParents[idx - 1];
    const siblings = sharedParent.children;
    const aSibling = aParents[idx];
    const bSibling = bParents[idx];
    if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
        if (sharedParent === nodeB) return $547f434c5042a8f2$export$406a59d989e8005a.FOLLOWING | $547f434c5042a8f2$export$406a59d989e8005a.CONTAINED_BY;
        return $547f434c5042a8f2$export$406a59d989e8005a.FOLLOWING;
    }
    if (sharedParent === nodeA) return $547f434c5042a8f2$export$406a59d989e8005a.PRECEDING | $547f434c5042a8f2$export$406a59d989e8005a.CONTAINS;
    return $547f434c5042a8f2$export$406a59d989e8005a.PRECEDING;
}
function $547f434c5042a8f2$export$1c267319665a7e7e(nodes) {
    nodes = nodes.filter((node, i, arr)=>!arr.includes(node, i + 1));
    nodes.sort((a, b)=>{
        const relative = $547f434c5042a8f2$export$17303b8fea718ecc(a, b);
        if (relative & $547f434c5042a8f2$export$406a59d989e8005a.PRECEDING) return -1;
        else if (relative & $547f434c5042a8f2$export$406a59d989e8005a.FOLLOWING) return 1;
        return 0;
    });
    return nodes;
}

});

parcelRegister("iG8B0", function(module, exports) {

$parcel$export(module.exports, "getFeed", () => $d992d12f9194bae7$export$ad32138c9e09ad4);

var $dzgAU = parcelRequire("dzgAU");

var $0bNle = parcelRequire("0bNle");
function $d992d12f9194bae7$export$ad32138c9e09ad4(doc) {
    const feedRoot = $d992d12f9194bae7$var$getOneElement($d992d12f9194bae7$var$isValidFeed, doc);
    return !feedRoot ? null : feedRoot.name === "feed" ? $d992d12f9194bae7$var$getAtomFeed(feedRoot) : $d992d12f9194bae7$var$getRssFeed(feedRoot);
}
/**
 * Parse an Atom feed.
 *
 * @param feedRoot The root of the feed.
 * @returns The parsed feed.
 */ function $d992d12f9194bae7$var$getAtomFeed(feedRoot) {
    var _a;
    const childs = feedRoot.children;
    const feed = {
        type: "atom",
        items: (0, $0bNle.getElementsByTagName)("entry", childs).map((item)=>{
            var _a;
            const { children: children } = item;
            const entry = {
                media: $d992d12f9194bae7$var$getMediaElements(children)
            };
            $d992d12f9194bae7$var$addConditionally(entry, "id", "id", children);
            $d992d12f9194bae7$var$addConditionally(entry, "title", "title", children);
            const href = (_a = $d992d12f9194bae7$var$getOneElement("link", children)) === null || _a === void 0 ? void 0 : _a.attribs["href"];
            if (href) entry.link = href;
            const description = $d992d12f9194bae7$var$fetch("summary", children) || $d992d12f9194bae7$var$fetch("content", children);
            if (description) entry.description = description;
            const pubDate = $d992d12f9194bae7$var$fetch("updated", children);
            if (pubDate) entry.pubDate = new Date(pubDate);
            return entry;
        })
    };
    $d992d12f9194bae7$var$addConditionally(feed, "id", "id", childs);
    $d992d12f9194bae7$var$addConditionally(feed, "title", "title", childs);
    const href = (_a = $d992d12f9194bae7$var$getOneElement("link", childs)) === null || _a === void 0 ? void 0 : _a.attribs["href"];
    if (href) feed.link = href;
    $d992d12f9194bae7$var$addConditionally(feed, "description", "subtitle", childs);
    const updated = $d992d12f9194bae7$var$fetch("updated", childs);
    if (updated) feed.updated = new Date(updated);
    $d992d12f9194bae7$var$addConditionally(feed, "author", "email", childs, true);
    return feed;
}
/**
 * Parse a RSS feed.
 *
 * @param feedRoot The root of the feed.
 * @returns The parsed feed.
 */ function $d992d12f9194bae7$var$getRssFeed(feedRoot) {
    var _a, _b;
    const childs = (_b = (_a = $d992d12f9194bae7$var$getOneElement("channel", feedRoot.children)) === null || _a === void 0 ? void 0 : _a.children) !== null && _b !== void 0 ? _b : [];
    const feed = {
        type: feedRoot.name.substr(0, 3),
        id: "",
        items: (0, $0bNle.getElementsByTagName)("item", feedRoot.children).map((item)=>{
            const { children: children } = item;
            const entry = {
                media: $d992d12f9194bae7$var$getMediaElements(children)
            };
            $d992d12f9194bae7$var$addConditionally(entry, "id", "guid", children);
            $d992d12f9194bae7$var$addConditionally(entry, "title", "title", children);
            $d992d12f9194bae7$var$addConditionally(entry, "link", "link", children);
            $d992d12f9194bae7$var$addConditionally(entry, "description", "description", children);
            const pubDate = $d992d12f9194bae7$var$fetch("pubDate", children) || $d992d12f9194bae7$var$fetch("dc:date", children);
            if (pubDate) entry.pubDate = new Date(pubDate);
            return entry;
        })
    };
    $d992d12f9194bae7$var$addConditionally(feed, "title", "title", childs);
    $d992d12f9194bae7$var$addConditionally(feed, "link", "link", childs);
    $d992d12f9194bae7$var$addConditionally(feed, "description", "description", childs);
    const updated = $d992d12f9194bae7$var$fetch("lastBuildDate", childs);
    if (updated) feed.updated = new Date(updated);
    $d992d12f9194bae7$var$addConditionally(feed, "author", "managingEditor", childs, true);
    return feed;
}
const $d992d12f9194bae7$var$MEDIA_KEYS_STRING = [
    "url",
    "type",
    "lang"
];
const $d992d12f9194bae7$var$MEDIA_KEYS_INT = [
    "fileSize",
    "bitrate",
    "framerate",
    "samplingrate",
    "channels",
    "duration",
    "height",
    "width"
];
/**
 * Get all media elements of a feed item.
 *
 * @param where Nodes to search in.
 * @returns Media elements.
 */ function $d992d12f9194bae7$var$getMediaElements(where) {
    return (0, $0bNle.getElementsByTagName)("media:content", where).map((elem)=>{
        const { attribs: attribs } = elem;
        const media = {
            medium: attribs["medium"],
            isDefault: !!attribs["isDefault"]
        };
        for (const attrib of $d992d12f9194bae7$var$MEDIA_KEYS_STRING)if (attribs[attrib]) media[attrib] = attribs[attrib];
        for (const attrib of $d992d12f9194bae7$var$MEDIA_KEYS_INT)if (attribs[attrib]) media[attrib] = parseInt(attribs[attrib], 10);
        if (attribs["expression"]) media.expression = attribs["expression"];
        return media;
    });
}
/**
 * Get one element by tag name.
 *
 * @param tagName Tag name to look for
 * @param node Node to search in
 * @returns The element or null
 */ function $d992d12f9194bae7$var$getOneElement(tagName, node) {
    return (0, $0bNle.getElementsByTagName)(tagName, node, true, 1)[0];
}
/**
 * Get the text content of an element with a certain tag name.
 *
 * @param tagName Tag name to look for.
 * @param where Node to search in.
 * @param recurse Whether to recurse into child nodes.
 * @returns The text content of the element.
 */ function $d992d12f9194bae7$var$fetch(tagName, where, recurse = false) {
    return (0, $dzgAU.textContent)((0, $0bNle.getElementsByTagName)(tagName, where, recurse, 1)).trim();
}
/**
 * Adds a property to an object if it has a value.
 *
 * @param obj Object to be extended
 * @param prop Property name
 * @param tagName Tag name that contains the conditionally added property
 * @param where Element to search for the property
 * @param recurse Whether to recurse into child nodes.
 */ function $d992d12f9194bae7$var$addConditionally(obj, prop, tagName, where, recurse = false) {
    const val = $d992d12f9194bae7$var$fetch(tagName, where, recurse);
    if (val) obj[prop] = val;
}
/**
 * Checks if an element is a feed root node.
 *
 * @param value The name of the element to check.
 * @returns Whether an element is a feed root node.
 */ function $d992d12f9194bae7$var$isValidFeed(value) {
    return value === "rss" || value === "feed" || value === "rdf:RDF";
}

});


parcelRegister("hAHiP", function(module, exports) {

$parcel$export(module.exports, "default", () => $cce7637befe7b06f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "flatten", () => $cce7637befe7b06f$export$bffa455ba8c619a6);
const $cce7637befe7b06f$var$defaultOpts = {
    xml: false,
    decodeEntities: true
};
var /** Cheerio default options. */ $cce7637befe7b06f$export$2e2bcd8739ae039 = $cce7637befe7b06f$var$defaultOpts;
const $cce7637befe7b06f$var$xmlModeDefault = {
    _useHtmlParser2: true,
    xmlMode: true
};
function $cce7637befe7b06f$export$bffa455ba8c619a6(options) {
    return (options === null || options === void 0 ? void 0 : options.xml) ? typeof options.xml === 'boolean' ? $cce7637befe7b06f$var$xmlModeDefault : {
        ...$cce7637befe7b06f$var$xmlModeDefault,
        ...options.xml
    } : options !== null && options !== void 0 ? options : undefined;
}

});


parcelRegister("6CIR4", function(module, exports) {

$parcel$export(module.exports, "attr", () => attr);
$parcel$export(module.exports, "prop", () => prop);
$parcel$export(module.exports, "data", () => data);
$parcel$export(module.exports, "val", () => val);
$parcel$export(module.exports, "removeAttr", () => removeAttr);
$parcel$export(module.exports, "hasClass", () => hasClass);
$parcel$export(module.exports, "addClass", () => addClass);
$parcel$export(module.exports, "removeClass", () => removeClass);
$parcel$export(module.exports, "toggleClass", () => toggleClass);
/**
 * Methods for getting and modifying attributes.
 *
 * @module cheerio/attributes
 */ 
var $8iuUi = parcelRequire("8iuUi");

var $2M1Qk = parcelRequire("2M1Qk");
var $k9MHs = parcelRequire("k9MHs");
parcelRequire("a45mF");
var $dzgAU = parcelRequire("dzgAU");
const hasOwn = Object.prototype.hasOwnProperty;
const rspace = /\s+/;
const dataAttrPrefix = 'data-';
/*
 * Lookup table for coercing string data-* attributes to their corresponding
 * JavaScript primitives
 */ const primitives = {
    null: null,
    true: true,
    false: false
};
// Attributes that are booleans
const rboolean = /^(?:autofocus|autoplay|async|checked|controls|defer|disabled|hidden|loop|multiple|open|readonly|required|scoped|selected)$/i;
// Matches strings that look like JSON objects or arrays
const rbrace = /^{[^]*}$|^\[[^]*]$/;
function getAttr(elem, name, xmlMode) {
    var _a;
    if (!elem || !(0, $k9MHs.isTag)(elem)) return undefined;
    (_a = elem.attribs) !== null && _a !== void 0 ? _a : elem.attribs = {};
    // Return the entire attribs object if no attribute specified
    if (!name) return elem.attribs;
    if (hasOwn.call(elem.attribs, name)) // Get the (decoded) attribute
    return !xmlMode && rboolean.test(name) ? name : elem.attribs[name];
    // Mimic the DOM and return text content as value for `option's`
    if (elem.name === 'option' && name === 'value') return (0, $8iuUi.text)(elem.children);
    // Mimic DOM with default value for radios/checkboxes
    if (elem.name === 'input' && (elem.attribs['type'] === 'radio' || elem.attribs['type'] === 'checkbox') && name === 'value') return 'on';
    return undefined;
}
/**
 * Sets the value of an attribute. The attribute will be deleted if the value is `null`.
 *
 * @private
 * @param el - The element to set the attribute on.
 * @param name - The attribute's name.
 * @param value - The attribute's value.
 */ function setAttr(el, name, value) {
    if (value === null) removeAttribute(el, name);
    else el.attribs[name] = `${value}`;
}
function attr(name, value) {
    // Set the value (with attr map support)
    if (typeof name === 'object' || value !== undefined) {
        if (typeof value === 'function') {
            if (typeof name !== 'string') throw new Error('Bad combination of arguments.');
            return (0, $2M1Qk.domEach)(this, (el, i)=>{
                if ((0, $k9MHs.isTag)(el)) setAttr(el, name, value.call(el, i, el.attribs[name]));
            });
        }
        return (0, $2M1Qk.domEach)(this, (el)=>{
            if (!(0, $k9MHs.isTag)(el)) return;
            if (typeof name === 'object') Object.keys(name).forEach((objName)=>{
                const objValue = name[objName];
                setAttr(el, objName, objValue);
            });
            else setAttr(el, name, value);
        });
    }
    return arguments.length > 1 ? this : getAttr(this[0], name, this.options.xmlMode);
}
/**
 * Gets a node's prop.
 *
 * @private
 * @category Attributes
 * @param el - Element to get the prop of.
 * @param name - Name of the prop.
 * @returns The prop's value.
 */ function getProp(el, name, xmlMode) {
    return name in el ? el[name] : !xmlMode && rboolean.test(name) ? getAttr(el, name, false) !== undefined : getAttr(el, name, xmlMode);
}
/**
 * Sets the value of a prop.
 *
 * @private
 * @param el - The element to set the prop on.
 * @param name - The prop's name.
 * @param value - The prop's value.
 */ function setProp(el, name, value, xmlMode) {
    if (name in el) // @ts-expect-error Overriding value
    el[name] = value;
    else setAttr(el, name, !xmlMode && rboolean.test(name) ? value ? '' : null : `${value}`);
}
function prop(name, value) {
    var _a;
    if (typeof name === 'string' && value === undefined) {
        const el = this[0];
        if (!el || !(0, $k9MHs.isTag)(el)) return undefined;
        switch(name){
            case 'style':
                {
                    const property = this.css();
                    const keys = Object.keys(property);
                    keys.forEach((p, i)=>{
                        property[i] = p;
                    });
                    property.length = keys.length;
                    return property;
                }
            case 'tagName':
            case 'nodeName':
                return el.name.toUpperCase();
            case 'href':
            case 'src':
                {
                    const prop = (_a = el.attribs) === null || _a === void 0 ? void 0 : _a[name];
                    /* eslint-disable node/no-unsupported-features/node-builtins */ if (typeof URL !== 'undefined' && (name === 'href' && (el.tagName === 'a' || el.name === 'link') || name === 'src' && (el.tagName === 'img' || el.tagName === 'iframe' || el.tagName === 'audio' || el.tagName === 'video' || el.tagName === 'source')) && prop !== undefined && this.options.baseURI) return new URL(prop, this.options.baseURI).href;
                    /* eslint-enable node/no-unsupported-features/node-builtins */ return prop;
                }
            case 'innerText':
                return (0, $dzgAU.innerText)(el);
            case 'textContent':
                return (0, $dzgAU.textContent)(el);
            case 'outerHTML':
                return this.clone().wrap('<container />').parent().html();
            case 'innerHTML':
                return this.html();
            default:
                return getProp(el, name, this.options.xmlMode);
        }
    }
    if (typeof name === 'object' || value !== undefined) {
        if (typeof value === 'function') {
            if (typeof name === 'object') throw new Error('Bad combination of arguments.');
            return (0, $2M1Qk.domEach)(this, (el, i)=>{
                if ((0, $k9MHs.isTag)(el)) setProp(el, name, value.call(el, i, getProp(el, name, this.options.xmlMode)), this.options.xmlMode);
            });
        }
        return (0, $2M1Qk.domEach)(this, (el)=>{
            if (!(0, $k9MHs.isTag)(el)) return;
            if (typeof name === 'object') Object.keys(name).forEach((key)=>{
                const val = name[key];
                setProp(el, key, val, this.options.xmlMode);
            });
            else setProp(el, name, value, this.options.xmlMode);
        });
    }
    return undefined;
}
/**
 * Sets the value of a data attribute.
 *
 * @private
 * @param el - The element to set the data attribute on.
 * @param name - The data attribute's name.
 * @param value - The data attribute's value.
 */ function setData(el, name, value) {
    var _a;
    const elem = el;
    (_a = elem.data) !== null && _a !== void 0 ? _a : elem.data = {};
    if (typeof name === 'object') Object.assign(elem.data, name);
    else if (typeof name === 'string' && value !== undefined) elem.data[name] = value;
}
/**
 * Read the specified attribute from the equivalent HTML5 `data-*` attribute,
 * and (if present) cache the value in the node's internal data store. If no
 * attribute name is specified, read _all_ HTML5 `data-*` attributes in this manner.
 *
 * @private
 * @category Attributes
 * @param el - Element to get the data attribute of.
 * @param name - Name of the data attribute.
 * @returns The data attribute's value, or a map with all of the data attributes.
 */ function readData(el, name) {
    let domNames;
    let jsNames;
    let value;
    if (name == null) {
        domNames = Object.keys(el.attribs).filter((attrName)=>attrName.startsWith(dataAttrPrefix));
        jsNames = domNames.map((domName)=>(0, $2M1Qk.camelCase)(domName.slice(dataAttrPrefix.length)));
    } else {
        domNames = [
            dataAttrPrefix + (0, $2M1Qk.cssCase)(name)
        ];
        jsNames = [
            name
        ];
    }
    for(let idx = 0; idx < domNames.length; ++idx){
        const domName = domNames[idx];
        const jsName = jsNames[idx];
        if (hasOwn.call(el.attribs, domName) && !hasOwn.call(el.data, jsName)) {
            value = el.attribs[domName];
            if (hasOwn.call(primitives, value)) value = primitives[value];
            else if (value === String(Number(value))) value = Number(value);
            else if (rbrace.test(value)) try {
                value = JSON.parse(value);
            } catch (e) {
            /* Ignore */ }
            el.data[jsName] = value;
        }
    }
    return name == null ? el.data : value;
}
function data(name, value) {
    var _a;
    const elem = this[0];
    if (!elem || !(0, $k9MHs.isTag)(elem)) return;
    const dataEl = elem;
    (_a = dataEl.data) !== null && _a !== void 0 ? _a : dataEl.data = {};
    // Return the entire data object if no data specified
    if (!name) return readData(dataEl);
    // Set the value (with attr map support)
    if (typeof name === 'object' || value !== undefined) {
        (0, $2M1Qk.domEach)(this, (el)=>{
            if ((0, $k9MHs.isTag)(el)) {
                if (typeof name === 'object') setData(el, name);
                else setData(el, name, value);
            }
        });
        return this;
    }
    if (hasOwn.call(dataEl.data, name)) return dataEl.data[name];
    return readData(dataEl, name);
}
function val(value) {
    const querying = arguments.length === 0;
    const element = this[0];
    if (!element || !(0, $k9MHs.isTag)(element)) return querying ? undefined : this;
    switch(element.name){
        case 'textarea':
            return this.text(value);
        case 'select':
            {
                const option = this.find('option:selected');
                if (!querying) {
                    if (this.attr('multiple') == null && typeof value === 'object') return this;
                    this.find('option').removeAttr('selected');
                    const values = typeof value !== 'object' ? [
                        value
                    ] : value;
                    for(let i = 0; i < values.length; i++)this.find(`option[value="${values[i]}"]`).attr('selected', '');
                    return this;
                }
                return this.attr('multiple') ? option.toArray().map((el)=>(0, $8iuUi.text)(el.children)) : option.attr('value');
            }
        case 'input':
        case 'option':
            return querying ? this.attr('value') : this.attr('value', value);
    }
    return undefined;
}
/**
 * Remove an attribute.
 *
 * @private
 * @param elem - Node to remove attribute from.
 * @param name - Name of the attribute to remove.
 */ function removeAttribute(elem, name) {
    if (!elem.attribs || !hasOwn.call(elem.attribs, name)) return;
    delete elem.attribs[name];
}
/**
 * Splits a space-separated list of names to individual names.
 *
 * @category Attributes
 * @param names - Names to split.
 * @returns - Split names.
 */ function splitNames(names) {
    return names ? names.trim().split(rspace) : [];
}
function removeAttr(name) {
    const attrNames = splitNames(name);
    for(let i = 0; i < attrNames.length; i++)(0, $2M1Qk.domEach)(this, (elem)=>{
        if ((0, $k9MHs.isTag)(elem)) removeAttribute(elem, attrNames[i]);
    });
    return this;
}
function hasClass(className) {
    return this.toArray().some((elem)=>{
        const clazz = (0, $k9MHs.isTag)(elem) && elem.attribs['class'];
        let idx = -1;
        if (clazz && className.length) while((idx = clazz.indexOf(className, idx + 1)) > -1){
            const end = idx + className.length;
            if ((idx === 0 || rspace.test(clazz[idx - 1])) && (end === clazz.length || rspace.test(clazz[end]))) return true;
        }
        return false;
    });
}
function addClass(value) {
    // Support functions
    if (typeof value === 'function') return (0, $2M1Qk.domEach)(this, (el, i)=>{
        if ((0, $k9MHs.isTag)(el)) {
            const className = el.attribs['class'] || '';
            addClass.call([
                el
            ], value.call(el, i, className));
        }
    });
    // Return if no value or not a string or function
    if (!value || typeof value !== 'string') return this;
    const classNames = value.split(rspace);
    const numElements = this.length;
    for(let i = 0; i < numElements; i++){
        const el = this[i];
        // If selected element isn't a tag, move on
        if (!(0, $k9MHs.isTag)(el)) continue;
        // If we don't already have classes — always set xmlMode to false here, as it doesn't matter for classes
        const className = getAttr(el, 'class', false);
        if (!className) setAttr(el, 'class', classNames.join(' ').trim());
        else {
            let setClass = ` ${className} `;
            // Check if class already exists
            for(let j = 0; j < classNames.length; j++){
                const appendClass = `${classNames[j]} `;
                if (!setClass.includes(` ${appendClass}`)) setClass += appendClass;
            }
            setAttr(el, 'class', setClass.trim());
        }
    }
    return this;
}
function removeClass(name) {
    // Handle if value is a function
    if (typeof name === 'function') return (0, $2M1Qk.domEach)(this, (el, i)=>{
        if ((0, $k9MHs.isTag)(el)) removeClass.call([
            el
        ], name.call(el, i, el.attribs['class'] || ''));
    });
    const classes = splitNames(name);
    const numClasses = classes.length;
    const removeAll = arguments.length === 0;
    return (0, $2M1Qk.domEach)(this, (el)=>{
        if (!(0, $k9MHs.isTag)(el)) return;
        if (removeAll) // Short circuit the remove all case as this is the nice one
        el.attribs['class'] = '';
        else {
            const elClasses = splitNames(el.attribs['class']);
            let changed = false;
            for(let j = 0; j < numClasses; j++){
                const index = elClasses.indexOf(classes[j]);
                if (index >= 0) {
                    elClasses.splice(index, 1);
                    changed = true;
                    /*
                     * We have to do another pass to ensure that there are not duplicate
                     * classes listed
                     */ j--;
                }
            }
            if (changed) el.attribs['class'] = elClasses.join(' ');
        }
    });
}
function toggleClass(value, stateVal) {
    // Support functions
    if (typeof value === 'function') return (0, $2M1Qk.domEach)(this, (el, i)=>{
        if ((0, $k9MHs.isTag)(el)) toggleClass.call([
            el
        ], value.call(el, i, el.attribs['class'] || '', stateVal), stateVal);
    });
    // Return if no value or not a string or function
    if (!value || typeof value !== 'string') return this;
    const classNames = value.split(rspace);
    const numClasses = classNames.length;
    const state = typeof stateVal === 'boolean' ? stateVal ? 1 : -1 : 0;
    const numElements = this.length;
    for(let i = 0; i < numElements; i++){
        const el = this[i];
        // If selected element isn't a tag, move on
        if (!(0, $k9MHs.isTag)(el)) continue;
        const elementClasses = splitNames(el.attribs['class']);
        // Check if class already exists
        for(let j = 0; j < numClasses; j++){
            // Check if the class name is currently defined
            const index = elementClasses.indexOf(classNames[j]);
            // Add if stateValue === true or we are toggling and there is no value
            if (state >= 0 && index < 0) elementClasses.push(classNames[j]);
            else if (state <= 0 && index >= 0) // Otherwise remove but only if the item exists
            elementClasses.splice(index, 1);
        }
        el.attribs['class'] = elementClasses.join(' ');
    }
    return this;
}

});
parcelRegister("2M1Qk", function(module, exports) {

$parcel$export(module.exports, "isCheerio", () => $20517e6d93202d4f$export$799a4b197f11d37);
$parcel$export(module.exports, "camelCase", () => $20517e6d93202d4f$export$8a7688a96d852767);
$parcel$export(module.exports, "cssCase", () => $20517e6d93202d4f$export$53d8919ad8038ec0);
$parcel$export(module.exports, "domEach", () => $20517e6d93202d4f$export$74822c5de6e95c1);
$parcel$export(module.exports, "cloneDom", () => $20517e6d93202d4f$export$773334283a3d1a04);
$parcel$export(module.exports, "isHtml", () => $20517e6d93202d4f$export$144ef0648535ac5a);
$parcel$export(module.exports, "isTag", () => (parcelRequire("k9MHs")).isTag);
parcelRequire("273yd");
var $k9MHs = parcelRequire("k9MHs");
function $20517e6d93202d4f$export$799a4b197f11d37(maybeCheerio) {
    return maybeCheerio.cheerio != null;
}
function $20517e6d93202d4f$export$8a7688a96d852767(str) {
    return str.replace(/[_.-](\w|$)/g, (_, x)=>x.toUpperCase());
}
function $20517e6d93202d4f$export$53d8919ad8038ec0(str) {
    return str.replace(/[A-Z]/g, '-$&').toLowerCase();
}
function $20517e6d93202d4f$export$74822c5de6e95c1(array, fn) {
    const len = array.length;
    for(let i = 0; i < len; i++)fn(array[i], i);
    return array;
}
function $20517e6d93202d4f$export$773334283a3d1a04(dom) {
    const clone = 'length' in dom ? Array.prototype.map.call(dom, (el)=>(0, $k9MHs.cloneNode)(el, true)) : [
        (0, $k9MHs.cloneNode)(dom, true)
    ];
    // Add a root node around the cloned nodes
    const root = new (0, $k9MHs.Document)(clone);
    clone.forEach((node)=>{
        node.parent = root;
    });
    return clone;
}
var $20517e6d93202d4f$var$CharacterCodes;
(function(CharacterCodes) {
    CharacterCodes[CharacterCodes["LowerA"] = 97] = "LowerA";
    CharacterCodes[CharacterCodes["LowerZ"] = 122] = "LowerZ";
    CharacterCodes[CharacterCodes["UpperA"] = 65] = "UpperA";
    CharacterCodes[CharacterCodes["UpperZ"] = 90] = "UpperZ";
    CharacterCodes[CharacterCodes["Exclamation"] = 33] = "Exclamation";
})($20517e6d93202d4f$var$CharacterCodes || ($20517e6d93202d4f$var$CharacterCodes = {}));
function $20517e6d93202d4f$export$144ef0648535ac5a(str) {
    const tagStart = str.indexOf('<');
    if (tagStart < 0 || tagStart > str.length - 3) return false;
    const tagChar = str.charCodeAt(tagStart + 1);
    return (tagChar >= $20517e6d93202d4f$var$CharacterCodes.LowerA && tagChar <= $20517e6d93202d4f$var$CharacterCodes.LowerZ || tagChar >= $20517e6d93202d4f$var$CharacterCodes.UpperA && tagChar <= $20517e6d93202d4f$var$CharacterCodes.UpperZ || tagChar === $20517e6d93202d4f$var$CharacterCodes.Exclamation) && str.includes('>', tagStart + 2);
}

});


parcelRegister("hK11S", function(module, exports) {

$parcel$export(module.exports, "find", () => find);
$parcel$export(module.exports, "filterArray", () => filterArray);
$parcel$export(module.exports, "parent", () => parent);
$parcel$export(module.exports, "parents", () => parents);
$parcel$export(module.exports, "parentsUntil", () => parentsUntil);
$parcel$export(module.exports, "closest", () => closest);
$parcel$export(module.exports, "next", () => next);
$parcel$export(module.exports, "nextAll", () => nextAll);
$parcel$export(module.exports, "nextUntil", () => nextUntil);
$parcel$export(module.exports, "prev", () => prev);
$parcel$export(module.exports, "prevAll", () => prevAll);
$parcel$export(module.exports, "prevUntil", () => prevUntil);
$parcel$export(module.exports, "siblings", () => siblings);
$parcel$export(module.exports, "children", () => children);
$parcel$export(module.exports, "contents", () => contents);
$parcel$export(module.exports, "each", () => each);
$parcel$export(module.exports, "map", () => map);
$parcel$export(module.exports, "filter", () => filter);
$parcel$export(module.exports, "is", () => is);
$parcel$export(module.exports, "not", () => not);
$parcel$export(module.exports, "has", () => has);
$parcel$export(module.exports, "first", () => first);
$parcel$export(module.exports, "last", () => last);
$parcel$export(module.exports, "eq", () => eq);
$parcel$export(module.exports, "get", () => get);
$parcel$export(module.exports, "toArray", () => toArray);
$parcel$export(module.exports, "index", () => index);
$parcel$export(module.exports, "slice", () => slice);
$parcel$export(module.exports, "end", () => end);
$parcel$export(module.exports, "add", () => add);
$parcel$export(module.exports, "addBack", () => addBack);
/**
 * Methods for traversing the DOM structure.
 *
 * @module cheerio/traversing
 */ parcelRequire("273yd");
var $k9MHs = parcelRequire("k9MHs");

var $dQzf4 = parcelRequire("dQzf4");

var $2M1Qk = parcelRequire("2M1Qk");
var $k9MHs = parcelRequire("k9MHs");

var $8iuUi = parcelRequire("8iuUi");
parcelRequire("a45mF");
var $8DVmQ = parcelRequire("8DVmQ");
var $7fM7F = parcelRequire("7fM7F");
const reSiblingSelector = /^\s*[~+]/;
function find(selectorOrHaystack) {
    var _a;
    if (!selectorOrHaystack) return this._make([]);
    const context = this.toArray();
    if (typeof selectorOrHaystack !== 'string') {
        const haystack = (0, $2M1Qk.isCheerio)(selectorOrHaystack) ? selectorOrHaystack.toArray() : [
            selectorOrHaystack
        ];
        return this._make(haystack.filter((elem)=>context.some((node)=>(0, $8iuUi.contains)(node, elem))));
    }
    const elems = reSiblingSelector.test(selectorOrHaystack) ? context : this.children().toArray();
    const options = {
        context: context,
        root: (_a = this._root) === null || _a === void 0 ? void 0 : _a[0],
        // Pass options that are recognized by `cheerio-select`
        xmlMode: this.options.xmlMode,
        lowerCaseTags: this.options.lowerCaseTags,
        lowerCaseAttributeNames: this.options.lowerCaseAttributeNames,
        pseudos: this.options.pseudos,
        quirksMode: this.options.quirksMode
    };
    return this._make($dQzf4.select(selectorOrHaystack, elems, options));
}
/**
 * Creates a matcher, using a particular mapping function. Matchers provide a
 * function that finds elements using a generating function, supporting filtering.
 *
 * @private
 * @param matchMap - Mapping function.
 * @returns - Function for wrapping generating functions.
 */ function _getMatcher(matchMap) {
    return function(fn, ...postFns) {
        return function(selector) {
            var _a;
            let matched = matchMap(fn, this);
            if (selector) matched = filterArray(matched, selector, this.options.xmlMode, (_a = this._root) === null || _a === void 0 ? void 0 : _a[0]);
            return this._make(// Post processing is only necessary if there is more than one element.
            this.length > 1 && matched.length > 1 ? postFns.reduce((elems, fn)=>fn(elems), matched) : matched);
        };
    };
}
/** Matcher that adds multiple elements for each entry in the input. */ const _matcher = _getMatcher((fn, elems)=>{
    const ret = [];
    for(let i = 0; i < elems.length; i++){
        const value = fn(elems[i]);
        ret.push(value);
    }
    return new Array().concat(...ret);
});
/** Matcher that adds at most one element for each entry in the input. */ const _singleMatcher = _getMatcher((fn, elems)=>{
    const ret = [];
    for(let i = 0; i < elems.length; i++){
        const value = fn(elems[i]);
        if (value !== null) ret.push(value);
    }
    return ret;
});
/**
 * Matcher that supports traversing until a condition is met.
 *
 * @returns A function usable for `*Until` methods.
 */ function _matchUntil(nextElem, ...postFns) {
    // We use a variable here that is used from within the matcher.
    let matches = null;
    const innerMatcher = _getMatcher((nextElem, elems)=>{
        const matched = [];
        (0, $2M1Qk.domEach)(elems, (elem)=>{
            for(let next; next = nextElem(elem); elem = next){
                // FIXME: `matched` might contain duplicates here and the index is too large.
                if (matches === null || matches === void 0 ? void 0 : matches(next, matched.length)) break;
                matched.push(next);
            }
        });
        return matched;
    })(nextElem, ...postFns);
    return function(selector, filterSelector) {
        // Override `matches` variable with the new target.
        matches = typeof selector === 'string' ? (elem)=>$dQzf4.is(elem, selector, this.options) : selector ? getFilterFn(selector) : null;
        const ret = innerMatcher.call(this, filterSelector);
        // Set `matches` to `null`, so we don't waste memory.
        matches = null;
        return ret;
    };
}
function _removeDuplicates(elems) {
    return Array.from(new Set(elems));
}
const parent = _singleMatcher(({ parent })=>parent && !(0, $k9MHs.isDocument)(parent) ? parent : null, _removeDuplicates);
const parents = _matcher((elem)=>{
    const matched = [];
    while(elem.parent && !(0, $k9MHs.isDocument)(elem.parent)){
        matched.push(elem.parent);
        elem = elem.parent;
    }
    return matched;
}, (0, $7fM7F.uniqueSort), (elems)=>elems.reverse());
const parentsUntil = _matchUntil(({ parent })=>parent && !(0, $k9MHs.isDocument)(parent) ? parent : null, (0, $7fM7F.uniqueSort), (elems)=>elems.reverse());
function closest(selector) {
    var _a;
    const set = [];
    if (!selector) return this._make(set);
    const selectOpts = {
        xmlMode: this.options.xmlMode,
        root: (_a = this._root) === null || _a === void 0 ? void 0 : _a[0]
    };
    const selectFn = typeof selector === 'string' ? (elem)=>$dQzf4.is(elem, selector, selectOpts) : getFilterFn(selector);
    (0, $2M1Qk.domEach)(this, (elem)=>{
        while(elem && (0, $k9MHs.isTag)(elem)){
            if (selectFn(elem, 0)) {
                // Do not add duplicate elements to the set
                if (!set.includes(elem)) set.push(elem);
                break;
            }
            elem = elem.parent;
        }
    });
    return this._make(set);
}
const next = _singleMatcher((elem)=>(0, $8DVmQ.nextElementSibling)(elem));
const nextAll = _matcher((elem)=>{
    const matched = [];
    while(elem.next){
        elem = elem.next;
        if ((0, $k9MHs.isTag)(elem)) matched.push(elem);
    }
    return matched;
}, _removeDuplicates);
const nextUntil = _matchUntil((el)=>(0, $8DVmQ.nextElementSibling)(el), _removeDuplicates);
const prev = _singleMatcher((elem)=>(0, $8DVmQ.prevElementSibling)(elem));
const prevAll = _matcher((elem)=>{
    const matched = [];
    while(elem.prev){
        elem = elem.prev;
        if ((0, $k9MHs.isTag)(elem)) matched.push(elem);
    }
    return matched;
}, _removeDuplicates);
const prevUntil = _matchUntil((el)=>(0, $8DVmQ.prevElementSibling)(el), _removeDuplicates);
const siblings = _matcher((elem)=>(0, $8DVmQ.getSiblings)(elem).filter((el)=>(0, $k9MHs.isTag)(el) && el !== elem), (0, $7fM7F.uniqueSort));
const children = _matcher((elem)=>(0, $8DVmQ.getChildren)(elem).filter((0, $k9MHs.isTag)), _removeDuplicates);
function contents() {
    const elems = this.toArray().reduce((newElems, elem)=>(0, $k9MHs.hasChildren)(elem) ? newElems.concat(elem.children) : newElems, []);
    return this._make(elems);
}
function each(fn) {
    let i = 0;
    const len = this.length;
    while(i < len && fn.call(this[i], i, this[i]) !== false)++i;
    return this;
}
function map(fn) {
    let elems = [];
    for(let i = 0; i < this.length; i++){
        const el = this[i];
        const val = fn.call(el, i, el);
        if (val != null) elems = elems.concat(val);
    }
    return this._make(elems);
}
/**
 * Creates a function to test if a filter is matched.
 *
 * @param match - A filter.
 * @returns A function that determines if a filter has been matched.
 */ function getFilterFn(match) {
    if (typeof match === 'function') return (el, i)=>match.call(el, i, el);
    if ((0, $2M1Qk.isCheerio)(match)) return (el)=>Array.prototype.includes.call(match, el);
    return function(el) {
        return match === el;
    };
}
function filter(match) {
    var _a;
    return this._make(filterArray(this.toArray(), match, this.options.xmlMode, (_a = this._root) === null || _a === void 0 ? void 0 : _a[0]));
}
function filterArray(nodes, match, xmlMode, root) {
    return typeof match === 'string' ? $dQzf4.filter(match, nodes, {
        xmlMode: xmlMode,
        root: root
    }) : nodes.filter(getFilterFn(match));
}
function is(selector) {
    const nodes = this.toArray();
    return typeof selector === 'string' ? $dQzf4.some(nodes.filter((0, $k9MHs.isTag)), selector, this.options) : selector ? nodes.some(getFilterFn(selector)) : false;
}
function not(match) {
    let nodes = this.toArray();
    if (typeof match === 'string') {
        const matches = new Set($dQzf4.filter(match, nodes, this.options));
        nodes = nodes.filter((el)=>!matches.has(el));
    } else {
        const filterFn = getFilterFn(match);
        nodes = nodes.filter((el, i)=>!filterFn(el, i));
    }
    return this._make(nodes);
}
function has(selectorOrHaystack) {
    return this.filter(typeof selectorOrHaystack === 'string' ? `:has(${selectorOrHaystack})` : (_, el)=>this._make(el).find(selectorOrHaystack).length > 0);
}
function first() {
    return this.length > 1 ? this._make(this[0]) : this;
}
function last() {
    return this.length > 0 ? this._make(this[this.length - 1]) : this;
}
function eq(i) {
    var _a;
    i = +i;
    // Use the first identity optimization if possible
    if (i === 0 && this.length <= 1) return this;
    if (i < 0) i = this.length + i;
    return this._make((_a = this[i]) !== null && _a !== void 0 ? _a : []);
}
function get(i) {
    if (i == null) return this.toArray();
    return this[i < 0 ? this.length + i : i];
}
function toArray() {
    return Array.prototype.slice.call(this);
}
function index(selectorOrNeedle) {
    let $haystack;
    let needle;
    if (selectorOrNeedle == null) {
        $haystack = this.parent().children();
        needle = this[0];
    } else if (typeof selectorOrNeedle === 'string') {
        $haystack = this._make(selectorOrNeedle);
        needle = this[0];
    } else {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        $haystack = this;
        needle = (0, $2M1Qk.isCheerio)(selectorOrNeedle) ? selectorOrNeedle[0] : selectorOrNeedle;
    }
    return Array.prototype.indexOf.call($haystack, needle);
}
function slice(start, end) {
    return this._make(Array.prototype.slice.call(this, start, end));
}
function end() {
    var _a;
    return (_a = this.prevObject) !== null && _a !== void 0 ? _a : this._make([]);
}
function add(other, context) {
    const selection = this._make(other, context);
    const contents = (0, $7fM7F.uniqueSort)([
        ...this.get(),
        ...selection.get()
    ]);
    return this._make(contents);
}
function addBack(selector) {
    return this.prevObject ? this.add(selector ? this.prevObject.filter(selector) : this.prevObject) : this;
}

});
parcelRegister("dQzf4", function(module, exports) {

$parcel$export(module.exports, "is", () => $a14b780d972c97fa$export$226b3eccf92c9ed9);
$parcel$export(module.exports, "some", () => $a14b780d972c97fa$export$ad14ef4001db2bcd);
$parcel$export(module.exports, "filter", () => $a14b780d972c97fa$export$3dea766d36a8935f);
$parcel$export(module.exports, "select", () => $a14b780d972c97fa$export$2e6c959c16ff56b8);

var $2yXYm = parcelRequire("2yXYm");
var $7GxKW = parcelRequire("7GxKW");

var $6r12e = parcelRequire("6r12e");

var $a45mF = parcelRequire("a45mF");

var $guB19 = parcelRequire("guB19");

var $jML7X = parcelRequire("jML7X");

var $hbA8b = parcelRequire("hbA8b");
const $a14b780d972c97fa$var$UNIVERSAL_SELECTOR = {
    type: (0, $7GxKW.SelectorType).Universal,
    namespace: null
};
const $a14b780d972c97fa$var$SCOPE_PSEUDO = {
    type: (0, $7GxKW.SelectorType).Pseudo,
    name: "scope",
    data: null
};
function $a14b780d972c97fa$export$226b3eccf92c9ed9(element, selector, options = {}) {
    return $a14b780d972c97fa$export$ad14ef4001db2bcd([
        element
    ], selector, options);
}
function $a14b780d972c97fa$export$ad14ef4001db2bcd(elements, selector, options = {}) {
    if (typeof selector === "function") return elements.some(selector);
    const [plain, filtered] = (0, $jML7X.groupSelectors)((0, $2yXYm.parse)(selector));
    return plain.length > 0 && elements.some((0, $6r12e._compileToken)(plain, options)) || filtered.some((sel)=>$a14b780d972c97fa$var$filterBySelector(sel, elements, options).length > 0);
}
function $a14b780d972c97fa$var$filterByPosition(filter, elems, data, options) {
    const num = typeof data === "string" ? parseInt(data, 10) : NaN;
    switch(filter){
        case "first":
        case "lt":
            // Already done in `getLimit`
            return elems;
        case "last":
            return elems.length > 0 ? [
                elems[elems.length - 1]
            ] : elems;
        case "nth":
        case "eq":
            return isFinite(num) && Math.abs(num) < elems.length ? [
                num < 0 ? elems[elems.length + num] : elems[num]
            ] : [];
        case "gt":
            return isFinite(num) ? elems.slice(num + 1) : [];
        case "even":
            return elems.filter((_, i)=>i % 2 === 0);
        case "odd":
            return elems.filter((_, i)=>i % 2 === 1);
        case "not":
            {
                const filtered = new Set($a14b780d972c97fa$var$filterParsed(data, elems, options));
                return elems.filter((e)=>!filtered.has(e));
            }
    }
}
function $a14b780d972c97fa$export$3dea766d36a8935f(selector, elements, options = {}) {
    return $a14b780d972c97fa$var$filterParsed((0, $2yXYm.parse)(selector), elements, options);
}
/**
 * Filter a set of elements by a selector.
 *
 * Will return elements in the original order.
 *
 * @param selector Selector to filter by.
 * @param elements Elements to filter.
 * @param options Options for selector.
 */ function $a14b780d972c97fa$var$filterParsed(selector, elements, options) {
    if (elements.length === 0) return [];
    const [plainSelectors, filteredSelectors] = (0, $jML7X.groupSelectors)(selector);
    let found;
    if (plainSelectors.length) {
        const filtered = $a14b780d972c97fa$var$filterElements(elements, plainSelectors, options);
        // If there are no filters, just return
        if (filteredSelectors.length === 0) return filtered;
        // Otherwise, we have to do some filtering
        if (filtered.length) found = new Set(filtered);
    }
    for(let i = 0; i < filteredSelectors.length && (found === null || found === void 0 ? void 0 : found.size) !== elements.length; i++){
        const filteredSelector = filteredSelectors[i];
        const missing = found ? elements.filter((e)=>$a45mF.isTag(e) && !found.has(e)) : elements;
        if (missing.length === 0) break;
        const filtered = $a14b780d972c97fa$var$filterBySelector(filteredSelector, elements, options);
        if (filtered.length) {
            if (!found) {
                /*
                 * If we haven't found anything before the last selector,
                 * just return what we found now.
                 */ if (i === filteredSelectors.length - 1) return filtered;
                found = new Set(filtered);
            } else filtered.forEach((el)=>found.add(el));
        }
    }
    return typeof found !== "undefined" ? found.size === elements.length ? elements : elements.filter((el)=>found.has(el)) : [];
}
function $a14b780d972c97fa$var$filterBySelector(selector, elements, options) {
    var _a;
    if (selector.some((0, $2yXYm.isTraversal))) {
        /*
         * Get root node, run selector with the scope
         * set to all of our nodes.
         */ const root = (_a = options.root) !== null && _a !== void 0 ? _a : (0, $jML7X.getDocumentRoot)(elements[0]);
        const opts = {
            ...options,
            context: elements,
            relativeSelector: false
        };
        selector.push($a14b780d972c97fa$var$SCOPE_PSEUDO);
        return $a14b780d972c97fa$var$findFilterElements(root, selector, opts, true, elements.length);
    }
    // Performance optimization: If we don't have to traverse, just filter set.
    return $a14b780d972c97fa$var$findFilterElements(elements, selector, options, false, elements.length);
}
function $a14b780d972c97fa$export$2e6c959c16ff56b8(selector, root, options = {}, limit = Infinity) {
    if (typeof selector === "function") return $a14b780d972c97fa$var$find(root, selector);
    const [plain, filtered] = (0, $jML7X.groupSelectors)((0, $2yXYm.parse)(selector));
    const results = filtered.map((sel)=>$a14b780d972c97fa$var$findFilterElements(root, sel, options, true, limit));
    // Plain selectors can be queried in a single go
    if (plain.length) results.push($a14b780d972c97fa$var$findElements(root, plain, options, limit));
    if (results.length === 0) return [];
    // If there was only a single selector, just return the result
    if (results.length === 1) return results[0];
    // Sort results, filtering for duplicates
    return $a45mF.uniqueSort(results.reduce((a, b)=>[
            ...a,
            ...b
        ]));
}
/**
 *
 * @param root Element(s) to search from.
 * @param selector Selector to look for.
 * @param options Options for querying.
 * @param queryForSelector Query multiple levels deep for the initial selector, even if it doesn't contain a traversal.
 */ function $a14b780d972c97fa$var$findFilterElements(root, selector, options, queryForSelector, totalLimit) {
    const filterIndex = selector.findIndex((0, $hbA8b.isFilter));
    const sub = selector.slice(0, filterIndex);
    const filter = selector[filterIndex];
    // If we are at the end of the selector, we can limit the number of elements to retrieve.
    const partLimit = selector.length - 1 === filterIndex ? totalLimit : Infinity;
    /*
     * Set the number of elements to retrieve.
     * Eg. for :first, we only have to get a single element.
     */ const limit = (0, $hbA8b.getLimit)(filter.name, filter.data, partLimit);
    if (limit === 0) return [];
    /*
     * Skip `findElements` call if our selector starts with a positional
     * pseudo.
     */ const elemsNoLimit = sub.length === 0 && !Array.isArray(root) ? $a45mF.getChildren(root).filter($a45mF.isTag) : sub.length === 0 ? (Array.isArray(root) ? root : [
        root
    ]).filter($a45mF.isTag) : queryForSelector || sub.some((0, $2yXYm.isTraversal)) ? $a14b780d972c97fa$var$findElements(root, [
        sub
    ], options, limit) : $a14b780d972c97fa$var$filterElements(root, [
        sub
    ], options);
    const elems = elemsNoLimit.slice(0, limit);
    let result = $a14b780d972c97fa$var$filterByPosition(filter.name, elems, filter.data, options);
    if (result.length === 0 || selector.length === filterIndex + 1) return result;
    const remainingSelector = selector.slice(filterIndex + 1);
    const remainingHasTraversal = remainingSelector.some((0, $2yXYm.isTraversal));
    if (remainingHasTraversal) {
        if ((0, $2yXYm.isTraversal)(remainingSelector[0])) {
            const { type: type } = remainingSelector[0];
            if (type === (0, $7GxKW.SelectorType).Sibling || type === (0, $7GxKW.SelectorType).Adjacent) // If we have a sibling traversal, we need to also look at the siblings.
            result = (0, $6r12e.prepareContext)(result, $a45mF, true);
            // Avoid a traversal-first selector error.
            remainingSelector.unshift($a14b780d972c97fa$var$UNIVERSAL_SELECTOR);
        }
        options = {
            ...options,
            // Avoid absolutizing the selector
            relativeSelector: false,
            /*
             * Add a custom root func, to make sure traversals don't match elements
             * that aren't a part of the considered tree.
             */ rootFunc: (el)=>result.includes(el)
        };
    } else if (options.rootFunc && options.rootFunc !== $guB19.trueFunc) options = {
        ...options,
        rootFunc: $guB19.trueFunc
    };
    /*
     * If we have another filter, recursively call `findFilterElements`,
     * with the `recursive` flag disabled. We only have to look for more
     * elements when we see a traversal.
     *
     * Otherwise,
     */ return remainingSelector.some((0, $hbA8b.isFilter)) ? $a14b780d972c97fa$var$findFilterElements(result, remainingSelector, options, false, totalLimit) : remainingHasTraversal ? $a14b780d972c97fa$var$findElements(result, [
        remainingSelector
    ], options, totalLimit) : $a14b780d972c97fa$var$filterElements(result, [
        remainingSelector
    ], options);
}
function $a14b780d972c97fa$var$findElements(root, sel, options, limit) {
    const query = (0, $6r12e._compileToken)(sel, options, root);
    return $a14b780d972c97fa$var$find(root, query, limit);
}
function $a14b780d972c97fa$var$find(root, query, limit = Infinity) {
    const elems = (0, $6r12e.prepareContext)(root, $a45mF, query.shouldTestNextSiblings);
    return $a45mF.find((node)=>$a45mF.isTag(node) && query(node), elems, true, limit);
}
function $a14b780d972c97fa$var$filterElements(elements, sel, options) {
    const els = (Array.isArray(elements) ? elements : [
        elements
    ]).filter($a45mF.isTag);
    if (els.length === 0) return els;
    const query = (0, $6r12e._compileToken)(sel, options);
    return query === $guB19.trueFunc ? els : els.filter(query);
}

});
parcelRegister("2yXYm", function(module, exports) {

$parcel$export(module.exports, "isTraversal", () => $1ddd47070907251b$export$41d1fe2780697dca);
$parcel$export(module.exports, "parse", () => $1ddd47070907251b$export$98e6a39c04603d36);

var $7GxKW = parcelRequire("7GxKW");
const $1ddd47070907251b$var$reName = /^[^\\#]?(?:\\(?:[\da-f]{1,6}\s?|.)|[\w\-\u00b0-\uFFFF])+/;
const $1ddd47070907251b$var$reEscape = /\\([\da-f]{1,6}\s?|(\s)|.)/gi;
const $1ddd47070907251b$var$actionTypes = new Map([
    [
        126 /* Tilde */ ,
        (0, $7GxKW.AttributeAction).Element
    ],
    [
        94 /* Circumflex */ ,
        (0, $7GxKW.AttributeAction).Start
    ],
    [
        36 /* Dollar */ ,
        (0, $7GxKW.AttributeAction).End
    ],
    [
        42 /* Asterisk */ ,
        (0, $7GxKW.AttributeAction).Any
    ],
    [
        33 /* ExclamationMark */ ,
        (0, $7GxKW.AttributeAction).Not
    ],
    [
        124 /* Pipe */ ,
        (0, $7GxKW.AttributeAction).Hyphen
    ]
]);
// Pseudos, whose data property is parsed as well.
const $1ddd47070907251b$var$unpackPseudos = new Set([
    "has",
    "not",
    "matches",
    "is",
    "where",
    "host",
    "host-context"
]);
function $1ddd47070907251b$export$41d1fe2780697dca(selector) {
    switch(selector.type){
        case (0, $7GxKW.SelectorType).Adjacent:
        case (0, $7GxKW.SelectorType).Child:
        case (0, $7GxKW.SelectorType).Descendant:
        case (0, $7GxKW.SelectorType).Parent:
        case (0, $7GxKW.SelectorType).Sibling:
        case (0, $7GxKW.SelectorType).ColumnCombinator:
            return true;
        default:
            return false;
    }
}
const $1ddd47070907251b$var$stripQuotesFromPseudos = new Set([
    "contains",
    "icontains"
]);
// Unescape function taken from https://github.com/jquery/sizzle/blob/master/src/sizzle.js#L152
function $1ddd47070907251b$var$funescape(_, escaped, escapedWhitespace) {
    const high = parseInt(escaped, 16) - 0x10000;
    // NaN means non-codepoint
    return high !== high || escapedWhitespace ? escaped : high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xd800, high & 0x3ff | 0xdc00);
}
function $1ddd47070907251b$var$unescapeCSS(str) {
    return str.replace($1ddd47070907251b$var$reEscape, $1ddd47070907251b$var$funescape);
}
function $1ddd47070907251b$var$isQuote(c) {
    return c === 39 /* SingleQuote */  || c === 34 /* DoubleQuote */ ;
}
function $1ddd47070907251b$var$isWhitespace(c) {
    return c === 32 /* Space */  || c === 9 /* Tab */  || c === 10 /* NewLine */  || c === 12 /* FormFeed */  || c === 13 /* CarriageReturn */ ;
}
function $1ddd47070907251b$export$98e6a39c04603d36(selector) {
    const subselects = [];
    const endIndex = $1ddd47070907251b$var$parseSelector(subselects, `${selector}`, 0);
    if (endIndex < selector.length) throw new Error(`Unmatched selector: ${selector.slice(endIndex)}`);
    return subselects;
}
function $1ddd47070907251b$var$parseSelector(subselects, selector, selectorIndex) {
    let tokens = [];
    function getName(offset) {
        const match = selector.slice(selectorIndex + offset).match($1ddd47070907251b$var$reName);
        if (!match) throw new Error(`Expected name, found ${selector.slice(selectorIndex)}`);
        const [name] = match;
        selectorIndex += offset + name.length;
        return $1ddd47070907251b$var$unescapeCSS(name);
    }
    function stripWhitespace(offset) {
        selectorIndex += offset;
        while(selectorIndex < selector.length && $1ddd47070907251b$var$isWhitespace(selector.charCodeAt(selectorIndex)))selectorIndex++;
    }
    function readValueWithParenthesis() {
        selectorIndex += 1;
        const start = selectorIndex;
        let counter = 1;
        for(; counter > 0 && selectorIndex < selector.length; selectorIndex++){
            if (selector.charCodeAt(selectorIndex) === 40 /* LeftParenthesis */  && !isEscaped(selectorIndex)) counter++;
            else if (selector.charCodeAt(selectorIndex) === 41 /* RightParenthesis */  && !isEscaped(selectorIndex)) counter--;
        }
        if (counter) throw new Error("Parenthesis not matched");
        return $1ddd47070907251b$var$unescapeCSS(selector.slice(start, selectorIndex - 1));
    }
    function isEscaped(pos) {
        let slashCount = 0;
        while(selector.charCodeAt(--pos) === 92 /* BackSlash */ )slashCount++;
        return (slashCount & 1) === 1;
    }
    function ensureNotTraversal() {
        if (tokens.length > 0 && $1ddd47070907251b$export$41d1fe2780697dca(tokens[tokens.length - 1])) throw new Error("Did not expect successive traversals.");
    }
    function addTraversal(type) {
        if (tokens.length > 0 && tokens[tokens.length - 1].type === (0, $7GxKW.SelectorType).Descendant) {
            tokens[tokens.length - 1].type = type;
            return;
        }
        ensureNotTraversal();
        tokens.push({
            type: type
        });
    }
    function addSpecialAttribute(name, action) {
        tokens.push({
            type: (0, $7GxKW.SelectorType).Attribute,
            name: name,
            action: action,
            value: getName(1),
            namespace: null,
            ignoreCase: "quirks"
        });
    }
    /**
     * We have finished parsing the current part of the selector.
     *
     * Remove descendant tokens at the end if they exist,
     * and return the last index, so that parsing can be
     * picked up from here.
     */ function finalizeSubselector() {
        if (tokens.length && tokens[tokens.length - 1].type === (0, $7GxKW.SelectorType).Descendant) tokens.pop();
        if (tokens.length === 0) throw new Error("Empty sub-selector");
        subselects.push(tokens);
    }
    stripWhitespace(0);
    if (selector.length === selectorIndex) return selectorIndex;
    loop: while(selectorIndex < selector.length){
        const firstChar = selector.charCodeAt(selectorIndex);
        switch(firstChar){
            // Whitespace
            case 32 /* Space */ :
            case 9 /* Tab */ :
            case 10 /* NewLine */ :
            case 12 /* FormFeed */ :
            case 13 /* CarriageReturn */ :
                if (tokens.length === 0 || tokens[0].type !== (0, $7GxKW.SelectorType).Descendant) {
                    ensureNotTraversal();
                    tokens.push({
                        type: (0, $7GxKW.SelectorType).Descendant
                    });
                }
                stripWhitespace(1);
                break;
            // Traversals
            case 62 /* GreaterThan */ :
                addTraversal((0, $7GxKW.SelectorType).Child);
                stripWhitespace(1);
                break;
            case 60 /* LessThan */ :
                addTraversal((0, $7GxKW.SelectorType).Parent);
                stripWhitespace(1);
                break;
            case 126 /* Tilde */ :
                addTraversal((0, $7GxKW.SelectorType).Sibling);
                stripWhitespace(1);
                break;
            case 43 /* Plus */ :
                addTraversal((0, $7GxKW.SelectorType).Adjacent);
                stripWhitespace(1);
                break;
            // Special attribute selectors: .class, #id
            case 46 /* Period */ :
                addSpecialAttribute("class", (0, $7GxKW.AttributeAction).Element);
                break;
            case 35 /* Hash */ :
                addSpecialAttribute("id", (0, $7GxKW.AttributeAction).Equals);
                break;
            case 91 /* LeftSquareBracket */ :
                {
                    stripWhitespace(1);
                    // Determine attribute name and namespace
                    let name;
                    let namespace = null;
                    if (selector.charCodeAt(selectorIndex) === 124 /* Pipe */ ) // Equivalent to no namespace
                    name = getName(1);
                    else if (selector.startsWith("*|", selectorIndex)) {
                        namespace = "*";
                        name = getName(2);
                    } else {
                        name = getName(0);
                        if (selector.charCodeAt(selectorIndex) === 124 /* Pipe */  && selector.charCodeAt(selectorIndex + 1) !== 61 /* Equal */ ) {
                            namespace = name;
                            name = getName(1);
                        }
                    }
                    stripWhitespace(0);
                    // Determine comparison operation
                    let action = (0, $7GxKW.AttributeAction).Exists;
                    const possibleAction = $1ddd47070907251b$var$actionTypes.get(selector.charCodeAt(selectorIndex));
                    if (possibleAction) {
                        action = possibleAction;
                        if (selector.charCodeAt(selectorIndex + 1) !== 61 /* Equal */ ) throw new Error("Expected `=`");
                        stripWhitespace(2);
                    } else if (selector.charCodeAt(selectorIndex) === 61 /* Equal */ ) {
                        action = (0, $7GxKW.AttributeAction).Equals;
                        stripWhitespace(1);
                    }
                    // Determine value
                    let value = "";
                    let ignoreCase = null;
                    if (action !== "exists") {
                        if ($1ddd47070907251b$var$isQuote(selector.charCodeAt(selectorIndex))) {
                            const quote = selector.charCodeAt(selectorIndex);
                            let sectionEnd = selectorIndex + 1;
                            while(sectionEnd < selector.length && (selector.charCodeAt(sectionEnd) !== quote || isEscaped(sectionEnd)))sectionEnd += 1;
                            if (selector.charCodeAt(sectionEnd) !== quote) throw new Error("Attribute value didn't end");
                            value = $1ddd47070907251b$var$unescapeCSS(selector.slice(selectorIndex + 1, sectionEnd));
                            selectorIndex = sectionEnd + 1;
                        } else {
                            const valueStart = selectorIndex;
                            while(selectorIndex < selector.length && (!$1ddd47070907251b$var$isWhitespace(selector.charCodeAt(selectorIndex)) && selector.charCodeAt(selectorIndex) !== 93 /* RightSquareBracket */  || isEscaped(selectorIndex)))selectorIndex += 1;
                            value = $1ddd47070907251b$var$unescapeCSS(selector.slice(valueStart, selectorIndex));
                        }
                        stripWhitespace(0);
                        // See if we have a force ignore flag
                        const forceIgnore = selector.charCodeAt(selectorIndex) | 0x20;
                        // If the forceIgnore flag is set (either `i` or `s`), use that value
                        if (forceIgnore === 115 /* LowerS */ ) {
                            ignoreCase = false;
                            stripWhitespace(1);
                        } else if (forceIgnore === 105 /* LowerI */ ) {
                            ignoreCase = true;
                            stripWhitespace(1);
                        }
                    }
                    if (selector.charCodeAt(selectorIndex) !== 93 /* RightSquareBracket */ ) throw new Error("Attribute selector didn't terminate");
                    selectorIndex += 1;
                    const attributeSelector = {
                        type: (0, $7GxKW.SelectorType).Attribute,
                        name: name,
                        action: action,
                        value: value,
                        namespace: namespace,
                        ignoreCase: ignoreCase
                    };
                    tokens.push(attributeSelector);
                    break;
                }
            case 58 /* Colon */ :
                {
                    if (selector.charCodeAt(selectorIndex + 1) === 58 /* Colon */ ) {
                        tokens.push({
                            type: (0, $7GxKW.SelectorType).PseudoElement,
                            name: getName(2).toLowerCase(),
                            data: selector.charCodeAt(selectorIndex) === 40 /* LeftParenthesis */  ? readValueWithParenthesis() : null
                        });
                        continue;
                    }
                    const name = getName(1).toLowerCase();
                    let data = null;
                    if (selector.charCodeAt(selectorIndex) === 40 /* LeftParenthesis */ ) {
                        if ($1ddd47070907251b$var$unpackPseudos.has(name)) {
                            if ($1ddd47070907251b$var$isQuote(selector.charCodeAt(selectorIndex + 1))) throw new Error(`Pseudo-selector ${name} cannot be quoted`);
                            data = [];
                            selectorIndex = $1ddd47070907251b$var$parseSelector(data, selector, selectorIndex + 1);
                            if (selector.charCodeAt(selectorIndex) !== 41 /* RightParenthesis */ ) throw new Error(`Missing closing parenthesis in :${name} (${selector})`);
                            selectorIndex += 1;
                        } else {
                            data = readValueWithParenthesis();
                            if ($1ddd47070907251b$var$stripQuotesFromPseudos.has(name)) {
                                const quot = data.charCodeAt(0);
                                if (quot === data.charCodeAt(data.length - 1) && $1ddd47070907251b$var$isQuote(quot)) data = data.slice(1, -1);
                            }
                            data = $1ddd47070907251b$var$unescapeCSS(data);
                        }
                    }
                    tokens.push({
                        type: (0, $7GxKW.SelectorType).Pseudo,
                        name: name,
                        data: data
                    });
                    break;
                }
            case 44 /* Comma */ :
                finalizeSubselector();
                tokens = [];
                stripWhitespace(1);
                break;
            default:
                {
                    if (selector.startsWith("/*", selectorIndex)) {
                        const endIndex = selector.indexOf("*/", selectorIndex + 2);
                        if (endIndex < 0) throw new Error("Comment was not terminated");
                        selectorIndex = endIndex + 2;
                        // Remove leading whitespace
                        if (tokens.length === 0) stripWhitespace(0);
                        break;
                    }
                    let namespace = null;
                    let name;
                    if (firstChar === 42 /* Asterisk */ ) {
                        selectorIndex += 1;
                        name = "*";
                    } else if (firstChar === 124 /* Pipe */ ) {
                        name = "";
                        if (selector.charCodeAt(selectorIndex + 1) === 124 /* Pipe */ ) {
                            addTraversal((0, $7GxKW.SelectorType).ColumnCombinator);
                            stripWhitespace(2);
                            break;
                        }
                    } else if ($1ddd47070907251b$var$reName.test(selector.slice(selectorIndex))) name = getName(0);
                    else break loop;
                    if (selector.charCodeAt(selectorIndex) === 124 /* Pipe */  && selector.charCodeAt(selectorIndex + 1) !== 124 /* Pipe */ ) {
                        namespace = name;
                        if (selector.charCodeAt(selectorIndex + 1) === 42 /* Asterisk */ ) {
                            name = "*";
                            selectorIndex += 2;
                        } else name = getName(1);
                    }
                    tokens.push(name === "*" ? {
                        type: (0, $7GxKW.SelectorType).Universal,
                        namespace: namespace
                    } : {
                        type: (0, $7GxKW.SelectorType).Tag,
                        name: name,
                        namespace: namespace
                    });
                }
        }
    }
    finalizeSubselector();
    return selectorIndex;
}

});
parcelRegister("7GxKW", function(module, exports) {

$parcel$export(module.exports, "SelectorType", () => $5986a3e48f9d9ddf$export$4e8b093ec8dcab0d);
$parcel$export(module.exports, "AttributeAction", () => $5986a3e48f9d9ddf$export$dbc3de62b8fcdc89);
var $5986a3e48f9d9ddf$export$4e8b093ec8dcab0d;
(function(SelectorType) {
    SelectorType["Attribute"] = "attribute";
    SelectorType["Pseudo"] = "pseudo";
    SelectorType["PseudoElement"] = "pseudo-element";
    SelectorType["Tag"] = "tag";
    SelectorType["Universal"] = "universal";
    // Traversals
    SelectorType["Adjacent"] = "adjacent";
    SelectorType["Child"] = "child";
    SelectorType["Descendant"] = "descendant";
    SelectorType["Parent"] = "parent";
    SelectorType["Sibling"] = "sibling";
    SelectorType["ColumnCombinator"] = "column-combinator";
})($5986a3e48f9d9ddf$export$4e8b093ec8dcab0d || ($5986a3e48f9d9ddf$export$4e8b093ec8dcab0d = {}));
const $5986a3e48f9d9ddf$export$b378b9ead145a8a4 = {
    Unknown: null,
    QuirksMode: "quirks",
    IgnoreCase: true,
    CaseSensitive: false
};
var $5986a3e48f9d9ddf$export$dbc3de62b8fcdc89;
(function(AttributeAction) {
    AttributeAction["Any"] = "any";
    AttributeAction["Element"] = "element";
    AttributeAction["End"] = "end";
    AttributeAction["Equals"] = "equals";
    AttributeAction["Exists"] = "exists";
    AttributeAction["Hyphen"] = "hyphen";
    AttributeAction["Not"] = "not";
    AttributeAction["Start"] = "start";
})($5986a3e48f9d9ddf$export$dbc3de62b8fcdc89 || ($5986a3e48f9d9ddf$export$dbc3de62b8fcdc89 = {}));

});


parcelRegister("6r12e", function(module, exports) {

$parcel$export(module.exports, "_compileToken", () => $4af61137df229ea3$export$3ed2edee2e7c5e35);
$parcel$export(module.exports, "prepareContext", () => $4af61137df229ea3$export$9c634076e0a91d1f);

var $a45mF = parcelRequire("a45mF");

var $guB19 = parcelRequire("guB19");

var $fMij3 = parcelRequire("fMij3");

var $2r79j = parcelRequire("2r79j");
parcelRequire("lIEEt");
var $kle0t = parcelRequire("kle0t");
var $bkiPz = parcelRequire("bkiPz");
var $bfEYC = parcelRequire("bfEYC");
const $4af61137df229ea3$var$defaultEquals = (a, b)=>a === b;
const $4af61137df229ea3$var$defaultOptions = {
    adapter: $a45mF,
    equals: $4af61137df229ea3$var$defaultEquals
};
function $4af61137df229ea3$var$convertOptionFormats(options) {
    var _a, _b, _c, _d;
    /*
     * We force one format of options to the other one.
     */ // @ts-expect-error Default options may have incompatible `Node` / `ElementNode`.
    const opts = options !== null && options !== void 0 ? options : $4af61137df229ea3$var$defaultOptions;
    // @ts-expect-error Same as above.
    (_a = opts.adapter) !== null && _a !== void 0 ? _a : opts.adapter = $a45mF;
    // @ts-expect-error `equals` does not exist on `Options`
    (_b = opts.equals) !== null && _b !== void 0 ? _b : opts.equals = (_d = (_c = opts.adapter) === null || _c === void 0 ? void 0 : _c.equals) !== null && _d !== void 0 ? _d : $4af61137df229ea3$var$defaultEquals;
    return opts;
}
function $4af61137df229ea3$var$wrapCompile(func) {
    return function addAdapter(selector, options, context) {
        const opts = $4af61137df229ea3$var$convertOptionFormats(options);
        return func(selector, opts, context);
    };
}
const $4af61137df229ea3$export$ef7acd7185315e22 = $4af61137df229ea3$var$wrapCompile((0, $fMij3.compile));
const $4af61137df229ea3$export$ff8dfdd3f753dc11 = $4af61137df229ea3$var$wrapCompile((0, $fMij3.compileUnsafe));
const $4af61137df229ea3$export$3ed2edee2e7c5e35 = $4af61137df229ea3$var$wrapCompile((0, $fMij3.compileToken));
function $4af61137df229ea3$var$getSelectorFunc(searchFunc) {
    return function select(query, elements, options) {
        const opts = $4af61137df229ea3$var$convertOptionFormats(options);
        if (typeof query !== "function") query = (0, $fMij3.compileUnsafe)(query, opts, elements);
        const filteredElements = $4af61137df229ea3$export$9c634076e0a91d1f(elements, opts.adapter, query.shouldTestNextSiblings);
        return searchFunc(query, filteredElements, opts);
    };
}
function $4af61137df229ea3$export$9c634076e0a91d1f(elems, adapter, shouldTestNextSiblings = false) {
    /*
     * Add siblings if the query requires them.
     * See https://github.com/fb55/css-select/pull/43#issuecomment-225414692
     */ if (shouldTestNextSiblings) elems = $4af61137df229ea3$var$appendNextSiblings(elems, adapter);
    return Array.isArray(elems) ? adapter.removeSubsets(elems) : adapter.getChildren(elems);
}
function $4af61137df229ea3$var$appendNextSiblings(elem, adapter) {
    // Order matters because jQuery seems to check the children before the siblings
    const elems = Array.isArray(elem) ? elem.slice(0) : [
        elem
    ];
    const elemsLength = elems.length;
    for(let i = 0; i < elemsLength; i++){
        const nextSiblings = (0, $2r79j.getNextSiblings)(elems[i], adapter);
        elems.push(...nextSiblings);
    }
    return elems;
}
const $4af61137df229ea3$export$90aca4adda6ff0f5 = $4af61137df229ea3$var$getSelectorFunc((query, elems, options)=>query === (0, (/*@__PURE__*/$parcel$interopDefault($guB19))).falseFunc || !elems || elems.length === 0 ? [] : options.adapter.findAll(query, elems));
const $4af61137df229ea3$export$9633ae49ba77655e = $4af61137df229ea3$var$getSelectorFunc((query, elems, options)=>query === (0, (/*@__PURE__*/$parcel$interopDefault($guB19))).falseFunc || !elems || elems.length === 0 ? null : options.adapter.findOne(query, elems));
function $4af61137df229ea3$export$226b3eccf92c9ed9(elem, query, options) {
    const opts = $4af61137df229ea3$var$convertOptionFormats(options);
    return (typeof query === "function" ? query : (0, $fMij3.compile)(query, opts))(elem);
}
var /**
 * Alias for selectAll(query, elems, options).
 * @see [compile] for supported selector queries.
 */ $4af61137df229ea3$export$2e2bcd8739ae039 = $4af61137df229ea3$export$90aca4adda6ff0f5;

});
parcelRegister("guB19", function(module, exports) {
module.exports = {
    trueFunc: function trueFunc() {
        return true;
    },
    falseFunc: function falseFunc() {
        return false;
    }
};

});

parcelRegister("fMij3", function(module, exports) {

$parcel$export(module.exports, "compile", () => $b7c989fc029a257f$export$ef7acd7185315e22);
$parcel$export(module.exports, "compileUnsafe", () => $b7c989fc029a257f$export$bbd36b99ab1dd6af);
$parcel$export(module.exports, "compileToken", () => $b7c989fc029a257f$export$9ac76eb524b317ec);

var $2yXYm = parcelRequire("2yXYm");
var $7GxKW = parcelRequire("7GxKW");

var $guB19 = parcelRequire("guB19");

var $4U6Xh = parcelRequire("4U6Xh");

var $1Ms0D = parcelRequire("1Ms0D");

var $2r79j = parcelRequire("2r79j");
function $b7c989fc029a257f$export$ef7acd7185315e22(selector, options, context) {
    const next = $b7c989fc029a257f$export$bbd36b99ab1dd6af(selector, options, context);
    return (0, $2r79j.ensureIsTag)(next, options.adapter);
}
function $b7c989fc029a257f$export$bbd36b99ab1dd6af(selector, options, context) {
    const token = typeof selector === "string" ? (0, $2yXYm.parse)(selector) : selector;
    return $b7c989fc029a257f$export$9ac76eb524b317ec(token, options, context);
}
function $b7c989fc029a257f$var$includesScopePseudo(t) {
    return t.type === (0, $7GxKW.SelectorType).Pseudo && (t.name === "scope" || Array.isArray(t.data) && t.data.some((data)=>data.some($b7c989fc029a257f$var$includesScopePseudo)));
}
const $b7c989fc029a257f$var$DESCENDANT_TOKEN = {
    type: (0, $7GxKW.SelectorType).Descendant
};
const $b7c989fc029a257f$var$FLEXIBLE_DESCENDANT_TOKEN = {
    type: "_flexibleDescendant"
};
const $b7c989fc029a257f$var$SCOPE_TOKEN = {
    type: (0, $7GxKW.SelectorType).Pseudo,
    name: "scope",
    data: null
};
/*
 * CSS 4 Spec (Draft): 3.4.1. Absolutizing a Relative Selector
 * http://www.w3.org/TR/selectors4/#absolutizing
 */ function $b7c989fc029a257f$var$absolutize(token, { adapter: adapter }, context) {
    // TODO Use better check if the context is a document
    const hasContext = !!(context === null || context === void 0 ? void 0 : context.every((e)=>{
        const parent = adapter.isTag(e) && adapter.getParent(e);
        return e === (0, $2r79j.PLACEHOLDER_ELEMENT) || parent && adapter.isTag(parent);
    }));
    for (const t of token){
        if (t.length > 0 && (0, $4U6Xh.isTraversal)(t[0]) && t[0].type !== (0, $7GxKW.SelectorType).Descendant) ;
        else if (hasContext && !t.some($b7c989fc029a257f$var$includesScopePseudo)) t.unshift($b7c989fc029a257f$var$DESCENDANT_TOKEN);
        else continue;
        t.unshift($b7c989fc029a257f$var$SCOPE_TOKEN);
    }
}
function $b7c989fc029a257f$export$9ac76eb524b317ec(token, options, context) {
    var _a;
    token.forEach((0, $4U6Xh.default));
    context = (_a = options.context) !== null && _a !== void 0 ? _a : context;
    const isArrayContext = Array.isArray(context);
    const finalContext = context && (Array.isArray(context) ? context : [
        context
    ]);
    // Check if the selector is relative
    if (options.relativeSelector !== false) $b7c989fc029a257f$var$absolutize(token, options, finalContext);
    else if (token.some((t)=>t.length > 0 && (0, $4U6Xh.isTraversal)(t[0]))) throw new Error("Relative selectors are not allowed when the `relativeSelector` option is disabled");
    let shouldTestNextSiblings = false;
    const query = token.map((rules)=>{
        if (rules.length >= 2) {
            const [first, second] = rules;
            if (first.type !== (0, $7GxKW.SelectorType).Pseudo || first.name !== "scope") ;
            else if (isArrayContext && second.type === (0, $7GxKW.SelectorType).Descendant) rules[1] = $b7c989fc029a257f$var$FLEXIBLE_DESCENDANT_TOKEN;
            else if (second.type === (0, $7GxKW.SelectorType).Adjacent || second.type === (0, $7GxKW.SelectorType).Sibling) shouldTestNextSiblings = true;
        }
        return $b7c989fc029a257f$var$compileRules(rules, options, finalContext);
    }).reduce($b7c989fc029a257f$var$reduceRules, (0, (/*@__PURE__*/$parcel$interopDefault($guB19))).falseFunc);
    query.shouldTestNextSiblings = shouldTestNextSiblings;
    return query;
}
function $b7c989fc029a257f$var$compileRules(rules, options, context) {
    var _a;
    return rules.reduce((previous, rule)=>previous === (0, (/*@__PURE__*/$parcel$interopDefault($guB19))).falseFunc ? (0, (/*@__PURE__*/$parcel$interopDefault($guB19))).falseFunc : (0, $1Ms0D.compileGeneralSelector)(previous, rule, options, context, $b7c989fc029a257f$export$9ac76eb524b317ec), (_a = options.rootFunc) !== null && _a !== void 0 ? _a : (0, (/*@__PURE__*/$parcel$interopDefault($guB19))).trueFunc);
}
function $b7c989fc029a257f$var$reduceRules(a, b) {
    if (b === (0, (/*@__PURE__*/$parcel$interopDefault($guB19))).falseFunc || a === (0, (/*@__PURE__*/$parcel$interopDefault($guB19))).trueFunc) return a;
    if (a === (0, (/*@__PURE__*/$parcel$interopDefault($guB19))).falseFunc || b === (0, (/*@__PURE__*/$parcel$interopDefault($guB19))).trueFunc) return b;
    return function combine(elem) {
        return a(elem) || b(elem);
    };
}

});
parcelRegister("4U6Xh", function(module, exports) {

$parcel$export(module.exports, "isTraversal", () => $3921c98551ccac32$export$41d1fe2780697dca);
$parcel$export(module.exports, "default", () => $3921c98551ccac32$export$2e2bcd8739ae039);

var $7GxKW = parcelRequire("7GxKW");
const $3921c98551ccac32$var$procedure = new Map([
    [
        (0, $7GxKW.SelectorType).Universal,
        50
    ],
    [
        (0, $7GxKW.SelectorType).Tag,
        30
    ],
    [
        (0, $7GxKW.SelectorType).Attribute,
        1
    ],
    [
        (0, $7GxKW.SelectorType).Pseudo,
        0
    ]
]);
function $3921c98551ccac32$export$41d1fe2780697dca(token) {
    return !$3921c98551ccac32$var$procedure.has(token.type);
}
const $3921c98551ccac32$var$attributes = new Map([
    [
        (0, $7GxKW.AttributeAction).Exists,
        10
    ],
    [
        (0, $7GxKW.AttributeAction).Equals,
        8
    ],
    [
        (0, $7GxKW.AttributeAction).Not,
        7
    ],
    [
        (0, $7GxKW.AttributeAction).Start,
        6
    ],
    [
        (0, $7GxKW.AttributeAction).End,
        6
    ],
    [
        (0, $7GxKW.AttributeAction).Any,
        5
    ]
]);
function $3921c98551ccac32$export$2e2bcd8739ae039(arr) {
    const procs = arr.map($3921c98551ccac32$var$getProcedure);
    for(let i = 1; i < arr.length; i++){
        const procNew = procs[i];
        if (procNew < 0) continue;
        for(let j = i - 1; j >= 0 && procNew < procs[j]; j--){
            const token = arr[j + 1];
            arr[j + 1] = arr[j];
            arr[j] = token;
            procs[j + 1] = procs[j];
            procs[j] = procNew;
        }
    }
}
function $3921c98551ccac32$var$getProcedure(token) {
    var _a, _b;
    let proc = (_a = $3921c98551ccac32$var$procedure.get(token.type)) !== null && _a !== void 0 ? _a : -1;
    if (token.type === (0, $7GxKW.SelectorType).Attribute) {
        proc = (_b = $3921c98551ccac32$var$attributes.get(token.action)) !== null && _b !== void 0 ? _b : 4;
        if (token.action === (0, $7GxKW.AttributeAction).Equals && token.name === "id") // Prefer ID selectors (eg. #ID)
        proc = 9;
        if (token.ignoreCase) /*
             * IgnoreCase adds some overhead, prefer "normal" token
             * this is a binary operation, to ensure it's still an int
             */ proc >>= 1;
    } else if (token.type === (0, $7GxKW.SelectorType).Pseudo) {
        if (!token.data) proc = 3;
        else if (token.name === "has" || token.name === "contains") proc = 0; // Expensive in any case
        else if (Array.isArray(token.data)) {
            // Eg. :matches, :not
            proc = Math.min(...token.data.map((d)=>Math.min(...d.map($3921c98551ccac32$var$getProcedure))));
            // If we have traversals, try to avoid executing this selector
            if (proc < 0) proc = 0;
        } else proc = 2;
    }
    return proc;
}

});

parcelRegister("1Ms0D", function(module, exports) {

$parcel$export(module.exports, "compileGeneralSelector", () => $14c00033fe060d15$export$afd2165e507ce8c5);

var $fglDM = parcelRequire("fglDM");

var $lIEEt = parcelRequire("lIEEt");

var $7GxKW = parcelRequire("7GxKW");
function $14c00033fe060d15$var$getElementParent(node, adapter) {
    const parent = adapter.getParent(node);
    if (parent && adapter.isTag(parent)) return parent;
    return null;
}
function $14c00033fe060d15$export$afd2165e507ce8c5(next, selector, options, context, compileToken) {
    const { adapter: adapter, equals: equals } = options;
    switch(selector.type){
        case (0, $7GxKW.SelectorType).PseudoElement:
            throw new Error("Pseudo-elements are not supported by css-select");
        case (0, $7GxKW.SelectorType).ColumnCombinator:
            throw new Error("Column combinators are not yet supported by css-select");
        case (0, $7GxKW.SelectorType).Attribute:
            if (selector.namespace != null) throw new Error("Namespaced attributes are not yet supported by css-select");
            if (!options.xmlMode || options.lowerCaseAttributeNames) selector.name = selector.name.toLowerCase();
            return (0, $fglDM.attributeRules)[selector.action](next, selector, options);
        case (0, $7GxKW.SelectorType).Pseudo:
            return (0, $lIEEt.compilePseudoSelector)(next, selector, options, context, compileToken);
        // Tags
        case (0, $7GxKW.SelectorType).Tag:
            {
                if (selector.namespace != null) throw new Error("Namespaced tag names are not yet supported by css-select");
                let { name: name } = selector;
                if (!options.xmlMode || options.lowerCaseTags) name = name.toLowerCase();
                return function tag(elem) {
                    return adapter.getName(elem) === name && next(elem);
                };
            }
        // Traversal
        case (0, $7GxKW.SelectorType).Descendant:
            {
                if (options.cacheResults === false || typeof WeakSet === "undefined") return function descendant(elem) {
                    let current = elem;
                    while(current = $14c00033fe060d15$var$getElementParent(current, adapter)){
                        if (next(current)) return true;
                    }
                    return false;
                };
                // @ts-expect-error `ElementNode` is not extending object
                const isFalseCache = new WeakSet();
                return function cachedDescendant(elem) {
                    let current = elem;
                    while(current = $14c00033fe060d15$var$getElementParent(current, adapter))if (!isFalseCache.has(current)) {
                        if (adapter.isTag(current) && next(current)) return true;
                        isFalseCache.add(current);
                    }
                    return false;
                };
            }
        case "_flexibleDescendant":
            // Include element itself, only used while querying an array
            return function flexibleDescendant(elem) {
                let current = elem;
                do {
                    if (next(current)) return true;
                }while (current = $14c00033fe060d15$var$getElementParent(current, adapter));
                return false;
            };
        case (0, $7GxKW.SelectorType).Parent:
            return function parent(elem) {
                return adapter.getChildren(elem).some((elem)=>adapter.isTag(elem) && next(elem));
            };
        case (0, $7GxKW.SelectorType).Child:
            return function child(elem) {
                const parent = adapter.getParent(elem);
                return parent != null && adapter.isTag(parent) && next(parent);
            };
        case (0, $7GxKW.SelectorType).Sibling:
            return function sibling(elem) {
                const siblings = adapter.getSiblings(elem);
                for(let i = 0; i < siblings.length; i++){
                    const currentSibling = siblings[i];
                    if (equals(elem, currentSibling)) break;
                    if (adapter.isTag(currentSibling) && next(currentSibling)) return true;
                }
                return false;
            };
        case (0, $7GxKW.SelectorType).Adjacent:
            if (adapter.prevElementSibling) return function adjacent(elem) {
                const previous = adapter.prevElementSibling(elem);
                return previous != null && next(previous);
            };
            return function adjacent(elem) {
                const siblings = adapter.getSiblings(elem);
                let lastElement;
                for(let i = 0; i < siblings.length; i++){
                    const currentSibling = siblings[i];
                    if (equals(elem, currentSibling)) break;
                    if (adapter.isTag(currentSibling)) lastElement = currentSibling;
                }
                return !!lastElement && next(lastElement);
            };
        case (0, $7GxKW.SelectorType).Universal:
            if (selector.namespace != null && selector.namespace !== "*") throw new Error("Namespaced universal selectors are not yet supported by css-select");
            return next;
    }
}

});
parcelRegister("fglDM", function(module, exports) {

$parcel$export(module.exports, "attributeRules", () => $b1c92307d4e0033b$export$ebf1ecb9197f27e);

var $guB19 = parcelRequire("guB19");
/**
 * All reserved characters in a regex, used for escaping.
 *
 * Taken from XRegExp, (c) 2007-2020 Steven Levithan under the MIT license
 * https://github.com/slevithan/xregexp/blob/95eeebeb8fac8754d54eafe2b4743661ac1cf028/src/xregexp.js#L794
 */ const $b1c92307d4e0033b$var$reChars = /[-[\]{}()*+?.,\\^$|#\s]/g;
function $b1c92307d4e0033b$var$escapeRegex(value) {
    return value.replace($b1c92307d4e0033b$var$reChars, "\\$&");
}
/**
 * Attributes that are case-insensitive in HTML.
 *
 * @private
 * @see https://html.spec.whatwg.org/multipage/semantics-other.html#case-sensitivity-of-selectors
 */ const $b1c92307d4e0033b$var$caseInsensitiveAttributes = new Set([
    "accept",
    "accept-charset",
    "align",
    "alink",
    "axis",
    "bgcolor",
    "charset",
    "checked",
    "clear",
    "codetype",
    "color",
    "compact",
    "declare",
    "defer",
    "dir",
    "direction",
    "disabled",
    "enctype",
    "face",
    "frame",
    "hreflang",
    "http-equiv",
    "lang",
    "language",
    "link",
    "media",
    "method",
    "multiple",
    "nohref",
    "noresize",
    "noshade",
    "nowrap",
    "readonly",
    "rel",
    "rev",
    "rules",
    "scope",
    "scrolling",
    "selected",
    "shape",
    "target",
    "text",
    "type",
    "valign",
    "valuetype",
    "vlink"
]);
function $b1c92307d4e0033b$var$shouldIgnoreCase(selector, options) {
    return typeof selector.ignoreCase === "boolean" ? selector.ignoreCase : selector.ignoreCase === "quirks" ? !!options.quirksMode : !options.xmlMode && $b1c92307d4e0033b$var$caseInsensitiveAttributes.has(selector.name);
}
const $b1c92307d4e0033b$export$ebf1ecb9197f27e = {
    equals (next, data, options) {
        const { adapter: adapter } = options;
        const { name: name } = data;
        let { value: value } = data;
        if ($b1c92307d4e0033b$var$shouldIgnoreCase(data, options)) {
            value = value.toLowerCase();
            return (elem)=>{
                const attr = adapter.getAttributeValue(elem, name);
                return attr != null && attr.length === value.length && attr.toLowerCase() === value && next(elem);
            };
        }
        return (elem)=>adapter.getAttributeValue(elem, name) === value && next(elem);
    },
    hyphen (next, data, options) {
        const { adapter: adapter } = options;
        const { name: name } = data;
        let { value: value } = data;
        const len = value.length;
        if ($b1c92307d4e0033b$var$shouldIgnoreCase(data, options)) {
            value = value.toLowerCase();
            return function hyphenIC(elem) {
                const attr = adapter.getAttributeValue(elem, name);
                return attr != null && (attr.length === len || attr.charAt(len) === "-") && attr.substr(0, len).toLowerCase() === value && next(elem);
            };
        }
        return function hyphen(elem) {
            const attr = adapter.getAttributeValue(elem, name);
            return attr != null && (attr.length === len || attr.charAt(len) === "-") && attr.substr(0, len) === value && next(elem);
        };
    },
    element (next, data, options) {
        const { adapter: adapter } = options;
        const { name: name, value: value } = data;
        if (/\s/.test(value)) return (0, (/*@__PURE__*/$parcel$interopDefault($guB19))).falseFunc;
        const regex = new RegExp(`(?:^|\\s)${$b1c92307d4e0033b$var$escapeRegex(value)}(?:$|\\s)`, $b1c92307d4e0033b$var$shouldIgnoreCase(data, options) ? "i" : "");
        return function element(elem) {
            const attr = adapter.getAttributeValue(elem, name);
            return attr != null && attr.length >= value.length && regex.test(attr) && next(elem);
        };
    },
    exists (next, { name: name }, { adapter: adapter }) {
        return (elem)=>adapter.hasAttrib(elem, name) && next(elem);
    },
    start (next, data, options) {
        const { adapter: adapter } = options;
        const { name: name } = data;
        let { value: value } = data;
        const len = value.length;
        if (len === 0) return (0, (/*@__PURE__*/$parcel$interopDefault($guB19))).falseFunc;
        if ($b1c92307d4e0033b$var$shouldIgnoreCase(data, options)) {
            value = value.toLowerCase();
            return (elem)=>{
                const attr = adapter.getAttributeValue(elem, name);
                return attr != null && attr.length >= len && attr.substr(0, len).toLowerCase() === value && next(elem);
            };
        }
        return (elem)=>{
            var _a;
            return !!((_a = adapter.getAttributeValue(elem, name)) === null || _a === void 0 ? void 0 : _a.startsWith(value)) && next(elem);
        };
    },
    end (next, data, options) {
        const { adapter: adapter } = options;
        const { name: name } = data;
        let { value: value } = data;
        const len = -value.length;
        if (len === 0) return (0, (/*@__PURE__*/$parcel$interopDefault($guB19))).falseFunc;
        if ($b1c92307d4e0033b$var$shouldIgnoreCase(data, options)) {
            value = value.toLowerCase();
            return (elem)=>{
                var _a;
                return ((_a = adapter.getAttributeValue(elem, name)) === null || _a === void 0 ? void 0 : _a.substr(len).toLowerCase()) === value && next(elem);
            };
        }
        return (elem)=>{
            var _a;
            return !!((_a = adapter.getAttributeValue(elem, name)) === null || _a === void 0 ? void 0 : _a.endsWith(value)) && next(elem);
        };
    },
    any (next, data, options) {
        const { adapter: adapter } = options;
        const { name: name, value: value } = data;
        if (value === "") return (0, (/*@__PURE__*/$parcel$interopDefault($guB19))).falseFunc;
        if ($b1c92307d4e0033b$var$shouldIgnoreCase(data, options)) {
            const regex = new RegExp($b1c92307d4e0033b$var$escapeRegex(value), "i");
            return function anyIC(elem) {
                const attr = adapter.getAttributeValue(elem, name);
                return attr != null && attr.length >= value.length && regex.test(attr) && next(elem);
            };
        }
        return (elem)=>{
            var _a;
            return !!((_a = adapter.getAttributeValue(elem, name)) === null || _a === void 0 ? void 0 : _a.includes(value)) && next(elem);
        };
    },
    not (next, data, options) {
        const { adapter: adapter } = options;
        const { name: name } = data;
        let { value: value } = data;
        if (value === "") return (elem)=>!!adapter.getAttributeValue(elem, name) && next(elem);
        else if ($b1c92307d4e0033b$var$shouldIgnoreCase(data, options)) {
            value = value.toLowerCase();
            return (elem)=>{
                const attr = adapter.getAttributeValue(elem, name);
                return (attr == null || attr.length !== value.length || attr.toLowerCase() !== value) && next(elem);
            };
        }
        return (elem)=>adapter.getAttributeValue(elem, name) !== value && next(elem);
    }
};

});

parcelRegister("lIEEt", function(module, exports) {

$parcel$export(module.exports, "compilePseudoSelector", () => $fcfd3da5396c339f$export$1a67b9bcd42231f5);

var $2yXYm = parcelRequire("2yXYm");

var $kle0t = parcelRequire("kle0t");

var $bkiPz = parcelRequire("bkiPz");

var $bfEYC = parcelRequire("bfEYC");

var $2r79j = parcelRequire("2r79j");
function $fcfd3da5396c339f$export$1a67b9bcd42231f5(next, selector, options, context, compileToken) {
    var _a;
    const { name: name, data: data } = selector;
    if (Array.isArray(data)) {
        if (!(name in (0, $2r79j.subselects))) throw new Error(`Unknown pseudo-class :${name}(${data})`);
        return (0, $2r79j.subselects)[name](next, data, options, context, compileToken);
    }
    const userPseudo = (_a = options.pseudos) === null || _a === void 0 ? void 0 : _a[name];
    const stringPseudo = typeof userPseudo === "string" ? userPseudo : (0, $bfEYC.aliases)[name];
    if (typeof stringPseudo === "string") {
        if (data != null) throw new Error(`Pseudo ${name} doesn't have any arguments`);
        // The alias has to be parsed here, to make sure options are respected.
        const alias = (0, $2yXYm.parse)(stringPseudo);
        return (0, $2r79j.subselects)["is"](next, alias, options, context, compileToken);
    }
    if (typeof userPseudo === "function") {
        (0, $bkiPz.verifyPseudoArgs)(userPseudo, name, data, 1);
        return (elem)=>userPseudo(elem, data) && next(elem);
    }
    if (name in (0, $kle0t.filters)) return (0, $kle0t.filters)[name](next, data, options, context);
    if (name in (0, $bkiPz.pseudos)) {
        const pseudo = (0, $bkiPz.pseudos)[name];
        (0, $bkiPz.verifyPseudoArgs)(pseudo, name, data, 2);
        return (elem)=>pseudo(elem, options, data) && next(elem);
    }
    throw new Error(`Unknown pseudo-class :${name}`);
}

});
parcelRegister("kle0t", function(module, exports) {

$parcel$export(module.exports, "filters", () => $ecf0a23adaa7002b$export$82462a21aead86ed);

var $gzNWb = parcelRequire("gzNWb");

var $guB19 = parcelRequire("guB19");
function $ecf0a23adaa7002b$var$getChildFunc(next, adapter) {
    return (elem)=>{
        const parent = adapter.getParent(elem);
        return parent != null && adapter.isTag(parent) && next(elem);
    };
}
const $ecf0a23adaa7002b$export$82462a21aead86ed = {
    contains (next, text, { adapter: adapter }) {
        return function contains(elem) {
            return next(elem) && adapter.getText(elem).includes(text);
        };
    },
    icontains (next, text, { adapter: adapter }) {
        const itext = text.toLowerCase();
        return function icontains(elem) {
            return next(elem) && adapter.getText(elem).toLowerCase().includes(itext);
        };
    },
    // Location specific methods
    "nth-child" (next, rule, { adapter: adapter, equals: equals }) {
        const func = (0, $gzNWb.default)(rule);
        if (func === (0, (/*@__PURE__*/$parcel$interopDefault($guB19))).falseFunc) return (0, (/*@__PURE__*/$parcel$interopDefault($guB19))).falseFunc;
        if (func === (0, (/*@__PURE__*/$parcel$interopDefault($guB19))).trueFunc) return $ecf0a23adaa7002b$var$getChildFunc(next, adapter);
        return function nthChild(elem) {
            const siblings = adapter.getSiblings(elem);
            let pos = 0;
            for(let i = 0; i < siblings.length; i++){
                if (equals(elem, siblings[i])) break;
                if (adapter.isTag(siblings[i])) pos++;
            }
            return func(pos) && next(elem);
        };
    },
    "nth-last-child" (next, rule, { adapter: adapter, equals: equals }) {
        const func = (0, $gzNWb.default)(rule);
        if (func === (0, (/*@__PURE__*/$parcel$interopDefault($guB19))).falseFunc) return (0, (/*@__PURE__*/$parcel$interopDefault($guB19))).falseFunc;
        if (func === (0, (/*@__PURE__*/$parcel$interopDefault($guB19))).trueFunc) return $ecf0a23adaa7002b$var$getChildFunc(next, adapter);
        return function nthLastChild(elem) {
            const siblings = adapter.getSiblings(elem);
            let pos = 0;
            for(let i = siblings.length - 1; i >= 0; i--){
                if (equals(elem, siblings[i])) break;
                if (adapter.isTag(siblings[i])) pos++;
            }
            return func(pos) && next(elem);
        };
    },
    "nth-of-type" (next, rule, { adapter: adapter, equals: equals }) {
        const func = (0, $gzNWb.default)(rule);
        if (func === (0, (/*@__PURE__*/$parcel$interopDefault($guB19))).falseFunc) return (0, (/*@__PURE__*/$parcel$interopDefault($guB19))).falseFunc;
        if (func === (0, (/*@__PURE__*/$parcel$interopDefault($guB19))).trueFunc) return $ecf0a23adaa7002b$var$getChildFunc(next, adapter);
        return function nthOfType(elem) {
            const siblings = adapter.getSiblings(elem);
            let pos = 0;
            for(let i = 0; i < siblings.length; i++){
                const currentSibling = siblings[i];
                if (equals(elem, currentSibling)) break;
                if (adapter.isTag(currentSibling) && adapter.getName(currentSibling) === adapter.getName(elem)) pos++;
            }
            return func(pos) && next(elem);
        };
    },
    "nth-last-of-type" (next, rule, { adapter: adapter, equals: equals }) {
        const func = (0, $gzNWb.default)(rule);
        if (func === (0, (/*@__PURE__*/$parcel$interopDefault($guB19))).falseFunc) return (0, (/*@__PURE__*/$parcel$interopDefault($guB19))).falseFunc;
        if (func === (0, (/*@__PURE__*/$parcel$interopDefault($guB19))).trueFunc) return $ecf0a23adaa7002b$var$getChildFunc(next, adapter);
        return function nthLastOfType(elem) {
            const siblings = adapter.getSiblings(elem);
            let pos = 0;
            for(let i = siblings.length - 1; i >= 0; i--){
                const currentSibling = siblings[i];
                if (equals(elem, currentSibling)) break;
                if (adapter.isTag(currentSibling) && adapter.getName(currentSibling) === adapter.getName(elem)) pos++;
            }
            return func(pos) && next(elem);
        };
    },
    // TODO determine the actual root element
    root (next, _rule, { adapter: adapter }) {
        return (elem)=>{
            const parent = adapter.getParent(elem);
            return (parent == null || !adapter.isTag(parent)) && next(elem);
        };
    },
    scope (next, rule, options, context) {
        const { equals: equals } = options;
        if (!context || context.length === 0) // Equivalent to :root
        return $ecf0a23adaa7002b$export$82462a21aead86ed["root"](next, rule, options);
        if (context.length === 1) // NOTE: can't be unpacked, as :has uses this for side-effects
        return (elem)=>equals(context[0], elem) && next(elem);
        return (elem)=>context.includes(elem) && next(elem);
    },
    hover: $ecf0a23adaa7002b$var$dynamicStatePseudo("isHovered"),
    visited: $ecf0a23adaa7002b$var$dynamicStatePseudo("isVisited"),
    active: $ecf0a23adaa7002b$var$dynamicStatePseudo("isActive")
};
/**
 * Dynamic state pseudos. These depend on optional Adapter methods.
 *
 * @param name The name of the adapter method to call.
 * @returns Pseudo for the `filters` object.
 */ function $ecf0a23adaa7002b$var$dynamicStatePseudo(name) {
    return function dynamicPseudo(next, _rule, { adapter: adapter }) {
        const func = adapter[name];
        if (typeof func !== "function") return (0, (/*@__PURE__*/$parcel$interopDefault($guB19))).falseFunc;
        return function active(elem) {
            return func(elem) && next(elem);
        };
    };
}

});
parcelRegister("gzNWb", function(module, exports) {

$parcel$export(module.exports, "default", () => $c116a6c15063a2f3$export$2e2bcd8739ae039);

var $glgu2 = parcelRequire("glgu2");

var $6dFom = parcelRequire("6dFom");
function $c116a6c15063a2f3$export$2e2bcd8739ae039(formula) {
    return (0, $6dFom.compile)((0, $glgu2.parse)(formula));
}
function $c116a6c15063a2f3$export$49bb65c2ea163039(formula) {
    return (0, $6dFom.generate)((0, $glgu2.parse)(formula));
}

});
parcelRegister("glgu2", function(module, exports) {

$parcel$export(module.exports, "parse", () => $be5b64c972714dd5$export$98e6a39c04603d36);
// Following http://www.w3.org/TR/css3-selectors/#nth-child-pseudo
// Whitespace as per https://www.w3.org/TR/selectors-3/#lex is " \t\r\n\f"
const $be5b64c972714dd5$var$whitespace = new Set([
    9,
    10,
    12,
    13,
    32
]);
const $be5b64c972714dd5$var$ZERO = "0".charCodeAt(0);
const $be5b64c972714dd5$var$NINE = "9".charCodeAt(0);
function $be5b64c972714dd5$export$98e6a39c04603d36(formula) {
    formula = formula.trim().toLowerCase();
    if (formula === "even") return [
        2,
        0
    ];
    else if (formula === "odd") return [
        2,
        1
    ];
    // Parse [ ['-'|'+']? INTEGER? {N} [ S* ['-'|'+'] S* INTEGER ]?
    let idx = 0;
    let a = 0;
    let sign = readSign();
    let number = readNumber();
    if (idx < formula.length && formula.charAt(idx) === "n") {
        idx++;
        a = sign * (number !== null && number !== void 0 ? number : 1);
        skipWhitespace();
        if (idx < formula.length) {
            sign = readSign();
            skipWhitespace();
            number = readNumber();
        } else sign = number = 0;
    }
    // Throw if there is anything else
    if (number === null || idx < formula.length) throw new Error(`n-th rule couldn't be parsed ('${formula}')`);
    return [
        a,
        sign * number
    ];
    function readSign() {
        if (formula.charAt(idx) === "-") {
            idx++;
            return -1;
        }
        if (formula.charAt(idx) === "+") idx++;
        return 1;
    }
    function readNumber() {
        const start = idx;
        let value = 0;
        while(idx < formula.length && formula.charCodeAt(idx) >= $be5b64c972714dd5$var$ZERO && formula.charCodeAt(idx) <= $be5b64c972714dd5$var$NINE){
            value = value * 10 + (formula.charCodeAt(idx) - $be5b64c972714dd5$var$ZERO);
            idx++;
        }
        // Return `null` if we didn't read anything.
        return idx === start ? null : value;
    }
    function skipWhitespace() {
        while(idx < formula.length && $be5b64c972714dd5$var$whitespace.has(formula.charCodeAt(idx)))idx++;
    }
}

});

parcelRegister("6dFom", function(module, exports) {

$parcel$export(module.exports, "compile", () => $4874108c70957ef8$export$ef7acd7185315e22);
$parcel$export(module.exports, "generate", () => $4874108c70957ef8$export$80d376111cc09ad7);

var $guB19 = parcelRequire("guB19");
function $4874108c70957ef8$export$ef7acd7185315e22(parsed) {
    const a = parsed[0];
    // Subtract 1 from `b`, to convert from one- to zero-indexed.
    const b = parsed[1] - 1;
    /*
     * When `b <= 0`, `a * n` won't be lead to any matches for `a < 0`.
     * Besides, the specification states that no elements are
     * matched when `a` and `b` are 0.
     *
     * `b < 0` here as we subtracted 1 from `b` above.
     */ if (b < 0 && a <= 0) return (0, (/*@__PURE__*/$parcel$interopDefault($guB19))).falseFunc;
    // When `a` is in the range -1..1, it matches any element (so only `b` is checked).
    if (a === -1) return (index)=>index <= b;
    if (a === 0) return (index)=>index === b;
    // When `b <= 0` and `a === 1`, they match any element.
    if (a === 1) return b < 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($guB19))).trueFunc : (index)=>index >= b;
    /*
     * Otherwise, modulo can be used to check if there is a match.
     *
     * Modulo doesn't care about the sign, so let's use `a`s absolute value.
     */ const absA = Math.abs(a);
    // Get `b mod a`, + a if this is negative.
    const bMod = (b % absA + absA) % absA;
    return a > 1 ? (index)=>index >= b && index % absA === bMod : (index)=>index <= b && index % absA === bMod;
}
function $4874108c70957ef8$export$80d376111cc09ad7(parsed) {
    const a = parsed[0];
    // Subtract 1 from `b`, to convert from one- to zero-indexed.
    let b = parsed[1] - 1;
    let n = 0;
    // Make sure to always return an increasing sequence
    if (a < 0) {
        const aPos = -a;
        // Get `b mod a`
        const minValue = (b % aPos + aPos) % aPos;
        return ()=>{
            const val = minValue + aPos * n++;
            return val > b ? null : val;
        };
    }
    if (a === 0) return b < 0 ? ()=>null : ()=>n++ === 0 ? b : null;
    if (b < 0) b += a * Math.ceil(-b / a);
    return ()=>a * n++ + b;
}

});



parcelRegister("bkiPz", function(module, exports) {

$parcel$export(module.exports, "pseudos", () => $83f02b5e76d1ea21$export$8dc723548151ed12);
$parcel$export(module.exports, "verifyPseudoArgs", () => $83f02b5e76d1ea21$export$d62f7d28fa725e36);
// While filters are precompiled, pseudos get called when they are needed
const $83f02b5e76d1ea21$export$8dc723548151ed12 = {
    empty (elem, { adapter: adapter }) {
        return !adapter.getChildren(elem).some((elem)=>// FIXME: `getText` call is potentially expensive.
            adapter.isTag(elem) || adapter.getText(elem) !== "");
    },
    "first-child" (elem, { adapter: adapter, equals: equals }) {
        if (adapter.prevElementSibling) return adapter.prevElementSibling(elem) == null;
        const firstChild = adapter.getSiblings(elem).find((elem)=>adapter.isTag(elem));
        return firstChild != null && equals(elem, firstChild);
    },
    "last-child" (elem, { adapter: adapter, equals: equals }) {
        const siblings = adapter.getSiblings(elem);
        for(let i = siblings.length - 1; i >= 0; i--){
            if (equals(elem, siblings[i])) return true;
            if (adapter.isTag(siblings[i])) break;
        }
        return false;
    },
    "first-of-type" (elem, { adapter: adapter, equals: equals }) {
        const siblings = adapter.getSiblings(elem);
        const elemName = adapter.getName(elem);
        for(let i = 0; i < siblings.length; i++){
            const currentSibling = siblings[i];
            if (equals(elem, currentSibling)) return true;
            if (adapter.isTag(currentSibling) && adapter.getName(currentSibling) === elemName) break;
        }
        return false;
    },
    "last-of-type" (elem, { adapter: adapter, equals: equals }) {
        const siblings = adapter.getSiblings(elem);
        const elemName = adapter.getName(elem);
        for(let i = siblings.length - 1; i >= 0; i--){
            const currentSibling = siblings[i];
            if (equals(elem, currentSibling)) return true;
            if (adapter.isTag(currentSibling) && adapter.getName(currentSibling) === elemName) break;
        }
        return false;
    },
    "only-of-type" (elem, { adapter: adapter, equals: equals }) {
        const elemName = adapter.getName(elem);
        return adapter.getSiblings(elem).every((sibling)=>equals(elem, sibling) || !adapter.isTag(sibling) || adapter.getName(sibling) !== elemName);
    },
    "only-child" (elem, { adapter: adapter, equals: equals }) {
        return adapter.getSiblings(elem).every((sibling)=>equals(elem, sibling) || !adapter.isTag(sibling));
    }
};
function $83f02b5e76d1ea21$export$d62f7d28fa725e36(func, name, subselect, argIndex) {
    if (subselect === null) {
        if (func.length > argIndex) throw new Error(`Pseudo-class :${name} requires an argument`);
    } else if (func.length === argIndex) throw new Error(`Pseudo-class :${name} doesn't have any arguments`);
}

});

parcelRegister("bfEYC", function(module, exports) {

$parcel$export(module.exports, "aliases", () => $8310e190124a547a$export$9af93bb9e9126a2);
/**
 * Aliases are pseudos that are expressed as selectors.
 */ const $8310e190124a547a$export$9af93bb9e9126a2 = {
    // Links
    "any-link": ":is(a, area, link)[href]",
    link: ":any-link:not(:visited)",
    // Forms
    // https://html.spec.whatwg.org/multipage/scripting.html#disabled-elements
    disabled: `:is(
        :is(button, input, select, textarea, optgroup, option)[disabled],
        optgroup[disabled] > option,
        fieldset[disabled]:not(fieldset[disabled] legend:first-of-type *)
    )`,
    enabled: ":not(:disabled)",
    checked: ":is(:is(input[type=radio], input[type=checkbox])[checked], option:selected)",
    required: ":is(input, select, textarea)[required]",
    optional: ":is(input, select, textarea):not([required])",
    // JQuery extensions
    // https://html.spec.whatwg.org/multipage/form-elements.html#concept-option-selectedness
    selected: "option:is([selected], select:not([multiple]):not(:has(> option[selected])) > :first-of-type)",
    checkbox: "[type=checkbox]",
    file: "[type=file]",
    password: "[type=password]",
    radio: "[type=radio]",
    reset: "[type=reset]",
    image: "[type=image]",
    submit: "[type=submit]",
    parent: ":not(:empty)",
    header: ":is(h1, h2, h3, h4, h5, h6)",
    button: ":is(button, input[type=button])",
    input: ":is(input, textarea, select, button)",
    text: "input:is(:not([type!='']), [type=text])"
};

});

parcelRegister("2r79j", function(module, exports) {

$parcel$export(module.exports, "PLACEHOLDER_ELEMENT", () => $1c63a6119d76a974$export$f2f25fe26aaee026);
$parcel$export(module.exports, "ensureIsTag", () => $1c63a6119d76a974$export$a48279061b25ff7);
$parcel$export(module.exports, "getNextSiblings", () => $1c63a6119d76a974$export$8666503a05bdce46);
$parcel$export(module.exports, "subselects", () => $1c63a6119d76a974$export$f3666d140abaf082);

var $guB19 = parcelRequire("guB19");

var $4U6Xh = parcelRequire("4U6Xh");
const $1c63a6119d76a974$export$f2f25fe26aaee026 = {};
function $1c63a6119d76a974$export$a48279061b25ff7(next, adapter) {
    if (next === (0, (/*@__PURE__*/$parcel$interopDefault($guB19))).falseFunc) return (0, (/*@__PURE__*/$parcel$interopDefault($guB19))).falseFunc;
    return (elem)=>adapter.isTag(elem) && next(elem);
}
function $1c63a6119d76a974$export$8666503a05bdce46(elem, adapter) {
    const siblings = adapter.getSiblings(elem);
    if (siblings.length <= 1) return [];
    const elemIndex = siblings.indexOf(elem);
    if (elemIndex < 0 || elemIndex === siblings.length - 1) return [];
    return siblings.slice(elemIndex + 1).filter(adapter.isTag);
}
function $1c63a6119d76a974$var$copyOptions(options) {
    // Not copied: context, rootFunc
    return {
        xmlMode: !!options.xmlMode,
        lowerCaseAttributeNames: !!options.lowerCaseAttributeNames,
        lowerCaseTags: !!options.lowerCaseTags,
        quirksMode: !!options.quirksMode,
        cacheResults: !!options.cacheResults,
        pseudos: options.pseudos,
        adapter: options.adapter,
        equals: options.equals
    };
}
const $1c63a6119d76a974$var$is = (next, token, options, context, compileToken)=>{
    const func = compileToken(token, $1c63a6119d76a974$var$copyOptions(options), context);
    return func === (0, (/*@__PURE__*/$parcel$interopDefault($guB19))).trueFunc ? next : func === (0, (/*@__PURE__*/$parcel$interopDefault($guB19))).falseFunc ? (0, (/*@__PURE__*/$parcel$interopDefault($guB19))).falseFunc : (elem)=>func(elem) && next(elem);
};
const $1c63a6119d76a974$export$f3666d140abaf082 = {
    is: $1c63a6119d76a974$var$is,
    /**
     * `:matches` and `:where` are aliases for `:is`.
     */ matches: $1c63a6119d76a974$var$is,
    where: $1c63a6119d76a974$var$is,
    not (next, token, options, context, compileToken) {
        const func = compileToken(token, $1c63a6119d76a974$var$copyOptions(options), context);
        return func === (0, (/*@__PURE__*/$parcel$interopDefault($guB19))).falseFunc ? next : func === (0, (/*@__PURE__*/$parcel$interopDefault($guB19))).trueFunc ? (0, (/*@__PURE__*/$parcel$interopDefault($guB19))).falseFunc : (elem)=>!func(elem) && next(elem);
    },
    has (next, subselect, options, _context, compileToken) {
        const { adapter: adapter } = options;
        const opts = $1c63a6119d76a974$var$copyOptions(options);
        opts.relativeSelector = true;
        const context = subselect.some((s)=>s.some((0, $4U6Xh.isTraversal))) ? [
            $1c63a6119d76a974$export$f2f25fe26aaee026
        ] : undefined;
        const compiled = compileToken(subselect, opts, context);
        if (compiled === (0, (/*@__PURE__*/$parcel$interopDefault($guB19))).falseFunc) return (0, (/*@__PURE__*/$parcel$interopDefault($guB19))).falseFunc;
        const hasElement = $1c63a6119d76a974$export$a48279061b25ff7(compiled, adapter);
        // If `compiled` is `trueFunc`, we can skip this.
        if (context && compiled !== (0, (/*@__PURE__*/$parcel$interopDefault($guB19))).trueFunc) {
            /*
             * `shouldTestNextSiblings` will only be true if the query starts with
             * a traversal (sibling or adjacent). That means we will always have a context.
             */ const { shouldTestNextSiblings: shouldTestNextSiblings = false } = compiled;
            return (elem)=>{
                if (!next(elem)) return false;
                context[0] = elem;
                const childs = adapter.getChildren(elem);
                const nextElements = shouldTestNextSiblings ? [
                    ...childs,
                    ...$1c63a6119d76a974$export$8666503a05bdce46(elem, adapter)
                ] : childs;
                return adapter.existsOne(hasElement, nextElements);
            };
        }
        return (elem)=>next(elem) && adapter.existsOne(hasElement, adapter.getChildren(elem));
    }
};

});





parcelRegister("jML7X", function(module, exports) {

$parcel$export(module.exports, "getDocumentRoot", () => $e6770e80d98d1757$export$6492b66915332185);
$parcel$export(module.exports, "groupSelectors", () => $e6770e80d98d1757$export$12837f7a14c656c9);

var $hbA8b = parcelRequire("hbA8b");
function $e6770e80d98d1757$export$6492b66915332185(node) {
    while(node.parent)node = node.parent;
    return node;
}
function $e6770e80d98d1757$export$12837f7a14c656c9(selectors) {
    const filteredSelectors = [];
    const plainSelectors = [];
    for (const selector of selectors)if (selector.some((0, $hbA8b.isFilter))) filteredSelectors.push(selector);
    else plainSelectors.push(selector);
    return [
        plainSelectors,
        filteredSelectors
    ];
}

});
parcelRegister("hbA8b", function(module, exports) {

$parcel$export(module.exports, "isFilter", () => $c82f7da15df629e7$export$b169a94581f05ec);
$parcel$export(module.exports, "getLimit", () => $c82f7da15df629e7$export$fb8ce379717a383d);
const $c82f7da15df629e7$export$899efafbba5f734f = new Set([
    "first",
    "last",
    "eq",
    "gt",
    "nth",
    "lt",
    "even",
    "odd"
]);
function $c82f7da15df629e7$export$b169a94581f05ec(s) {
    if (s.type !== "pseudo") return false;
    if ($c82f7da15df629e7$export$899efafbba5f734f.has(s.name)) return true;
    if (s.name === "not" && Array.isArray(s.data)) // Only consider `:not` with embedded filters
    return s.data.some((s)=>s.some($c82f7da15df629e7$export$b169a94581f05ec));
    return false;
}
function $c82f7da15df629e7$export$fb8ce379717a383d(filter, data, partLimit) {
    const num = data != null ? parseInt(data, 10) : NaN;
    switch(filter){
        case "first":
            return 1;
        case "nth":
        case "eq":
            return isFinite(num) ? num >= 0 ? num + 1 : Infinity : 0;
        case "lt":
            return isFinite(num) ? num >= 0 ? Math.min(num, partLimit) : Infinity : 0;
        case "gt":
            return isFinite(num) ? Infinity : 0;
        case "odd":
            return 2 * partLimit;
        case "even":
            return 2 * partLimit - 1;
        case "last":
        case "not":
            return Infinity;
    }
}

});




parcelRegister("7tPyY", function(module, exports) {

$parcel$export(module.exports, "_makeDomArray", () => _makeDomArray);
$parcel$export(module.exports, "appendTo", () => appendTo);
$parcel$export(module.exports, "prependTo", () => prependTo);
$parcel$export(module.exports, "append", () => append);
$parcel$export(module.exports, "prepend", () => prepend);
$parcel$export(module.exports, "wrap", () => wrap);
$parcel$export(module.exports, "wrapInner", () => wrapInner);
$parcel$export(module.exports, "unwrap", () => unwrap);
$parcel$export(module.exports, "wrapAll", () => wrapAll);
$parcel$export(module.exports, "after", () => after);
$parcel$export(module.exports, "insertAfter", () => insertAfter);
$parcel$export(module.exports, "before", () => before);
$parcel$export(module.exports, "insertBefore", () => insertBefore);
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "replaceWith", () => replaceWith);
$parcel$export(module.exports, "empty", () => empty);
$parcel$export(module.exports, "html", () => html);
$parcel$export(module.exports, "toString", () => toString);
$parcel$export(module.exports, "text", () => text);
$parcel$export(module.exports, "clone", () => clone);
/**
 * Methods for modifying the DOM structure.
 *
 * @module cheerio/manipulation
 */ parcelRequire("273yd");
var $k9MHs = parcelRequire("k9MHs");

var $dbuHA = parcelRequire("dbuHA");

var $8iuUi = parcelRequire("8iuUi");

var $2M1Qk = parcelRequire("2M1Qk");
var $k9MHs = parcelRequire("k9MHs");
parcelRequire("a45mF");
var $itbnG = parcelRequire("itbnG");
function _makeDomArray(elem, clone) {
    if (elem == null) return [];
    if ((0, $2M1Qk.isCheerio)(elem)) return clone ? (0, $2M1Qk.cloneDom)(elem.get()) : elem.get();
    if (Array.isArray(elem)) return elem.reduce((newElems, el)=>newElems.concat(this._makeDomArray(el, clone)), []);
    if (typeof elem === 'string') return this._parse(elem, this.options, false, null).children;
    return clone ? (0, $2M1Qk.cloneDom)([
        elem
    ]) : [
        elem
    ];
}
function _insert(concatenator) {
    return function(...elems) {
        const lastIdx = this.length - 1;
        return (0, $2M1Qk.domEach)(this, (el, i)=>{
            if (!(0, $k9MHs.hasChildren)(el)) return;
            const domSrc = typeof elems[0] === 'function' ? elems[0].call(el, i, this._render(el.children)) : elems;
            const dom = this._makeDomArray(domSrc, i < lastIdx);
            concatenator(dom, el.children, el);
        });
    };
}
/**
 * Modify an array in-place, removing some number of elements and adding new
 * elements directly following them.
 *
 * @private
 * @category Manipulation
 * @param array - Target array to splice.
 * @param spliceIdx - Index at which to begin changing the array.
 * @param spliceCount - Number of elements to remove from the array.
 * @param newElems - Elements to insert into the array.
 * @param parent - The parent of the node.
 * @returns The spliced array.
 */ function uniqueSplice(array, spliceIdx, spliceCount, newElems, parent) {
    var _a, _b;
    const spliceArgs = [
        spliceIdx,
        spliceCount,
        ...newElems
    ];
    const prev = spliceIdx === 0 ? null : array[spliceIdx - 1];
    const next = spliceIdx + spliceCount >= array.length ? null : array[spliceIdx + spliceCount];
    /*
     * Before splicing in new elements, ensure they do not already appear in the
     * current array.
     */ for(let idx = 0; idx < newElems.length; ++idx){
        const node = newElems[idx];
        const oldParent = node.parent;
        if (oldParent) {
            const oldSiblings = oldParent.children;
            const prevIdx = oldSiblings.indexOf(node);
            if (prevIdx > -1) {
                oldParent.children.splice(prevIdx, 1);
                if (parent === oldParent && spliceIdx > prevIdx) spliceArgs[0]--;
            }
        }
        node.parent = parent;
        if (node.prev) node.prev.next = (_a = node.next) !== null && _a !== void 0 ? _a : null;
        if (node.next) node.next.prev = (_b = node.prev) !== null && _b !== void 0 ? _b : null;
        node.prev = idx === 0 ? prev : newElems[idx - 1];
        node.next = idx === newElems.length - 1 ? next : newElems[idx + 1];
    }
    if (prev) prev.next = newElems[0];
    if (next) next.prev = newElems[newElems.length - 1];
    return array.splice(...spliceArgs);
}
function appendTo(target) {
    const appendTarget = (0, $2M1Qk.isCheerio)(target) ? target : this._make(target);
    appendTarget.append(this);
    return this;
}
function prependTo(target) {
    const prependTarget = (0, $2M1Qk.isCheerio)(target) ? target : this._make(target);
    prependTarget.prepend(this);
    return this;
}
const append = _insert((dom, children, parent)=>{
    uniqueSplice(children, children.length, 0, dom, parent);
});
const prepend = _insert((dom, children, parent)=>{
    uniqueSplice(children, 0, 0, dom, parent);
});
function _wrap(insert) {
    return function(wrapper) {
        const lastIdx = this.length - 1;
        const lastParent = this.parents().last();
        for(let i = 0; i < this.length; i++){
            const el = this[i];
            const wrap = typeof wrapper === 'function' ? wrapper.call(el, i, el) : typeof wrapper === 'string' && !(0, $2M1Qk.isHtml)(wrapper) ? lastParent.find(wrapper).clone() : wrapper;
            const [wrapperDom] = this._makeDomArray(wrap, i < lastIdx);
            if (!wrapperDom || !(0, $k9MHs.hasChildren)(wrapperDom)) continue;
            let elInsertLocation = wrapperDom;
            /*
             * Find the deepest child. Only consider the first tag child of each node
             * (ignore text); stop if no children are found.
             */ let j = 0;
            while(j < elInsertLocation.children.length){
                const child = elInsertLocation.children[j];
                if ((0, $k9MHs.isTag)(child)) {
                    elInsertLocation = child;
                    j = 0;
                } else j++;
            }
            insert(el, elInsertLocation, [
                wrapperDom
            ]);
        }
        return this;
    };
}
const wrap = _wrap((el, elInsertLocation, wrapperDom)=>{
    const { parent } = el;
    if (!parent) return;
    const siblings = parent.children;
    const index = siblings.indexOf(el);
    (0, $dbuHA.update)([
        el
    ], elInsertLocation);
    /*
     * The previous operation removed the current element from the `siblings`
     * array, so the `dom` array can be inserted without removing any
     * additional elements.
     */ uniqueSplice(siblings, index, 0, wrapperDom, parent);
});
const wrapInner = _wrap((el, elInsertLocation, wrapperDom)=>{
    if (!(0, $k9MHs.hasChildren)(el)) return;
    (0, $dbuHA.update)(el.children, elInsertLocation);
    (0, $dbuHA.update)(wrapperDom, el);
});
function unwrap(selector) {
    this.parent(selector).not('body').each((_, el)=>{
        this._make(el).replaceWith(el.children);
    });
    return this;
}
function wrapAll(wrapper) {
    const el = this[0];
    if (el) {
        const wrap = this._make(typeof wrapper === 'function' ? wrapper.call(el, 0, el) : wrapper).insertBefore(el);
        // If html is given as wrapper, wrap may contain text elements
        let elInsertLocation;
        for(let i = 0; i < wrap.length; i++)if (wrap[i].type === 'tag') elInsertLocation = wrap[i];
        let j = 0;
        /*
         * Find the deepest child. Only consider the first tag child of each node
         * (ignore text); stop if no children are found.
         */ while(elInsertLocation && j < elInsertLocation.children.length){
            const child = elInsertLocation.children[j];
            if (child.type === 'tag') {
                elInsertLocation = child;
                j = 0;
            } else j++;
        }
        if (elInsertLocation) this._make(elInsertLocation).append(this);
    }
    return this;
}
function after(...elems) {
    const lastIdx = this.length - 1;
    return (0, $2M1Qk.domEach)(this, (el, i)=>{
        const { parent } = el;
        if (!(0, $k9MHs.hasChildren)(el) || !parent) return;
        const siblings = parent.children;
        const index = siblings.indexOf(el);
        // If not found, move on
        /* istanbul ignore next */ if (index < 0) return;
        const domSrc = typeof elems[0] === 'function' ? elems[0].call(el, i, this._render(el.children)) : elems;
        const dom = this._makeDomArray(domSrc, i < lastIdx);
        // Add element after `this` element
        uniqueSplice(siblings, index + 1, 0, dom, parent);
    });
}
function insertAfter(target) {
    if (typeof target === 'string') target = this._make(target);
    this.remove();
    const clones = [];
    this._makeDomArray(target).forEach((el)=>{
        const clonedSelf = this.clone().toArray();
        const { parent } = el;
        if (!parent) return;
        const siblings = parent.children;
        const index = siblings.indexOf(el);
        // If not found, move on
        /* istanbul ignore next */ if (index < 0) return;
        // Add cloned `this` element(s) after target element
        uniqueSplice(siblings, index + 1, 0, clonedSelf, parent);
        clones.push(...clonedSelf);
    });
    return this._make(clones);
}
function before(...elems) {
    const lastIdx = this.length - 1;
    return (0, $2M1Qk.domEach)(this, (el, i)=>{
        const { parent } = el;
        if (!(0, $k9MHs.hasChildren)(el) || !parent) return;
        const siblings = parent.children;
        const index = siblings.indexOf(el);
        // If not found, move on
        /* istanbul ignore next */ if (index < 0) return;
        const domSrc = typeof elems[0] === 'function' ? elems[0].call(el, i, this._render(el.children)) : elems;
        const dom = this._makeDomArray(domSrc, i < lastIdx);
        // Add element before `el` element
        uniqueSplice(siblings, index, 0, dom, parent);
    });
}
function insertBefore(target) {
    const targetArr = this._make(target);
    this.remove();
    const clones = [];
    (0, $2M1Qk.domEach)(targetArr, (el)=>{
        const clonedSelf = this.clone().toArray();
        const { parent } = el;
        if (!parent) return;
        const siblings = parent.children;
        const index = siblings.indexOf(el);
        // If not found, move on
        /* istanbul ignore next */ if (index < 0) return;
        // Add cloned `this` element(s) after target element
        uniqueSplice(siblings, index, 0, clonedSelf, parent);
        clones.push(...clonedSelf);
    });
    return this._make(clones);
}
function remove(selector) {
    // Filter if we have selector
    const elems = selector ? this.filter(selector) : this;
    (0, $2M1Qk.domEach)(elems, (el)=>{
        (0, $itbnG.removeElement)(el);
        el.prev = el.next = el.parent = null;
    });
    return this;
}
function replaceWith(content) {
    return (0, $2M1Qk.domEach)(this, (el, i)=>{
        const { parent } = el;
        if (!parent) return;
        const siblings = parent.children;
        const cont = typeof content === 'function' ? content.call(el, i, el) : content;
        const dom = this._makeDomArray(cont);
        /*
         * In the case that `dom` contains nodes that already exist in other
         * structures, ensure those nodes are properly removed.
         */ (0, $dbuHA.update)(dom, null);
        const index = siblings.indexOf(el);
        // Completely remove old element
        uniqueSplice(siblings, index, 1, dom, parent);
        if (!dom.includes(el)) el.parent = el.prev = el.next = null;
    });
}
function empty() {
    return (0, $2M1Qk.domEach)(this, (el)=>{
        if (!(0, $k9MHs.hasChildren)(el)) return;
        el.children.forEach((child)=>{
            child.next = child.prev = child.parent = null;
        });
        el.children.length = 0;
    });
}
function html(str) {
    if (str === undefined) {
        const el = this[0];
        if (!el || !(0, $k9MHs.hasChildren)(el)) return null;
        return this._render(el.children);
    }
    return (0, $2M1Qk.domEach)(this, (el)=>{
        if (!(0, $k9MHs.hasChildren)(el)) return;
        el.children.forEach((child)=>{
            child.next = child.prev = child.parent = null;
        });
        const content = (0, $2M1Qk.isCheerio)(str) ? str.toArray() : this._parse(`${str}`, this.options, false, el).children;
        (0, $dbuHA.update)(content, el);
    });
}
function toString() {
    return this._render(this);
}
function text(str) {
    // If `str` is undefined, act as a "getter"
    if (str === undefined) return (0, $8iuUi.text)(this);
    if (typeof str === 'function') // Function support
    return (0, $2M1Qk.domEach)(this, (el, i)=>this._make(el).text(str.call(el, i, (0, $8iuUi.text)([
            el
        ]))));
    // Append text node to each selected elements
    return (0, $2M1Qk.domEach)(this, (el)=>{
        if (!(0, $k9MHs.hasChildren)(el)) return;
        el.children.forEach((child)=>{
            child.next = child.prev = child.parent = null;
        });
        const textNode = new (0, $k9MHs.Text)(`${str}`);
        (0, $dbuHA.update)(textNode, el);
    });
}
function clone() {
    return this._make((0, $2M1Qk.cloneDom)(this.get()));
}

});
parcelRegister("dbuHA", function(module, exports) {

$parcel$export(module.exports, "getParse", () => $99941e3efacd104e$export$c94b5dd2e133d87c);
$parcel$export(module.exports, "update", () => $99941e3efacd104e$export$722fbec263ad908a);
parcelRequire("a45mF");
var $itbnG = parcelRequire("itbnG");
parcelRequire("273yd");
var $k9MHs = parcelRequire("k9MHs");

var $N0o3H = parcelRequire("N0o3H");
var $99941e3efacd104e$require$Buffer = $N0o3H.Buffer;
function $99941e3efacd104e$export$c94b5dd2e133d87c(parser) {
    /**
     * Parse a HTML string or a node.
     *
     * @param content - The HTML string or node.
     * @param options - The parser options.
     * @param isDocument - If `content` is a document.
     * @param context - The context node in the DOM tree.
     * @returns The parsed document node.
     */ return function parse(content, options, isDocument, context) {
        if (typeof $99941e3efacd104e$require$Buffer !== 'undefined' && $99941e3efacd104e$require$Buffer.isBuffer(content)) content = content.toString();
        if (typeof content === 'string') return parser(content, options, isDocument, context);
        const doc = content;
        if (!Array.isArray(doc) && (0, $k9MHs.isDocument)(doc)) // If `doc` is already a root, just return it
        return doc;
        // Add conent to new root element
        const root = new (0, $k9MHs.Document)([]);
        // Update the DOM using the root
        $99941e3efacd104e$export$722fbec263ad908a(doc, root);
        return root;
    };
}
function $99941e3efacd104e$export$722fbec263ad908a(newChilds, parent) {
    // Normalize
    const arr = Array.isArray(newChilds) ? newChilds : [
        newChilds
    ];
    // Update parent
    if (parent) parent.children = arr;
    else parent = null;
    // Update neighbors
    for(let i = 0; i < arr.length; i++){
        const node = arr[i];
        // Cleanly remove existing nodes from their previous structures.
        if (node.parent && node.parent.children !== arr) (0, $itbnG.removeElement)(node);
        if (parent) {
            node.prev = arr[i - 1] || null;
            node.next = arr[i + 1] || null;
        } else node.prev = node.next = null;
        node.parent = parent;
    }
    return parent;
}

});
parcelRegister("N0o3H", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $0934e0939605d48c$export$a143d493d941bafc, (v) => $0934e0939605d48c$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $0934e0939605d48c$export$f99ded8fe4b79145, (v) => $0934e0939605d48c$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $0934e0939605d48c$export$a143d493d941bafc;
var $0934e0939605d48c$export$e4cf37d7f6fb9e0a;
var $0934e0939605d48c$export$f99ded8fe4b79145;
var $0934e0939605d48c$export$599f31c3813fae4d;
'use strict';

var $bQMRt = parcelRequire("bQMRt");

var $dbnIE = parcelRequire("dbnIE");
const $0934e0939605d48c$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$0934e0939605d48c$export$a143d493d941bafc = $0934e0939605d48c$var$Buffer;
$0934e0939605d48c$export$e4cf37d7f6fb9e0a = $0934e0939605d48c$var$SlowBuffer;
$0934e0939605d48c$export$f99ded8fe4b79145 = 50;
const $0934e0939605d48c$var$K_MAX_LENGTH = 0x7fffffff;
$0934e0939605d48c$export$599f31c3813fae4d = $0934e0939605d48c$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $0934e0939605d48c$var$Buffer.TYPED_ARRAY_SUPPORT = $0934e0939605d48c$var$typedArraySupport();
if (!$0934e0939605d48c$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $0934e0939605d48c$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($0934e0939605d48c$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$0934e0939605d48c$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($0934e0939605d48c$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$0934e0939605d48c$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $0934e0939605d48c$var$createBuffer(length) {
    if (length > $0934e0939605d48c$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $0934e0939605d48c$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $0934e0939605d48c$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $0934e0939605d48c$var$allocUnsafe(arg);
    }
    return $0934e0939605d48c$var$from(arg, encodingOrOffset, length);
}
$0934e0939605d48c$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $0934e0939605d48c$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $0934e0939605d48c$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $0934e0939605d48c$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($0934e0939605d48c$var$isInstance(value, ArrayBuffer) || value && $0934e0939605d48c$var$isInstance(value.buffer, ArrayBuffer)) return $0934e0939605d48c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($0934e0939605d48c$var$isInstance(value, SharedArrayBuffer) || value && $0934e0939605d48c$var$isInstance(value.buffer, SharedArrayBuffer))) return $0934e0939605d48c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $0934e0939605d48c$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $0934e0939605d48c$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $0934e0939605d48c$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $0934e0939605d48c$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $0934e0939605d48c$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($0934e0939605d48c$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($0934e0939605d48c$var$Buffer, Uint8Array);
function $0934e0939605d48c$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $0934e0939605d48c$var$alloc(size, fill, encoding) {
    $0934e0939605d48c$var$assertSize(size);
    if (size <= 0) return $0934e0939605d48c$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $0934e0939605d48c$var$createBuffer(size).fill(fill, encoding) : $0934e0939605d48c$var$createBuffer(size).fill(fill);
    return $0934e0939605d48c$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $0934e0939605d48c$var$Buffer.alloc = function(size, fill, encoding) {
    return $0934e0939605d48c$var$alloc(size, fill, encoding);
};
function $0934e0939605d48c$var$allocUnsafe(size) {
    $0934e0939605d48c$var$assertSize(size);
    return $0934e0939605d48c$var$createBuffer(size < 0 ? 0 : $0934e0939605d48c$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $0934e0939605d48c$var$Buffer.allocUnsafe = function(size) {
    return $0934e0939605d48c$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $0934e0939605d48c$var$Buffer.allocUnsafeSlow = function(size) {
    return $0934e0939605d48c$var$allocUnsafe(size);
};
function $0934e0939605d48c$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$0934e0939605d48c$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $0934e0939605d48c$var$byteLength(string, encoding) | 0;
    let buf = $0934e0939605d48c$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $0934e0939605d48c$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $0934e0939605d48c$var$checked(array.length) | 0;
    const buf = $0934e0939605d48c$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $0934e0939605d48c$var$fromArrayView(arrayView) {
    if ($0934e0939605d48c$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $0934e0939605d48c$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $0934e0939605d48c$var$fromArrayLike(arrayView);
}
function $0934e0939605d48c$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $0934e0939605d48c$var$Buffer.prototype);
    return buf;
}
function $0934e0939605d48c$var$fromObject(obj) {
    if ($0934e0939605d48c$var$Buffer.isBuffer(obj)) {
        const len = $0934e0939605d48c$var$checked(obj.length) | 0;
        const buf = $0934e0939605d48c$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $0934e0939605d48c$var$numberIsNaN(obj.length)) return $0934e0939605d48c$var$createBuffer(0);
        return $0934e0939605d48c$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $0934e0939605d48c$var$fromArrayLike(obj.data);
}
function $0934e0939605d48c$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $0934e0939605d48c$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $0934e0939605d48c$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $0934e0939605d48c$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $0934e0939605d48c$var$Buffer.alloc(+length);
}
$0934e0939605d48c$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $0934e0939605d48c$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$0934e0939605d48c$var$Buffer.compare = function compare(a, b) {
    if ($0934e0939605d48c$var$isInstance(a, Uint8Array)) a = $0934e0939605d48c$var$Buffer.from(a, a.offset, a.byteLength);
    if ($0934e0939605d48c$var$isInstance(b, Uint8Array)) b = $0934e0939605d48c$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$0934e0939605d48c$var$Buffer.isBuffer(a) || !$0934e0939605d48c$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$0934e0939605d48c$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$0934e0939605d48c$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $0934e0939605d48c$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $0934e0939605d48c$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($0934e0939605d48c$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) buf = $0934e0939605d48c$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $0934e0939605d48c$var$byteLength(string, encoding) {
    if ($0934e0939605d48c$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $0934e0939605d48c$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $0934e0939605d48c$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $0934e0939605d48c$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $0934e0939605d48c$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$0934e0939605d48c$var$Buffer.byteLength = $0934e0939605d48c$var$byteLength;
function $0934e0939605d48c$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $0934e0939605d48c$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $0934e0939605d48c$var$utf8Slice(this, start, end);
        case 'ascii':
            return $0934e0939605d48c$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $0934e0939605d48c$var$latin1Slice(this, start, end);
        case 'base64':
            return $0934e0939605d48c$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $0934e0939605d48c$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$0934e0939605d48c$var$Buffer.prototype._isBuffer = true;
function $0934e0939605d48c$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$0934e0939605d48c$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$0934e0939605d48c$var$swap(this, i, i + 1);
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $0934e0939605d48c$var$swap(this, i, i + 3);
        $0934e0939605d48c$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $0934e0939605d48c$var$swap(this, i, i + 7);
        $0934e0939605d48c$var$swap(this, i + 1, i + 6);
        $0934e0939605d48c$var$swap(this, i + 2, i + 5);
        $0934e0939605d48c$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $0934e0939605d48c$var$utf8Slice(this, 0, length);
    return $0934e0939605d48c$var$slowToString.apply(this, arguments);
};
$0934e0939605d48c$var$Buffer.prototype.toLocaleString = $0934e0939605d48c$var$Buffer.prototype.toString;
$0934e0939605d48c$var$Buffer.prototype.equals = function equals(b) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $0934e0939605d48c$var$Buffer.compare(this, b) === 0;
};
$0934e0939605d48c$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $0934e0939605d48c$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($0934e0939605d48c$var$customInspectSymbol) $0934e0939605d48c$var$Buffer.prototype[$0934e0939605d48c$var$customInspectSymbol] = $0934e0939605d48c$var$Buffer.prototype.inspect;
$0934e0939605d48c$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($0934e0939605d48c$var$isInstance(target, Uint8Array)) target = $0934e0939605d48c$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$0934e0939605d48c$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $0934e0939605d48c$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($0934e0939605d48c$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $0934e0939605d48c$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($0934e0939605d48c$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $0934e0939605d48c$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $0934e0939605d48c$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $0934e0939605d48c$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$0934e0939605d48c$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$0934e0939605d48c$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $0934e0939605d48c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$0934e0939605d48c$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $0934e0939605d48c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $0934e0939605d48c$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($0934e0939605d48c$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $0934e0939605d48c$var$utf8Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $0934e0939605d48c$var$asciiWrite(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$asciiToBytes(string), buf, offset, length);
}
function $0934e0939605d48c$var$base64Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$base64ToBytes(string), buf, offset, length);
}
function $0934e0939605d48c$var$ucs2Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$0934e0939605d48c$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $0934e0939605d48c$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $0934e0939605d48c$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $0934e0939605d48c$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $0934e0939605d48c$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $0934e0939605d48c$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$0934e0939605d48c$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $0934e0939605d48c$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $bQMRt.fromByteArray(buf);
    else return $bQMRt.fromByteArray(buf.slice(start, end));
}
function $0934e0939605d48c$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $0934e0939605d48c$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $0934e0939605d48c$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $0934e0939605d48c$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $0934e0939605d48c$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $0934e0939605d48c$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $0934e0939605d48c$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $0934e0939605d48c$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$0934e0939605d48c$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $0934e0939605d48c$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $0934e0939605d48c$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$0934e0939605d48c$var$Buffer.prototype.readUintLE = $0934e0939605d48c$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readUintBE = $0934e0939605d48c$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readUint8 = $0934e0939605d48c$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$0934e0939605d48c$var$Buffer.prototype.readUint16LE = $0934e0939605d48c$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$0934e0939605d48c$var$Buffer.prototype.readUint16BE = $0934e0939605d48c$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$0934e0939605d48c$var$Buffer.prototype.readUint32LE = $0934e0939605d48c$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$0934e0939605d48c$var$Buffer.prototype.readUint32BE = $0934e0939605d48c$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$0934e0939605d48c$var$Buffer.prototype.readBigUInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$0934e0939605d48c$var$Buffer.prototype.readBigUInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$0934e0939605d48c$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$0934e0939605d48c$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$0934e0939605d48c$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$0934e0939605d48c$var$Buffer.prototype.readBigInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$0934e0939605d48c$var$Buffer.prototype.readBigInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$0934e0939605d48c$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return $dbnIE.read(this, offset, true, 23, 4);
};
$0934e0939605d48c$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return $dbnIE.read(this, offset, false, 23, 4);
};
$0934e0939605d48c$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 8, this.length);
    return $dbnIE.read(this, offset, true, 52, 8);
};
$0934e0939605d48c$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 8, this.length);
    return $dbnIE.read(this, offset, false, 52, 8);
};
function $0934e0939605d48c$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$0934e0939605d48c$var$Buffer.prototype.writeUintLE = $0934e0939605d48c$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeUintBE = $0934e0939605d48c$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint8 = $0934e0939605d48c$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint16LE = $0934e0939605d48c$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint16BE = $0934e0939605d48c$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint32LE = $0934e0939605d48c$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint32BE = $0934e0939605d48c$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $0934e0939605d48c$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $0934e0939605d48c$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$0934e0939605d48c$var$Buffer.prototype.writeBigUInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$0934e0939605d48c$var$Buffer.prototype.writeBigUInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$0934e0939605d48c$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeBigInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$0934e0939605d48c$var$Buffer.prototype.writeBigInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $0934e0939605d48c$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $0934e0939605d48c$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $dbnIE.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$0934e0939605d48c$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeFloat(this, value, offset, true, noAssert);
};
$0934e0939605d48c$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeFloat(this, value, offset, false, noAssert);
};
function $0934e0939605d48c$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $dbnIE.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$0934e0939605d48c$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeDouble(this, value, offset, true, noAssert);
};
$0934e0939605d48c$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$0934e0939605d48c$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$0934e0939605d48c$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$0934e0939605d48c$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $0934e0939605d48c$var$Buffer.isBuffer(val) ? val : $0934e0939605d48c$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $0934e0939605d48c$var$errors = {};
function $0934e0939605d48c$var$E(sym, getMessage, Base) {
    $0934e0939605d48c$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$0934e0939605d48c$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$0934e0939605d48c$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$0934e0939605d48c$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $0934e0939605d48c$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $0934e0939605d48c$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $0934e0939605d48c$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $0934e0939605d48c$var$checkBounds(buf, offset, byteLength) {
    $0934e0939605d48c$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $0934e0939605d48c$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $0934e0939605d48c$var$checkBounds(buf, offset, byteLength);
}
function $0934e0939605d48c$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $0934e0939605d48c$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $0934e0939605d48c$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $0934e0939605d48c$var$validateNumber(value, type);
        throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $0934e0939605d48c$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $0934e0939605d48c$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $0934e0939605d48c$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($0934e0939605d48c$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $0934e0939605d48c$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $0934e0939605d48c$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $0934e0939605d48c$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $0934e0939605d48c$var$base64ToBytes(str) {
    return $bQMRt.toByteArray($0934e0939605d48c$var$base64clean(str));
}
function $0934e0939605d48c$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $0934e0939605d48c$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $0934e0939605d48c$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $0934e0939605d48c$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $0934e0939605d48c$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $0934e0939605d48c$var$BufferBigIntNotDefined : fn;
}
function $0934e0939605d48c$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("bQMRt", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $8a0a73e6b73fd0c4$export$d622b2ad8d90c771, (v) => $8a0a73e6b73fd0c4$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $8a0a73e6b73fd0c4$export$6100ba28696e12de, (v) => $8a0a73e6b73fd0c4$export$6100ba28696e12de = v);
var $8a0a73e6b73fd0c4$export$a48f0734ac7c2329;
var $8a0a73e6b73fd0c4$export$d622b2ad8d90c771;
var $8a0a73e6b73fd0c4$export$6100ba28696e12de;
'use strict';
$8a0a73e6b73fd0c4$export$a48f0734ac7c2329 = $8a0a73e6b73fd0c4$var$byteLength;
$8a0a73e6b73fd0c4$export$d622b2ad8d90c771 = $8a0a73e6b73fd0c4$var$toByteArray;
$8a0a73e6b73fd0c4$export$6100ba28696e12de = $8a0a73e6b73fd0c4$var$fromByteArray;
var $8a0a73e6b73fd0c4$var$lookup = [];
var $8a0a73e6b73fd0c4$var$revLookup = [];
var $8a0a73e6b73fd0c4$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $8a0a73e6b73fd0c4$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $8a0a73e6b73fd0c4$var$i = 0, $8a0a73e6b73fd0c4$var$len = $8a0a73e6b73fd0c4$var$code.length; $8a0a73e6b73fd0c4$var$i < $8a0a73e6b73fd0c4$var$len; ++$8a0a73e6b73fd0c4$var$i){
    $8a0a73e6b73fd0c4$var$lookup[$8a0a73e6b73fd0c4$var$i] = $8a0a73e6b73fd0c4$var$code[$8a0a73e6b73fd0c4$var$i];
    $8a0a73e6b73fd0c4$var$revLookup[$8a0a73e6b73fd0c4$var$code.charCodeAt($8a0a73e6b73fd0c4$var$i)] = $8a0a73e6b73fd0c4$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$8a0a73e6b73fd0c4$var$revLookup['-'.charCodeAt(0)] = 62;
$8a0a73e6b73fd0c4$var$revLookup['_'.charCodeAt(0)] = 63;
function $8a0a73e6b73fd0c4$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $8a0a73e6b73fd0c4$var$byteLength(b64) {
    var lens = $8a0a73e6b73fd0c4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8a0a73e6b73fd0c4$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8a0a73e6b73fd0c4$var$toByteArray(b64) {
    var tmp;
    var lens = $8a0a73e6b73fd0c4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $8a0a73e6b73fd0c4$var$Arr($8a0a73e6b73fd0c4$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 18 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 2 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 10 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $8a0a73e6b73fd0c4$var$tripletToBase64(num) {
    return $8a0a73e6b73fd0c4$var$lookup[num >> 18 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num >> 12 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num >> 6 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num & 0x3F];
}
function $8a0a73e6b73fd0c4$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($8a0a73e6b73fd0c4$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $8a0a73e6b73fd0c4$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($8a0a73e6b73fd0c4$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($8a0a73e6b73fd0c4$var$lookup[tmp >> 2] + $8a0a73e6b73fd0c4$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($8a0a73e6b73fd0c4$var$lookup[tmp >> 10] + $8a0a73e6b73fd0c4$var$lookup[tmp >> 4 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("dbnIE", function(module, exports) {

$parcel$export(module.exports, "read", () => $998eb38f4d082829$export$aafa59e2e03f2942, (v) => $998eb38f4d082829$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $998eb38f4d082829$export$68d8715fc104d294, (v) => $998eb38f4d082829$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $998eb38f4d082829$export$aafa59e2e03f2942;
var $998eb38f4d082829$export$68d8715fc104d294;
$998eb38f4d082829$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$998eb38f4d082829$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});




parcelRegister("8pn8k", function(module, exports) {

$parcel$export(module.exports, "serialize", () => serialize);
$parcel$export(module.exports, "serializeArray", () => serializeArray);
parcelRequire("2M1Qk");
var $k9MHs = parcelRequire("k9MHs");
/*
 * https://github.com/jquery/jquery/blob/2.1.3/src/manipulation/var/rcheckableType.js
 * https://github.com/jquery/jquery/blob/2.1.3/src/serialize.js
 */ const submittableSelector = 'input,select,textarea,keygen';
const r20 = /%20/g;
const rCRLF = /\r?\n/g;
function serialize() {
    // Convert form elements into name/value objects
    const arr = this.serializeArray();
    // Serialize each element into a key/value string
    const retArr = arr.map((data)=>`${encodeURIComponent(data.name)}=${encodeURIComponent(data.value)}`);
    // Return the resulting serialization
    return retArr.join('&').replace(r20, '+');
}
function serializeArray() {
    // Resolve all form elements from either forms or collections of form elements
    return this.map((_, elem)=>{
        const $elem = this._make(elem);
        if ((0, $k9MHs.isTag)(elem) && elem.name === 'form') return $elem.find(submittableSelector).toArray();
        return $elem.filter(submittableSelector).toArray();
    }).filter(// Verify elements have a name (`attr.name`) and are not disabled (`:enabled`)
    '[name!=""]:enabled:not(:submit, :button, :image, :reset, :file):matches([checked], :not(:checkbox, :radio))').map((_, elem)=>{
        var _a;
        const $elem = this._make(elem);
        const name = $elem.attr('name'); // We have filtered for elements with a name before.
        // If there is no value set (e.g. `undefined`, `null`), then default value to empty
        const value = (_a = $elem.val()) !== null && _a !== void 0 ? _a : '';
        // If we have an array of values (e.g. `<select multiple>`), return an array of key/value pairs
        if (Array.isArray(value)) return value.map((val)=>/*
             * We trim replace any line endings (e.g. `\r` or `\r\n` with `\r\n`) to guarantee consistency across platforms
             * These can occur inside of `<textarea>'s`
             */ ({
                name: name,
                value: val.replace(rCRLF, '\r\n')
            }));
        // Otherwise (e.g. `<input type="text">`, return only one key/value pair
        return {
            name: name,
            value: value.replace(rCRLF, '\r\n')
        };
    }).toArray();
}

});

parcelRegister("5sG9R", function(module, exports) {
"use strict";
// Generated using scripts/write-decode-map.ts
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = new Uint16Array(// prettier-ignore
"\u1d41<\xd5\u0131\u028a\u049d\u057b\u05d0\u0675\u06de\u07a2\u07d6\u080f\u0a4a\u0a91\u0da1\u0e6d\u0f09\u0f26\u10ca\u1228\u12e1\u1415\u149d\u14c3\u14df\u1525\0\0\0\0\0\0\u156b\u16cd\u198d\u1c12\u1ddd\u1f7e\u2060\u21b0\u228d\u23c0\u23fb\u2442\u2824\u2912\u2d08\u2e48\u2fce\u3016\u32ba\u3639\u37ac\u38fe\u3a28\u3a71\u3ae0\u3b2e\u0800EMabcfglmnoprstu\\bfms\x7f\x84\x8b\x90\x95\x98\xa6\xb3\xb9\xc8\xcflig\u803b\xc6\u40c6P\u803b&\u4026cute\u803b\xc1\u40c1reve;\u4102\u0100iyx}rc\u803b\xc2\u40c2;\u4410r;\uc000\ud835\udd04rave\u803b\xc0\u40c0pha;\u4391acr;\u4100d;\u6a53\u0100gp\x9d\xa1on;\u4104f;\uc000\ud835\udd38plyFunction;\u6061ing\u803b\xc5\u40c5\u0100cs\xbe\xc3r;\uc000\ud835\udc9cign;\u6254ilde\u803b\xc3\u40c3ml\u803b\xc4\u40c4\u0400aceforsu\xe5\xfb\xfe\u0117\u011c\u0122\u0127\u012a\u0100cr\xea\xf2kslash;\u6216\u0176\xf6\xf8;\u6ae7ed;\u6306y;\u4411\u0180crt\u0105\u010b\u0114ause;\u6235noullis;\u612ca;\u4392r;\uc000\ud835\udd05pf;\uc000\ud835\udd39eve;\u42d8c\xf2\u0113mpeq;\u624e\u0700HOacdefhilorsu\u014d\u0151\u0156\u0180\u019e\u01a2\u01b5\u01b7\u01ba\u01dc\u0215\u0273\u0278\u027ecy;\u4427PY\u803b\xa9\u40a9\u0180cpy\u015d\u0162\u017aute;\u4106\u0100;i\u0167\u0168\u62d2talDifferentialD;\u6145leys;\u612d\u0200aeio\u0189\u018e\u0194\u0198ron;\u410cdil\u803b\xc7\u40c7rc;\u4108nint;\u6230ot;\u410a\u0100dn\u01a7\u01adilla;\u40b8terDot;\u40b7\xf2\u017fi;\u43a7rcle\u0200DMPT\u01c7\u01cb\u01d1\u01d6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01e2\u01f8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020foubleQuote;\u601duote;\u6019\u0200lnpu\u021e\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6a74\u0180git\u022f\u0236\u023aruent;\u6261nt;\u622fourIntegral;\u622e\u0100fr\u024c\u024e;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6a2fcr;\uc000\ud835\udc9ep\u0100;C\u0284\u0285\u62d3ap;\u624d\u0580DJSZacefios\u02a0\u02ac\u02b0\u02b4\u02b8\u02cb\u02d7\u02e1\u02e6\u0333\u048d\u0100;o\u0179\u02a5trahd;\u6911cy;\u4402cy;\u4405cy;\u440f\u0180grs\u02bf\u02c4\u02c7ger;\u6021r;\u61a1hv;\u6ae4\u0100ay\u02d0\u02d5ron;\u410e;\u4414l\u0100;t\u02dd\u02de\u6207a;\u4394r;\uc000\ud835\udd07\u0100af\u02eb\u0327\u0100cm\u02f0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031ccute;\u40b4o\u0174\u030b\u030d;\u42d9bleAcute;\u42ddrave;\u4060ilde;\u42dcond;\u62c4ferentialD;\u6146\u0470\u033d\0\0\0\u0342\u0354\0\u0405f;\uc000\ud835\udd3b\u0180;DE\u0348\u0349\u034d\u40a8ot;\u60dcqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03cf\u03e2\u03f8ontourIntegra\xec\u0239o\u0274\u0379\0\0\u037b\xbb\u0349nArrow;\u61d3\u0100eo\u0387\u03a4ft\u0180ART\u0390\u0396\u03a1rrow;\u61d0ightArrow;\u61d4e\xe5\u02cang\u0100LR\u03ab\u03c4eft\u0100AR\u03b3\u03b9rrow;\u67f8ightArrow;\u67faightArrow;\u67f9ight\u0100AT\u03d8\u03derrow;\u61d2ee;\u62a8p\u0241\u03e9\0\0\u03efrrow;\u61d1ownArrow;\u61d5erticalBar;\u6225n\u0300ABLRTa\u0412\u042a\u0430\u045e\u047f\u037crrow\u0180;BU\u041d\u041e\u0422\u6193ar;\u6913pArrow;\u61f5reve;\u4311eft\u02d2\u043a\0\u0446\0\u0450ightVector;\u6950eeVector;\u695eector\u0100;B\u0459\u045a\u61bdar;\u6956ight\u01d4\u0467\0\u0471eeVector;\u695fector\u0100;B\u047a\u047b\u61c1ar;\u6957ee\u0100;A\u0486\u0487\u62a4rrow;\u61a7\u0100ct\u0492\u0497r;\uc000\ud835\udc9frok;\u4110\u0800NTacdfglmopqstux\u04bd\u04c0\u04c4\u04cb\u04de\u04e2\u04e7\u04ee\u04f5\u0521\u052f\u0536\u0552\u055d\u0560\u0565G;\u414aH\u803b\xd0\u40d0cute\u803b\xc9\u40c9\u0180aiy\u04d2\u04d7\u04dcron;\u411arc\u803b\xca\u40ca;\u442dot;\u4116r;\uc000\ud835\udd08rave\u803b\xc8\u40c8ement;\u6208\u0100ap\u04fa\u04fecr;\u4112ty\u0253\u0506\0\0\u0512mallSquare;\u65fberySmallSquare;\u65ab\u0100gp\u0526\u052aon;\u4118f;\uc000\ud835\udd3csilon;\u4395u\u0100ai\u053c\u0549l\u0100;T\u0542\u0543\u6a75ilde;\u6242librium;\u61cc\u0100ci\u0557\u055ar;\u6130m;\u6a73a;\u4397ml\u803b\xcb\u40cb\u0100ip\u056a\u056fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058d\u05b2\u05ccy;\u4424r;\uc000\ud835\udd09lled\u0253\u0597\0\0\u05a3mallSquare;\u65fcerySmallSquare;\u65aa\u0370\u05ba\0\u05bf\0\0\u05c4f;\uc000\ud835\udd3dAll;\u6200riertrf;\u6131c\xf2\u05cb\u0600JTabcdfgorst\u05e8\u05ec\u05ef\u05fa\u0600\u0612\u0616\u061b\u061d\u0623\u066c\u0672cy;\u4403\u803b>\u403emma\u0100;d\u05f7\u05f8\u4393;\u43dcreve;\u411e\u0180eiy\u0607\u060c\u0610dil;\u4122rc;\u411c;\u4413ot;\u4120r;\uc000\ud835\udd0a;\u62d9pf;\uc000\ud835\udd3eeater\u0300EFGLST\u0635\u0644\u064e\u0656\u065b\u0666qual\u0100;L\u063e\u063f\u6265ess;\u62dbullEqual;\u6267reater;\u6aa2ess;\u6277lantEqual;\u6a7eilde;\u6273cr;\uc000\ud835\udca2;\u626b\u0400Aacfiosu\u0685\u068b\u0696\u069b\u069e\u06aa\u06be\u06caRDcy;\u442a\u0100ct\u0690\u0694ek;\u42c7;\u405eirc;\u4124r;\u610clbertSpace;\u610b\u01f0\u06af\0\u06b2f;\u610dizontalLine;\u6500\u0100ct\u06c3\u06c5\xf2\u06a9rok;\u4126mp\u0144\u06d0\u06d8ownHum\xf0\u012fqual;\u624f\u0700EJOacdfgmnostu\u06fa\u06fe\u0703\u0707\u070e\u071a\u071e\u0721\u0728\u0744\u0778\u078b\u078f\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803b\xcd\u40cd\u0100iy\u0713\u0718rc\u803b\xce\u40ce;\u4418ot;\u4130r;\u6111rave\u803b\xcc\u40cc\u0180;ap\u0720\u072f\u073f\u0100cg\u0734\u0737r;\u412ainaryI;\u6148lie\xf3\u03dd\u01f4\u0749\0\u0762\u0100;e\u074d\u074e\u622c\u0100gr\u0753\u0758ral;\u622bsection;\u62c2isible\u0100CT\u076c\u0772omma;\u6063imes;\u6062\u0180gpt\u077f\u0783\u0788on;\u412ef;\uc000\ud835\udd40a;\u4399cr;\u6110ilde;\u4128\u01eb\u079a\0\u079ecy;\u4406l\u803b\xcf\u40cf\u0280cfosu\u07ac\u07b7\u07bc\u07c2\u07d0\u0100iy\u07b1\u07b5rc;\u4134;\u4419r;\uc000\ud835\udd0dpf;\uc000\ud835\udd41\u01e3\u07c7\0\u07ccr;\uc000\ud835\udca5rcy;\u4408kcy;\u4404\u0380HJacfos\u07e4\u07e8\u07ec\u07f1\u07fd\u0802\u0808cy;\u4425cy;\u440cppa;\u439a\u0100ey\u07f6\u07fbdil;\u4136;\u441ar;\uc000\ud835\udd0epf;\uc000\ud835\udd42cr;\uc000\ud835\udca6\u0580JTaceflmost\u0825\u0829\u082c\u0850\u0863\u09b3\u09b8\u09c7\u09cd\u0a37\u0a47cy;\u4409\u803b<\u403c\u0280cmnpr\u0837\u083c\u0841\u0844\u084dute;\u4139bda;\u439bg;\u67ealacetrf;\u6112r;\u619e\u0180aey\u0857\u085c\u0861ron;\u413ddil;\u413b;\u441b\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087e\u08a9\u08b1\u08e0\u08e6\u08fc\u092f\u095b\u0390\u096a\u0100nr\u0883\u088fgleBracket;\u67e8row\u0180;BR\u0899\u089a\u089e\u6190ar;\u61e4ightArrow;\u61c6eiling;\u6308o\u01f5\u08b7\0\u08c3bleBracket;\u67e6n\u01d4\u08c8\0\u08d2eeVector;\u6961ector\u0100;B\u08db\u08dc\u61c3ar;\u6959loor;\u630aight\u0100AV\u08ef\u08f5rrow;\u6194ector;\u694e\u0100er\u0901\u0917e\u0180;AV\u0909\u090a\u0910\u62a3rrow;\u61a4ector;\u695aiangle\u0180;BE\u0924\u0925\u0929\u62b2ar;\u69cfqual;\u62b4p\u0180DTV\u0937\u0942\u094cownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61bfar;\u6958ector\u0100;B\u0965\u0966\u61bcar;\u6952ight\xe1\u039cs\u0300EFGLST\u097e\u098b\u0995\u099d\u09a2\u09adqualGreater;\u62daullEqual;\u6266reater;\u6276ess;\u6aa1lantEqual;\u6a7dilde;\u6272r;\uc000\ud835\udd0f\u0100;e\u09bd\u09be\u62d8ftarrow;\u61daidot;\u413f\u0180npw\u09d4\u0a16\u0a1bg\u0200LRlr\u09de\u09f7\u0a02\u0a10eft\u0100AR\u09e6\u09ecrrow;\u67f5ightArrow;\u67f7ightArrow;\u67f6eft\u0100ar\u03b3\u0a0aight\xe1\u03bfight\xe1\u03caf;\uc000\ud835\udd43er\u0100LR\u0a22\u0a2ceftArrow;\u6199ightArrow;\u6198\u0180cht\u0a3e\u0a40\u0a42\xf2\u084c;\u61b0rok;\u4141;\u626a\u0400acefiosu\u0a5a\u0a5d\u0a60\u0a77\u0a7c\u0a85\u0a8b\u0a8ep;\u6905y;\u441c\u0100dl\u0a65\u0a6fiumSpace;\u605flintrf;\u6133r;\uc000\ud835\udd10nusPlus;\u6213pf;\uc000\ud835\udd44c\xf2\u0a76;\u439c\u0480Jacefostu\u0aa3\u0aa7\u0aad\u0ac0\u0b14\u0b19\u0d91\u0d97\u0d9ecy;\u440acute;\u4143\u0180aey\u0ab4\u0ab9\u0aberon;\u4147dil;\u4145;\u441d\u0180gsw\u0ac7\u0af0\u0b0eative\u0180MTV\u0ad3\u0adf\u0ae8ediumSpace;\u600bhi\u0100cn\u0ae6\u0ad8\xeb\u0ad9eryThi\xee\u0ad9ted\u0100GL\u0af8\u0b06reaterGreate\xf2\u0673essLes\xf3\u0a48Line;\u400ar;\uc000\ud835\udd11\u0200Bnpt\u0b22\u0b28\u0b37\u0b3areak;\u6060BreakingSpace;\u40a0f;\u6115\u0680;CDEGHLNPRSTV\u0b55\u0b56\u0b6a\u0b7c\u0ba1\u0beb\u0c04\u0c5e\u0c84\u0ca6\u0cd8\u0d61\u0d85\u6aec\u0100ou\u0b5b\u0b64ngruent;\u6262pCap;\u626doubleVerticalBar;\u6226\u0180lqx\u0b83\u0b8a\u0b9bement;\u6209ual\u0100;T\u0b92\u0b93\u6260ilde;\uc000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0bb6\u0bb7\u0bbd\u0bc9\u0bd3\u0bd8\u0be5\u626fqual;\u6271ullEqual;\uc000\u2267\u0338reater;\uc000\u226b\u0338ess;\u6279lantEqual;\uc000\u2a7e\u0338ilde;\u6275ump\u0144\u0bf2\u0bfdownHump;\uc000\u224e\u0338qual;\uc000\u224f\u0338e\u0100fs\u0c0a\u0c27tTriangle\u0180;BE\u0c1a\u0c1b\u0c21\u62eaar;\uc000\u29cf\u0338qual;\u62ecs\u0300;EGLST\u0c35\u0c36\u0c3c\u0c44\u0c4b\u0c58\u626equal;\u6270reater;\u6278ess;\uc000\u226a\u0338lantEqual;\uc000\u2a7d\u0338ilde;\u6274ested\u0100GL\u0c68\u0c79reaterGreater;\uc000\u2aa2\u0338essLess;\uc000\u2aa1\u0338recedes\u0180;ES\u0c92\u0c93\u0c9b\u6280qual;\uc000\u2aaf\u0338lantEqual;\u62e0\u0100ei\u0cab\u0cb9verseElement;\u620cghtTriangle\u0180;BE\u0ccb\u0ccc\u0cd2\u62ebar;\uc000\u29d0\u0338qual;\u62ed\u0100qu\u0cdd\u0d0cuareSu\u0100bp\u0ce8\u0cf9set\u0100;E\u0cf0\u0cf3\uc000\u228f\u0338qual;\u62e2erset\u0100;E\u0d03\u0d06\uc000\u2290\u0338qual;\u62e3\u0180bcp\u0d13\u0d24\u0d4eset\u0100;E\u0d1b\u0d1e\uc000\u2282\u20d2qual;\u6288ceeds\u0200;EST\u0d32\u0d33\u0d3b\u0d46\u6281qual;\uc000\u2ab0\u0338lantEqual;\u62e1ilde;\uc000\u227f\u0338erset\u0100;E\u0d58\u0d5b\uc000\u2283\u20d2qual;\u6289ilde\u0200;EFT\u0d6e\u0d6f\u0d75\u0d7f\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uc000\ud835\udca9ilde\u803b\xd1\u40d1;\u439d\u0700Eacdfgmoprstuv\u0dbd\u0dc2\u0dc9\u0dd5\u0ddb\u0de0\u0de7\u0dfc\u0e02\u0e20\u0e22\u0e32\u0e3f\u0e44lig;\u4152cute\u803b\xd3\u40d3\u0100iy\u0dce\u0dd3rc\u803b\xd4\u40d4;\u441eblac;\u4150r;\uc000\ud835\udd12rave\u803b\xd2\u40d2\u0180aei\u0dee\u0df2\u0df6cr;\u414cga;\u43a9cron;\u439fpf;\uc000\ud835\udd46enCurly\u0100DQ\u0e0e\u0e1aoubleQuote;\u601cuote;\u6018;\u6a54\u0100cl\u0e27\u0e2cr;\uc000\ud835\udcaaash\u803b\xd8\u40d8i\u016c\u0e37\u0e3cde\u803b\xd5\u40d5es;\u6a37ml\u803b\xd6\u40d6er\u0100BP\u0e4b\u0e60\u0100ar\u0e50\u0e53r;\u603eac\u0100ek\u0e5a\u0e5c;\u63deet;\u63b4arenthesis;\u63dc\u0480acfhilors\u0e7f\u0e87\u0e8a\u0e8f\u0e92\u0e94\u0e9d\u0eb0\u0efcrtialD;\u6202y;\u441fr;\uc000\ud835\udd13i;\u43a6;\u43a0usMinus;\u40b1\u0100ip\u0ea2\u0eadncareplan\xe5\u069df;\u6119\u0200;eio\u0eb9\u0eba\u0ee0\u0ee4\u6abbcedes\u0200;EST\u0ec8\u0ec9\u0ecf\u0eda\u627aqual;\u6aaflantEqual;\u627cilde;\u627eme;\u6033\u0100dp\u0ee9\u0eeeuct;\u620fortion\u0100;a\u0225\u0ef9l;\u621d\u0100ci\u0f01\u0f06r;\uc000\ud835\udcab;\u43a8\u0200Ufos\u0f11\u0f16\u0f1b\u0f1fOT\u803b\"\u4022r;\uc000\ud835\udd14pf;\u611acr;\uc000\ud835\udcac\u0600BEacefhiorsu\u0f3e\u0f43\u0f47\u0f60\u0f73\u0fa7\u0faa\u0fad\u1096\u10a9\u10b4\u10bearr;\u6910G\u803b\xae\u40ae\u0180cnr\u0f4e\u0f53\u0f56ute;\u4154g;\u67ebr\u0100;t\u0f5c\u0f5d\u61a0l;\u6916\u0180aey\u0f67\u0f6c\u0f71ron;\u4158dil;\u4156;\u4420\u0100;v\u0f78\u0f79\u611cerse\u0100EU\u0f82\u0f99\u0100lq\u0f87\u0f8eement;\u620builibrium;\u61cbpEquilibrium;\u696fr\xbb\u0f79o;\u43a1ght\u0400ACDFTUVa\u0fc1\u0feb\u0ff3\u1022\u1028\u105b\u1087\u03d8\u0100nr\u0fc6\u0fd2gleBracket;\u67e9row\u0180;BL\u0fdc\u0fdd\u0fe1\u6192ar;\u61e5eftArrow;\u61c4eiling;\u6309o\u01f5\u0ff9\0\u1005bleBracket;\u67e7n\u01d4\u100a\0\u1014eeVector;\u695dector\u0100;B\u101d\u101e\u61c2ar;\u6955loor;\u630b\u0100er\u102d\u1043e\u0180;AV\u1035\u1036\u103c\u62a2rrow;\u61a6ector;\u695biangle\u0180;BE\u1050\u1051\u1055\u62b3ar;\u69d0qual;\u62b5p\u0180DTV\u1063\u106e\u1078ownVector;\u694feeVector;\u695cector\u0100;B\u1082\u1083\u61bear;\u6954ector\u0100;B\u1091\u1092\u61c0ar;\u6953\u0100pu\u109b\u109ef;\u611dndImplies;\u6970ightarrow;\u61db\u0100ch\u10b9\u10bcr;\u611b;\u61b1leDelayed;\u69f4\u0680HOacfhimoqstu\u10e4\u10f1\u10f7\u10fd\u1119\u111e\u1151\u1156\u1161\u1167\u11b5\u11bb\u11bf\u0100Cc\u10e9\u10eeHcy;\u4429y;\u4428FTcy;\u442ccute;\u415a\u0280;aeiy\u1108\u1109\u110e\u1113\u1117\u6abcron;\u4160dil;\u415erc;\u415c;\u4421r;\uc000\ud835\udd16ort\u0200DLRU\u112a\u1134\u113e\u1149ownArrow\xbb\u041eeftArrow\xbb\u089aightArrow\xbb\u0fddpArrow;\u6191gma;\u43a3allCircle;\u6218pf;\uc000\ud835\udd4a\u0272\u116d\0\0\u1170t;\u621aare\u0200;ISU\u117b\u117c\u1189\u11af\u65a1ntersection;\u6293u\u0100bp\u118f\u119eset\u0100;E\u1197\u1198\u628fqual;\u6291erset\u0100;E\u11a8\u11a9\u6290qual;\u6292nion;\u6294cr;\uc000\ud835\udcaear;\u62c6\u0200bcmp\u11c8\u11db\u1209\u120b\u0100;s\u11cd\u11ce\u62d0et\u0100;E\u11cd\u11d5qual;\u6286\u0100ch\u11e0\u1205eeds\u0200;EST\u11ed\u11ee\u11f4\u11ff\u627bqual;\u6ab0lantEqual;\u627dilde;\u627fTh\xe1\u0f8c;\u6211\u0180;es\u1212\u1213\u1223\u62d1rset\u0100;E\u121c\u121d\u6283qual;\u6287et\xbb\u1213\u0580HRSacfhiors\u123e\u1244\u1249\u1255\u125e\u1271\u1276\u129f\u12c2\u12c8\u12d1ORN\u803b\xde\u40deADE;\u6122\u0100Hc\u124e\u1252cy;\u440by;\u4426\u0100bu\u125a\u125c;\u4009;\u43a4\u0180aey\u1265\u126a\u126fron;\u4164dil;\u4162;\u4422r;\uc000\ud835\udd17\u0100ei\u127b\u1289\u01f2\u1280\0\u1287efore;\u6234a;\u4398\u0100cn\u128e\u1298kSpace;\uc000\u205f\u200aSpace;\u6009lde\u0200;EFT\u12ab\u12ac\u12b2\u12bc\u623cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uc000\ud835\udd4bipleDot;\u60db\u0100ct\u12d6\u12dbr;\uc000\ud835\udcafrok;\u4166\u0ae1\u12f7\u130e\u131a\u1326\0\u132c\u1331\0\0\0\0\0\u1338\u133d\u1377\u1385\0\u13ff\u1404\u140a\u1410\u0100cr\u12fb\u1301ute\u803b\xda\u40dar\u0100;o\u1307\u1308\u619fcir;\u6949r\u01e3\u1313\0\u1316y;\u440eve;\u416c\u0100iy\u131e\u1323rc\u803b\xdb\u40db;\u4423blac;\u4170r;\uc000\ud835\udd18rave\u803b\xd9\u40d9acr;\u416a\u0100di\u1341\u1369er\u0100BP\u1348\u135d\u0100ar\u134d\u1350r;\u405fac\u0100ek\u1357\u1359;\u63dfet;\u63b5arenthesis;\u63ddon\u0100;P\u1370\u1371\u62c3lus;\u628e\u0100gp\u137b\u137fon;\u4172f;\uc000\ud835\udd4c\u0400ADETadps\u1395\u13ae\u13b8\u13c4\u03e8\u13d2\u13d7\u13f3rrow\u0180;BD\u1150\u13a0\u13a4ar;\u6912ownArrow;\u61c5ownArrow;\u6195quilibrium;\u696eee\u0100;A\u13cb\u13cc\u62a5rrow;\u61a5own\xe1\u03f3er\u0100LR\u13de\u13e8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13f9\u13fa\u43d2on;\u43a5ing;\u416ecr;\uc000\ud835\udcb0ilde;\u4168ml\u803b\xdc\u40dc\u0480Dbcdefosv\u1427\u142c\u1430\u1433\u143e\u1485\u148a\u1490\u1496ash;\u62abar;\u6aeby;\u4412ash\u0100;l\u143b\u143c\u62a9;\u6ae6\u0100er\u1443\u1445;\u62c1\u0180bty\u144c\u1450\u147aar;\u6016\u0100;i\u144f\u1455cal\u0200BLST\u1461\u1465\u146a\u1474ar;\u6223ine;\u407ceparator;\u6758ilde;\u6240ThinSpace;\u600ar;\uc000\ud835\udd19pf;\uc000\ud835\udd4dcr;\uc000\ud835\udcb1dash;\u62aa\u0280cefos\u14a7\u14ac\u14b1\u14b6\u14bcirc;\u4174dge;\u62c0r;\uc000\ud835\udd1apf;\uc000\ud835\udd4ecr;\uc000\ud835\udcb2\u0200fios\u14cb\u14d0\u14d2\u14d8r;\uc000\ud835\udd1b;\u439epf;\uc000\ud835\udd4fcr;\uc000\ud835\udcb3\u0480AIUacfosu\u14f1\u14f5\u14f9\u14fd\u1504\u150f\u1514\u151a\u1520cy;\u442fcy;\u4407cy;\u442ecute\u803b\xdd\u40dd\u0100iy\u1509\u150drc;\u4176;\u442br;\uc000\ud835\udd1cpf;\uc000\ud835\udd50cr;\uc000\ud835\udcb4ml;\u4178\u0400Hacdefos\u1535\u1539\u153f\u154b\u154f\u155d\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417d;\u4417ot;\u417b\u01f2\u1554\0\u155boWidt\xe8\u0ad9a;\u4396r;\u6128pf;\u6124cr;\uc000\ud835\udcb5\u0be1\u1583\u158a\u1590\0\u15b0\u15b6\u15bf\0\0\0\0\u15c6\u15db\u15eb\u165f\u166d\0\u1695\u169b\u16b2\u16b9\0\u16becute\u803b\xe1\u40e1reve;\u4103\u0300;Ediuy\u159c\u159d\u15a1\u15a3\u15a8\u15ad\u623e;\uc000\u223e\u0333;\u623frc\u803b\xe2\u40e2te\u80bb\xb4\u0306;\u4430lig\u803b\xe6\u40e6\u0100;r\xb2\u15ba;\uc000\ud835\udd1erave\u803b\xe0\u40e0\u0100ep\u15ca\u15d6\u0100fp\u15cf\u15d4sym;\u6135\xe8\u15d3ha;\u43b1\u0100ap\u15dfc\u0100cl\u15e4\u15e7r;\u4101g;\u6a3f\u0264\u15f0\0\0\u160a\u0280;adsv\u15fa\u15fb\u15ff\u1601\u1607\u6227nd;\u6a55;\u6a5clope;\u6a58;\u6a5a\u0380;elmrsz\u1618\u1619\u161b\u161e\u163f\u164f\u1659\u6220;\u69a4e\xbb\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163a\u163c\u163e;\u69a8;\u69a9;\u69aa;\u69ab;\u69ac;\u69ad;\u69ae;\u69aft\u0100;v\u1645\u1646\u621fb\u0100;d\u164c\u164d\u62be;\u699d\u0100pt\u1654\u1657h;\u6222\xbb\xb9arr;\u637c\u0100gp\u1663\u1667on;\u4105f;\uc000\ud835\udd52\u0380;Eaeiop\u12c1\u167b\u167d\u1682\u1684\u1687\u168a;\u6a70cir;\u6a6f;\u624ad;\u624bs;\u4027rox\u0100;e\u12c1\u1692\xf1\u1683ing\u803b\xe5\u40e5\u0180cty\u16a1\u16a6\u16a8r;\uc000\ud835\udcb6;\u402amp\u0100;e\u12c1\u16af\xf1\u0288ilde\u803b\xe3\u40e3ml\u803b\xe4\u40e4\u0100ci\u16c2\u16c8onin\xf4\u0272nt;\u6a11\u0800Nabcdefiklnoprsu\u16ed\u16f1\u1730\u173c\u1743\u1748\u1778\u177d\u17e0\u17e6\u1839\u1850\u170d\u193d\u1948\u1970ot;\u6aed\u0100cr\u16f6\u171ek\u0200ceps\u1700\u1705\u170d\u1713ong;\u624cpsilon;\u43f6rime;\u6035im\u0100;e\u171a\u171b\u623dq;\u62cd\u0176\u1722\u1726ee;\u62bded\u0100;g\u172c\u172d\u6305e\xbb\u172drk\u0100;t\u135c\u1737brk;\u63b6\u0100oy\u1701\u1741;\u4431quo;\u601e\u0280cmprt\u1753\u175b\u1761\u1764\u1768aus\u0100;e\u010a\u0109ptyv;\u69b0s\xe9\u170cno\xf5\u0113\u0180ahw\u176f\u1771\u1773;\u43b2;\u6136een;\u626cr;\uc000\ud835\udd1fg\u0380costuvw\u178d\u179d\u17b3\u17c1\u17d5\u17db\u17de\u0180aiu\u1794\u1796\u179a\xf0\u0760rc;\u65efp\xbb\u1371\u0180dpt\u17a4\u17a8\u17adot;\u6a00lus;\u6a01imes;\u6a02\u0271\u17b9\0\0\u17becup;\u6a06ar;\u6605riangle\u0100du\u17cd\u17d2own;\u65bdp;\u65b3plus;\u6a04e\xe5\u1444\xe5\u14adarow;\u690d\u0180ako\u17ed\u1826\u1835\u0100cn\u17f2\u1823k\u0180lst\u17fa\u05ab\u1802ozenge;\u69ebriangle\u0200;dlr\u1812\u1813\u1818\u181d\u65b4own;\u65beeft;\u65c2ight;\u65b8k;\u6423\u01b1\u182b\0\u1833\u01b2\u182f\0\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183e\u184d\u0100;q\u1843\u1846\uc000=\u20e5uiv;\uc000\u2261\u20e5t;\u6310\u0200ptwx\u1859\u185e\u1867\u186cf;\uc000\ud835\udd53\u0100;t\u13cb\u1863om\xbb\u13cctie;\u62c8\u0600DHUVbdhmptuv\u1885\u1896\u18aa\u18bb\u18d7\u18db\u18ec\u18ff\u1905\u190a\u1910\u1921\u0200LRlr\u188e\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18a1\u18a2\u18a4\u18a6\u18a8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18b3\u18b5\u18b7\u18b9;\u655d;\u655a;\u655c;\u6559\u0380;HLRhlr\u18ca\u18cb\u18cd\u18cf\u18d1\u18d3\u18d5\u6551;\u656c;\u6563;\u6560;\u656b;\u6562;\u655fox;\u69c9\u0200LRlr\u18e4\u18e6\u18e8\u18ea;\u6555;\u6552;\u6510;\u650c\u0280;DUdu\u06bd\u18f7\u18f9\u18fb\u18fd;\u6565;\u6568;\u652c;\u6534inus;\u629flus;\u629eimes;\u62a0\u0200LRlr\u1919\u191b\u191d\u191f;\u655b;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193b\u6502;\u656a;\u6561;\u655e;\u653c;\u6524;\u651c\u0100ev\u0123\u1942bar\u803b\xa6\u40a6\u0200ceio\u1951\u1956\u195a\u1960r;\uc000\ud835\udcb7mi;\u604fm\u0100;e\u171a\u171cl\u0180;bh\u1968\u1969\u196b\u405c;\u69c5sub;\u67c8\u016c\u1974\u197el\u0100;e\u1979\u197a\u6022t\xbb\u197ap\u0180;Ee\u012f\u1985\u1987;\u6aae\u0100;q\u06dc\u06db\u0ce1\u19a7\0\u19e8\u1a11\u1a15\u1a32\0\u1a37\u1a50\0\0\u1ab4\0\0\u1ac1\0\0\u1b21\u1b2e\u1b4d\u1b52\0\u1bfd\0\u1c0c\u0180cpr\u19ad\u19b2\u19ddute;\u4107\u0300;abcds\u19bf\u19c0\u19c4\u19ca\u19d5\u19d9\u6229nd;\u6a44rcup;\u6a49\u0100au\u19cf\u19d2p;\u6a4bp;\u6a47ot;\u6a40;\uc000\u2229\ufe00\u0100eo\u19e2\u19e5t;\u6041\xee\u0693\u0200aeiu\u19f0\u19fb\u1a01\u1a05\u01f0\u19f5\0\u19f8s;\u6a4don;\u410ddil\u803b\xe7\u40e7rc;\u4109ps\u0100;s\u1a0c\u1a0d\u6a4cm;\u6a50ot;\u410b\u0180dmn\u1a1b\u1a20\u1a26il\u80bb\xb8\u01adptyv;\u69b2t\u8100\xa2;e\u1a2d\u1a2e\u40a2r\xe4\u01b2r;\uc000\ud835\udd20\u0180cei\u1a3d\u1a40\u1a4dy;\u4447ck\u0100;m\u1a47\u1a48\u6713ark\xbb\u1a48;\u43c7r\u0380;Ecefms\u1a5f\u1a60\u1a62\u1a6b\u1aa4\u1aaa\u1aae\u65cb;\u69c3\u0180;el\u1a69\u1a6a\u1a6d\u42c6q;\u6257e\u0261\u1a74\0\0\u1a88rrow\u0100lr\u1a7c\u1a81eft;\u61baight;\u61bb\u0280RSacd\u1a92\u1a94\u1a96\u1a9a\u1a9f\xbb\u0f47;\u64c8st;\u629birc;\u629aash;\u629dnint;\u6a10id;\u6aefcir;\u69c2ubs\u0100;u\u1abb\u1abc\u6663it\xbb\u1abc\u02ec\u1ac7\u1ad4\u1afa\0\u1b0aon\u0100;e\u1acd\u1ace\u403a\u0100;q\xc7\xc6\u026d\u1ad9\0\0\u1ae2a\u0100;t\u1ade\u1adf\u402c;\u4040\u0180;fl\u1ae8\u1ae9\u1aeb\u6201\xee\u1160e\u0100mx\u1af1\u1af6ent\xbb\u1ae9e\xf3\u024d\u01e7\u1afe\0\u1b07\u0100;d\u12bb\u1b02ot;\u6a6dn\xf4\u0246\u0180fry\u1b10\u1b14\u1b17;\uc000\ud835\udd54o\xe4\u0254\u8100\xa9;s\u0155\u1b1dr;\u6117\u0100ao\u1b25\u1b29rr;\u61b5ss;\u6717\u0100cu\u1b32\u1b37r;\uc000\ud835\udcb8\u0100bp\u1b3c\u1b44\u0100;e\u1b41\u1b42\u6acf;\u6ad1\u0100;e\u1b49\u1b4a\u6ad0;\u6ad2dot;\u62ef\u0380delprvw\u1b60\u1b6c\u1b77\u1b82\u1bac\u1bd4\u1bf9arr\u0100lr\u1b68\u1b6a;\u6938;\u6935\u0270\u1b72\0\0\u1b75r;\u62dec;\u62dfarr\u0100;p\u1b7f\u1b80\u61b6;\u693d\u0300;bcdos\u1b8f\u1b90\u1b96\u1ba1\u1ba5\u1ba8\u622arcap;\u6a48\u0100au\u1b9b\u1b9ep;\u6a46p;\u6a4aot;\u628dr;\u6a45;\uc000\u222a\ufe00\u0200alrv\u1bb5\u1bbf\u1bde\u1be3rr\u0100;m\u1bbc\u1bbd\u61b7;\u693cy\u0180evw\u1bc7\u1bd4\u1bd8q\u0270\u1bce\0\0\u1bd2re\xe3\u1b73u\xe3\u1b75ee;\u62ceedge;\u62cfen\u803b\xa4\u40a4earrow\u0100lr\u1bee\u1bf3eft\xbb\u1b80ight\xbb\u1bbde\xe4\u1bdd\u0100ci\u1c01\u1c07onin\xf4\u01f7nt;\u6231lcty;\u632d\u0980AHabcdefhijlorstuwz\u1c38\u1c3b\u1c3f\u1c5d\u1c69\u1c75\u1c8a\u1c9e\u1cac\u1cb7\u1cfb\u1cff\u1d0d\u1d7b\u1d91\u1dab\u1dbb\u1dc6\u1dcdr\xf2\u0381ar;\u6965\u0200glrs\u1c48\u1c4d\u1c52\u1c54ger;\u6020eth;\u6138\xf2\u1133h\u0100;v\u1c5a\u1c5b\u6010\xbb\u090a\u016b\u1c61\u1c67arow;\u690fa\xe3\u0315\u0100ay\u1c6e\u1c73ron;\u410f;\u4434\u0180;ao\u0332\u1c7c\u1c84\u0100gr\u02bf\u1c81r;\u61catseq;\u6a77\u0180glm\u1c91\u1c94\u1c98\u803b\xb0\u40b0ta;\u43b4ptyv;\u69b1\u0100ir\u1ca3\u1ca8sht;\u697f;\uc000\ud835\udd21ar\u0100lr\u1cb3\u1cb5\xbb\u08dc\xbb\u101e\u0280aegsv\u1cc2\u0378\u1cd6\u1cdc\u1ce0m\u0180;os\u0326\u1cca\u1cd4nd\u0100;s\u0326\u1cd1uit;\u6666amma;\u43ddin;\u62f2\u0180;io\u1ce7\u1ce8\u1cf8\u40f7de\u8100\xf7;o\u1ce7\u1cf0ntimes;\u62c7n\xf8\u1cf7cy;\u4452c\u026f\u1d06\0\0\u1d0arn;\u631eop;\u630d\u0280lptuw\u1d18\u1d1d\u1d22\u1d49\u1d55lar;\u4024f;\uc000\ud835\udd55\u0280;emps\u030b\u1d2d\u1d37\u1d3d\u1d42q\u0100;d\u0352\u1d33ot;\u6251inus;\u6238lus;\u6214quare;\u62a1blebarwedg\xe5\xfan\u0180adh\u112e\u1d5d\u1d67ownarrow\xf3\u1c83arpoon\u0100lr\u1d72\u1d76ef\xf4\u1cb4igh\xf4\u1cb6\u0162\u1d7f\u1d85karo\xf7\u0f42\u026f\u1d8a\0\0\u1d8ern;\u631fop;\u630c\u0180cot\u1d98\u1da3\u1da6\u0100ry\u1d9d\u1da1;\uc000\ud835\udcb9;\u4455l;\u69f6rok;\u4111\u0100dr\u1db0\u1db4ot;\u62f1i\u0100;f\u1dba\u1816\u65bf\u0100ah\u1dc0\u1dc3r\xf2\u0429a\xf2\u0fa6angle;\u69a6\u0100ci\u1dd2\u1dd5y;\u445fgrarr;\u67ff\u0900Dacdefglmnopqrstux\u1e01\u1e09\u1e19\u1e38\u0578\u1e3c\u1e49\u1e61\u1e7e\u1ea5\u1eaf\u1ebd\u1ee1\u1f2a\u1f37\u1f44\u1f4e\u1f5a\u0100Do\u1e06\u1d34o\xf4\u1c89\u0100cs\u1e0e\u1e14ute\u803b\xe9\u40e9ter;\u6a6e\u0200aioy\u1e22\u1e27\u1e31\u1e36ron;\u411br\u0100;c\u1e2d\u1e2e\u6256\u803b\xea\u40ealon;\u6255;\u444dot;\u4117\u0100Dr\u1e41\u1e45ot;\u6252;\uc000\ud835\udd22\u0180;rs\u1e50\u1e51\u1e57\u6a9aave\u803b\xe8\u40e8\u0100;d\u1e5c\u1e5d\u6a96ot;\u6a98\u0200;ils\u1e6a\u1e6b\u1e72\u1e74\u6a99nters;\u63e7;\u6113\u0100;d\u1e79\u1e7a\u6a95ot;\u6a97\u0180aps\u1e85\u1e89\u1e97cr;\u4113ty\u0180;sv\u1e92\u1e93\u1e95\u6205et\xbb\u1e93p\u01001;\u1e9d\u1ea4\u0133\u1ea1\u1ea3;\u6004;\u6005\u6003\u0100gs\u1eaa\u1eac;\u414bp;\u6002\u0100gp\u1eb4\u1eb8on;\u4119f;\uc000\ud835\udd56\u0180als\u1ec4\u1ece\u1ed2r\u0100;s\u1eca\u1ecb\u62d5l;\u69e3us;\u6a71i\u0180;lv\u1eda\u1edb\u1edf\u43b5on\xbb\u1edb;\u43f5\u0200csuv\u1eea\u1ef3\u1f0b\u1f23\u0100io\u1eef\u1e31rc\xbb\u1e2e\u0269\u1ef9\0\0\u1efb\xed\u0548ant\u0100gl\u1f02\u1f06tr\xbb\u1e5dess\xbb\u1e7a\u0180aei\u1f12\u1f16\u1f1als;\u403dst;\u625fv\u0100;D\u0235\u1f20D;\u6a78parsl;\u69e5\u0100Da\u1f2f\u1f33ot;\u6253rr;\u6971\u0180cdi\u1f3e\u1f41\u1ef8r;\u612fo\xf4\u0352\u0100ah\u1f49\u1f4b;\u43b7\u803b\xf0\u40f0\u0100mr\u1f53\u1f57l\u803b\xeb\u40ebo;\u60ac\u0180cip\u1f61\u1f64\u1f67l;\u4021s\xf4\u056e\u0100eo\u1f6c\u1f74ctatio\xee\u0559nential\xe5\u0579\u09e1\u1f92\0\u1f9e\0\u1fa1\u1fa7\0\0\u1fc6\u1fcc\0\u1fd3\0\u1fe6\u1fea\u2000\0\u2008\u205allingdotse\xf1\u1e44y;\u4444male;\u6640\u0180ilr\u1fad\u1fb3\u1fc1lig;\u8000\ufb03\u0269\u1fb9\0\0\u1fbdg;\u8000\ufb00ig;\u8000\ufb04;\uc000\ud835\udd23lig;\u8000\ufb01lig;\uc000fj\u0180alt\u1fd9\u1fdc\u1fe1t;\u666dig;\u8000\ufb02ns;\u65b1of;\u4192\u01f0\u1fee\0\u1ff3f;\uc000\ud835\udd57\u0100ak\u05bf\u1ff7\u0100;v\u1ffc\u1ffd\u62d4;\u6ad9artint;\u6a0d\u0100ao\u200c\u2055\u0100cs\u2011\u2052\u03b1\u201a\u2030\u2038\u2045\u2048\0\u2050\u03b2\u2022\u2025\u2027\u202a\u202c\0\u202e\u803b\xbd\u40bd;\u6153\u803b\xbc\u40bc;\u6155;\u6159;\u615b\u01b3\u2034\0\u2036;\u6154;\u6156\u02b4\u203e\u2041\0\0\u2043\u803b\xbe\u40be;\u6157;\u615c5;\u6158\u01b6\u204c\0\u204e;\u615a;\u615d8;\u615el;\u6044wn;\u6322cr;\uc000\ud835\udcbb\u0880Eabcdefgijlnorstv\u2082\u2089\u209f\u20a5\u20b0\u20b4\u20f0\u20f5\u20fa\u20ff\u2103\u2112\u2138\u0317\u213e\u2152\u219e\u0100;l\u064d\u2087;\u6a8c\u0180cmp\u2090\u2095\u209dute;\u41f5ma\u0100;d\u209c\u1cda\u43b3;\u6a86reve;\u411f\u0100iy\u20aa\u20aerc;\u411d;\u4433ot;\u4121\u0200;lqs\u063e\u0642\u20bd\u20c9\u0180;qs\u063e\u064c\u20c4lan\xf4\u0665\u0200;cdl\u0665\u20d2\u20d5\u20e5c;\u6aa9ot\u0100;o\u20dc\u20dd\u6a80\u0100;l\u20e2\u20e3\u6a82;\u6a84\u0100;e\u20ea\u20ed\uc000\u22db\ufe00s;\u6a94r;\uc000\ud835\udd24\u0100;g\u0673\u061bmel;\u6137cy;\u4453\u0200;Eaj\u065a\u210c\u210e\u2110;\u6a92;\u6aa5;\u6aa4\u0200Eaes\u211b\u211d\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6a8arox\xbb\u2124\u0100;q\u212e\u212f\u6a88\u0100;q\u212e\u211bim;\u62e7pf;\uc000\ud835\udd58\u0100ci\u2143\u2146r;\u610am\u0180;el\u066b\u214e\u2150;\u6a8e;\u6a90\u8300>;cdlqr\u05ee\u2160\u216a\u216e\u2173\u2179\u0100ci\u2165\u2167;\u6aa7r;\u6a7aot;\u62d7Par;\u6995uest;\u6a7c\u0280adels\u2184\u216a\u2190\u0656\u219b\u01f0\u2189\0\u218epro\xf8\u209er;\u6978q\u0100lq\u063f\u2196les\xf3\u2088i\xed\u066b\u0100en\u21a3\u21adrtneqq;\uc000\u2269\ufe00\xc5\u21aa\u0500Aabcefkosy\u21c4\u21c7\u21f1\u21f5\u21fa\u2218\u221d\u222f\u2268\u227dr\xf2\u03a0\u0200ilmr\u21d0\u21d4\u21d7\u21dbrs\xf0\u1484f\xbb\u2024il\xf4\u06a9\u0100dr\u21e0\u21e4cy;\u444a\u0180;cw\u08f4\u21eb\u21efir;\u6948;\u61adar;\u610firc;\u4125\u0180alr\u2201\u220e\u2213rts\u0100;u\u2209\u220a\u6665it\xbb\u220alip;\u6026con;\u62b9r;\uc000\ud835\udd25s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223a\u223e\u2243\u225e\u2263rr;\u61fftht;\u623bk\u0100lr\u2249\u2253eftarrow;\u61a9ightarrow;\u61aaf;\uc000\ud835\udd59bar;\u6015\u0180clt\u226f\u2274\u2278r;\uc000\ud835\udcbdas\xe8\u21f4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\xbb\u1c5b\u0ae1\u22a3\0\u22aa\0\u22b8\u22c5\u22ce\0\u22d5\u22f3\0\0\u22f8\u2322\u2367\u2362\u237f\0\u2386\u23aa\u23b4cute\u803b\xed\u40ed\u0180;iy\u0771\u22b0\u22b5rc\u803b\xee\u40ee;\u4438\u0100cx\u22bc\u22bfy;\u4435cl\u803b\xa1\u40a1\u0100fr\u039f\u22c9;\uc000\ud835\udd26rave\u803b\xec\u40ec\u0200;ino\u073e\u22dd\u22e9\u22ee\u0100in\u22e2\u22e6nt;\u6a0ct;\u622dfin;\u69dcta;\u6129lig;\u4133\u0180aop\u22fe\u231a\u231d\u0180cgt\u2305\u2308\u2317r;\u412b\u0180elp\u071f\u230f\u2313in\xe5\u078ear\xf4\u0720h;\u4131f;\u62b7ed;\u41b5\u0280;cfot\u04f4\u232c\u2331\u233d\u2341are;\u6105in\u0100;t\u2338\u2339\u621eie;\u69dddo\xf4\u2319\u0280;celp\u0757\u234c\u2350\u235b\u2361al;\u62ba\u0100gr\u2355\u2359er\xf3\u1563\xe3\u234darhk;\u6a17rod;\u6a3c\u0200cgpt\u236f\u2372\u2376\u237by;\u4451on;\u412ff;\uc000\ud835\udd5aa;\u43b9uest\u803b\xbf\u40bf\u0100ci\u238a\u238fr;\uc000\ud835\udcben\u0280;Edsv\u04f4\u239b\u239d\u23a1\u04f3;\u62f9ot;\u62f5\u0100;v\u23a6\u23a7\u62f4;\u62f3\u0100;i\u0777\u23aelde;\u4129\u01eb\u23b8\0\u23bccy;\u4456l\u803b\xef\u40ef\u0300cfmosu\u23cc\u23d7\u23dc\u23e1\u23e7\u23f5\u0100iy\u23d1\u23d5rc;\u4135;\u4439r;\uc000\ud835\udd27ath;\u4237pf;\uc000\ud835\udd5b\u01e3\u23ec\0\u23f1r;\uc000\ud835\udcbfrcy;\u4458kcy;\u4454\u0400acfghjos\u240b\u2416\u2422\u2427\u242d\u2431\u2435\u243bppa\u0100;v\u2413\u2414\u43ba;\u43f0\u0100ey\u241b\u2420dil;\u4137;\u443ar;\uc000\ud835\udd28reen;\u4138cy;\u4445cy;\u445cpf;\uc000\ud835\udd5ccr;\uc000\ud835\udcc0\u0b80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248d\u2491\u250e\u253d\u255a\u2580\u264e\u265e\u2665\u2679\u267d\u269a\u26b2\u26d8\u275d\u2768\u278b\u27c0\u2801\u2812\u0180art\u2477\u247a\u247cr\xf2\u09c6\xf2\u0395ail;\u691barr;\u690e\u0100;g\u0994\u248b;\u6a8bar;\u6962\u0963\u24a5\0\u24aa\0\u24b1\0\0\0\0\0\u24b5\u24ba\0\u24c6\u24c8\u24cd\0\u24f9ute;\u413amptyv;\u69b4ra\xee\u084cbda;\u43bbg\u0180;dl\u088e\u24c1\u24c3;\u6991\xe5\u088e;\u6a85uo\u803b\xab\u40abr\u0400;bfhlpst\u0899\u24de\u24e6\u24e9\u24eb\u24ee\u24f1\u24f5\u0100;f\u089d\u24e3s;\u691fs;\u691d\xeb\u2252p;\u61abl;\u6939im;\u6973l;\u61a2\u0180;ae\u24ff\u2500\u2504\u6aabil;\u6919\u0100;s\u2509\u250a\u6aad;\uc000\u2aad\ufe00\u0180abr\u2515\u2519\u251drr;\u690crk;\u6772\u0100ak\u2522\u252cc\u0100ek\u2528\u252a;\u407b;\u405b\u0100es\u2531\u2533;\u698bl\u0100du\u2539\u253b;\u698f;\u698d\u0200aeuy\u2546\u254b\u2556\u2558ron;\u413e\u0100di\u2550\u2554il;\u413c\xec\u08b0\xe2\u2529;\u443b\u0200cqrs\u2563\u2566\u256d\u257da;\u6936uo\u0100;r\u0e19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694bh;\u61b2\u0280;fgqs\u258b\u258c\u0989\u25f3\u25ff\u6264t\u0280ahlrt\u2598\u25a4\u25b7\u25c2\u25e8rrow\u0100;t\u0899\u25a1a\xe9\u24f6arpoon\u0100du\u25af\u25b4own\xbb\u045ap\xbb\u0966eftarrows;\u61c7ight\u0180ahs\u25cd\u25d6\u25derrow\u0100;s\u08f4\u08a7arpoon\xf3\u0f98quigarro\xf7\u21f0hreetimes;\u62cb\u0180;qs\u258b\u0993\u25falan\xf4\u09ac\u0280;cdgs\u09ac\u260a\u260d\u261d\u2628c;\u6aa8ot\u0100;o\u2614\u2615\u6a7f\u0100;r\u261a\u261b\u6a81;\u6a83\u0100;e\u2622\u2625\uc000\u22da\ufe00s;\u6a93\u0280adegs\u2633\u2639\u263d\u2649\u264bppro\xf8\u24c6ot;\u62d6q\u0100gq\u2643\u2645\xf4\u0989gt\xf2\u248c\xf4\u099bi\xed\u09b2\u0180ilr\u2655\u08e1\u265asht;\u697c;\uc000\ud835\udd29\u0100;E\u099c\u2663;\u6a91\u0161\u2669\u2676r\u0100du\u25b2\u266e\u0100;l\u0965\u2673;\u696alk;\u6584cy;\u4459\u0280;acht\u0a48\u2688\u268b\u2691\u2696r\xf2\u25c1orne\xf2\u1d08ard;\u696bri;\u65fa\u0100io\u269f\u26a4dot;\u4140ust\u0100;a\u26ac\u26ad\u63b0che\xbb\u26ad\u0200Eaes\u26bb\u26bd\u26c9\u26d4;\u6268p\u0100;p\u26c3\u26c4\u6a89rox\xbb\u26c4\u0100;q\u26ce\u26cf\u6a87\u0100;q\u26ce\u26bbim;\u62e6\u0400abnoptwz\u26e9\u26f4\u26f7\u271a\u272f\u2741\u2747\u2750\u0100nr\u26ee\u26f1g;\u67ecr;\u61fdr\xeb\u08c1g\u0180lmr\u26ff\u270d\u2714eft\u0100ar\u09e6\u2707ight\xe1\u09f2apsto;\u67fcight\xe1\u09fdparrow\u0100lr\u2725\u2729ef\xf4\u24edight;\u61ac\u0180afl\u2736\u2739\u273dr;\u6985;\uc000\ud835\udd5dus;\u6a2dimes;\u6a34\u0161\u274b\u274fst;\u6217\xe1\u134e\u0180;ef\u2757\u2758\u1800\u65cange\xbb\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277c\u2785\u2787r\xf2\u08a8orne\xf2\u1d8car\u0100;d\u0f98\u2783;\u696d;\u600eri;\u62bf\u0300achiqt\u2798\u279d\u0a40\u27a2\u27ae\u27bbquo;\u6039r;\uc000\ud835\udcc1m\u0180;eg\u09b2\u27aa\u27ac;\u6a8d;\u6a8f\u0100bu\u252a\u27b3o\u0100;r\u0e1f\u27b9;\u601arok;\u4142\u8400<;cdhilqr\u082b\u27d2\u2639\u27dc\u27e0\u27e5\u27ea\u27f0\u0100ci\u27d7\u27d9;\u6aa6r;\u6a79re\xe5\u25f2mes;\u62c9arr;\u6976uest;\u6a7b\u0100Pi\u27f5\u27f9ar;\u6996\u0180;ef\u2800\u092d\u181b\u65c3r\u0100du\u2807\u280dshar;\u694ahar;\u6966\u0100en\u2817\u2821rtneqq;\uc000\u2268\ufe00\xc5\u281e\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288e\u2893\u28a0\u28a5\u28a8\u28da\u28e2\u28e4\u0a83\u28f3\u2902Dot;\u623a\u0200clpr\u284e\u2852\u2863\u287dr\u803b\xaf\u40af\u0100et\u2857\u2859;\u6642\u0100;e\u285e\u285f\u6720se\xbb\u285f\u0100;s\u103b\u2868to\u0200;dlu\u103b\u2873\u2877\u287bow\xee\u048cef\xf4\u090f\xf0\u13d1ker;\u65ae\u0100oy\u2887\u288cmma;\u6a29;\u443cash;\u6014asuredangle\xbb\u1626r;\uc000\ud835\udd2ao;\u6127\u0180cdn\u28af\u28b4\u28c9ro\u803b\xb5\u40b5\u0200;acd\u1464\u28bd\u28c0\u28c4s\xf4\u16a7ir;\u6af0ot\u80bb\xb7\u01b5us\u0180;bd\u28d2\u1903\u28d3\u6212\u0100;u\u1d3c\u28d8;\u6a2a\u0163\u28de\u28e1p;\u6adb\xf2\u2212\xf0\u0a81\u0100dp\u28e9\u28eeels;\u62a7f;\uc000\ud835\udd5e\u0100ct\u28f8\u28fdr;\uc000\ud835\udcc2pos\xbb\u159d\u0180;lm\u2909\u290a\u290d\u43bctimap;\u62b8\u0c00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297e\u2989\u2998\u29da\u29e9\u2a15\u2a1a\u2a58\u2a5d\u2a83\u2a95\u2aa4\u2aa8\u2b04\u2b07\u2b44\u2b7f\u2bae\u2c34\u2c67\u2c7c\u2ce9\u0100gt\u2947\u294b;\uc000\u22d9\u0338\u0100;v\u2950\u0bcf\uc000\u226b\u20d2\u0180elt\u295a\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61cdightarrow;\u61ce;\uc000\u22d8\u0338\u0100;v\u297b\u0c47\uc000\u226a\u20d2ightarrow;\u61cf\u0100Dd\u298e\u2993ash;\u62afash;\u62ae\u0280bcnpt\u29a3\u29a7\u29ac\u29b1\u29ccla\xbb\u02deute;\u4144g;\uc000\u2220\u20d2\u0280;Eiop\u0d84\u29bc\u29c0\u29c5\u29c8;\uc000\u2a70\u0338d;\uc000\u224b\u0338s;\u4149ro\xf8\u0d84ur\u0100;a\u29d3\u29d4\u666el\u0100;s\u29d3\u0b38\u01f3\u29df\0\u29e3p\u80bb\xa0\u0b37mp\u0100;e\u0bf9\u0c00\u0280aeouy\u29f4\u29fe\u2a03\u2a10\u2a13\u01f0\u29f9\0\u29fb;\u6a43on;\u4148dil;\u4146ng\u0100;d\u0d7e\u2a0aot;\uc000\u2a6d\u0338p;\u6a42;\u443dash;\u6013\u0380;Aadqsx\u0b92\u2a29\u2a2d\u2a3b\u2a41\u2a45\u2a50rr;\u61d7r\u0100hr\u2a33\u2a36k;\u6924\u0100;o\u13f2\u13f0ot;\uc000\u2250\u0338ui\xf6\u0b63\u0100ei\u2a4a\u2a4ear;\u6928\xed\u0b98ist\u0100;s\u0ba0\u0b9fr;\uc000\ud835\udd2b\u0200Eest\u0bc5\u2a66\u2a79\u2a7c\u0180;qs\u0bbc\u2a6d\u0be1\u0180;qs\u0bbc\u0bc5\u2a74lan\xf4\u0be2i\xed\u0bea\u0100;r\u0bb6\u2a81\xbb\u0bb7\u0180Aap\u2a8a\u2a8d\u2a91r\xf2\u2971rr;\u61aear;\u6af2\u0180;sv\u0f8d\u2a9c\u0f8c\u0100;d\u2aa1\u2aa2\u62fc;\u62facy;\u445a\u0380AEadest\u2ab7\u2aba\u2abe\u2ac2\u2ac5\u2af6\u2af9r\xf2\u2966;\uc000\u2266\u0338rr;\u619ar;\u6025\u0200;fqs\u0c3b\u2ace\u2ae3\u2aeft\u0100ar\u2ad4\u2ad9rro\xf7\u2ac1ightarro\xf7\u2a90\u0180;qs\u0c3b\u2aba\u2aealan\xf4\u0c55\u0100;s\u0c55\u2af4\xbb\u0c36i\xed\u0c5d\u0100;r\u0c35\u2afei\u0100;e\u0c1a\u0c25i\xe4\u0d90\u0100pt\u2b0c\u2b11f;\uc000\ud835\udd5f\u8180\xac;in\u2b19\u2b1a\u2b36\u40acn\u0200;Edv\u0b89\u2b24\u2b28\u2b2e;\uc000\u22f9\u0338ot;\uc000\u22f5\u0338\u01e1\u0b89\u2b33\u2b35;\u62f7;\u62f6i\u0100;v\u0cb8\u2b3c\u01e1\u0cb8\u2b41\u2b43;\u62fe;\u62fd\u0180aor\u2b4b\u2b63\u2b69r\u0200;ast\u0b7b\u2b55\u2b5a\u2b5flle\xec\u0b7bl;\uc000\u2afd\u20e5;\uc000\u2202\u0338lint;\u6a14\u0180;ce\u0c92\u2b70\u2b73u\xe5\u0ca5\u0100;c\u0c98\u2b78\u0100;e\u0c92\u2b7d\xf1\u0c98\u0200Aait\u2b88\u2b8b\u2b9d\u2ba7r\xf2\u2988rr\u0180;cw\u2b94\u2b95\u2b99\u619b;\uc000\u2933\u0338;\uc000\u219d\u0338ghtarrow\xbb\u2b95ri\u0100;e\u0ccb\u0cd6\u0380chimpqu\u2bbd\u2bcd\u2bd9\u2b04\u0b78\u2be4\u2bef\u0200;cer\u0d32\u2bc6\u0d37\u2bc9u\xe5\u0d45;\uc000\ud835\udcc3ort\u026d\u2b05\0\0\u2bd6ar\xe1\u2b56m\u0100;e\u0d6e\u2bdf\u0100;q\u0d74\u0d73su\u0100bp\u2beb\u2bed\xe5\u0cf8\xe5\u0d0b\u0180bcp\u2bf6\u2c11\u2c19\u0200;Ees\u2bff\u2c00\u0d22\u2c04\u6284;\uc000\u2ac5\u0338et\u0100;e\u0d1b\u2c0bq\u0100;q\u0d23\u2c00c\u0100;e\u0d32\u2c17\xf1\u0d38\u0200;Ees\u2c22\u2c23\u0d5f\u2c27\u6285;\uc000\u2ac6\u0338et\u0100;e\u0d58\u2c2eq\u0100;q\u0d60\u2c23\u0200gilr\u2c3d\u2c3f\u2c45\u2c47\xec\u0bd7lde\u803b\xf1\u40f1\xe7\u0c43iangle\u0100lr\u2c52\u2c5ceft\u0100;e\u0c1a\u2c5a\xf1\u0c26ight\u0100;e\u0ccb\u2c65\xf1\u0cd7\u0100;m\u2c6c\u2c6d\u43bd\u0180;es\u2c74\u2c75\u2c79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2c8f\u2c94\u2c99\u2c9e\u2ca3\u2cb0\u2cb6\u2cd3\u2ce3ash;\u62adarr;\u6904p;\uc000\u224d\u20d2ash;\u62ac\u0100et\u2ca8\u2cac;\uc000\u2265\u20d2;\uc000>\u20d2nfin;\u69de\u0180Aet\u2cbd\u2cc1\u2cc5rr;\u6902;\uc000\u2264\u20d2\u0100;r\u2cca\u2ccd\uc000<\u20d2ie;\uc000\u22b4\u20d2\u0100At\u2cd8\u2cdcrr;\u6903rie;\uc000\u22b5\u20d2im;\uc000\u223c\u20d2\u0180Aan\u2cf0\u2cf4\u2d02rr;\u61d6r\u0100hr\u2cfa\u2cfdk;\u6923\u0100;o\u13e7\u13e5ear;\u6927\u1253\u1a95\0\0\0\0\0\0\0\0\0\0\0\0\0\u2d2d\0\u2d38\u2d48\u2d60\u2d65\u2d72\u2d84\u1b07\0\0\u2d8d\u2dab\0\u2dc8\u2dce\0\u2ddc\u2e19\u2e2b\u2e3e\u2e43\u0100cs\u2d31\u1a97ute\u803b\xf3\u40f3\u0100iy\u2d3c\u2d45r\u0100;c\u1a9e\u2d42\u803b\xf4\u40f4;\u443e\u0280abios\u1aa0\u2d52\u2d57\u01c8\u2d5alac;\u4151v;\u6a38old;\u69bclig;\u4153\u0100cr\u2d69\u2d6dir;\u69bf;\uc000\ud835\udd2c\u036f\u2d79\0\0\u2d7c\0\u2d82n;\u42dbave\u803b\xf2\u40f2;\u69c1\u0100bm\u2d88\u0df4ar;\u69b5\u0200acit\u2d95\u2d98\u2da5\u2da8r\xf2\u1a80\u0100ir\u2d9d\u2da0r;\u69beoss;\u69bbn\xe5\u0e52;\u69c0\u0180aei\u2db1\u2db5\u2db9cr;\u414dga;\u43c9\u0180cdn\u2dc0\u2dc5\u01cdron;\u43bf;\u69b6pf;\uc000\ud835\udd60\u0180ael\u2dd4\u2dd7\u01d2r;\u69b7rp;\u69b9\u0380;adiosv\u2dea\u2deb\u2dee\u2e08\u2e0d\u2e10\u2e16\u6228r\xf2\u1a86\u0200;efm\u2df7\u2df8\u2e02\u2e05\u6a5dr\u0100;o\u2dfe\u2dff\u6134f\xbb\u2dff\u803b\xaa\u40aa\u803b\xba\u40bagof;\u62b6r;\u6a56lope;\u6a57;\u6a5b\u0180clo\u2e1f\u2e21\u2e27\xf2\u2e01ash\u803b\xf8\u40f8l;\u6298i\u016c\u2e2f\u2e34de\u803b\xf5\u40f5es\u0100;a\u01db\u2e3as;\u6a36ml\u803b\xf6\u40f6bar;\u633d\u0ae1\u2e5e\0\u2e7d\0\u2e80\u2e9d\0\u2ea2\u2eb9\0\0\u2ecb\u0e9c\0\u2f13\0\0\u2f2b\u2fbc\0\u2fc8r\u0200;ast\u0403\u2e67\u2e72\u0e85\u8100\xb6;l\u2e6d\u2e6e\u40b6le\xec\u0403\u0269\u2e78\0\0\u2e7bm;\u6af3;\u6afdy;\u443fr\u0280cimpt\u2e8b\u2e8f\u2e93\u1865\u2e97nt;\u4025od;\u402eil;\u6030enk;\u6031r;\uc000\ud835\udd2d\u0180imo\u2ea8\u2eb0\u2eb4\u0100;v\u2ead\u2eae\u43c6;\u43d5ma\xf4\u0a76ne;\u660e\u0180;tv\u2ebf\u2ec0\u2ec8\u43c0chfork\xbb\u1ffd;\u43d6\u0100au\u2ecf\u2edfn\u0100ck\u2ed5\u2eddk\u0100;h\u21f4\u2edb;\u610e\xf6\u21f4s\u0480;abcdemst\u2ef3\u2ef4\u1908\u2ef9\u2efd\u2f04\u2f06\u2f0a\u2f0e\u402bcir;\u6a23ir;\u6a22\u0100ou\u1d40\u2f02;\u6a25;\u6a72n\u80bb\xb1\u0e9dim;\u6a26wo;\u6a27\u0180ipu\u2f19\u2f20\u2f25ntint;\u6a15f;\uc000\ud835\udd61nd\u803b\xa3\u40a3\u0500;Eaceinosu\u0ec8\u2f3f\u2f41\u2f44\u2f47\u2f81\u2f89\u2f92\u2f7e\u2fb6;\u6ab3p;\u6ab7u\xe5\u0ed9\u0100;c\u0ece\u2f4c\u0300;acens\u0ec8\u2f59\u2f5f\u2f66\u2f68\u2f7eppro\xf8\u2f43urlye\xf1\u0ed9\xf1\u0ece\u0180aes\u2f6f\u2f76\u2f7approx;\u6ab9qq;\u6ab5im;\u62e8i\xed\u0edfme\u0100;s\u2f88\u0eae\u6032\u0180Eas\u2f78\u2f90\u2f7a\xf0\u2f75\u0180dfp\u0eec\u2f99\u2faf\u0180als\u2fa0\u2fa5\u2faalar;\u632eine;\u6312urf;\u6313\u0100;t\u0efb\u2fb4\xef\u0efbrel;\u62b0\u0100ci\u2fc0\u2fc5r;\uc000\ud835\udcc5;\u43c8ncsp;\u6008\u0300fiopsu\u2fda\u22e2\u2fdf\u2fe5\u2feb\u2ff1r;\uc000\ud835\udd2epf;\uc000\ud835\udd62rime;\u6057cr;\uc000\ud835\udcc6\u0180aeo\u2ff8\u3009\u3013t\u0100ei\u2ffe\u3005rnion\xf3\u06b0nt;\u6a16st\u0100;e\u3010\u3011\u403f\xf1\u1f19\xf4\u0f14\u0a80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30e0\u310e\u312b\u3147\u3162\u3172\u318e\u3206\u3215\u3224\u3229\u3258\u326e\u3272\u3290\u32b0\u32b7\u0180art\u3047\u304a\u304cr\xf2\u10b3\xf2\u03ddail;\u691car\xf2\u1c65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307f\u308f\u3094\u30cc\u0100eu\u306d\u3071;\uc000\u223d\u0331te;\u4155i\xe3\u116emptyv;\u69b3g\u0200;del\u0fd1\u3089\u308b\u308d;\u6992;\u69a5\xe5\u0fd1uo\u803b\xbb\u40bbr\u0580;abcfhlpstw\u0fdc\u30ac\u30af\u30b7\u30b9\u30bc\u30be\u30c0\u30c3\u30c7\u30cap;\u6975\u0100;f\u0fe0\u30b4s;\u6920;\u6933s;\u691e\xeb\u225d\xf0\u272el;\u6945im;\u6974l;\u61a3;\u619d\u0100ai\u30d1\u30d5il;\u691ao\u0100;n\u30db\u30dc\u6236al\xf3\u0f1e\u0180abr\u30e7\u30ea\u30eer\xf2\u17e5rk;\u6773\u0100ak\u30f3\u30fdc\u0100ek\u30f9\u30fb;\u407d;\u405d\u0100es\u3102\u3104;\u698cl\u0100du\u310a\u310c;\u698e;\u6990\u0200aeuy\u3117\u311c\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\xec\u0ff2\xe2\u30fa;\u4440\u0200clqs\u3134\u3137\u313d\u3144a;\u6937dhar;\u6969uo\u0100;r\u020e\u020dh;\u61b3\u0180acg\u314e\u315f\u0f44l\u0200;ips\u0f78\u3158\u315b\u109cn\xe5\u10bbar\xf4\u0fa9t;\u65ad\u0180ilr\u3169\u1023\u316esht;\u697d;\uc000\ud835\udd2f\u0100ao\u3177\u3186r\u0100du\u317d\u317f\xbb\u047b\u0100;l\u1091\u3184;\u696c\u0100;v\u318b\u318c\u43c1;\u43f1\u0180gns\u3195\u31f9\u31fcht\u0300ahlrst\u31a4\u31b0\u31c2\u31d8\u31e4\u31eerrow\u0100;t\u0fdc\u31ada\xe9\u30c8arpoon\u0100du\u31bb\u31bfow\xee\u317ep\xbb\u1092eft\u0100ah\u31ca\u31d0rrow\xf3\u0feaarpoon\xf3\u0551ightarrows;\u61c9quigarro\xf7\u30cbhreetimes;\u62ccg;\u42daingdotse\xf1\u1f32\u0180ahm\u320d\u3210\u3213r\xf2\u0feaa\xf2\u0551;\u600foust\u0100;a\u321e\u321f\u63b1che\xbb\u321fmid;\u6aee\u0200abpt\u3232\u323d\u3240\u3252\u0100nr\u3237\u323ag;\u67edr;\u61fer\xeb\u1003\u0180afl\u3247\u324a\u324er;\u6986;\uc000\ud835\udd63us;\u6a2eimes;\u6a35\u0100ap\u325d\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6a12ar\xf2\u31e3\u0200achq\u327b\u3280\u10bc\u3285quo;\u603ar;\uc000\ud835\udcc7\u0100bu\u30fb\u328ao\u0100;r\u0214\u0213\u0180hir\u3297\u329b\u32a0re\xe5\u31f8mes;\u62cai\u0200;efl\u32aa\u1059\u1821\u32ab\u65b9tri;\u69celuhar;\u6968;\u611e\u0d61\u32d5\u32db\u32df\u332c\u3338\u3371\0\u337a\u33a4\0\0\u33ec\u33f0\0\u3428\u3448\u345a\u34ad\u34b1\u34ca\u34f1\0\u3616\0\0\u3633cute;\u415bqu\xef\u27ba\u0500;Eaceinpsy\u11ed\u32f3\u32f5\u32ff\u3302\u330b\u330f\u331f\u3326\u3329;\u6ab4\u01f0\u32fa\0\u32fc;\u6ab8on;\u4161u\xe5\u11fe\u0100;d\u11f3\u3307il;\u415frc;\u415d\u0180Eas\u3316\u3318\u331b;\u6ab6p;\u6abaim;\u62e9olint;\u6a13i\xed\u1204;\u4441ot\u0180;be\u3334\u1d47\u3335\u62c5;\u6a66\u0380Aacmstx\u3346\u334a\u3357\u335b\u335e\u3363\u336drr;\u61d8r\u0100hr\u3350\u3352\xeb\u2228\u0100;o\u0a36\u0a34t\u803b\xa7\u40a7i;\u403bwar;\u6929m\u0100in\u3369\xf0nu\xf3\xf1t;\u6736r\u0100;o\u3376\u2055\uc000\ud835\udd30\u0200acoy\u3382\u3386\u3391\u33a0rp;\u666f\u0100hy\u338b\u338fcy;\u4449;\u4448rt\u026d\u3399\0\0\u339ci\xe4\u1464ara\xec\u2e6f\u803b\xad\u40ad\u0100gm\u33a8\u33b4ma\u0180;fv\u33b1\u33b2\u33b2\u43c3;\u43c2\u0400;deglnpr\u12ab\u33c5\u33c9\u33ce\u33d6\u33de\u33e1\u33e6ot;\u6a6a\u0100;q\u12b1\u12b0\u0100;E\u33d3\u33d4\u6a9e;\u6aa0\u0100;E\u33db\u33dc\u6a9d;\u6a9fe;\u6246lus;\u6a24arr;\u6972ar\xf2\u113d\u0200aeit\u33f8\u3408\u340f\u3417\u0100ls\u33fd\u3404lsetm\xe9\u336ahp;\u6a33parsl;\u69e4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341c\u341d\u6aaa\u0100;s\u3422\u3423\u6aac;\uc000\u2aac\ufe00\u0180flp\u342e\u3433\u3442tcy;\u444c\u0100;b\u3438\u3439\u402f\u0100;a\u343e\u343f\u69c4r;\u633ff;\uc000\ud835\udd64a\u0100dr\u344d\u0402es\u0100;u\u3454\u3455\u6660it\xbb\u3455\u0180csu\u3460\u3479\u349f\u0100au\u3465\u346fp\u0100;s\u1188\u346b;\uc000\u2293\ufe00p\u0100;s\u11b4\u3475;\uc000\u2294\ufe00u\u0100bp\u347f\u348f\u0180;es\u1197\u119c\u3486et\u0100;e\u1197\u348d\xf1\u119d\u0180;es\u11a8\u11ad\u3496et\u0100;e\u11a8\u349d\xf1\u11ae\u0180;af\u117b\u34a6\u05b0r\u0165\u34ab\u05b1\xbb\u117car\xf2\u1148\u0200cemt\u34b9\u34be\u34c2\u34c5r;\uc000\ud835\udcc8tm\xee\xf1i\xec\u3415ar\xe6\u11be\u0100ar\u34ce\u34d5r\u0100;f\u34d4\u17bf\u6606\u0100an\u34da\u34edight\u0100ep\u34e3\u34eapsilo\xee\u1ee0h\xe9\u2eafs\xbb\u2852\u0280bcmnp\u34fb\u355e\u1209\u358b\u358e\u0480;Edemnprs\u350e\u350f\u3511\u3515\u351e\u3523\u352c\u3531\u3536\u6282;\u6ac5ot;\u6abd\u0100;d\u11da\u351aot;\u6ac3ult;\u6ac1\u0100Ee\u3528\u352a;\u6acb;\u628alus;\u6abfarr;\u6979\u0180eiu\u353d\u3552\u3555t\u0180;en\u350e\u3545\u354bq\u0100;q\u11da\u350feq\u0100;q\u352b\u3528m;\u6ac7\u0100bp\u355a\u355c;\u6ad5;\u6ad3c\u0300;acens\u11ed\u356c\u3572\u3579\u357b\u3326ppro\xf8\u32faurlye\xf1\u11fe\xf1\u11f3\u0180aes\u3582\u3588\u331bppro\xf8\u331aq\xf1\u3317g;\u666a\u0680123;Edehlmnps\u35a9\u35ac\u35af\u121c\u35b2\u35b4\u35c0\u35c9\u35d5\u35da\u35df\u35e8\u35ed\u803b\xb9\u40b9\u803b\xb2\u40b2\u803b\xb3\u40b3;\u6ac6\u0100os\u35b9\u35bct;\u6abeub;\u6ad8\u0100;d\u1222\u35c5ot;\u6ac4s\u0100ou\u35cf\u35d2l;\u67c9b;\u6ad7arr;\u697bult;\u6ac2\u0100Ee\u35e4\u35e6;\u6acc;\u628blus;\u6ac0\u0180eiu\u35f4\u3609\u360ct\u0180;en\u121c\u35fc\u3602q\u0100;q\u1222\u35b2eq\u0100;q\u35e7\u35e4m;\u6ac8\u0100bp\u3611\u3613;\u6ad4;\u6ad6\u0180Aan\u361c\u3620\u362drr;\u61d9r\u0100hr\u3626\u3628\xeb\u222e\u0100;o\u0a2b\u0a29war;\u692alig\u803b\xdf\u40df\u0be1\u3651\u365d\u3660\u12ce\u3673\u3679\0\u367e\u36c2\0\0\0\0\0\u36db\u3703\0\u3709\u376c\0\0\0\u3787\u0272\u3656\0\0\u365bget;\u6316;\u43c4r\xeb\u0e5f\u0180aey\u3666\u366b\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uc000\ud835\udd31\u0200eiko\u3686\u369d\u36b5\u36bc\u01f2\u368b\0\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369b\u43b8ym;\u43d1\u0100cn\u36a2\u36b2k\u0100as\u36a8\u36aeppro\xf8\u12c1im\xbb\u12acs\xf0\u129e\u0100as\u36ba\u36ae\xf0\u12c1rn\u803b\xfe\u40fe\u01ec\u031f\u36c6\u22e7es\u8180\xd7;bd\u36cf\u36d0\u36d8\u40d7\u0100;a\u190f\u36d5r;\u6a31;\u6a30\u0180eps\u36e1\u36e3\u3700\xe1\u2a4d\u0200;bcf\u0486\u36ec\u36f0\u36f4ot;\u6336ir;\u6af1\u0100;o\u36f9\u36fc\uc000\ud835\udd65rk;\u6ada\xe1\u3362rime;\u6034\u0180aip\u370f\u3712\u3764d\xe5\u1248\u0380adempst\u3721\u374d\u3740\u3751\u3757\u375c\u375fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65b5own\xbb\u1dbbeft\u0100;e\u2800\u373e\xf1\u092e;\u625cight\u0100;e\u32aa\u374b\xf1\u105aot;\u65ecinus;\u6a3alus;\u6a39b;\u69cdime;\u6a3bezium;\u63e2\u0180cht\u3772\u377d\u3781\u0100ry\u3777\u377b;\uc000\ud835\udcc9;\u4446cy;\u445brok;\u4167\u0100io\u378b\u378ex\xf4\u1777head\u0100lr\u3797\u37a0eftarro\xf7\u084fightarrow\xbb\u0f5d\u0900AHabcdfghlmoprstuw\u37d0\u37d3\u37d7\u37e4\u37f0\u37fc\u380e\u381c\u3823\u3834\u3851\u385d\u386b\u38a9\u38cc\u38d2\u38ea\u38f6r\xf2\u03edar;\u6963\u0100cr\u37dc\u37e2ute\u803b\xfa\u40fa\xf2\u1150r\u01e3\u37ea\0\u37edy;\u445eve;\u416d\u0100iy\u37f5\u37farc\u803b\xfb\u40fb;\u4443\u0180abh\u3803\u3806\u380br\xf2\u13adlac;\u4171a\xf2\u13c3\u0100ir\u3813\u3818sht;\u697e;\uc000\ud835\udd32rave\u803b\xf9\u40f9\u0161\u3827\u3831r\u0100lr\u382c\u382e\xbb\u0957\xbb\u1083lk;\u6580\u0100ct\u3839\u384d\u026f\u383f\0\0\u384arn\u0100;e\u3845\u3846\u631cr\xbb\u3846op;\u630fri;\u65f8\u0100al\u3856\u385acr;\u416b\u80bb\xa8\u0349\u0100gp\u3862\u3866on;\u4173f;\uc000\ud835\udd66\u0300adhlsu\u114b\u3878\u387d\u1372\u3891\u38a0own\xe1\u13b3arpoon\u0100lr\u3888\u388cef\xf4\u382digh\xf4\u382fi\u0180;hl\u3899\u389a\u389c\u43c5\xbb\u13faon\xbb\u389aparrows;\u61c8\u0180cit\u38b0\u38c4\u38c8\u026f\u38b6\0\0\u38c1rn\u0100;e\u38bc\u38bd\u631dr\xbb\u38bdop;\u630eng;\u416fri;\u65f9cr;\uc000\ud835\udcca\u0180dir\u38d9\u38dd\u38e2ot;\u62f0lde;\u4169i\u0100;f\u3730\u38e8\xbb\u1813\u0100am\u38ef\u38f2r\xf2\u38a8l\u803b\xfc\u40fcangle;\u69a7\u0780ABDacdeflnoprsz\u391c\u391f\u3929\u392d\u39b5\u39b8\u39bd\u39df\u39e4\u39e8\u39f3\u39f9\u39fd\u3a01\u3a20r\xf2\u03f7ar\u0100;v\u3926\u3927\u6ae8;\u6ae9as\xe8\u03e1\u0100nr\u3932\u3937grt;\u699c\u0380eknprst\u34e3\u3946\u394b\u3952\u395d\u3964\u3996app\xe1\u2415othin\xe7\u1e96\u0180hir\u34eb\u2ec8\u3959op\xf4\u2fb5\u0100;h\u13b7\u3962\xef\u318d\u0100iu\u3969\u396dgm\xe1\u33b3\u0100bp\u3972\u3984setneq\u0100;q\u397d\u3980\uc000\u228a\ufe00;\uc000\u2acb\ufe00setneq\u0100;q\u398f\u3992\uc000\u228b\ufe00;\uc000\u2acc\ufe00\u0100hr\u399b\u399fet\xe1\u369ciangle\u0100lr\u39aa\u39afeft\xbb\u0925ight\xbb\u1051y;\u4432ash\xbb\u1036\u0180elr\u39c4\u39d2\u39d7\u0180;be\u2dea\u39cb\u39cfar;\u62bbq;\u625alip;\u62ee\u0100bt\u39dc\u1468a\xf2\u1469r;\uc000\ud835\udd33tr\xe9\u39aesu\u0100bp\u39ef\u39f1\xbb\u0d1c\xbb\u0d59pf;\uc000\ud835\udd67ro\xf0\u0efbtr\xe9\u39b4\u0100cu\u3a06\u3a0br;\uc000\ud835\udccb\u0100bp\u3a10\u3a18n\u0100Ee\u3980\u3a16\xbb\u397en\u0100Ee\u3992\u3a1e\xbb\u3990igzag;\u699a\u0380cefoprs\u3a36\u3a3b\u3a56\u3a5b\u3a54\u3a61\u3a6airc;\u4175\u0100di\u3a40\u3a51\u0100bg\u3a45\u3a49ar;\u6a5fe\u0100;q\u15fa\u3a4f;\u6259erp;\u6118r;\uc000\ud835\udd34pf;\uc000\ud835\udd68\u0100;e\u1479\u3a66at\xe8\u1479cr;\uc000\ud835\udccc\u0ae3\u178e\u3a87\0\u3a8b\0\u3a90\u3a9b\0\0\u3a9d\u3aa8\u3aab\u3aaf\0\0\u3ac3\u3ace\0\u3ad8\u17dc\u17dftr\xe9\u17d1r;\uc000\ud835\udd35\u0100Aa\u3a94\u3a97r\xf2\u03c3r\xf2\u09f6;\u43be\u0100Aa\u3aa1\u3aa4r\xf2\u03b8r\xf2\u09eba\xf0\u2713is;\u62fb\u0180dpt\u17a4\u3ab5\u3abe\u0100fl\u3aba\u17a9;\uc000\ud835\udd69im\xe5\u17b2\u0100Aa\u3ac7\u3acar\xf2\u03cer\xf2\u0a01\u0100cq\u3ad2\u17b8r;\uc000\ud835\udccd\u0100pt\u17d6\u3adcr\xe9\u17d4\u0400acefiosu\u3af0\u3afd\u3b08\u3b0c\u3b11\u3b15\u3b1b\u3b21c\u0100uy\u3af6\u3afbte\u803b\xfd\u40fd;\u444f\u0100iy\u3b02\u3b06rc;\u4177;\u444bn\u803b\xa5\u40a5r;\uc000\ud835\udd36cy;\u4457pf;\uc000\ud835\udd6acr;\uc000\ud835\udcce\u0100cm\u3b26\u3b29y;\u444el\u803b\xff\u40ff\u0500acdefhiosw\u3b42\u3b48\u3b54\u3b58\u3b64\u3b69\u3b6d\u3b74\u3b7a\u3b80cute;\u417a\u0100ay\u3b4d\u3b52ron;\u417e;\u4437ot;\u417c\u0100et\u3b5d\u3b61tr\xe6\u155fa;\u43b6r;\uc000\ud835\udd37cy;\u4436grarr;\u61ddpf;\uc000\ud835\udd6bcr;\uc000\ud835\udccf\u0100jn\u3b85\u3b87;\u600dj;\u600c".split("").map(function(c) {
    return c.charCodeAt(0);
}));

});

parcelRegister("cziBi", function(module, exports) {
"use strict";
// Generated using scripts/write-decode-map.ts
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = new Uint16Array(// prettier-ignore
"\u0200aglq\t\x15\x18\x1b\u026d\x0f\0\0\x12p;\u4026os;\u4027t;\u403et;\u403cuot;\u4022".split("").map(function(c) {
    return c.charCodeAt(0);
}));

});

parcelRegister("6DwAw", function(module, exports) {
"use strict";
// Adapted from https://github.com/mathiasbynens/he/blob/36afe179392226cf1b6ccdb16ebbb7a5a844d93a/src/he.js#L106-L134
var $4d4fa9e4a7c3cec6$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.replaceCodePoint = module.exports.fromCodePoint = void 0;
var $4d4fa9e4a7c3cec6$var$decodeMap = new Map([
    [
        0,
        65533
    ],
    // C1 Unicode control character reference replacements
    [
        128,
        8364
    ],
    [
        130,
        8218
    ],
    [
        131,
        402
    ],
    [
        132,
        8222
    ],
    [
        133,
        8230
    ],
    [
        134,
        8224
    ],
    [
        135,
        8225
    ],
    [
        136,
        710
    ],
    [
        137,
        8240
    ],
    [
        138,
        352
    ],
    [
        139,
        8249
    ],
    [
        140,
        338
    ],
    [
        142,
        381
    ],
    [
        145,
        8216
    ],
    [
        146,
        8217
    ],
    [
        147,
        8220
    ],
    [
        148,
        8221
    ],
    [
        149,
        8226
    ],
    [
        150,
        8211
    ],
    [
        151,
        8212
    ],
    [
        152,
        732
    ],
    [
        153,
        8482
    ],
    [
        154,
        353
    ],
    [
        155,
        8250
    ],
    [
        156,
        339
    ],
    [
        158,
        382
    ],
    [
        159,
        376
    ]
]);
/**
 * Polyfill for `String.fromCodePoint`. It is used to create a string from a Unicode code point.
 */ module.exports.fromCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
($4d4fa9e4a7c3cec6$var$_a = String.fromCodePoint) !== null && $4d4fa9e4a7c3cec6$var$_a !== void 0 ? $4d4fa9e4a7c3cec6$var$_a : function(codePoint) {
    var output = "";
    if (codePoint > 0xffff) {
        codePoint -= 0x10000;
        output += String.fromCharCode(codePoint >>> 10 & 0x3ff | 0xd800);
        codePoint = 0xdc00 | codePoint & 0x3ff;
    }
    output += String.fromCharCode(codePoint);
    return output;
};
/**
 * Replace the given code point with a replacement character if it is a
 * surrogate or is outside the valid range. Otherwise return the code
 * point unchanged.
 */ function $4d4fa9e4a7c3cec6$var$replaceCodePoint(codePoint) {
    var _a;
    if (codePoint >= 0xd800 && codePoint <= 0xdfff || codePoint > 0x10ffff) return 0xfffd;
    return (_a = $4d4fa9e4a7c3cec6$var$decodeMap.get(codePoint)) !== null && _a !== void 0 ? _a : codePoint;
}
module.exports.replaceCodePoint = $4d4fa9e4a7c3cec6$var$replaceCodePoint;
/**
 * Replace the code point if relevant, then convert it to a string.
 *
 * @deprecated Use `fromCodePoint(replaceCodePoint(codePoint))` instead.
 * @param codePoint The code point to decode.
 * @returns The decoded code point.
 */ function $4d4fa9e4a7c3cec6$var$decodeCodePoint(codePoint) {
    return (0, module.exports.fromCodePoint)($4d4fa9e4a7c3cec6$var$replaceCodePoint(codePoint));
}
module.exports.default = $4d4fa9e4a7c3cec6$var$decodeCodePoint;

});

var $3581ee5e9a4ae8b2$exports = {};
(function() {
    /**
 * A convenience function for configuring and constructing
 * a new lunr Index.
 *
 * A lunr.Builder instance is created and the pipeline setup
 * with a trimmer, stop word filter and stemmer.
 *
 * This builder object is yielded to the configuration function
 * that is passed as a parameter, allowing the list of fields
 * and other builder parameters to be customised.
 *
 * All documents _must_ be added within the passed config function.
 *
 * @example
 * var idx = lunr(function () {
 *   this.field('title')
 *   this.field('body')
 *   this.ref('id')
 *
 *   documents.forEach(function (doc) {
 *     this.add(doc)
 *   }, this)
 * })
 *
 * @see {@link lunr.Builder}
 * @see {@link lunr.Pipeline}
 * @see {@link lunr.trimmer}
 * @see {@link lunr.stopWordFilter}
 * @see {@link lunr.stemmer}
 * @namespace {function} lunr
 */ var lunr = function(config) {
        var builder = new lunr.Builder;
        builder.pipeline.add(lunr.trimmer, lunr.stopWordFilter, lunr.stemmer);
        builder.searchPipeline.add(lunr.stemmer);
        config.call(builder, builder);
        return builder.build();
    };
    lunr.version = "2.3.9";
    /*!
 * lunr.utils
 * Copyright (C) 2020 Oliver Nightingale
 */ /**
 * A namespace containing utils for the rest of the lunr library
 * @namespace lunr.utils
 */ lunr.utils = {};
    /**
 * Print a warning message to the console.
 *
 * @param {String} message The message to be printed.
 * @memberOf lunr.utils
 * @function
 */ lunr.utils.warn = function(global) {
        /* eslint-disable no-console */ return function(message) {
            if (global.console && console.warn) console.warn(message);
        };
    /* eslint-enable no-console */ }(this);
    /**
 * Convert an object to a string.
 *
 * In the case of `null` and `undefined` the function returns
 * the empty string, in all other cases the result of calling
 * `toString` on the passed object is returned.
 *
 * @param {Any} obj The object to convert to a string.
 * @return {String} string representation of the passed object.
 * @memberOf lunr.utils
 */ lunr.utils.asString = function(obj) {
        if (obj === void 0 || obj === null) return "";
        else return obj.toString();
    };
    /**
 * Clones an object.
 *
 * Will create a copy of an existing object such that any mutations
 * on the copy cannot affect the original.
 *
 * Only shallow objects are supported, passing a nested object to this
 * function will cause a TypeError.
 *
 * Objects with primitives, and arrays of primitives are supported.
 *
 * @param {Object} obj The object to clone.
 * @return {Object} a clone of the passed object.
 * @throws {TypeError} when a nested object is passed.
 * @memberOf Utils
 */ lunr.utils.clone = function(obj) {
        if (obj === null || obj === undefined) return obj;
        var clone = Object.create(null), keys = Object.keys(obj);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i], val = obj[key];
            if (Array.isArray(val)) {
                clone[key] = val.slice();
                continue;
            }
            if (typeof val === 'string' || typeof val === 'number' || typeof val === 'boolean') {
                clone[key] = val;
                continue;
            }
            throw new TypeError("clone is not deep and does not support nested objects");
        }
        return clone;
    };
    lunr.FieldRef = function(docRef, fieldName, stringValue) {
        this.docRef = docRef;
        this.fieldName = fieldName;
        this._stringValue = stringValue;
    };
    lunr.FieldRef.joiner = "/";
    lunr.FieldRef.fromString = function(s) {
        var n = s.indexOf(lunr.FieldRef.joiner);
        if (n === -1) throw "malformed field ref string";
        var fieldRef = s.slice(0, n), docRef = s.slice(n + 1);
        return new lunr.FieldRef(docRef, fieldRef, s);
    };
    lunr.FieldRef.prototype.toString = function() {
        if (this._stringValue == undefined) this._stringValue = this.fieldName + lunr.FieldRef.joiner + this.docRef;
        return this._stringValue;
    };
    /*!
 * lunr.Set
 * Copyright (C) 2020 Oliver Nightingale
 */ /**
 * A lunr set.
 *
 * @constructor
 */ lunr.Set = function(elements) {
        this.elements = Object.create(null);
        if (elements) {
            this.length = elements.length;
            for(var i = 0; i < this.length; i++)this.elements[elements[i]] = true;
        } else this.length = 0;
    };
    /**
 * A complete set that contains all elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */ lunr.Set.complete = {
        intersect: function(other) {
            return other;
        },
        union: function() {
            return this;
        },
        contains: function() {
            return true;
        }
    };
    /**
 * An empty set that contains no elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */ lunr.Set.empty = {
        intersect: function() {
            return this;
        },
        union: function(other) {
            return other;
        },
        contains: function() {
            return false;
        }
    };
    /**
 * Returns true if this set contains the specified object.
 *
 * @param {object} object - Object whose presence in this set is to be tested.
 * @returns {boolean} - True if this set contains the specified object.
 */ lunr.Set.prototype.contains = function(object) {
        return !!this.elements[object];
    };
    /**
 * Returns a new set containing only the elements that are present in both
 * this set and the specified set.
 *
 * @param {lunr.Set} other - set to intersect with this set.
 * @returns {lunr.Set} a new set that is the intersection of this and the specified set.
 */ lunr.Set.prototype.intersect = function(other) {
        var a, b, elements, intersection = [];
        if (other === lunr.Set.complete) return this;
        if (other === lunr.Set.empty) return other;
        if (this.length < other.length) {
            a = this;
            b = other;
        } else {
            a = other;
            b = this;
        }
        elements = Object.keys(a.elements);
        for(var i = 0; i < elements.length; i++){
            var element = elements[i];
            if (element in b.elements) intersection.push(element);
        }
        return new lunr.Set(intersection);
    };
    /**
 * Returns a new set combining the elements of this and the specified set.
 *
 * @param {lunr.Set} other - set to union with this set.
 * @return {lunr.Set} a new set that is the union of this and the specified set.
 */ lunr.Set.prototype.union = function(other) {
        if (other === lunr.Set.complete) return lunr.Set.complete;
        if (other === lunr.Set.empty) return this;
        return new lunr.Set(Object.keys(this.elements).concat(Object.keys(other.elements)));
    };
    /**
 * A function to calculate the inverse document frequency for
 * a posting. This is shared between the builder and the index
 *
 * @private
 * @param {object} posting - The posting for a given term
 * @param {number} documentCount - The total number of documents.
 */ lunr.idf = function(posting, documentCount) {
        var documentsWithTerm = 0;
        for(var fieldName in posting){
            if (fieldName == '_index') continue; // Ignore the term index, its not a field
            documentsWithTerm += Object.keys(posting[fieldName]).length;
        }
        var x = (documentCount - documentsWithTerm + 0.5) / (documentsWithTerm + 0.5);
        return Math.log(1 + Math.abs(x));
    };
    /**
 * A token wraps a string representation of a token
 * as it is passed through the text processing pipeline.
 *
 * @constructor
 * @param {string} [str=''] - The string token being wrapped.
 * @param {object} [metadata={}] - Metadata associated with this token.
 */ lunr.Token = function(str, metadata) {
        this.str = str || "";
        this.metadata = metadata || {};
    };
    /**
 * Returns the token string that is being wrapped by this object.
 *
 * @returns {string}
 */ lunr.Token.prototype.toString = function() {
        return this.str;
    };
    /**
 * A token update function is used when updating or optionally
 * when cloning a token.
 *
 * @callback lunr.Token~updateFunction
 * @param {string} str - The string representation of the token.
 * @param {Object} metadata - All metadata associated with this token.
 */ /**
 * Applies the given function to the wrapped string token.
 *
 * @example
 * token.update(function (str, metadata) {
 *   return str.toUpperCase()
 * })
 *
 * @param {lunr.Token~updateFunction} fn - A function to apply to the token string.
 * @returns {lunr.Token}
 */ lunr.Token.prototype.update = function(fn) {
        this.str = fn(this.str, this.metadata);
        return this;
    };
    /**
 * Creates a clone of this token. Optionally a function can be
 * applied to the cloned token.
 *
 * @param {lunr.Token~updateFunction} [fn] - An optional function to apply to the cloned token.
 * @returns {lunr.Token}
 */ lunr.Token.prototype.clone = function(fn) {
        fn = fn || function(s) {
            return s;
        };
        return new lunr.Token(fn(this.str, this.metadata), this.metadata);
    };
    /*!
 * lunr.tokenizer
 * Copyright (C) 2020 Oliver Nightingale
 */ /**
 * A function for splitting a string into tokens ready to be inserted into
 * the search index. Uses `lunr.tokenizer.separator` to split strings, change
 * the value of this property to change how strings are split into tokens.
 *
 * This tokenizer will convert its parameter to a string by calling `toString` and
 * then will split this string on the character in `lunr.tokenizer.separator`.
 * Arrays will have their elements converted to strings and wrapped in a lunr.Token.
 *
 * Optional metadata can be passed to the tokenizer, this metadata will be cloned and
 * added as metadata to every token that is created from the object to be tokenized.
 *
 * @static
 * @param {?(string|object|object[])} obj - The object to convert into tokens
 * @param {?object} metadata - Optional metadata to associate with every token
 * @returns {lunr.Token[]}
 * @see {@link lunr.Pipeline}
 */ lunr.tokenizer = function(obj, metadata) {
        if (obj == null || obj == undefined) return [];
        if (Array.isArray(obj)) return obj.map(function(t) {
            return new lunr.Token(lunr.utils.asString(t).toLowerCase(), lunr.utils.clone(metadata));
        });
        var str = obj.toString().toLowerCase(), len = str.length, tokens = [];
        for(var sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++){
            var char = str.charAt(sliceEnd), sliceLength = sliceEnd - sliceStart;
            if (char.match(lunr.tokenizer.separator) || sliceEnd == len) {
                if (sliceLength > 0) {
                    var tokenMetadata = lunr.utils.clone(metadata) || {};
                    tokenMetadata["position"] = [
                        sliceStart,
                        sliceLength
                    ];
                    tokenMetadata["index"] = tokens.length;
                    tokens.push(new lunr.Token(str.slice(sliceStart, sliceEnd), tokenMetadata));
                }
                sliceStart = sliceEnd + 1;
            }
        }
        return tokens;
    };
    /**
 * The separator used to split a string into tokens. Override this property to change the behaviour of
 * `lunr.tokenizer` behaviour when tokenizing strings. By default this splits on whitespace and hyphens.
 *
 * @static
 * @see lunr.tokenizer
 */ lunr.tokenizer.separator = /[\s\-]+/;
    /*!
 * lunr.Pipeline
 * Copyright (C) 2020 Oliver Nightingale
 */ /**
 * lunr.Pipelines maintain an ordered list of functions to be applied to all
 * tokens in documents entering the search index and queries being ran against
 * the index.
 *
 * An instance of lunr.Index created with the lunr shortcut will contain a
 * pipeline with a stop word filter and an English language stemmer. Extra
 * functions can be added before or after either of these functions or these
 * default functions can be removed.
 *
 * When run the pipeline will call each function in turn, passing a token, the
 * index of that token in the original list of all tokens and finally a list of
 * all the original tokens.
 *
 * The output of functions in the pipeline will be passed to the next function
 * in the pipeline. To exclude a token from entering the index the function
 * should return undefined, the rest of the pipeline will not be called with
 * this token.
 *
 * For serialisation of pipelines to work, all functions used in an instance of
 * a pipeline should be registered with lunr.Pipeline. Registered functions can
 * then be loaded. If trying to load a serialised pipeline that uses functions
 * that are not registered an error will be thrown.
 *
 * If not planning on serialising the pipeline then registering pipeline functions
 * is not necessary.
 *
 * @constructor
 */ lunr.Pipeline = function() {
        this._stack = [];
    };
    lunr.Pipeline.registeredFunctions = Object.create(null);
    /**
 * A pipeline function maps lunr.Token to lunr.Token. A lunr.Token contains the token
 * string as well as all known metadata. A pipeline function can mutate the token string
 * or mutate (or add) metadata for a given token.
 *
 * A pipeline function can indicate that the passed token should be discarded by returning
 * null, undefined or an empty string. This token will not be passed to any downstream pipeline
 * functions and will not be added to the index.
 *
 * Multiple tokens can be returned by returning an array of tokens. Each token will be passed
 * to any downstream pipeline functions and all will returned tokens will be added to the index.
 *
 * Any number of pipeline functions may be chained together using a lunr.Pipeline.
 *
 * @interface lunr.PipelineFunction
 * @param {lunr.Token} token - A token from the document being processed.
 * @param {number} i - The index of this token in the complete list of tokens for this document/field.
 * @param {lunr.Token[]} tokens - All tokens for this document/field.
 * @returns {(?lunr.Token|lunr.Token[])}
 */ /**
 * Register a function with the pipeline.
 *
 * Functions that are used in the pipeline should be registered if the pipeline
 * needs to be serialised, or a serialised pipeline needs to be loaded.
 *
 * Registering a function does not add it to a pipeline, functions must still be
 * added to instances of the pipeline for them to be used when running a pipeline.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @param {String} label - The label to register this function with
 */ lunr.Pipeline.registerFunction = function(fn, label) {
        if (label in this.registeredFunctions) lunr.utils.warn('Overwriting existing registered function: ' + label);
        fn.label = label;
        lunr.Pipeline.registeredFunctions[fn.label] = fn;
    };
    /**
 * Warns if the function is not registered as a Pipeline function.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @private
 */ lunr.Pipeline.warnIfFunctionNotRegistered = function(fn) {
        var isRegistered = fn.label && fn.label in this.registeredFunctions;
        if (!isRegistered) lunr.utils.warn('Function is not registered with pipeline. This may cause problems when serialising the index.\n', fn);
    };
    /**
 * Loads a previously serialised pipeline.
 *
 * All functions to be loaded must already be registered with lunr.Pipeline.
 * If any function from the serialised data has not been registered then an
 * error will be thrown.
 *
 * @param {Object} serialised - The serialised pipeline to load.
 * @returns {lunr.Pipeline}
 */ lunr.Pipeline.load = function(serialised) {
        var pipeline = new lunr.Pipeline;
        serialised.forEach(function(fnName) {
            var fn = lunr.Pipeline.registeredFunctions[fnName];
            if (fn) pipeline.add(fn);
            else throw new Error('Cannot load unregistered function: ' + fnName);
        });
        return pipeline;
    };
    /**
 * Adds new functions to the end of the pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction[]} functions - Any number of functions to add to the pipeline.
 */ lunr.Pipeline.prototype.add = function() {
        var fns = Array.prototype.slice.call(arguments);
        fns.forEach(function(fn) {
            lunr.Pipeline.warnIfFunctionNotRegistered(fn);
            this._stack.push(fn);
        }, this);
    };
    /**
 * Adds a single function after a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */ lunr.Pipeline.prototype.after = function(existingFn, newFn) {
        lunr.Pipeline.warnIfFunctionNotRegistered(newFn);
        var pos = this._stack.indexOf(existingFn);
        if (pos == -1) throw new Error('Cannot find existingFn');
        pos = pos + 1;
        this._stack.splice(pos, 0, newFn);
    };
    /**
 * Adds a single function before a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */ lunr.Pipeline.prototype.before = function(existingFn, newFn) {
        lunr.Pipeline.warnIfFunctionNotRegistered(newFn);
        var pos = this._stack.indexOf(existingFn);
        if (pos == -1) throw new Error('Cannot find existingFn');
        this._stack.splice(pos, 0, newFn);
    };
    /**
 * Removes a function from the pipeline.
 *
 * @param {lunr.PipelineFunction} fn The function to remove from the pipeline.
 */ lunr.Pipeline.prototype.remove = function(fn) {
        var pos = this._stack.indexOf(fn);
        if (pos == -1) return;
        this._stack.splice(pos, 1);
    };
    /**
 * Runs the current list of functions that make up the pipeline against the
 * passed tokens.
 *
 * @param {Array} tokens The tokens to run through the pipeline.
 * @returns {Array}
 */ lunr.Pipeline.prototype.run = function(tokens) {
        var stackLength = this._stack.length;
        for(var i = 0; i < stackLength; i++){
            var fn = this._stack[i];
            var memo = [];
            for(var j = 0; j < tokens.length; j++){
                var result = fn(tokens[j], j, tokens);
                if (result === null || result === void 0 || result === '') continue;
                if (Array.isArray(result)) for(var k = 0; k < result.length; k++)memo.push(result[k]);
                else memo.push(result);
            }
            tokens = memo;
        }
        return tokens;
    };
    /**
 * Convenience method for passing a string through a pipeline and getting
 * strings out. This method takes care of wrapping the passed string in a
 * token and mapping the resulting tokens back to strings.
 *
 * @param {string} str - The string to pass through the pipeline.
 * @param {?object} metadata - Optional metadata to associate with the token
 * passed to the pipeline.
 * @returns {string[]}
 */ lunr.Pipeline.prototype.runString = function(str, metadata) {
        var token = new lunr.Token(str, metadata);
        return this.run([
            token
        ]).map(function(t) {
            return t.toString();
        });
    };
    /**
 * Resets the pipeline by removing any existing processors.
 *
 */ lunr.Pipeline.prototype.reset = function() {
        this._stack = [];
    };
    /**
 * Returns a representation of the pipeline ready for serialisation.
 *
 * Logs a warning if the function has not been registered.
 *
 * @returns {Array}
 */ lunr.Pipeline.prototype.toJSON = function() {
        return this._stack.map(function(fn) {
            lunr.Pipeline.warnIfFunctionNotRegistered(fn);
            return fn.label;
        });
    };
    /*!
 * lunr.Vector
 * Copyright (C) 2020 Oliver Nightingale
 */ /**
 * A vector is used to construct the vector space of documents and queries. These
 * vectors support operations to determine the similarity between two documents or
 * a document and a query.
 *
 * Normally no parameters are required for initializing a vector, but in the case of
 * loading a previously dumped vector the raw elements can be provided to the constructor.
 *
 * For performance reasons vectors are implemented with a flat array, where an elements
 * index is immediately followed by its value. E.g. [index, value, index, value]. This
 * allows the underlying array to be as sparse as possible and still offer decent
 * performance when being used for vector calculations.
 *
 * @constructor
 * @param {Number[]} [elements] - The flat list of element index and element value pairs.
 */ lunr.Vector = function(elements) {
        this._magnitude = 0;
        this.elements = elements || [];
    };
    /**
 * Calculates the position within the vector to insert a given index.
 *
 * This is used internally by insert and upsert. If there are duplicate indexes then
 * the position is returned as if the value for that index were to be updated, but it
 * is the callers responsibility to check whether there is a duplicate at that index
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @returns {Number}
 */ lunr.Vector.prototype.positionForIndex = function(index) {
        // For an empty vector the tuple can be inserted at the beginning
        if (this.elements.length == 0) return 0;
        var start = 0, end = this.elements.length / 2, sliceLength = end - start, pivotPoint = Math.floor(sliceLength / 2), pivotIndex = this.elements[pivotPoint * 2];
        while(sliceLength > 1){
            if (pivotIndex < index) start = pivotPoint;
            if (pivotIndex > index) end = pivotPoint;
            if (pivotIndex == index) break;
            sliceLength = end - start;
            pivotPoint = start + Math.floor(sliceLength / 2);
            pivotIndex = this.elements[pivotPoint * 2];
        }
        if (pivotIndex == index) return pivotPoint * 2;
        if (pivotIndex > index) return pivotPoint * 2;
        if (pivotIndex < index) return (pivotPoint + 1) * 2;
    };
    /**
 * Inserts an element at an index within the vector.
 *
 * Does not allow duplicates, will throw an error if there is already an entry
 * for this index.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 */ lunr.Vector.prototype.insert = function(insertIdx, val) {
        this.upsert(insertIdx, val, function() {
            throw "duplicate index";
        });
    };
    /**
 * Inserts or updates an existing index within the vector.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 * @param {function} fn - A function that is called for updates, the existing value and the
 * requested value are passed as arguments
 */ lunr.Vector.prototype.upsert = function(insertIdx, val, fn) {
        this._magnitude = 0;
        var position = this.positionForIndex(insertIdx);
        if (this.elements[position] == insertIdx) this.elements[position + 1] = fn(this.elements[position + 1], val);
        else this.elements.splice(position, 0, insertIdx, val);
    };
    /**
 * Calculates the magnitude of this vector.
 *
 * @returns {Number}
 */ lunr.Vector.prototype.magnitude = function() {
        if (this._magnitude) return this._magnitude;
        var sumOfSquares = 0, elementsLength = this.elements.length;
        for(var i = 1; i < elementsLength; i += 2){
            var val = this.elements[i];
            sumOfSquares += val * val;
        }
        return this._magnitude = Math.sqrt(sumOfSquares);
    };
    /**
 * Calculates the dot product of this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The vector to compute the dot product with.
 * @returns {Number}
 */ lunr.Vector.prototype.dot = function(otherVector) {
        var dotProduct = 0, a = this.elements, b = otherVector.elements, aLen = a.length, bLen = b.length, aVal = 0, bVal = 0, i = 0, j = 0;
        while(i < aLen && j < bLen){
            aVal = a[i], bVal = b[j];
            if (aVal < bVal) i += 2;
            else if (aVal > bVal) j += 2;
            else if (aVal == bVal) {
                dotProduct += a[i + 1] * b[j + 1];
                i += 2;
                j += 2;
            }
        }
        return dotProduct;
    };
    /**
 * Calculates the similarity between this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The other vector to calculate the
 * similarity with.
 * @returns {Number}
 */ lunr.Vector.prototype.similarity = function(otherVector) {
        return this.dot(otherVector) / this.magnitude() || 0;
    };
    /**
 * Converts the vector to an array of the elements within the vector.
 *
 * @returns {Number[]}
 */ lunr.Vector.prototype.toArray = function() {
        var output = new Array(this.elements.length / 2);
        for(var i = 1, j = 0; i < this.elements.length; i += 2, j++)output[j] = this.elements[i];
        return output;
    };
    /**
 * A JSON serializable representation of the vector.
 *
 * @returns {Number[]}
 */ lunr.Vector.prototype.toJSON = function() {
        return this.elements;
    };
    /* eslint-disable */ /*!
 * lunr.stemmer
 * Copyright (C) 2020 Oliver Nightingale
 * Includes code from - http://tartarus.org/~martin/PorterStemmer/js.txt
 */ /**
 * lunr.stemmer is an english language stemmer, this is a JavaScript
 * implementation of the PorterStemmer taken from http://tartarus.org/~martin
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token - The string to stem
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 * @function
 */ lunr.stemmer = function() {
        var step2list = {
            "ational": "ate",
            "tional": "tion",
            "enci": "ence",
            "anci": "ance",
            "izer": "ize",
            "bli": "ble",
            "alli": "al",
            "entli": "ent",
            "eli": "e",
            "ousli": "ous",
            "ization": "ize",
            "ation": "ate",
            "ator": "ate",
            "alism": "al",
            "iveness": "ive",
            "fulness": "ful",
            "ousness": "ous",
            "aliti": "al",
            "iviti": "ive",
            "biliti": "ble",
            "logi": "log"
        }, step3list = {
            "icate": "ic",
            "ative": "",
            "alize": "al",
            "iciti": "ic",
            "ical": "ic",
            "ful": "",
            "ness": ""
        }, c = "[^aeiou]", v = "[aeiouy]", C = c + "[^aeiouy]*", V = v + "[aeiou]*", mgr0 = "^(" + C + ")?" + V + C, meq1 = "^(" + C + ")?" + V + C + "(" + V + ")?$", mgr1 = "^(" + C + ")?" + V + C + V + C, s_v = "^(" + C + ")?" + v; // vowel in stem
        var re_mgr0 = new RegExp(mgr0);
        var re_mgr1 = new RegExp(mgr1);
        var re_meq1 = new RegExp(meq1);
        var re_s_v = new RegExp(s_v);
        var re_1a = /^(.+?)(ss|i)es$/;
        var re2_1a = /^(.+?)([^s])s$/;
        var re_1b = /^(.+?)eed$/;
        var re2_1b = /^(.+?)(ed|ing)$/;
        var re_1b_2 = /.$/;
        var re2_1b_2 = /(at|bl|iz)$/;
        var re3_1b_2 = new RegExp("([^aeiouylsz])\\1$");
        var re4_1b_2 = new RegExp("^" + C + v + "[^aeiouwxy]$");
        var re_1c = /^(.+?[^aeiou])y$/;
        var re_2 = /^(.+?)(ational|tional|enci|anci|izer|bli|alli|entli|eli|ousli|ization|ation|ator|alism|iveness|fulness|ousness|aliti|iviti|biliti|logi)$/;
        var re_3 = /^(.+?)(icate|ative|alize|iciti|ical|ful|ness)$/;
        var re_4 = /^(.+?)(al|ance|ence|er|ic|able|ible|ant|ement|ment|ent|ou|ism|ate|iti|ous|ive|ize)$/;
        var re2_4 = /^(.+?)(s|t)(ion)$/;
        var re_5 = /^(.+?)e$/;
        var re_5_1 = /ll$/;
        var re3_5 = new RegExp("^" + C + v + "[^aeiouwxy]$");
        var porterStemmer = function porterStemmer(w) {
            var stem, suffix, firstch, re, re2, re3, re4;
            if (w.length < 3) return w;
            firstch = w.substr(0, 1);
            if (firstch == "y") w = firstch.toUpperCase() + w.substr(1);
            // Step 1a
            re = re_1a;
            re2 = re2_1a;
            if (re.test(w)) w = w.replace(re, "$1$2");
            else if (re2.test(w)) w = w.replace(re2, "$1$2");
            // Step 1b
            re = re_1b;
            re2 = re2_1b;
            if (re.test(w)) {
                var fp = re.exec(w);
                re = re_mgr0;
                if (re.test(fp[1])) {
                    re = re_1b_2;
                    w = w.replace(re, "");
                }
            } else if (re2.test(w)) {
                var fp = re2.exec(w);
                stem = fp[1];
                re2 = re_s_v;
                if (re2.test(stem)) {
                    w = stem;
                    re2 = re2_1b_2;
                    re3 = re3_1b_2;
                    re4 = re4_1b_2;
                    if (re2.test(w)) w = w + "e";
                    else if (re3.test(w)) {
                        re = re_1b_2;
                        w = w.replace(re, "");
                    } else if (re4.test(w)) w = w + "e";
                }
            }
            // Step 1c - replace suffix y or Y by i if preceded by a non-vowel which is not the first letter of the word (so cry -> cri, by -> by, say -> say)
            re = re_1c;
            if (re.test(w)) {
                var fp = re.exec(w);
                stem = fp[1];
                w = stem + "i";
            }
            // Step 2
            re = re_2;
            if (re.test(w)) {
                var fp = re.exec(w);
                stem = fp[1];
                suffix = fp[2];
                re = re_mgr0;
                if (re.test(stem)) w = stem + step2list[suffix];
            }
            // Step 3
            re = re_3;
            if (re.test(w)) {
                var fp = re.exec(w);
                stem = fp[1];
                suffix = fp[2];
                re = re_mgr0;
                if (re.test(stem)) w = stem + step3list[suffix];
            }
            // Step 4
            re = re_4;
            re2 = re2_4;
            if (re.test(w)) {
                var fp = re.exec(w);
                stem = fp[1];
                re = re_mgr1;
                if (re.test(stem)) w = stem;
            } else if (re2.test(w)) {
                var fp = re2.exec(w);
                stem = fp[1] + fp[2];
                re2 = re_mgr1;
                if (re2.test(stem)) w = stem;
            }
            // Step 5
            re = re_5;
            if (re.test(w)) {
                var fp = re.exec(w);
                stem = fp[1];
                re = re_mgr1;
                re2 = re_meq1;
                re3 = re3_5;
                if (re.test(stem) || re2.test(stem) && !re3.test(stem)) w = stem;
            }
            re = re_5_1;
            re2 = re_mgr1;
            if (re.test(w) && re2.test(w)) {
                re = re_1b_2;
                w = w.replace(re, "");
            }
            // and turn initial Y back to y
            if (firstch == "y") w = firstch.toLowerCase() + w.substr(1);
            return w;
        };
        return function(token) {
            return token.update(porterStemmer);
        };
    }();
    lunr.Pipeline.registerFunction(lunr.stemmer, 'stemmer');
    /*!
 * lunr.stopWordFilter
 * Copyright (C) 2020 Oliver Nightingale
 */ /**
 * lunr.generateStopWordFilter builds a stopWordFilter function from the provided
 * list of stop words.
 *
 * The built in lunr.stopWordFilter is built using this generator and can be used
 * to generate custom stopWordFilters for applications or non English languages.
 *
 * @function
 * @param {Array} token The token to pass through the filter
 * @returns {lunr.PipelineFunction}
 * @see lunr.Pipeline
 * @see lunr.stopWordFilter
 */ lunr.generateStopWordFilter = function(stopWords) {
        var words = stopWords.reduce(function(memo, stopWord) {
            memo[stopWord] = stopWord;
            return memo;
        }, {});
        return function(token) {
            if (token && words[token.toString()] !== token.toString()) return token;
        };
    };
    /**
 * lunr.stopWordFilter is an English language stop word list filter, any words
 * contained in the list will not be passed through the filter.
 *
 * This is intended to be used in the Pipeline. If the token does not pass the
 * filter then undefined will be returned.
 *
 * @function
 * @implements {lunr.PipelineFunction}
 * @params {lunr.Token} token - A token to check for being a stop word.
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 */ lunr.stopWordFilter = lunr.generateStopWordFilter([
        'a',
        'able',
        'about',
        'across',
        'after',
        'all',
        'almost',
        'also',
        'am',
        'among',
        'an',
        'and',
        'any',
        'are',
        'as',
        'at',
        'be',
        'because',
        'been',
        'but',
        'by',
        'can',
        'cannot',
        'could',
        'dear',
        'did',
        'do',
        'does',
        'either',
        'else',
        'ever',
        'every',
        'for',
        'from',
        'get',
        'got',
        'had',
        'has',
        'have',
        'he',
        'her',
        'hers',
        'him',
        'his',
        'how',
        'however',
        'i',
        'if',
        'in',
        'into',
        'is',
        'it',
        'its',
        'just',
        'least',
        'let',
        'like',
        'likely',
        'may',
        'me',
        'might',
        'most',
        'must',
        'my',
        'neither',
        'no',
        'nor',
        'not',
        'of',
        'off',
        'often',
        'on',
        'only',
        'or',
        'other',
        'our',
        'own',
        'rather',
        'said',
        'say',
        'says',
        'she',
        'should',
        'since',
        'so',
        'some',
        'than',
        'that',
        'the',
        'their',
        'them',
        'then',
        'there',
        'these',
        'they',
        'this',
        'tis',
        'to',
        'too',
        'twas',
        'us',
        'wants',
        'was',
        'we',
        'were',
        'what',
        'when',
        'where',
        'which',
        'while',
        'who',
        'whom',
        'why',
        'will',
        'with',
        'would',
        'yet',
        'you',
        'your'
    ]);
    lunr.Pipeline.registerFunction(lunr.stopWordFilter, 'stopWordFilter');
    /*!
 * lunr.trimmer
 * Copyright (C) 2020 Oliver Nightingale
 */ /**
 * lunr.trimmer is a pipeline function for trimming non word
 * characters from the beginning and end of tokens before they
 * enter the index.
 *
 * This implementation may not work correctly for non latin
 * characters and should either be removed or adapted for use
 * with languages with non-latin characters.
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token The token to pass through the filter
 * @returns {lunr.Token}
 * @see lunr.Pipeline
 */ lunr.trimmer = function(token) {
        return token.update(function(s) {
            return s.replace(/^\W+/, '').replace(/\W+$/, '');
        });
    };
    lunr.Pipeline.registerFunction(lunr.trimmer, 'trimmer');
    /*!
 * lunr.TokenSet
 * Copyright (C) 2020 Oliver Nightingale
 */ /**
 * A token set is used to store the unique list of all tokens
 * within an index. Token sets are also used to represent an
 * incoming query to the index, this query token set and index
 * token set are then intersected to find which tokens to look
 * up in the inverted index.
 *
 * A token set can hold multiple tokens, as in the case of the
 * index token set, or it can hold a single token as in the
 * case of a simple query token set.
 *
 * Additionally token sets are used to perform wildcard matching.
 * Leading, contained and trailing wildcards are supported, and
 * from this edit distance matching can also be provided.
 *
 * Token sets are implemented as a minimal finite state automata,
 * where both common prefixes and suffixes are shared between tokens.
 * This helps to reduce the space used for storing the token set.
 *
 * @constructor
 */ lunr.TokenSet = function() {
        this.final = false;
        this.edges = {};
        this.id = lunr.TokenSet._nextId;
        lunr.TokenSet._nextId += 1;
    };
    /**
 * Keeps track of the next, auto increment, identifier to assign
 * to a new tokenSet.
 *
 * TokenSets require a unique identifier to be correctly minimised.
 *
 * @private
 */ lunr.TokenSet._nextId = 1;
    /**
 * Creates a TokenSet instance from the given sorted array of words.
 *
 * @param {String[]} arr - A sorted array of strings to create the set from.
 * @returns {lunr.TokenSet}
 * @throws Will throw an error if the input array is not sorted.
 */ lunr.TokenSet.fromArray = function(arr) {
        var builder = new lunr.TokenSet.Builder;
        for(var i = 0, len = arr.length; i < len; i++)builder.insert(arr[i]);
        builder.finish();
        return builder.root;
    };
    /**
 * Creates a token set from a query clause.
 *
 * @private
 * @param {Object} clause - A single clause from lunr.Query.
 * @param {string} clause.term - The query clause term.
 * @param {number} [clause.editDistance] - The optional edit distance for the term.
 * @returns {lunr.TokenSet}
 */ lunr.TokenSet.fromClause = function(clause) {
        if ('editDistance' in clause) return lunr.TokenSet.fromFuzzyString(clause.term, clause.editDistance);
        else return lunr.TokenSet.fromString(clause.term);
    };
    /**
 * Creates a token set representing a single string with a specified
 * edit distance.
 *
 * Insertions, deletions, substitutions and transpositions are each
 * treated as an edit distance of 1.
 *
 * Increasing the allowed edit distance will have a dramatic impact
 * on the performance of both creating and intersecting these TokenSets.
 * It is advised to keep the edit distance less than 3.
 *
 * @param {string} str - The string to create the token set from.
 * @param {number} editDistance - The allowed edit distance to match.
 * @returns {lunr.Vector}
 */ lunr.TokenSet.fromFuzzyString = function(str, editDistance) {
        var root = new lunr.TokenSet;
        var stack = [
            {
                node: root,
                editsRemaining: editDistance,
                str: str
            }
        ];
        while(stack.length){
            var frame = stack.pop();
            // no edit
            if (frame.str.length > 0) {
                var char = frame.str.charAt(0), noEditNode;
                if (char in frame.node.edges) noEditNode = frame.node.edges[char];
                else {
                    noEditNode = new lunr.TokenSet;
                    frame.node.edges[char] = noEditNode;
                }
                if (frame.str.length == 1) noEditNode.final = true;
                stack.push({
                    node: noEditNode,
                    editsRemaining: frame.editsRemaining,
                    str: frame.str.slice(1)
                });
            }
            if (frame.editsRemaining == 0) continue;
            // insertion
            if ("*" in frame.node.edges) var insertionNode = frame.node.edges["*"];
            else {
                var insertionNode = new lunr.TokenSet;
                frame.node.edges["*"] = insertionNode;
            }
            if (frame.str.length == 0) insertionNode.final = true;
            stack.push({
                node: insertionNode,
                editsRemaining: frame.editsRemaining - 1,
                str: frame.str
            });
            // deletion
            // can only do a deletion if we have enough edits remaining
            // and if there are characters left to delete in the string
            if (frame.str.length > 1) stack.push({
                node: frame.node,
                editsRemaining: frame.editsRemaining - 1,
                str: frame.str.slice(1)
            });
            // deletion
            // just removing the last character from the str
            if (frame.str.length == 1) frame.node.final = true;
            // substitution
            // can only do a substitution if we have enough edits remaining
            // and if there are characters left to substitute
            if (frame.str.length >= 1) {
                if ("*" in frame.node.edges) var substitutionNode = frame.node.edges["*"];
                else {
                    var substitutionNode = new lunr.TokenSet;
                    frame.node.edges["*"] = substitutionNode;
                }
                if (frame.str.length == 1) substitutionNode.final = true;
                stack.push({
                    node: substitutionNode,
                    editsRemaining: frame.editsRemaining - 1,
                    str: frame.str.slice(1)
                });
            }
            // transposition
            // can only do a transposition if there are edits remaining
            // and there are enough characters to transpose
            if (frame.str.length > 1) {
                var charA = frame.str.charAt(0), charB = frame.str.charAt(1), transposeNode;
                if (charB in frame.node.edges) transposeNode = frame.node.edges[charB];
                else {
                    transposeNode = new lunr.TokenSet;
                    frame.node.edges[charB] = transposeNode;
                }
                if (frame.str.length == 1) transposeNode.final = true;
                stack.push({
                    node: transposeNode,
                    editsRemaining: frame.editsRemaining - 1,
                    str: charA + frame.str.slice(2)
                });
            }
        }
        return root;
    };
    /**
 * Creates a TokenSet from a string.
 *
 * The string may contain one or more wildcard characters (*)
 * that will allow wildcard matching when intersecting with
 * another TokenSet.
 *
 * @param {string} str - The string to create a TokenSet from.
 * @returns {lunr.TokenSet}
 */ lunr.TokenSet.fromString = function(str) {
        var node = new lunr.TokenSet, root = node;
        /*
   * Iterates through all characters within the passed string
   * appending a node for each character.
   *
   * When a wildcard character is found then a self
   * referencing edge is introduced to continually match
   * any number of any characters.
   */ for(var i = 0, len = str.length; i < len; i++){
            var char = str[i], final = i == len - 1;
            if (char == "*") {
                node.edges[char] = node;
                node.final = final;
            } else {
                var next = new lunr.TokenSet;
                next.final = final;
                node.edges[char] = next;
                node = next;
            }
        }
        return root;
    };
    /**
 * Converts this TokenSet into an array of strings
 * contained within the TokenSet.
 *
 * This is not intended to be used on a TokenSet that
 * contains wildcards, in these cases the results are
 * undefined and are likely to cause an infinite loop.
 *
 * @returns {string[]}
 */ lunr.TokenSet.prototype.toArray = function() {
        var words = [];
        var stack = [
            {
                prefix: "",
                node: this
            }
        ];
        while(stack.length){
            var frame = stack.pop(), edges = Object.keys(frame.node.edges), len = edges.length;
            if (frame.node.final) {
                /* In Safari, at this point the prefix is sometimes corrupted, see:
       * https://github.com/olivernn/lunr.js/issues/279 Calling any
       * String.prototype method forces Safari to "cast" this string to what
       * it's supposed to be, fixing the bug. */ frame.prefix.charAt(0);
                words.push(frame.prefix);
            }
            for(var i = 0; i < len; i++){
                var edge = edges[i];
                stack.push({
                    prefix: frame.prefix.concat(edge),
                    node: frame.node.edges[edge]
                });
            }
        }
        return words;
    };
    /**
 * Generates a string representation of a TokenSet.
 *
 * This is intended to allow TokenSets to be used as keys
 * in objects, largely to aid the construction and minimisation
 * of a TokenSet. As such it is not designed to be a human
 * friendly representation of the TokenSet.
 *
 * @returns {string}
 */ lunr.TokenSet.prototype.toString = function() {
        // NOTE: Using Object.keys here as this.edges is very likely
        // to enter 'hash-mode' with many keys being added
        //
        // avoiding a for-in loop here as it leads to the function
        // being de-optimised (at least in V8). From some simple
        // benchmarks the performance is comparable, but allowing
        // V8 to optimize may mean easy performance wins in the future.
        if (this._str) return this._str;
        var str = this.final ? '1' : '0', labels = Object.keys(this.edges).sort(), len = labels.length;
        for(var i = 0; i < len; i++){
            var label = labels[i], node = this.edges[label];
            str = str + label + node.id;
        }
        return str;
    };
    /**
 * Returns a new TokenSet that is the intersection of
 * this TokenSet and the passed TokenSet.
 *
 * This intersection will take into account any wildcards
 * contained within the TokenSet.
 *
 * @param {lunr.TokenSet} b - An other TokenSet to intersect with.
 * @returns {lunr.TokenSet}
 */ lunr.TokenSet.prototype.intersect = function(b) {
        var output = new lunr.TokenSet, frame = undefined;
        var stack = [
            {
                qNode: b,
                output: output,
                node: this
            }
        ];
        while(stack.length){
            frame = stack.pop();
            // NOTE: As with the #toString method, we are using
            // Object.keys and a for loop instead of a for-in loop
            // as both of these objects enter 'hash' mode, causing
            // the function to be de-optimised in V8
            var qEdges = Object.keys(frame.qNode.edges), qLen = qEdges.length, nEdges = Object.keys(frame.node.edges), nLen = nEdges.length;
            for(var q = 0; q < qLen; q++){
                var qEdge = qEdges[q];
                for(var n = 0; n < nLen; n++){
                    var nEdge = nEdges[n];
                    if (nEdge == qEdge || qEdge == '*') {
                        var node = frame.node.edges[nEdge], qNode = frame.qNode.edges[qEdge], final = node.final && qNode.final, next = undefined;
                        if (nEdge in frame.output.edges) {
                            // an edge already exists for this character
                            // no need to create a new node, just set the finality
                            // bit unless this node is already final
                            next = frame.output.edges[nEdge];
                            next.final = next.final || final;
                        } else {
                            // no edge exists yet, must create one
                            // set the finality bit and insert it
                            // into the output
                            next = new lunr.TokenSet;
                            next.final = final;
                            frame.output.edges[nEdge] = next;
                        }
                        stack.push({
                            qNode: qNode,
                            output: next,
                            node: node
                        });
                    }
                }
            }
        }
        return output;
    };
    lunr.TokenSet.Builder = function() {
        this.previousWord = "";
        this.root = new lunr.TokenSet;
        this.uncheckedNodes = [];
        this.minimizedNodes = {};
    };
    lunr.TokenSet.Builder.prototype.insert = function(word) {
        var node, commonPrefix = 0;
        if (word < this.previousWord) throw new Error("Out of order word insertion");
        for(var i = 0; i < word.length && i < this.previousWord.length; i++){
            if (word[i] != this.previousWord[i]) break;
            commonPrefix++;
        }
        this.minimize(commonPrefix);
        if (this.uncheckedNodes.length == 0) node = this.root;
        else node = this.uncheckedNodes[this.uncheckedNodes.length - 1].child;
        for(var i = commonPrefix; i < word.length; i++){
            var nextNode = new lunr.TokenSet, char = word[i];
            node.edges[char] = nextNode;
            this.uncheckedNodes.push({
                parent: node,
                char: char,
                child: nextNode
            });
            node = nextNode;
        }
        node.final = true;
        this.previousWord = word;
    };
    lunr.TokenSet.Builder.prototype.finish = function() {
        this.minimize(0);
    };
    lunr.TokenSet.Builder.prototype.minimize = function(downTo) {
        for(var i = this.uncheckedNodes.length - 1; i >= downTo; i--){
            var node = this.uncheckedNodes[i], childKey = node.child.toString();
            if (childKey in this.minimizedNodes) node.parent.edges[node.char] = this.minimizedNodes[childKey];
            else {
                // Cache the key for this node since
                // we know it can't change anymore
                node.child._str = childKey;
                this.minimizedNodes[childKey] = node.child;
            }
            this.uncheckedNodes.pop();
        }
    };
    /*!
 * lunr.Index
 * Copyright (C) 2020 Oliver Nightingale
 */ /**
 * An index contains the built index of all documents and provides a query interface
 * to the index.
 *
 * Usually instances of lunr.Index will not be created using this constructor, instead
 * lunr.Builder should be used to construct new indexes, or lunr.Index.load should be
 * used to load previously built and serialized indexes.
 *
 * @constructor
 * @param {Object} attrs - The attributes of the built search index.
 * @param {Object} attrs.invertedIndex - An index of term/field to document reference.
 * @param {Object<string, lunr.Vector>} attrs.fieldVectors - Field vectors
 * @param {lunr.TokenSet} attrs.tokenSet - An set of all corpus tokens.
 * @param {string[]} attrs.fields - The names of indexed document fields.
 * @param {lunr.Pipeline} attrs.pipeline - The pipeline to use for search terms.
 */ lunr.Index = function(attrs) {
        this.invertedIndex = attrs.invertedIndex;
        this.fieldVectors = attrs.fieldVectors;
        this.tokenSet = attrs.tokenSet;
        this.fields = attrs.fields;
        this.pipeline = attrs.pipeline;
    };
    /**
 * A result contains details of a document matching a search query.
 * @typedef {Object} lunr.Index~Result
 * @property {string} ref - The reference of the document this result represents.
 * @property {number} score - A number between 0 and 1 representing how similar this document is to the query.
 * @property {lunr.MatchData} matchData - Contains metadata about this match including which term(s) caused the match.
 */ /**
 * Although lunr provides the ability to create queries using lunr.Query, it also provides a simple
 * query language which itself is parsed into an instance of lunr.Query.
 *
 * For programmatically building queries it is advised to directly use lunr.Query, the query language
 * is best used for human entered text rather than program generated text.
 *
 * At its simplest queries can just be a single term, e.g. `hello`, multiple terms are also supported
 * and will be combined with OR, e.g `hello world` will match documents that contain either 'hello'
 * or 'world', though those that contain both will rank higher in the results.
 *
 * Wildcards can be included in terms to match one or more unspecified characters, these wildcards can
 * be inserted anywhere within the term, and more than one wildcard can exist in a single term. Adding
 * wildcards will increase the number of documents that will be found but can also have a negative
 * impact on query performance, especially with wildcards at the beginning of a term.
 *
 * Terms can be restricted to specific fields, e.g. `title:hello`, only documents with the term
 * hello in the title field will match this query. Using a field not present in the index will lead
 * to an error being thrown.
 *
 * Modifiers can also be added to terms, lunr supports edit distance and boost modifiers on terms. A term
 * boost will make documents matching that term score higher, e.g. `foo^5`. Edit distance is also supported
 * to provide fuzzy matching, e.g. 'hello~2' will match documents with hello with an edit distance of 2.
 * Avoid large values for edit distance to improve query performance.
 *
 * Each term also supports a presence modifier. By default a term's presence in document is optional, however
 * this can be changed to either required or prohibited. For a term's presence to be required in a document the
 * term should be prefixed with a '+', e.g. `+foo bar` is a search for documents that must contain 'foo' and
 * optionally contain 'bar'. Conversely a leading '-' sets the terms presence to prohibited, i.e. it must not
 * appear in a document, e.g. `-foo bar` is a search for documents that do not contain 'foo' but may contain 'bar'.
 *
 * To escape special characters the backslash character '\' can be used, this allows searches to include
 * characters that would normally be considered modifiers, e.g. `foo\~2` will search for a term "foo~2" instead
 * of attempting to apply a boost of 2 to the search term "foo".
 *
 * @typedef {string} lunr.Index~QueryString
 * @example <caption>Simple single term query</caption>
 * hello
 * @example <caption>Multiple term query</caption>
 * hello world
 * @example <caption>term scoped to a field</caption>
 * title:hello
 * @example <caption>term with a boost of 10</caption>
 * hello^10
 * @example <caption>term with an edit distance of 2</caption>
 * hello~2
 * @example <caption>terms with presence modifiers</caption>
 * -foo +bar baz
 */ /**
 * Performs a search against the index using lunr query syntax.
 *
 * Results will be returned sorted by their score, the most relevant results
 * will be returned first.  For details on how the score is calculated, please see
 * the {@link https://lunrjs.com/guides/searching.html#scoring|guide}.
 *
 * For more programmatic querying use lunr.Index#query.
 *
 * @param {lunr.Index~QueryString} queryString - A string containing a lunr query.
 * @throws {lunr.QueryParseError} If the passed query string cannot be parsed.
 * @returns {lunr.Index~Result[]}
 */ lunr.Index.prototype.search = function(queryString) {
        return this.query(function(query) {
            var parser = new lunr.QueryParser(queryString, query);
            parser.parse();
        });
    };
    /**
 * A query builder callback provides a query object to be used to express
 * the query to perform on the index.
 *
 * @callback lunr.Index~queryBuilder
 * @param {lunr.Query} query - The query object to build up.
 * @this lunr.Query
 */ /**
 * Performs a query against the index using the yielded lunr.Query object.
 *
 * If performing programmatic queries against the index, this method is preferred
 * over lunr.Index#search so as to avoid the additional query parsing overhead.
 *
 * A query object is yielded to the supplied function which should be used to
 * express the query to be run against the index.
 *
 * Note that although this function takes a callback parameter it is _not_ an
 * asynchronous operation, the callback is just yielded a query object to be
 * customized.
 *
 * @param {lunr.Index~queryBuilder} fn - A function that is used to build the query.
 * @returns {lunr.Index~Result[]}
 */ lunr.Index.prototype.query = function(fn) {
        // for each query clause
        // * process terms
        // * expand terms from token set
        // * find matching documents and metadata
        // * get document vectors
        // * score documents
        var query = new lunr.Query(this.fields), matchingFields = Object.create(null), queryVectors = Object.create(null), termFieldCache = Object.create(null), requiredMatches = Object.create(null), prohibitedMatches = Object.create(null);
        /*
   * To support field level boosts a query vector is created per
   * field. An empty vector is eagerly created to support negated
   * queries.
   */ for(var i = 0; i < this.fields.length; i++)queryVectors[this.fields[i]] = new lunr.Vector;
        fn.call(query, query);
        for(var i = 0; i < query.clauses.length; i++){
            /*
     * Unless the pipeline has been disabled for this term, which is
     * the case for terms with wildcards, we need to pass the clause
     * term through the search pipeline. A pipeline returns an array
     * of processed terms. Pipeline functions may expand the passed
     * term, which means we may end up performing multiple index lookups
     * for a single query term.
     */ var clause = query.clauses[i], terms = null, clauseMatches = lunr.Set.empty;
            if (clause.usePipeline) terms = this.pipeline.runString(clause.term, {
                fields: clause.fields
            });
            else terms = [
                clause.term
            ];
            for(var m = 0; m < terms.length; m++){
                var term = terms[m];
                /*
       * Each term returned from the pipeline needs to use the same query
       * clause object, e.g. the same boost and or edit distance. The
       * simplest way to do this is to re-use the clause object but mutate
       * its term property.
       */ clause.term = term;
                /*
       * From the term in the clause we create a token set which will then
       * be used to intersect the indexes token set to get a list of terms
       * to lookup in the inverted index
       */ var termTokenSet = lunr.TokenSet.fromClause(clause), expandedTerms = this.tokenSet.intersect(termTokenSet).toArray();
                /*
       * If a term marked as required does not exist in the tokenSet it is
       * impossible for the search to return any matches. We set all the field
       * scoped required matches set to empty and stop examining any further
       * clauses.
       */ if (expandedTerms.length === 0 && clause.presence === lunr.Query.presence.REQUIRED) {
                    for(var k = 0; k < clause.fields.length; k++){
                        var field = clause.fields[k];
                        requiredMatches[field] = lunr.Set.empty;
                    }
                    break;
                }
                for(var j = 0; j < expandedTerms.length; j++){
                    /*
         * For each term get the posting and termIndex, this is required for
         * building the query vector.
         */ var expandedTerm = expandedTerms[j], posting = this.invertedIndex[expandedTerm], termIndex = posting._index;
                    for(var k = 0; k < clause.fields.length; k++){
                        /*
           * For each field that this query term is scoped by (by default
           * all fields are in scope) we need to get all the document refs
           * that have this term in that field.
           *
           * The posting is the entry in the invertedIndex for the matching
           * term from above.
           */ var field = clause.fields[k], fieldPosting = posting[field], matchingDocumentRefs = Object.keys(fieldPosting), termField = expandedTerm + "/" + field, matchingDocumentsSet = new lunr.Set(matchingDocumentRefs);
                        /*
           * if the presence of this term is required ensure that the matching
           * documents are added to the set of required matches for this clause.
           *
           */ if (clause.presence == lunr.Query.presence.REQUIRED) {
                            clauseMatches = clauseMatches.union(matchingDocumentsSet);
                            if (requiredMatches[field] === undefined) requiredMatches[field] = lunr.Set.complete;
                        }
                        /*
           * if the presence of this term is prohibited ensure that the matching
           * documents are added to the set of prohibited matches for this field,
           * creating that set if it does not yet exist.
           */ if (clause.presence == lunr.Query.presence.PROHIBITED) {
                            if (prohibitedMatches[field] === undefined) prohibitedMatches[field] = lunr.Set.empty;
                            prohibitedMatches[field] = prohibitedMatches[field].union(matchingDocumentsSet);
                            continue;
                        }
                        /*
           * The query field vector is populated using the termIndex found for
           * the term and a unit value with the appropriate boost applied.
           * Using upsert because there could already be an entry in the vector
           * for the term we are working with. In that case we just add the scores
           * together.
           */ queryVectors[field].upsert(termIndex, clause.boost, function(a, b) {
                            return a + b;
                        });
                        /**
           * If we've already seen this term, field combo then we've already collected
           * the matching documents and metadata, no need to go through all that again
           */ if (termFieldCache[termField]) continue;
                        for(var l = 0; l < matchingDocumentRefs.length; l++){
                            /*
             * All metadata for this term/field/document triple
             * are then extracted and collected into an instance
             * of lunr.MatchData ready to be returned in the query
             * results
             */ var matchingDocumentRef = matchingDocumentRefs[l], matchingFieldRef = new lunr.FieldRef(matchingDocumentRef, field), metadata = fieldPosting[matchingDocumentRef], fieldMatch;
                            if ((fieldMatch = matchingFields[matchingFieldRef]) === undefined) matchingFields[matchingFieldRef] = new lunr.MatchData(expandedTerm, field, metadata);
                            else fieldMatch.add(expandedTerm, field, metadata);
                        }
                        termFieldCache[termField] = true;
                    }
                }
            }
            /**
     * If the presence was required we need to update the requiredMatches field sets.
     * We do this after all fields for the term have collected their matches because
     * the clause terms presence is required in _any_ of the fields not _all_ of the
     * fields.
     */ if (clause.presence === lunr.Query.presence.REQUIRED) for(var k = 0; k < clause.fields.length; k++){
                var field = clause.fields[k];
                requiredMatches[field] = requiredMatches[field].intersect(clauseMatches);
            }
        }
        /**
   * Need to combine the field scoped required and prohibited
   * matching documents into a global set of required and prohibited
   * matches
   */ var allRequiredMatches = lunr.Set.complete, allProhibitedMatches = lunr.Set.empty;
        for(var i = 0; i < this.fields.length; i++){
            var field = this.fields[i];
            if (requiredMatches[field]) allRequiredMatches = allRequiredMatches.intersect(requiredMatches[field]);
            if (prohibitedMatches[field]) allProhibitedMatches = allProhibitedMatches.union(prohibitedMatches[field]);
        }
        var matchingFieldRefs = Object.keys(matchingFields), results = [], matches = Object.create(null);
        /*
   * If the query is negated (contains only prohibited terms)
   * we need to get _all_ fieldRefs currently existing in the
   * index. This is only done when we know that the query is
   * entirely prohibited terms to avoid any cost of getting all
   * fieldRefs unnecessarily.
   *
   * Additionally, blank MatchData must be created to correctly
   * populate the results.
   */ if (query.isNegated()) {
            matchingFieldRefs = Object.keys(this.fieldVectors);
            for(var i = 0; i < matchingFieldRefs.length; i++){
                var matchingFieldRef = matchingFieldRefs[i];
                var fieldRef = lunr.FieldRef.fromString(matchingFieldRef);
                matchingFields[matchingFieldRef] = new lunr.MatchData;
            }
        }
        for(var i = 0; i < matchingFieldRefs.length; i++){
            /*
     * Currently we have document fields that match the query, but we
     * need to return documents. The matchData and scores are combined
     * from multiple fields belonging to the same document.
     *
     * Scores are calculated by field, using the query vectors created
     * above, and combined into a final document score using addition.
     */ var fieldRef = lunr.FieldRef.fromString(matchingFieldRefs[i]), docRef = fieldRef.docRef;
            if (!allRequiredMatches.contains(docRef)) continue;
            if (allProhibitedMatches.contains(docRef)) continue;
            var fieldVector = this.fieldVectors[fieldRef], score = queryVectors[fieldRef.fieldName].similarity(fieldVector), docMatch;
            if ((docMatch = matches[docRef]) !== undefined) {
                docMatch.score += score;
                docMatch.matchData.combine(matchingFields[fieldRef]);
            } else {
                var match = {
                    ref: docRef,
                    score: score,
                    matchData: matchingFields[fieldRef]
                };
                matches[docRef] = match;
                results.push(match);
            }
        }
        /*
   * Sort the results objects by score, highest first.
   */ return results.sort(function(a, b) {
            return b.score - a.score;
        });
    };
    /**
 * Prepares the index for JSON serialization.
 *
 * The schema for this JSON blob will be described in a
 * separate JSON schema file.
 *
 * @returns {Object}
 */ lunr.Index.prototype.toJSON = function() {
        var invertedIndex = Object.keys(this.invertedIndex).sort().map(function(term) {
            return [
                term,
                this.invertedIndex[term]
            ];
        }, this);
        var fieldVectors = Object.keys(this.fieldVectors).map(function(ref) {
            return [
                ref,
                this.fieldVectors[ref].toJSON()
            ];
        }, this);
        return {
            version: lunr.version,
            fields: this.fields,
            fieldVectors: fieldVectors,
            invertedIndex: invertedIndex,
            pipeline: this.pipeline.toJSON()
        };
    };
    /**
 * Loads a previously serialized lunr.Index
 *
 * @param {Object} serializedIndex - A previously serialized lunr.Index
 * @returns {lunr.Index}
 */ lunr.Index.load = function(serializedIndex) {
        var attrs = {}, fieldVectors = {}, serializedVectors = serializedIndex.fieldVectors, invertedIndex = Object.create(null), serializedInvertedIndex = serializedIndex.invertedIndex, tokenSetBuilder = new lunr.TokenSet.Builder, pipeline = lunr.Pipeline.load(serializedIndex.pipeline);
        if (serializedIndex.version != lunr.version) lunr.utils.warn("Version mismatch when loading serialised index. Current version of lunr '" + lunr.version + "' does not match serialized index '" + serializedIndex.version + "'");
        for(var i = 0; i < serializedVectors.length; i++){
            var tuple = serializedVectors[i], ref = tuple[0], elements = tuple[1];
            fieldVectors[ref] = new lunr.Vector(elements);
        }
        for(var i = 0; i < serializedInvertedIndex.length; i++){
            var tuple = serializedInvertedIndex[i], term = tuple[0], posting = tuple[1];
            tokenSetBuilder.insert(term);
            invertedIndex[term] = posting;
        }
        tokenSetBuilder.finish();
        attrs.fields = serializedIndex.fields;
        attrs.fieldVectors = fieldVectors;
        attrs.invertedIndex = invertedIndex;
        attrs.tokenSet = tokenSetBuilder.root;
        attrs.pipeline = pipeline;
        return new lunr.Index(attrs);
    };
    /*!
 * lunr.Builder
 * Copyright (C) 2020 Oliver Nightingale
 */ /**
 * lunr.Builder performs indexing on a set of documents and
 * returns instances of lunr.Index ready for querying.
 *
 * All configuration of the index is done via the builder, the
 * fields to index, the document reference, the text processing
 * pipeline and document scoring parameters are all set on the
 * builder before indexing.
 *
 * @constructor
 * @property {string} _ref - Internal reference to the document reference field.
 * @property {string[]} _fields - Internal reference to the document fields to index.
 * @property {object} invertedIndex - The inverted index maps terms to document fields.
 * @property {object} documentTermFrequencies - Keeps track of document term frequencies.
 * @property {object} documentLengths - Keeps track of the length of documents added to the index.
 * @property {lunr.tokenizer} tokenizer - Function for splitting strings into tokens for indexing.
 * @property {lunr.Pipeline} pipeline - The pipeline performs text processing on tokens before indexing.
 * @property {lunr.Pipeline} searchPipeline - A pipeline for processing search terms before querying the index.
 * @property {number} documentCount - Keeps track of the total number of documents indexed.
 * @property {number} _b - A parameter to control field length normalization, setting this to 0 disabled normalization, 1 fully normalizes field lengths, the default value is 0.75.
 * @property {number} _k1 - A parameter to control how quickly an increase in term frequency results in term frequency saturation, the default value is 1.2.
 * @property {number} termIndex - A counter incremented for each unique term, used to identify a terms position in the vector space.
 * @property {array} metadataWhitelist - A list of metadata keys that have been whitelisted for entry in the index.
 */ lunr.Builder = function() {
        this._ref = "id";
        this._fields = Object.create(null);
        this._documents = Object.create(null);
        this.invertedIndex = Object.create(null);
        this.fieldTermFrequencies = {};
        this.fieldLengths = {};
        this.tokenizer = lunr.tokenizer;
        this.pipeline = new lunr.Pipeline;
        this.searchPipeline = new lunr.Pipeline;
        this.documentCount = 0;
        this._b = 0.75;
        this._k1 = 1.2;
        this.termIndex = 0;
        this.metadataWhitelist = [];
    };
    /**
 * Sets the document field used as the document reference. Every document must have this field.
 * The type of this field in the document should be a string, if it is not a string it will be
 * coerced into a string by calling toString.
 *
 * The default ref is 'id'.
 *
 * The ref should _not_ be changed during indexing, it should be set before any documents are
 * added to the index. Changing it during indexing can lead to inconsistent results.
 *
 * @param {string} ref - The name of the reference field in the document.
 */ lunr.Builder.prototype.ref = function(ref) {
        this._ref = ref;
    };
    /**
 * A function that is used to extract a field from a document.
 *
 * Lunr expects a field to be at the top level of a document, if however the field
 * is deeply nested within a document an extractor function can be used to extract
 * the right field for indexing.
 *
 * @callback fieldExtractor
 * @param {object} doc - The document being added to the index.
 * @returns {?(string|object|object[])} obj - The object that will be indexed for this field.
 * @example <caption>Extracting a nested field</caption>
 * function (doc) { return doc.nested.field }
 */ /**
 * Adds a field to the list of document fields that will be indexed. Every document being
 * indexed should have this field. Null values for this field in indexed documents will
 * not cause errors but will limit the chance of that document being retrieved by searches.
 *
 * All fields should be added before adding documents to the index. Adding fields after
 * a document has been indexed will have no effect on already indexed documents.
 *
 * Fields can be boosted at build time. This allows terms within that field to have more
 * importance when ranking search results. Use a field boost to specify that matches within
 * one field are more important than other fields.
 *
 * @param {string} fieldName - The name of a field to index in all documents.
 * @param {object} attributes - Optional attributes associated with this field.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this field.
 * @param {fieldExtractor} [attributes.extractor] - Function to extract a field from a document.
 * @throws {RangeError} fieldName cannot contain unsupported characters '/'
 */ lunr.Builder.prototype.field = function(fieldName, attributes) {
        if (/\//.test(fieldName)) throw new RangeError("Field '" + fieldName + "' contains illegal character '/'");
        this._fields[fieldName] = attributes || {};
    };
    /**
 * A parameter to tune the amount of field length normalisation that is applied when
 * calculating relevance scores. A value of 0 will completely disable any normalisation
 * and a value of 1 will fully normalise field lengths. The default is 0.75. Values of b
 * will be clamped to the range 0 - 1.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */ lunr.Builder.prototype.b = function(number) {
        if (number < 0) this._b = 0;
        else if (number > 1) this._b = 1;
        else this._b = number;
    };
    /**
 * A parameter that controls the speed at which a rise in term frequency results in term
 * frequency saturation. The default value is 1.2. Setting this to a higher value will give
 * slower saturation levels, a lower value will result in quicker saturation.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */ lunr.Builder.prototype.k1 = function(number) {
        this._k1 = number;
    };
    /**
 * Adds a document to the index.
 *
 * Before adding fields to the index the index should have been fully setup, with the document
 * ref and all fields to index already having been specified.
 *
 * The document must have a field name as specified by the ref (by default this is 'id') and
 * it should have all fields defined for indexing, though null or undefined values will not
 * cause errors.
 *
 * Entire documents can be boosted at build time. Applying a boost to a document indicates that
 * this document should rank higher in search results than other documents.
 *
 * @param {object} doc - The document to add to the index.
 * @param {object} attributes - Optional attributes associated with this document.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this document.
 */ lunr.Builder.prototype.add = function(doc, attributes) {
        var docRef = doc[this._ref], fields = Object.keys(this._fields);
        this._documents[docRef] = attributes || {};
        this.documentCount += 1;
        for(var i = 0; i < fields.length; i++){
            var fieldName = fields[i], extractor = this._fields[fieldName].extractor, field = extractor ? extractor(doc) : doc[fieldName], tokens = this.tokenizer(field, {
                fields: [
                    fieldName
                ]
            }), terms = this.pipeline.run(tokens), fieldRef = new lunr.FieldRef(docRef, fieldName), fieldTerms = Object.create(null);
            this.fieldTermFrequencies[fieldRef] = fieldTerms;
            this.fieldLengths[fieldRef] = 0;
            // store the length of this field for this document
            this.fieldLengths[fieldRef] += terms.length;
            // calculate term frequencies for this field
            for(var j = 0; j < terms.length; j++){
                var term = terms[j];
                if (fieldTerms[term] == undefined) fieldTerms[term] = 0;
                fieldTerms[term] += 1;
                // add to inverted index
                // create an initial posting if one doesn't exist
                if (this.invertedIndex[term] == undefined) {
                    var posting = Object.create(null);
                    posting["_index"] = this.termIndex;
                    this.termIndex += 1;
                    for(var k = 0; k < fields.length; k++)posting[fields[k]] = Object.create(null);
                    this.invertedIndex[term] = posting;
                }
                // add an entry for this term/fieldName/docRef to the invertedIndex
                if (this.invertedIndex[term][fieldName][docRef] == undefined) this.invertedIndex[term][fieldName][docRef] = Object.create(null);
                // store all whitelisted metadata about this token in the
                // inverted index
                for(var l = 0; l < this.metadataWhitelist.length; l++){
                    var metadataKey = this.metadataWhitelist[l], metadata = term.metadata[metadataKey];
                    if (this.invertedIndex[term][fieldName][docRef][metadataKey] == undefined) this.invertedIndex[term][fieldName][docRef][metadataKey] = [];
                    this.invertedIndex[term][fieldName][docRef][metadataKey].push(metadata);
                }
            }
        }
    };
    /**
 * Calculates the average document length for this index
 *
 * @private
 */ lunr.Builder.prototype.calculateAverageFieldLengths = function() {
        var fieldRefs = Object.keys(this.fieldLengths), numberOfFields = fieldRefs.length, accumulator = {}, documentsWithField = {};
        for(var i = 0; i < numberOfFields; i++){
            var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]), field = fieldRef.fieldName;
            documentsWithField[field] || (documentsWithField[field] = 0);
            documentsWithField[field] += 1;
            accumulator[field] || (accumulator[field] = 0);
            accumulator[field] += this.fieldLengths[fieldRef];
        }
        var fields = Object.keys(this._fields);
        for(var i = 0; i < fields.length; i++){
            var fieldName = fields[i];
            accumulator[fieldName] = accumulator[fieldName] / documentsWithField[fieldName];
        }
        this.averageFieldLength = accumulator;
    };
    /**
 * Builds a vector space model of every document using lunr.Vector
 *
 * @private
 */ lunr.Builder.prototype.createFieldVectors = function() {
        var fieldVectors = {}, fieldRefs = Object.keys(this.fieldTermFrequencies), fieldRefsLength = fieldRefs.length, termIdfCache = Object.create(null);
        for(var i = 0; i < fieldRefsLength; i++){
            var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]), fieldName = fieldRef.fieldName, fieldLength = this.fieldLengths[fieldRef], fieldVector = new lunr.Vector, termFrequencies = this.fieldTermFrequencies[fieldRef], terms = Object.keys(termFrequencies), termsLength = terms.length;
            var fieldBoost = this._fields[fieldName].boost || 1, docBoost = this._documents[fieldRef.docRef].boost || 1;
            for(var j = 0; j < termsLength; j++){
                var term = terms[j], tf = termFrequencies[term], termIndex = this.invertedIndex[term]._index, idf, score, scoreWithPrecision;
                if (termIdfCache[term] === undefined) {
                    idf = lunr.idf(this.invertedIndex[term], this.documentCount);
                    termIdfCache[term] = idf;
                } else idf = termIdfCache[term];
                score = idf * ((this._k1 + 1) * tf) / (this._k1 * (1 - this._b + this._b * (fieldLength / this.averageFieldLength[fieldName])) + tf);
                score *= fieldBoost;
                score *= docBoost;
                scoreWithPrecision = Math.round(score * 1000) / 1000;
                // Converts 1.23456789 to 1.234.
                // Reducing the precision so that the vectors take up less
                // space when serialised. Doing it now so that they behave
                // the same before and after serialisation. Also, this is
                // the fastest approach to reducing a number's precision in
                // JavaScript.
                fieldVector.insert(termIndex, scoreWithPrecision);
            }
            fieldVectors[fieldRef] = fieldVector;
        }
        this.fieldVectors = fieldVectors;
    };
    /**
 * Creates a token set of all tokens in the index using lunr.TokenSet
 *
 * @private
 */ lunr.Builder.prototype.createTokenSet = function() {
        this.tokenSet = lunr.TokenSet.fromArray(Object.keys(this.invertedIndex).sort());
    };
    /**
 * Builds the index, creating an instance of lunr.Index.
 *
 * This completes the indexing process and should only be called
 * once all documents have been added to the index.
 *
 * @returns {lunr.Index}
 */ lunr.Builder.prototype.build = function() {
        this.calculateAverageFieldLengths();
        this.createFieldVectors();
        this.createTokenSet();
        return new lunr.Index({
            invertedIndex: this.invertedIndex,
            fieldVectors: this.fieldVectors,
            tokenSet: this.tokenSet,
            fields: Object.keys(this._fields),
            pipeline: this.searchPipeline
        });
    };
    /**
 * Applies a plugin to the index builder.
 *
 * A plugin is a function that is called with the index builder as its context.
 * Plugins can be used to customise or extend the behaviour of the index
 * in some way. A plugin is just a function, that encapsulated the custom
 * behaviour that should be applied when building the index.
 *
 * The plugin function will be called with the index builder as its argument, additional
 * arguments can also be passed when calling use. The function will be called
 * with the index builder as its context.
 *
 * @param {Function} plugin The plugin to apply.
 */ lunr.Builder.prototype.use = function(fn) {
        var args = Array.prototype.slice.call(arguments, 1);
        args.unshift(this);
        fn.apply(this, args);
    };
    /**
 * Contains and collects metadata about a matching document.
 * A single instance of lunr.MatchData is returned as part of every
 * lunr.Index~Result.
 *
 * @constructor
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 * @property {object} metadata - A cloned collection of metadata associated with this document.
 * @see {@link lunr.Index~Result}
 */ lunr.MatchData = function(term, field, metadata) {
        var clonedMetadata = Object.create(null), metadataKeys = Object.keys(metadata || {});
        // Cloning the metadata to prevent the original
        // being mutated during match data combination.
        // Metadata is kept in an array within the inverted
        // index so cloning the data can be done with
        // Array#slice
        for(var i = 0; i < metadataKeys.length; i++){
            var key = metadataKeys[i];
            clonedMetadata[key] = metadata[key].slice();
        }
        this.metadata = Object.create(null);
        if (term !== undefined) {
            this.metadata[term] = Object.create(null);
            this.metadata[term][field] = clonedMetadata;
        }
    };
    /**
 * An instance of lunr.MatchData will be created for every term that matches a
 * document. However only one instance is required in a lunr.Index~Result. This
 * method combines metadata from another instance of lunr.MatchData with this
 * objects metadata.
 *
 * @param {lunr.MatchData} otherMatchData - Another instance of match data to merge with this one.
 * @see {@link lunr.Index~Result}
 */ lunr.MatchData.prototype.combine = function(otherMatchData) {
        var terms = Object.keys(otherMatchData.metadata);
        for(var i = 0; i < terms.length; i++){
            var term = terms[i], fields = Object.keys(otherMatchData.metadata[term]);
            if (this.metadata[term] == undefined) this.metadata[term] = Object.create(null);
            for(var j = 0; j < fields.length; j++){
                var field = fields[j], keys = Object.keys(otherMatchData.metadata[term][field]);
                if (this.metadata[term][field] == undefined) this.metadata[term][field] = Object.create(null);
                for(var k = 0; k < keys.length; k++){
                    var key = keys[k];
                    if (this.metadata[term][field][key] == undefined) this.metadata[term][field][key] = otherMatchData.metadata[term][field][key];
                    else this.metadata[term][field][key] = this.metadata[term][field][key].concat(otherMatchData.metadata[term][field][key]);
                }
            }
        }
    };
    /**
 * Add metadata for a term/field pair to this instance of match data.
 *
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 */ lunr.MatchData.prototype.add = function(term, field, metadata) {
        if (!(term in this.metadata)) {
            this.metadata[term] = Object.create(null);
            this.metadata[term][field] = metadata;
            return;
        }
        if (!(field in this.metadata[term])) {
            this.metadata[term][field] = metadata;
            return;
        }
        var metadataKeys = Object.keys(metadata);
        for(var i = 0; i < metadataKeys.length; i++){
            var key = metadataKeys[i];
            if (key in this.metadata[term][field]) this.metadata[term][field][key] = this.metadata[term][field][key].concat(metadata[key]);
            else this.metadata[term][field][key] = metadata[key];
        }
    };
    /**
 * A lunr.Query provides a programmatic way of defining queries to be performed
 * against a {@link lunr.Index}.
 *
 * Prefer constructing a lunr.Query using the {@link lunr.Index#query} method
 * so the query object is pre-initialized with the right index fields.
 *
 * @constructor
 * @property {lunr.Query~Clause[]} clauses - An array of query clauses.
 * @property {string[]} allFields - An array of all available fields in a lunr.Index.
 */ lunr.Query = function(allFields) {
        this.clauses = [];
        this.allFields = allFields;
    };
    /**
 * Constants for indicating what kind of automatic wildcard insertion will be used when constructing a query clause.
 *
 * This allows wildcards to be added to the beginning and end of a term without having to manually do any string
 * concatenation.
 *
 * The wildcard constants can be bitwise combined to select both leading and trailing wildcards.
 *
 * @constant
 * @default
 * @property {number} wildcard.NONE - The term will have no wildcards inserted, this is the default behaviour
 * @property {number} wildcard.LEADING - Prepend the term with a wildcard, unless a leading wildcard already exists
 * @property {number} wildcard.TRAILING - Append a wildcard to the term, unless a trailing wildcard already exists
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with trailing wildcard</caption>
 * query.term('foo', { wildcard: lunr.Query.wildcard.TRAILING })
 * @example <caption>query term with leading and trailing wildcard</caption>
 * query.term('foo', {
 *   wildcard: lunr.Query.wildcard.LEADING | lunr.Query.wildcard.TRAILING
 * })
 */ lunr.Query.wildcard = new String("*");
    lunr.Query.wildcard.NONE = 0;
    lunr.Query.wildcard.LEADING = 1;
    lunr.Query.wildcard.TRAILING = 2;
    /**
 * Constants for indicating what kind of presence a term must have in matching documents.
 *
 * @constant
 * @enum {number}
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with required presence</caption>
 * query.term('foo', { presence: lunr.Query.presence.REQUIRED })
 */ lunr.Query.presence = {
        /**
   * Term's presence in a document is optional, this is the default value.
   */ OPTIONAL: 1,
        /**
   * Term's presence in a document is required, documents that do not contain
   * this term will not be returned.
   */ REQUIRED: 2,
        /**
   * Term's presence in a document is prohibited, documents that do contain
   * this term will not be returned.
   */ PROHIBITED: 3
    };
    /**
 * A single clause in a {@link lunr.Query} contains a term and details on how to
 * match that term against a {@link lunr.Index}.
 *
 * @typedef {Object} lunr.Query~Clause
 * @property {string[]} fields - The fields in an index this clause should be matched against.
 * @property {number} [boost=1] - Any boost that should be applied when matching this clause.
 * @property {number} [editDistance] - Whether the term should have fuzzy matching applied, and how fuzzy the match should be.
 * @property {boolean} [usePipeline] - Whether the term should be passed through the search pipeline.
 * @property {number} [wildcard=lunr.Query.wildcard.NONE] - Whether the term should have wildcards appended or prepended.
 * @property {number} [presence=lunr.Query.presence.OPTIONAL] - The terms presence in any matching documents.
 */ /**
 * Adds a {@link lunr.Query~Clause} to this query.
 *
 * Unless the clause contains the fields to be matched all fields will be matched. In addition
 * a default boost of 1 is applied to the clause.
 *
 * @param {lunr.Query~Clause} clause - The clause to add to this query.
 * @see lunr.Query~Clause
 * @returns {lunr.Query}
 */ lunr.Query.prototype.clause = function(clause) {
        if (!('fields' in clause)) clause.fields = this.allFields;
        if (!('boost' in clause)) clause.boost = 1;
        if (!('usePipeline' in clause)) clause.usePipeline = true;
        if (!('wildcard' in clause)) clause.wildcard = lunr.Query.wildcard.NONE;
        if (clause.wildcard & lunr.Query.wildcard.LEADING && clause.term.charAt(0) != lunr.Query.wildcard) clause.term = "*" + clause.term;
        if (clause.wildcard & lunr.Query.wildcard.TRAILING && clause.term.slice(-1) != lunr.Query.wildcard) clause.term = "" + clause.term + "*";
        if (!('presence' in clause)) clause.presence = lunr.Query.presence.OPTIONAL;
        this.clauses.push(clause);
        return this;
    };
    /**
 * A negated query is one in which every clause has a presence of
 * prohibited. These queries require some special processing to return
 * the expected results.
 *
 * @returns boolean
 */ lunr.Query.prototype.isNegated = function() {
        for(var i = 0; i < this.clauses.length; i++){
            if (this.clauses[i].presence != lunr.Query.presence.PROHIBITED) return false;
        }
        return true;
    };
    /**
 * Adds a term to the current query, under the covers this will create a {@link lunr.Query~Clause}
 * to the list of clauses that make up this query.
 *
 * The term is used as is, i.e. no tokenization will be performed by this method. Instead conversion
 * to a token or token-like string should be done before calling this method.
 *
 * The term will be converted to a string by calling `toString`. Multiple terms can be passed as an
 * array, each term in the array will share the same options.
 *
 * @param {object|object[]} term - The term(s) to add to the query.
 * @param {object} [options] - Any additional properties to add to the query clause.
 * @returns {lunr.Query}
 * @see lunr.Query#clause
 * @see lunr.Query~Clause
 * @example <caption>adding a single term to a query</caption>
 * query.term("foo")
 * @example <caption>adding a single term to a query and specifying search fields, term boost and automatic trailing wildcard</caption>
 * query.term("foo", {
 *   fields: ["title"],
 *   boost: 10,
 *   wildcard: lunr.Query.wildcard.TRAILING
 * })
 * @example <caption>using lunr.tokenizer to convert a string to tokens before using them as terms</caption>
 * query.term(lunr.tokenizer("foo bar"))
 */ lunr.Query.prototype.term = function(term, options) {
        if (Array.isArray(term)) {
            term.forEach(function(t) {
                this.term(t, lunr.utils.clone(options));
            }, this);
            return this;
        }
        var clause = options || {};
        clause.term = term.toString();
        this.clause(clause);
        return this;
    };
    lunr.QueryParseError = function(message, start, end) {
        this.name = "QueryParseError";
        this.message = message;
        this.start = start;
        this.end = end;
    };
    lunr.QueryParseError.prototype = new Error;
    lunr.QueryLexer = function(str) {
        this.lexemes = [];
        this.str = str;
        this.length = str.length;
        this.pos = 0;
        this.start = 0;
        this.escapeCharPositions = [];
    };
    lunr.QueryLexer.prototype.run = function() {
        var state = lunr.QueryLexer.lexText;
        while(state)state = state(this);
    };
    lunr.QueryLexer.prototype.sliceString = function() {
        var subSlices = [], sliceStart = this.start, sliceEnd = this.pos;
        for(var i = 0; i < this.escapeCharPositions.length; i++){
            sliceEnd = this.escapeCharPositions[i];
            subSlices.push(this.str.slice(sliceStart, sliceEnd));
            sliceStart = sliceEnd + 1;
        }
        subSlices.push(this.str.slice(sliceStart, this.pos));
        this.escapeCharPositions.length = 0;
        return subSlices.join('');
    };
    lunr.QueryLexer.prototype.emit = function(type) {
        this.lexemes.push({
            type: type,
            str: this.sliceString(),
            start: this.start,
            end: this.pos
        });
        this.start = this.pos;
    };
    lunr.QueryLexer.prototype.escapeCharacter = function() {
        this.escapeCharPositions.push(this.pos - 1);
        this.pos += 1;
    };
    lunr.QueryLexer.prototype.next = function() {
        if (this.pos >= this.length) return lunr.QueryLexer.EOS;
        var char = this.str.charAt(this.pos);
        this.pos += 1;
        return char;
    };
    lunr.QueryLexer.prototype.width = function() {
        return this.pos - this.start;
    };
    lunr.QueryLexer.prototype.ignore = function() {
        if (this.start == this.pos) this.pos += 1;
        this.start = this.pos;
    };
    lunr.QueryLexer.prototype.backup = function() {
        this.pos -= 1;
    };
    lunr.QueryLexer.prototype.acceptDigitRun = function() {
        var char, charCode;
        do {
            char = this.next();
            charCode = char.charCodeAt(0);
        }while (charCode > 47 && charCode < 58);
        if (char != lunr.QueryLexer.EOS) this.backup();
    };
    lunr.QueryLexer.prototype.more = function() {
        return this.pos < this.length;
    };
    lunr.QueryLexer.EOS = 'EOS';
    lunr.QueryLexer.FIELD = 'FIELD';
    lunr.QueryLexer.TERM = 'TERM';
    lunr.QueryLexer.EDIT_DISTANCE = 'EDIT_DISTANCE';
    lunr.QueryLexer.BOOST = 'BOOST';
    lunr.QueryLexer.PRESENCE = 'PRESENCE';
    lunr.QueryLexer.lexField = function(lexer) {
        lexer.backup();
        lexer.emit(lunr.QueryLexer.FIELD);
        lexer.ignore();
        return lunr.QueryLexer.lexText;
    };
    lunr.QueryLexer.lexTerm = function(lexer) {
        if (lexer.width() > 1) {
            lexer.backup();
            lexer.emit(lunr.QueryLexer.TERM);
        }
        lexer.ignore();
        if (lexer.more()) return lunr.QueryLexer.lexText;
    };
    lunr.QueryLexer.lexEditDistance = function(lexer) {
        lexer.ignore();
        lexer.acceptDigitRun();
        lexer.emit(lunr.QueryLexer.EDIT_DISTANCE);
        return lunr.QueryLexer.lexText;
    };
    lunr.QueryLexer.lexBoost = function(lexer) {
        lexer.ignore();
        lexer.acceptDigitRun();
        lexer.emit(lunr.QueryLexer.BOOST);
        return lunr.QueryLexer.lexText;
    };
    lunr.QueryLexer.lexEOS = function(lexer) {
        if (lexer.width() > 0) lexer.emit(lunr.QueryLexer.TERM);
    };
    // This matches the separator used when tokenising fields
    // within a document. These should match otherwise it is
    // not possible to search for some tokens within a document.
    //
    // It is possible for the user to change the separator on the
    // tokenizer so it _might_ clash with any other of the special
    // characters already used within the search string, e.g. :.
    //
    // This means that it is possible to change the separator in
    // such a way that makes some words unsearchable using a search
    // string.
    lunr.QueryLexer.termSeparator = lunr.tokenizer.separator;
    lunr.QueryLexer.lexText = function(lexer) {
        while(true){
            var char = lexer.next();
            if (char == lunr.QueryLexer.EOS) return lunr.QueryLexer.lexEOS;
            // Escape character is '\'
            if (char.charCodeAt(0) == 92) {
                lexer.escapeCharacter();
                continue;
            }
            if (char == ":") return lunr.QueryLexer.lexField;
            if (char == "~") {
                lexer.backup();
                if (lexer.width() > 0) lexer.emit(lunr.QueryLexer.TERM);
                return lunr.QueryLexer.lexEditDistance;
            }
            if (char == "^") {
                lexer.backup();
                if (lexer.width() > 0) lexer.emit(lunr.QueryLexer.TERM);
                return lunr.QueryLexer.lexBoost;
            }
            // "+" indicates term presence is required
            // checking for length to ensure that only
            // leading "+" are considered
            if (char == "+" && lexer.width() === 1) {
                lexer.emit(lunr.QueryLexer.PRESENCE);
                return lunr.QueryLexer.lexText;
            }
            // "-" indicates term presence is prohibited
            // checking for length to ensure that only
            // leading "-" are considered
            if (char == "-" && lexer.width() === 1) {
                lexer.emit(lunr.QueryLexer.PRESENCE);
                return lunr.QueryLexer.lexText;
            }
            if (char.match(lunr.QueryLexer.termSeparator)) return lunr.QueryLexer.lexTerm;
        }
    };
    lunr.QueryParser = function(str, query) {
        this.lexer = new lunr.QueryLexer(str);
        this.query = query;
        this.currentClause = {};
        this.lexemeIdx = 0;
    };
    lunr.QueryParser.prototype.parse = function() {
        this.lexer.run();
        this.lexemes = this.lexer.lexemes;
        var state = lunr.QueryParser.parseClause;
        while(state)state = state(this);
        return this.query;
    };
    lunr.QueryParser.prototype.peekLexeme = function() {
        return this.lexemes[this.lexemeIdx];
    };
    lunr.QueryParser.prototype.consumeLexeme = function() {
        var lexeme = this.peekLexeme();
        this.lexemeIdx += 1;
        return lexeme;
    };
    lunr.QueryParser.prototype.nextClause = function() {
        var completedClause = this.currentClause;
        this.query.clause(completedClause);
        this.currentClause = {};
    };
    lunr.QueryParser.parseClause = function(parser) {
        var lexeme = parser.peekLexeme();
        if (lexeme == undefined) return;
        switch(lexeme.type){
            case lunr.QueryLexer.PRESENCE:
                return lunr.QueryParser.parsePresence;
            case lunr.QueryLexer.FIELD:
                return lunr.QueryParser.parseField;
            case lunr.QueryLexer.TERM:
                return lunr.QueryParser.parseTerm;
            default:
                var errorMessage = "expected either a field or a term, found " + lexeme.type;
                if (lexeme.str.length >= 1) errorMessage += " with value '" + lexeme.str + "'";
                throw new lunr.QueryParseError(errorMessage, lexeme.start, lexeme.end);
        }
    };
    lunr.QueryParser.parsePresence = function(parser) {
        var lexeme = parser.consumeLexeme();
        if (lexeme == undefined) return;
        switch(lexeme.str){
            case "-":
                parser.currentClause.presence = lunr.Query.presence.PROHIBITED;
                break;
            case "+":
                parser.currentClause.presence = lunr.Query.presence.REQUIRED;
                break;
            default:
                var errorMessage = "unrecognised presence operator'" + lexeme.str + "'";
                throw new lunr.QueryParseError(errorMessage, lexeme.start, lexeme.end);
        }
        var nextLexeme = parser.peekLexeme();
        if (nextLexeme == undefined) {
            var errorMessage = "expecting term or field, found nothing";
            throw new lunr.QueryParseError(errorMessage, lexeme.start, lexeme.end);
        }
        switch(nextLexeme.type){
            case lunr.QueryLexer.FIELD:
                return lunr.QueryParser.parseField;
            case lunr.QueryLexer.TERM:
                return lunr.QueryParser.parseTerm;
            default:
                var errorMessage = "expecting term or field, found '" + nextLexeme.type + "'";
                throw new lunr.QueryParseError(errorMessage, nextLexeme.start, nextLexeme.end);
        }
    };
    lunr.QueryParser.parseField = function(parser) {
        var lexeme = parser.consumeLexeme();
        if (lexeme == undefined) return;
        if (parser.query.allFields.indexOf(lexeme.str) == -1) {
            var possibleFields = parser.query.allFields.map(function(f) {
                return "'" + f + "'";
            }).join(', '), errorMessage = "unrecognised field '" + lexeme.str + "', possible fields: " + possibleFields;
            throw new lunr.QueryParseError(errorMessage, lexeme.start, lexeme.end);
        }
        parser.currentClause.fields = [
            lexeme.str
        ];
        var nextLexeme = parser.peekLexeme();
        if (nextLexeme == undefined) {
            var errorMessage = "expecting term, found nothing";
            throw new lunr.QueryParseError(errorMessage, lexeme.start, lexeme.end);
        }
        switch(nextLexeme.type){
            case lunr.QueryLexer.TERM:
                return lunr.QueryParser.parseTerm;
            default:
                var errorMessage = "expecting term, found '" + nextLexeme.type + "'";
                throw new lunr.QueryParseError(errorMessage, nextLexeme.start, nextLexeme.end);
        }
    };
    lunr.QueryParser.parseTerm = function(parser) {
        var lexeme = parser.consumeLexeme();
        if (lexeme == undefined) return;
        parser.currentClause.term = lexeme.str.toLowerCase();
        if (lexeme.str.indexOf("*") != -1) parser.currentClause.usePipeline = false;
        var nextLexeme = parser.peekLexeme();
        if (nextLexeme == undefined) {
            parser.nextClause();
            return;
        }
        switch(nextLexeme.type){
            case lunr.QueryLexer.TERM:
                parser.nextClause();
                return lunr.QueryParser.parseTerm;
            case lunr.QueryLexer.FIELD:
                parser.nextClause();
                return lunr.QueryParser.parseField;
            case lunr.QueryLexer.EDIT_DISTANCE:
                return lunr.QueryParser.parseEditDistance;
            case lunr.QueryLexer.BOOST:
                return lunr.QueryParser.parseBoost;
            case lunr.QueryLexer.PRESENCE:
                parser.nextClause();
                return lunr.QueryParser.parsePresence;
            default:
                var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'";
                throw new lunr.QueryParseError(errorMessage, nextLexeme.start, nextLexeme.end);
        }
    };
    lunr.QueryParser.parseEditDistance = function(parser) {
        var lexeme = parser.consumeLexeme();
        if (lexeme == undefined) return;
        var editDistance = parseInt(lexeme.str, 10);
        if (isNaN(editDistance)) {
            var errorMessage = "edit distance must be numeric";
            throw new lunr.QueryParseError(errorMessage, lexeme.start, lexeme.end);
        }
        parser.currentClause.editDistance = editDistance;
        var nextLexeme = parser.peekLexeme();
        if (nextLexeme == undefined) {
            parser.nextClause();
            return;
        }
        switch(nextLexeme.type){
            case lunr.QueryLexer.TERM:
                parser.nextClause();
                return lunr.QueryParser.parseTerm;
            case lunr.QueryLexer.FIELD:
                parser.nextClause();
                return lunr.QueryParser.parseField;
            case lunr.QueryLexer.EDIT_DISTANCE:
                return lunr.QueryParser.parseEditDistance;
            case lunr.QueryLexer.BOOST:
                return lunr.QueryParser.parseBoost;
            case lunr.QueryLexer.PRESENCE:
                parser.nextClause();
                return lunr.QueryParser.parsePresence;
            default:
                var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'";
                throw new lunr.QueryParseError(errorMessage, nextLexeme.start, nextLexeme.end);
        }
    };
    lunr.QueryParser.parseBoost = function(parser) {
        var lexeme = parser.consumeLexeme();
        if (lexeme == undefined) return;
        var boost = parseInt(lexeme.str, 10);
        if (isNaN(boost)) {
            var errorMessage = "boost must be numeric";
            throw new lunr.QueryParseError(errorMessage, lexeme.start, lexeme.end);
        }
        parser.currentClause.boost = boost;
        var nextLexeme = parser.peekLexeme();
        if (nextLexeme == undefined) {
            parser.nextClause();
            return;
        }
        switch(nextLexeme.type){
            case lunr.QueryLexer.TERM:
                parser.nextClause();
                return lunr.QueryParser.parseTerm;
            case lunr.QueryLexer.FIELD:
                parser.nextClause();
                return lunr.QueryParser.parseField;
            case lunr.QueryLexer.EDIT_DISTANCE:
                return lunr.QueryParser.parseEditDistance;
            case lunr.QueryLexer.BOOST:
                return lunr.QueryParser.parseBoost;
            case lunr.QueryLexer.PRESENCE:
                parser.nextClause();
                return lunr.QueryParser.parsePresence;
            default:
                var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'";
                throw new lunr.QueryParseError(errorMessage, nextLexeme.start, nextLexeme.end);
        }
    } /**
   * export the module via AMD, CommonJS or as a browser global
   * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
   */ ;
    (function(root, factory) {
        if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
        define(factory);
        else /**
       * Node. Does not work with strict CommonJS, but
       * only CommonJS-like enviroments that support module.exports,
       * like Node.
       */ $3581ee5e9a4ae8b2$exports = factory();
    })(this, function() {
        /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */ return lunr;
    });
})();


var $49c217790058dcc8$exports = {};
(function(global, factory) {
    $49c217790058dcc8$exports = factory();
})($49c217790058dcc8$exports, function() {
    'use strict';
    /*!
   * mustache.js - Logic-less {{mustache}} templates with JavaScript
   * http://github.com/janl/mustache.js
   */ var objectToString = Object.prototype.toString;
    var isArray = Array.isArray || function isArrayPolyfill(object) {
        return objectToString.call(object) === '[object Array]';
    };
    function isFunction(object) {
        return typeof object === 'function';
    }
    /**
   * More correct typeof string handling array
   * which normally returns typeof 'object'
   */ function typeStr(obj) {
        return isArray(obj) ? 'array' : typeof obj;
    }
    function escapeRegExp(string) {
        return string.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&');
    }
    /**
   * Null safe way of checking whether or not an object,
   * including its prototype, has a given property
   */ function hasProperty(obj, propName) {
        return obj != null && typeof obj === 'object' && propName in obj;
    }
    /**
   * Safe way of detecting whether or not the given thing is a primitive and
   * whether it has the given property
   */ function primitiveHasOwnProperty(primitive, propName) {
        return primitive != null && typeof primitive !== 'object' && primitive.hasOwnProperty && primitive.hasOwnProperty(propName);
    }
    // Workaround for https://issues.apache.org/jira/browse/COUCHDB-577
    // See https://github.com/janl/mustache.js/issues/189
    var regExpTest = RegExp.prototype.test;
    function testRegExp(re, string) {
        return regExpTest.call(re, string);
    }
    var nonSpaceRe = /\S/;
    function isWhitespace(string) {
        return !testRegExp(nonSpaceRe, string);
    }
    var entityMap = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
        '/': '&#x2F;',
        '`': '&#x60;',
        '=': '&#x3D;'
    };
    function escapeHtml(string) {
        return String(string).replace(/[&<>"'`=\/]/g, function fromEntityMap(s) {
            return entityMap[s];
        });
    }
    var whiteRe = /\s*/;
    var spaceRe = /\s+/;
    var equalsRe = /\s*=/;
    var curlyRe = /\s*\}/;
    var tagRe = /#|\^|\/|>|\{|&|=|!/;
    /**
   * Breaks up the given `template` string into a tree of tokens. If the `tags`
   * argument is given here it must be an array with two string values: the
   * opening and closing tags used in the template (e.g. [ "<%", "%>" ]). Of
   * course, the default is to use mustaches (i.e. mustache.tags).
   *
   * A token is an array with at least 4 elements. The first element is the
   * mustache symbol that was used inside the tag, e.g. "#" or "&". If the tag
   * did not contain a symbol (i.e. {{myValue}}) this element is "name". For
   * all text that appears outside a symbol this element is "text".
   *
   * The second element of a token is its "value". For mustache tags this is
   * whatever else was inside the tag besides the opening symbol. For text tokens
   * this is the text itself.
   *
   * The third and fourth elements of the token are the start and end indices,
   * respectively, of the token in the original template.
   *
   * Tokens that are the root node of a subtree contain two more elements: 1) an
   * array of tokens in the subtree and 2) the index in the original template at
   * which the closing tag for that section begins.
   *
   * Tokens for partials also contain two more elements: 1) a string value of
   * indendation prior to that tag and 2) the index of that tag on that line -
   * eg a value of 2 indicates the partial is the third tag on this line.
   */ function parseTemplate(template, tags) {
        if (!template) return [];
        var lineHasNonSpace = false;
        var sections = []; // Stack to hold section tokens
        var tokens = []; // Buffer to hold the tokens
        var spaces = []; // Indices of whitespace tokens on the current line
        var hasTag = false; // Is there a {{tag}} on the current line?
        var nonSpace = false; // Is there a non-space char on the current line?
        var indentation = ''; // Tracks indentation for tags that use it
        var tagIndex = 0; // Stores a count of number of tags encountered on a line
        // Strips all whitespace tokens array for the current line
        // if there was a {{#tag}} on it and otherwise only space.
        function stripSpace() {
            if (hasTag && !nonSpace) while(spaces.length)delete tokens[spaces.pop()];
            else spaces = [];
            hasTag = false;
            nonSpace = false;
        }
        var openingTagRe, closingTagRe, closingCurlyRe;
        function compileTags(tagsToCompile) {
            if (typeof tagsToCompile === 'string') tagsToCompile = tagsToCompile.split(spaceRe, 2);
            if (!isArray(tagsToCompile) || tagsToCompile.length !== 2) throw new Error('Invalid tags: ' + tagsToCompile);
            openingTagRe = new RegExp(escapeRegExp(tagsToCompile[0]) + '\\s*');
            closingTagRe = new RegExp('\\s*' + escapeRegExp(tagsToCompile[1]));
            closingCurlyRe = new RegExp('\\s*' + escapeRegExp('}' + tagsToCompile[1]));
        }
        compileTags(tags || mustache.tags);
        var scanner = new Scanner(template);
        var start, type, value, chr, token, openSection;
        while(!scanner.eos()){
            start = scanner.pos;
            // Match any text between tags.
            value = scanner.scanUntil(openingTagRe);
            if (value) for(var i = 0, valueLength = value.length; i < valueLength; ++i){
                chr = value.charAt(i);
                if (isWhitespace(chr)) {
                    spaces.push(tokens.length);
                    indentation += chr;
                } else {
                    nonSpace = true;
                    lineHasNonSpace = true;
                    indentation += ' ';
                }
                tokens.push([
                    'text',
                    chr,
                    start,
                    start + 1
                ]);
                start += 1;
                // Check for whitespace on the current line.
                if (chr === '\n') {
                    stripSpace();
                    indentation = '';
                    tagIndex = 0;
                    lineHasNonSpace = false;
                }
            }
            // Match the opening tag.
            if (!scanner.scan(openingTagRe)) break;
            hasTag = true;
            // Get the tag type.
            type = scanner.scan(tagRe) || 'name';
            scanner.scan(whiteRe);
            // Get the tag value.
            if (type === '=') {
                value = scanner.scanUntil(equalsRe);
                scanner.scan(equalsRe);
                scanner.scanUntil(closingTagRe);
            } else if (type === '{') {
                value = scanner.scanUntil(closingCurlyRe);
                scanner.scan(curlyRe);
                scanner.scanUntil(closingTagRe);
                type = '&';
            } else value = scanner.scanUntil(closingTagRe);
            // Match the closing tag.
            if (!scanner.scan(closingTagRe)) throw new Error('Unclosed tag at ' + scanner.pos);
            if (type == '>') token = [
                type,
                value,
                start,
                scanner.pos,
                indentation,
                tagIndex,
                lineHasNonSpace
            ];
            else token = [
                type,
                value,
                start,
                scanner.pos
            ];
            tagIndex++;
            tokens.push(token);
            if (type === '#' || type === '^') sections.push(token);
            else if (type === '/') {
                // Check section nesting.
                openSection = sections.pop();
                if (!openSection) throw new Error('Unopened section "' + value + '" at ' + start);
                if (openSection[1] !== value) throw new Error('Unclosed section "' + openSection[1] + '" at ' + start);
            } else if (type === 'name' || type === '{' || type === '&') nonSpace = true;
            else if (type === '=') // Set the tags for the next time around.
            compileTags(value);
        }
        stripSpace();
        // Make sure there are no open sections when we're done.
        openSection = sections.pop();
        if (openSection) throw new Error('Unclosed section "' + openSection[1] + '" at ' + scanner.pos);
        return nestTokens(squashTokens(tokens));
    }
    /**
   * Combines the values of consecutive text tokens in the given `tokens` array
   * to a single token.
   */ function squashTokens(tokens) {
        var squashedTokens = [];
        var token, lastToken;
        for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
            token = tokens[i];
            if (token) {
                if (token[0] === 'text' && lastToken && lastToken[0] === 'text') {
                    lastToken[1] += token[1];
                    lastToken[3] = token[3];
                } else {
                    squashedTokens.push(token);
                    lastToken = token;
                }
            }
        }
        return squashedTokens;
    }
    /**
   * Forms the given array of `tokens` into a nested tree structure where
   * tokens that represent a section have two additional items: 1) an array of
   * all tokens that appear in that section and 2) the index in the original
   * template that represents the end of that section.
   */ function nestTokens(tokens) {
        var nestedTokens = [];
        var collector = nestedTokens;
        var sections = [];
        var token, section;
        for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
            token = tokens[i];
            switch(token[0]){
                case '#':
                case '^':
                    collector.push(token);
                    sections.push(token);
                    collector = token[4] = [];
                    break;
                case '/':
                    section = sections.pop();
                    section[5] = token[2];
                    collector = sections.length > 0 ? sections[sections.length - 1][4] : nestedTokens;
                    break;
                default:
                    collector.push(token);
            }
        }
        return nestedTokens;
    }
    /**
   * A simple string scanner that is used by the template parser to find
   * tokens in template strings.
   */ function Scanner(string) {
        this.string = string;
        this.tail = string;
        this.pos = 0;
    }
    /**
   * Returns `true` if the tail is empty (end of string).
   */ Scanner.prototype.eos = function eos() {
        return this.tail === '';
    };
    /**
   * Tries to match the given regular expression at the current position.
   * Returns the matched text if it can match, the empty string otherwise.
   */ Scanner.prototype.scan = function scan(re) {
        var match = this.tail.match(re);
        if (!match || match.index !== 0) return '';
        var string = match[0];
        this.tail = this.tail.substring(string.length);
        this.pos += string.length;
        return string;
    };
    /**
   * Skips all text until the given regular expression can be matched. Returns
   * the skipped string, which is the entire tail if no match can be made.
   */ Scanner.prototype.scanUntil = function scanUntil(re) {
        var index = this.tail.search(re), match;
        switch(index){
            case -1:
                match = this.tail;
                this.tail = '';
                break;
            case 0:
                match = '';
                break;
            default:
                match = this.tail.substring(0, index);
                this.tail = this.tail.substring(index);
        }
        this.pos += match.length;
        return match;
    };
    /**
   * Represents a rendering context by wrapping a view object and
   * maintaining a reference to the parent context.
   */ function Context(view, parentContext) {
        this.view = view;
        this.cache = {
            '.': this.view
        };
        this.parent = parentContext;
    }
    /**
   * Creates a new context using the given view with this context
   * as the parent.
   */ Context.prototype.push = function push(view) {
        return new Context(view, this);
    };
    /**
   * Returns the value of the given name in this context, traversing
   * up the context hierarchy if the value is absent in this context's view.
   */ Context.prototype.lookup = function lookup(name) {
        var cache1 = this.cache;
        var value;
        if (cache1.hasOwnProperty(name)) value = cache1[name];
        else {
            var context = this, intermediateValue, names, index, lookupHit = false;
            while(context){
                if (name.indexOf('.') > 0) {
                    intermediateValue = context.view;
                    names = name.split('.');
                    index = 0;
                    /**
           * Using the dot notion path in `name`, we descend through the
           * nested objects.
           *
           * To be certain that the lookup has been successful, we have to
           * check if the last object in the path actually has the property
           * we are looking for. We store the result in `lookupHit`.
           *
           * This is specially necessary for when the value has been set to
           * `undefined` and we want to avoid looking up parent contexts.
           *
           * In the case where dot notation is used, we consider the lookup
           * to be successful even if the last "object" in the path is
           * not actually an object but a primitive (e.g., a string, or an
           * integer), because it is sometimes useful to access a property
           * of an autoboxed primitive, such as the length of a string.
           **/ while(intermediateValue != null && index < names.length){
                        if (index === names.length - 1) lookupHit = hasProperty(intermediateValue, names[index]) || primitiveHasOwnProperty(intermediateValue, names[index]);
                        intermediateValue = intermediateValue[names[index++]];
                    }
                } else {
                    intermediateValue = context.view[name];
                    /**
           * Only checking against `hasProperty`, which always returns `false` if
           * `context.view` is not an object. Deliberately omitting the check
           * against `primitiveHasOwnProperty` if dot notation is not used.
           *
           * Consider this example:
           * ```
           * Mustache.render("The length of a football field is {{#length}}{{length}}{{/length}}.", {length: "100 yards"})
           * ```
           *
           * If we were to check also against `primitiveHasOwnProperty`, as we do
           * in the dot notation case, then render call would return:
           *
           * "The length of a football field is 9."
           *
           * rather than the expected:
           *
           * "The length of a football field is 100 yards."
           **/ lookupHit = hasProperty(context.view, name);
                }
                if (lookupHit) {
                    value = intermediateValue;
                    break;
                }
                context = context.parent;
            }
            cache1[name] = value;
        }
        if (isFunction(value)) value = value.call(this.view);
        return value;
    };
    /**
   * A Writer knows how to take a stream of tokens and render them to a
   * string, given a context. It also maintains a cache of templates to
   * avoid the need to parse the same template twice.
   */ function Writer() {
        this.templateCache = {
            _cache: {},
            set: function set(key, value) {
                this._cache[key] = value;
            },
            get: function get(key) {
                return this._cache[key];
            },
            clear: function clear() {
                this._cache = {};
            }
        };
    }
    /**
   * Clears all cached templates in this writer.
   */ Writer.prototype.clearCache = function clearCache() {
        if (typeof this.templateCache !== 'undefined') this.templateCache.clear();
    };
    /**
   * Parses and caches the given `template` according to the given `tags` or
   * `mustache.tags` if `tags` is omitted,  and returns the array of tokens
   * that is generated from the parse.
   */ Writer.prototype.parse = function parse(template, tags) {
        var cache1 = this.templateCache;
        var cacheKey = template + ':' + (tags || mustache.tags).join(':');
        var isCacheEnabled = typeof cache1 !== 'undefined';
        var tokens = isCacheEnabled ? cache1.get(cacheKey) : undefined;
        if (tokens == undefined) {
            tokens = parseTemplate(template, tags);
            isCacheEnabled && cache1.set(cacheKey, tokens);
        }
        return tokens;
    };
    /**
   * High-level method that is used to render the given `template` with
   * the given `view`.
   *
   * The optional `partials` argument may be an object that contains the
   * names and templates of partials that are used in the template. It may
   * also be a function that is used to load partial templates on the fly
   * that takes a single argument: the name of the partial.
   *
   * If the optional `config` argument is given here, then it should be an
   * object with a `tags` attribute or an `escape` attribute or both.
   * If an array is passed, then it will be interpreted the same way as
   * a `tags` attribute on a `config` object.
   *
   * The `tags` attribute of a `config` object must be an array with two
   * string values: the opening and closing tags used in the template (e.g.
   * [ "<%", "%>" ]). The default is to mustache.tags.
   *
   * The `escape` attribute of a `config` object must be a function which
   * accepts a string as input and outputs a safely escaped string.
   * If an `escape` function is not provided, then an HTML-safe string
   * escaping function is used as the default.
   */ Writer.prototype.render = function render(template, view, partials, config) {
        var tags = this.getConfigTags(config);
        var tokens = this.parse(template, tags);
        var context = view instanceof Context ? view : new Context(view, undefined);
        return this.renderTokens(tokens, context, partials, template, config);
    };
    /**
   * Low-level method that renders the given array of `tokens` using
   * the given `context` and `partials`.
   *
   * Note: The `originalTemplate` is only ever used to extract the portion
   * of the original template that was contained in a higher-order section.
   * If the template doesn't use higher-order sections, this argument may
   * be omitted.
   */ Writer.prototype.renderTokens = function renderTokens(tokens, context, partials, originalTemplate, config) {
        var buffer = '';
        var token, symbol, value;
        for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
            value = undefined;
            token = tokens[i];
            symbol = token[0];
            if (symbol === '#') value = this.renderSection(token, context, partials, originalTemplate, config);
            else if (symbol === '^') value = this.renderInverted(token, context, partials, originalTemplate, config);
            else if (symbol === '>') value = this.renderPartial(token, context, partials, config);
            else if (symbol === '&') value = this.unescapedValue(token, context);
            else if (symbol === 'name') value = this.escapedValue(token, context, config);
            else if (symbol === 'text') value = this.rawValue(token);
            if (value !== undefined) buffer += value;
        }
        return buffer;
    };
    Writer.prototype.renderSection = function renderSection(token, context, partials, originalTemplate, config) {
        var self = this;
        var buffer = '';
        var value = context.lookup(token[1]);
        // This function is used to render an arbitrary template
        // in the current context by higher-order sections.
        function subRender(template) {
            return self.render(template, context, partials, config);
        }
        if (!value) return;
        if (isArray(value)) for(var j = 0, valueLength = value.length; j < valueLength; ++j)buffer += this.renderTokens(token[4], context.push(value[j]), partials, originalTemplate, config);
        else if (typeof value === 'object' || typeof value === 'string' || typeof value === 'number') buffer += this.renderTokens(token[4], context.push(value), partials, originalTemplate, config);
        else if (isFunction(value)) {
            if (typeof originalTemplate !== 'string') throw new Error('Cannot use higher-order sections without the original template');
            // Extract the portion of the original template that the section contains.
            value = value.call(context.view, originalTemplate.slice(token[3], token[5]), subRender);
            if (value != null) buffer += value;
        } else buffer += this.renderTokens(token[4], context, partials, originalTemplate, config);
        return buffer;
    };
    Writer.prototype.renderInverted = function renderInverted(token, context, partials, originalTemplate, config) {
        var value = context.lookup(token[1]);
        // Use JavaScript's definition of falsy. Include empty arrays.
        // See https://github.com/janl/mustache.js/issues/186
        if (!value || isArray(value) && value.length === 0) return this.renderTokens(token[4], context, partials, originalTemplate, config);
    };
    Writer.prototype.indentPartial = function indentPartial(partial, indentation, lineHasNonSpace) {
        var filteredIndentation = indentation.replace(/[^ \t]/g, '');
        var partialByNl = partial.split('\n');
        for(var i = 0; i < partialByNl.length; i++)if (partialByNl[i].length && (i > 0 || !lineHasNonSpace)) partialByNl[i] = filteredIndentation + partialByNl[i];
        return partialByNl.join('\n');
    };
    Writer.prototype.renderPartial = function renderPartial(token, context, partials, config) {
        if (!partials) return;
        var tags = this.getConfigTags(config);
        var value = isFunction(partials) ? partials(token[1]) : partials[token[1]];
        if (value != null) {
            var lineHasNonSpace = token[6];
            var tagIndex = token[5];
            var indentation = token[4];
            var indentedValue = value;
            if (tagIndex == 0 && indentation) indentedValue = this.indentPartial(value, indentation, lineHasNonSpace);
            var tokens = this.parse(indentedValue, tags);
            return this.renderTokens(tokens, context, partials, indentedValue, config);
        }
    };
    Writer.prototype.unescapedValue = function unescapedValue(token, context) {
        var value = context.lookup(token[1]);
        if (value != null) return value;
    };
    Writer.prototype.escapedValue = function escapedValue(token, context, config) {
        var escape = this.getConfigEscape(config) || mustache.escape;
        var value = context.lookup(token[1]);
        if (value != null) return typeof value === 'number' && escape === mustache.escape ? String(value) : escape(value);
    };
    Writer.prototype.rawValue = function rawValue(token) {
        return token[1];
    };
    Writer.prototype.getConfigTags = function getConfigTags(config) {
        if (isArray(config)) return config;
        else if (config && typeof config === 'object') return config.tags;
        else return undefined;
    };
    Writer.prototype.getConfigEscape = function getConfigEscape(config) {
        if (config && typeof config === 'object' && !isArray(config)) return config.escape;
        else return undefined;
    };
    var mustache = {
        name: 'mustache.js',
        version: '4.2.0',
        tags: [
            '{{',
            '}}'
        ],
        clearCache: undefined,
        escape: undefined,
        parse: undefined,
        render: undefined,
        Scanner: undefined,
        Context: undefined,
        Writer: undefined,
        /**
     * Allows a user to override the default caching strategy, by providing an
     * object with set, get and clear methods. This can also be used to disable
     * the cache by setting it to the literal `undefined`.
     */ set templateCache (cache){
            defaultWriter.templateCache = cache;
        },
        /**
     * Gets the default or overridden caching object from the default writer.
     */ get templateCache () {
            return defaultWriter.templateCache;
        }
    };
    // All high-level mustache.* functions use this writer.
    var defaultWriter = new Writer();
    /**
   * Clears all cached templates in the default writer.
   */ mustache.clearCache = function clearCache() {
        return defaultWriter.clearCache();
    };
    /**
   * Parses and caches the given template in the default writer and returns the
   * array of tokens it contains. Doing this ahead of time avoids the need to
   * parse templates on the fly as they are rendered.
   */ mustache.parse = function parse(template, tags) {
        return defaultWriter.parse(template, tags);
    };
    /**
   * Renders the `template` with the given `view`, `partials`, and `config`
   * using the default writer.
   */ mustache.render = function render(template, view, partials, config) {
        if (typeof template !== 'string') throw new TypeError('Invalid template! Template should be a "string" but "' + typeStr(template) + '" was given as the first ' + 'argument for mustache#render(template, view, partials)');
        return defaultWriter.render(template, view, partials, config);
    };
    // Export the escaping function so that the user may override it.
    // See https://github.com/janl/mustache.js/issues/244
    mustache.escape = escapeHtml;
    // Export these mainly for testing, but also for advanced usage.
    mustache.Scanner = Scanner;
    mustache.Context = Context;
    mustache.Writer = Writer;
    return mustache;
});


function $fa9a32662aa629fa$var$t(t) {
    return "object" == typeof t && null != t && 1 === t.nodeType;
}
function $fa9a32662aa629fa$var$e(t, e) {
    return (!e || "hidden" !== t) && "visible" !== t && "clip" !== t;
}
function $fa9a32662aa629fa$var$n(t, n) {
    if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
        var r = getComputedStyle(t, null);
        return $fa9a32662aa629fa$var$e(r.overflowY, n) || $fa9a32662aa629fa$var$e(r.overflowX, n) || function(t) {
            var e = function(t) {
                if (!t.ownerDocument || !t.ownerDocument.defaultView) return null;
                try {
                    return t.ownerDocument.defaultView.frameElement;
                } catch (t) {
                    return null;
                }
            }(t);
            return !!e && (e.clientHeight < t.scrollHeight || e.clientWidth < t.scrollWidth);
        }(t);
    }
    return !1;
}
function $fa9a32662aa629fa$var$r(t, e, n, r, i, o, l, d) {
    return o < t && l > e || o > t && l < e ? 0 : o <= t && d <= n || l >= e && d >= n ? o - t - r : l > e && d < n || o < t && d > n ? l - e + i : 0;
}
var $fa9a32662aa629fa$export$2e2bcd8739ae039 = function(e, i) {
    var o = window, l = i.scrollMode, d = i.block, f = i.inline, h = i.boundary, u = i.skipOverflowHiddenElements, s = "function" == typeof h ? h : function(t) {
        return t !== h;
    };
    if (!$fa9a32662aa629fa$var$t(e)) throw new TypeError("Invalid target");
    for(var a, c, g = document.scrollingElement || document.documentElement, p = [], m = e; $fa9a32662aa629fa$var$t(m) && s(m);){
        if ((m = null == (c = (a = m).parentElement) ? a.getRootNode().host || null : c) === g) {
            p.push(m);
            break;
        }
        null != m && m === document.body && $fa9a32662aa629fa$var$n(m) && !$fa9a32662aa629fa$var$n(document.documentElement) || null != m && $fa9a32662aa629fa$var$n(m, u) && p.push(m);
    }
    for(var w = o.visualViewport ? o.visualViewport.width : innerWidth, v = o.visualViewport ? o.visualViewport.height : innerHeight, W = window.scrollX || pageXOffset, H = window.scrollY || pageYOffset, b = e.getBoundingClientRect(), y = b.height, E = b.width, M = b.top, V = b.right, x = b.bottom, I = b.left, C = "start" === d || "nearest" === d ? M : "end" === d ? x : M + y / 2, R = "center" === f ? I + E / 2 : "end" === f ? V : I, T = [], k = 0; k < p.length; k++){
        var B = p[k], D = B.getBoundingClientRect(), O = D.height, X = D.width, Y = D.top, L = D.right, S = D.bottom, j = D.left;
        if ("if-needed" === l && M >= 0 && I >= 0 && x <= v && V <= w && M >= Y && x <= S && I >= j && V <= L) return T;
        var N = getComputedStyle(B), q = parseInt(N.borderLeftWidth, 10), z = parseInt(N.borderTopWidth, 10), A = parseInt(N.borderRightWidth, 10), F = parseInt(N.borderBottomWidth, 10), G = 0, J = 0, K = "offsetWidth" in B ? B.offsetWidth - B.clientWidth - q - A : 0, P = "offsetHeight" in B ? B.offsetHeight - B.clientHeight - z - F : 0, Q = "offsetWidth" in B ? 0 === B.offsetWidth ? 0 : X / B.offsetWidth : 0, U = "offsetHeight" in B ? 0 === B.offsetHeight ? 0 : O / B.offsetHeight : 0;
        if (g === B) G = "start" === d ? C : "end" === d ? C - v : "nearest" === d ? $fa9a32662aa629fa$var$r(H, H + v, v, z, F, H + C, H + C + y, y) : C - v / 2, J = "start" === f ? R : "center" === f ? R - w / 2 : "end" === f ? R - w : $fa9a32662aa629fa$var$r(W, W + w, w, q, A, W + R, W + R + E, E), G = Math.max(0, G + H), J = Math.max(0, J + W);
        else {
            G = "start" === d ? C - Y - z : "end" === d ? C - S + F + P : "nearest" === d ? $fa9a32662aa629fa$var$r(Y, S, O, z, F + P, C, C + y, y) : C - (Y + O / 2) + P / 2, J = "start" === f ? R - j - q : "center" === f ? R - (j + X / 2) + K / 2 : "end" === f ? R - L + A + K : $fa9a32662aa629fa$var$r(j, L, X, q, A + K, R, R + E, E);
            var Z = B.scrollLeft, $ = B.scrollTop;
            C += $ - (G = Math.max(0, Math.min($ + G / U, B.scrollHeight - O / U + P))), R += Z - (J = Math.max(0, Math.min(Z + J / Q, B.scrollWidth - X / Q + K)));
        }
        T.push({
            el: B,
            top: G,
            left: J
        });
    }
    return T;
};


function $29db0e804895ff35$var$isOptionsObject(options) {
    return options === Object(options) && Object.keys(options).length !== 0;
}
function $29db0e804895ff35$var$defaultBehavior(actions, behavior) {
    if (behavior === void 0) behavior = 'auto';
    var canSmoothScroll = 'scrollBehavior' in document.body.style;
    actions.forEach(function(_ref) {
        var el = _ref.el, top = _ref.top, left = _ref.left;
        if (el.scroll && canSmoothScroll) el.scroll({
            top: top,
            left: left,
            behavior: behavior
        });
        else {
            el.scrollTop = top;
            el.scrollLeft = left;
        }
    });
}
function $29db0e804895ff35$var$getOptions(options) {
    if (options === false) return {
        block: 'end',
        inline: 'nearest'
    };
    if ($29db0e804895ff35$var$isOptionsObject(options)) return options;
    return {
        block: 'start',
        inline: 'nearest'
    };
}
function $29db0e804895ff35$var$scrollIntoView(target, options) {
    var isTargetAttached = target.isConnected || target.ownerDocument.documentElement.contains(target);
    if ($29db0e804895ff35$var$isOptionsObject(options) && typeof options.behavior === 'function') return options.behavior(isTargetAttached ? (0, $fa9a32662aa629fa$export$2e2bcd8739ae039)(target, options) : []);
    if (!isTargetAttached) return;
    var computeOptions = $29db0e804895ff35$var$getOptions(options);
    return $29db0e804895ff35$var$defaultBehavior((0, $fa9a32662aa629fa$export$2e2bcd8739ae039)(target, computeOptions), computeOptions.behavior);
}
var $29db0e804895ff35$export$2e2bcd8739ae039 = $29db0e804895ff35$var$scrollIntoView;


var $2ab1c991cdb4f4ac$exports = {};
/*!***************************************************
* mark.js v8.11.1
* https://markjs.io/
* Copyright (c) 2014–2018, Julian Kühnel
* Released under the MIT license https://git.io/vwTVl
*****************************************************/ (function(global, factory) {
    $2ab1c991cdb4f4ac$exports = factory();
})($2ab1c991cdb4f4ac$exports, function() {
    'use strict';
    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    var classCallCheck = function(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    };
    var createClass = function() {
        function defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();
    var _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    var DOMIterator = function() {
        function DOMIterator(ctx) {
            var iframes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            var exclude = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
            var iframesTimeout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 5000;
            classCallCheck(this, DOMIterator);
            this.ctx = ctx;
            this.iframes = iframes;
            this.exclude = exclude;
            this.iframesTimeout = iframesTimeout;
        }
        createClass(DOMIterator, [
            {
                key: 'getContexts',
                value: function getContexts() {
                    var ctx = void 0, filteredCtx = [];
                    if (typeof this.ctx === 'undefined' || !this.ctx) ctx = [];
                    else if (NodeList.prototype.isPrototypeOf(this.ctx)) ctx = Array.prototype.slice.call(this.ctx);
                    else if (Array.isArray(this.ctx)) ctx = this.ctx;
                    else if (typeof this.ctx === 'string') ctx = Array.prototype.slice.call(document.querySelectorAll(this.ctx));
                    else ctx = [
                        this.ctx
                    ];
                    ctx.forEach(function(ctx) {
                        var isDescendant = filteredCtx.filter(function(contexts) {
                            return contexts.contains(ctx);
                        }).length > 0;
                        if (filteredCtx.indexOf(ctx) === -1 && !isDescendant) filteredCtx.push(ctx);
                    });
                    return filteredCtx;
                }
            },
            {
                key: 'getIframeContents',
                value: function getIframeContents(ifr, successFn) {
                    var errorFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function() {};
                    var doc = void 0;
                    try {
                        var ifrWin = ifr.contentWindow;
                        doc = ifrWin.document;
                        if (!ifrWin || !doc) throw new Error('iframe inaccessible');
                    } catch (e) {
                        errorFn();
                    }
                    if (doc) successFn(doc);
                }
            },
            {
                key: 'isIframeBlank',
                value: function isIframeBlank(ifr) {
                    var bl = 'about:blank', src = ifr.getAttribute('src').trim(), href = ifr.contentWindow.location.href;
                    return href === bl && src !== bl && src;
                }
            },
            {
                key: 'observeIframeLoad',
                value: function observeIframeLoad(ifr, successFn, errorFn) {
                    var _this = this;
                    var called = false, tout = null;
                    var listener = function listener() {
                        if (called) return;
                        called = true;
                        clearTimeout(tout);
                        try {
                            if (!_this.isIframeBlank(ifr)) {
                                ifr.removeEventListener('load', listener);
                                _this.getIframeContents(ifr, successFn, errorFn);
                            }
                        } catch (e) {
                            errorFn();
                        }
                    };
                    ifr.addEventListener('load', listener);
                    tout = setTimeout(listener, this.iframesTimeout);
                }
            },
            {
                key: 'onIframeReady',
                value: function onIframeReady(ifr, successFn, errorFn) {
                    try {
                        if (ifr.contentWindow.document.readyState === 'complete') {
                            if (this.isIframeBlank(ifr)) this.observeIframeLoad(ifr, successFn, errorFn);
                            else this.getIframeContents(ifr, successFn, errorFn);
                        } else this.observeIframeLoad(ifr, successFn, errorFn);
                    } catch (e) {
                        errorFn();
                    }
                }
            },
            {
                key: 'waitForIframes',
                value: function waitForIframes(ctx, done) {
                    var _this2 = this;
                    var eachCalled = 0;
                    this.forEachIframe(ctx, function() {
                        return true;
                    }, function(ifr) {
                        eachCalled++;
                        _this2.waitForIframes(ifr.querySelector('html'), function() {
                            if (!--eachCalled) done();
                        });
                    }, function(handled) {
                        if (!handled) done();
                    });
                }
            },
            {
                key: 'forEachIframe',
                value: function forEachIframe(ctx, filter, each) {
                    var _this3 = this;
                    var end = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function() {};
                    var ifr = ctx.querySelectorAll('iframe'), open = ifr.length, handled = 0;
                    ifr = Array.prototype.slice.call(ifr);
                    var checkEnd = function checkEnd() {
                        if (--open <= 0) end(handled);
                    };
                    if (!open) checkEnd();
                    ifr.forEach(function(ifr) {
                        if (DOMIterator.matches(ifr, _this3.exclude)) checkEnd();
                        else _this3.onIframeReady(ifr, function(con) {
                            if (filter(ifr)) {
                                handled++;
                                each(con);
                            }
                            checkEnd();
                        }, checkEnd);
                    });
                }
            },
            {
                key: 'createIterator',
                value: function createIterator(ctx, whatToShow, filter) {
                    return document.createNodeIterator(ctx, whatToShow, filter, false);
                }
            },
            {
                key: 'createInstanceOnIframe',
                value: function createInstanceOnIframe(contents) {
                    return new DOMIterator(contents.querySelector('html'), this.iframes);
                }
            },
            {
                key: 'compareNodeIframe',
                value: function compareNodeIframe(node, prevNode, ifr) {
                    var compCurr = node.compareDocumentPosition(ifr), prev = Node.DOCUMENT_POSITION_PRECEDING;
                    if (compCurr & prev) {
                        if (prevNode !== null) {
                            var compPrev = prevNode.compareDocumentPosition(ifr), after = Node.DOCUMENT_POSITION_FOLLOWING;
                            if (compPrev & after) return true;
                        } else return true;
                    }
                    return false;
                }
            },
            {
                key: 'getIteratorNode',
                value: function getIteratorNode(itr) {
                    var prevNode = itr.previousNode();
                    var node = void 0;
                    if (prevNode === null) node = itr.nextNode();
                    else node = itr.nextNode() && itr.nextNode();
                    return {
                        prevNode: prevNode,
                        node: node
                    };
                }
            },
            {
                key: 'checkIframeFilter',
                value: function checkIframeFilter(node, prevNode, currIfr, ifr) {
                    var key = false, handled = false;
                    ifr.forEach(function(ifrDict, i) {
                        if (ifrDict.val === currIfr) {
                            key = i;
                            handled = ifrDict.handled;
                        }
                    });
                    if (this.compareNodeIframe(node, prevNode, currIfr)) {
                        if (key === false && !handled) ifr.push({
                            val: currIfr,
                            handled: true
                        });
                        else if (key !== false && !handled) ifr[key].handled = true;
                        return true;
                    }
                    if (key === false) ifr.push({
                        val: currIfr,
                        handled: false
                    });
                    return false;
                }
            },
            {
                key: 'handleOpenIframes',
                value: function handleOpenIframes(ifr, whatToShow, eCb, fCb) {
                    var _this4 = this;
                    ifr.forEach(function(ifrDict) {
                        if (!ifrDict.handled) _this4.getIframeContents(ifrDict.val, function(con) {
                            _this4.createInstanceOnIframe(con).forEachNode(whatToShow, eCb, fCb);
                        });
                    });
                }
            },
            {
                key: 'iterateThroughNodes',
                value: function iterateThroughNodes(whatToShow, ctx, eachCb, filterCb, doneCb) {
                    var _this5 = this;
                    var itr = this.createIterator(ctx, whatToShow, filterCb);
                    var ifr = [], elements = [], node = void 0, prevNode = void 0, retrieveNodes = function retrieveNodes() {
                        var _getIteratorNode = _this5.getIteratorNode(itr);
                        prevNode = _getIteratorNode.prevNode;
                        node = _getIteratorNode.node;
                        return node;
                    };
                    while(retrieveNodes()){
                        if (this.iframes) this.forEachIframe(ctx, function(currIfr) {
                            return _this5.checkIframeFilter(node, prevNode, currIfr, ifr);
                        }, function(con) {
                            _this5.createInstanceOnIframe(con).forEachNode(whatToShow, function(ifrNode) {
                                return elements.push(ifrNode);
                            }, filterCb);
                        });
                        elements.push(node);
                    }
                    elements.forEach(function(node) {
                        eachCb(node);
                    });
                    if (this.iframes) this.handleOpenIframes(ifr, whatToShow, eachCb, filterCb);
                    doneCb();
                }
            },
            {
                key: 'forEachNode',
                value: function forEachNode(whatToShow, each, filter) {
                    var _this6 = this;
                    var done = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function() {};
                    var contexts = this.getContexts();
                    var open = contexts.length;
                    if (!open) done();
                    contexts.forEach(function(ctx) {
                        var ready = function ready() {
                            _this6.iterateThroughNodes(whatToShow, ctx, each, filter, function() {
                                if (--open <= 0) done();
                            });
                        };
                        if (_this6.iframes) _this6.waitForIframes(ctx, ready);
                        else ready();
                    });
                }
            }
        ], [
            {
                key: 'matches',
                value: function matches(element, selector) {
                    var selectors = typeof selector === 'string' ? [
                        selector
                    ] : selector, fn = element.matches || element.matchesSelector || element.msMatchesSelector || element.mozMatchesSelector || element.oMatchesSelector || element.webkitMatchesSelector;
                    if (fn) {
                        var match = false;
                        selectors.every(function(sel) {
                            if (fn.call(element, sel)) {
                                match = true;
                                return false;
                            }
                            return true;
                        });
                        return match;
                    } else return false;
                }
            }
        ]);
        return DOMIterator;
    }();
    var Mark$1 = function() {
        function Mark(ctx) {
            classCallCheck(this, Mark);
            this.ctx = ctx;
            this.ie = false;
            var ua = window.navigator.userAgent;
            if (ua.indexOf('MSIE') > -1 || ua.indexOf('Trident') > -1) this.ie = true;
        }
        createClass(Mark, [
            {
                key: 'log',
                value: function log(msg) {
                    var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'debug';
                    var log = this.opt.log;
                    if (!this.opt.debug) return;
                    if ((typeof log === 'undefined' ? 'undefined' : _typeof(log)) === 'object' && typeof log[level] === 'function') log[level]('mark.js: ' + msg);
                }
            },
            {
                key: 'escapeStr',
                value: function escapeStr(str) {
                    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
                }
            },
            {
                key: 'createRegExp',
                value: function createRegExp(str) {
                    if (this.opt.wildcards !== 'disabled') str = this.setupWildcardsRegExp(str);
                    str = this.escapeStr(str);
                    if (Object.keys(this.opt.synonyms).length) str = this.createSynonymsRegExp(str);
                    if (this.opt.ignoreJoiners || this.opt.ignorePunctuation.length) str = this.setupIgnoreJoinersRegExp(str);
                    if (this.opt.diacritics) str = this.createDiacriticsRegExp(str);
                    str = this.createMergedBlanksRegExp(str);
                    if (this.opt.ignoreJoiners || this.opt.ignorePunctuation.length) str = this.createJoinersRegExp(str);
                    if (this.opt.wildcards !== 'disabled') str = this.createWildcardsRegExp(str);
                    str = this.createAccuracyRegExp(str);
                    return str;
                }
            },
            {
                key: 'createSynonymsRegExp',
                value: function createSynonymsRegExp(str) {
                    var syn = this.opt.synonyms, sens = this.opt.caseSensitive ? '' : 'i', joinerPlaceholder = this.opt.ignoreJoiners || this.opt.ignorePunctuation.length ? '\0' : '';
                    for(var index in syn)if (syn.hasOwnProperty(index)) {
                        var value = syn[index], k1 = this.opt.wildcards !== 'disabled' ? this.setupWildcardsRegExp(index) : this.escapeStr(index), k2 = this.opt.wildcards !== 'disabled' ? this.setupWildcardsRegExp(value) : this.escapeStr(value);
                        if (k1 !== '' && k2 !== '') str = str.replace(new RegExp('(' + this.escapeStr(k1) + '|' + this.escapeStr(k2) + ')', 'gm' + sens), joinerPlaceholder + ('(' + this.processSynomyms(k1) + '|') + (this.processSynomyms(k2) + ')') + joinerPlaceholder);
                    }
                    return str;
                }
            },
            {
                key: 'processSynomyms',
                value: function processSynomyms(str) {
                    if (this.opt.ignoreJoiners || this.opt.ignorePunctuation.length) str = this.setupIgnoreJoinersRegExp(str);
                    return str;
                }
            },
            {
                key: 'setupWildcardsRegExp',
                value: function setupWildcardsRegExp(str) {
                    str = str.replace(/(?:\\)*\?/g, function(val) {
                        return val.charAt(0) === '\\' ? '?' : '\x01';
                    });
                    return str.replace(/(?:\\)*\*/g, function(val) {
                        return val.charAt(0) === '\\' ? '*' : '\x02';
                    });
                }
            },
            {
                key: 'createWildcardsRegExp',
                value: function createWildcardsRegExp(str) {
                    var spaces = this.opt.wildcards === 'withSpaces';
                    return str.replace(/\u0001/g, spaces ? '[\\S\\s]?' : '\\S?').replace(/\u0002/g, spaces ? '[\\S\\s]*?' : '\\S*');
                }
            },
            {
                key: 'setupIgnoreJoinersRegExp',
                value: function setupIgnoreJoinersRegExp(str) {
                    return str.replace(/[^(|)\\]/g, function(val, indx, original) {
                        var nextChar = original.charAt(indx + 1);
                        if (/[(|)\\]/.test(nextChar) || nextChar === '') return val;
                        else return val + '\0';
                    });
                }
            },
            {
                key: 'createJoinersRegExp',
                value: function createJoinersRegExp(str) {
                    var joiner = [];
                    var ignorePunctuation = this.opt.ignorePunctuation;
                    if (Array.isArray(ignorePunctuation) && ignorePunctuation.length) joiner.push(this.escapeStr(ignorePunctuation.join('')));
                    if (this.opt.ignoreJoiners) joiner.push('\\u00ad\\u200b\\u200c\\u200d');
                    return joiner.length ? str.split(/\u0000+/).join('[' + joiner.join('') + ']*') : str;
                }
            },
            {
                key: 'createDiacriticsRegExp',
                value: function createDiacriticsRegExp(str) {
                    var sens = this.opt.caseSensitive ? '' : 'i', dct = this.opt.caseSensitive ? [
                        "a\xe0\xe1\u1EA3\xe3\u1EA1\u0103\u1EB1\u1EAF\u1EB3\u1EB5\u1EB7\xe2\u1EA7\u1EA5\u1EA9\u1EAB\u1EAD\xe4\xe5\u0101\u0105",
                        "A\xc0\xc1\u1EA2\xc3\u1EA0\u0102\u1EB0\u1EAE\u1EB2\u1EB4\u1EB6\xc2\u1EA6\u1EA4\u1EA8\u1EAA\u1EAC\xc4\xc5\u0100\u0104",
                        "c\xe7\u0107\u010D",
                        "C\xc7\u0106\u010C",
                        "d\u0111\u010F",
                        "D\u0110\u010E",
                        "e\xe8\xe9\u1EBB\u1EBD\u1EB9\xea\u1EC1\u1EBF\u1EC3\u1EC5\u1EC7\xeb\u011B\u0113\u0119",
                        "E\xc8\xc9\u1EBA\u1EBC\u1EB8\xca\u1EC0\u1EBE\u1EC2\u1EC4\u1EC6\xcb\u011A\u0112\u0118",
                        "i\xec\xed\u1EC9\u0129\u1ECB\xee\xef\u012B",
                        "I\xcc\xcd\u1EC8\u0128\u1ECA\xce\xcf\u012A",
                        "l\u0142",
                        "L\u0141",
                        "n\xf1\u0148\u0144",
                        "N\xd1\u0147\u0143",
                        "o\xf2\xf3\u1ECF\xf5\u1ECD\xf4\u1ED3\u1ED1\u1ED5\u1ED7\u1ED9\u01A1\u1EDF\u1EE1\u1EDB\u1EDD\u1EE3\xf6\xf8\u014D",
                        "O\xd2\xd3\u1ECE\xd5\u1ECC\xd4\u1ED2\u1ED0\u1ED4\u1ED6\u1ED8\u01A0\u1EDE\u1EE0\u1EDA\u1EDC\u1EE2\xd6\xd8\u014C",
                        "r\u0159",
                        "R\u0158",
                        "s\u0161\u015B\u0219\u015F",
                        "S\u0160\u015A\u0218\u015E",
                        "t\u0165\u021B\u0163",
                        "T\u0164\u021A\u0162",
                        "u\xf9\xfa\u1EE7\u0169\u1EE5\u01B0\u1EEB\u1EE9\u1EED\u1EEF\u1EF1\xfb\xfc\u016F\u016B",
                        "U\xd9\xda\u1EE6\u0168\u1EE4\u01AF\u1EEA\u1EE8\u1EEC\u1EEE\u1EF0\xdb\xdc\u016E\u016A",
                        "y\xfd\u1EF3\u1EF7\u1EF9\u1EF5\xff",
                        "Y\xdd\u1EF2\u1EF6\u1EF8\u1EF4\u0178",
                        "z\u017E\u017C\u017A",
                        "Z\u017D\u017B\u0179"
                    ] : [
                        "a\xe0\xe1\u1EA3\xe3\u1EA1\u0103\u1EB1\u1EAF\u1EB3\u1EB5\u1EB7\xe2\u1EA7\u1EA5\u1EA9\u1EAB\u1EAD\xe4\xe5\u0101\u0105A\xc0\xc1\u1EA2\xc3\u1EA0\u0102\u1EB0\u1EAE\u1EB2\u1EB4\u1EB6\xc2\u1EA6\u1EA4\u1EA8\u1EAA\u1EAC\xc4\xc5\u0100\u0104",
                        "c\xe7\u0107\u010DC\xc7\u0106\u010C",
                        "d\u0111\u010FD\u0110\u010E",
                        "e\xe8\xe9\u1EBB\u1EBD\u1EB9\xea\u1EC1\u1EBF\u1EC3\u1EC5\u1EC7\xeb\u011B\u0113\u0119E\xc8\xc9\u1EBA\u1EBC\u1EB8\xca\u1EC0\u1EBE\u1EC2\u1EC4\u1EC6\xcb\u011A\u0112\u0118",
                        "i\xec\xed\u1EC9\u0129\u1ECB\xee\xef\u012BI\xcc\xcd\u1EC8\u0128\u1ECA\xce\xcf\u012A",
                        "l\u0142L\u0141",
                        "n\xf1\u0148\u0144N\xd1\u0147\u0143",
                        "o\xf2\xf3\u1ECF\xf5\u1ECD\xf4\u1ED3\u1ED1\u1ED5\u1ED7\u1ED9\u01A1\u1EDF\u1EE1\u1EDB\u1EDD\u1EE3\xf6\xf8\u014DO\xd2\xd3\u1ECE\xd5\u1ECC\xd4\u1ED2\u1ED0\u1ED4\u1ED6\u1ED8\u01A0\u1EDE\u1EE0\u1EDA\u1EDC\u1EE2\xd6\xd8\u014C",
                        "r\u0159R\u0158",
                        "s\u0161\u015B\u0219\u015FS\u0160\u015A\u0218\u015E",
                        "t\u0165\u021B\u0163T\u0164\u021A\u0162",
                        "u\xf9\xfa\u1EE7\u0169\u1EE5\u01B0\u1EEB\u1EE9\u1EED\u1EEF\u1EF1\xfb\xfc\u016F\u016BU\xd9\xda\u1EE6\u0168\u1EE4\u01AF\u1EEA\u1EE8\u1EEC\u1EEE\u1EF0\xdb\xdc\u016E\u016A",
                        "y\xfd\u1EF3\u1EF7\u1EF9\u1EF5\xffY\xdd\u1EF2\u1EF6\u1EF8\u1EF4\u0178",
                        "z\u017E\u017C\u017AZ\u017D\u017B\u0179"
                    ];
                    var handled = [];
                    str.split('').forEach(function(ch) {
                        dct.every(function(dct) {
                            if (dct.indexOf(ch) !== -1) {
                                if (handled.indexOf(dct) > -1) return false;
                                str = str.replace(new RegExp('[' + dct + ']', 'gm' + sens), '[' + dct + ']');
                                handled.push(dct);
                            }
                            return true;
                        });
                    });
                    return str;
                }
            },
            {
                key: 'createMergedBlanksRegExp',
                value: function createMergedBlanksRegExp(str) {
                    return str.replace(/[\s]+/gmi, '[\\s]+');
                }
            },
            {
                key: 'createAccuracyRegExp',
                value: function createAccuracyRegExp(str) {
                    var _this = this;
                    var chars = "!\"#$%&'()*+,-./:;<=>?@[\\]^_`{|}~\xa1\xbf";
                    var acc = this.opt.accuracy, val = typeof acc === 'string' ? acc : acc.value, ls = typeof acc === 'string' ? [] : acc.limiters, lsJoin = '';
                    ls.forEach(function(limiter) {
                        lsJoin += '|' + _this.escapeStr(limiter);
                    });
                    switch(val){
                        case 'partially':
                        default:
                            return '()(' + str + ')';
                        case 'complementary':
                            lsJoin = '\\s' + (lsJoin ? lsJoin : this.escapeStr(chars));
                            return '()([^' + lsJoin + ']*' + str + '[^' + lsJoin + ']*)';
                        case 'exactly':
                            return '(^|\\s' + lsJoin + ')(' + str + ')(?=$|\\s' + lsJoin + ')';
                    }
                }
            },
            {
                key: 'getSeparatedKeywords',
                value: function getSeparatedKeywords(sv) {
                    var _this2 = this;
                    var stack = [];
                    sv.forEach(function(kw) {
                        if (!_this2.opt.separateWordSearch) {
                            if (kw.trim() && stack.indexOf(kw) === -1) stack.push(kw);
                        } else kw.split(' ').forEach(function(kwSplitted) {
                            if (kwSplitted.trim() && stack.indexOf(kwSplitted) === -1) stack.push(kwSplitted);
                        });
                    });
                    return {
                        'keywords': stack.sort(function(a, b) {
                            return b.length - a.length;
                        }),
                        'length': stack.length
                    };
                }
            },
            {
                key: 'isNumeric',
                value: function isNumeric(value) {
                    return Number(parseFloat(value)) == value;
                }
            },
            {
                key: 'checkRanges',
                value: function checkRanges(array) {
                    var _this3 = this;
                    if (!Array.isArray(array) || Object.prototype.toString.call(array[0]) !== '[object Object]') {
                        this.log('markRanges() will only accept an array of objects');
                        this.opt.noMatch(array);
                        return [];
                    }
                    var stack = [];
                    var last = 0;
                    array.sort(function(a, b) {
                        return a.start - b.start;
                    }).forEach(function(item) {
                        var _callNoMatchOnInvalid = _this3.callNoMatchOnInvalidRanges(item, last), start = _callNoMatchOnInvalid.start, end = _callNoMatchOnInvalid.end, valid = _callNoMatchOnInvalid.valid;
                        if (valid) {
                            item.start = start;
                            item.length = end - start;
                            stack.push(item);
                            last = end;
                        }
                    });
                    return stack;
                }
            },
            {
                key: 'callNoMatchOnInvalidRanges',
                value: function callNoMatchOnInvalidRanges(range, last) {
                    var start = void 0, end = void 0, valid = false;
                    if (range && typeof range.start !== 'undefined') {
                        start = parseInt(range.start, 10);
                        end = start + parseInt(range.length, 10);
                        if (this.isNumeric(range.start) && this.isNumeric(range.length) && end - last > 0 && end - start > 0) valid = true;
                        else {
                            this.log('Ignoring invalid or overlapping range: ' + ('' + JSON.stringify(range)));
                            this.opt.noMatch(range);
                        }
                    } else {
                        this.log('Ignoring invalid range: ' + JSON.stringify(range));
                        this.opt.noMatch(range);
                    }
                    return {
                        start: start,
                        end: end,
                        valid: valid
                    };
                }
            },
            {
                key: 'checkWhitespaceRanges',
                value: function checkWhitespaceRanges(range, originalLength, string) {
                    var end = void 0, valid = true, max = string.length, offset = originalLength - max, start = parseInt(range.start, 10) - offset;
                    start = start > max ? max : start;
                    end = start + parseInt(range.length, 10);
                    if (end > max) {
                        end = max;
                        this.log('End range automatically set to the max value of ' + max);
                    }
                    if (start < 0 || end - start < 0 || start > max || end > max) {
                        valid = false;
                        this.log('Invalid range: ' + JSON.stringify(range));
                        this.opt.noMatch(range);
                    } else if (string.substring(start, end).replace(/\s+/g, '') === '') {
                        valid = false;
                        this.log('Skipping whitespace only range: ' + JSON.stringify(range));
                        this.opt.noMatch(range);
                    }
                    return {
                        start: start,
                        end: end,
                        valid: valid
                    };
                }
            },
            {
                key: 'getTextNodes',
                value: function getTextNodes(cb) {
                    var _this4 = this;
                    var val = '', nodes = [];
                    this.iterator.forEachNode(NodeFilter.SHOW_TEXT, function(node) {
                        nodes.push({
                            start: val.length,
                            end: (val += node.textContent).length,
                            node: node
                        });
                    }, function(node) {
                        if (_this4.matchesExclude(node.parentNode)) return NodeFilter.FILTER_REJECT;
                        else return NodeFilter.FILTER_ACCEPT;
                    }, function() {
                        cb({
                            value: val,
                            nodes: nodes
                        });
                    });
                }
            },
            {
                key: 'matchesExclude',
                value: function matchesExclude(el) {
                    return DOMIterator.matches(el, this.opt.exclude.concat([
                        'script',
                        'style',
                        'title',
                        'head',
                        'html'
                    ]));
                }
            },
            {
                key: 'wrapRangeInTextNode',
                value: function wrapRangeInTextNode(node, start, end) {
                    var hEl = !this.opt.element ? 'mark' : this.opt.element, startNode = node.splitText(start), ret = startNode.splitText(end - start);
                    var repl = document.createElement(hEl);
                    repl.setAttribute('data-markjs', 'true');
                    if (this.opt.className) repl.setAttribute('class', this.opt.className);
                    repl.textContent = startNode.textContent;
                    startNode.parentNode.replaceChild(repl, startNode);
                    return ret;
                }
            },
            {
                key: 'wrapRangeInMappedTextNode',
                value: function wrapRangeInMappedTextNode(dict, start, end, filterCb, eachCb) {
                    var _this5 = this;
                    dict.nodes.every(function(n, i) {
                        var sibl = dict.nodes[i + 1];
                        if (typeof sibl === 'undefined' || sibl.start > start) {
                            if (!filterCb(n.node)) return false;
                            var s = start - n.start, e = (end > n.end ? n.end : end) - n.start, startStr = dict.value.substr(0, n.start), endStr = dict.value.substr(e + n.start);
                            n.node = _this5.wrapRangeInTextNode(n.node, s, e);
                            dict.value = startStr + endStr;
                            dict.nodes.forEach(function(k, j) {
                                if (j >= i) {
                                    if (dict.nodes[j].start > 0 && j !== i) dict.nodes[j].start -= e;
                                    dict.nodes[j].end -= e;
                                }
                            });
                            end -= e;
                            eachCb(n.node.previousSibling, n.start);
                            if (end > n.end) start = n.end;
                            else return false;
                        }
                        return true;
                    });
                }
            },
            {
                key: 'wrapMatches',
                value: function wrapMatches(regex, ignoreGroups, filterCb, eachCb, endCb) {
                    var _this6 = this;
                    var matchIdx = ignoreGroups === 0 ? 0 : ignoreGroups + 1;
                    this.getTextNodes(function(dict) {
                        dict.nodes.forEach(function(node) {
                            node = node.node;
                            var match = void 0;
                            while((match = regex.exec(node.textContent)) !== null && match[matchIdx] !== ''){
                                if (!filterCb(match[matchIdx], node)) continue;
                                var pos = match.index;
                                if (matchIdx !== 0) for(var i = 1; i < matchIdx; i++)pos += match[i].length;
                                node = _this6.wrapRangeInTextNode(node, pos, pos + match[matchIdx].length);
                                eachCb(node.previousSibling);
                                regex.lastIndex = 0;
                            }
                        });
                        endCb();
                    });
                }
            },
            {
                key: 'wrapMatchesAcrossElements',
                value: function wrapMatchesAcrossElements(regex, ignoreGroups, filterCb, eachCb, endCb) {
                    var _this7 = this;
                    var matchIdx = ignoreGroups === 0 ? 0 : ignoreGroups + 1;
                    this.getTextNodes(function(dict) {
                        var match = void 0;
                        while((match = regex.exec(dict.value)) !== null && match[matchIdx] !== ''){
                            var start = match.index;
                            if (matchIdx !== 0) for(var i = 1; i < matchIdx; i++)start += match[i].length;
                            var end = start + match[matchIdx].length;
                            _this7.wrapRangeInMappedTextNode(dict, start, end, function(node) {
                                return filterCb(match[matchIdx], node);
                            }, function(node, lastIndex) {
                                regex.lastIndex = lastIndex;
                                eachCb(node);
                            });
                        }
                        endCb();
                    });
                }
            },
            {
                key: 'wrapRangeFromIndex',
                value: function wrapRangeFromIndex(ranges, filterCb, eachCb, endCb) {
                    var _this8 = this;
                    this.getTextNodes(function(dict) {
                        var originalLength = dict.value.length;
                        ranges.forEach(function(range, counter) {
                            var _checkWhitespaceRange = _this8.checkWhitespaceRanges(range, originalLength, dict.value), start = _checkWhitespaceRange.start, end = _checkWhitespaceRange.end, valid = _checkWhitespaceRange.valid;
                            if (valid) _this8.wrapRangeInMappedTextNode(dict, start, end, function(node) {
                                return filterCb(node, range, dict.value.substring(start, end), counter);
                            }, function(node) {
                                eachCb(node, range);
                            });
                        });
                        endCb();
                    });
                }
            },
            {
                key: 'unwrapMatches',
                value: function unwrapMatches(node) {
                    var parent = node.parentNode;
                    var docFrag = document.createDocumentFragment();
                    while(node.firstChild)docFrag.appendChild(node.removeChild(node.firstChild));
                    parent.replaceChild(docFrag, node);
                    if (!this.ie) parent.normalize();
                    else this.normalizeTextNode(parent);
                }
            },
            {
                key: 'normalizeTextNode',
                value: function normalizeTextNode(node) {
                    if (!node) return;
                    if (node.nodeType === 3) while(node.nextSibling && node.nextSibling.nodeType === 3){
                        node.nodeValue += node.nextSibling.nodeValue;
                        node.parentNode.removeChild(node.nextSibling);
                    }
                    else this.normalizeTextNode(node.firstChild);
                    this.normalizeTextNode(node.nextSibling);
                }
            },
            {
                key: 'markRegExp',
                value: function markRegExp(regexp, opt) {
                    var _this9 = this;
                    this.opt = opt;
                    this.log('Searching with expression "' + regexp + '"');
                    var totalMatches = 0, fn = 'wrapMatches';
                    var eachCb = function eachCb(element) {
                        totalMatches++;
                        _this9.opt.each(element);
                    };
                    if (this.opt.acrossElements) fn = 'wrapMatchesAcrossElements';
                    this[fn](regexp, this.opt.ignoreGroups, function(match, node) {
                        return _this9.opt.filter(node, match, totalMatches);
                    }, eachCb, function() {
                        if (totalMatches === 0) _this9.opt.noMatch(regexp);
                        _this9.opt.done(totalMatches);
                    });
                }
            },
            {
                key: 'mark',
                value: function mark(sv, opt) {
                    var _this10 = this;
                    this.opt = opt;
                    var totalMatches = 0, fn = 'wrapMatches';
                    var _getSeparatedKeywords = this.getSeparatedKeywords(typeof sv === 'string' ? [
                        sv
                    ] : sv), kwArr = _getSeparatedKeywords.keywords, kwArrLen = _getSeparatedKeywords.length, sens = this.opt.caseSensitive ? '' : 'i', handler = function handler(kw) {
                        var regex = new RegExp(_this10.createRegExp(kw), 'gm' + sens), matches = 0;
                        _this10.log('Searching with expression "' + regex + '"');
                        _this10[fn](regex, 1, function(term, node) {
                            return _this10.opt.filter(node, kw, totalMatches, matches);
                        }, function(element) {
                            matches++;
                            totalMatches++;
                            _this10.opt.each(element);
                        }, function() {
                            if (matches === 0) _this10.opt.noMatch(kw);
                            if (kwArr[kwArrLen - 1] === kw) _this10.opt.done(totalMatches);
                            else handler(kwArr[kwArr.indexOf(kw) + 1]);
                        });
                    };
                    if (this.opt.acrossElements) fn = 'wrapMatchesAcrossElements';
                    if (kwArrLen === 0) this.opt.done(totalMatches);
                    else handler(kwArr[0]);
                }
            },
            {
                key: 'markRanges',
                value: function markRanges(rawRanges, opt) {
                    var _this11 = this;
                    this.opt = opt;
                    var totalMatches = 0, ranges = this.checkRanges(rawRanges);
                    if (ranges && ranges.length) {
                        this.log('Starting to mark with the following ranges: ' + JSON.stringify(ranges));
                        this.wrapRangeFromIndex(ranges, function(node, range, match, counter) {
                            return _this11.opt.filter(node, range, match, counter);
                        }, function(element, range) {
                            totalMatches++;
                            _this11.opt.each(element, range);
                        }, function() {
                            _this11.opt.done(totalMatches);
                        });
                    } else this.opt.done(totalMatches);
                }
            },
            {
                key: 'unmark',
                value: function unmark(opt) {
                    var _this12 = this;
                    this.opt = opt;
                    var sel = this.opt.element ? this.opt.element : '*';
                    sel += '[data-markjs]';
                    if (this.opt.className) sel += '.' + this.opt.className;
                    this.log('Removal selector "' + sel + '"');
                    this.iterator.forEachNode(NodeFilter.SHOW_ELEMENT, function(node) {
                        _this12.unwrapMatches(node);
                    }, function(node) {
                        var matchesSel = DOMIterator.matches(node, sel), matchesExclude = _this12.matchesExclude(node);
                        if (!matchesSel || matchesExclude) return NodeFilter.FILTER_REJECT;
                        else return NodeFilter.FILTER_ACCEPT;
                    }, this.opt.done);
                }
            },
            {
                key: 'opt',
                set: function set$$1(val) {
                    this._opt = _extends({}, {
                        'element': '',
                        'className': '',
                        'exclude': [],
                        'iframes': false,
                        'iframesTimeout': 5000,
                        'separateWordSearch': true,
                        'diacritics': true,
                        'synonyms': {},
                        'accuracy': 'partially',
                        'acrossElements': false,
                        'caseSensitive': false,
                        'ignoreJoiners': false,
                        'ignoreGroups': 0,
                        'ignorePunctuation': [],
                        'wildcards': 'disabled',
                        'each': function each() {},
                        'noMatch': function noMatch() {},
                        'filter': function filter() {
                            return true;
                        },
                        'done': function done() {},
                        'debug': false,
                        'log': window.console
                    }, val);
                },
                get: function get$$1() {
                    return this._opt;
                }
            },
            {
                key: 'iterator',
                get: function get$$1() {
                    return new DOMIterator(this.ctx, this.opt.iframes, this.opt.exclude, this.opt.iframesTimeout);
                }
            }
        ]);
        return Mark;
    }();
    function Mark(ctx) {
        var _this = this;
        var instance = new Mark$1(ctx);
        this.mark = function(sv, opt) {
            instance.mark(sv, opt);
            return _this;
        };
        this.markRegExp = function(sv, opt) {
            instance.markRegExp(sv, opt);
            return _this;
        };
        this.markRanges = function(sv, opt) {
            instance.markRanges(sv, opt);
            return _this;
        };
        this.unmark = function(opt) {
            instance.unmark(opt);
            return _this;
        };
        return this;
    }
    return Mark;
});


/**
 * Types used in signatures of Cheerio methods.
 *
 * @category Cheerio
 */ 


var $hAHiP = parcelRequire("hAHiP");

var $8iuUi = parcelRequire("8iuUi");

var $6CIR4 = parcelRequire("6CIR4");

var $hK11S = parcelRequire("hK11S");

var $7tPyY = parcelRequire("7tPyY");
var $369ab71a64ae16e6$exports = {};

$parcel$export($369ab71a64ae16e6$exports, "css", () => $369ab71a64ae16e6$export$dbf350e5966cf602);

var $2M1Qk = parcelRequire("2M1Qk");
var $k9MHs = parcelRequire("k9MHs");
function $369ab71a64ae16e6$export$dbf350e5966cf602(prop, val) {
    if (prop != null && val != null || // When `prop` is a "plain" object
    typeof prop === 'object' && !Array.isArray(prop)) return (0, $2M1Qk.domEach)(this, (el, i)=>{
        if ((0, $k9MHs.isTag)(el)) // `prop` can't be an array here anymore.
        $369ab71a64ae16e6$var$setCss(el, prop, val, i);
    });
    if (this.length === 0) return undefined;
    return $369ab71a64ae16e6$var$getCss(this[0], prop);
}
/**
 * Set styles of all elements.
 *
 * @private
 * @param el - Element to set style of.
 * @param prop - Name of property.
 * @param value - Value to set property to.
 * @param idx - Optional index within the selection.
 */ function $369ab71a64ae16e6$var$setCss(el, prop, value, idx) {
    if (typeof prop === 'string') {
        const styles = $369ab71a64ae16e6$var$getCss(el);
        const val = typeof value === 'function' ? value.call(el, idx, styles[prop]) : value;
        if (val === '') delete styles[prop];
        else if (val != null) styles[prop] = val;
        el.attribs['style'] = $369ab71a64ae16e6$var$stringify(styles);
    } else if (typeof prop === 'object') Object.keys(prop).forEach((k, i)=>{
        $369ab71a64ae16e6$var$setCss(el, k, prop[k], i);
    });
}
function $369ab71a64ae16e6$var$getCss(el, prop) {
    if (!el || !(0, $k9MHs.isTag)(el)) return;
    const styles = $369ab71a64ae16e6$var$parse(el.attribs['style']);
    if (typeof prop === 'string') return styles[prop];
    if (Array.isArray(prop)) {
        const newStyles = {};
        prop.forEach((item)=>{
            if (styles[item] != null) newStyles[item] = styles[item];
        });
        return newStyles;
    }
    return styles;
}
/**
 * Stringify `obj` to styles.
 *
 * @private
 * @category CSS
 * @param obj - Object to stringify.
 * @returns The serialized styles.
 */ function $369ab71a64ae16e6$var$stringify(obj) {
    return Object.keys(obj).reduce((str, prop)=>`${str}${str ? ' ' : ''}${prop}: ${obj[prop]};`, '');
}
/**
 * Parse `styles`.
 *
 * @private
 * @category CSS
 * @param styles - Styles to be parsed.
 * @returns The parsed styles.
 */ function $369ab71a64ae16e6$var$parse(styles) {
    styles = (styles || '').trim();
    if (!styles) return {};
    const obj = {};
    let key;
    for (const str of styles.split(';')){
        const n = str.indexOf(':');
        // If there is no :, or if it is the first/last character, add to the previous item's value
        if (n < 1 || n === str.length - 1) {
            const trimmed = str.trimEnd();
            if (trimmed.length > 0 && key !== undefined) obj[key] += `;${trimmed}`;
        } else {
            key = str.slice(0, n).trim();
            obj[key] = str.slice(n + 1).trim();
        }
    }
    return obj;
}



var $8pn8k = parcelRequire("8pn8k");
class $94dc079efa600b6a$export$a25e727e7f7b9892 {
    /**
     * Instance of cheerio. Methods are specified in the modules. Usage of this
     * constructor is not recommended. Please use `$.load` instead.
     *
     * @private
     * @param elements - The new selection.
     * @param root - Sets the root node.
     * @param options - Options for the instance.
     */ constructor(elements, root, options){
        this.length = 0;
        this.options = options;
        this._root = root;
        if (elements) {
            for(let idx = 0; idx < elements.length; idx++)this[idx] = elements[idx];
            this.length = elements.length;
        }
    }
}
/** Set a signature of the object. */ $94dc079efa600b6a$export$a25e727e7f7b9892.prototype.cheerio = '[cheerio object]';
/*
 * Make cheerio an array-like object
 */ $94dc079efa600b6a$export$a25e727e7f7b9892.prototype.splice = Array.prototype.splice;
// Support for (const element of $(...)) iteration:
$94dc079efa600b6a$export$a25e727e7f7b9892.prototype[Symbol.iterator] = Array.prototype[Symbol.iterator];
// Plug in the API
Object.assign($94dc079efa600b6a$export$a25e727e7f7b9892.prototype, $6CIR4, $hK11S, $7tPyY, $369ab71a64ae16e6$exports, $8pn8k);



var $2M1Qk = parcelRequire("2M1Qk");
function $b5f679c4131ed3ad$export$8b469b2b7efa8d79(parse, render) {
    /**
     * Create a querying function, bound to a document created from the provided markup.
     *
     * Note that similar to web browser contexts, this operation may introduce
     * `<html>`, `<head>`, and `<body>` elements; set `isDocument` to `false` to
     * switch to fragment mode and disable this.
     *
     * @param content - Markup to be loaded.
     * @param options - Options for the created instance.
     * @param isDocument - Allows parser to be switched to fragment mode.
     * @returns The loaded document.
     * @see {@link https://cheerio.js.org#loading} for additional usage information.
     */ return function load(content, options, isDocument = true) {
        if (content == null) throw new Error('cheerio.load() expects a string');
        const internalOpts = {
            ...(0, $hAHiP.default),
            ...(0, $hAHiP.flatten)(options)
        };
        const initialRoot = parse(content, internalOpts, isDocument, null);
        /** Create an extended class here, so that extensions only live on one instance. */ class LoadedCheerio extends (0, $94dc079efa600b6a$export$a25e727e7f7b9892) {
            _make(selector, context) {
                const cheerio = initialize(selector, context);
                cheerio.prevObject = this;
                return cheerio;
            }
            _parse(content, options, isDocument, context) {
                return parse(content, options, isDocument, context);
            }
            _render(dom) {
                return render(dom, this.options);
            }
        }
        function initialize(selector, context, root = initialRoot, opts) {
            // $($)
            if (selector && (0, $2M1Qk.isCheerio)(selector)) return selector;
            const options = {
                ...internalOpts,
                ...(0, $hAHiP.flatten)(opts)
            };
            const r = typeof root === 'string' ? [
                parse(root, options, false, null)
            ] : 'length' in root ? root : [
                root
            ];
            const rootInstance = (0, $2M1Qk.isCheerio)(r) ? r : new LoadedCheerio(r, null, options);
            // Add a cyclic reference, so that calling methods on `_root` never fails.
            rootInstance._root = rootInstance;
            // $(), $(null), $(undefined), $(false)
            if (!selector) return new LoadedCheerio(undefined, rootInstance, options);
            const elements = typeof selector === 'string' && (0, $2M1Qk.isHtml)(selector) ? parse(selector, options, false, null).children : $b5f679c4131ed3ad$var$isNode(selector) ? [
                selector
            ] : Array.isArray(selector) ? selector : undefined;
            const instance = new LoadedCheerio(elements, rootInstance, options);
            if (elements) return instance;
            if (typeof selector !== 'string') throw new Error('Unexpected type of selector');
            // We know that our selector is a string now.
            let search = selector;
            const searchContext = !context ? rootInstance : typeof context === 'string' ? (0, $2M1Qk.isHtml)(context) ? new LoadedCheerio([
                parse(context, options, false, null)
            ], rootInstance, options) : (search = `${context} ${search}`, rootInstance) : (0, $2M1Qk.isCheerio)(context) ? context : new LoadedCheerio(Array.isArray(context) ? context : [
                context
            ], rootInstance, options);
            // If we still don't have a context, return
            if (!searchContext) return instance;
            /*
             * #id, .class, tag
             */ return searchContext.find(search);
        }
        // Add in static methods & properties
        Object.assign(initialize, $8iuUi, {
            load: load,
            // `_root` and `_options` are used in static methods.
            _root: initialRoot,
            _options: internalOpts,
            // Add `fn` for plugins
            fn: LoadedCheerio.prototype,
            // Add the prototype here to maintain `instanceof` behavior.
            prototype: LoadedCheerio.prototype
        });
        return initialize;
    };
}
function $b5f679c4131ed3ad$var$isNode(obj) {
    return !!obj.name || obj.type === 'root' || obj.type === 'text' || obj.type === 'comment';
}



var $dbuHA = parcelRequire("dbuHA");
parcelRequire("273yd");
var $k9MHs = parcelRequire("k9MHs");
const $6c7c9c6fba662a30$var$UNDEFINED_CODE_POINTS = new Set([
    65534,
    65535,
    131070,
    131071,
    196606,
    196607,
    262142,
    262143,
    327678,
    327679,
    393214,
    393215,
    458750,
    458751,
    524286,
    524287,
    589822,
    589823,
    655358,
    655359,
    720894,
    720895,
    786430,
    786431,
    851966,
    851967,
    917502,
    917503,
    983038,
    983039,
    1048574,
    1048575,
    1114110,
    1114111
]);
const $6c7c9c6fba662a30$export$e8d20e7a50e6c279 = '\uFFFD';
var $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0;
(function(CODE_POINTS) {
    CODE_POINTS[CODE_POINTS["EOF"] = -1] = "EOF";
    CODE_POINTS[CODE_POINTS["NULL"] = 0] = "NULL";
    CODE_POINTS[CODE_POINTS["TABULATION"] = 9] = "TABULATION";
    CODE_POINTS[CODE_POINTS["CARRIAGE_RETURN"] = 13] = "CARRIAGE_RETURN";
    CODE_POINTS[CODE_POINTS["LINE_FEED"] = 10] = "LINE_FEED";
    CODE_POINTS[CODE_POINTS["FORM_FEED"] = 12] = "FORM_FEED";
    CODE_POINTS[CODE_POINTS["SPACE"] = 32] = "SPACE";
    CODE_POINTS[CODE_POINTS["EXCLAMATION_MARK"] = 33] = "EXCLAMATION_MARK";
    CODE_POINTS[CODE_POINTS["QUOTATION_MARK"] = 34] = "QUOTATION_MARK";
    CODE_POINTS[CODE_POINTS["NUMBER_SIGN"] = 35] = "NUMBER_SIGN";
    CODE_POINTS[CODE_POINTS["AMPERSAND"] = 38] = "AMPERSAND";
    CODE_POINTS[CODE_POINTS["APOSTROPHE"] = 39] = "APOSTROPHE";
    CODE_POINTS[CODE_POINTS["HYPHEN_MINUS"] = 45] = "HYPHEN_MINUS";
    CODE_POINTS[CODE_POINTS["SOLIDUS"] = 47] = "SOLIDUS";
    CODE_POINTS[CODE_POINTS["DIGIT_0"] = 48] = "DIGIT_0";
    CODE_POINTS[CODE_POINTS["DIGIT_9"] = 57] = "DIGIT_9";
    CODE_POINTS[CODE_POINTS["SEMICOLON"] = 59] = "SEMICOLON";
    CODE_POINTS[CODE_POINTS["LESS_THAN_SIGN"] = 60] = "LESS_THAN_SIGN";
    CODE_POINTS[CODE_POINTS["EQUALS_SIGN"] = 61] = "EQUALS_SIGN";
    CODE_POINTS[CODE_POINTS["GREATER_THAN_SIGN"] = 62] = "GREATER_THAN_SIGN";
    CODE_POINTS[CODE_POINTS["QUESTION_MARK"] = 63] = "QUESTION_MARK";
    CODE_POINTS[CODE_POINTS["LATIN_CAPITAL_A"] = 65] = "LATIN_CAPITAL_A";
    CODE_POINTS[CODE_POINTS["LATIN_CAPITAL_F"] = 70] = "LATIN_CAPITAL_F";
    CODE_POINTS[CODE_POINTS["LATIN_CAPITAL_X"] = 88] = "LATIN_CAPITAL_X";
    CODE_POINTS[CODE_POINTS["LATIN_CAPITAL_Z"] = 90] = "LATIN_CAPITAL_Z";
    CODE_POINTS[CODE_POINTS["RIGHT_SQUARE_BRACKET"] = 93] = "RIGHT_SQUARE_BRACKET";
    CODE_POINTS[CODE_POINTS["GRAVE_ACCENT"] = 96] = "GRAVE_ACCENT";
    CODE_POINTS[CODE_POINTS["LATIN_SMALL_A"] = 97] = "LATIN_SMALL_A";
    CODE_POINTS[CODE_POINTS["LATIN_SMALL_F"] = 102] = "LATIN_SMALL_F";
    CODE_POINTS[CODE_POINTS["LATIN_SMALL_X"] = 120] = "LATIN_SMALL_X";
    CODE_POINTS[CODE_POINTS["LATIN_SMALL_Z"] = 122] = "LATIN_SMALL_Z";
    CODE_POINTS[CODE_POINTS["REPLACEMENT_CHARACTER"] = 65533] = "REPLACEMENT_CHARACTER";
})($6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0 = $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0 || ($6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0 = {}));
const $6c7c9c6fba662a30$export$5abac700f947e2 = {
    DASH_DASH: '--',
    CDATA_START: '[CDATA[',
    DOCTYPE: 'doctype',
    SCRIPT: 'script',
    PUBLIC: 'public',
    SYSTEM: 'system'
};
function $6c7c9c6fba662a30$export$7e678b42035e707f(cp) {
    return cp >= 55296 && cp <= 57343;
}
function $6c7c9c6fba662a30$export$e7f1d94bb17e4055(cp) {
    return cp >= 56320 && cp <= 57343;
}
function $6c7c9c6fba662a30$export$91e83256751ec906(cp1, cp2) {
    return (cp1 - 55296) * 1024 + 9216 + cp2;
}
function $6c7c9c6fba662a30$export$d6953a6077926e(cp) {
    return cp !== 0x20 && cp !== 0x0a && cp !== 0x0d && cp !== 0x09 && cp !== 0x0c && cp >= 0x01 && cp <= 0x1f || cp >= 0x7f && cp <= 0x9f;
}
function $6c7c9c6fba662a30$export$b3484aaf321bda02(cp) {
    return cp >= 64976 && cp <= 65007 || $6c7c9c6fba662a30$var$UNDEFINED_CODE_POINTS.has(cp);
} //# sourceMappingURL=unicode.js.map


var $016d4fdae73ebe61$export$9e0efcb140234d2;
(function(ERR) {
    ERR["controlCharacterInInputStream"] = "control-character-in-input-stream";
    ERR["noncharacterInInputStream"] = "noncharacter-in-input-stream";
    ERR["surrogateInInputStream"] = "surrogate-in-input-stream";
    ERR["nonVoidHtmlElementStartTagWithTrailingSolidus"] = "non-void-html-element-start-tag-with-trailing-solidus";
    ERR["endTagWithAttributes"] = "end-tag-with-attributes";
    ERR["endTagWithTrailingSolidus"] = "end-tag-with-trailing-solidus";
    ERR["unexpectedSolidusInTag"] = "unexpected-solidus-in-tag";
    ERR["unexpectedNullCharacter"] = "unexpected-null-character";
    ERR["unexpectedQuestionMarkInsteadOfTagName"] = "unexpected-question-mark-instead-of-tag-name";
    ERR["invalidFirstCharacterOfTagName"] = "invalid-first-character-of-tag-name";
    ERR["unexpectedEqualsSignBeforeAttributeName"] = "unexpected-equals-sign-before-attribute-name";
    ERR["missingEndTagName"] = "missing-end-tag-name";
    ERR["unexpectedCharacterInAttributeName"] = "unexpected-character-in-attribute-name";
    ERR["unknownNamedCharacterReference"] = "unknown-named-character-reference";
    ERR["missingSemicolonAfterCharacterReference"] = "missing-semicolon-after-character-reference";
    ERR["unexpectedCharacterAfterDoctypeSystemIdentifier"] = "unexpected-character-after-doctype-system-identifier";
    ERR["unexpectedCharacterInUnquotedAttributeValue"] = "unexpected-character-in-unquoted-attribute-value";
    ERR["eofBeforeTagName"] = "eof-before-tag-name";
    ERR["eofInTag"] = "eof-in-tag";
    ERR["missingAttributeValue"] = "missing-attribute-value";
    ERR["missingWhitespaceBetweenAttributes"] = "missing-whitespace-between-attributes";
    ERR["missingWhitespaceAfterDoctypePublicKeyword"] = "missing-whitespace-after-doctype-public-keyword";
    ERR["missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers"] = "missing-whitespace-between-doctype-public-and-system-identifiers";
    ERR["missingWhitespaceAfterDoctypeSystemKeyword"] = "missing-whitespace-after-doctype-system-keyword";
    ERR["missingQuoteBeforeDoctypePublicIdentifier"] = "missing-quote-before-doctype-public-identifier";
    ERR["missingQuoteBeforeDoctypeSystemIdentifier"] = "missing-quote-before-doctype-system-identifier";
    ERR["missingDoctypePublicIdentifier"] = "missing-doctype-public-identifier";
    ERR["missingDoctypeSystemIdentifier"] = "missing-doctype-system-identifier";
    ERR["abruptDoctypePublicIdentifier"] = "abrupt-doctype-public-identifier";
    ERR["abruptDoctypeSystemIdentifier"] = "abrupt-doctype-system-identifier";
    ERR["cdataInHtmlContent"] = "cdata-in-html-content";
    ERR["incorrectlyOpenedComment"] = "incorrectly-opened-comment";
    ERR["eofInScriptHtmlCommentLikeText"] = "eof-in-script-html-comment-like-text";
    ERR["eofInDoctype"] = "eof-in-doctype";
    ERR["nestedComment"] = "nested-comment";
    ERR["abruptClosingOfEmptyComment"] = "abrupt-closing-of-empty-comment";
    ERR["eofInComment"] = "eof-in-comment";
    ERR["incorrectlyClosedComment"] = "incorrectly-closed-comment";
    ERR["eofInCdata"] = "eof-in-cdata";
    ERR["absenceOfDigitsInNumericCharacterReference"] = "absence-of-digits-in-numeric-character-reference";
    ERR["nullCharacterReference"] = "null-character-reference";
    ERR["surrogateCharacterReference"] = "surrogate-character-reference";
    ERR["characterReferenceOutsideUnicodeRange"] = "character-reference-outside-unicode-range";
    ERR["controlCharacterReference"] = "control-character-reference";
    ERR["noncharacterCharacterReference"] = "noncharacter-character-reference";
    ERR["missingWhitespaceBeforeDoctypeName"] = "missing-whitespace-before-doctype-name";
    ERR["missingDoctypeName"] = "missing-doctype-name";
    ERR["invalidCharacterSequenceAfterDoctypeName"] = "invalid-character-sequence-after-doctype-name";
    ERR["duplicateAttribute"] = "duplicate-attribute";
    ERR["nonConformingDoctype"] = "non-conforming-doctype";
    ERR["missingDoctype"] = "missing-doctype";
    ERR["misplacedDoctype"] = "misplaced-doctype";
    ERR["endTagWithoutMatchingOpenElement"] = "end-tag-without-matching-open-element";
    ERR["closingOfElementWithOpenChildElements"] = "closing-of-element-with-open-child-elements";
    ERR["disallowedContentInNoscriptInHead"] = "disallowed-content-in-noscript-in-head";
    ERR["openElementsLeftAfterEof"] = "open-elements-left-after-eof";
    ERR["abandonedHeadElementChild"] = "abandoned-head-element-child";
    ERR["misplacedStartTagForHeadElement"] = "misplaced-start-tag-for-head-element";
    ERR["nestedNoscriptInHead"] = "nested-noscript-in-head";
    ERR["eofInElementThatCanContainOnlyText"] = "eof-in-element-that-can-contain-only-text";
})($016d4fdae73ebe61$export$9e0efcb140234d2 = $016d4fdae73ebe61$export$9e0efcb140234d2 || ($016d4fdae73ebe61$export$9e0efcb140234d2 = {})); //# sourceMappingURL=error-codes.js.map


//Const
const $1fc009bbc44566a5$var$DEFAULT_BUFFER_WATERLINE = 65536;
class $1fc009bbc44566a5$export$35db5c8036a15ad1 {
    constructor(handler){
        this.handler = handler;
        this.html = '';
        this.pos = -1;
        // NOTE: Initial `lastGapPos` is -2, to ensure `col` on initialisation is 0
        this.lastGapPos = -2;
        this.gapStack = [];
        this.skipNextNewLine = false;
        this.lastChunkWritten = false;
        this.endOfChunkHit = false;
        this.bufferWaterline = $1fc009bbc44566a5$var$DEFAULT_BUFFER_WATERLINE;
        this.isEol = false;
        this.lineStartPos = 0;
        this.droppedBufferSize = 0;
        this.line = 1;
        //NOTE: avoid reporting errors twice on advance/retreat
        this.lastErrOffset = -1;
    }
    /** The column on the current line. If we just saw a gap (eg. a surrogate pair), return the index before. */ get col() {
        return this.pos - this.lineStartPos + Number(this.lastGapPos !== this.pos);
    }
    get offset() {
        return this.droppedBufferSize + this.pos;
    }
    getError(code) {
        const { line: line, col: col, offset: offset } = this;
        return {
            code: code,
            startLine: line,
            endLine: line,
            startCol: col,
            endCol: col,
            startOffset: offset,
            endOffset: offset
        };
    }
    _err(code) {
        if (this.handler.onParseError && this.lastErrOffset !== this.offset) {
            this.lastErrOffset = this.offset;
            this.handler.onParseError(this.getError(code));
        }
    }
    _addGap() {
        this.gapStack.push(this.lastGapPos);
        this.lastGapPos = this.pos;
    }
    _processSurrogate(cp) {
        //NOTE: try to peek a surrogate pair
        if (this.pos !== this.html.length - 1) {
            const nextCp = this.html.charCodeAt(this.pos + 1);
            if ((0, $6c7c9c6fba662a30$export$e7f1d94bb17e4055)(nextCp)) {
                //NOTE: we have a surrogate pair. Peek pair character and recalculate code point.
                this.pos++;
                //NOTE: add a gap that should be avoided during retreat
                this._addGap();
                return (0, $6c7c9c6fba662a30$export$91e83256751ec906)(cp, nextCp);
            }
        } else if (!this.lastChunkWritten) {
            this.endOfChunkHit = true;
            return (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EOF;
        }
        //NOTE: isolated surrogate
        this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).surrogateInInputStream);
        return cp;
    }
    willDropParsedChunk() {
        return this.pos > this.bufferWaterline;
    }
    dropParsedChunk() {
        if (this.willDropParsedChunk()) {
            this.html = this.html.substring(this.pos);
            this.lineStartPos -= this.pos;
            this.droppedBufferSize += this.pos;
            this.pos = 0;
            this.lastGapPos = -2;
            this.gapStack.length = 0;
        }
    }
    write(chunk, isLastChunk) {
        if (this.html.length > 0) this.html += chunk;
        else this.html = chunk;
        this.endOfChunkHit = false;
        this.lastChunkWritten = isLastChunk;
    }
    insertHtmlAtCurrentPos(chunk) {
        this.html = this.html.substring(0, this.pos + 1) + chunk + this.html.substring(this.pos + 1);
        this.endOfChunkHit = false;
    }
    startsWith(pattern, caseSensitive) {
        // Check if our buffer has enough characters
        if (this.pos + pattern.length > this.html.length) {
            this.endOfChunkHit = !this.lastChunkWritten;
            return false;
        }
        if (caseSensitive) return this.html.startsWith(pattern, this.pos);
        for(let i = 0; i < pattern.length; i++){
            const cp = this.html.charCodeAt(this.pos + i) | 0x20;
            if (cp !== pattern.charCodeAt(i)) return false;
        }
        return true;
    }
    peek(offset) {
        const pos = this.pos + offset;
        if (pos >= this.html.length) {
            this.endOfChunkHit = !this.lastChunkWritten;
            return (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EOF;
        }
        const code = this.html.charCodeAt(pos);
        return code === (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).CARRIAGE_RETURN ? (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).LINE_FEED : code;
    }
    advance() {
        this.pos++;
        //NOTE: LF should be in the last column of the line
        if (this.isEol) {
            this.isEol = false;
            this.line++;
            this.lineStartPos = this.pos;
        }
        if (this.pos >= this.html.length) {
            this.endOfChunkHit = !this.lastChunkWritten;
            return (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EOF;
        }
        let cp = this.html.charCodeAt(this.pos);
        //NOTE: all U+000D CARRIAGE RETURN (CR) characters must be converted to U+000A LINE FEED (LF) characters
        if (cp === (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).CARRIAGE_RETURN) {
            this.isEol = true;
            this.skipNextNewLine = true;
            return (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).LINE_FEED;
        }
        //NOTE: any U+000A LINE FEED (LF) characters that immediately follow a U+000D CARRIAGE RETURN (CR) character
        //must be ignored.
        if (cp === (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).LINE_FEED) {
            this.isEol = true;
            if (this.skipNextNewLine) {
                // `line` will be bumped again in the recursive call.
                this.line--;
                this.skipNextNewLine = false;
                this._addGap();
                return this.advance();
            }
        }
        this.skipNextNewLine = false;
        if ((0, $6c7c9c6fba662a30$export$7e678b42035e707f)(cp)) cp = this._processSurrogate(cp);
        //OPTIMIZATION: first check if code point is in the common allowed
        //range (ASCII alphanumeric, whitespaces, big chunk of BMP)
        //before going into detailed performance cost validation.
        const isCommonValidRange = this.handler.onParseError === null || cp > 0x1f && cp < 0x7f || cp === (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).LINE_FEED || cp === (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).CARRIAGE_RETURN || cp > 0x9f && cp < 64976;
        if (!isCommonValidRange) this._checkForProblematicCharacters(cp);
        return cp;
    }
    _checkForProblematicCharacters(cp) {
        if ((0, $6c7c9c6fba662a30$export$d6953a6077926e)(cp)) this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).controlCharacterInInputStream);
        else if ((0, $6c7c9c6fba662a30$export$b3484aaf321bda02)(cp)) this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).noncharacterInInputStream);
    }
    retreat(count) {
        this.pos -= count;
        while(this.pos < this.lastGapPos){
            this.lastGapPos = this.gapStack.pop();
            this.pos--;
        }
        this.isEol = false;
    }
} //# sourceMappingURL=preprocessor.js.map



var $c78559b0b620233e$export$f435f793048e7a0f;
(function(TokenType) {
    TokenType[TokenType["CHARACTER"] = 0] = "CHARACTER";
    TokenType[TokenType["NULL_CHARACTER"] = 1] = "NULL_CHARACTER";
    TokenType[TokenType["WHITESPACE_CHARACTER"] = 2] = "WHITESPACE_CHARACTER";
    TokenType[TokenType["START_TAG"] = 3] = "START_TAG";
    TokenType[TokenType["END_TAG"] = 4] = "END_TAG";
    TokenType[TokenType["COMMENT"] = 5] = "COMMENT";
    TokenType[TokenType["DOCTYPE"] = 6] = "DOCTYPE";
    TokenType[TokenType["EOF"] = 7] = "EOF";
    TokenType[TokenType["HIBERNATION"] = 8] = "HIBERNATION";
})($c78559b0b620233e$export$f435f793048e7a0f = $c78559b0b620233e$export$f435f793048e7a0f || ($c78559b0b620233e$export$f435f793048e7a0f = {}));
function $c78559b0b620233e$export$df33bba014b5841e(token, attrName) {
    for(let i = token.attrs.length - 1; i >= 0; i--){
        if (token.attrs[i].name === attrName) return token.attrs[i].value;
    }
    return null;
} //# sourceMappingURL=token.js.map


var $14589e7572d0431f$exports = {};
"use strict";
var $14589e7572d0431f$var$__createBinding = $14589e7572d0431f$exports && $14589e7572d0431f$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $14589e7572d0431f$var$__setModuleDefault = $14589e7572d0431f$exports && $14589e7572d0431f$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $14589e7572d0431f$var$__importStar = $14589e7572d0431f$exports && $14589e7572d0431f$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $14589e7572d0431f$var$__createBinding(result, mod, k);
    }
    $14589e7572d0431f$var$__setModuleDefault(result, mod);
    return result;
};
var $14589e7572d0431f$var$__importDefault = $14589e7572d0431f$exports && $14589e7572d0431f$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($14589e7572d0431f$exports, "__esModule", {
    value: true
});
$14589e7572d0431f$exports.decodeXML = $14589e7572d0431f$exports.decodeHTMLStrict = $14589e7572d0431f$exports.decodeHTMLAttribute = $14589e7572d0431f$exports.decodeHTML = $14589e7572d0431f$exports.determineBranch = $14589e7572d0431f$exports.EntityDecoder = $14589e7572d0431f$exports.DecodingMode = $14589e7572d0431f$exports.BinTrieFlags = $14589e7572d0431f$exports.fromCodePoint = $14589e7572d0431f$exports.replaceCodePoint = $14589e7572d0431f$exports.decodeCodePoint = $14589e7572d0431f$exports.xmlDecodeTree = $14589e7572d0431f$exports.htmlDecodeTree = void 0;

var $14589e7572d0431f$var$decode_data_html_js_1 = $14589e7572d0431f$var$__importDefault((parcelRequire("5sG9R")));
$14589e7572d0431f$exports.htmlDecodeTree = $14589e7572d0431f$var$decode_data_html_js_1.default;

var $14589e7572d0431f$var$decode_data_xml_js_1 = $14589e7572d0431f$var$__importDefault((parcelRequire("cziBi")));
$14589e7572d0431f$exports.xmlDecodeTree = $14589e7572d0431f$var$decode_data_xml_js_1.default;

var $14589e7572d0431f$var$decode_codepoint_js_1 = $14589e7572d0431f$var$__importStar((parcelRequire("6DwAw")));
$14589e7572d0431f$exports.decodeCodePoint = $14589e7572d0431f$var$decode_codepoint_js_1.default;

Object.defineProperty($14589e7572d0431f$exports, "replaceCodePoint", {
    enumerable: true,
    get: function() {
        return (parcelRequire("6DwAw")).replaceCodePoint;
    }
});
Object.defineProperty($14589e7572d0431f$exports, "fromCodePoint", {
    enumerable: true,
    get: function() {
        return (parcelRequire("6DwAw")).fromCodePoint;
    }
});
var $14589e7572d0431f$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["NUM"] = 35] = "NUM";
    CharCodes[CharCodes["SEMI"] = 59] = "SEMI";
    CharCodes[CharCodes["EQUALS"] = 61] = "EQUALS";
    CharCodes[CharCodes["ZERO"] = 48] = "ZERO";
    CharCodes[CharCodes["NINE"] = 57] = "NINE";
    CharCodes[CharCodes["LOWER_A"] = 97] = "LOWER_A";
    CharCodes[CharCodes["LOWER_F"] = 102] = "LOWER_F";
    CharCodes[CharCodes["LOWER_X"] = 120] = "LOWER_X";
    CharCodes[CharCodes["LOWER_Z"] = 122] = "LOWER_Z";
    CharCodes[CharCodes["UPPER_A"] = 65] = "UPPER_A";
    CharCodes[CharCodes["UPPER_F"] = 70] = "UPPER_F";
    CharCodes[CharCodes["UPPER_Z"] = 90] = "UPPER_Z";
})($14589e7572d0431f$var$CharCodes || ($14589e7572d0431f$var$CharCodes = {}));
/** Bit that needs to be set to convert an upper case ASCII character to lower case */ var $14589e7572d0431f$var$TO_LOWER_BIT = 32;
var $14589e7572d0431f$var$BinTrieFlags;
(function(BinTrieFlags) {
    BinTrieFlags[BinTrieFlags["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
    BinTrieFlags[BinTrieFlags["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
    BinTrieFlags[BinTrieFlags["JUMP_TABLE"] = 127] = "JUMP_TABLE";
})($14589e7572d0431f$var$BinTrieFlags = $14589e7572d0431f$exports.BinTrieFlags || ($14589e7572d0431f$exports.BinTrieFlags = {}));
function $14589e7572d0431f$var$isNumber(code) {
    return code >= $14589e7572d0431f$var$CharCodes.ZERO && code <= $14589e7572d0431f$var$CharCodes.NINE;
}
function $14589e7572d0431f$var$isHexadecimalCharacter(code) {
    return code >= $14589e7572d0431f$var$CharCodes.UPPER_A && code <= $14589e7572d0431f$var$CharCodes.UPPER_F || code >= $14589e7572d0431f$var$CharCodes.LOWER_A && code <= $14589e7572d0431f$var$CharCodes.LOWER_F;
}
function $14589e7572d0431f$var$isAsciiAlphaNumeric(code) {
    return code >= $14589e7572d0431f$var$CharCodes.UPPER_A && code <= $14589e7572d0431f$var$CharCodes.UPPER_Z || code >= $14589e7572d0431f$var$CharCodes.LOWER_A && code <= $14589e7572d0431f$var$CharCodes.LOWER_Z || $14589e7572d0431f$var$isNumber(code);
}
/**
 * Checks if the given character is a valid end character for an entity in an attribute.
 *
 * Attribute values that aren't terminated properly aren't parsed, and shouldn't lead to a parser error.
 * See the example in https://html.spec.whatwg.org/multipage/parsing.html#named-character-reference-state
 */ function $14589e7572d0431f$var$isEntityInAttributeInvalidEnd(code) {
    return code === $14589e7572d0431f$var$CharCodes.EQUALS || $14589e7572d0431f$var$isAsciiAlphaNumeric(code);
}
var $14589e7572d0431f$var$EntityDecoderState;
(function(EntityDecoderState) {
    EntityDecoderState[EntityDecoderState["EntityStart"] = 0] = "EntityStart";
    EntityDecoderState[EntityDecoderState["NumericStart"] = 1] = "NumericStart";
    EntityDecoderState[EntityDecoderState["NumericDecimal"] = 2] = "NumericDecimal";
    EntityDecoderState[EntityDecoderState["NumericHex"] = 3] = "NumericHex";
    EntityDecoderState[EntityDecoderState["NamedEntity"] = 4] = "NamedEntity";
})($14589e7572d0431f$var$EntityDecoderState || ($14589e7572d0431f$var$EntityDecoderState = {}));
var $14589e7572d0431f$var$DecodingMode;
(function(DecodingMode) {
    /** Entities in text nodes that can end with any character. */ DecodingMode[DecodingMode["Legacy"] = 0] = "Legacy";
    /** Only allow entities terminated with a semicolon. */ DecodingMode[DecodingMode["Strict"] = 1] = "Strict";
    /** Entities in attributes have limitations on ending characters. */ DecodingMode[DecodingMode["Attribute"] = 2] = "Attribute";
})($14589e7572d0431f$var$DecodingMode = $14589e7572d0431f$exports.DecodingMode || ($14589e7572d0431f$exports.DecodingMode = {}));
/**
 * Token decoder with support of writing partial entities.
 */ var $14589e7572d0431f$var$EntityDecoder = /** @class */ function() {
    function EntityDecoder(/** The tree used to decode entities. */ decodeTree, /**
     * The function that is called when a codepoint is decoded.
     *
     * For multi-byte named entities, this will be called multiple times,
     * with the second codepoint, and the same `consumed` value.
     *
     * @param codepoint The decoded codepoint.
     * @param consumed The number of bytes consumed by the decoder.
     */ emitCodePoint, /** An object that is used to produce errors. */ errors) {
        this.decodeTree = decodeTree;
        this.emitCodePoint = emitCodePoint;
        this.errors = errors;
        /** The current state of the decoder. */ this.state = $14589e7572d0431f$var$EntityDecoderState.EntityStart;
        /** Characters that were consumed while parsing an entity. */ this.consumed = 1;
        /**
         * The result of the entity.
         *
         * Either the result index of a numeric entity, or the codepoint of a
         * numeric entity.
         */ this.result = 0;
        /** The current index in the decode tree. */ this.treeIndex = 0;
        /** The number of characters that were consumed in excess. */ this.excess = 1;
        /** The mode in which the decoder is operating. */ this.decodeMode = $14589e7572d0431f$var$DecodingMode.Strict;
    }
    /** Resets the instance to make it reusable. */ EntityDecoder.prototype.startEntity = function(decodeMode) {
        this.decodeMode = decodeMode;
        this.state = $14589e7572d0431f$var$EntityDecoderState.EntityStart;
        this.result = 0;
        this.treeIndex = 0;
        this.excess = 1;
        this.consumed = 1;
    };
    /**
     * Write an entity to the decoder. This can be called multiple times with partial entities.
     * If the entity is incomplete, the decoder will return -1.
     *
     * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
     * entity is incomplete, and resume when the next string is written.
     *
     * @param string The string containing the entity (or a continuation of the entity).
     * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.write = function(str, offset) {
        switch(this.state){
            case $14589e7572d0431f$var$EntityDecoderState.EntityStart:
                if (str.charCodeAt(offset) === $14589e7572d0431f$var$CharCodes.NUM) {
                    this.state = $14589e7572d0431f$var$EntityDecoderState.NumericStart;
                    this.consumed += 1;
                    return this.stateNumericStart(str, offset + 1);
                }
                this.state = $14589e7572d0431f$var$EntityDecoderState.NamedEntity;
                return this.stateNamedEntity(str, offset);
            case $14589e7572d0431f$var$EntityDecoderState.NumericStart:
                return this.stateNumericStart(str, offset);
            case $14589e7572d0431f$var$EntityDecoderState.NumericDecimal:
                return this.stateNumericDecimal(str, offset);
            case $14589e7572d0431f$var$EntityDecoderState.NumericHex:
                return this.stateNumericHex(str, offset);
            case $14589e7572d0431f$var$EntityDecoderState.NamedEntity:
                return this.stateNamedEntity(str, offset);
        }
    };
    /**
     * Switches between the numeric decimal and hexadecimal states.
     *
     * Equivalent to the `Numeric character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.stateNumericStart = function(str, offset) {
        if (offset >= str.length) return -1;
        if ((str.charCodeAt(offset) | $14589e7572d0431f$var$TO_LOWER_BIT) === $14589e7572d0431f$var$CharCodes.LOWER_X) {
            this.state = $14589e7572d0431f$var$EntityDecoderState.NumericHex;
            this.consumed += 1;
            return this.stateNumericHex(str, offset + 1);
        }
        this.state = $14589e7572d0431f$var$EntityDecoderState.NumericDecimal;
        return this.stateNumericDecimal(str, offset);
    };
    EntityDecoder.prototype.addToNumericResult = function(str, start, end, base) {
        if (start !== end) {
            var digitCount = end - start;
            this.result = this.result * Math.pow(base, digitCount) + parseInt(str.substr(start, digitCount), base);
            this.consumed += digitCount;
        }
    };
    /**
     * Parses a hexadecimal numeric entity.
     *
     * Equivalent to the `Hexademical character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.stateNumericHex = function(str, offset) {
        var startIdx = offset;
        while(offset < str.length){
            var char = str.charCodeAt(offset);
            if ($14589e7572d0431f$var$isNumber(char) || $14589e7572d0431f$var$isHexadecimalCharacter(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 16);
                return this.emitNumericEntity(char, 3);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 16);
        return -1;
    };
    /**
     * Parses a decimal numeric entity.
     *
     * Equivalent to the `Decimal character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.stateNumericDecimal = function(str, offset) {
        var startIdx = offset;
        while(offset < str.length){
            var char = str.charCodeAt(offset);
            if ($14589e7572d0431f$var$isNumber(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 10);
                return this.emitNumericEntity(char, 2);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 10);
        return -1;
    };
    /**
     * Validate and emit a numeric entity.
     *
     * Implements the logic from the `Hexademical character reference start
     * state` and `Numeric character reference end state` in the HTML spec.
     *
     * @param lastCp The last code point of the entity. Used to see if the
     *               entity was terminated with a semicolon.
     * @param expectedLength The minimum number of characters that should be
     *                       consumed. Used to validate that at least one digit
     *                       was consumed.
     * @returns The number of characters that were consumed.
     */ EntityDecoder.prototype.emitNumericEntity = function(lastCp, expectedLength) {
        var _a;
        // Ensure we consumed at least one digit.
        if (this.consumed <= expectedLength) {
            (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
            return 0;
        }
        // Figure out if this is a legit end of the entity
        if (lastCp === $14589e7572d0431f$var$CharCodes.SEMI) this.consumed += 1;
        else if (this.decodeMode === $14589e7572d0431f$var$DecodingMode.Strict) return 0;
        this.emitCodePoint((0, $14589e7572d0431f$var$decode_codepoint_js_1.replaceCodePoint)(this.result), this.consumed);
        if (this.errors) {
            if (lastCp !== $14589e7572d0431f$var$CharCodes.SEMI) this.errors.missingSemicolonAfterCharacterReference();
            this.errors.validateNumericCharacterReference(this.result);
        }
        return this.consumed;
    };
    /**
     * Parses a named entity.
     *
     * Equivalent to the `Named character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.stateNamedEntity = function(str, offset) {
        var decodeTree = this.decodeTree;
        var current = decodeTree[this.treeIndex];
        // The mask is the number of bytes of the value, including the current byte.
        var valueLength = (current & $14589e7572d0431f$var$BinTrieFlags.VALUE_LENGTH) >> 14;
        for(; offset < str.length; offset++, this.excess++){
            var char = str.charCodeAt(offset);
            this.treeIndex = $14589e7572d0431f$var$determineBranch(decodeTree, current, this.treeIndex + Math.max(1, valueLength), char);
            if (this.treeIndex < 0) return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === $14589e7572d0431f$var$DecodingMode.Attribute && // We shouldn't have consumed any characters after the entity,
            (valueLength === 0 || // And there should be no invalid characters.
            $14589e7572d0431f$var$isEntityInAttributeInvalidEnd(char)) ? 0 : this.emitNotTerminatedNamedEntity();
            current = decodeTree[this.treeIndex];
            valueLength = (current & $14589e7572d0431f$var$BinTrieFlags.VALUE_LENGTH) >> 14;
            // If the branch is a value, store it and continue
            if (valueLength !== 0) {
                // If the entity is terminated by a semicolon, we are done.
                if (char === $14589e7572d0431f$var$CharCodes.SEMI) return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
                // If we encounter a non-terminated (legacy) entity while parsing strictly, then ignore it.
                if (this.decodeMode !== $14589e7572d0431f$var$DecodingMode.Strict) {
                    this.result = this.treeIndex;
                    this.consumed += this.excess;
                    this.excess = 0;
                }
            }
        }
        return -1;
    };
    /**
     * Emit a named entity that was not terminated with a semicolon.
     *
     * @returns The number of characters consumed.
     */ EntityDecoder.prototype.emitNotTerminatedNamedEntity = function() {
        var _a;
        var _b = this, result = _b.result, decodeTree = _b.decodeTree;
        var valueLength = (decodeTree[result] & $14589e7572d0431f$var$BinTrieFlags.VALUE_LENGTH) >> 14;
        this.emitNamedEntityData(result, valueLength, this.consumed);
        (_a = this.errors) === null || _a === void 0 || _a.missingSemicolonAfterCharacterReference();
        return this.consumed;
    };
    /**
     * Emit a named entity.
     *
     * @param result The index of the entity in the decode tree.
     * @param valueLength The number of bytes in the entity.
     * @param consumed The number of characters consumed.
     *
     * @returns The number of characters consumed.
     */ EntityDecoder.prototype.emitNamedEntityData = function(result, valueLength, consumed) {
        var decodeTree = this.decodeTree;
        this.emitCodePoint(valueLength === 1 ? decodeTree[result] & ~$14589e7572d0431f$var$BinTrieFlags.VALUE_LENGTH : decodeTree[result + 1], consumed);
        if (valueLength === 3) // For multi-byte values, we need to emit the second byte.
        this.emitCodePoint(decodeTree[result + 2], consumed);
        return consumed;
    };
    /**
     * Signal to the parser that the end of the input was reached.
     *
     * Remaining data will be emitted and relevant errors will be produced.
     *
     * @returns The number of characters consumed.
     */ EntityDecoder.prototype.end = function() {
        var _a;
        switch(this.state){
            case $14589e7572d0431f$var$EntityDecoderState.NamedEntity:
                // Emit a named entity if we have one.
                return this.result !== 0 && (this.decodeMode !== $14589e7572d0431f$var$DecodingMode.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
            // Otherwise, emit a numeric entity if we have one.
            case $14589e7572d0431f$var$EntityDecoderState.NumericDecimal:
                return this.emitNumericEntity(0, 2);
            case $14589e7572d0431f$var$EntityDecoderState.NumericHex:
                return this.emitNumericEntity(0, 3);
            case $14589e7572d0431f$var$EntityDecoderState.NumericStart:
                (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
                return 0;
            case $14589e7572d0431f$var$EntityDecoderState.EntityStart:
                // Return 0 if we have no entity.
                return 0;
        }
    };
    return EntityDecoder;
}();
$14589e7572d0431f$exports.EntityDecoder = $14589e7572d0431f$var$EntityDecoder;
/**
 * Creates a function that decodes entities in a string.
 *
 * @param decodeTree The decode tree.
 * @returns A function that decodes entities in a string.
 */ function $14589e7572d0431f$var$getDecoder(decodeTree) {
    var ret = "";
    var decoder = new $14589e7572d0431f$var$EntityDecoder(decodeTree, function(str) {
        return ret += (0, $14589e7572d0431f$var$decode_codepoint_js_1.fromCodePoint)(str);
    });
    return function decodeWithTrie(str, decodeMode) {
        var lastIndex = 0;
        var offset = 0;
        while((offset = str.indexOf("&", offset)) >= 0){
            ret += str.slice(lastIndex, offset);
            decoder.startEntity(decodeMode);
            var len = decoder.write(str, // Skip the "&"
            offset + 1);
            if (len < 0) {
                lastIndex = offset + decoder.end();
                break;
            }
            lastIndex = offset + len;
            // If `len` is 0, skip the current `&` and continue.
            offset = len === 0 ? lastIndex + 1 : lastIndex;
        }
        var result = ret + str.slice(lastIndex);
        // Make sure we don't keep a reference to the final string.
        ret = "";
        return result;
    };
}
/**
 * Determines the branch of the current node that is taken given the current
 * character. This function is used to traverse the trie.
 *
 * @param decodeTree The trie.
 * @param current The current node.
 * @param nodeIdx The index right after the current node and its value.
 * @param char The current character.
 * @returns The index of the next node, or -1 if no branch is taken.
 */ function $14589e7572d0431f$var$determineBranch(decodeTree, current, nodeIdx, char) {
    var branchCount = (current & $14589e7572d0431f$var$BinTrieFlags.BRANCH_LENGTH) >> 7;
    var jumpOffset = current & $14589e7572d0431f$var$BinTrieFlags.JUMP_TABLE;
    // Case 1: Single branch encoded in jump offset
    if (branchCount === 0) return jumpOffset !== 0 && char === jumpOffset ? nodeIdx : -1;
    // Case 2: Multiple branches encoded in jump table
    if (jumpOffset) {
        var value = char - jumpOffset;
        return value < 0 || value >= branchCount ? -1 : decodeTree[nodeIdx + value] - 1;
    }
    // Case 3: Multiple branches encoded in dictionary
    // Binary search for the character.
    var lo = nodeIdx;
    var hi = lo + branchCount - 1;
    while(lo <= hi){
        var mid = lo + hi >>> 1;
        var midVal = decodeTree[mid];
        if (midVal < char) lo = mid + 1;
        else if (midVal > char) hi = mid - 1;
        else return decodeTree[mid + branchCount];
    }
    return -1;
}
$14589e7572d0431f$exports.determineBranch = $14589e7572d0431f$var$determineBranch;
var $14589e7572d0431f$var$htmlDecoder = $14589e7572d0431f$var$getDecoder($14589e7572d0431f$var$decode_data_html_js_1.default);
var $14589e7572d0431f$var$xmlDecoder = $14589e7572d0431f$var$getDecoder($14589e7572d0431f$var$decode_data_xml_js_1.default);
/**
 * Decodes an HTML string.
 *
 * @param str The string to decode.
 * @param mode The decoding mode.
 * @returns The decoded string.
 */ function $14589e7572d0431f$var$decodeHTML(str, mode) {
    if (mode === void 0) mode = $14589e7572d0431f$var$DecodingMode.Legacy;
    return $14589e7572d0431f$var$htmlDecoder(str, mode);
}
$14589e7572d0431f$exports.decodeHTML = $14589e7572d0431f$var$decodeHTML;
/**
 * Decodes an HTML string in an attribute.
 *
 * @param str The string to decode.
 * @returns The decoded string.
 */ function $14589e7572d0431f$var$decodeHTMLAttribute(str) {
    return $14589e7572d0431f$var$htmlDecoder(str, $14589e7572d0431f$var$DecodingMode.Attribute);
}
$14589e7572d0431f$exports.decodeHTMLAttribute = $14589e7572d0431f$var$decodeHTMLAttribute;
/**
 * Decodes an HTML string, requiring all entities to be terminated by a semicolon.
 *
 * @param str The string to decode.
 * @returns The decoded string.
 */ function $14589e7572d0431f$var$decodeHTMLStrict(str) {
    return $14589e7572d0431f$var$htmlDecoder(str, $14589e7572d0431f$var$DecodingMode.Strict);
}
$14589e7572d0431f$exports.decodeHTMLStrict = $14589e7572d0431f$var$decodeHTMLStrict;
/**
 * Decodes an XML string, requiring all entities to be terminated by a semicolon.
 *
 * @param str The string to decode.
 * @returns The decoded string.
 */ function $14589e7572d0431f$var$decodeXML(str) {
    return $14589e7572d0431f$var$xmlDecoder(str, $14589e7572d0431f$var$DecodingMode.Strict);
}
$14589e7572d0431f$exports.decodeXML = $14589e7572d0431f$var$decodeXML;



var $0ddaebefe9b4fbd6$exports = {};

$parcel$export($0ddaebefe9b4fbd6$exports, "NS", () => $0ddaebefe9b4fbd6$export$fb4028874a74450);
$parcel$export($0ddaebefe9b4fbd6$exports, "ATTRS", () => $0ddaebefe9b4fbd6$export$380b7bc9e6cb1918);
$parcel$export($0ddaebefe9b4fbd6$exports, "DOCUMENT_MODE", () => $0ddaebefe9b4fbd6$export$a74d46c85337d29a);
$parcel$export($0ddaebefe9b4fbd6$exports, "TAG_NAMES", () => $0ddaebefe9b4fbd6$export$7e674a85a2656dce);
$parcel$export($0ddaebefe9b4fbd6$exports, "TAG_ID", () => $0ddaebefe9b4fbd6$export$cb0999a53e0acaed);
$parcel$export($0ddaebefe9b4fbd6$exports, "getTagID", () => $0ddaebefe9b4fbd6$export$39db8a1315f68282);
$parcel$export($0ddaebefe9b4fbd6$exports, "SPECIAL_ELEMENTS", () => $0ddaebefe9b4fbd6$export$7e5172336f7d2bbb);
$parcel$export($0ddaebefe9b4fbd6$exports, "isNumberedHeader", () => $0ddaebefe9b4fbd6$export$5ed5f14a3d15367);
$parcel$export($0ddaebefe9b4fbd6$exports, "hasUnescapedText", () => $0ddaebefe9b4fbd6$export$4ce4f8c09f921aed);
/** All valid namespaces in HTML. */ var $0ddaebefe9b4fbd6$export$fb4028874a74450;
(function(NS) {
    NS["HTML"] = "http://www.w3.org/1999/xhtml";
    NS["MATHML"] = "http://www.w3.org/1998/Math/MathML";
    NS["SVG"] = "http://www.w3.org/2000/svg";
    NS["XLINK"] = "http://www.w3.org/1999/xlink";
    NS["XML"] = "http://www.w3.org/XML/1998/namespace";
    NS["XMLNS"] = "http://www.w3.org/2000/xmlns/";
})($0ddaebefe9b4fbd6$export$fb4028874a74450 = $0ddaebefe9b4fbd6$export$fb4028874a74450 || ($0ddaebefe9b4fbd6$export$fb4028874a74450 = {}));
var $0ddaebefe9b4fbd6$export$380b7bc9e6cb1918;
(function(ATTRS) {
    ATTRS["TYPE"] = "type";
    ATTRS["ACTION"] = "action";
    ATTRS["ENCODING"] = "encoding";
    ATTRS["PROMPT"] = "prompt";
    ATTRS["NAME"] = "name";
    ATTRS["COLOR"] = "color";
    ATTRS["FACE"] = "face";
    ATTRS["SIZE"] = "size";
})($0ddaebefe9b4fbd6$export$380b7bc9e6cb1918 = $0ddaebefe9b4fbd6$export$380b7bc9e6cb1918 || ($0ddaebefe9b4fbd6$export$380b7bc9e6cb1918 = {}));
var $0ddaebefe9b4fbd6$export$a74d46c85337d29a;
(function(DOCUMENT_MODE) {
    DOCUMENT_MODE["NO_QUIRKS"] = "no-quirks";
    DOCUMENT_MODE["QUIRKS"] = "quirks";
    DOCUMENT_MODE["LIMITED_QUIRKS"] = "limited-quirks";
})($0ddaebefe9b4fbd6$export$a74d46c85337d29a = $0ddaebefe9b4fbd6$export$a74d46c85337d29a || ($0ddaebefe9b4fbd6$export$a74d46c85337d29a = {}));
var $0ddaebefe9b4fbd6$export$7e674a85a2656dce;
(function(TAG_NAMES) {
    TAG_NAMES["A"] = "a";
    TAG_NAMES["ADDRESS"] = "address";
    TAG_NAMES["ANNOTATION_XML"] = "annotation-xml";
    TAG_NAMES["APPLET"] = "applet";
    TAG_NAMES["AREA"] = "area";
    TAG_NAMES["ARTICLE"] = "article";
    TAG_NAMES["ASIDE"] = "aside";
    TAG_NAMES["B"] = "b";
    TAG_NAMES["BASE"] = "base";
    TAG_NAMES["BASEFONT"] = "basefont";
    TAG_NAMES["BGSOUND"] = "bgsound";
    TAG_NAMES["BIG"] = "big";
    TAG_NAMES["BLOCKQUOTE"] = "blockquote";
    TAG_NAMES["BODY"] = "body";
    TAG_NAMES["BR"] = "br";
    TAG_NAMES["BUTTON"] = "button";
    TAG_NAMES["CAPTION"] = "caption";
    TAG_NAMES["CENTER"] = "center";
    TAG_NAMES["CODE"] = "code";
    TAG_NAMES["COL"] = "col";
    TAG_NAMES["COLGROUP"] = "colgroup";
    TAG_NAMES["DD"] = "dd";
    TAG_NAMES["DESC"] = "desc";
    TAG_NAMES["DETAILS"] = "details";
    TAG_NAMES["DIALOG"] = "dialog";
    TAG_NAMES["DIR"] = "dir";
    TAG_NAMES["DIV"] = "div";
    TAG_NAMES["DL"] = "dl";
    TAG_NAMES["DT"] = "dt";
    TAG_NAMES["EM"] = "em";
    TAG_NAMES["EMBED"] = "embed";
    TAG_NAMES["FIELDSET"] = "fieldset";
    TAG_NAMES["FIGCAPTION"] = "figcaption";
    TAG_NAMES["FIGURE"] = "figure";
    TAG_NAMES["FONT"] = "font";
    TAG_NAMES["FOOTER"] = "footer";
    TAG_NAMES["FOREIGN_OBJECT"] = "foreignObject";
    TAG_NAMES["FORM"] = "form";
    TAG_NAMES["FRAME"] = "frame";
    TAG_NAMES["FRAMESET"] = "frameset";
    TAG_NAMES["H1"] = "h1";
    TAG_NAMES["H2"] = "h2";
    TAG_NAMES["H3"] = "h3";
    TAG_NAMES["H4"] = "h4";
    TAG_NAMES["H5"] = "h5";
    TAG_NAMES["H6"] = "h6";
    TAG_NAMES["HEAD"] = "head";
    TAG_NAMES["HEADER"] = "header";
    TAG_NAMES["HGROUP"] = "hgroup";
    TAG_NAMES["HR"] = "hr";
    TAG_NAMES["HTML"] = "html";
    TAG_NAMES["I"] = "i";
    TAG_NAMES["IMG"] = "img";
    TAG_NAMES["IMAGE"] = "image";
    TAG_NAMES["INPUT"] = "input";
    TAG_NAMES["IFRAME"] = "iframe";
    TAG_NAMES["KEYGEN"] = "keygen";
    TAG_NAMES["LABEL"] = "label";
    TAG_NAMES["LI"] = "li";
    TAG_NAMES["LINK"] = "link";
    TAG_NAMES["LISTING"] = "listing";
    TAG_NAMES["MAIN"] = "main";
    TAG_NAMES["MALIGNMARK"] = "malignmark";
    TAG_NAMES["MARQUEE"] = "marquee";
    TAG_NAMES["MATH"] = "math";
    TAG_NAMES["MENU"] = "menu";
    TAG_NAMES["META"] = "meta";
    TAG_NAMES["MGLYPH"] = "mglyph";
    TAG_NAMES["MI"] = "mi";
    TAG_NAMES["MO"] = "mo";
    TAG_NAMES["MN"] = "mn";
    TAG_NAMES["MS"] = "ms";
    TAG_NAMES["MTEXT"] = "mtext";
    TAG_NAMES["NAV"] = "nav";
    TAG_NAMES["NOBR"] = "nobr";
    TAG_NAMES["NOFRAMES"] = "noframes";
    TAG_NAMES["NOEMBED"] = "noembed";
    TAG_NAMES["NOSCRIPT"] = "noscript";
    TAG_NAMES["OBJECT"] = "object";
    TAG_NAMES["OL"] = "ol";
    TAG_NAMES["OPTGROUP"] = "optgroup";
    TAG_NAMES["OPTION"] = "option";
    TAG_NAMES["P"] = "p";
    TAG_NAMES["PARAM"] = "param";
    TAG_NAMES["PLAINTEXT"] = "plaintext";
    TAG_NAMES["PRE"] = "pre";
    TAG_NAMES["RB"] = "rb";
    TAG_NAMES["RP"] = "rp";
    TAG_NAMES["RT"] = "rt";
    TAG_NAMES["RTC"] = "rtc";
    TAG_NAMES["RUBY"] = "ruby";
    TAG_NAMES["S"] = "s";
    TAG_NAMES["SCRIPT"] = "script";
    TAG_NAMES["SECTION"] = "section";
    TAG_NAMES["SELECT"] = "select";
    TAG_NAMES["SOURCE"] = "source";
    TAG_NAMES["SMALL"] = "small";
    TAG_NAMES["SPAN"] = "span";
    TAG_NAMES["STRIKE"] = "strike";
    TAG_NAMES["STRONG"] = "strong";
    TAG_NAMES["STYLE"] = "style";
    TAG_NAMES["SUB"] = "sub";
    TAG_NAMES["SUMMARY"] = "summary";
    TAG_NAMES["SUP"] = "sup";
    TAG_NAMES["TABLE"] = "table";
    TAG_NAMES["TBODY"] = "tbody";
    TAG_NAMES["TEMPLATE"] = "template";
    TAG_NAMES["TEXTAREA"] = "textarea";
    TAG_NAMES["TFOOT"] = "tfoot";
    TAG_NAMES["TD"] = "td";
    TAG_NAMES["TH"] = "th";
    TAG_NAMES["THEAD"] = "thead";
    TAG_NAMES["TITLE"] = "title";
    TAG_NAMES["TR"] = "tr";
    TAG_NAMES["TRACK"] = "track";
    TAG_NAMES["TT"] = "tt";
    TAG_NAMES["U"] = "u";
    TAG_NAMES["UL"] = "ul";
    TAG_NAMES["SVG"] = "svg";
    TAG_NAMES["VAR"] = "var";
    TAG_NAMES["WBR"] = "wbr";
    TAG_NAMES["XMP"] = "xmp";
})($0ddaebefe9b4fbd6$export$7e674a85a2656dce = $0ddaebefe9b4fbd6$export$7e674a85a2656dce || ($0ddaebefe9b4fbd6$export$7e674a85a2656dce = {}));
var $0ddaebefe9b4fbd6$export$cb0999a53e0acaed;
(function(TAG_ID) {
    TAG_ID[TAG_ID["UNKNOWN"] = 0] = "UNKNOWN";
    TAG_ID[TAG_ID["A"] = 1] = "A";
    TAG_ID[TAG_ID["ADDRESS"] = 2] = "ADDRESS";
    TAG_ID[TAG_ID["ANNOTATION_XML"] = 3] = "ANNOTATION_XML";
    TAG_ID[TAG_ID["APPLET"] = 4] = "APPLET";
    TAG_ID[TAG_ID["AREA"] = 5] = "AREA";
    TAG_ID[TAG_ID["ARTICLE"] = 6] = "ARTICLE";
    TAG_ID[TAG_ID["ASIDE"] = 7] = "ASIDE";
    TAG_ID[TAG_ID["B"] = 8] = "B";
    TAG_ID[TAG_ID["BASE"] = 9] = "BASE";
    TAG_ID[TAG_ID["BASEFONT"] = 10] = "BASEFONT";
    TAG_ID[TAG_ID["BGSOUND"] = 11] = "BGSOUND";
    TAG_ID[TAG_ID["BIG"] = 12] = "BIG";
    TAG_ID[TAG_ID["BLOCKQUOTE"] = 13] = "BLOCKQUOTE";
    TAG_ID[TAG_ID["BODY"] = 14] = "BODY";
    TAG_ID[TAG_ID["BR"] = 15] = "BR";
    TAG_ID[TAG_ID["BUTTON"] = 16] = "BUTTON";
    TAG_ID[TAG_ID["CAPTION"] = 17] = "CAPTION";
    TAG_ID[TAG_ID["CENTER"] = 18] = "CENTER";
    TAG_ID[TAG_ID["CODE"] = 19] = "CODE";
    TAG_ID[TAG_ID["COL"] = 20] = "COL";
    TAG_ID[TAG_ID["COLGROUP"] = 21] = "COLGROUP";
    TAG_ID[TAG_ID["DD"] = 22] = "DD";
    TAG_ID[TAG_ID["DESC"] = 23] = "DESC";
    TAG_ID[TAG_ID["DETAILS"] = 24] = "DETAILS";
    TAG_ID[TAG_ID["DIALOG"] = 25] = "DIALOG";
    TAG_ID[TAG_ID["DIR"] = 26] = "DIR";
    TAG_ID[TAG_ID["DIV"] = 27] = "DIV";
    TAG_ID[TAG_ID["DL"] = 28] = "DL";
    TAG_ID[TAG_ID["DT"] = 29] = "DT";
    TAG_ID[TAG_ID["EM"] = 30] = "EM";
    TAG_ID[TAG_ID["EMBED"] = 31] = "EMBED";
    TAG_ID[TAG_ID["FIELDSET"] = 32] = "FIELDSET";
    TAG_ID[TAG_ID["FIGCAPTION"] = 33] = "FIGCAPTION";
    TAG_ID[TAG_ID["FIGURE"] = 34] = "FIGURE";
    TAG_ID[TAG_ID["FONT"] = 35] = "FONT";
    TAG_ID[TAG_ID["FOOTER"] = 36] = "FOOTER";
    TAG_ID[TAG_ID["FOREIGN_OBJECT"] = 37] = "FOREIGN_OBJECT";
    TAG_ID[TAG_ID["FORM"] = 38] = "FORM";
    TAG_ID[TAG_ID["FRAME"] = 39] = "FRAME";
    TAG_ID[TAG_ID["FRAMESET"] = 40] = "FRAMESET";
    TAG_ID[TAG_ID["H1"] = 41] = "H1";
    TAG_ID[TAG_ID["H2"] = 42] = "H2";
    TAG_ID[TAG_ID["H3"] = 43] = "H3";
    TAG_ID[TAG_ID["H4"] = 44] = "H4";
    TAG_ID[TAG_ID["H5"] = 45] = "H5";
    TAG_ID[TAG_ID["H6"] = 46] = "H6";
    TAG_ID[TAG_ID["HEAD"] = 47] = "HEAD";
    TAG_ID[TAG_ID["HEADER"] = 48] = "HEADER";
    TAG_ID[TAG_ID["HGROUP"] = 49] = "HGROUP";
    TAG_ID[TAG_ID["HR"] = 50] = "HR";
    TAG_ID[TAG_ID["HTML"] = 51] = "HTML";
    TAG_ID[TAG_ID["I"] = 52] = "I";
    TAG_ID[TAG_ID["IMG"] = 53] = "IMG";
    TAG_ID[TAG_ID["IMAGE"] = 54] = "IMAGE";
    TAG_ID[TAG_ID["INPUT"] = 55] = "INPUT";
    TAG_ID[TAG_ID["IFRAME"] = 56] = "IFRAME";
    TAG_ID[TAG_ID["KEYGEN"] = 57] = "KEYGEN";
    TAG_ID[TAG_ID["LABEL"] = 58] = "LABEL";
    TAG_ID[TAG_ID["LI"] = 59] = "LI";
    TAG_ID[TAG_ID["LINK"] = 60] = "LINK";
    TAG_ID[TAG_ID["LISTING"] = 61] = "LISTING";
    TAG_ID[TAG_ID["MAIN"] = 62] = "MAIN";
    TAG_ID[TAG_ID["MALIGNMARK"] = 63] = "MALIGNMARK";
    TAG_ID[TAG_ID["MARQUEE"] = 64] = "MARQUEE";
    TAG_ID[TAG_ID["MATH"] = 65] = "MATH";
    TAG_ID[TAG_ID["MENU"] = 66] = "MENU";
    TAG_ID[TAG_ID["META"] = 67] = "META";
    TAG_ID[TAG_ID["MGLYPH"] = 68] = "MGLYPH";
    TAG_ID[TAG_ID["MI"] = 69] = "MI";
    TAG_ID[TAG_ID["MO"] = 70] = "MO";
    TAG_ID[TAG_ID["MN"] = 71] = "MN";
    TAG_ID[TAG_ID["MS"] = 72] = "MS";
    TAG_ID[TAG_ID["MTEXT"] = 73] = "MTEXT";
    TAG_ID[TAG_ID["NAV"] = 74] = "NAV";
    TAG_ID[TAG_ID["NOBR"] = 75] = "NOBR";
    TAG_ID[TAG_ID["NOFRAMES"] = 76] = "NOFRAMES";
    TAG_ID[TAG_ID["NOEMBED"] = 77] = "NOEMBED";
    TAG_ID[TAG_ID["NOSCRIPT"] = 78] = "NOSCRIPT";
    TAG_ID[TAG_ID["OBJECT"] = 79] = "OBJECT";
    TAG_ID[TAG_ID["OL"] = 80] = "OL";
    TAG_ID[TAG_ID["OPTGROUP"] = 81] = "OPTGROUP";
    TAG_ID[TAG_ID["OPTION"] = 82] = "OPTION";
    TAG_ID[TAG_ID["P"] = 83] = "P";
    TAG_ID[TAG_ID["PARAM"] = 84] = "PARAM";
    TAG_ID[TAG_ID["PLAINTEXT"] = 85] = "PLAINTEXT";
    TAG_ID[TAG_ID["PRE"] = 86] = "PRE";
    TAG_ID[TAG_ID["RB"] = 87] = "RB";
    TAG_ID[TAG_ID["RP"] = 88] = "RP";
    TAG_ID[TAG_ID["RT"] = 89] = "RT";
    TAG_ID[TAG_ID["RTC"] = 90] = "RTC";
    TAG_ID[TAG_ID["RUBY"] = 91] = "RUBY";
    TAG_ID[TAG_ID["S"] = 92] = "S";
    TAG_ID[TAG_ID["SCRIPT"] = 93] = "SCRIPT";
    TAG_ID[TAG_ID["SECTION"] = 94] = "SECTION";
    TAG_ID[TAG_ID["SELECT"] = 95] = "SELECT";
    TAG_ID[TAG_ID["SOURCE"] = 96] = "SOURCE";
    TAG_ID[TAG_ID["SMALL"] = 97] = "SMALL";
    TAG_ID[TAG_ID["SPAN"] = 98] = "SPAN";
    TAG_ID[TAG_ID["STRIKE"] = 99] = "STRIKE";
    TAG_ID[TAG_ID["STRONG"] = 100] = "STRONG";
    TAG_ID[TAG_ID["STYLE"] = 101] = "STYLE";
    TAG_ID[TAG_ID["SUB"] = 102] = "SUB";
    TAG_ID[TAG_ID["SUMMARY"] = 103] = "SUMMARY";
    TAG_ID[TAG_ID["SUP"] = 104] = "SUP";
    TAG_ID[TAG_ID["TABLE"] = 105] = "TABLE";
    TAG_ID[TAG_ID["TBODY"] = 106] = "TBODY";
    TAG_ID[TAG_ID["TEMPLATE"] = 107] = "TEMPLATE";
    TAG_ID[TAG_ID["TEXTAREA"] = 108] = "TEXTAREA";
    TAG_ID[TAG_ID["TFOOT"] = 109] = "TFOOT";
    TAG_ID[TAG_ID["TD"] = 110] = "TD";
    TAG_ID[TAG_ID["TH"] = 111] = "TH";
    TAG_ID[TAG_ID["THEAD"] = 112] = "THEAD";
    TAG_ID[TAG_ID["TITLE"] = 113] = "TITLE";
    TAG_ID[TAG_ID["TR"] = 114] = "TR";
    TAG_ID[TAG_ID["TRACK"] = 115] = "TRACK";
    TAG_ID[TAG_ID["TT"] = 116] = "TT";
    TAG_ID[TAG_ID["U"] = 117] = "U";
    TAG_ID[TAG_ID["UL"] = 118] = "UL";
    TAG_ID[TAG_ID["SVG"] = 119] = "SVG";
    TAG_ID[TAG_ID["VAR"] = 120] = "VAR";
    TAG_ID[TAG_ID["WBR"] = 121] = "WBR";
    TAG_ID[TAG_ID["XMP"] = 122] = "XMP";
})($0ddaebefe9b4fbd6$export$cb0999a53e0acaed = $0ddaebefe9b4fbd6$export$cb0999a53e0acaed || ($0ddaebefe9b4fbd6$export$cb0999a53e0acaed = {}));
const $0ddaebefe9b4fbd6$var$TAG_NAME_TO_ID = new Map([
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.A,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.A
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.ADDRESS,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.ADDRESS
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.ANNOTATION_XML,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.ANNOTATION_XML
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.APPLET,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.APPLET
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.AREA,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.AREA
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.ARTICLE,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.ARTICLE
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.ASIDE,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.ASIDE
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.B,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.B
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.BASE,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.BASE
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.BASEFONT,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.BASEFONT
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.BGSOUND,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.BGSOUND
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.BIG,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.BIG
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.BLOCKQUOTE,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.BLOCKQUOTE
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.BODY,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.BODY
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.BR,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.BR
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.BUTTON,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.BUTTON
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.CAPTION,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.CAPTION
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.CENTER,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.CENTER
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.CODE,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.CODE
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.COL,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.COL
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.COLGROUP,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.COLGROUP
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.DD,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.DD
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.DESC,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.DESC
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.DETAILS,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.DETAILS
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.DIALOG,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.DIALOG
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.DIR,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.DIR
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.DIV,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.DIV
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.DL,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.DL
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.DT,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.DT
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.EM,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.EM
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.EMBED,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.EMBED
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.FIELDSET,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.FIELDSET
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.FIGCAPTION,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.FIGCAPTION
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.FIGURE,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.FIGURE
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.FONT,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.FONT
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.FOOTER,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.FOOTER
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.FOREIGN_OBJECT,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.FOREIGN_OBJECT
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.FORM,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.FORM
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.FRAME,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.FRAME
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.FRAMESET,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.FRAMESET
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.H1,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.H1
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.H2,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.H2
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.H3,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.H3
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.H4,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.H4
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.H5,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.H5
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.H6,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.H6
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.HEAD,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.HEAD
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.HEADER,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.HEADER
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.HGROUP,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.HGROUP
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.HR,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.HR
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.HTML,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.HTML
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.I,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.I
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.IMG,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.IMG
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.IMAGE,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.IMAGE
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.INPUT,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.INPUT
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.IFRAME,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.IFRAME
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.KEYGEN,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.KEYGEN
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.LABEL,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.LABEL
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.LI,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.LI
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.LINK,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.LINK
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.LISTING,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.LISTING
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.MAIN,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.MAIN
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.MALIGNMARK,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.MALIGNMARK
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.MARQUEE,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.MARQUEE
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.MATH,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.MATH
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.MENU,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.MENU
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.META,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.META
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.MGLYPH,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.MGLYPH
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.MI,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.MI
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.MO,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.MO
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.MN,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.MN
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.MS,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.MS
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.MTEXT,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.MTEXT
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.NAV,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.NAV
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.NOBR,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.NOBR
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.NOFRAMES,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.NOFRAMES
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.NOEMBED,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.NOEMBED
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.NOSCRIPT,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.NOSCRIPT
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.OBJECT,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.OBJECT
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.OL,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.OL
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.OPTGROUP,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.OPTGROUP
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.OPTION,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.OPTION
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.P,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.P
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.PARAM,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.PARAM
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.PLAINTEXT,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.PLAINTEXT
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.PRE,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.PRE
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.RB,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.RB
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.RP,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.RP
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.RT,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.RT
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.RTC,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.RTC
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.RUBY,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.RUBY
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.S,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.S
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.SCRIPT,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.SCRIPT
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.SECTION,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.SECTION
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.SELECT,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.SELECT
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.SOURCE,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.SOURCE
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.SMALL,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.SMALL
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.SPAN,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.SPAN
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.STRIKE,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.STRIKE
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.STRONG,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.STRONG
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.STYLE,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.STYLE
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.SUB,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.SUB
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.SUMMARY,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.SUMMARY
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.SUP,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.SUP
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.TABLE,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.TABLE
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.TBODY,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.TBODY
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.TEMPLATE,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.TEMPLATE
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.TEXTAREA,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.TEXTAREA
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.TFOOT,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.TFOOT
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.TD,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.TD
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.TH,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.TH
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.THEAD,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.THEAD
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.TITLE,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.TITLE
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.TR,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.TR
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.TRACK,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.TRACK
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.TT,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.TT
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.U,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.U
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.UL,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.UL
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.SVG,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.SVG
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.VAR,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.VAR
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.WBR,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.WBR
    ],
    [
        $0ddaebefe9b4fbd6$export$7e674a85a2656dce.XMP,
        $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.XMP
    ]
]);
function $0ddaebefe9b4fbd6$export$39db8a1315f68282(tagName) {
    var _a;
    return (_a = $0ddaebefe9b4fbd6$var$TAG_NAME_TO_ID.get(tagName)) !== null && _a !== void 0 ? _a : $0ddaebefe9b4fbd6$export$cb0999a53e0acaed.UNKNOWN;
}
const $0ddaebefe9b4fbd6$var$$ = $0ddaebefe9b4fbd6$export$cb0999a53e0acaed;
const $0ddaebefe9b4fbd6$export$7e5172336f7d2bbb = {
    [$0ddaebefe9b4fbd6$export$fb4028874a74450.HTML]: new Set([
        $0ddaebefe9b4fbd6$var$$.ADDRESS,
        $0ddaebefe9b4fbd6$var$$.APPLET,
        $0ddaebefe9b4fbd6$var$$.AREA,
        $0ddaebefe9b4fbd6$var$$.ARTICLE,
        $0ddaebefe9b4fbd6$var$$.ASIDE,
        $0ddaebefe9b4fbd6$var$$.BASE,
        $0ddaebefe9b4fbd6$var$$.BASEFONT,
        $0ddaebefe9b4fbd6$var$$.BGSOUND,
        $0ddaebefe9b4fbd6$var$$.BLOCKQUOTE,
        $0ddaebefe9b4fbd6$var$$.BODY,
        $0ddaebefe9b4fbd6$var$$.BR,
        $0ddaebefe9b4fbd6$var$$.BUTTON,
        $0ddaebefe9b4fbd6$var$$.CAPTION,
        $0ddaebefe9b4fbd6$var$$.CENTER,
        $0ddaebefe9b4fbd6$var$$.COL,
        $0ddaebefe9b4fbd6$var$$.COLGROUP,
        $0ddaebefe9b4fbd6$var$$.DD,
        $0ddaebefe9b4fbd6$var$$.DETAILS,
        $0ddaebefe9b4fbd6$var$$.DIR,
        $0ddaebefe9b4fbd6$var$$.DIV,
        $0ddaebefe9b4fbd6$var$$.DL,
        $0ddaebefe9b4fbd6$var$$.DT,
        $0ddaebefe9b4fbd6$var$$.EMBED,
        $0ddaebefe9b4fbd6$var$$.FIELDSET,
        $0ddaebefe9b4fbd6$var$$.FIGCAPTION,
        $0ddaebefe9b4fbd6$var$$.FIGURE,
        $0ddaebefe9b4fbd6$var$$.FOOTER,
        $0ddaebefe9b4fbd6$var$$.FORM,
        $0ddaebefe9b4fbd6$var$$.FRAME,
        $0ddaebefe9b4fbd6$var$$.FRAMESET,
        $0ddaebefe9b4fbd6$var$$.H1,
        $0ddaebefe9b4fbd6$var$$.H2,
        $0ddaebefe9b4fbd6$var$$.H3,
        $0ddaebefe9b4fbd6$var$$.H4,
        $0ddaebefe9b4fbd6$var$$.H5,
        $0ddaebefe9b4fbd6$var$$.H6,
        $0ddaebefe9b4fbd6$var$$.HEAD,
        $0ddaebefe9b4fbd6$var$$.HEADER,
        $0ddaebefe9b4fbd6$var$$.HGROUP,
        $0ddaebefe9b4fbd6$var$$.HR,
        $0ddaebefe9b4fbd6$var$$.HTML,
        $0ddaebefe9b4fbd6$var$$.IFRAME,
        $0ddaebefe9b4fbd6$var$$.IMG,
        $0ddaebefe9b4fbd6$var$$.INPUT,
        $0ddaebefe9b4fbd6$var$$.LI,
        $0ddaebefe9b4fbd6$var$$.LINK,
        $0ddaebefe9b4fbd6$var$$.LISTING,
        $0ddaebefe9b4fbd6$var$$.MAIN,
        $0ddaebefe9b4fbd6$var$$.MARQUEE,
        $0ddaebefe9b4fbd6$var$$.MENU,
        $0ddaebefe9b4fbd6$var$$.META,
        $0ddaebefe9b4fbd6$var$$.NAV,
        $0ddaebefe9b4fbd6$var$$.NOEMBED,
        $0ddaebefe9b4fbd6$var$$.NOFRAMES,
        $0ddaebefe9b4fbd6$var$$.NOSCRIPT,
        $0ddaebefe9b4fbd6$var$$.OBJECT,
        $0ddaebefe9b4fbd6$var$$.OL,
        $0ddaebefe9b4fbd6$var$$.P,
        $0ddaebefe9b4fbd6$var$$.PARAM,
        $0ddaebefe9b4fbd6$var$$.PLAINTEXT,
        $0ddaebefe9b4fbd6$var$$.PRE,
        $0ddaebefe9b4fbd6$var$$.SCRIPT,
        $0ddaebefe9b4fbd6$var$$.SECTION,
        $0ddaebefe9b4fbd6$var$$.SELECT,
        $0ddaebefe9b4fbd6$var$$.SOURCE,
        $0ddaebefe9b4fbd6$var$$.STYLE,
        $0ddaebefe9b4fbd6$var$$.SUMMARY,
        $0ddaebefe9b4fbd6$var$$.TABLE,
        $0ddaebefe9b4fbd6$var$$.TBODY,
        $0ddaebefe9b4fbd6$var$$.TD,
        $0ddaebefe9b4fbd6$var$$.TEMPLATE,
        $0ddaebefe9b4fbd6$var$$.TEXTAREA,
        $0ddaebefe9b4fbd6$var$$.TFOOT,
        $0ddaebefe9b4fbd6$var$$.TH,
        $0ddaebefe9b4fbd6$var$$.THEAD,
        $0ddaebefe9b4fbd6$var$$.TITLE,
        $0ddaebefe9b4fbd6$var$$.TR,
        $0ddaebefe9b4fbd6$var$$.TRACK,
        $0ddaebefe9b4fbd6$var$$.UL,
        $0ddaebefe9b4fbd6$var$$.WBR,
        $0ddaebefe9b4fbd6$var$$.XMP
    ]),
    [$0ddaebefe9b4fbd6$export$fb4028874a74450.MATHML]: new Set([
        $0ddaebefe9b4fbd6$var$$.MI,
        $0ddaebefe9b4fbd6$var$$.MO,
        $0ddaebefe9b4fbd6$var$$.MN,
        $0ddaebefe9b4fbd6$var$$.MS,
        $0ddaebefe9b4fbd6$var$$.MTEXT,
        $0ddaebefe9b4fbd6$var$$.ANNOTATION_XML
    ]),
    [$0ddaebefe9b4fbd6$export$fb4028874a74450.SVG]: new Set([
        $0ddaebefe9b4fbd6$var$$.TITLE,
        $0ddaebefe9b4fbd6$var$$.FOREIGN_OBJECT,
        $0ddaebefe9b4fbd6$var$$.DESC
    ]),
    [$0ddaebefe9b4fbd6$export$fb4028874a74450.XLINK]: new Set(),
    [$0ddaebefe9b4fbd6$export$fb4028874a74450.XML]: new Set(),
    [$0ddaebefe9b4fbd6$export$fb4028874a74450.XMLNS]: new Set()
};
function $0ddaebefe9b4fbd6$export$5ed5f14a3d15367(tn) {
    return tn === $0ddaebefe9b4fbd6$var$$.H1 || tn === $0ddaebefe9b4fbd6$var$$.H2 || tn === $0ddaebefe9b4fbd6$var$$.H3 || tn === $0ddaebefe9b4fbd6$var$$.H4 || tn === $0ddaebefe9b4fbd6$var$$.H5 || tn === $0ddaebefe9b4fbd6$var$$.H6;
}
const $0ddaebefe9b4fbd6$var$UNESCAPED_TEXT = new Set([
    $0ddaebefe9b4fbd6$export$7e674a85a2656dce.STYLE,
    $0ddaebefe9b4fbd6$export$7e674a85a2656dce.SCRIPT,
    $0ddaebefe9b4fbd6$export$7e674a85a2656dce.XMP,
    $0ddaebefe9b4fbd6$export$7e674a85a2656dce.IFRAME,
    $0ddaebefe9b4fbd6$export$7e674a85a2656dce.NOEMBED,
    $0ddaebefe9b4fbd6$export$7e674a85a2656dce.NOFRAMES,
    $0ddaebefe9b4fbd6$export$7e674a85a2656dce.PLAINTEXT
]);
function $0ddaebefe9b4fbd6$export$4ce4f8c09f921aed(tn, scriptingEnabled) {
    return $0ddaebefe9b4fbd6$var$UNESCAPED_TEXT.has(tn) || scriptingEnabled && tn === $0ddaebefe9b4fbd6$export$7e674a85a2656dce.NOSCRIPT;
} //# sourceMappingURL=html.js.map


//C1 Unicode control character reference replacements
const $3e8f9cdab96dd92f$var$C1_CONTROLS_REFERENCE_REPLACEMENTS = new Map([
    [
        0x80,
        8364
    ],
    [
        0x82,
        8218
    ],
    [
        0x83,
        402
    ],
    [
        0x84,
        8222
    ],
    [
        0x85,
        8230
    ],
    [
        0x86,
        8224
    ],
    [
        0x87,
        8225
    ],
    [
        0x88,
        710
    ],
    [
        0x89,
        8240
    ],
    [
        0x8a,
        352
    ],
    [
        0x8b,
        8249
    ],
    [
        0x8c,
        338
    ],
    [
        0x8e,
        381
    ],
    [
        0x91,
        8216
    ],
    [
        0x92,
        8217
    ],
    [
        0x93,
        8220
    ],
    [
        0x94,
        8221
    ],
    [
        0x95,
        8226
    ],
    [
        0x96,
        8211
    ],
    [
        0x97,
        8212
    ],
    [
        0x98,
        732
    ],
    [
        0x99,
        8482
    ],
    [
        0x9a,
        353
    ],
    [
        0x9b,
        8250
    ],
    [
        0x9c,
        339
    ],
    [
        0x9e,
        382
    ],
    [
        0x9f,
        376
    ]
]);
//States
var $3e8f9cdab96dd92f$var$State;
(function(State) {
    State[State["DATA"] = 0] = "DATA";
    State[State["RCDATA"] = 1] = "RCDATA";
    State[State["RAWTEXT"] = 2] = "RAWTEXT";
    State[State["SCRIPT_DATA"] = 3] = "SCRIPT_DATA";
    State[State["PLAINTEXT"] = 4] = "PLAINTEXT";
    State[State["TAG_OPEN"] = 5] = "TAG_OPEN";
    State[State["END_TAG_OPEN"] = 6] = "END_TAG_OPEN";
    State[State["TAG_NAME"] = 7] = "TAG_NAME";
    State[State["RCDATA_LESS_THAN_SIGN"] = 8] = "RCDATA_LESS_THAN_SIGN";
    State[State["RCDATA_END_TAG_OPEN"] = 9] = "RCDATA_END_TAG_OPEN";
    State[State["RCDATA_END_TAG_NAME"] = 10] = "RCDATA_END_TAG_NAME";
    State[State["RAWTEXT_LESS_THAN_SIGN"] = 11] = "RAWTEXT_LESS_THAN_SIGN";
    State[State["RAWTEXT_END_TAG_OPEN"] = 12] = "RAWTEXT_END_TAG_OPEN";
    State[State["RAWTEXT_END_TAG_NAME"] = 13] = "RAWTEXT_END_TAG_NAME";
    State[State["SCRIPT_DATA_LESS_THAN_SIGN"] = 14] = "SCRIPT_DATA_LESS_THAN_SIGN";
    State[State["SCRIPT_DATA_END_TAG_OPEN"] = 15] = "SCRIPT_DATA_END_TAG_OPEN";
    State[State["SCRIPT_DATA_END_TAG_NAME"] = 16] = "SCRIPT_DATA_END_TAG_NAME";
    State[State["SCRIPT_DATA_ESCAPE_START"] = 17] = "SCRIPT_DATA_ESCAPE_START";
    State[State["SCRIPT_DATA_ESCAPE_START_DASH"] = 18] = "SCRIPT_DATA_ESCAPE_START_DASH";
    State[State["SCRIPT_DATA_ESCAPED"] = 19] = "SCRIPT_DATA_ESCAPED";
    State[State["SCRIPT_DATA_ESCAPED_DASH"] = 20] = "SCRIPT_DATA_ESCAPED_DASH";
    State[State["SCRIPT_DATA_ESCAPED_DASH_DASH"] = 21] = "SCRIPT_DATA_ESCAPED_DASH_DASH";
    State[State["SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN"] = 22] = "SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN";
    State[State["SCRIPT_DATA_ESCAPED_END_TAG_OPEN"] = 23] = "SCRIPT_DATA_ESCAPED_END_TAG_OPEN";
    State[State["SCRIPT_DATA_ESCAPED_END_TAG_NAME"] = 24] = "SCRIPT_DATA_ESCAPED_END_TAG_NAME";
    State[State["SCRIPT_DATA_DOUBLE_ESCAPE_START"] = 25] = "SCRIPT_DATA_DOUBLE_ESCAPE_START";
    State[State["SCRIPT_DATA_DOUBLE_ESCAPED"] = 26] = "SCRIPT_DATA_DOUBLE_ESCAPED";
    State[State["SCRIPT_DATA_DOUBLE_ESCAPED_DASH"] = 27] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH";
    State[State["SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH"] = 28] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH";
    State[State["SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN"] = 29] = "SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN";
    State[State["SCRIPT_DATA_DOUBLE_ESCAPE_END"] = 30] = "SCRIPT_DATA_DOUBLE_ESCAPE_END";
    State[State["BEFORE_ATTRIBUTE_NAME"] = 31] = "BEFORE_ATTRIBUTE_NAME";
    State[State["ATTRIBUTE_NAME"] = 32] = "ATTRIBUTE_NAME";
    State[State["AFTER_ATTRIBUTE_NAME"] = 33] = "AFTER_ATTRIBUTE_NAME";
    State[State["BEFORE_ATTRIBUTE_VALUE"] = 34] = "BEFORE_ATTRIBUTE_VALUE";
    State[State["ATTRIBUTE_VALUE_DOUBLE_QUOTED"] = 35] = "ATTRIBUTE_VALUE_DOUBLE_QUOTED";
    State[State["ATTRIBUTE_VALUE_SINGLE_QUOTED"] = 36] = "ATTRIBUTE_VALUE_SINGLE_QUOTED";
    State[State["ATTRIBUTE_VALUE_UNQUOTED"] = 37] = "ATTRIBUTE_VALUE_UNQUOTED";
    State[State["AFTER_ATTRIBUTE_VALUE_QUOTED"] = 38] = "AFTER_ATTRIBUTE_VALUE_QUOTED";
    State[State["SELF_CLOSING_START_TAG"] = 39] = "SELF_CLOSING_START_TAG";
    State[State["BOGUS_COMMENT"] = 40] = "BOGUS_COMMENT";
    State[State["MARKUP_DECLARATION_OPEN"] = 41] = "MARKUP_DECLARATION_OPEN";
    State[State["COMMENT_START"] = 42] = "COMMENT_START";
    State[State["COMMENT_START_DASH"] = 43] = "COMMENT_START_DASH";
    State[State["COMMENT"] = 44] = "COMMENT";
    State[State["COMMENT_LESS_THAN_SIGN"] = 45] = "COMMENT_LESS_THAN_SIGN";
    State[State["COMMENT_LESS_THAN_SIGN_BANG"] = 46] = "COMMENT_LESS_THAN_SIGN_BANG";
    State[State["COMMENT_LESS_THAN_SIGN_BANG_DASH"] = 47] = "COMMENT_LESS_THAN_SIGN_BANG_DASH";
    State[State["COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH"] = 48] = "COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH";
    State[State["COMMENT_END_DASH"] = 49] = "COMMENT_END_DASH";
    State[State["COMMENT_END"] = 50] = "COMMENT_END";
    State[State["COMMENT_END_BANG"] = 51] = "COMMENT_END_BANG";
    State[State["DOCTYPE"] = 52] = "DOCTYPE";
    State[State["BEFORE_DOCTYPE_NAME"] = 53] = "BEFORE_DOCTYPE_NAME";
    State[State["DOCTYPE_NAME"] = 54] = "DOCTYPE_NAME";
    State[State["AFTER_DOCTYPE_NAME"] = 55] = "AFTER_DOCTYPE_NAME";
    State[State["AFTER_DOCTYPE_PUBLIC_KEYWORD"] = 56] = "AFTER_DOCTYPE_PUBLIC_KEYWORD";
    State[State["BEFORE_DOCTYPE_PUBLIC_IDENTIFIER"] = 57] = "BEFORE_DOCTYPE_PUBLIC_IDENTIFIER";
    State[State["DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED"] = 58] = "DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED";
    State[State["DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED"] = 59] = "DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED";
    State[State["AFTER_DOCTYPE_PUBLIC_IDENTIFIER"] = 60] = "AFTER_DOCTYPE_PUBLIC_IDENTIFIER";
    State[State["BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS"] = 61] = "BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS";
    State[State["AFTER_DOCTYPE_SYSTEM_KEYWORD"] = 62] = "AFTER_DOCTYPE_SYSTEM_KEYWORD";
    State[State["BEFORE_DOCTYPE_SYSTEM_IDENTIFIER"] = 63] = "BEFORE_DOCTYPE_SYSTEM_IDENTIFIER";
    State[State["DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED"] = 64] = "DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED";
    State[State["DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED"] = 65] = "DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED";
    State[State["AFTER_DOCTYPE_SYSTEM_IDENTIFIER"] = 66] = "AFTER_DOCTYPE_SYSTEM_IDENTIFIER";
    State[State["BOGUS_DOCTYPE"] = 67] = "BOGUS_DOCTYPE";
    State[State["CDATA_SECTION"] = 68] = "CDATA_SECTION";
    State[State["CDATA_SECTION_BRACKET"] = 69] = "CDATA_SECTION_BRACKET";
    State[State["CDATA_SECTION_END"] = 70] = "CDATA_SECTION_END";
    State[State["CHARACTER_REFERENCE"] = 71] = "CHARACTER_REFERENCE";
    State[State["NAMED_CHARACTER_REFERENCE"] = 72] = "NAMED_CHARACTER_REFERENCE";
    State[State["AMBIGUOUS_AMPERSAND"] = 73] = "AMBIGUOUS_AMPERSAND";
    State[State["NUMERIC_CHARACTER_REFERENCE"] = 74] = "NUMERIC_CHARACTER_REFERENCE";
    State[State["HEXADEMICAL_CHARACTER_REFERENCE_START"] = 75] = "HEXADEMICAL_CHARACTER_REFERENCE_START";
    State[State["HEXADEMICAL_CHARACTER_REFERENCE"] = 76] = "HEXADEMICAL_CHARACTER_REFERENCE";
    State[State["DECIMAL_CHARACTER_REFERENCE"] = 77] = "DECIMAL_CHARACTER_REFERENCE";
    State[State["NUMERIC_CHARACTER_REFERENCE_END"] = 78] = "NUMERIC_CHARACTER_REFERENCE_END";
})($3e8f9cdab96dd92f$var$State || ($3e8f9cdab96dd92f$var$State = {}));
const $3e8f9cdab96dd92f$export$d0c9fb8d2ebe5159 = {
    DATA: $3e8f9cdab96dd92f$var$State.DATA,
    RCDATA: $3e8f9cdab96dd92f$var$State.RCDATA,
    RAWTEXT: $3e8f9cdab96dd92f$var$State.RAWTEXT,
    SCRIPT_DATA: $3e8f9cdab96dd92f$var$State.SCRIPT_DATA,
    PLAINTEXT: $3e8f9cdab96dd92f$var$State.PLAINTEXT,
    CDATA_SECTION: $3e8f9cdab96dd92f$var$State.CDATA_SECTION
};
//Utils
//OPTIMIZATION: these utility functions should not be moved out of this module. V8 Crankshaft will not inline
//this functions if they will be situated in another module due to context switch.
//Always perform inlining check before modifying this functions ('node --trace-inlining').
function $3e8f9cdab96dd92f$var$isAsciiDigit(cp) {
    return cp >= (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).DIGIT_0 && cp <= (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).DIGIT_9;
}
function $3e8f9cdab96dd92f$var$isAsciiUpper(cp) {
    return cp >= (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).LATIN_CAPITAL_A && cp <= (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).LATIN_CAPITAL_Z;
}
function $3e8f9cdab96dd92f$var$isAsciiLower(cp) {
    return cp >= (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).LATIN_SMALL_A && cp <= (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).LATIN_SMALL_Z;
}
function $3e8f9cdab96dd92f$var$isAsciiLetter(cp) {
    return $3e8f9cdab96dd92f$var$isAsciiLower(cp) || $3e8f9cdab96dd92f$var$isAsciiUpper(cp);
}
function $3e8f9cdab96dd92f$var$isAsciiAlphaNumeric(cp) {
    return $3e8f9cdab96dd92f$var$isAsciiLetter(cp) || $3e8f9cdab96dd92f$var$isAsciiDigit(cp);
}
function $3e8f9cdab96dd92f$var$isAsciiUpperHexDigit(cp) {
    return cp >= (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).LATIN_CAPITAL_A && cp <= (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).LATIN_CAPITAL_F;
}
function $3e8f9cdab96dd92f$var$isAsciiLowerHexDigit(cp) {
    return cp >= (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).LATIN_SMALL_A && cp <= (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).LATIN_SMALL_F;
}
function $3e8f9cdab96dd92f$var$isAsciiHexDigit(cp) {
    return $3e8f9cdab96dd92f$var$isAsciiDigit(cp) || $3e8f9cdab96dd92f$var$isAsciiUpperHexDigit(cp) || $3e8f9cdab96dd92f$var$isAsciiLowerHexDigit(cp);
}
function $3e8f9cdab96dd92f$var$toAsciiLower(cp) {
    return cp + 32;
}
function $3e8f9cdab96dd92f$var$isWhitespace(cp) {
    return cp === (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).SPACE || cp === (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).LINE_FEED || cp === (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).TABULATION || cp === (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).FORM_FEED;
}
function $3e8f9cdab96dd92f$var$isEntityInAttributeInvalidEnd(nextCp) {
    return nextCp === (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EQUALS_SIGN || $3e8f9cdab96dd92f$var$isAsciiAlphaNumeric(nextCp);
}
function $3e8f9cdab96dd92f$var$isScriptDataDoubleEscapeSequenceEnd(cp) {
    return $3e8f9cdab96dd92f$var$isWhitespace(cp) || cp === (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).SOLIDUS || cp === (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN;
}
class $3e8f9cdab96dd92f$export$55e8b082af4aa63e {
    constructor(options, handler){
        this.options = options;
        this.handler = handler;
        this.paused = false;
        /** Ensures that the parsing loop isn't run multiple times at once. */ this.inLoop = false;
        /**
         * Indicates that the current adjusted node exists, is not an element in the HTML namespace,
         * and that it is not an integration point for either MathML or HTML.
         *
         * @see {@link https://html.spec.whatwg.org/multipage/parsing.html#tree-construction}
         */ this.inForeignNode = false;
        this.lastStartTagName = '';
        this.active = false;
        this.state = $3e8f9cdab96dd92f$var$State.DATA;
        this.returnState = $3e8f9cdab96dd92f$var$State.DATA;
        this.charRefCode = -1;
        this.consumedAfterSnapshot = -1;
        this.currentCharacterToken = null;
        this.currentToken = null;
        this.currentAttr = {
            name: '',
            value: ''
        };
        this.preprocessor = new (0, $1fc009bbc44566a5$export$35db5c8036a15ad1)(handler);
        this.currentLocation = this.getCurrentLocation(-1);
    }
    //Errors
    _err(code) {
        var _a, _b;
        (_b = (_a = this.handler).onParseError) === null || _b === void 0 || _b.call(_a, this.preprocessor.getError(code));
    }
    // NOTE: `offset` may never run across line boundaries.
    getCurrentLocation(offset) {
        if (!this.options.sourceCodeLocationInfo) return null;
        return {
            startLine: this.preprocessor.line,
            startCol: this.preprocessor.col - offset,
            startOffset: this.preprocessor.offset - offset,
            endLine: -1,
            endCol: -1,
            endOffset: -1
        };
    }
    _runParsingLoop() {
        if (this.inLoop) return;
        this.inLoop = true;
        while(this.active && !this.paused){
            this.consumedAfterSnapshot = 0;
            const cp = this._consume();
            if (!this._ensureHibernation()) this._callState(cp);
        }
        this.inLoop = false;
    }
    //API
    pause() {
        this.paused = true;
    }
    resume(writeCallback) {
        if (!this.paused) throw new Error('Parser was already resumed');
        this.paused = false;
        // Necessary for synchronous resume.
        if (this.inLoop) return;
        this._runParsingLoop();
        if (!this.paused) writeCallback === null || writeCallback === void 0 || writeCallback();
    }
    write(chunk, isLastChunk, writeCallback) {
        this.active = true;
        this.preprocessor.write(chunk, isLastChunk);
        this._runParsingLoop();
        if (!this.paused) writeCallback === null || writeCallback === void 0 || writeCallback();
    }
    insertHtmlAtCurrentPos(chunk) {
        this.active = true;
        this.preprocessor.insertHtmlAtCurrentPos(chunk);
        this._runParsingLoop();
    }
    //Hibernation
    _ensureHibernation() {
        if (this.preprocessor.endOfChunkHit) {
            this._unconsume(this.consumedAfterSnapshot);
            this.active = false;
            return true;
        }
        return false;
    }
    //Consumption
    _consume() {
        this.consumedAfterSnapshot++;
        return this.preprocessor.advance();
    }
    _unconsume(count) {
        this.consumedAfterSnapshot -= count;
        this.preprocessor.retreat(count);
    }
    _reconsumeInState(state, cp) {
        this.state = state;
        this._callState(cp);
    }
    _advanceBy(count) {
        this.consumedAfterSnapshot += count;
        for(let i = 0; i < count; i++)this.preprocessor.advance();
    }
    _consumeSequenceIfMatch(pattern, caseSensitive) {
        if (this.preprocessor.startsWith(pattern, caseSensitive)) {
            // We will already have consumed one character before calling this method.
            this._advanceBy(pattern.length - 1);
            return true;
        }
        return false;
    }
    //Token creation
    _createStartTagToken() {
        this.currentToken = {
            type: (0, $c78559b0b620233e$export$f435f793048e7a0f).START_TAG,
            tagName: '',
            tagID: (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).UNKNOWN,
            selfClosing: false,
            ackSelfClosing: false,
            attrs: [],
            location: this.getCurrentLocation(1)
        };
    }
    _createEndTagToken() {
        this.currentToken = {
            type: (0, $c78559b0b620233e$export$f435f793048e7a0f).END_TAG,
            tagName: '',
            tagID: (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).UNKNOWN,
            selfClosing: false,
            ackSelfClosing: false,
            attrs: [],
            location: this.getCurrentLocation(2)
        };
    }
    _createCommentToken(offset) {
        this.currentToken = {
            type: (0, $c78559b0b620233e$export$f435f793048e7a0f).COMMENT,
            data: '',
            location: this.getCurrentLocation(offset)
        };
    }
    _createDoctypeToken(initialName) {
        this.currentToken = {
            type: (0, $c78559b0b620233e$export$f435f793048e7a0f).DOCTYPE,
            name: initialName,
            forceQuirks: false,
            publicId: null,
            systemId: null,
            location: this.currentLocation
        };
    }
    _createCharacterToken(type, chars) {
        this.currentCharacterToken = {
            type: type,
            chars: chars,
            location: this.currentLocation
        };
    }
    //Tag attributes
    _createAttr(attrNameFirstCh) {
        this.currentAttr = {
            name: attrNameFirstCh,
            value: ''
        };
        this.currentLocation = this.getCurrentLocation(0);
    }
    _leaveAttrName() {
        var _a;
        var _b;
        const token = this.currentToken;
        if ((0, $c78559b0b620233e$export$df33bba014b5841e)(token, this.currentAttr.name) === null) {
            token.attrs.push(this.currentAttr);
            if (token.location && this.currentLocation) {
                const attrLocations = (_a = (_b = token.location).attrs) !== null && _a !== void 0 ? _a : _b.attrs = Object.create(null);
                attrLocations[this.currentAttr.name] = this.currentLocation;
                // Set end location
                this._leaveAttrValue();
            }
        } else this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).duplicateAttribute);
    }
    _leaveAttrValue() {
        if (this.currentLocation) {
            this.currentLocation.endLine = this.preprocessor.line;
            this.currentLocation.endCol = this.preprocessor.col;
            this.currentLocation.endOffset = this.preprocessor.offset;
        }
    }
    //Token emission
    prepareToken(ct) {
        this._emitCurrentCharacterToken(ct.location);
        this.currentToken = null;
        if (ct.location) {
            ct.location.endLine = this.preprocessor.line;
            ct.location.endCol = this.preprocessor.col + 1;
            ct.location.endOffset = this.preprocessor.offset + 1;
        }
        this.currentLocation = this.getCurrentLocation(-1);
    }
    emitCurrentTagToken() {
        const ct = this.currentToken;
        this.prepareToken(ct);
        ct.tagID = (0, $0ddaebefe9b4fbd6$export$39db8a1315f68282)(ct.tagName);
        if (ct.type === (0, $c78559b0b620233e$export$f435f793048e7a0f).START_TAG) {
            this.lastStartTagName = ct.tagName;
            this.handler.onStartTag(ct);
        } else {
            if (ct.attrs.length > 0) this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).endTagWithAttributes);
            if (ct.selfClosing) this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).endTagWithTrailingSolidus);
            this.handler.onEndTag(ct);
        }
        this.preprocessor.dropParsedChunk();
    }
    emitCurrentComment(ct) {
        this.prepareToken(ct);
        this.handler.onComment(ct);
        this.preprocessor.dropParsedChunk();
    }
    emitCurrentDoctype(ct) {
        this.prepareToken(ct);
        this.handler.onDoctype(ct);
        this.preprocessor.dropParsedChunk();
    }
    _emitCurrentCharacterToken(nextLocation) {
        if (this.currentCharacterToken) {
            //NOTE: if we have a pending character token, make it's end location equal to the
            //current token's start location.
            if (nextLocation && this.currentCharacterToken.location) {
                this.currentCharacterToken.location.endLine = nextLocation.startLine;
                this.currentCharacterToken.location.endCol = nextLocation.startCol;
                this.currentCharacterToken.location.endOffset = nextLocation.startOffset;
            }
            switch(this.currentCharacterToken.type){
                case (0, $c78559b0b620233e$export$f435f793048e7a0f).CHARACTER:
                    this.handler.onCharacter(this.currentCharacterToken);
                    break;
                case (0, $c78559b0b620233e$export$f435f793048e7a0f).NULL_CHARACTER:
                    this.handler.onNullCharacter(this.currentCharacterToken);
                    break;
                case (0, $c78559b0b620233e$export$f435f793048e7a0f).WHITESPACE_CHARACTER:
                    this.handler.onWhitespaceCharacter(this.currentCharacterToken);
                    break;
            }
            this.currentCharacterToken = null;
        }
    }
    _emitEOFToken() {
        const location = this.getCurrentLocation(0);
        if (location) {
            location.endLine = location.startLine;
            location.endCol = location.startCol;
            location.endOffset = location.startOffset;
        }
        this._emitCurrentCharacterToken(location);
        this.handler.onEof({
            type: (0, $c78559b0b620233e$export$f435f793048e7a0f).EOF,
            location: location
        });
        this.active = false;
    }
    //Characters emission
    //OPTIMIZATION: specification uses only one type of character tokens (one token per character).
    //This causes a huge memory overhead and a lot of unnecessary parser loops. parse5 uses 3 groups of characters.
    //If we have a sequence of characters that belong to the same group, the parser can process it
    //as a single solid character token.
    //So, there are 3 types of character tokens in parse5:
    //1)TokenType.NULL_CHARACTER - \u0000-character sequences (e.g. '\u0000\u0000\u0000')
    //2)TokenType.WHITESPACE_CHARACTER - any whitespace/new-line character sequences (e.g. '\n  \r\t   \f')
    //3)TokenType.CHARACTER - any character sequence which don't belong to groups 1 and 2 (e.g. 'abcdef1234@@#$%^')
    _appendCharToCurrentCharacterToken(type, ch) {
        if (this.currentCharacterToken) {
            if (this.currentCharacterToken.type !== type) {
                this.currentLocation = this.getCurrentLocation(0);
                this._emitCurrentCharacterToken(this.currentLocation);
                this.preprocessor.dropParsedChunk();
            } else {
                this.currentCharacterToken.chars += ch;
                return;
            }
        }
        this._createCharacterToken(type, ch);
    }
    _emitCodePoint(cp) {
        const type = $3e8f9cdab96dd92f$var$isWhitespace(cp) ? (0, $c78559b0b620233e$export$f435f793048e7a0f).WHITESPACE_CHARACTER : cp === (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).NULL ? (0, $c78559b0b620233e$export$f435f793048e7a0f).NULL_CHARACTER : (0, $c78559b0b620233e$export$f435f793048e7a0f).CHARACTER;
        this._appendCharToCurrentCharacterToken(type, String.fromCodePoint(cp));
    }
    //NOTE: used when we emit characters explicitly.
    //This is always for non-whitespace and non-null characters, which allows us to avoid additional checks.
    _emitChars(ch) {
        this._appendCharToCurrentCharacterToken((0, $c78559b0b620233e$export$f435f793048e7a0f).CHARACTER, ch);
    }
    // Character reference helpers
    _matchNamedCharacterReference(cp) {
        let result = null;
        let excess = 0;
        let withoutSemicolon = false;
        for(let i = 0, current = (0, $14589e7572d0431f$exports.htmlDecodeTree)[0]; i >= 0; cp = this._consume()){
            i = (0, $14589e7572d0431f$exports.determineBranch)((0, $14589e7572d0431f$exports.htmlDecodeTree), current, i + 1, cp);
            if (i < 0) break;
            excess += 1;
            current = (0, $14589e7572d0431f$exports.htmlDecodeTree)[i];
            const masked = current & (0, $14589e7572d0431f$exports.BinTrieFlags).VALUE_LENGTH;
            // If the branch is a value, store it and continue
            if (masked) {
                // The mask is the number of bytes of the value, including the current byte.
                const valueLength = (masked >> 14) - 1;
                // Attribute values that aren't terminated properly aren't parsed, and shouldn't lead to a parser error.
                // See the example in https://html.spec.whatwg.org/multipage/parsing.html#named-character-reference-state
                if (cp !== (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).SEMICOLON && this._isCharacterReferenceInAttribute() && $3e8f9cdab96dd92f$var$isEntityInAttributeInvalidEnd(this.preprocessor.peek(1))) {
                    //NOTE: we don't flush all consumed code points here, and instead switch back to the original state after
                    //emitting an ampersand. This is fine, as alphanumeric characters won't be parsed differently in attributes.
                    result = [
                        (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).AMPERSAND
                    ];
                    // Skip over the value.
                    i += valueLength;
                } else {
                    // If this is a surrogate pair, consume the next two bytes.
                    result = valueLength === 0 ? [
                        (0, $14589e7572d0431f$exports.htmlDecodeTree)[i] & ~(0, $14589e7572d0431f$exports.BinTrieFlags).VALUE_LENGTH
                    ] : valueLength === 1 ? [
                        (0, $14589e7572d0431f$exports.htmlDecodeTree)[++i]
                    ] : [
                        (0, $14589e7572d0431f$exports.htmlDecodeTree)[++i],
                        (0, $14589e7572d0431f$exports.htmlDecodeTree)[++i]
                    ];
                    excess = 0;
                    withoutSemicolon = cp !== (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).SEMICOLON;
                }
                if (valueLength === 0) {
                    // If the value is zero-length, we're done.
                    this._consume();
                    break;
                }
            }
        }
        this._unconsume(excess);
        if (withoutSemicolon && !this.preprocessor.endOfChunkHit) this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).missingSemicolonAfterCharacterReference);
        // We want to emit the error above on the code point after the entity.
        // We always consume one code point too many in the loop, and we wait to
        // unconsume it until after the error is emitted.
        this._unconsume(1);
        return result;
    }
    _isCharacterReferenceInAttribute() {
        return this.returnState === $3e8f9cdab96dd92f$var$State.ATTRIBUTE_VALUE_DOUBLE_QUOTED || this.returnState === $3e8f9cdab96dd92f$var$State.ATTRIBUTE_VALUE_SINGLE_QUOTED || this.returnState === $3e8f9cdab96dd92f$var$State.ATTRIBUTE_VALUE_UNQUOTED;
    }
    _flushCodePointConsumedAsCharacterReference(cp) {
        if (this._isCharacterReferenceInAttribute()) this.currentAttr.value += String.fromCodePoint(cp);
        else this._emitCodePoint(cp);
    }
    // Calling states this way turns out to be much faster than any other approach.
    _callState(cp) {
        switch(this.state){
            case $3e8f9cdab96dd92f$var$State.DATA:
                this._stateData(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.RCDATA:
                this._stateRcdata(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.RAWTEXT:
                this._stateRawtext(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.SCRIPT_DATA:
                this._stateScriptData(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.PLAINTEXT:
                this._statePlaintext(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.TAG_OPEN:
                this._stateTagOpen(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.END_TAG_OPEN:
                this._stateEndTagOpen(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.TAG_NAME:
                this._stateTagName(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.RCDATA_LESS_THAN_SIGN:
                this._stateRcdataLessThanSign(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.RCDATA_END_TAG_OPEN:
                this._stateRcdataEndTagOpen(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.RCDATA_END_TAG_NAME:
                this._stateRcdataEndTagName(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.RAWTEXT_LESS_THAN_SIGN:
                this._stateRawtextLessThanSign(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.RAWTEXT_END_TAG_OPEN:
                this._stateRawtextEndTagOpen(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.RAWTEXT_END_TAG_NAME:
                this._stateRawtextEndTagName(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_LESS_THAN_SIGN:
                this._stateScriptDataLessThanSign(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_END_TAG_OPEN:
                this._stateScriptDataEndTagOpen(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_END_TAG_NAME:
                this._stateScriptDataEndTagName(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_ESCAPE_START:
                this._stateScriptDataEscapeStart(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_ESCAPE_START_DASH:
                this._stateScriptDataEscapeStartDash(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_ESCAPED:
                this._stateScriptDataEscaped(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_ESCAPED_DASH:
                this._stateScriptDataEscapedDash(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_ESCAPED_DASH_DASH:
                this._stateScriptDataEscapedDashDash(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN:
                this._stateScriptDataEscapedLessThanSign(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_ESCAPED_END_TAG_OPEN:
                this._stateScriptDataEscapedEndTagOpen(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_ESCAPED_END_TAG_NAME:
                this._stateScriptDataEscapedEndTagName(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_DOUBLE_ESCAPE_START:
                this._stateScriptDataDoubleEscapeStart(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_DOUBLE_ESCAPED:
                this._stateScriptDataDoubleEscaped(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_DOUBLE_ESCAPED_DASH:
                this._stateScriptDataDoubleEscapedDash(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH:
                this._stateScriptDataDoubleEscapedDashDash(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN:
                this._stateScriptDataDoubleEscapedLessThanSign(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_DOUBLE_ESCAPE_END:
                this._stateScriptDataDoubleEscapeEnd(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.BEFORE_ATTRIBUTE_NAME:
                this._stateBeforeAttributeName(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.ATTRIBUTE_NAME:
                this._stateAttributeName(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.AFTER_ATTRIBUTE_NAME:
                this._stateAfterAttributeName(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.BEFORE_ATTRIBUTE_VALUE:
                this._stateBeforeAttributeValue(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.ATTRIBUTE_VALUE_DOUBLE_QUOTED:
                this._stateAttributeValueDoubleQuoted(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.ATTRIBUTE_VALUE_SINGLE_QUOTED:
                this._stateAttributeValueSingleQuoted(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.ATTRIBUTE_VALUE_UNQUOTED:
                this._stateAttributeValueUnquoted(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.AFTER_ATTRIBUTE_VALUE_QUOTED:
                this._stateAfterAttributeValueQuoted(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.SELF_CLOSING_START_TAG:
                this._stateSelfClosingStartTag(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.BOGUS_COMMENT:
                this._stateBogusComment(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.MARKUP_DECLARATION_OPEN:
                this._stateMarkupDeclarationOpen(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.COMMENT_START:
                this._stateCommentStart(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.COMMENT_START_DASH:
                this._stateCommentStartDash(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.COMMENT:
                this._stateComment(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.COMMENT_LESS_THAN_SIGN:
                this._stateCommentLessThanSign(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.COMMENT_LESS_THAN_SIGN_BANG:
                this._stateCommentLessThanSignBang(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.COMMENT_LESS_THAN_SIGN_BANG_DASH:
                this._stateCommentLessThanSignBangDash(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH:
                this._stateCommentLessThanSignBangDashDash(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.COMMENT_END_DASH:
                this._stateCommentEndDash(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.COMMENT_END:
                this._stateCommentEnd(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.COMMENT_END_BANG:
                this._stateCommentEndBang(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.DOCTYPE:
                this._stateDoctype(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.BEFORE_DOCTYPE_NAME:
                this._stateBeforeDoctypeName(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.DOCTYPE_NAME:
                this._stateDoctypeName(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.AFTER_DOCTYPE_NAME:
                this._stateAfterDoctypeName(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.AFTER_DOCTYPE_PUBLIC_KEYWORD:
                this._stateAfterDoctypePublicKeyword(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER:
                this._stateBeforeDoctypePublicIdentifier(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED:
                this._stateDoctypePublicIdentifierDoubleQuoted(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED:
                this._stateDoctypePublicIdentifierSingleQuoted(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.AFTER_DOCTYPE_PUBLIC_IDENTIFIER:
                this._stateAfterDoctypePublicIdentifier(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS:
                this._stateBetweenDoctypePublicAndSystemIdentifiers(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.AFTER_DOCTYPE_SYSTEM_KEYWORD:
                this._stateAfterDoctypeSystemKeyword(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER:
                this._stateBeforeDoctypeSystemIdentifier(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED:
                this._stateDoctypeSystemIdentifierDoubleQuoted(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED:
                this._stateDoctypeSystemIdentifierSingleQuoted(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.AFTER_DOCTYPE_SYSTEM_IDENTIFIER:
                this._stateAfterDoctypeSystemIdentifier(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.BOGUS_DOCTYPE:
                this._stateBogusDoctype(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.CDATA_SECTION:
                this._stateCdataSection(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.CDATA_SECTION_BRACKET:
                this._stateCdataSectionBracket(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.CDATA_SECTION_END:
                this._stateCdataSectionEnd(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.CHARACTER_REFERENCE:
                this._stateCharacterReference(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.NAMED_CHARACTER_REFERENCE:
                this._stateNamedCharacterReference(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.AMBIGUOUS_AMPERSAND:
                this._stateAmbiguousAmpersand(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.NUMERIC_CHARACTER_REFERENCE:
                this._stateNumericCharacterReference(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.HEXADEMICAL_CHARACTER_REFERENCE_START:
                this._stateHexademicalCharacterReferenceStart(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.HEXADEMICAL_CHARACTER_REFERENCE:
                this._stateHexademicalCharacterReference(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.DECIMAL_CHARACTER_REFERENCE:
                this._stateDecimalCharacterReference(cp);
                break;
            case $3e8f9cdab96dd92f$var$State.NUMERIC_CHARACTER_REFERENCE_END:
                this._stateNumericCharacterReferenceEnd(cp);
                break;
            default:
                throw new Error('Unknown state');
        }
    }
    // State machine
    // Data state
    //------------------------------------------------------------------
    _stateData(cp) {
        switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                this.state = $3e8f9cdab96dd92f$var$State.TAG_OPEN;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).AMPERSAND:
                this.returnState = $3e8f9cdab96dd92f$var$State.DATA;
                this.state = $3e8f9cdab96dd92f$var$State.CHARACTER_REFERENCE;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).unexpectedNullCharacter);
                this._emitCodePoint(cp);
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EOF:
                this._emitEOFToken();
                break;
            default:
                this._emitCodePoint(cp);
        }
    }
    //  RCDATA state
    //------------------------------------------------------------------
    _stateRcdata(cp) {
        switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).AMPERSAND:
                this.returnState = $3e8f9cdab96dd92f$var$State.RCDATA;
                this.state = $3e8f9cdab96dd92f$var$State.CHARACTER_REFERENCE;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                this.state = $3e8f9cdab96dd92f$var$State.RCDATA_LESS_THAN_SIGN;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).unexpectedNullCharacter);
                this._emitChars((0, $6c7c9c6fba662a30$export$e8d20e7a50e6c279));
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EOF:
                this._emitEOFToken();
                break;
            default:
                this._emitCodePoint(cp);
        }
    }
    // RAWTEXT state
    //------------------------------------------------------------------
    _stateRawtext(cp) {
        switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                this.state = $3e8f9cdab96dd92f$var$State.RAWTEXT_LESS_THAN_SIGN;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).unexpectedNullCharacter);
                this._emitChars((0, $6c7c9c6fba662a30$export$e8d20e7a50e6c279));
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EOF:
                this._emitEOFToken();
                break;
            default:
                this._emitCodePoint(cp);
        }
    }
    // Script data state
    //------------------------------------------------------------------
    _stateScriptData(cp) {
        switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                this.state = $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_LESS_THAN_SIGN;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).unexpectedNullCharacter);
                this._emitChars((0, $6c7c9c6fba662a30$export$e8d20e7a50e6c279));
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EOF:
                this._emitEOFToken();
                break;
            default:
                this._emitCodePoint(cp);
        }
    }
    // PLAINTEXT state
    //------------------------------------------------------------------
    _statePlaintext(cp) {
        switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).unexpectedNullCharacter);
                this._emitChars((0, $6c7c9c6fba662a30$export$e8d20e7a50e6c279));
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EOF:
                this._emitEOFToken();
                break;
            default:
                this._emitCodePoint(cp);
        }
    }
    // Tag open state
    //------------------------------------------------------------------
    _stateTagOpen(cp) {
        if ($3e8f9cdab96dd92f$var$isAsciiLetter(cp)) {
            this._createStartTagToken();
            this.state = $3e8f9cdab96dd92f$var$State.TAG_NAME;
            this._stateTagName(cp);
        } else switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EXCLAMATION_MARK:
                this.state = $3e8f9cdab96dd92f$var$State.MARKUP_DECLARATION_OPEN;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).SOLIDUS:
                this.state = $3e8f9cdab96dd92f$var$State.END_TAG_OPEN;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).QUESTION_MARK:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).unexpectedQuestionMarkInsteadOfTagName);
                this._createCommentToken(1);
                this.state = $3e8f9cdab96dd92f$var$State.BOGUS_COMMENT;
                this._stateBogusComment(cp);
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).eofBeforeTagName);
                this._emitChars('<');
                this._emitEOFToken();
                break;
            default:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).invalidFirstCharacterOfTagName);
                this._emitChars('<');
                this.state = $3e8f9cdab96dd92f$var$State.DATA;
                this._stateData(cp);
        }
    }
    // End tag open state
    //------------------------------------------------------------------
    _stateEndTagOpen(cp) {
        if ($3e8f9cdab96dd92f$var$isAsciiLetter(cp)) {
            this._createEndTagToken();
            this.state = $3e8f9cdab96dd92f$var$State.TAG_NAME;
            this._stateTagName(cp);
        } else switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).missingEndTagName);
                this.state = $3e8f9cdab96dd92f$var$State.DATA;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).eofBeforeTagName);
                this._emitChars('</');
                this._emitEOFToken();
                break;
            default:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).invalidFirstCharacterOfTagName);
                this._createCommentToken(2);
                this.state = $3e8f9cdab96dd92f$var$State.BOGUS_COMMENT;
                this._stateBogusComment(cp);
        }
    }
    // Tag name state
    //------------------------------------------------------------------
    _stateTagName(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).FORM_FEED:
                this.state = $3e8f9cdab96dd92f$var$State.BEFORE_ATTRIBUTE_NAME;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).SOLIDUS:
                this.state = $3e8f9cdab96dd92f$var$State.SELF_CLOSING_START_TAG;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.state = $3e8f9cdab96dd92f$var$State.DATA;
                this.emitCurrentTagToken();
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).unexpectedNullCharacter);
                token.tagName += (0, $6c7c9c6fba662a30$export$e8d20e7a50e6c279);
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).eofInTag);
                this._emitEOFToken();
                break;
            default:
                token.tagName += String.fromCodePoint($3e8f9cdab96dd92f$var$isAsciiUpper(cp) ? $3e8f9cdab96dd92f$var$toAsciiLower(cp) : cp);
        }
    }
    // RCDATA less-than sign state
    //------------------------------------------------------------------
    _stateRcdataLessThanSign(cp) {
        if (cp === (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).SOLIDUS) this.state = $3e8f9cdab96dd92f$var$State.RCDATA_END_TAG_OPEN;
        else {
            this._emitChars('<');
            this.state = $3e8f9cdab96dd92f$var$State.RCDATA;
            this._stateRcdata(cp);
        }
    }
    // RCDATA end tag open state
    //------------------------------------------------------------------
    _stateRcdataEndTagOpen(cp) {
        if ($3e8f9cdab96dd92f$var$isAsciiLetter(cp)) {
            this.state = $3e8f9cdab96dd92f$var$State.RCDATA_END_TAG_NAME;
            this._stateRcdataEndTagName(cp);
        } else {
            this._emitChars('</');
            this.state = $3e8f9cdab96dd92f$var$State.RCDATA;
            this._stateRcdata(cp);
        }
    }
    handleSpecialEndTag(_cp) {
        if (!this.preprocessor.startsWith(this.lastStartTagName, false)) return !this._ensureHibernation();
        this._createEndTagToken();
        const token = this.currentToken;
        token.tagName = this.lastStartTagName;
        const cp = this.preprocessor.peek(this.lastStartTagName.length);
        switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).FORM_FEED:
                this._advanceBy(this.lastStartTagName.length);
                this.state = $3e8f9cdab96dd92f$var$State.BEFORE_ATTRIBUTE_NAME;
                return false;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).SOLIDUS:
                this._advanceBy(this.lastStartTagName.length);
                this.state = $3e8f9cdab96dd92f$var$State.SELF_CLOSING_START_TAG;
                return false;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._advanceBy(this.lastStartTagName.length);
                this.emitCurrentTagToken();
                this.state = $3e8f9cdab96dd92f$var$State.DATA;
                return false;
            default:
                return !this._ensureHibernation();
        }
    }
    // RCDATA end tag name state
    //------------------------------------------------------------------
    _stateRcdataEndTagName(cp) {
        if (this.handleSpecialEndTag(cp)) {
            this._emitChars('</');
            this.state = $3e8f9cdab96dd92f$var$State.RCDATA;
            this._stateRcdata(cp);
        }
    }
    // RAWTEXT less-than sign state
    //------------------------------------------------------------------
    _stateRawtextLessThanSign(cp) {
        if (cp === (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).SOLIDUS) this.state = $3e8f9cdab96dd92f$var$State.RAWTEXT_END_TAG_OPEN;
        else {
            this._emitChars('<');
            this.state = $3e8f9cdab96dd92f$var$State.RAWTEXT;
            this._stateRawtext(cp);
        }
    }
    // RAWTEXT end tag open state
    //------------------------------------------------------------------
    _stateRawtextEndTagOpen(cp) {
        if ($3e8f9cdab96dd92f$var$isAsciiLetter(cp)) {
            this.state = $3e8f9cdab96dd92f$var$State.RAWTEXT_END_TAG_NAME;
            this._stateRawtextEndTagName(cp);
        } else {
            this._emitChars('</');
            this.state = $3e8f9cdab96dd92f$var$State.RAWTEXT;
            this._stateRawtext(cp);
        }
    }
    // RAWTEXT end tag name state
    //------------------------------------------------------------------
    _stateRawtextEndTagName(cp) {
        if (this.handleSpecialEndTag(cp)) {
            this._emitChars('</');
            this.state = $3e8f9cdab96dd92f$var$State.RAWTEXT;
            this._stateRawtext(cp);
        }
    }
    // Script data less-than sign state
    //------------------------------------------------------------------
    _stateScriptDataLessThanSign(cp) {
        switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).SOLIDUS:
                this.state = $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_END_TAG_OPEN;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EXCLAMATION_MARK:
                this.state = $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_ESCAPE_START;
                this._emitChars('<!');
                break;
            default:
                this._emitChars('<');
                this.state = $3e8f9cdab96dd92f$var$State.SCRIPT_DATA;
                this._stateScriptData(cp);
        }
    }
    // Script data end tag open state
    //------------------------------------------------------------------
    _stateScriptDataEndTagOpen(cp) {
        if ($3e8f9cdab96dd92f$var$isAsciiLetter(cp)) {
            this.state = $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_END_TAG_NAME;
            this._stateScriptDataEndTagName(cp);
        } else {
            this._emitChars('</');
            this.state = $3e8f9cdab96dd92f$var$State.SCRIPT_DATA;
            this._stateScriptData(cp);
        }
    }
    // Script data end tag name state
    //------------------------------------------------------------------
    _stateScriptDataEndTagName(cp) {
        if (this.handleSpecialEndTag(cp)) {
            this._emitChars('</');
            this.state = $3e8f9cdab96dd92f$var$State.SCRIPT_DATA;
            this._stateScriptData(cp);
        }
    }
    // Script data escape start state
    //------------------------------------------------------------------
    _stateScriptDataEscapeStart(cp) {
        if (cp === (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS) {
            this.state = $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_ESCAPE_START_DASH;
            this._emitChars('-');
        } else {
            this.state = $3e8f9cdab96dd92f$var$State.SCRIPT_DATA;
            this._stateScriptData(cp);
        }
    }
    // Script data escape start dash state
    //------------------------------------------------------------------
    _stateScriptDataEscapeStartDash(cp) {
        if (cp === (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS) {
            this.state = $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_ESCAPED_DASH_DASH;
            this._emitChars('-');
        } else {
            this.state = $3e8f9cdab96dd92f$var$State.SCRIPT_DATA;
            this._stateScriptData(cp);
        }
    }
    // Script data escaped state
    //------------------------------------------------------------------
    _stateScriptDataEscaped(cp) {
        switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS:
                this.state = $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_ESCAPED_DASH;
                this._emitChars('-');
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                this.state = $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).unexpectedNullCharacter);
                this._emitChars((0, $6c7c9c6fba662a30$export$e8d20e7a50e6c279));
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).eofInScriptHtmlCommentLikeText);
                this._emitEOFToken();
                break;
            default:
                this._emitCodePoint(cp);
        }
    }
    // Script data escaped dash state
    //------------------------------------------------------------------
    _stateScriptDataEscapedDash(cp) {
        switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS:
                this.state = $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_ESCAPED_DASH_DASH;
                this._emitChars('-');
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                this.state = $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).unexpectedNullCharacter);
                this.state = $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_ESCAPED;
                this._emitChars((0, $6c7c9c6fba662a30$export$e8d20e7a50e6c279));
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).eofInScriptHtmlCommentLikeText);
                this._emitEOFToken();
                break;
            default:
                this.state = $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_ESCAPED;
                this._emitCodePoint(cp);
        }
    }
    // Script data escaped dash dash state
    //------------------------------------------------------------------
    _stateScriptDataEscapedDashDash(cp) {
        switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS:
                this._emitChars('-');
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                this.state = $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.state = $3e8f9cdab96dd92f$var$State.SCRIPT_DATA;
                this._emitChars('>');
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).unexpectedNullCharacter);
                this.state = $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_ESCAPED;
                this._emitChars((0, $6c7c9c6fba662a30$export$e8d20e7a50e6c279));
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).eofInScriptHtmlCommentLikeText);
                this._emitEOFToken();
                break;
            default:
                this.state = $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_ESCAPED;
                this._emitCodePoint(cp);
        }
    }
    // Script data escaped less-than sign state
    //------------------------------------------------------------------
    _stateScriptDataEscapedLessThanSign(cp) {
        if (cp === (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).SOLIDUS) this.state = $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_ESCAPED_END_TAG_OPEN;
        else if ($3e8f9cdab96dd92f$var$isAsciiLetter(cp)) {
            this._emitChars('<');
            this.state = $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_DOUBLE_ESCAPE_START;
            this._stateScriptDataDoubleEscapeStart(cp);
        } else {
            this._emitChars('<');
            this.state = $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_ESCAPED;
            this._stateScriptDataEscaped(cp);
        }
    }
    // Script data escaped end tag open state
    //------------------------------------------------------------------
    _stateScriptDataEscapedEndTagOpen(cp) {
        if ($3e8f9cdab96dd92f$var$isAsciiLetter(cp)) {
            this.state = $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_ESCAPED_END_TAG_NAME;
            this._stateScriptDataEscapedEndTagName(cp);
        } else {
            this._emitChars('</');
            this.state = $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_ESCAPED;
            this._stateScriptDataEscaped(cp);
        }
    }
    // Script data escaped end tag name state
    //------------------------------------------------------------------
    _stateScriptDataEscapedEndTagName(cp) {
        if (this.handleSpecialEndTag(cp)) {
            this._emitChars('</');
            this.state = $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_ESCAPED;
            this._stateScriptDataEscaped(cp);
        }
    }
    // Script data double escape start state
    //------------------------------------------------------------------
    _stateScriptDataDoubleEscapeStart(cp) {
        if (this.preprocessor.startsWith((0, $6c7c9c6fba662a30$export$5abac700f947e2).SCRIPT, false) && $3e8f9cdab96dd92f$var$isScriptDataDoubleEscapeSequenceEnd(this.preprocessor.peek((0, $6c7c9c6fba662a30$export$5abac700f947e2).SCRIPT.length))) {
            this._emitCodePoint(cp);
            for(let i = 0; i < (0, $6c7c9c6fba662a30$export$5abac700f947e2).SCRIPT.length; i++)this._emitCodePoint(this._consume());
            this.state = $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_DOUBLE_ESCAPED;
        } else if (!this._ensureHibernation()) {
            this.state = $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_ESCAPED;
            this._stateScriptDataEscaped(cp);
        }
    }
    // Script data double escaped state
    //------------------------------------------------------------------
    _stateScriptDataDoubleEscaped(cp) {
        switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS:
                this.state = $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_DOUBLE_ESCAPED_DASH;
                this._emitChars('-');
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                this.state = $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN;
                this._emitChars('<');
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).unexpectedNullCharacter);
                this._emitChars((0, $6c7c9c6fba662a30$export$e8d20e7a50e6c279));
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).eofInScriptHtmlCommentLikeText);
                this._emitEOFToken();
                break;
            default:
                this._emitCodePoint(cp);
        }
    }
    // Script data double escaped dash state
    //------------------------------------------------------------------
    _stateScriptDataDoubleEscapedDash(cp) {
        switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS:
                this.state = $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH;
                this._emitChars('-');
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                this.state = $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN;
                this._emitChars('<');
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).unexpectedNullCharacter);
                this.state = $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_DOUBLE_ESCAPED;
                this._emitChars((0, $6c7c9c6fba662a30$export$e8d20e7a50e6c279));
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).eofInScriptHtmlCommentLikeText);
                this._emitEOFToken();
                break;
            default:
                this.state = $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_DOUBLE_ESCAPED;
                this._emitCodePoint(cp);
        }
    }
    // Script data double escaped dash dash state
    //------------------------------------------------------------------
    _stateScriptDataDoubleEscapedDashDash(cp) {
        switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS:
                this._emitChars('-');
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                this.state = $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN;
                this._emitChars('<');
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.state = $3e8f9cdab96dd92f$var$State.SCRIPT_DATA;
                this._emitChars('>');
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).unexpectedNullCharacter);
                this.state = $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_DOUBLE_ESCAPED;
                this._emitChars((0, $6c7c9c6fba662a30$export$e8d20e7a50e6c279));
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).eofInScriptHtmlCommentLikeText);
                this._emitEOFToken();
                break;
            default:
                this.state = $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_DOUBLE_ESCAPED;
                this._emitCodePoint(cp);
        }
    }
    // Script data double escaped less-than sign state
    //------------------------------------------------------------------
    _stateScriptDataDoubleEscapedLessThanSign(cp) {
        if (cp === (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).SOLIDUS) {
            this.state = $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_DOUBLE_ESCAPE_END;
            this._emitChars('/');
        } else {
            this.state = $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_DOUBLE_ESCAPED;
            this._stateScriptDataDoubleEscaped(cp);
        }
    }
    // Script data double escape end state
    //------------------------------------------------------------------
    _stateScriptDataDoubleEscapeEnd(cp) {
        if (this.preprocessor.startsWith((0, $6c7c9c6fba662a30$export$5abac700f947e2).SCRIPT, false) && $3e8f9cdab96dd92f$var$isScriptDataDoubleEscapeSequenceEnd(this.preprocessor.peek((0, $6c7c9c6fba662a30$export$5abac700f947e2).SCRIPT.length))) {
            this._emitCodePoint(cp);
            for(let i = 0; i < (0, $6c7c9c6fba662a30$export$5abac700f947e2).SCRIPT.length; i++)this._emitCodePoint(this._consume());
            this.state = $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_ESCAPED;
        } else if (!this._ensureHibernation()) {
            this.state = $3e8f9cdab96dd92f$var$State.SCRIPT_DATA_DOUBLE_ESCAPED;
            this._stateScriptDataDoubleEscaped(cp);
        }
    }
    // Before attribute name state
    //------------------------------------------------------------------
    _stateBeforeAttributeName(cp) {
        switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).FORM_FEED:
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).SOLIDUS:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EOF:
                this.state = $3e8f9cdab96dd92f$var$State.AFTER_ATTRIBUTE_NAME;
                this._stateAfterAttributeName(cp);
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EQUALS_SIGN:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).unexpectedEqualsSignBeforeAttributeName);
                this._createAttr('=');
                this.state = $3e8f9cdab96dd92f$var$State.ATTRIBUTE_NAME;
                break;
            default:
                this._createAttr('');
                this.state = $3e8f9cdab96dd92f$var$State.ATTRIBUTE_NAME;
                this._stateAttributeName(cp);
        }
    }
    // Attribute name state
    //------------------------------------------------------------------
    _stateAttributeName(cp) {
        switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).FORM_FEED:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).SOLIDUS:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EOF:
                this._leaveAttrName();
                this.state = $3e8f9cdab96dd92f$var$State.AFTER_ATTRIBUTE_NAME;
                this._stateAfterAttributeName(cp);
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EQUALS_SIGN:
                this._leaveAttrName();
                this.state = $3e8f9cdab96dd92f$var$State.BEFORE_ATTRIBUTE_VALUE;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).QUOTATION_MARK:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).APOSTROPHE:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).unexpectedCharacterInAttributeName);
                this.currentAttr.name += String.fromCodePoint(cp);
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).unexpectedNullCharacter);
                this.currentAttr.name += (0, $6c7c9c6fba662a30$export$e8d20e7a50e6c279);
                break;
            default:
                this.currentAttr.name += String.fromCodePoint($3e8f9cdab96dd92f$var$isAsciiUpper(cp) ? $3e8f9cdab96dd92f$var$toAsciiLower(cp) : cp);
        }
    }
    // After attribute name state
    //------------------------------------------------------------------
    _stateAfterAttributeName(cp) {
        switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).FORM_FEED:
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).SOLIDUS:
                this.state = $3e8f9cdab96dd92f$var$State.SELF_CLOSING_START_TAG;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EQUALS_SIGN:
                this.state = $3e8f9cdab96dd92f$var$State.BEFORE_ATTRIBUTE_VALUE;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.state = $3e8f9cdab96dd92f$var$State.DATA;
                this.emitCurrentTagToken();
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).eofInTag);
                this._emitEOFToken();
                break;
            default:
                this._createAttr('');
                this.state = $3e8f9cdab96dd92f$var$State.ATTRIBUTE_NAME;
                this._stateAttributeName(cp);
        }
    }
    // Before attribute value state
    //------------------------------------------------------------------
    _stateBeforeAttributeValue(cp) {
        switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).FORM_FEED:
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).QUOTATION_MARK:
                this.state = $3e8f9cdab96dd92f$var$State.ATTRIBUTE_VALUE_DOUBLE_QUOTED;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).APOSTROPHE:
                this.state = $3e8f9cdab96dd92f$var$State.ATTRIBUTE_VALUE_SINGLE_QUOTED;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).missingAttributeValue);
                this.state = $3e8f9cdab96dd92f$var$State.DATA;
                this.emitCurrentTagToken();
                break;
            default:
                this.state = $3e8f9cdab96dd92f$var$State.ATTRIBUTE_VALUE_UNQUOTED;
                this._stateAttributeValueUnquoted(cp);
        }
    }
    // Attribute value (double-quoted) state
    //------------------------------------------------------------------
    _stateAttributeValueDoubleQuoted(cp) {
        switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).QUOTATION_MARK:
                this.state = $3e8f9cdab96dd92f$var$State.AFTER_ATTRIBUTE_VALUE_QUOTED;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).AMPERSAND:
                this.returnState = $3e8f9cdab96dd92f$var$State.ATTRIBUTE_VALUE_DOUBLE_QUOTED;
                this.state = $3e8f9cdab96dd92f$var$State.CHARACTER_REFERENCE;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).unexpectedNullCharacter);
                this.currentAttr.value += (0, $6c7c9c6fba662a30$export$e8d20e7a50e6c279);
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).eofInTag);
                this._emitEOFToken();
                break;
            default:
                this.currentAttr.value += String.fromCodePoint(cp);
        }
    }
    // Attribute value (single-quoted) state
    //------------------------------------------------------------------
    _stateAttributeValueSingleQuoted(cp) {
        switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).APOSTROPHE:
                this.state = $3e8f9cdab96dd92f$var$State.AFTER_ATTRIBUTE_VALUE_QUOTED;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).AMPERSAND:
                this.returnState = $3e8f9cdab96dd92f$var$State.ATTRIBUTE_VALUE_SINGLE_QUOTED;
                this.state = $3e8f9cdab96dd92f$var$State.CHARACTER_REFERENCE;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).unexpectedNullCharacter);
                this.currentAttr.value += (0, $6c7c9c6fba662a30$export$e8d20e7a50e6c279);
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).eofInTag);
                this._emitEOFToken();
                break;
            default:
                this.currentAttr.value += String.fromCodePoint(cp);
        }
    }
    // Attribute value (unquoted) state
    //------------------------------------------------------------------
    _stateAttributeValueUnquoted(cp) {
        switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).FORM_FEED:
                this._leaveAttrValue();
                this.state = $3e8f9cdab96dd92f$var$State.BEFORE_ATTRIBUTE_NAME;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).AMPERSAND:
                this.returnState = $3e8f9cdab96dd92f$var$State.ATTRIBUTE_VALUE_UNQUOTED;
                this.state = $3e8f9cdab96dd92f$var$State.CHARACTER_REFERENCE;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._leaveAttrValue();
                this.state = $3e8f9cdab96dd92f$var$State.DATA;
                this.emitCurrentTagToken();
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).unexpectedNullCharacter);
                this.currentAttr.value += (0, $6c7c9c6fba662a30$export$e8d20e7a50e6c279);
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).QUOTATION_MARK:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).APOSTROPHE:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EQUALS_SIGN:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).GRAVE_ACCENT:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).unexpectedCharacterInUnquotedAttributeValue);
                this.currentAttr.value += String.fromCodePoint(cp);
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).eofInTag);
                this._emitEOFToken();
                break;
            default:
                this.currentAttr.value += String.fromCodePoint(cp);
        }
    }
    // After attribute value (quoted) state
    //------------------------------------------------------------------
    _stateAfterAttributeValueQuoted(cp) {
        switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).FORM_FEED:
                this._leaveAttrValue();
                this.state = $3e8f9cdab96dd92f$var$State.BEFORE_ATTRIBUTE_NAME;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).SOLIDUS:
                this._leaveAttrValue();
                this.state = $3e8f9cdab96dd92f$var$State.SELF_CLOSING_START_TAG;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._leaveAttrValue();
                this.state = $3e8f9cdab96dd92f$var$State.DATA;
                this.emitCurrentTagToken();
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).eofInTag);
                this._emitEOFToken();
                break;
            default:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).missingWhitespaceBetweenAttributes);
                this.state = $3e8f9cdab96dd92f$var$State.BEFORE_ATTRIBUTE_NAME;
                this._stateBeforeAttributeName(cp);
        }
    }
    // Self-closing start tag state
    //------------------------------------------------------------------
    _stateSelfClosingStartTag(cp) {
        switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                {
                    const token = this.currentToken;
                    token.selfClosing = true;
                    this.state = $3e8f9cdab96dd92f$var$State.DATA;
                    this.emitCurrentTagToken();
                    break;
                }
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).eofInTag);
                this._emitEOFToken();
                break;
            default:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).unexpectedSolidusInTag);
                this.state = $3e8f9cdab96dd92f$var$State.BEFORE_ATTRIBUTE_NAME;
                this._stateBeforeAttributeName(cp);
        }
    }
    // Bogus comment state
    //------------------------------------------------------------------
    _stateBogusComment(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.state = $3e8f9cdab96dd92f$var$State.DATA;
                this.emitCurrentComment(token);
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EOF:
                this.emitCurrentComment(token);
                this._emitEOFToken();
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).unexpectedNullCharacter);
                token.data += (0, $6c7c9c6fba662a30$export$e8d20e7a50e6c279);
                break;
            default:
                token.data += String.fromCodePoint(cp);
        }
    }
    // Markup declaration open state
    //------------------------------------------------------------------
    _stateMarkupDeclarationOpen(cp) {
        if (this._consumeSequenceIfMatch((0, $6c7c9c6fba662a30$export$5abac700f947e2).DASH_DASH, true)) {
            this._createCommentToken((0, $6c7c9c6fba662a30$export$5abac700f947e2).DASH_DASH.length + 1);
            this.state = $3e8f9cdab96dd92f$var$State.COMMENT_START;
        } else if (this._consumeSequenceIfMatch((0, $6c7c9c6fba662a30$export$5abac700f947e2).DOCTYPE, false)) {
            // NOTE: Doctypes tokens are created without fixed offsets. We keep track of the moment a doctype *might* start here.
            this.currentLocation = this.getCurrentLocation((0, $6c7c9c6fba662a30$export$5abac700f947e2).DOCTYPE.length + 1);
            this.state = $3e8f9cdab96dd92f$var$State.DOCTYPE;
        } else if (this._consumeSequenceIfMatch((0, $6c7c9c6fba662a30$export$5abac700f947e2).CDATA_START, true)) {
            if (this.inForeignNode) this.state = $3e8f9cdab96dd92f$var$State.CDATA_SECTION;
            else {
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).cdataInHtmlContent);
                this._createCommentToken((0, $6c7c9c6fba662a30$export$5abac700f947e2).CDATA_START.length + 1);
                this.currentToken.data = '[CDATA[';
                this.state = $3e8f9cdab96dd92f$var$State.BOGUS_COMMENT;
            }
        } else if (!this._ensureHibernation()) {
            this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).incorrectlyOpenedComment);
            this._createCommentToken(2);
            this.state = $3e8f9cdab96dd92f$var$State.BOGUS_COMMENT;
            this._stateBogusComment(cp);
        }
    }
    // Comment start state
    //------------------------------------------------------------------
    _stateCommentStart(cp) {
        switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS:
                this.state = $3e8f9cdab96dd92f$var$State.COMMENT_START_DASH;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                {
                    this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).abruptClosingOfEmptyComment);
                    this.state = $3e8f9cdab96dd92f$var$State.DATA;
                    const token = this.currentToken;
                    this.emitCurrentComment(token);
                    break;
                }
            default:
                this.state = $3e8f9cdab96dd92f$var$State.COMMENT;
                this._stateComment(cp);
        }
    }
    // Comment start dash state
    //------------------------------------------------------------------
    _stateCommentStartDash(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS:
                this.state = $3e8f9cdab96dd92f$var$State.COMMENT_END;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).abruptClosingOfEmptyComment);
                this.state = $3e8f9cdab96dd92f$var$State.DATA;
                this.emitCurrentComment(token);
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).eofInComment);
                this.emitCurrentComment(token);
                this._emitEOFToken();
                break;
            default:
                token.data += '-';
                this.state = $3e8f9cdab96dd92f$var$State.COMMENT;
                this._stateComment(cp);
        }
    }
    // Comment state
    //------------------------------------------------------------------
    _stateComment(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS:
                this.state = $3e8f9cdab96dd92f$var$State.COMMENT_END_DASH;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                token.data += '<';
                this.state = $3e8f9cdab96dd92f$var$State.COMMENT_LESS_THAN_SIGN;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).unexpectedNullCharacter);
                token.data += (0, $6c7c9c6fba662a30$export$e8d20e7a50e6c279);
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).eofInComment);
                this.emitCurrentComment(token);
                this._emitEOFToken();
                break;
            default:
                token.data += String.fromCodePoint(cp);
        }
    }
    // Comment less-than sign state
    //------------------------------------------------------------------
    _stateCommentLessThanSign(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EXCLAMATION_MARK:
                token.data += '!';
                this.state = $3e8f9cdab96dd92f$var$State.COMMENT_LESS_THAN_SIGN_BANG;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).LESS_THAN_SIGN:
                token.data += '<';
                break;
            default:
                this.state = $3e8f9cdab96dd92f$var$State.COMMENT;
                this._stateComment(cp);
        }
    }
    // Comment less-than sign bang state
    //------------------------------------------------------------------
    _stateCommentLessThanSignBang(cp) {
        if (cp === (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS) this.state = $3e8f9cdab96dd92f$var$State.COMMENT_LESS_THAN_SIGN_BANG_DASH;
        else {
            this.state = $3e8f9cdab96dd92f$var$State.COMMENT;
            this._stateComment(cp);
        }
    }
    // Comment less-than sign bang dash state
    //------------------------------------------------------------------
    _stateCommentLessThanSignBangDash(cp) {
        if (cp === (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS) this.state = $3e8f9cdab96dd92f$var$State.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH;
        else {
            this.state = $3e8f9cdab96dd92f$var$State.COMMENT_END_DASH;
            this._stateCommentEndDash(cp);
        }
    }
    // Comment less-than sign bang dash dash state
    //------------------------------------------------------------------
    _stateCommentLessThanSignBangDashDash(cp) {
        if (cp !== (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN && cp !== (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EOF) this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).nestedComment);
        this.state = $3e8f9cdab96dd92f$var$State.COMMENT_END;
        this._stateCommentEnd(cp);
    }
    // Comment end dash state
    //------------------------------------------------------------------
    _stateCommentEndDash(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS:
                this.state = $3e8f9cdab96dd92f$var$State.COMMENT_END;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).eofInComment);
                this.emitCurrentComment(token);
                this._emitEOFToken();
                break;
            default:
                token.data += '-';
                this.state = $3e8f9cdab96dd92f$var$State.COMMENT;
                this._stateComment(cp);
        }
    }
    // Comment end state
    //------------------------------------------------------------------
    _stateCommentEnd(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.state = $3e8f9cdab96dd92f$var$State.DATA;
                this.emitCurrentComment(token);
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EXCLAMATION_MARK:
                this.state = $3e8f9cdab96dd92f$var$State.COMMENT_END_BANG;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS:
                token.data += '-';
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).eofInComment);
                this.emitCurrentComment(token);
                this._emitEOFToken();
                break;
            default:
                token.data += '--';
                this.state = $3e8f9cdab96dd92f$var$State.COMMENT;
                this._stateComment(cp);
        }
    }
    // Comment end bang state
    //------------------------------------------------------------------
    _stateCommentEndBang(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).HYPHEN_MINUS:
                token.data += '--!';
                this.state = $3e8f9cdab96dd92f$var$State.COMMENT_END_DASH;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).incorrectlyClosedComment);
                this.state = $3e8f9cdab96dd92f$var$State.DATA;
                this.emitCurrentComment(token);
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).eofInComment);
                this.emitCurrentComment(token);
                this._emitEOFToken();
                break;
            default:
                token.data += '--!';
                this.state = $3e8f9cdab96dd92f$var$State.COMMENT;
                this._stateComment(cp);
        }
    }
    // DOCTYPE state
    //------------------------------------------------------------------
    _stateDoctype(cp) {
        switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).FORM_FEED:
                this.state = $3e8f9cdab96dd92f$var$State.BEFORE_DOCTYPE_NAME;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.state = $3e8f9cdab96dd92f$var$State.BEFORE_DOCTYPE_NAME;
                this._stateBeforeDoctypeName(cp);
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EOF:
                {
                    this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).eofInDoctype);
                    this._createDoctypeToken(null);
                    const token = this.currentToken;
                    token.forceQuirks = true;
                    this.emitCurrentDoctype(token);
                    this._emitEOFToken();
                    break;
                }
            default:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).missingWhitespaceBeforeDoctypeName);
                this.state = $3e8f9cdab96dd92f$var$State.BEFORE_DOCTYPE_NAME;
                this._stateBeforeDoctypeName(cp);
        }
    }
    // Before DOCTYPE name state
    //------------------------------------------------------------------
    _stateBeforeDoctypeName(cp) {
        if ($3e8f9cdab96dd92f$var$isAsciiUpper(cp)) {
            this._createDoctypeToken(String.fromCharCode($3e8f9cdab96dd92f$var$toAsciiLower(cp)));
            this.state = $3e8f9cdab96dd92f$var$State.DOCTYPE_NAME;
        } else switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).FORM_FEED:
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).unexpectedNullCharacter);
                this._createDoctypeToken((0, $6c7c9c6fba662a30$export$e8d20e7a50e6c279));
                this.state = $3e8f9cdab96dd92f$var$State.DOCTYPE_NAME;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                {
                    this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).missingDoctypeName);
                    this._createDoctypeToken(null);
                    const token = this.currentToken;
                    token.forceQuirks = true;
                    this.emitCurrentDoctype(token);
                    this.state = $3e8f9cdab96dd92f$var$State.DATA;
                    break;
                }
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EOF:
                {
                    this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).eofInDoctype);
                    this._createDoctypeToken(null);
                    const token = this.currentToken;
                    token.forceQuirks = true;
                    this.emitCurrentDoctype(token);
                    this._emitEOFToken();
                    break;
                }
            default:
                this._createDoctypeToken(String.fromCodePoint(cp));
                this.state = $3e8f9cdab96dd92f$var$State.DOCTYPE_NAME;
        }
    }
    // DOCTYPE name state
    //------------------------------------------------------------------
    _stateDoctypeName(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).FORM_FEED:
                this.state = $3e8f9cdab96dd92f$var$State.AFTER_DOCTYPE_NAME;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.state = $3e8f9cdab96dd92f$var$State.DATA;
                this.emitCurrentDoctype(token);
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).unexpectedNullCharacter);
                token.name += (0, $6c7c9c6fba662a30$export$e8d20e7a50e6c279);
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                token.name += String.fromCodePoint($3e8f9cdab96dd92f$var$isAsciiUpper(cp) ? $3e8f9cdab96dd92f$var$toAsciiLower(cp) : cp);
        }
    }
    // After DOCTYPE name state
    //------------------------------------------------------------------
    _stateAfterDoctypeName(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).FORM_FEED:
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.state = $3e8f9cdab96dd92f$var$State.DATA;
                this.emitCurrentDoctype(token);
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                if (this._consumeSequenceIfMatch((0, $6c7c9c6fba662a30$export$5abac700f947e2).PUBLIC, false)) this.state = $3e8f9cdab96dd92f$var$State.AFTER_DOCTYPE_PUBLIC_KEYWORD;
                else if (this._consumeSequenceIfMatch((0, $6c7c9c6fba662a30$export$5abac700f947e2).SYSTEM, false)) this.state = $3e8f9cdab96dd92f$var$State.AFTER_DOCTYPE_SYSTEM_KEYWORD;
                else if (!this._ensureHibernation()) {
                    this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).invalidCharacterSequenceAfterDoctypeName);
                    token.forceQuirks = true;
                    this.state = $3e8f9cdab96dd92f$var$State.BOGUS_DOCTYPE;
                    this._stateBogusDoctype(cp);
                }
        }
    }
    // After DOCTYPE public keyword state
    //------------------------------------------------------------------
    _stateAfterDoctypePublicKeyword(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).FORM_FEED:
                this.state = $3e8f9cdab96dd92f$var$State.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).QUOTATION_MARK:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).missingWhitespaceAfterDoctypePublicKeyword);
                token.publicId = '';
                this.state = $3e8f9cdab96dd92f$var$State.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).APOSTROPHE:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).missingWhitespaceAfterDoctypePublicKeyword);
                token.publicId = '';
                this.state = $3e8f9cdab96dd92f$var$State.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).missingDoctypePublicIdentifier);
                token.forceQuirks = true;
                this.state = $3e8f9cdab96dd92f$var$State.DATA;
                this.emitCurrentDoctype(token);
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).missingQuoteBeforeDoctypePublicIdentifier);
                token.forceQuirks = true;
                this.state = $3e8f9cdab96dd92f$var$State.BOGUS_DOCTYPE;
                this._stateBogusDoctype(cp);
        }
    }
    // Before DOCTYPE public identifier state
    //------------------------------------------------------------------
    _stateBeforeDoctypePublicIdentifier(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).FORM_FEED:
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).QUOTATION_MARK:
                token.publicId = '';
                this.state = $3e8f9cdab96dd92f$var$State.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).APOSTROPHE:
                token.publicId = '';
                this.state = $3e8f9cdab96dd92f$var$State.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).missingDoctypePublicIdentifier);
                token.forceQuirks = true;
                this.state = $3e8f9cdab96dd92f$var$State.DATA;
                this.emitCurrentDoctype(token);
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).missingQuoteBeforeDoctypePublicIdentifier);
                token.forceQuirks = true;
                this.state = $3e8f9cdab96dd92f$var$State.BOGUS_DOCTYPE;
                this._stateBogusDoctype(cp);
        }
    }
    // DOCTYPE public identifier (double-quoted) state
    //------------------------------------------------------------------
    _stateDoctypePublicIdentifierDoubleQuoted(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).QUOTATION_MARK:
                this.state = $3e8f9cdab96dd92f$var$State.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).unexpectedNullCharacter);
                token.publicId += (0, $6c7c9c6fba662a30$export$e8d20e7a50e6c279);
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).abruptDoctypePublicIdentifier);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this.state = $3e8f9cdab96dd92f$var$State.DATA;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                token.publicId += String.fromCodePoint(cp);
        }
    }
    // DOCTYPE public identifier (single-quoted) state
    //------------------------------------------------------------------
    _stateDoctypePublicIdentifierSingleQuoted(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).APOSTROPHE:
                this.state = $3e8f9cdab96dd92f$var$State.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).unexpectedNullCharacter);
                token.publicId += (0, $6c7c9c6fba662a30$export$e8d20e7a50e6c279);
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).abruptDoctypePublicIdentifier);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this.state = $3e8f9cdab96dd92f$var$State.DATA;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                token.publicId += String.fromCodePoint(cp);
        }
    }
    // After DOCTYPE public identifier state
    //------------------------------------------------------------------
    _stateAfterDoctypePublicIdentifier(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).FORM_FEED:
                this.state = $3e8f9cdab96dd92f$var$State.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.state = $3e8f9cdab96dd92f$var$State.DATA;
                this.emitCurrentDoctype(token);
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).QUOTATION_MARK:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers);
                token.systemId = '';
                this.state = $3e8f9cdab96dd92f$var$State.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).APOSTROPHE:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers);
                token.systemId = '';
                this.state = $3e8f9cdab96dd92f$var$State.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).missingQuoteBeforeDoctypeSystemIdentifier);
                token.forceQuirks = true;
                this.state = $3e8f9cdab96dd92f$var$State.BOGUS_DOCTYPE;
                this._stateBogusDoctype(cp);
        }
    }
    // Between DOCTYPE public and system identifiers state
    //------------------------------------------------------------------
    _stateBetweenDoctypePublicAndSystemIdentifiers(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).FORM_FEED:
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.emitCurrentDoctype(token);
                this.state = $3e8f9cdab96dd92f$var$State.DATA;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).QUOTATION_MARK:
                token.systemId = '';
                this.state = $3e8f9cdab96dd92f$var$State.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).APOSTROPHE:
                token.systemId = '';
                this.state = $3e8f9cdab96dd92f$var$State.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).missingQuoteBeforeDoctypeSystemIdentifier);
                token.forceQuirks = true;
                this.state = $3e8f9cdab96dd92f$var$State.BOGUS_DOCTYPE;
                this._stateBogusDoctype(cp);
        }
    }
    // After DOCTYPE system keyword state
    //------------------------------------------------------------------
    _stateAfterDoctypeSystemKeyword(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).FORM_FEED:
                this.state = $3e8f9cdab96dd92f$var$State.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).QUOTATION_MARK:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).missingWhitespaceAfterDoctypeSystemKeyword);
                token.systemId = '';
                this.state = $3e8f9cdab96dd92f$var$State.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).APOSTROPHE:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).missingWhitespaceAfterDoctypeSystemKeyword);
                token.systemId = '';
                this.state = $3e8f9cdab96dd92f$var$State.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).missingDoctypeSystemIdentifier);
                token.forceQuirks = true;
                this.state = $3e8f9cdab96dd92f$var$State.DATA;
                this.emitCurrentDoctype(token);
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).missingQuoteBeforeDoctypeSystemIdentifier);
                token.forceQuirks = true;
                this.state = $3e8f9cdab96dd92f$var$State.BOGUS_DOCTYPE;
                this._stateBogusDoctype(cp);
        }
    }
    // Before DOCTYPE system identifier state
    //------------------------------------------------------------------
    _stateBeforeDoctypeSystemIdentifier(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).FORM_FEED:
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).QUOTATION_MARK:
                token.systemId = '';
                this.state = $3e8f9cdab96dd92f$var$State.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).APOSTROPHE:
                token.systemId = '';
                this.state = $3e8f9cdab96dd92f$var$State.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).missingDoctypeSystemIdentifier);
                token.forceQuirks = true;
                this.state = $3e8f9cdab96dd92f$var$State.DATA;
                this.emitCurrentDoctype(token);
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).missingQuoteBeforeDoctypeSystemIdentifier);
                token.forceQuirks = true;
                this.state = $3e8f9cdab96dd92f$var$State.BOGUS_DOCTYPE;
                this._stateBogusDoctype(cp);
        }
    }
    // DOCTYPE system identifier (double-quoted) state
    //------------------------------------------------------------------
    _stateDoctypeSystemIdentifierDoubleQuoted(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).QUOTATION_MARK:
                this.state = $3e8f9cdab96dd92f$var$State.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).unexpectedNullCharacter);
                token.systemId += (0, $6c7c9c6fba662a30$export$e8d20e7a50e6c279);
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).abruptDoctypeSystemIdentifier);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this.state = $3e8f9cdab96dd92f$var$State.DATA;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                token.systemId += String.fromCodePoint(cp);
        }
    }
    // DOCTYPE system identifier (single-quoted) state
    //------------------------------------------------------------------
    _stateDoctypeSystemIdentifierSingleQuoted(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).APOSTROPHE:
                this.state = $3e8f9cdab96dd92f$var$State.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).unexpectedNullCharacter);
                token.systemId += (0, $6c7c9c6fba662a30$export$e8d20e7a50e6c279);
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).abruptDoctypeSystemIdentifier);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this.state = $3e8f9cdab96dd92f$var$State.DATA;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                token.systemId += String.fromCodePoint(cp);
        }
    }
    // After DOCTYPE system identifier state
    //------------------------------------------------------------------
    _stateAfterDoctypeSystemIdentifier(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).SPACE:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).LINE_FEED:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).TABULATION:
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).FORM_FEED:
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.emitCurrentDoctype(token);
                this.state = $3e8f9cdab96dd92f$var$State.DATA;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).eofInDoctype);
                token.forceQuirks = true;
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).unexpectedCharacterAfterDoctypeSystemIdentifier);
                this.state = $3e8f9cdab96dd92f$var$State.BOGUS_DOCTYPE;
                this._stateBogusDoctype(cp);
        }
    }
    // Bogus DOCTYPE state
    //------------------------------------------------------------------
    _stateBogusDoctype(cp) {
        const token = this.currentToken;
        switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.emitCurrentDoctype(token);
                this.state = $3e8f9cdab96dd92f$var$State.DATA;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).NULL:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).unexpectedNullCharacter);
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EOF:
                this.emitCurrentDoctype(token);
                this._emitEOFToken();
                break;
            default:
        }
    }
    // CDATA section state
    //------------------------------------------------------------------
    _stateCdataSection(cp) {
        switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).RIGHT_SQUARE_BRACKET:
                this.state = $3e8f9cdab96dd92f$var$State.CDATA_SECTION_BRACKET;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).EOF:
                this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).eofInCdata);
                this._emitEOFToken();
                break;
            default:
                this._emitCodePoint(cp);
        }
    }
    // CDATA section bracket state
    //------------------------------------------------------------------
    _stateCdataSectionBracket(cp) {
        if (cp === (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).RIGHT_SQUARE_BRACKET) this.state = $3e8f9cdab96dd92f$var$State.CDATA_SECTION_END;
        else {
            this._emitChars(']');
            this.state = $3e8f9cdab96dd92f$var$State.CDATA_SECTION;
            this._stateCdataSection(cp);
        }
    }
    // CDATA section end state
    //------------------------------------------------------------------
    _stateCdataSectionEnd(cp) {
        switch(cp){
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).GREATER_THAN_SIGN:
                this.state = $3e8f9cdab96dd92f$var$State.DATA;
                break;
            case (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).RIGHT_SQUARE_BRACKET:
                this._emitChars(']');
                break;
            default:
                this._emitChars(']]');
                this.state = $3e8f9cdab96dd92f$var$State.CDATA_SECTION;
                this._stateCdataSection(cp);
        }
    }
    // Character reference state
    //------------------------------------------------------------------
    _stateCharacterReference(cp) {
        if (cp === (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).NUMBER_SIGN) this.state = $3e8f9cdab96dd92f$var$State.NUMERIC_CHARACTER_REFERENCE;
        else if ($3e8f9cdab96dd92f$var$isAsciiAlphaNumeric(cp)) {
            this.state = $3e8f9cdab96dd92f$var$State.NAMED_CHARACTER_REFERENCE;
            this._stateNamedCharacterReference(cp);
        } else {
            this._flushCodePointConsumedAsCharacterReference((0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).AMPERSAND);
            this._reconsumeInState(this.returnState, cp);
        }
    }
    // Named character reference state
    //------------------------------------------------------------------
    _stateNamedCharacterReference(cp) {
        const matchResult = this._matchNamedCharacterReference(cp);
        //NOTE: Matching can be abrupted by hibernation. In that case, match
        //results are no longer valid and we will need to start over.
        if (this._ensureHibernation()) ;
        else if (matchResult) {
            for(let i = 0; i < matchResult.length; i++)this._flushCodePointConsumedAsCharacterReference(matchResult[i]);
            this.state = this.returnState;
        } else {
            this._flushCodePointConsumedAsCharacterReference((0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).AMPERSAND);
            this.state = $3e8f9cdab96dd92f$var$State.AMBIGUOUS_AMPERSAND;
        }
    }
    // Ambiguos ampersand state
    //------------------------------------------------------------------
    _stateAmbiguousAmpersand(cp) {
        if ($3e8f9cdab96dd92f$var$isAsciiAlphaNumeric(cp)) this._flushCodePointConsumedAsCharacterReference(cp);
        else {
            if (cp === (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).SEMICOLON) this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).unknownNamedCharacterReference);
            this._reconsumeInState(this.returnState, cp);
        }
    }
    // Numeric character reference state
    //------------------------------------------------------------------
    _stateNumericCharacterReference(cp) {
        this.charRefCode = 0;
        if (cp === (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).LATIN_SMALL_X || cp === (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).LATIN_CAPITAL_X) this.state = $3e8f9cdab96dd92f$var$State.HEXADEMICAL_CHARACTER_REFERENCE_START;
        else if ($3e8f9cdab96dd92f$var$isAsciiDigit(cp)) {
            this.state = $3e8f9cdab96dd92f$var$State.DECIMAL_CHARACTER_REFERENCE;
            this._stateDecimalCharacterReference(cp);
        } else {
            this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).absenceOfDigitsInNumericCharacterReference);
            this._flushCodePointConsumedAsCharacterReference((0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).AMPERSAND);
            this._flushCodePointConsumedAsCharacterReference((0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).NUMBER_SIGN);
            this._reconsumeInState(this.returnState, cp);
        }
    }
    // Hexademical character reference start state
    //------------------------------------------------------------------
    _stateHexademicalCharacterReferenceStart(cp) {
        if ($3e8f9cdab96dd92f$var$isAsciiHexDigit(cp)) {
            this.state = $3e8f9cdab96dd92f$var$State.HEXADEMICAL_CHARACTER_REFERENCE;
            this._stateHexademicalCharacterReference(cp);
        } else {
            this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).absenceOfDigitsInNumericCharacterReference);
            this._flushCodePointConsumedAsCharacterReference((0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).AMPERSAND);
            this._flushCodePointConsumedAsCharacterReference((0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).NUMBER_SIGN);
            this._unconsume(2);
            this.state = this.returnState;
        }
    }
    // Hexademical character reference state
    //------------------------------------------------------------------
    _stateHexademicalCharacterReference(cp) {
        if ($3e8f9cdab96dd92f$var$isAsciiUpperHexDigit(cp)) this.charRefCode = this.charRefCode * 16 + cp - 0x37;
        else if ($3e8f9cdab96dd92f$var$isAsciiLowerHexDigit(cp)) this.charRefCode = this.charRefCode * 16 + cp - 0x57;
        else if ($3e8f9cdab96dd92f$var$isAsciiDigit(cp)) this.charRefCode = this.charRefCode * 16 + cp - 0x30;
        else if (cp === (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).SEMICOLON) this.state = $3e8f9cdab96dd92f$var$State.NUMERIC_CHARACTER_REFERENCE_END;
        else {
            this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).missingSemicolonAfterCharacterReference);
            this.state = $3e8f9cdab96dd92f$var$State.NUMERIC_CHARACTER_REFERENCE_END;
            this._stateNumericCharacterReferenceEnd(cp);
        }
    }
    // Decimal character reference state
    //------------------------------------------------------------------
    _stateDecimalCharacterReference(cp) {
        if ($3e8f9cdab96dd92f$var$isAsciiDigit(cp)) this.charRefCode = this.charRefCode * 10 + cp - 0x30;
        else if (cp === (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).SEMICOLON) this.state = $3e8f9cdab96dd92f$var$State.NUMERIC_CHARACTER_REFERENCE_END;
        else {
            this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).missingSemicolonAfterCharacterReference);
            this.state = $3e8f9cdab96dd92f$var$State.NUMERIC_CHARACTER_REFERENCE_END;
            this._stateNumericCharacterReferenceEnd(cp);
        }
    }
    // Numeric character reference end state
    //------------------------------------------------------------------
    _stateNumericCharacterReferenceEnd(cp) {
        if (this.charRefCode === (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).NULL) {
            this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).nullCharacterReference);
            this.charRefCode = (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).REPLACEMENT_CHARACTER;
        } else if (this.charRefCode > 1114111) {
            this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).characterReferenceOutsideUnicodeRange);
            this.charRefCode = (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).REPLACEMENT_CHARACTER;
        } else if ((0, $6c7c9c6fba662a30$export$7e678b42035e707f)(this.charRefCode)) {
            this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).surrogateCharacterReference);
            this.charRefCode = (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).REPLACEMENT_CHARACTER;
        } else if ((0, $6c7c9c6fba662a30$export$b3484aaf321bda02)(this.charRefCode)) this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).noncharacterCharacterReference);
        else if ((0, $6c7c9c6fba662a30$export$d6953a6077926e)(this.charRefCode) || this.charRefCode === (0, $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0).CARRIAGE_RETURN) {
            this._err((0, $016d4fdae73ebe61$export$9e0efcb140234d2).controlCharacterReference);
            const replacement = $3e8f9cdab96dd92f$var$C1_CONTROLS_REFERENCE_REPLACEMENTS.get(this.charRefCode);
            if (replacement !== undefined) this.charRefCode = replacement;
        }
        this._flushCodePointConsumedAsCharacterReference(this.charRefCode);
        this._reconsumeInState(this.returnState, cp);
    }
} //# sourceMappingURL=index.js.map



//Element utils
const $bfa58636f76c952b$var$IMPLICIT_END_TAG_REQUIRED = new Set([
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).DD,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).DT,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).LI,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).OPTGROUP,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).OPTION,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).P,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).RB,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).RP,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).RT,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).RTC
]);
const $bfa58636f76c952b$var$IMPLICIT_END_TAG_REQUIRED_THOROUGHLY = new Set([
    ...$bfa58636f76c952b$var$IMPLICIT_END_TAG_REQUIRED,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).CAPTION,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).COLGROUP,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TBODY,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TD,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TFOOT,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TH,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).THEAD,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TR
]);
const $bfa58636f76c952b$var$SCOPING_ELEMENT_NS = new Map([
    [
        (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).APPLET,
        (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML
    ],
    [
        (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).CAPTION,
        (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML
    ],
    [
        (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HTML,
        (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML
    ],
    [
        (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).MARQUEE,
        (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML
    ],
    [
        (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).OBJECT,
        (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML
    ],
    [
        (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TABLE,
        (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML
    ],
    [
        (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TD,
        (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML
    ],
    [
        (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TEMPLATE,
        (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML
    ],
    [
        (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TH,
        (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML
    ],
    [
        (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).ANNOTATION_XML,
        (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).MATHML
    ],
    [
        (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).MI,
        (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).MATHML
    ],
    [
        (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).MN,
        (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).MATHML
    ],
    [
        (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).MO,
        (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).MATHML
    ],
    [
        (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).MS,
        (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).MATHML
    ],
    [
        (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).MTEXT,
        (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).MATHML
    ],
    [
        (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).DESC,
        (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).SVG
    ],
    [
        (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).FOREIGN_OBJECT,
        (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).SVG
    ],
    [
        (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TITLE,
        (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).SVG
    ]
]);
const $bfa58636f76c952b$var$NAMED_HEADERS = [
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).H1,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).H2,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).H3,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).H4,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).H5,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).H6
];
const $bfa58636f76c952b$var$TABLE_ROW_CONTEXT = [
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TR,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TEMPLATE,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HTML
];
const $bfa58636f76c952b$var$TABLE_BODY_CONTEXT = [
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TBODY,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TFOOT,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).THEAD,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TEMPLATE,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HTML
];
const $bfa58636f76c952b$var$TABLE_CONTEXT = [
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TABLE,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TEMPLATE,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HTML
];
const $bfa58636f76c952b$var$TABLE_CELLS = [
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TD,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TH
];
class $bfa58636f76c952b$export$56decf886ed987d6 {
    get currentTmplContentOrNode() {
        return this._isInTemplate() ? this.treeAdapter.getTemplateContent(this.current) : this.current;
    }
    constructor(document, treeAdapter, handler){
        this.treeAdapter = treeAdapter;
        this.handler = handler;
        this.items = [];
        this.tagIDs = [];
        this.stackTop = -1;
        this.tmplCount = 0;
        this.currentTagId = (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).UNKNOWN;
        this.current = document;
    }
    //Index of element
    _indexOf(element) {
        return this.items.lastIndexOf(element, this.stackTop);
    }
    //Update current element
    _isInTemplate() {
        return this.currentTagId === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TEMPLATE && this.treeAdapter.getNamespaceURI(this.current) === (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML;
    }
    _updateCurrentElement() {
        this.current = this.items[this.stackTop];
        this.currentTagId = this.tagIDs[this.stackTop];
    }
    //Mutations
    push(element, tagID) {
        this.stackTop++;
        this.items[this.stackTop] = element;
        this.current = element;
        this.tagIDs[this.stackTop] = tagID;
        this.currentTagId = tagID;
        if (this._isInTemplate()) this.tmplCount++;
        this.handler.onItemPush(element, tagID, true);
    }
    pop() {
        const popped = this.current;
        if (this.tmplCount > 0 && this._isInTemplate()) this.tmplCount--;
        this.stackTop--;
        this._updateCurrentElement();
        this.handler.onItemPop(popped, true);
    }
    replace(oldElement, newElement) {
        const idx = this._indexOf(oldElement);
        this.items[idx] = newElement;
        if (idx === this.stackTop) this.current = newElement;
    }
    insertAfter(referenceElement, newElement, newElementID) {
        const insertionIdx = this._indexOf(referenceElement) + 1;
        this.items.splice(insertionIdx, 0, newElement);
        this.tagIDs.splice(insertionIdx, 0, newElementID);
        this.stackTop++;
        if (insertionIdx === this.stackTop) this._updateCurrentElement();
        this.handler.onItemPush(this.current, this.currentTagId, insertionIdx === this.stackTop);
    }
    popUntilTagNamePopped(tagName) {
        let targetIdx = this.stackTop + 1;
        do targetIdx = this.tagIDs.lastIndexOf(tagName, targetIdx - 1);
        while (targetIdx > 0 && this.treeAdapter.getNamespaceURI(this.items[targetIdx]) !== (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML);
        this.shortenToLength(targetIdx < 0 ? 0 : targetIdx);
    }
    shortenToLength(idx) {
        while(this.stackTop >= idx){
            const popped = this.current;
            if (this.tmplCount > 0 && this._isInTemplate()) this.tmplCount -= 1;
            this.stackTop--;
            this._updateCurrentElement();
            this.handler.onItemPop(popped, this.stackTop < idx);
        }
    }
    popUntilElementPopped(element) {
        const idx = this._indexOf(element);
        this.shortenToLength(idx < 0 ? 0 : idx);
    }
    popUntilPopped(tagNames, targetNS) {
        const idx = this._indexOfTagNames(tagNames, targetNS);
        this.shortenToLength(idx < 0 ? 0 : idx);
    }
    popUntilNumberedHeaderPopped() {
        this.popUntilPopped($bfa58636f76c952b$var$NAMED_HEADERS, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML);
    }
    popUntilTableCellPopped() {
        this.popUntilPopped($bfa58636f76c952b$var$TABLE_CELLS, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML);
    }
    popAllUpToHtmlElement() {
        //NOTE: here we assume that the root <html> element is always first in the open element stack, so
        //we perform this fast stack clean up.
        this.tmplCount = 0;
        this.shortenToLength(1);
    }
    _indexOfTagNames(tagNames, namespace) {
        for(let i = this.stackTop; i >= 0; i--){
            if (tagNames.includes(this.tagIDs[i]) && this.treeAdapter.getNamespaceURI(this.items[i]) === namespace) return i;
        }
        return -1;
    }
    clearBackTo(tagNames, targetNS) {
        const idx = this._indexOfTagNames(tagNames, targetNS);
        this.shortenToLength(idx + 1);
    }
    clearBackToTableContext() {
        this.clearBackTo($bfa58636f76c952b$var$TABLE_CONTEXT, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML);
    }
    clearBackToTableBodyContext() {
        this.clearBackTo($bfa58636f76c952b$var$TABLE_BODY_CONTEXT, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML);
    }
    clearBackToTableRowContext() {
        this.clearBackTo($bfa58636f76c952b$var$TABLE_ROW_CONTEXT, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML);
    }
    remove(element) {
        const idx = this._indexOf(element);
        if (idx >= 0) {
            if (idx === this.stackTop) this.pop();
            else {
                this.items.splice(idx, 1);
                this.tagIDs.splice(idx, 1);
                this.stackTop--;
                this._updateCurrentElement();
                this.handler.onItemPop(element, false);
            }
        }
    }
    //Search
    tryPeekProperlyNestedBodyElement() {
        //Properly nested <body> element (should be second element in stack).
        return this.stackTop >= 1 && this.tagIDs[1] === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BODY ? this.items[1] : null;
    }
    contains(element) {
        return this._indexOf(element) > -1;
    }
    getCommonAncestor(element) {
        const elementIdx = this._indexOf(element) - 1;
        return elementIdx >= 0 ? this.items[elementIdx] : null;
    }
    isRootHtmlElementCurrent() {
        return this.stackTop === 0 && this.tagIDs[0] === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HTML;
    }
    //Element in scope
    hasInScope(tagName) {
        for(let i = this.stackTop; i >= 0; i--){
            const tn = this.tagIDs[i];
            const ns = this.treeAdapter.getNamespaceURI(this.items[i]);
            if (tn === tagName && ns === (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML) return true;
            if ($bfa58636f76c952b$var$SCOPING_ELEMENT_NS.get(tn) === ns) return false;
        }
        return true;
    }
    hasNumberedHeaderInScope() {
        for(let i = this.stackTop; i >= 0; i--){
            const tn = this.tagIDs[i];
            const ns = this.treeAdapter.getNamespaceURI(this.items[i]);
            if ((0, $0ddaebefe9b4fbd6$export$5ed5f14a3d15367)(tn) && ns === (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML) return true;
            if ($bfa58636f76c952b$var$SCOPING_ELEMENT_NS.get(tn) === ns) return false;
        }
        return true;
    }
    hasInListItemScope(tagName) {
        for(let i = this.stackTop; i >= 0; i--){
            const tn = this.tagIDs[i];
            const ns = this.treeAdapter.getNamespaceURI(this.items[i]);
            if (tn === tagName && ns === (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML) return true;
            if ((tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).UL || tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).OL) && ns === (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML || $bfa58636f76c952b$var$SCOPING_ELEMENT_NS.get(tn) === ns) return false;
        }
        return true;
    }
    hasInButtonScope(tagName) {
        for(let i = this.stackTop; i >= 0; i--){
            const tn = this.tagIDs[i];
            const ns = this.treeAdapter.getNamespaceURI(this.items[i]);
            if (tn === tagName && ns === (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML) return true;
            if (tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BUTTON && ns === (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML || $bfa58636f76c952b$var$SCOPING_ELEMENT_NS.get(tn) === ns) return false;
        }
        return true;
    }
    hasInTableScope(tagName) {
        for(let i = this.stackTop; i >= 0; i--){
            const tn = this.tagIDs[i];
            const ns = this.treeAdapter.getNamespaceURI(this.items[i]);
            if (ns !== (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML) continue;
            if (tn === tagName) return true;
            if (tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TABLE || tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TEMPLATE || tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HTML) return false;
        }
        return true;
    }
    hasTableBodyContextInTableScope() {
        for(let i = this.stackTop; i >= 0; i--){
            const tn = this.tagIDs[i];
            const ns = this.treeAdapter.getNamespaceURI(this.items[i]);
            if (ns !== (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML) continue;
            if (tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TBODY || tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).THEAD || tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TFOOT) return true;
            if (tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TABLE || tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HTML) return false;
        }
        return true;
    }
    hasInSelectScope(tagName) {
        for(let i = this.stackTop; i >= 0; i--){
            const tn = this.tagIDs[i];
            const ns = this.treeAdapter.getNamespaceURI(this.items[i]);
            if (ns !== (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML) continue;
            if (tn === tagName) return true;
            if (tn !== (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).OPTION && tn !== (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).OPTGROUP) return false;
        }
        return true;
    }
    //Implied end tags
    generateImpliedEndTags() {
        while($bfa58636f76c952b$var$IMPLICIT_END_TAG_REQUIRED.has(this.currentTagId))this.pop();
    }
    generateImpliedEndTagsThoroughly() {
        while($bfa58636f76c952b$var$IMPLICIT_END_TAG_REQUIRED_THOROUGHLY.has(this.currentTagId))this.pop();
    }
    generateImpliedEndTagsWithExclusion(exclusionId) {
        while(this.currentTagId !== exclusionId && $bfa58636f76c952b$var$IMPLICIT_END_TAG_REQUIRED_THOROUGHLY.has(this.currentTagId))this.pop();
    }
} //# sourceMappingURL=open-element-stack.js.map


//Const
const $a62b4ea8619a62dc$var$NOAH_ARK_CAPACITY = 3;
var $a62b4ea8619a62dc$export$e41c32906b33062a;
(function(EntryType) {
    EntryType[EntryType["Marker"] = 0] = "Marker";
    EntryType[EntryType["Element"] = 1] = "Element";
})($a62b4ea8619a62dc$export$e41c32906b33062a = $a62b4ea8619a62dc$export$e41c32906b33062a || ($a62b4ea8619a62dc$export$e41c32906b33062a = {}));
const $a62b4ea8619a62dc$var$MARKER = {
    type: $a62b4ea8619a62dc$export$e41c32906b33062a.Marker
};
class $a62b4ea8619a62dc$export$20023318d9d5bbce {
    constructor(treeAdapter){
        this.treeAdapter = treeAdapter;
        this.entries = [];
        this.bookmark = null;
    }
    //Noah Ark's condition
    //OPTIMIZATION: at first we try to find possible candidates for exclusion using
    //lightweight heuristics without thorough attributes check.
    _getNoahArkConditionCandidates(newElement, neAttrs) {
        const candidates = [];
        const neAttrsLength = neAttrs.length;
        const neTagName = this.treeAdapter.getTagName(newElement);
        const neNamespaceURI = this.treeAdapter.getNamespaceURI(newElement);
        for(let i = 0; i < this.entries.length; i++){
            const entry = this.entries[i];
            if (entry.type === $a62b4ea8619a62dc$export$e41c32906b33062a.Marker) break;
            const { element: element } = entry;
            if (this.treeAdapter.getTagName(element) === neTagName && this.treeAdapter.getNamespaceURI(element) === neNamespaceURI) {
                const elementAttrs = this.treeAdapter.getAttrList(element);
                if (elementAttrs.length === neAttrsLength) candidates.push({
                    idx: i,
                    attrs: elementAttrs
                });
            }
        }
        return candidates;
    }
    _ensureNoahArkCondition(newElement) {
        if (this.entries.length < $a62b4ea8619a62dc$var$NOAH_ARK_CAPACITY) return;
        const neAttrs = this.treeAdapter.getAttrList(newElement);
        const candidates = this._getNoahArkConditionCandidates(newElement, neAttrs);
        if (candidates.length < $a62b4ea8619a62dc$var$NOAH_ARK_CAPACITY) return;
        //NOTE: build attrs map for the new element, so we can perform fast lookups
        const neAttrsMap = new Map(neAttrs.map((neAttr)=>[
                neAttr.name,
                neAttr.value
            ]));
        let validCandidates = 0;
        //NOTE: remove bottommost candidates, until Noah's Ark condition will not be met
        for(let i = 0; i < candidates.length; i++){
            const candidate = candidates[i];
            // We know that `candidate.attrs.length === neAttrs.length`
            if (candidate.attrs.every((cAttr)=>neAttrsMap.get(cAttr.name) === cAttr.value)) {
                validCandidates += 1;
                if (validCandidates >= $a62b4ea8619a62dc$var$NOAH_ARK_CAPACITY) this.entries.splice(candidate.idx, 1);
            }
        }
    }
    //Mutations
    insertMarker() {
        this.entries.unshift($a62b4ea8619a62dc$var$MARKER);
    }
    pushElement(element, token) {
        this._ensureNoahArkCondition(element);
        this.entries.unshift({
            type: $a62b4ea8619a62dc$export$e41c32906b33062a.Element,
            element: element,
            token: token
        });
    }
    insertElementAfterBookmark(element, token) {
        const bookmarkIdx = this.entries.indexOf(this.bookmark);
        this.entries.splice(bookmarkIdx, 0, {
            type: $a62b4ea8619a62dc$export$e41c32906b33062a.Element,
            element: element,
            token: token
        });
    }
    removeEntry(entry) {
        const entryIndex = this.entries.indexOf(entry);
        if (entryIndex >= 0) this.entries.splice(entryIndex, 1);
    }
    /**
     * Clears the list of formatting elements up to the last marker.
     *
     * @see https://html.spec.whatwg.org/multipage/parsing.html#clear-the-list-of-active-formatting-elements-up-to-the-last-marker
     */ clearToLastMarker() {
        const markerIdx = this.entries.indexOf($a62b4ea8619a62dc$var$MARKER);
        if (markerIdx >= 0) this.entries.splice(0, markerIdx + 1);
        else this.entries.length = 0;
    }
    //Search
    getElementEntryInScopeWithTagName(tagName) {
        const entry = this.entries.find((entry)=>entry.type === $a62b4ea8619a62dc$export$e41c32906b33062a.Marker || this.treeAdapter.getTagName(entry.element) === tagName);
        return entry && entry.type === $a62b4ea8619a62dc$export$e41c32906b33062a.Element ? entry : null;
    }
    getElementEntry(element) {
        return this.entries.find((entry)=>entry.type === $a62b4ea8619a62dc$export$e41c32906b33062a.Element && entry.element === element);
    }
} //# sourceMappingURL=formatting-element-list.js.map



function $d477d1ad14c7d387$var$createTextNode(value) {
    return {
        nodeName: '#text',
        value: value,
        parentNode: null
    };
}
const $d477d1ad14c7d387$export$7ddbba828dfa4796 = {
    //Node construction
    createDocument () {
        return {
            nodeName: '#document',
            mode: (0, $0ddaebefe9b4fbd6$export$a74d46c85337d29a).NO_QUIRKS,
            childNodes: []
        };
    },
    createDocumentFragment () {
        return {
            nodeName: '#document-fragment',
            childNodes: []
        };
    },
    createElement (tagName, namespaceURI, attrs) {
        return {
            nodeName: tagName,
            tagName: tagName,
            attrs: attrs,
            namespaceURI: namespaceURI,
            childNodes: [],
            parentNode: null
        };
    },
    createCommentNode (data) {
        return {
            nodeName: '#comment',
            data: data,
            parentNode: null
        };
    },
    //Tree mutation
    appendChild (parentNode, newNode) {
        parentNode.childNodes.push(newNode);
        newNode.parentNode = parentNode;
    },
    insertBefore (parentNode, newNode, referenceNode) {
        const insertionIdx = parentNode.childNodes.indexOf(referenceNode);
        parentNode.childNodes.splice(insertionIdx, 0, newNode);
        newNode.parentNode = parentNode;
    },
    setTemplateContent (templateElement, contentElement) {
        templateElement.content = contentElement;
    },
    getTemplateContent (templateElement) {
        return templateElement.content;
    },
    setDocumentType (document, name, publicId, systemId) {
        const doctypeNode = document.childNodes.find((node)=>node.nodeName === '#documentType');
        if (doctypeNode) {
            doctypeNode.name = name;
            doctypeNode.publicId = publicId;
            doctypeNode.systemId = systemId;
        } else {
            const node = {
                nodeName: '#documentType',
                name: name,
                publicId: publicId,
                systemId: systemId,
                parentNode: null
            };
            $d477d1ad14c7d387$export$7ddbba828dfa4796.appendChild(document, node);
        }
    },
    setDocumentMode (document, mode) {
        document.mode = mode;
    },
    getDocumentMode (document) {
        return document.mode;
    },
    detachNode (node) {
        if (node.parentNode) {
            const idx = node.parentNode.childNodes.indexOf(node);
            node.parentNode.childNodes.splice(idx, 1);
            node.parentNode = null;
        }
    },
    insertText (parentNode, text) {
        if (parentNode.childNodes.length > 0) {
            const prevNode = parentNode.childNodes[parentNode.childNodes.length - 1];
            if ($d477d1ad14c7d387$export$7ddbba828dfa4796.isTextNode(prevNode)) {
                prevNode.value += text;
                return;
            }
        }
        $d477d1ad14c7d387$export$7ddbba828dfa4796.appendChild(parentNode, $d477d1ad14c7d387$var$createTextNode(text));
    },
    insertTextBefore (parentNode, text, referenceNode) {
        const prevNode = parentNode.childNodes[parentNode.childNodes.indexOf(referenceNode) - 1];
        if (prevNode && $d477d1ad14c7d387$export$7ddbba828dfa4796.isTextNode(prevNode)) prevNode.value += text;
        else $d477d1ad14c7d387$export$7ddbba828dfa4796.insertBefore(parentNode, $d477d1ad14c7d387$var$createTextNode(text), referenceNode);
    },
    adoptAttributes (recipient, attrs) {
        const recipientAttrsMap = new Set(recipient.attrs.map((attr)=>attr.name));
        for(let j = 0; j < attrs.length; j++)if (!recipientAttrsMap.has(attrs[j].name)) recipient.attrs.push(attrs[j]);
    },
    //Tree traversing
    getFirstChild (node) {
        return node.childNodes[0];
    },
    getChildNodes (node) {
        return node.childNodes;
    },
    getParentNode (node) {
        return node.parentNode;
    },
    getAttrList (element) {
        return element.attrs;
    },
    //Node data
    getTagName (element) {
        return element.tagName;
    },
    getNamespaceURI (element) {
        return element.namespaceURI;
    },
    getTextNodeContent (textNode) {
        return textNode.value;
    },
    getCommentNodeContent (commentNode) {
        return commentNode.data;
    },
    getDocumentTypeNodeName (doctypeNode) {
        return doctypeNode.name;
    },
    getDocumentTypeNodePublicId (doctypeNode) {
        return doctypeNode.publicId;
    },
    getDocumentTypeNodeSystemId (doctypeNode) {
        return doctypeNode.systemId;
    },
    //Node types
    isTextNode (node) {
        return node.nodeName === '#text';
    },
    isCommentNode (node) {
        return node.nodeName === '#comment';
    },
    isDocumentTypeNode (node) {
        return node.nodeName === '#documentType';
    },
    isElementNode (node) {
        return Object.prototype.hasOwnProperty.call(node, 'tagName');
    },
    // Source code location
    setNodeSourceCodeLocation (node, location) {
        node.sourceCodeLocation = location;
    },
    getNodeSourceCodeLocation (node) {
        return node.sourceCodeLocation;
    },
    updateNodeSourceCodeLocation (node, endLocation) {
        node.sourceCodeLocation = {
            ...node.sourceCodeLocation,
            ...endLocation
        };
    }
}; //# sourceMappingURL=default.js.map



//Const
const $7824bc91d370139a$var$VALID_DOCTYPE_NAME = 'html';
const $7824bc91d370139a$var$VALID_SYSTEM_ID = 'about:legacy-compat';
const $7824bc91d370139a$var$QUIRKS_MODE_SYSTEM_ID = 'http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd';
const $7824bc91d370139a$var$QUIRKS_MODE_PUBLIC_ID_PREFIXES = [
    '+//silmaril//dtd html pro v0r11 19970101//',
    '-//as//dtd html 3.0 aswedit + extensions//',
    '-//advasoft ltd//dtd html 3.0 aswedit + extensions//',
    '-//ietf//dtd html 2.0 level 1//',
    '-//ietf//dtd html 2.0 level 2//',
    '-//ietf//dtd html 2.0 strict level 1//',
    '-//ietf//dtd html 2.0 strict level 2//',
    '-//ietf//dtd html 2.0 strict//',
    '-//ietf//dtd html 2.0//',
    '-//ietf//dtd html 2.1e//',
    '-//ietf//dtd html 3.0//',
    '-//ietf//dtd html 3.2 final//',
    '-//ietf//dtd html 3.2//',
    '-//ietf//dtd html 3//',
    '-//ietf//dtd html level 0//',
    '-//ietf//dtd html level 1//',
    '-//ietf//dtd html level 2//',
    '-//ietf//dtd html level 3//',
    '-//ietf//dtd html strict level 0//',
    '-//ietf//dtd html strict level 1//',
    '-//ietf//dtd html strict level 2//',
    '-//ietf//dtd html strict level 3//',
    '-//ietf//dtd html strict//',
    '-//ietf//dtd html//',
    '-//metrius//dtd metrius presentational//',
    '-//microsoft//dtd internet explorer 2.0 html strict//',
    '-//microsoft//dtd internet explorer 2.0 html//',
    '-//microsoft//dtd internet explorer 2.0 tables//',
    '-//microsoft//dtd internet explorer 3.0 html strict//',
    '-//microsoft//dtd internet explorer 3.0 html//',
    '-//microsoft//dtd internet explorer 3.0 tables//',
    '-//netscape comm. corp.//dtd html//',
    '-//netscape comm. corp.//dtd strict html//',
    "-//o'reilly and associates//dtd html 2.0//",
    "-//o'reilly and associates//dtd html extended 1.0//",
    "-//o'reilly and associates//dtd html extended relaxed 1.0//",
    '-//sq//dtd html 2.0 hotmetal + extensions//',
    '-//softquad software//dtd hotmetal pro 6.0::19990601::extensions to html 4.0//',
    '-//softquad//dtd hotmetal pro 4.0::19971010::extensions to html 4.0//',
    '-//spyglass//dtd html 2.0 extended//',
    '-//sun microsystems corp.//dtd hotjava html//',
    '-//sun microsystems corp.//dtd hotjava strict html//',
    '-//w3c//dtd html 3 1995-03-24//',
    '-//w3c//dtd html 3.2 draft//',
    '-//w3c//dtd html 3.2 final//',
    '-//w3c//dtd html 3.2//',
    '-//w3c//dtd html 3.2s draft//',
    '-//w3c//dtd html 4.0 frameset//',
    '-//w3c//dtd html 4.0 transitional//',
    '-//w3c//dtd html experimental 19960712//',
    '-//w3c//dtd html experimental 970421//',
    '-//w3c//dtd w3 html//',
    '-//w3o//dtd w3 html 3.0//',
    '-//webtechs//dtd mozilla html 2.0//',
    '-//webtechs//dtd mozilla html//'
];
const $7824bc91d370139a$var$QUIRKS_MODE_NO_SYSTEM_ID_PUBLIC_ID_PREFIXES = [
    ...$7824bc91d370139a$var$QUIRKS_MODE_PUBLIC_ID_PREFIXES,
    '-//w3c//dtd html 4.01 frameset//',
    '-//w3c//dtd html 4.01 transitional//'
];
const $7824bc91d370139a$var$QUIRKS_MODE_PUBLIC_IDS = new Set([
    '-//w3o//dtd w3 html strict 3.0//en//',
    '-/w3c/dtd html 4.0 transitional/en',
    'html'
]);
const $7824bc91d370139a$var$LIMITED_QUIRKS_PUBLIC_ID_PREFIXES = [
    '-//w3c//dtd xhtml 1.0 frameset//',
    '-//w3c//dtd xhtml 1.0 transitional//'
];
const $7824bc91d370139a$var$LIMITED_QUIRKS_WITH_SYSTEM_ID_PUBLIC_ID_PREFIXES = [
    ...$7824bc91d370139a$var$LIMITED_QUIRKS_PUBLIC_ID_PREFIXES,
    '-//w3c//dtd html 4.01 frameset//',
    '-//w3c//dtd html 4.01 transitional//'
];
//Utils
function $7824bc91d370139a$var$hasPrefix(publicId, prefixes) {
    return prefixes.some((prefix)=>publicId.startsWith(prefix));
}
function $7824bc91d370139a$export$ee48152ecc0e3f40(token) {
    return token.name === $7824bc91d370139a$var$VALID_DOCTYPE_NAME && token.publicId === null && (token.systemId === null || token.systemId === $7824bc91d370139a$var$VALID_SYSTEM_ID);
}
function $7824bc91d370139a$export$64782beacef87b30(token) {
    if (token.name !== $7824bc91d370139a$var$VALID_DOCTYPE_NAME) return (0, $0ddaebefe9b4fbd6$export$a74d46c85337d29a).QUIRKS;
    const { systemId: systemId } = token;
    if (systemId && systemId.toLowerCase() === $7824bc91d370139a$var$QUIRKS_MODE_SYSTEM_ID) return (0, $0ddaebefe9b4fbd6$export$a74d46c85337d29a).QUIRKS;
    let { publicId: publicId } = token;
    if (publicId !== null) {
        publicId = publicId.toLowerCase();
        if ($7824bc91d370139a$var$QUIRKS_MODE_PUBLIC_IDS.has(publicId)) return (0, $0ddaebefe9b4fbd6$export$a74d46c85337d29a).QUIRKS;
        let prefixes = systemId === null ? $7824bc91d370139a$var$QUIRKS_MODE_NO_SYSTEM_ID_PUBLIC_ID_PREFIXES : $7824bc91d370139a$var$QUIRKS_MODE_PUBLIC_ID_PREFIXES;
        if ($7824bc91d370139a$var$hasPrefix(publicId, prefixes)) return (0, $0ddaebefe9b4fbd6$export$a74d46c85337d29a).QUIRKS;
        prefixes = systemId === null ? $7824bc91d370139a$var$LIMITED_QUIRKS_PUBLIC_ID_PREFIXES : $7824bc91d370139a$var$LIMITED_QUIRKS_WITH_SYSTEM_ID_PUBLIC_ID_PREFIXES;
        if ($7824bc91d370139a$var$hasPrefix(publicId, prefixes)) return (0, $0ddaebefe9b4fbd6$export$a74d46c85337d29a).LIMITED_QUIRKS;
    }
    return (0, $0ddaebefe9b4fbd6$export$a74d46c85337d29a).NO_QUIRKS;
} //# sourceMappingURL=doctype.js.map



//MIME types
const $96fb900eda529a8a$var$MIME_TYPES = {
    TEXT_HTML: 'text/html',
    APPLICATION_XML: 'application/xhtml+xml'
};
//Attributes
const $96fb900eda529a8a$var$DEFINITION_URL_ATTR = 'definitionurl';
const $96fb900eda529a8a$var$ADJUSTED_DEFINITION_URL_ATTR = 'definitionURL';
const $96fb900eda529a8a$var$SVG_ATTRS_ADJUSTMENT_MAP = new Map([
    'attributeName',
    'attributeType',
    'baseFrequency',
    'baseProfile',
    'calcMode',
    'clipPathUnits',
    'diffuseConstant',
    'edgeMode',
    'filterUnits',
    'glyphRef',
    'gradientTransform',
    'gradientUnits',
    'kernelMatrix',
    'kernelUnitLength',
    'keyPoints',
    'keySplines',
    'keyTimes',
    'lengthAdjust',
    'limitingConeAngle',
    'markerHeight',
    'markerUnits',
    'markerWidth',
    'maskContentUnits',
    'maskUnits',
    'numOctaves',
    'pathLength',
    'patternContentUnits',
    'patternTransform',
    'patternUnits',
    'pointsAtX',
    'pointsAtY',
    'pointsAtZ',
    'preserveAlpha',
    'preserveAspectRatio',
    'primitiveUnits',
    'refX',
    'refY',
    'repeatCount',
    'repeatDur',
    'requiredExtensions',
    'requiredFeatures',
    'specularConstant',
    'specularExponent',
    'spreadMethod',
    'startOffset',
    'stdDeviation',
    'stitchTiles',
    'surfaceScale',
    'systemLanguage',
    'tableValues',
    'targetX',
    'targetY',
    'textLength',
    'viewBox',
    'viewTarget',
    'xChannelSelector',
    'yChannelSelector',
    'zoomAndPan'
].map((attr)=>[
        attr.toLowerCase(),
        attr
    ]));
const $96fb900eda529a8a$var$XML_ATTRS_ADJUSTMENT_MAP = new Map([
    [
        'xlink:actuate',
        {
            prefix: 'xlink',
            name: 'actuate',
            namespace: (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).XLINK
        }
    ],
    [
        'xlink:arcrole',
        {
            prefix: 'xlink',
            name: 'arcrole',
            namespace: (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).XLINK
        }
    ],
    [
        'xlink:href',
        {
            prefix: 'xlink',
            name: 'href',
            namespace: (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).XLINK
        }
    ],
    [
        'xlink:role',
        {
            prefix: 'xlink',
            name: 'role',
            namespace: (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).XLINK
        }
    ],
    [
        'xlink:show',
        {
            prefix: 'xlink',
            name: 'show',
            namespace: (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).XLINK
        }
    ],
    [
        'xlink:title',
        {
            prefix: 'xlink',
            name: 'title',
            namespace: (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).XLINK
        }
    ],
    [
        'xlink:type',
        {
            prefix: 'xlink',
            name: 'type',
            namespace: (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).XLINK
        }
    ],
    [
        'xml:base',
        {
            prefix: 'xml',
            name: 'base',
            namespace: (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).XML
        }
    ],
    [
        'xml:lang',
        {
            prefix: 'xml',
            name: 'lang',
            namespace: (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).XML
        }
    ],
    [
        'xml:space',
        {
            prefix: 'xml',
            name: 'space',
            namespace: (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).XML
        }
    ],
    [
        'xmlns',
        {
            prefix: '',
            name: 'xmlns',
            namespace: (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).XMLNS
        }
    ],
    [
        'xmlns:xlink',
        {
            prefix: 'xmlns',
            name: 'xlink',
            namespace: (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).XMLNS
        }
    ]
]);
const $96fb900eda529a8a$export$86512877756eb1b1 = new Map([
    'altGlyph',
    'altGlyphDef',
    'altGlyphItem',
    'animateColor',
    'animateMotion',
    'animateTransform',
    'clipPath',
    'feBlend',
    'feColorMatrix',
    'feComponentTransfer',
    'feComposite',
    'feConvolveMatrix',
    'feDiffuseLighting',
    'feDisplacementMap',
    'feDistantLight',
    'feFlood',
    'feFuncA',
    'feFuncB',
    'feFuncG',
    'feFuncR',
    'feGaussianBlur',
    'feImage',
    'feMerge',
    'feMergeNode',
    'feMorphology',
    'feOffset',
    'fePointLight',
    'feSpecularLighting',
    'feSpotLight',
    'feTile',
    'feTurbulence',
    'foreignObject',
    'glyphRef',
    'linearGradient',
    'radialGradient',
    'textPath'
].map((tn)=>[
        tn.toLowerCase(),
        tn
    ]));
//Tags that causes exit from foreign content
const $96fb900eda529a8a$var$EXITS_FOREIGN_CONTENT = new Set([
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).B,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BIG,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BLOCKQUOTE,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BODY,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BR,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).CENTER,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).CODE,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).DD,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).DIV,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).DL,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).DT,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).EM,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).EMBED,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).H1,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).H2,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).H3,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).H4,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).H5,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).H6,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HEAD,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HR,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).I,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).IMG,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).LI,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).LISTING,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).MENU,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).META,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).NOBR,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).OL,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).P,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).PRE,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).RUBY,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).S,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).SMALL,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).SPAN,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).STRONG,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).STRIKE,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).SUB,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).SUP,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TABLE,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TT,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).U,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).UL,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).VAR
]);
function $96fb900eda529a8a$export$3435eb4ab4d2ed2d(startTagToken) {
    const tn = startTagToken.tagID;
    const isFontWithAttrs = tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).FONT && startTagToken.attrs.some(({ name: name })=>name === (0, $0ddaebefe9b4fbd6$export$380b7bc9e6cb1918).COLOR || name === (0, $0ddaebefe9b4fbd6$export$380b7bc9e6cb1918).SIZE || name === (0, $0ddaebefe9b4fbd6$export$380b7bc9e6cb1918).FACE);
    return isFontWithAttrs || $96fb900eda529a8a$var$EXITS_FOREIGN_CONTENT.has(tn);
}
function $96fb900eda529a8a$export$c583cc5a9d633feb(token) {
    for(let i = 0; i < token.attrs.length; i++)if (token.attrs[i].name === $96fb900eda529a8a$var$DEFINITION_URL_ATTR) {
        token.attrs[i].name = $96fb900eda529a8a$var$ADJUSTED_DEFINITION_URL_ATTR;
        break;
    }
}
function $96fb900eda529a8a$export$74ce06f755fb8f68(token) {
    for(let i = 0; i < token.attrs.length; i++){
        const adjustedAttrName = $96fb900eda529a8a$var$SVG_ATTRS_ADJUSTMENT_MAP.get(token.attrs[i].name);
        if (adjustedAttrName != null) token.attrs[i].name = adjustedAttrName;
    }
}
function $96fb900eda529a8a$export$a5192af02995cbdc(token) {
    for(let i = 0; i < token.attrs.length; i++){
        const adjustedAttrEntry = $96fb900eda529a8a$var$XML_ATTRS_ADJUSTMENT_MAP.get(token.attrs[i].name);
        if (adjustedAttrEntry) {
            token.attrs[i].prefix = adjustedAttrEntry.prefix;
            token.attrs[i].name = adjustedAttrEntry.name;
            token.attrs[i].namespace = adjustedAttrEntry.namespace;
        }
    }
}
function $96fb900eda529a8a$export$95df78fe2e7f33e3(token) {
    const adjustedTagName = $96fb900eda529a8a$export$86512877756eb1b1.get(token.tagName);
    if (adjustedTagName != null) {
        token.tagName = adjustedTagName;
        token.tagID = (0, $0ddaebefe9b4fbd6$export$39db8a1315f68282)(token.tagName);
    }
}
//Integration points
function $96fb900eda529a8a$var$isMathMLTextIntegrationPoint(tn, ns) {
    return ns === (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).MATHML && (tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).MI || tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).MO || tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).MN || tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).MS || tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).MTEXT);
}
function $96fb900eda529a8a$var$isHtmlIntegrationPoint(tn, ns, attrs) {
    if (ns === (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).MATHML && tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).ANNOTATION_XML) {
        for(let i = 0; i < attrs.length; i++)if (attrs[i].name === (0, $0ddaebefe9b4fbd6$export$380b7bc9e6cb1918).ENCODING) {
            const value = attrs[i].value.toLowerCase();
            return value === $96fb900eda529a8a$var$MIME_TYPES.TEXT_HTML || value === $96fb900eda529a8a$var$MIME_TYPES.APPLICATION_XML;
        }
    }
    return ns === (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).SVG && (tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).FOREIGN_OBJECT || tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).DESC || tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TITLE);
}
function $96fb900eda529a8a$export$6baf3ebfdd620e1(tn, ns, attrs, foreignNS) {
    return (!foreignNS || foreignNS === (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML) && $96fb900eda529a8a$var$isHtmlIntegrationPoint(tn, ns, attrs) || (!foreignNS || foreignNS === (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).MATHML) && $96fb900eda529a8a$var$isMathMLTextIntegrationPoint(tn, ns);
} //# sourceMappingURL=foreign-content.js.map






//Misc constants
const $603fd1ed28de42fc$var$HIDDEN_INPUT_TYPE = 'hidden';
//Adoption agency loops iteration count
const $603fd1ed28de42fc$var$AA_OUTER_LOOP_ITER = 8;
const $603fd1ed28de42fc$var$AA_INNER_LOOP_ITER = 3;
//Insertion modes
var $603fd1ed28de42fc$var$InsertionMode;
(function(InsertionMode) {
    InsertionMode[InsertionMode["INITIAL"] = 0] = "INITIAL";
    InsertionMode[InsertionMode["BEFORE_HTML"] = 1] = "BEFORE_HTML";
    InsertionMode[InsertionMode["BEFORE_HEAD"] = 2] = "BEFORE_HEAD";
    InsertionMode[InsertionMode["IN_HEAD"] = 3] = "IN_HEAD";
    InsertionMode[InsertionMode["IN_HEAD_NO_SCRIPT"] = 4] = "IN_HEAD_NO_SCRIPT";
    InsertionMode[InsertionMode["AFTER_HEAD"] = 5] = "AFTER_HEAD";
    InsertionMode[InsertionMode["IN_BODY"] = 6] = "IN_BODY";
    InsertionMode[InsertionMode["TEXT"] = 7] = "TEXT";
    InsertionMode[InsertionMode["IN_TABLE"] = 8] = "IN_TABLE";
    InsertionMode[InsertionMode["IN_TABLE_TEXT"] = 9] = "IN_TABLE_TEXT";
    InsertionMode[InsertionMode["IN_CAPTION"] = 10] = "IN_CAPTION";
    InsertionMode[InsertionMode["IN_COLUMN_GROUP"] = 11] = "IN_COLUMN_GROUP";
    InsertionMode[InsertionMode["IN_TABLE_BODY"] = 12] = "IN_TABLE_BODY";
    InsertionMode[InsertionMode["IN_ROW"] = 13] = "IN_ROW";
    InsertionMode[InsertionMode["IN_CELL"] = 14] = "IN_CELL";
    InsertionMode[InsertionMode["IN_SELECT"] = 15] = "IN_SELECT";
    InsertionMode[InsertionMode["IN_SELECT_IN_TABLE"] = 16] = "IN_SELECT_IN_TABLE";
    InsertionMode[InsertionMode["IN_TEMPLATE"] = 17] = "IN_TEMPLATE";
    InsertionMode[InsertionMode["AFTER_BODY"] = 18] = "AFTER_BODY";
    InsertionMode[InsertionMode["IN_FRAMESET"] = 19] = "IN_FRAMESET";
    InsertionMode[InsertionMode["AFTER_FRAMESET"] = 20] = "AFTER_FRAMESET";
    InsertionMode[InsertionMode["AFTER_AFTER_BODY"] = 21] = "AFTER_AFTER_BODY";
    InsertionMode[InsertionMode["AFTER_AFTER_FRAMESET"] = 22] = "AFTER_AFTER_FRAMESET";
})($603fd1ed28de42fc$var$InsertionMode || ($603fd1ed28de42fc$var$InsertionMode = {}));
const $603fd1ed28de42fc$var$BASE_LOC = {
    startLine: -1,
    startCol: -1,
    startOffset: -1,
    endLine: -1,
    endCol: -1,
    endOffset: -1
};
const $603fd1ed28de42fc$var$TABLE_STRUCTURE_TAGS = new Set([
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TABLE,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TBODY,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TFOOT,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).THEAD,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TR
]);
const $603fd1ed28de42fc$var$defaultParserOptions = {
    scriptingEnabled: true,
    sourceCodeLocationInfo: false,
    treeAdapter: (0, $d477d1ad14c7d387$export$7ddbba828dfa4796),
    onParseError: null
};
class $603fd1ed28de42fc$export$7acfa6ed01010e37 {
    constructor(options, document, fragmentContext = null, scriptHandler = null){
        this.fragmentContext = fragmentContext;
        this.scriptHandler = scriptHandler;
        this.currentToken = null;
        this.stopped = false;
        this.insertionMode = $603fd1ed28de42fc$var$InsertionMode.INITIAL;
        this.originalInsertionMode = $603fd1ed28de42fc$var$InsertionMode.INITIAL;
        this.headElement = null;
        this.formElement = null;
        /** Indicates that the current node is not an element in the HTML namespace */ this.currentNotInHTML = false;
        /**
         * The template insertion mode stack is maintained from the left.
         * Ie. the topmost element will always have index 0.
         */ this.tmplInsertionModeStack = [];
        this.pendingCharacterTokens = [];
        this.hasNonWhitespacePendingCharacterToken = false;
        this.framesetOk = true;
        this.skipNextNewLine = false;
        this.fosterParentingEnabled = false;
        this.options = {
            ...$603fd1ed28de42fc$var$defaultParserOptions,
            ...options
        };
        this.treeAdapter = this.options.treeAdapter;
        this.onParseError = this.options.onParseError;
        // Always enable location info if we report parse errors.
        if (this.onParseError) this.options.sourceCodeLocationInfo = true;
        this.document = document !== null && document !== void 0 ? document : this.treeAdapter.createDocument();
        this.tokenizer = new (0, $3e8f9cdab96dd92f$export$55e8b082af4aa63e)(this.options, this);
        this.activeFormattingElements = new (0, $a62b4ea8619a62dc$export$20023318d9d5bbce)(this.treeAdapter);
        this.fragmentContextID = fragmentContext ? (0, $0ddaebefe9b4fbd6$export$39db8a1315f68282)(this.treeAdapter.getTagName(fragmentContext)) : (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).UNKNOWN;
        this._setContextModes(fragmentContext !== null && fragmentContext !== void 0 ? fragmentContext : this.document, this.fragmentContextID);
        this.openElements = new (0, $bfa58636f76c952b$export$56decf886ed987d6)(this.document, this.treeAdapter, this);
    }
    // API
    static parse(html, options) {
        const parser = new this(options);
        parser.tokenizer.write(html, true);
        return parser.document;
    }
    static getFragmentParser(fragmentContext, options) {
        const opts = {
            ...$603fd1ed28de42fc$var$defaultParserOptions,
            ...options
        };
        //NOTE: use a <template> element as the fragment context if no context element was provided,
        //so we will parse in a "forgiving" manner
        fragmentContext !== null && fragmentContext !== void 0 ? fragmentContext : fragmentContext = opts.treeAdapter.createElement((0, $0ddaebefe9b4fbd6$export$7e674a85a2656dce).TEMPLATE, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML, []);
        //NOTE: create a fake element which will be used as the `document` for fragment parsing.
        //This is important for jsdom, where a new `document` cannot be created. This led to
        //fragment parsing messing with the main `document`.
        const documentMock = opts.treeAdapter.createElement('documentmock', (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML, []);
        const parser = new this(opts, documentMock, fragmentContext);
        if (parser.fragmentContextID === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TEMPLATE) parser.tmplInsertionModeStack.unshift($603fd1ed28de42fc$var$InsertionMode.IN_TEMPLATE);
        parser._initTokenizerForFragmentParsing();
        parser._insertFakeRootElement();
        parser._resetInsertionMode();
        parser._findFormInFragmentContext();
        return parser;
    }
    getFragment() {
        const rootElement = this.treeAdapter.getFirstChild(this.document);
        const fragment = this.treeAdapter.createDocumentFragment();
        this._adoptNodes(rootElement, fragment);
        return fragment;
    }
    //Errors
    _err(token, code, beforeToken) {
        var _a;
        if (!this.onParseError) return;
        const loc = (_a = token.location) !== null && _a !== void 0 ? _a : $603fd1ed28de42fc$var$BASE_LOC;
        const err = {
            code: code,
            startLine: loc.startLine,
            startCol: loc.startCol,
            startOffset: loc.startOffset,
            endLine: beforeToken ? loc.startLine : loc.endLine,
            endCol: beforeToken ? loc.startCol : loc.endCol,
            endOffset: beforeToken ? loc.startOffset : loc.endOffset
        };
        this.onParseError(err);
    }
    //Stack events
    onItemPush(node, tid, isTop) {
        var _a, _b;
        (_b = (_a = this.treeAdapter).onItemPush) === null || _b === void 0 || _b.call(_a, node);
        if (isTop && this.openElements.stackTop > 0) this._setContextModes(node, tid);
    }
    onItemPop(node, isTop) {
        var _a, _b;
        if (this.options.sourceCodeLocationInfo) this._setEndLocation(node, this.currentToken);
        (_b = (_a = this.treeAdapter).onItemPop) === null || _b === void 0 || _b.call(_a, node, this.openElements.current);
        if (isTop) {
            let current;
            let currentTagId;
            if (this.openElements.stackTop === 0 && this.fragmentContext) {
                current = this.fragmentContext;
                currentTagId = this.fragmentContextID;
            } else ({ current: current, currentTagId: currentTagId } = this.openElements);
            this._setContextModes(current, currentTagId);
        }
    }
    _setContextModes(current, tid) {
        const isHTML = current === this.document || this.treeAdapter.getNamespaceURI(current) === (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML;
        this.currentNotInHTML = !isHTML;
        this.tokenizer.inForeignNode = !isHTML && !this._isIntegrationPoint(tid, current);
    }
    _switchToTextParsing(currentToken, nextTokenizerState) {
        this._insertElement(currentToken, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML);
        this.tokenizer.state = nextTokenizerState;
        this.originalInsertionMode = this.insertionMode;
        this.insertionMode = $603fd1ed28de42fc$var$InsertionMode.TEXT;
    }
    switchToPlaintextParsing() {
        this.insertionMode = $603fd1ed28de42fc$var$InsertionMode.TEXT;
        this.originalInsertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_BODY;
        this.tokenizer.state = (0, $3e8f9cdab96dd92f$export$d0c9fb8d2ebe5159).PLAINTEXT;
    }
    //Fragment parsing
    _getAdjustedCurrentElement() {
        return this.openElements.stackTop === 0 && this.fragmentContext ? this.fragmentContext : this.openElements.current;
    }
    _findFormInFragmentContext() {
        let node = this.fragmentContext;
        while(node){
            if (this.treeAdapter.getTagName(node) === (0, $0ddaebefe9b4fbd6$export$7e674a85a2656dce).FORM) {
                this.formElement = node;
                break;
            }
            node = this.treeAdapter.getParentNode(node);
        }
    }
    _initTokenizerForFragmentParsing() {
        if (!this.fragmentContext || this.treeAdapter.getNamespaceURI(this.fragmentContext) !== (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML) return;
        switch(this.fragmentContextID){
            case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TITLE:
            case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TEXTAREA:
                this.tokenizer.state = (0, $3e8f9cdab96dd92f$export$d0c9fb8d2ebe5159).RCDATA;
                break;
            case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).STYLE:
            case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).XMP:
            case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).IFRAME:
            case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).NOEMBED:
            case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).NOFRAMES:
            case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).NOSCRIPT:
                this.tokenizer.state = (0, $3e8f9cdab96dd92f$export$d0c9fb8d2ebe5159).RAWTEXT;
                break;
            case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).SCRIPT:
                this.tokenizer.state = (0, $3e8f9cdab96dd92f$export$d0c9fb8d2ebe5159).SCRIPT_DATA;
                break;
            case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).PLAINTEXT:
                this.tokenizer.state = (0, $3e8f9cdab96dd92f$export$d0c9fb8d2ebe5159).PLAINTEXT;
                break;
            default:
        }
    }
    //Tree mutation
    _setDocumentType(token) {
        const name = token.name || '';
        const publicId = token.publicId || '';
        const systemId = token.systemId || '';
        this.treeAdapter.setDocumentType(this.document, name, publicId, systemId);
        if (token.location) {
            const documentChildren = this.treeAdapter.getChildNodes(this.document);
            const docTypeNode = documentChildren.find((node)=>this.treeAdapter.isDocumentTypeNode(node));
            if (docTypeNode) this.treeAdapter.setNodeSourceCodeLocation(docTypeNode, token.location);
        }
    }
    _attachElementToTree(element, location) {
        if (this.options.sourceCodeLocationInfo) {
            const loc = location && {
                ...location,
                startTag: location
            };
            this.treeAdapter.setNodeSourceCodeLocation(element, loc);
        }
        if (this._shouldFosterParentOnInsertion()) this._fosterParentElement(element);
        else {
            const parent = this.openElements.currentTmplContentOrNode;
            this.treeAdapter.appendChild(parent, element);
        }
    }
    _appendElement(token, namespaceURI) {
        const element = this.treeAdapter.createElement(token.tagName, namespaceURI, token.attrs);
        this._attachElementToTree(element, token.location);
    }
    _insertElement(token, namespaceURI) {
        const element = this.treeAdapter.createElement(token.tagName, namespaceURI, token.attrs);
        this._attachElementToTree(element, token.location);
        this.openElements.push(element, token.tagID);
    }
    _insertFakeElement(tagName, tagID) {
        const element = this.treeAdapter.createElement(tagName, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML, []);
        this._attachElementToTree(element, null);
        this.openElements.push(element, tagID);
    }
    _insertTemplate(token) {
        const tmpl = this.treeAdapter.createElement(token.tagName, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML, token.attrs);
        const content = this.treeAdapter.createDocumentFragment();
        this.treeAdapter.setTemplateContent(tmpl, content);
        this._attachElementToTree(tmpl, token.location);
        this.openElements.push(tmpl, token.tagID);
        if (this.options.sourceCodeLocationInfo) this.treeAdapter.setNodeSourceCodeLocation(content, null);
    }
    _insertFakeRootElement() {
        const element = this.treeAdapter.createElement((0, $0ddaebefe9b4fbd6$export$7e674a85a2656dce).HTML, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML, []);
        if (this.options.sourceCodeLocationInfo) this.treeAdapter.setNodeSourceCodeLocation(element, null);
        this.treeAdapter.appendChild(this.openElements.current, element);
        this.openElements.push(element, (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HTML);
    }
    _appendCommentNode(token, parent) {
        const commentNode = this.treeAdapter.createCommentNode(token.data);
        this.treeAdapter.appendChild(parent, commentNode);
        if (this.options.sourceCodeLocationInfo) this.treeAdapter.setNodeSourceCodeLocation(commentNode, token.location);
    }
    _insertCharacters(token) {
        let parent;
        let beforeElement;
        if (this._shouldFosterParentOnInsertion()) {
            ({ parent: parent, beforeElement: beforeElement } = this._findFosterParentingLocation());
            if (beforeElement) this.treeAdapter.insertTextBefore(parent, token.chars, beforeElement);
            else this.treeAdapter.insertText(parent, token.chars);
        } else {
            parent = this.openElements.currentTmplContentOrNode;
            this.treeAdapter.insertText(parent, token.chars);
        }
        if (!token.location) return;
        const siblings = this.treeAdapter.getChildNodes(parent);
        const textNodeIdx = beforeElement ? siblings.lastIndexOf(beforeElement) : siblings.length;
        const textNode = siblings[textNodeIdx - 1];
        //NOTE: if we have a location assigned by another token, then just update the end position
        const tnLoc = this.treeAdapter.getNodeSourceCodeLocation(textNode);
        if (tnLoc) {
            const { endLine: endLine, endCol: endCol, endOffset: endOffset } = token.location;
            this.treeAdapter.updateNodeSourceCodeLocation(textNode, {
                endLine: endLine,
                endCol: endCol,
                endOffset: endOffset
            });
        } else if (this.options.sourceCodeLocationInfo) this.treeAdapter.setNodeSourceCodeLocation(textNode, token.location);
    }
    _adoptNodes(donor, recipient) {
        for(let child = this.treeAdapter.getFirstChild(donor); child; child = this.treeAdapter.getFirstChild(donor)){
            this.treeAdapter.detachNode(child);
            this.treeAdapter.appendChild(recipient, child);
        }
    }
    _setEndLocation(element, closingToken) {
        if (this.treeAdapter.getNodeSourceCodeLocation(element) && closingToken.location) {
            const ctLoc = closingToken.location;
            const tn = this.treeAdapter.getTagName(element);
            const endLoc = // NOTE: For cases like <p> <p> </p> - First 'p' closes without a closing
            // tag and for cases like <td> <p> </td> - 'p' closes without a closing tag.
            closingToken.type === (0, $c78559b0b620233e$export$f435f793048e7a0f).END_TAG && tn === closingToken.tagName ? {
                endTag: {
                    ...ctLoc
                },
                endLine: ctLoc.endLine,
                endCol: ctLoc.endCol,
                endOffset: ctLoc.endOffset
            } : {
                endLine: ctLoc.startLine,
                endCol: ctLoc.startCol,
                endOffset: ctLoc.startOffset
            };
            this.treeAdapter.updateNodeSourceCodeLocation(element, endLoc);
        }
    }
    //Token processing
    shouldProcessStartTagTokenInForeignContent(token) {
        // Check that neither current === document, or ns === NS.HTML
        if (!this.currentNotInHTML) return false;
        let current;
        let currentTagId;
        if (this.openElements.stackTop === 0 && this.fragmentContext) {
            current = this.fragmentContext;
            currentTagId = this.fragmentContextID;
        } else ({ current: current, currentTagId: currentTagId } = this.openElements);
        if (token.tagID === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).SVG && this.treeAdapter.getTagName(current) === (0, $0ddaebefe9b4fbd6$export$7e674a85a2656dce).ANNOTATION_XML && this.treeAdapter.getNamespaceURI(current) === (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).MATHML) return false;
        return(// Check that `current` is not an integration point for HTML or MathML elements.
        this.tokenizer.inForeignNode || // If it _is_ an integration point, then we might have to check that it is not an HTML
        // integration point.
        (token.tagID === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).MGLYPH || token.tagID === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).MALIGNMARK) && !this._isIntegrationPoint(currentTagId, current, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML));
    }
    _processToken(token) {
        switch(token.type){
            case (0, $c78559b0b620233e$export$f435f793048e7a0f).CHARACTER:
                this.onCharacter(token);
                break;
            case (0, $c78559b0b620233e$export$f435f793048e7a0f).NULL_CHARACTER:
                this.onNullCharacter(token);
                break;
            case (0, $c78559b0b620233e$export$f435f793048e7a0f).COMMENT:
                this.onComment(token);
                break;
            case (0, $c78559b0b620233e$export$f435f793048e7a0f).DOCTYPE:
                this.onDoctype(token);
                break;
            case (0, $c78559b0b620233e$export$f435f793048e7a0f).START_TAG:
                this._processStartTag(token);
                break;
            case (0, $c78559b0b620233e$export$f435f793048e7a0f).END_TAG:
                this.onEndTag(token);
                break;
            case (0, $c78559b0b620233e$export$f435f793048e7a0f).EOF:
                this.onEof(token);
                break;
            case (0, $c78559b0b620233e$export$f435f793048e7a0f).WHITESPACE_CHARACTER:
                this.onWhitespaceCharacter(token);
                break;
        }
    }
    //Integration points
    _isIntegrationPoint(tid, element, foreignNS) {
        const ns = this.treeAdapter.getNamespaceURI(element);
        const attrs = this.treeAdapter.getAttrList(element);
        return $96fb900eda529a8a$export$6baf3ebfdd620e1(tid, ns, attrs, foreignNS);
    }
    //Active formatting elements reconstruction
    _reconstructActiveFormattingElements() {
        const listLength = this.activeFormattingElements.entries.length;
        if (listLength) {
            const endIndex = this.activeFormattingElements.entries.findIndex((entry)=>entry.type === (0, $a62b4ea8619a62dc$export$e41c32906b33062a).Marker || this.openElements.contains(entry.element));
            const unopenIdx = endIndex < 0 ? listLength - 1 : endIndex - 1;
            for(let i = unopenIdx; i >= 0; i--){
                const entry = this.activeFormattingElements.entries[i];
                this._insertElement(entry.token, this.treeAdapter.getNamespaceURI(entry.element));
                entry.element = this.openElements.current;
            }
        }
    }
    //Close elements
    _closeTableCell() {
        this.openElements.generateImpliedEndTags();
        this.openElements.popUntilTableCellPopped();
        this.activeFormattingElements.clearToLastMarker();
        this.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_ROW;
    }
    _closePElement() {
        this.openElements.generateImpliedEndTagsWithExclusion((0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).P);
        this.openElements.popUntilTagNamePopped((0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).P);
    }
    //Insertion modes
    _resetInsertionMode() {
        for(let i = this.openElements.stackTop; i >= 0; i--)//Insertion mode reset map
        switch(i === 0 && this.fragmentContext ? this.fragmentContextID : this.openElements.tagIDs[i]){
            case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TR:
                this.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_ROW;
                return;
            case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TBODY:
            case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).THEAD:
            case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TFOOT:
                this.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_TABLE_BODY;
                return;
            case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).CAPTION:
                this.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_CAPTION;
                return;
            case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).COLGROUP:
                this.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_COLUMN_GROUP;
                return;
            case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TABLE:
                this.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_TABLE;
                return;
            case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BODY:
                this.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_BODY;
                return;
            case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).FRAMESET:
                this.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_FRAMESET;
                return;
            case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).SELECT:
                this._resetInsertionModeForSelect(i);
                return;
            case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TEMPLATE:
                this.insertionMode = this.tmplInsertionModeStack[0];
                return;
            case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HTML:
                this.insertionMode = this.headElement ? $603fd1ed28de42fc$var$InsertionMode.AFTER_HEAD : $603fd1ed28de42fc$var$InsertionMode.BEFORE_HEAD;
                return;
            case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TD:
            case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TH:
                if (i > 0) {
                    this.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_CELL;
                    return;
                }
                break;
            case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HEAD:
                if (i > 0) {
                    this.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_HEAD;
                    return;
                }
                break;
        }
        this.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_BODY;
    }
    _resetInsertionModeForSelect(selectIdx) {
        if (selectIdx > 0) for(let i = selectIdx - 1; i > 0; i--){
            const tn = this.openElements.tagIDs[i];
            if (tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TEMPLATE) break;
            else if (tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TABLE) {
                this.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_SELECT_IN_TABLE;
                return;
            }
        }
        this.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_SELECT;
    }
    //Foster parenting
    _isElementCausesFosterParenting(tn) {
        return $603fd1ed28de42fc$var$TABLE_STRUCTURE_TAGS.has(tn);
    }
    _shouldFosterParentOnInsertion() {
        return this.fosterParentingEnabled && this._isElementCausesFosterParenting(this.openElements.currentTagId);
    }
    _findFosterParentingLocation() {
        for(let i = this.openElements.stackTop; i >= 0; i--){
            const openElement = this.openElements.items[i];
            switch(this.openElements.tagIDs[i]){
                case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TEMPLATE:
                    if (this.treeAdapter.getNamespaceURI(openElement) === (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML) return {
                        parent: this.treeAdapter.getTemplateContent(openElement),
                        beforeElement: null
                    };
                    break;
                case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TABLE:
                    {
                        const parent = this.treeAdapter.getParentNode(openElement);
                        if (parent) return {
                            parent: parent,
                            beforeElement: openElement
                        };
                        return {
                            parent: this.openElements.items[i - 1],
                            beforeElement: null
                        };
                    }
                default:
            }
        }
        return {
            parent: this.openElements.items[0],
            beforeElement: null
        };
    }
    _fosterParentElement(element) {
        const location = this._findFosterParentingLocation();
        if (location.beforeElement) this.treeAdapter.insertBefore(location.parent, element, location.beforeElement);
        else this.treeAdapter.appendChild(location.parent, element);
    }
    //Special elements
    _isSpecialElement(element, id) {
        const ns = this.treeAdapter.getNamespaceURI(element);
        return (0, $0ddaebefe9b4fbd6$export$7e5172336f7d2bbb)[ns].has(id);
    }
    onCharacter(token) {
        this.skipNextNewLine = false;
        if (this.tokenizer.inForeignNode) {
            $603fd1ed28de42fc$var$characterInForeignContent(this, token);
            return;
        }
        switch(this.insertionMode){
            case $603fd1ed28de42fc$var$InsertionMode.INITIAL:
                $603fd1ed28de42fc$var$tokenInInitialMode(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.BEFORE_HTML:
                $603fd1ed28de42fc$var$tokenBeforeHtml(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.BEFORE_HEAD:
                $603fd1ed28de42fc$var$tokenBeforeHead(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.IN_HEAD:
                $603fd1ed28de42fc$var$tokenInHead(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.IN_HEAD_NO_SCRIPT:
                $603fd1ed28de42fc$var$tokenInHeadNoScript(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.AFTER_HEAD:
                $603fd1ed28de42fc$var$tokenAfterHead(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.IN_BODY:
            case $603fd1ed28de42fc$var$InsertionMode.IN_CAPTION:
            case $603fd1ed28de42fc$var$InsertionMode.IN_CELL:
            case $603fd1ed28de42fc$var$InsertionMode.IN_TEMPLATE:
                $603fd1ed28de42fc$var$characterInBody(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.TEXT:
            case $603fd1ed28de42fc$var$InsertionMode.IN_SELECT:
            case $603fd1ed28de42fc$var$InsertionMode.IN_SELECT_IN_TABLE:
                this._insertCharacters(token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.IN_TABLE:
            case $603fd1ed28de42fc$var$InsertionMode.IN_TABLE_BODY:
            case $603fd1ed28de42fc$var$InsertionMode.IN_ROW:
                $603fd1ed28de42fc$var$characterInTable(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.IN_TABLE_TEXT:
                $603fd1ed28de42fc$var$characterInTableText(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.IN_COLUMN_GROUP:
                $603fd1ed28de42fc$var$tokenInColumnGroup(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.AFTER_BODY:
                $603fd1ed28de42fc$var$tokenAfterBody(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.AFTER_AFTER_BODY:
                $603fd1ed28de42fc$var$tokenAfterAfterBody(this, token);
                break;
            default:
        }
    }
    onNullCharacter(token) {
        this.skipNextNewLine = false;
        if (this.tokenizer.inForeignNode) {
            $603fd1ed28de42fc$var$nullCharacterInForeignContent(this, token);
            return;
        }
        switch(this.insertionMode){
            case $603fd1ed28de42fc$var$InsertionMode.INITIAL:
                $603fd1ed28de42fc$var$tokenInInitialMode(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.BEFORE_HTML:
                $603fd1ed28de42fc$var$tokenBeforeHtml(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.BEFORE_HEAD:
                $603fd1ed28de42fc$var$tokenBeforeHead(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.IN_HEAD:
                $603fd1ed28de42fc$var$tokenInHead(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.IN_HEAD_NO_SCRIPT:
                $603fd1ed28de42fc$var$tokenInHeadNoScript(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.AFTER_HEAD:
                $603fd1ed28de42fc$var$tokenAfterHead(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.TEXT:
                this._insertCharacters(token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.IN_TABLE:
            case $603fd1ed28de42fc$var$InsertionMode.IN_TABLE_BODY:
            case $603fd1ed28de42fc$var$InsertionMode.IN_ROW:
                $603fd1ed28de42fc$var$characterInTable(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.IN_COLUMN_GROUP:
                $603fd1ed28de42fc$var$tokenInColumnGroup(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.AFTER_BODY:
                $603fd1ed28de42fc$var$tokenAfterBody(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.AFTER_AFTER_BODY:
                $603fd1ed28de42fc$var$tokenAfterAfterBody(this, token);
                break;
            default:
        }
    }
    onComment(token) {
        this.skipNextNewLine = false;
        if (this.currentNotInHTML) {
            $603fd1ed28de42fc$var$appendComment(this, token);
            return;
        }
        switch(this.insertionMode){
            case $603fd1ed28de42fc$var$InsertionMode.INITIAL:
            case $603fd1ed28de42fc$var$InsertionMode.BEFORE_HTML:
            case $603fd1ed28de42fc$var$InsertionMode.BEFORE_HEAD:
            case $603fd1ed28de42fc$var$InsertionMode.IN_HEAD:
            case $603fd1ed28de42fc$var$InsertionMode.IN_HEAD_NO_SCRIPT:
            case $603fd1ed28de42fc$var$InsertionMode.AFTER_HEAD:
            case $603fd1ed28de42fc$var$InsertionMode.IN_BODY:
            case $603fd1ed28de42fc$var$InsertionMode.IN_TABLE:
            case $603fd1ed28de42fc$var$InsertionMode.IN_CAPTION:
            case $603fd1ed28de42fc$var$InsertionMode.IN_COLUMN_GROUP:
            case $603fd1ed28de42fc$var$InsertionMode.IN_TABLE_BODY:
            case $603fd1ed28de42fc$var$InsertionMode.IN_ROW:
            case $603fd1ed28de42fc$var$InsertionMode.IN_CELL:
            case $603fd1ed28de42fc$var$InsertionMode.IN_SELECT:
            case $603fd1ed28de42fc$var$InsertionMode.IN_SELECT_IN_TABLE:
            case $603fd1ed28de42fc$var$InsertionMode.IN_TEMPLATE:
            case $603fd1ed28de42fc$var$InsertionMode.IN_FRAMESET:
            case $603fd1ed28de42fc$var$InsertionMode.AFTER_FRAMESET:
                $603fd1ed28de42fc$var$appendComment(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.IN_TABLE_TEXT:
                $603fd1ed28de42fc$var$tokenInTableText(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.AFTER_BODY:
                $603fd1ed28de42fc$var$appendCommentToRootHtmlElement(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.AFTER_AFTER_BODY:
            case $603fd1ed28de42fc$var$InsertionMode.AFTER_AFTER_FRAMESET:
                $603fd1ed28de42fc$var$appendCommentToDocument(this, token);
                break;
            default:
        }
    }
    onDoctype(token) {
        this.skipNextNewLine = false;
        switch(this.insertionMode){
            case $603fd1ed28de42fc$var$InsertionMode.INITIAL:
                $603fd1ed28de42fc$var$doctypeInInitialMode(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.BEFORE_HEAD:
            case $603fd1ed28de42fc$var$InsertionMode.IN_HEAD:
            case $603fd1ed28de42fc$var$InsertionMode.IN_HEAD_NO_SCRIPT:
            case $603fd1ed28de42fc$var$InsertionMode.AFTER_HEAD:
                this._err(token, (0, $016d4fdae73ebe61$export$9e0efcb140234d2).misplacedDoctype);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.IN_TABLE_TEXT:
                $603fd1ed28de42fc$var$tokenInTableText(this, token);
                break;
            default:
        }
    }
    onStartTag(token) {
        this.skipNextNewLine = false;
        this.currentToken = token;
        this._processStartTag(token);
        if (token.selfClosing && !token.ackSelfClosing) this._err(token, (0, $016d4fdae73ebe61$export$9e0efcb140234d2).nonVoidHtmlElementStartTagWithTrailingSolidus);
    }
    /**
     * Processes a given start tag.
     *
     * `onStartTag` checks if a self-closing tag was recognized. When a token
     * is moved inbetween multiple insertion modes, this check for self-closing
     * could lead to false positives. To avoid this, `_processStartTag` is used
     * for nested calls.
     *
     * @param token The token to process.
     */ _processStartTag(token) {
        if (this.shouldProcessStartTagTokenInForeignContent(token)) $603fd1ed28de42fc$var$startTagInForeignContent(this, token);
        else this._startTagOutsideForeignContent(token);
    }
    _startTagOutsideForeignContent(token) {
        switch(this.insertionMode){
            case $603fd1ed28de42fc$var$InsertionMode.INITIAL:
                $603fd1ed28de42fc$var$tokenInInitialMode(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.BEFORE_HTML:
                $603fd1ed28de42fc$var$startTagBeforeHtml(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.BEFORE_HEAD:
                $603fd1ed28de42fc$var$startTagBeforeHead(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.IN_HEAD:
                $603fd1ed28de42fc$var$startTagInHead(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.IN_HEAD_NO_SCRIPT:
                $603fd1ed28de42fc$var$startTagInHeadNoScript(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.AFTER_HEAD:
                $603fd1ed28de42fc$var$startTagAfterHead(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.IN_BODY:
                $603fd1ed28de42fc$var$startTagInBody(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.IN_TABLE:
                $603fd1ed28de42fc$var$startTagInTable(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.IN_TABLE_TEXT:
                $603fd1ed28de42fc$var$tokenInTableText(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.IN_CAPTION:
                $603fd1ed28de42fc$var$startTagInCaption(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.IN_COLUMN_GROUP:
                $603fd1ed28de42fc$var$startTagInColumnGroup(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.IN_TABLE_BODY:
                $603fd1ed28de42fc$var$startTagInTableBody(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.IN_ROW:
                $603fd1ed28de42fc$var$startTagInRow(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.IN_CELL:
                $603fd1ed28de42fc$var$startTagInCell(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.IN_SELECT:
                $603fd1ed28de42fc$var$startTagInSelect(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.IN_SELECT_IN_TABLE:
                $603fd1ed28de42fc$var$startTagInSelectInTable(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.IN_TEMPLATE:
                $603fd1ed28de42fc$var$startTagInTemplate(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.AFTER_BODY:
                $603fd1ed28de42fc$var$startTagAfterBody(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.IN_FRAMESET:
                $603fd1ed28de42fc$var$startTagInFrameset(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.AFTER_FRAMESET:
                $603fd1ed28de42fc$var$startTagAfterFrameset(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.AFTER_AFTER_BODY:
                $603fd1ed28de42fc$var$startTagAfterAfterBody(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.AFTER_AFTER_FRAMESET:
                $603fd1ed28de42fc$var$startTagAfterAfterFrameset(this, token);
                break;
            default:
        }
    }
    onEndTag(token) {
        this.skipNextNewLine = false;
        this.currentToken = token;
        if (this.currentNotInHTML) $603fd1ed28de42fc$var$endTagInForeignContent(this, token);
        else this._endTagOutsideForeignContent(token);
    }
    _endTagOutsideForeignContent(token) {
        switch(this.insertionMode){
            case $603fd1ed28de42fc$var$InsertionMode.INITIAL:
                $603fd1ed28de42fc$var$tokenInInitialMode(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.BEFORE_HTML:
                $603fd1ed28de42fc$var$endTagBeforeHtml(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.BEFORE_HEAD:
                $603fd1ed28de42fc$var$endTagBeforeHead(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.IN_HEAD:
                $603fd1ed28de42fc$var$endTagInHead(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.IN_HEAD_NO_SCRIPT:
                $603fd1ed28de42fc$var$endTagInHeadNoScript(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.AFTER_HEAD:
                $603fd1ed28de42fc$var$endTagAfterHead(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.IN_BODY:
                $603fd1ed28de42fc$var$endTagInBody(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.TEXT:
                $603fd1ed28de42fc$var$endTagInText(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.IN_TABLE:
                $603fd1ed28de42fc$var$endTagInTable(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.IN_TABLE_TEXT:
                $603fd1ed28de42fc$var$tokenInTableText(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.IN_CAPTION:
                $603fd1ed28de42fc$var$endTagInCaption(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.IN_COLUMN_GROUP:
                $603fd1ed28de42fc$var$endTagInColumnGroup(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.IN_TABLE_BODY:
                $603fd1ed28de42fc$var$endTagInTableBody(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.IN_ROW:
                $603fd1ed28de42fc$var$endTagInRow(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.IN_CELL:
                $603fd1ed28de42fc$var$endTagInCell(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.IN_SELECT:
                $603fd1ed28de42fc$var$endTagInSelect(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.IN_SELECT_IN_TABLE:
                $603fd1ed28de42fc$var$endTagInSelectInTable(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.IN_TEMPLATE:
                $603fd1ed28de42fc$var$endTagInTemplate(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.AFTER_BODY:
                $603fd1ed28de42fc$var$endTagAfterBody(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.IN_FRAMESET:
                $603fd1ed28de42fc$var$endTagInFrameset(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.AFTER_FRAMESET:
                $603fd1ed28de42fc$var$endTagAfterFrameset(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.AFTER_AFTER_BODY:
                $603fd1ed28de42fc$var$tokenAfterAfterBody(this, token);
                break;
            default:
        }
    }
    onEof(token) {
        switch(this.insertionMode){
            case $603fd1ed28de42fc$var$InsertionMode.INITIAL:
                $603fd1ed28de42fc$var$tokenInInitialMode(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.BEFORE_HTML:
                $603fd1ed28de42fc$var$tokenBeforeHtml(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.BEFORE_HEAD:
                $603fd1ed28de42fc$var$tokenBeforeHead(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.IN_HEAD:
                $603fd1ed28de42fc$var$tokenInHead(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.IN_HEAD_NO_SCRIPT:
                $603fd1ed28de42fc$var$tokenInHeadNoScript(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.AFTER_HEAD:
                $603fd1ed28de42fc$var$tokenAfterHead(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.IN_BODY:
            case $603fd1ed28de42fc$var$InsertionMode.IN_TABLE:
            case $603fd1ed28de42fc$var$InsertionMode.IN_CAPTION:
            case $603fd1ed28de42fc$var$InsertionMode.IN_COLUMN_GROUP:
            case $603fd1ed28de42fc$var$InsertionMode.IN_TABLE_BODY:
            case $603fd1ed28de42fc$var$InsertionMode.IN_ROW:
            case $603fd1ed28de42fc$var$InsertionMode.IN_CELL:
            case $603fd1ed28de42fc$var$InsertionMode.IN_SELECT:
            case $603fd1ed28de42fc$var$InsertionMode.IN_SELECT_IN_TABLE:
                $603fd1ed28de42fc$var$eofInBody(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.TEXT:
                $603fd1ed28de42fc$var$eofInText(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.IN_TABLE_TEXT:
                $603fd1ed28de42fc$var$tokenInTableText(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.IN_TEMPLATE:
                $603fd1ed28de42fc$var$eofInTemplate(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.AFTER_BODY:
            case $603fd1ed28de42fc$var$InsertionMode.IN_FRAMESET:
            case $603fd1ed28de42fc$var$InsertionMode.AFTER_FRAMESET:
            case $603fd1ed28de42fc$var$InsertionMode.AFTER_AFTER_BODY:
            case $603fd1ed28de42fc$var$InsertionMode.AFTER_AFTER_FRAMESET:
                $603fd1ed28de42fc$var$stopParsing(this, token);
                break;
            default:
        }
    }
    onWhitespaceCharacter(token) {
        if (this.skipNextNewLine) {
            this.skipNextNewLine = false;
            if (token.chars.charCodeAt(0) === $6c7c9c6fba662a30$export$e3f6c2feb5c0ecc0.LINE_FEED) {
                if (token.chars.length === 1) return;
                token.chars = token.chars.substr(1);
            }
        }
        if (this.tokenizer.inForeignNode) {
            this._insertCharacters(token);
            return;
        }
        switch(this.insertionMode){
            case $603fd1ed28de42fc$var$InsertionMode.IN_HEAD:
            case $603fd1ed28de42fc$var$InsertionMode.IN_HEAD_NO_SCRIPT:
            case $603fd1ed28de42fc$var$InsertionMode.AFTER_HEAD:
            case $603fd1ed28de42fc$var$InsertionMode.TEXT:
            case $603fd1ed28de42fc$var$InsertionMode.IN_COLUMN_GROUP:
            case $603fd1ed28de42fc$var$InsertionMode.IN_SELECT:
            case $603fd1ed28de42fc$var$InsertionMode.IN_SELECT_IN_TABLE:
            case $603fd1ed28de42fc$var$InsertionMode.IN_FRAMESET:
            case $603fd1ed28de42fc$var$InsertionMode.AFTER_FRAMESET:
                this._insertCharacters(token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.IN_BODY:
            case $603fd1ed28de42fc$var$InsertionMode.IN_CAPTION:
            case $603fd1ed28de42fc$var$InsertionMode.IN_CELL:
            case $603fd1ed28de42fc$var$InsertionMode.IN_TEMPLATE:
            case $603fd1ed28de42fc$var$InsertionMode.AFTER_BODY:
            case $603fd1ed28de42fc$var$InsertionMode.AFTER_AFTER_BODY:
            case $603fd1ed28de42fc$var$InsertionMode.AFTER_AFTER_FRAMESET:
                $603fd1ed28de42fc$var$whitespaceCharacterInBody(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.IN_TABLE:
            case $603fd1ed28de42fc$var$InsertionMode.IN_TABLE_BODY:
            case $603fd1ed28de42fc$var$InsertionMode.IN_ROW:
                $603fd1ed28de42fc$var$characterInTable(this, token);
                break;
            case $603fd1ed28de42fc$var$InsertionMode.IN_TABLE_TEXT:
                $603fd1ed28de42fc$var$whitespaceCharacterInTableText(this, token);
                break;
            default:
        }
    }
}
//Adoption agency algorithm
//(see: http://www.whatwg.org/specs/web-apps/current-work/multipage/tree-construction.html#adoptionAgency)
//------------------------------------------------------------------
//Steps 5-8 of the algorithm
function $603fd1ed28de42fc$var$aaObtainFormattingElementEntry(p, token) {
    let formattingElementEntry = p.activeFormattingElements.getElementEntryInScopeWithTagName(token.tagName);
    if (formattingElementEntry) {
        if (!p.openElements.contains(formattingElementEntry.element)) {
            p.activeFormattingElements.removeEntry(formattingElementEntry);
            formattingElementEntry = null;
        } else if (!p.openElements.hasInScope(token.tagID)) formattingElementEntry = null;
    } else $603fd1ed28de42fc$var$genericEndTagInBody(p, token);
    return formattingElementEntry;
}
//Steps 9 and 10 of the algorithm
function $603fd1ed28de42fc$var$aaObtainFurthestBlock(p, formattingElementEntry) {
    let furthestBlock = null;
    let idx = p.openElements.stackTop;
    for(; idx >= 0; idx--){
        const element = p.openElements.items[idx];
        if (element === formattingElementEntry.element) break;
        if (p._isSpecialElement(element, p.openElements.tagIDs[idx])) furthestBlock = element;
    }
    if (!furthestBlock) {
        p.openElements.shortenToLength(idx < 0 ? 0 : idx);
        p.activeFormattingElements.removeEntry(formattingElementEntry);
    }
    return furthestBlock;
}
//Step 13 of the algorithm
function $603fd1ed28de42fc$var$aaInnerLoop(p, furthestBlock, formattingElement) {
    let lastElement = furthestBlock;
    let nextElement = p.openElements.getCommonAncestor(furthestBlock);
    for(let i = 0, element = nextElement; element !== formattingElement; i++, element = nextElement){
        //NOTE: store the next element for the next loop iteration (it may be deleted from the stack by step 9.5)
        nextElement = p.openElements.getCommonAncestor(element);
        const elementEntry = p.activeFormattingElements.getElementEntry(element);
        const counterOverflow = elementEntry && i >= $603fd1ed28de42fc$var$AA_INNER_LOOP_ITER;
        const shouldRemoveFromOpenElements = !elementEntry || counterOverflow;
        if (shouldRemoveFromOpenElements) {
            if (counterOverflow) p.activeFormattingElements.removeEntry(elementEntry);
            p.openElements.remove(element);
        } else {
            element = $603fd1ed28de42fc$var$aaRecreateElementFromEntry(p, elementEntry);
            if (lastElement === furthestBlock) p.activeFormattingElements.bookmark = elementEntry;
            p.treeAdapter.detachNode(lastElement);
            p.treeAdapter.appendChild(element, lastElement);
            lastElement = element;
        }
    }
    return lastElement;
}
//Step 13.7 of the algorithm
function $603fd1ed28de42fc$var$aaRecreateElementFromEntry(p, elementEntry) {
    const ns = p.treeAdapter.getNamespaceURI(elementEntry.element);
    const newElement = p.treeAdapter.createElement(elementEntry.token.tagName, ns, elementEntry.token.attrs);
    p.openElements.replace(elementEntry.element, newElement);
    elementEntry.element = newElement;
    return newElement;
}
//Step 14 of the algorithm
function $603fd1ed28de42fc$var$aaInsertLastNodeInCommonAncestor(p, commonAncestor, lastElement) {
    const tn = p.treeAdapter.getTagName(commonAncestor);
    const tid = (0, $0ddaebefe9b4fbd6$export$39db8a1315f68282)(tn);
    if (p._isElementCausesFosterParenting(tid)) p._fosterParentElement(lastElement);
    else {
        const ns = p.treeAdapter.getNamespaceURI(commonAncestor);
        if (tid === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TEMPLATE && ns === (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML) commonAncestor = p.treeAdapter.getTemplateContent(commonAncestor);
        p.treeAdapter.appendChild(commonAncestor, lastElement);
    }
}
//Steps 15-19 of the algorithm
function $603fd1ed28de42fc$var$aaReplaceFormattingElement(p, furthestBlock, formattingElementEntry) {
    const ns = p.treeAdapter.getNamespaceURI(formattingElementEntry.element);
    const { token: token } = formattingElementEntry;
    const newElement = p.treeAdapter.createElement(token.tagName, ns, token.attrs);
    p._adoptNodes(furthestBlock, newElement);
    p.treeAdapter.appendChild(furthestBlock, newElement);
    p.activeFormattingElements.insertElementAfterBookmark(newElement, token);
    p.activeFormattingElements.removeEntry(formattingElementEntry);
    p.openElements.remove(formattingElementEntry.element);
    p.openElements.insertAfter(furthestBlock, newElement, token.tagID);
}
//Algorithm entry point
function $603fd1ed28de42fc$var$callAdoptionAgency(p, token) {
    for(let i = 0; i < $603fd1ed28de42fc$var$AA_OUTER_LOOP_ITER; i++){
        const formattingElementEntry = $603fd1ed28de42fc$var$aaObtainFormattingElementEntry(p, token);
        if (!formattingElementEntry) break;
        const furthestBlock = $603fd1ed28de42fc$var$aaObtainFurthestBlock(p, formattingElementEntry);
        if (!furthestBlock) break;
        p.activeFormattingElements.bookmark = formattingElementEntry;
        const lastElement = $603fd1ed28de42fc$var$aaInnerLoop(p, furthestBlock, formattingElementEntry.element);
        const commonAncestor = p.openElements.getCommonAncestor(formattingElementEntry.element);
        p.treeAdapter.detachNode(lastElement);
        if (commonAncestor) $603fd1ed28de42fc$var$aaInsertLastNodeInCommonAncestor(p, commonAncestor, lastElement);
        $603fd1ed28de42fc$var$aaReplaceFormattingElement(p, furthestBlock, formattingElementEntry);
    }
}
//Generic token handlers
//------------------------------------------------------------------
function $603fd1ed28de42fc$var$appendComment(p, token) {
    p._appendCommentNode(token, p.openElements.currentTmplContentOrNode);
}
function $603fd1ed28de42fc$var$appendCommentToRootHtmlElement(p, token) {
    p._appendCommentNode(token, p.openElements.items[0]);
}
function $603fd1ed28de42fc$var$appendCommentToDocument(p, token) {
    p._appendCommentNode(token, p.document);
}
function $603fd1ed28de42fc$var$stopParsing(p, token) {
    p.stopped = true;
    // NOTE: Set end locations for elements that remain on the open element stack.
    if (token.location) {
        // NOTE: If we are not in a fragment, `html` and `body` will stay on the stack.
        // This is a problem, as we might overwrite their end position here.
        const target = p.fragmentContext ? 0 : 2;
        for(let i = p.openElements.stackTop; i >= target; i--)p._setEndLocation(p.openElements.items[i], token);
        // Handle `html` and `body`
        if (!p.fragmentContext && p.openElements.stackTop >= 0) {
            const htmlElement = p.openElements.items[0];
            const htmlLocation = p.treeAdapter.getNodeSourceCodeLocation(htmlElement);
            if (htmlLocation && !htmlLocation.endTag) {
                p._setEndLocation(htmlElement, token);
                if (p.openElements.stackTop >= 1) {
                    const bodyElement = p.openElements.items[1];
                    const bodyLocation = p.treeAdapter.getNodeSourceCodeLocation(bodyElement);
                    if (bodyLocation && !bodyLocation.endTag) p._setEndLocation(bodyElement, token);
                }
            }
        }
    }
}
// The "initial" insertion mode
//------------------------------------------------------------------
function $603fd1ed28de42fc$var$doctypeInInitialMode(p, token) {
    p._setDocumentType(token);
    const mode = token.forceQuirks ? (0, $0ddaebefe9b4fbd6$export$a74d46c85337d29a).QUIRKS : $7824bc91d370139a$export$64782beacef87b30(token);
    if (!$7824bc91d370139a$export$ee48152ecc0e3f40(token)) p._err(token, (0, $016d4fdae73ebe61$export$9e0efcb140234d2).nonConformingDoctype);
    p.treeAdapter.setDocumentMode(p.document, mode);
    p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.BEFORE_HTML;
}
function $603fd1ed28de42fc$var$tokenInInitialMode(p, token) {
    p._err(token, (0, $016d4fdae73ebe61$export$9e0efcb140234d2).missingDoctype, true);
    p.treeAdapter.setDocumentMode(p.document, (0, $0ddaebefe9b4fbd6$export$a74d46c85337d29a).QUIRKS);
    p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.BEFORE_HTML;
    p._processToken(token);
}
// The "before html" insertion mode
//------------------------------------------------------------------
function $603fd1ed28de42fc$var$startTagBeforeHtml(p, token) {
    if (token.tagID === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HTML) {
        p._insertElement(token, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML);
        p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.BEFORE_HEAD;
    } else $603fd1ed28de42fc$var$tokenBeforeHtml(p, token);
}
function $603fd1ed28de42fc$var$endTagBeforeHtml(p, token) {
    const tn = token.tagID;
    if (tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HTML || tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HEAD || tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BODY || tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BR) $603fd1ed28de42fc$var$tokenBeforeHtml(p, token);
}
function $603fd1ed28de42fc$var$tokenBeforeHtml(p, token) {
    p._insertFakeRootElement();
    p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.BEFORE_HEAD;
    p._processToken(token);
}
// The "before head" insertion mode
//------------------------------------------------------------------
function $603fd1ed28de42fc$var$startTagBeforeHead(p, token) {
    switch(token.tagID){
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HTML:
            $603fd1ed28de42fc$var$startTagInBody(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HEAD:
            p._insertElement(token, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML);
            p.headElement = p.openElements.current;
            p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_HEAD;
            break;
        default:
            $603fd1ed28de42fc$var$tokenBeforeHead(p, token);
    }
}
function $603fd1ed28de42fc$var$endTagBeforeHead(p, token) {
    const tn = token.tagID;
    if (tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HEAD || tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BODY || tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HTML || tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BR) $603fd1ed28de42fc$var$tokenBeforeHead(p, token);
    else p._err(token, (0, $016d4fdae73ebe61$export$9e0efcb140234d2).endTagWithoutMatchingOpenElement);
}
function $603fd1ed28de42fc$var$tokenBeforeHead(p, token) {
    p._insertFakeElement((0, $0ddaebefe9b4fbd6$export$7e674a85a2656dce).HEAD, (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HEAD);
    p.headElement = p.openElements.current;
    p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_HEAD;
    p._processToken(token);
}
// The "in head" insertion mode
//------------------------------------------------------------------
function $603fd1ed28de42fc$var$startTagInHead(p, token) {
    switch(token.tagID){
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HTML:
            $603fd1ed28de42fc$var$startTagInBody(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BASE:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BASEFONT:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BGSOUND:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).LINK:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).META:
            p._appendElement(token, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML);
            token.ackSelfClosing = true;
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TITLE:
            p._switchToTextParsing(token, (0, $3e8f9cdab96dd92f$export$d0c9fb8d2ebe5159).RCDATA);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).NOSCRIPT:
            if (p.options.scriptingEnabled) p._switchToTextParsing(token, (0, $3e8f9cdab96dd92f$export$d0c9fb8d2ebe5159).RAWTEXT);
            else {
                p._insertElement(token, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML);
                p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_HEAD_NO_SCRIPT;
            }
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).NOFRAMES:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).STYLE:
            p._switchToTextParsing(token, (0, $3e8f9cdab96dd92f$export$d0c9fb8d2ebe5159).RAWTEXT);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).SCRIPT:
            p._switchToTextParsing(token, (0, $3e8f9cdab96dd92f$export$d0c9fb8d2ebe5159).SCRIPT_DATA);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TEMPLATE:
            p._insertTemplate(token);
            p.activeFormattingElements.insertMarker();
            p.framesetOk = false;
            p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_TEMPLATE;
            p.tmplInsertionModeStack.unshift($603fd1ed28de42fc$var$InsertionMode.IN_TEMPLATE);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HEAD:
            p._err(token, (0, $016d4fdae73ebe61$export$9e0efcb140234d2).misplacedStartTagForHeadElement);
            break;
        default:
            $603fd1ed28de42fc$var$tokenInHead(p, token);
    }
}
function $603fd1ed28de42fc$var$endTagInHead(p, token) {
    switch(token.tagID){
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HEAD:
            p.openElements.pop();
            p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.AFTER_HEAD;
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BODY:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BR:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HTML:
            $603fd1ed28de42fc$var$tokenInHead(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TEMPLATE:
            $603fd1ed28de42fc$var$templateEndTagInHead(p, token);
            break;
        default:
            p._err(token, (0, $016d4fdae73ebe61$export$9e0efcb140234d2).endTagWithoutMatchingOpenElement);
    }
}
function $603fd1ed28de42fc$var$templateEndTagInHead(p, token) {
    if (p.openElements.tmplCount > 0) {
        p.openElements.generateImpliedEndTagsThoroughly();
        if (p.openElements.currentTagId !== (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TEMPLATE) p._err(token, (0, $016d4fdae73ebe61$export$9e0efcb140234d2).closingOfElementWithOpenChildElements);
        p.openElements.popUntilTagNamePopped((0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TEMPLATE);
        p.activeFormattingElements.clearToLastMarker();
        p.tmplInsertionModeStack.shift();
        p._resetInsertionMode();
    } else p._err(token, (0, $016d4fdae73ebe61$export$9e0efcb140234d2).endTagWithoutMatchingOpenElement);
}
function $603fd1ed28de42fc$var$tokenInHead(p, token) {
    p.openElements.pop();
    p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.AFTER_HEAD;
    p._processToken(token);
}
// The "in head no script" insertion mode
//------------------------------------------------------------------
function $603fd1ed28de42fc$var$startTagInHeadNoScript(p, token) {
    switch(token.tagID){
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HTML:
            $603fd1ed28de42fc$var$startTagInBody(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BASEFONT:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BGSOUND:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HEAD:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).LINK:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).META:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).NOFRAMES:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).STYLE:
            $603fd1ed28de42fc$var$startTagInHead(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).NOSCRIPT:
            p._err(token, (0, $016d4fdae73ebe61$export$9e0efcb140234d2).nestedNoscriptInHead);
            break;
        default:
            $603fd1ed28de42fc$var$tokenInHeadNoScript(p, token);
    }
}
function $603fd1ed28de42fc$var$endTagInHeadNoScript(p, token) {
    switch(token.tagID){
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).NOSCRIPT:
            p.openElements.pop();
            p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_HEAD;
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BR:
            $603fd1ed28de42fc$var$tokenInHeadNoScript(p, token);
            break;
        default:
            p._err(token, (0, $016d4fdae73ebe61$export$9e0efcb140234d2).endTagWithoutMatchingOpenElement);
    }
}
function $603fd1ed28de42fc$var$tokenInHeadNoScript(p, token) {
    const errCode = token.type === (0, $c78559b0b620233e$export$f435f793048e7a0f).EOF ? (0, $016d4fdae73ebe61$export$9e0efcb140234d2).openElementsLeftAfterEof : (0, $016d4fdae73ebe61$export$9e0efcb140234d2).disallowedContentInNoscriptInHead;
    p._err(token, errCode);
    p.openElements.pop();
    p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_HEAD;
    p._processToken(token);
}
// The "after head" insertion mode
//------------------------------------------------------------------
function $603fd1ed28de42fc$var$startTagAfterHead(p, token) {
    switch(token.tagID){
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HTML:
            $603fd1ed28de42fc$var$startTagInBody(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BODY:
            p._insertElement(token, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML);
            p.framesetOk = false;
            p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_BODY;
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).FRAMESET:
            p._insertElement(token, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML);
            p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_FRAMESET;
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BASE:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BASEFONT:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BGSOUND:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).LINK:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).META:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).NOFRAMES:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).SCRIPT:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).STYLE:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TEMPLATE:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TITLE:
            p._err(token, (0, $016d4fdae73ebe61$export$9e0efcb140234d2).abandonedHeadElementChild);
            p.openElements.push(p.headElement, (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HEAD);
            $603fd1ed28de42fc$var$startTagInHead(p, token);
            p.openElements.remove(p.headElement);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HEAD:
            p._err(token, (0, $016d4fdae73ebe61$export$9e0efcb140234d2).misplacedStartTagForHeadElement);
            break;
        default:
            $603fd1ed28de42fc$var$tokenAfterHead(p, token);
    }
}
function $603fd1ed28de42fc$var$endTagAfterHead(p, token) {
    switch(token.tagID){
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BODY:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HTML:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BR:
            $603fd1ed28de42fc$var$tokenAfterHead(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TEMPLATE:
            $603fd1ed28de42fc$var$templateEndTagInHead(p, token);
            break;
        default:
            p._err(token, (0, $016d4fdae73ebe61$export$9e0efcb140234d2).endTagWithoutMatchingOpenElement);
    }
}
function $603fd1ed28de42fc$var$tokenAfterHead(p, token) {
    p._insertFakeElement((0, $0ddaebefe9b4fbd6$export$7e674a85a2656dce).BODY, (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BODY);
    p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_BODY;
    $603fd1ed28de42fc$var$modeInBody(p, token);
}
// The "in body" insertion mode
//------------------------------------------------------------------
function $603fd1ed28de42fc$var$modeInBody(p, token) {
    switch(token.type){
        case (0, $c78559b0b620233e$export$f435f793048e7a0f).CHARACTER:
            $603fd1ed28de42fc$var$characterInBody(p, token);
            break;
        case (0, $c78559b0b620233e$export$f435f793048e7a0f).WHITESPACE_CHARACTER:
            $603fd1ed28de42fc$var$whitespaceCharacterInBody(p, token);
            break;
        case (0, $c78559b0b620233e$export$f435f793048e7a0f).COMMENT:
            $603fd1ed28de42fc$var$appendComment(p, token);
            break;
        case (0, $c78559b0b620233e$export$f435f793048e7a0f).START_TAG:
            $603fd1ed28de42fc$var$startTagInBody(p, token);
            break;
        case (0, $c78559b0b620233e$export$f435f793048e7a0f).END_TAG:
            $603fd1ed28de42fc$var$endTagInBody(p, token);
            break;
        case (0, $c78559b0b620233e$export$f435f793048e7a0f).EOF:
            $603fd1ed28de42fc$var$eofInBody(p, token);
            break;
        default:
    }
}
function $603fd1ed28de42fc$var$whitespaceCharacterInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertCharacters(token);
}
function $603fd1ed28de42fc$var$characterInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertCharacters(token);
    p.framesetOk = false;
}
function $603fd1ed28de42fc$var$htmlStartTagInBody(p, token) {
    if (p.openElements.tmplCount === 0) p.treeAdapter.adoptAttributes(p.openElements.items[0], token.attrs);
}
function $603fd1ed28de42fc$var$bodyStartTagInBody(p, token) {
    const bodyElement = p.openElements.tryPeekProperlyNestedBodyElement();
    if (bodyElement && p.openElements.tmplCount === 0) {
        p.framesetOk = false;
        p.treeAdapter.adoptAttributes(bodyElement, token.attrs);
    }
}
function $603fd1ed28de42fc$var$framesetStartTagInBody(p, token) {
    const bodyElement = p.openElements.tryPeekProperlyNestedBodyElement();
    if (p.framesetOk && bodyElement) {
        p.treeAdapter.detachNode(bodyElement);
        p.openElements.popAllUpToHtmlElement();
        p._insertElement(token, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML);
        p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_FRAMESET;
    }
}
function $603fd1ed28de42fc$var$addressStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope((0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).P)) p._closePElement();
    p._insertElement(token, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML);
}
function $603fd1ed28de42fc$var$numberedHeaderStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope((0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).P)) p._closePElement();
    if ((0, $0ddaebefe9b4fbd6$export$5ed5f14a3d15367)(p.openElements.currentTagId)) p.openElements.pop();
    p._insertElement(token, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML);
}
function $603fd1ed28de42fc$var$preStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope((0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).P)) p._closePElement();
    p._insertElement(token, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML);
    //NOTE: If the next token is a U+000A LINE FEED (LF) character token, then ignore that token and move
    //on to the next one. (Newlines at the start of pre blocks are ignored as an authoring convenience.)
    p.skipNextNewLine = true;
    p.framesetOk = false;
}
function $603fd1ed28de42fc$var$formStartTagInBody(p, token) {
    const inTemplate = p.openElements.tmplCount > 0;
    if (!p.formElement || inTemplate) {
        if (p.openElements.hasInButtonScope((0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).P)) p._closePElement();
        p._insertElement(token, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML);
        if (!inTemplate) p.formElement = p.openElements.current;
    }
}
function $603fd1ed28de42fc$var$listItemStartTagInBody(p, token) {
    p.framesetOk = false;
    const tn = token.tagID;
    for(let i = p.openElements.stackTop; i >= 0; i--){
        const elementId = p.openElements.tagIDs[i];
        if (tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).LI && elementId === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).LI || (tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).DD || tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).DT) && (elementId === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).DD || elementId === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).DT)) {
            p.openElements.generateImpliedEndTagsWithExclusion(elementId);
            p.openElements.popUntilTagNamePopped(elementId);
            break;
        }
        if (elementId !== (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).ADDRESS && elementId !== (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).DIV && elementId !== (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).P && p._isSpecialElement(p.openElements.items[i], elementId)) break;
    }
    if (p.openElements.hasInButtonScope((0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).P)) p._closePElement();
    p._insertElement(token, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML);
}
function $603fd1ed28de42fc$var$plaintextStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope((0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).P)) p._closePElement();
    p._insertElement(token, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML);
    p.tokenizer.state = (0, $3e8f9cdab96dd92f$export$d0c9fb8d2ebe5159).PLAINTEXT;
}
function $603fd1ed28de42fc$var$buttonStartTagInBody(p, token) {
    if (p.openElements.hasInScope((0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BUTTON)) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilTagNamePopped((0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BUTTON);
    }
    p._reconstructActiveFormattingElements();
    p._insertElement(token, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML);
    p.framesetOk = false;
}
function $603fd1ed28de42fc$var$aStartTagInBody(p, token) {
    const activeElementEntry = p.activeFormattingElements.getElementEntryInScopeWithTagName((0, $0ddaebefe9b4fbd6$export$7e674a85a2656dce).A);
    if (activeElementEntry) {
        $603fd1ed28de42fc$var$callAdoptionAgency(p, token);
        p.openElements.remove(activeElementEntry.element);
        p.activeFormattingElements.removeEntry(activeElementEntry);
    }
    p._reconstructActiveFormattingElements();
    p._insertElement(token, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML);
    p.activeFormattingElements.pushElement(p.openElements.current, token);
}
function $603fd1ed28de42fc$var$bStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML);
    p.activeFormattingElements.pushElement(p.openElements.current, token);
}
function $603fd1ed28de42fc$var$nobrStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    if (p.openElements.hasInScope((0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).NOBR)) {
        $603fd1ed28de42fc$var$callAdoptionAgency(p, token);
        p._reconstructActiveFormattingElements();
    }
    p._insertElement(token, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML);
    p.activeFormattingElements.pushElement(p.openElements.current, token);
}
function $603fd1ed28de42fc$var$appletStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML);
    p.activeFormattingElements.insertMarker();
    p.framesetOk = false;
}
function $603fd1ed28de42fc$var$tableStartTagInBody(p, token) {
    if (p.treeAdapter.getDocumentMode(p.document) !== (0, $0ddaebefe9b4fbd6$export$a74d46c85337d29a).QUIRKS && p.openElements.hasInButtonScope((0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).P)) p._closePElement();
    p._insertElement(token, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML);
    p.framesetOk = false;
    p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_TABLE;
}
function $603fd1ed28de42fc$var$areaStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._appendElement(token, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML);
    p.framesetOk = false;
    token.ackSelfClosing = true;
}
function $603fd1ed28de42fc$var$isHiddenInput(token) {
    const inputType = (0, $c78559b0b620233e$export$df33bba014b5841e)(token, (0, $0ddaebefe9b4fbd6$export$380b7bc9e6cb1918).TYPE);
    return inputType != null && inputType.toLowerCase() === $603fd1ed28de42fc$var$HIDDEN_INPUT_TYPE;
}
function $603fd1ed28de42fc$var$inputStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._appendElement(token, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML);
    if (!$603fd1ed28de42fc$var$isHiddenInput(token)) p.framesetOk = false;
    token.ackSelfClosing = true;
}
function $603fd1ed28de42fc$var$paramStartTagInBody(p, token) {
    p._appendElement(token, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML);
    token.ackSelfClosing = true;
}
function $603fd1ed28de42fc$var$hrStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope((0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).P)) p._closePElement();
    p._appendElement(token, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML);
    p.framesetOk = false;
    token.ackSelfClosing = true;
}
function $603fd1ed28de42fc$var$imageStartTagInBody(p, token) {
    token.tagName = (0, $0ddaebefe9b4fbd6$export$7e674a85a2656dce).IMG;
    token.tagID = (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).IMG;
    $603fd1ed28de42fc$var$areaStartTagInBody(p, token);
}
function $603fd1ed28de42fc$var$textareaStartTagInBody(p, token) {
    p._insertElement(token, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML);
    //NOTE: If the next token is a U+000A LINE FEED (LF) character token, then ignore that token and move
    //on to the next one. (Newlines at the start of textarea elements are ignored as an authoring convenience.)
    p.skipNextNewLine = true;
    p.tokenizer.state = (0, $3e8f9cdab96dd92f$export$d0c9fb8d2ebe5159).RCDATA;
    p.originalInsertionMode = p.insertionMode;
    p.framesetOk = false;
    p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.TEXT;
}
function $603fd1ed28de42fc$var$xmpStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope((0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).P)) p._closePElement();
    p._reconstructActiveFormattingElements();
    p.framesetOk = false;
    p._switchToTextParsing(token, (0, $3e8f9cdab96dd92f$export$d0c9fb8d2ebe5159).RAWTEXT);
}
function $603fd1ed28de42fc$var$iframeStartTagInBody(p, token) {
    p.framesetOk = false;
    p._switchToTextParsing(token, (0, $3e8f9cdab96dd92f$export$d0c9fb8d2ebe5159).RAWTEXT);
}
//NOTE: here we assume that we always act as an user agent with enabled plugins, so we parse
//<noembed> as rawtext.
function $603fd1ed28de42fc$var$noembedStartTagInBody(p, token) {
    p._switchToTextParsing(token, (0, $3e8f9cdab96dd92f$export$d0c9fb8d2ebe5159).RAWTEXT);
}
function $603fd1ed28de42fc$var$selectStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML);
    p.framesetOk = false;
    p.insertionMode = p.insertionMode === $603fd1ed28de42fc$var$InsertionMode.IN_TABLE || p.insertionMode === $603fd1ed28de42fc$var$InsertionMode.IN_CAPTION || p.insertionMode === $603fd1ed28de42fc$var$InsertionMode.IN_TABLE_BODY || p.insertionMode === $603fd1ed28de42fc$var$InsertionMode.IN_ROW || p.insertionMode === $603fd1ed28de42fc$var$InsertionMode.IN_CELL ? $603fd1ed28de42fc$var$InsertionMode.IN_SELECT_IN_TABLE : $603fd1ed28de42fc$var$InsertionMode.IN_SELECT;
}
function $603fd1ed28de42fc$var$optgroupStartTagInBody(p, token) {
    if (p.openElements.currentTagId === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).OPTION) p.openElements.pop();
    p._reconstructActiveFormattingElements();
    p._insertElement(token, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML);
}
function $603fd1ed28de42fc$var$rbStartTagInBody(p, token) {
    if (p.openElements.hasInScope((0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).RUBY)) p.openElements.generateImpliedEndTags();
    p._insertElement(token, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML);
}
function $603fd1ed28de42fc$var$rtStartTagInBody(p, token) {
    if (p.openElements.hasInScope((0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).RUBY)) p.openElements.generateImpliedEndTagsWithExclusion((0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).RTC);
    p._insertElement(token, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML);
}
function $603fd1ed28de42fc$var$mathStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    $96fb900eda529a8a$export$c583cc5a9d633feb(token);
    $96fb900eda529a8a$export$a5192af02995cbdc(token);
    if (token.selfClosing) p._appendElement(token, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).MATHML);
    else p._insertElement(token, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).MATHML);
    token.ackSelfClosing = true;
}
function $603fd1ed28de42fc$var$svgStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    $96fb900eda529a8a$export$74ce06f755fb8f68(token);
    $96fb900eda529a8a$export$a5192af02995cbdc(token);
    if (token.selfClosing) p._appendElement(token, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).SVG);
    else p._insertElement(token, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).SVG);
    token.ackSelfClosing = true;
}
function $603fd1ed28de42fc$var$genericStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML);
}
function $603fd1ed28de42fc$var$startTagInBody(p, token) {
    switch(token.tagID){
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).I:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).S:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).B:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).U:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).EM:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TT:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BIG:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).CODE:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).FONT:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).SMALL:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).STRIKE:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).STRONG:
            $603fd1ed28de42fc$var$bStartTagInBody(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).A:
            $603fd1ed28de42fc$var$aStartTagInBody(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).H1:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).H2:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).H3:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).H4:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).H5:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).H6:
            $603fd1ed28de42fc$var$numberedHeaderStartTagInBody(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).P:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).DL:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).OL:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).UL:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).DIV:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).DIR:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).NAV:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).MAIN:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).MENU:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).ASIDE:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).CENTER:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).FIGURE:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).FOOTER:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HEADER:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HGROUP:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).DIALOG:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).DETAILS:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).ADDRESS:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).ARTICLE:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).SECTION:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).SUMMARY:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).FIELDSET:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BLOCKQUOTE:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).FIGCAPTION:
            $603fd1ed28de42fc$var$addressStartTagInBody(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).LI:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).DD:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).DT:
            $603fd1ed28de42fc$var$listItemStartTagInBody(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BR:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).IMG:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).WBR:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).AREA:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).EMBED:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).KEYGEN:
            $603fd1ed28de42fc$var$areaStartTagInBody(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HR:
            $603fd1ed28de42fc$var$hrStartTagInBody(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).RB:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).RTC:
            $603fd1ed28de42fc$var$rbStartTagInBody(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).RT:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).RP:
            $603fd1ed28de42fc$var$rtStartTagInBody(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).PRE:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).LISTING:
            $603fd1ed28de42fc$var$preStartTagInBody(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).XMP:
            $603fd1ed28de42fc$var$xmpStartTagInBody(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).SVG:
            $603fd1ed28de42fc$var$svgStartTagInBody(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HTML:
            $603fd1ed28de42fc$var$htmlStartTagInBody(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BASE:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).LINK:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).META:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).STYLE:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TITLE:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).SCRIPT:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BGSOUND:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BASEFONT:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TEMPLATE:
            $603fd1ed28de42fc$var$startTagInHead(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BODY:
            $603fd1ed28de42fc$var$bodyStartTagInBody(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).FORM:
            $603fd1ed28de42fc$var$formStartTagInBody(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).NOBR:
            $603fd1ed28de42fc$var$nobrStartTagInBody(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).MATH:
            $603fd1ed28de42fc$var$mathStartTagInBody(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TABLE:
            $603fd1ed28de42fc$var$tableStartTagInBody(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).INPUT:
            $603fd1ed28de42fc$var$inputStartTagInBody(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).PARAM:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TRACK:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).SOURCE:
            $603fd1ed28de42fc$var$paramStartTagInBody(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).IMAGE:
            $603fd1ed28de42fc$var$imageStartTagInBody(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BUTTON:
            $603fd1ed28de42fc$var$buttonStartTagInBody(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).APPLET:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).OBJECT:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).MARQUEE:
            $603fd1ed28de42fc$var$appletStartTagInBody(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).IFRAME:
            $603fd1ed28de42fc$var$iframeStartTagInBody(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).SELECT:
            $603fd1ed28de42fc$var$selectStartTagInBody(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).OPTION:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).OPTGROUP:
            $603fd1ed28de42fc$var$optgroupStartTagInBody(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).NOEMBED:
            $603fd1ed28de42fc$var$noembedStartTagInBody(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).FRAMESET:
            $603fd1ed28de42fc$var$framesetStartTagInBody(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TEXTAREA:
            $603fd1ed28de42fc$var$textareaStartTagInBody(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).NOSCRIPT:
            if (p.options.scriptingEnabled) $603fd1ed28de42fc$var$noembedStartTagInBody(p, token);
            else $603fd1ed28de42fc$var$genericStartTagInBody(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).PLAINTEXT:
            $603fd1ed28de42fc$var$plaintextStartTagInBody(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).COL:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TH:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TD:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TR:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HEAD:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).FRAME:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TBODY:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TFOOT:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).THEAD:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).CAPTION:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).COLGROUP:
            break;
        default:
            $603fd1ed28de42fc$var$genericStartTagInBody(p, token);
    }
}
function $603fd1ed28de42fc$var$bodyEndTagInBody(p, token) {
    if (p.openElements.hasInScope((0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BODY)) {
        p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.AFTER_BODY;
        //NOTE: <body> is never popped from the stack, so we need to updated
        //the end location explicitly.
        if (p.options.sourceCodeLocationInfo) {
            const bodyElement = p.openElements.tryPeekProperlyNestedBodyElement();
            if (bodyElement) p._setEndLocation(bodyElement, token);
        }
    }
}
function $603fd1ed28de42fc$var$htmlEndTagInBody(p, token) {
    if (p.openElements.hasInScope((0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BODY)) {
        p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.AFTER_BODY;
        $603fd1ed28de42fc$var$endTagAfterBody(p, token);
    }
}
function $603fd1ed28de42fc$var$addressEndTagInBody(p, token) {
    const tn = token.tagID;
    if (p.openElements.hasInScope(tn)) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilTagNamePopped(tn);
    }
}
function $603fd1ed28de42fc$var$formEndTagInBody(p) {
    const inTemplate = p.openElements.tmplCount > 0;
    const { formElement: formElement } = p;
    if (!inTemplate) p.formElement = null;
    if ((formElement || inTemplate) && p.openElements.hasInScope((0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).FORM)) {
        p.openElements.generateImpliedEndTags();
        if (inTemplate) p.openElements.popUntilTagNamePopped((0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).FORM);
        else if (formElement) p.openElements.remove(formElement);
    }
}
function $603fd1ed28de42fc$var$pEndTagInBody(p) {
    if (!p.openElements.hasInButtonScope((0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).P)) p._insertFakeElement((0, $0ddaebefe9b4fbd6$export$7e674a85a2656dce).P, (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).P);
    p._closePElement();
}
function $603fd1ed28de42fc$var$liEndTagInBody(p) {
    if (p.openElements.hasInListItemScope((0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).LI)) {
        p.openElements.generateImpliedEndTagsWithExclusion((0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).LI);
        p.openElements.popUntilTagNamePopped((0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).LI);
    }
}
function $603fd1ed28de42fc$var$ddEndTagInBody(p, token) {
    const tn = token.tagID;
    if (p.openElements.hasInScope(tn)) {
        p.openElements.generateImpliedEndTagsWithExclusion(tn);
        p.openElements.popUntilTagNamePopped(tn);
    }
}
function $603fd1ed28de42fc$var$numberedHeaderEndTagInBody(p) {
    if (p.openElements.hasNumberedHeaderInScope()) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilNumberedHeaderPopped();
    }
}
function $603fd1ed28de42fc$var$appletEndTagInBody(p, token) {
    const tn = token.tagID;
    if (p.openElements.hasInScope(tn)) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilTagNamePopped(tn);
        p.activeFormattingElements.clearToLastMarker();
    }
}
function $603fd1ed28de42fc$var$brEndTagInBody(p) {
    p._reconstructActiveFormattingElements();
    p._insertFakeElement((0, $0ddaebefe9b4fbd6$export$7e674a85a2656dce).BR, (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BR);
    p.openElements.pop();
    p.framesetOk = false;
}
function $603fd1ed28de42fc$var$genericEndTagInBody(p, token) {
    const tn = token.tagName;
    const tid = token.tagID;
    for(let i = p.openElements.stackTop; i > 0; i--){
        const element = p.openElements.items[i];
        const elementId = p.openElements.tagIDs[i];
        // Compare the tag name here, as the tag might not be a known tag with an ID.
        if (tid === elementId && (tid !== (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).UNKNOWN || p.treeAdapter.getTagName(element) === tn)) {
            p.openElements.generateImpliedEndTagsWithExclusion(tid);
            if (p.openElements.stackTop >= i) p.openElements.shortenToLength(i);
            break;
        }
        if (p._isSpecialElement(element, elementId)) break;
    }
}
function $603fd1ed28de42fc$var$endTagInBody(p, token) {
    switch(token.tagID){
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).A:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).B:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).I:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).S:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).U:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).EM:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TT:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BIG:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).CODE:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).FONT:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).NOBR:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).SMALL:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).STRIKE:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).STRONG:
            $603fd1ed28de42fc$var$callAdoptionAgency(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).P:
            $603fd1ed28de42fc$var$pEndTagInBody(p);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).DL:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).UL:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).OL:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).DIR:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).DIV:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).NAV:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).PRE:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).MAIN:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).MENU:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).ASIDE:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BUTTON:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).CENTER:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).FIGURE:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).FOOTER:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HEADER:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HGROUP:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).DIALOG:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).ADDRESS:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).ARTICLE:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).DETAILS:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).SECTION:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).SUMMARY:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).LISTING:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).FIELDSET:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BLOCKQUOTE:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).FIGCAPTION:
            $603fd1ed28de42fc$var$addressEndTagInBody(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).LI:
            $603fd1ed28de42fc$var$liEndTagInBody(p);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).DD:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).DT:
            $603fd1ed28de42fc$var$ddEndTagInBody(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).H1:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).H2:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).H3:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).H4:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).H5:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).H6:
            $603fd1ed28de42fc$var$numberedHeaderEndTagInBody(p);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BR:
            $603fd1ed28de42fc$var$brEndTagInBody(p);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BODY:
            $603fd1ed28de42fc$var$bodyEndTagInBody(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HTML:
            $603fd1ed28de42fc$var$htmlEndTagInBody(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).FORM:
            $603fd1ed28de42fc$var$formEndTagInBody(p);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).APPLET:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).OBJECT:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).MARQUEE:
            $603fd1ed28de42fc$var$appletEndTagInBody(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TEMPLATE:
            $603fd1ed28de42fc$var$templateEndTagInHead(p, token);
            break;
        default:
            $603fd1ed28de42fc$var$genericEndTagInBody(p, token);
    }
}
function $603fd1ed28de42fc$var$eofInBody(p, token) {
    if (p.tmplInsertionModeStack.length > 0) $603fd1ed28de42fc$var$eofInTemplate(p, token);
    else $603fd1ed28de42fc$var$stopParsing(p, token);
}
// The "text" insertion mode
//------------------------------------------------------------------
function $603fd1ed28de42fc$var$endTagInText(p, token) {
    var _a;
    if (token.tagID === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).SCRIPT) (_a = p.scriptHandler) === null || _a === void 0 || _a.call(p, p.openElements.current);
    p.openElements.pop();
    p.insertionMode = p.originalInsertionMode;
}
function $603fd1ed28de42fc$var$eofInText(p, token) {
    p._err(token, (0, $016d4fdae73ebe61$export$9e0efcb140234d2).eofInElementThatCanContainOnlyText);
    p.openElements.pop();
    p.insertionMode = p.originalInsertionMode;
    p.onEof(token);
}
// The "in table" insertion mode
//------------------------------------------------------------------
function $603fd1ed28de42fc$var$characterInTable(p, token) {
    if ($603fd1ed28de42fc$var$TABLE_STRUCTURE_TAGS.has(p.openElements.currentTagId)) {
        p.pendingCharacterTokens.length = 0;
        p.hasNonWhitespacePendingCharacterToken = false;
        p.originalInsertionMode = p.insertionMode;
        p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_TABLE_TEXT;
        switch(token.type){
            case (0, $c78559b0b620233e$export$f435f793048e7a0f).CHARACTER:
                $603fd1ed28de42fc$var$characterInTableText(p, token);
                break;
            case (0, $c78559b0b620233e$export$f435f793048e7a0f).WHITESPACE_CHARACTER:
                $603fd1ed28de42fc$var$whitespaceCharacterInTableText(p, token);
                break;
        }
    } else $603fd1ed28de42fc$var$tokenInTable(p, token);
}
function $603fd1ed28de42fc$var$captionStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p.activeFormattingElements.insertMarker();
    p._insertElement(token, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML);
    p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_CAPTION;
}
function $603fd1ed28de42fc$var$colgroupStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertElement(token, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML);
    p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_COLUMN_GROUP;
}
function $603fd1ed28de42fc$var$colStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertFakeElement((0, $0ddaebefe9b4fbd6$export$7e674a85a2656dce).COLGROUP, (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).COLGROUP);
    p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_COLUMN_GROUP;
    $603fd1ed28de42fc$var$startTagInColumnGroup(p, token);
}
function $603fd1ed28de42fc$var$tbodyStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertElement(token, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML);
    p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_TABLE_BODY;
}
function $603fd1ed28de42fc$var$tdStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertFakeElement((0, $0ddaebefe9b4fbd6$export$7e674a85a2656dce).TBODY, (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TBODY);
    p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_TABLE_BODY;
    $603fd1ed28de42fc$var$startTagInTableBody(p, token);
}
function $603fd1ed28de42fc$var$tableStartTagInTable(p, token) {
    if (p.openElements.hasInTableScope((0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TABLE)) {
        p.openElements.popUntilTagNamePopped((0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TABLE);
        p._resetInsertionMode();
        p._processStartTag(token);
    }
}
function $603fd1ed28de42fc$var$inputStartTagInTable(p, token) {
    if ($603fd1ed28de42fc$var$isHiddenInput(token)) p._appendElement(token, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML);
    else $603fd1ed28de42fc$var$tokenInTable(p, token);
    token.ackSelfClosing = true;
}
function $603fd1ed28de42fc$var$formStartTagInTable(p, token) {
    if (!p.formElement && p.openElements.tmplCount === 0) {
        p._insertElement(token, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML);
        p.formElement = p.openElements.current;
        p.openElements.pop();
    }
}
function $603fd1ed28de42fc$var$startTagInTable(p, token) {
    switch(token.tagID){
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TD:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TH:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TR:
            $603fd1ed28de42fc$var$tdStartTagInTable(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).STYLE:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).SCRIPT:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TEMPLATE:
            $603fd1ed28de42fc$var$startTagInHead(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).COL:
            $603fd1ed28de42fc$var$colStartTagInTable(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).FORM:
            $603fd1ed28de42fc$var$formStartTagInTable(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TABLE:
            $603fd1ed28de42fc$var$tableStartTagInTable(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TBODY:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TFOOT:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).THEAD:
            $603fd1ed28de42fc$var$tbodyStartTagInTable(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).INPUT:
            $603fd1ed28de42fc$var$inputStartTagInTable(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).CAPTION:
            $603fd1ed28de42fc$var$captionStartTagInTable(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).COLGROUP:
            $603fd1ed28de42fc$var$colgroupStartTagInTable(p, token);
            break;
        default:
            $603fd1ed28de42fc$var$tokenInTable(p, token);
    }
}
function $603fd1ed28de42fc$var$endTagInTable(p, token) {
    switch(token.tagID){
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TABLE:
            if (p.openElements.hasInTableScope((0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TABLE)) {
                p.openElements.popUntilTagNamePopped((0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TABLE);
                p._resetInsertionMode();
            }
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TEMPLATE:
            $603fd1ed28de42fc$var$templateEndTagInHead(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BODY:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).CAPTION:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).COL:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).COLGROUP:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HTML:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TBODY:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TD:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TFOOT:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TH:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).THEAD:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TR:
            break;
        default:
            $603fd1ed28de42fc$var$tokenInTable(p, token);
    }
}
function $603fd1ed28de42fc$var$tokenInTable(p, token) {
    const savedFosterParentingState = p.fosterParentingEnabled;
    p.fosterParentingEnabled = true;
    // Process token in `In Body` mode
    $603fd1ed28de42fc$var$modeInBody(p, token);
    p.fosterParentingEnabled = savedFosterParentingState;
}
// The "in table text" insertion mode
//------------------------------------------------------------------
function $603fd1ed28de42fc$var$whitespaceCharacterInTableText(p, token) {
    p.pendingCharacterTokens.push(token);
}
function $603fd1ed28de42fc$var$characterInTableText(p, token) {
    p.pendingCharacterTokens.push(token);
    p.hasNonWhitespacePendingCharacterToken = true;
}
function $603fd1ed28de42fc$var$tokenInTableText(p, token) {
    let i = 0;
    if (p.hasNonWhitespacePendingCharacterToken) for(; i < p.pendingCharacterTokens.length; i++)$603fd1ed28de42fc$var$tokenInTable(p, p.pendingCharacterTokens[i]);
    else for(; i < p.pendingCharacterTokens.length; i++)p._insertCharacters(p.pendingCharacterTokens[i]);
    p.insertionMode = p.originalInsertionMode;
    p._processToken(token);
}
// The "in caption" insertion mode
//------------------------------------------------------------------
const $603fd1ed28de42fc$var$TABLE_VOID_ELEMENTS = new Set([
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).CAPTION,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).COL,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).COLGROUP,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TBODY,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TD,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TFOOT,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TH,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).THEAD,
    (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TR
]);
function $603fd1ed28de42fc$var$startTagInCaption(p, token) {
    const tn = token.tagID;
    if ($603fd1ed28de42fc$var$TABLE_VOID_ELEMENTS.has(tn)) {
        if (p.openElements.hasInTableScope((0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).CAPTION)) {
            p.openElements.generateImpliedEndTags();
            p.openElements.popUntilTagNamePopped((0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).CAPTION);
            p.activeFormattingElements.clearToLastMarker();
            p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_TABLE;
            $603fd1ed28de42fc$var$startTagInTable(p, token);
        }
    } else $603fd1ed28de42fc$var$startTagInBody(p, token);
}
function $603fd1ed28de42fc$var$endTagInCaption(p, token) {
    const tn = token.tagID;
    switch(tn){
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).CAPTION:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TABLE:
            if (p.openElements.hasInTableScope((0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).CAPTION)) {
                p.openElements.generateImpliedEndTags();
                p.openElements.popUntilTagNamePopped((0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).CAPTION);
                p.activeFormattingElements.clearToLastMarker();
                p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_TABLE;
                if (tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TABLE) $603fd1ed28de42fc$var$endTagInTable(p, token);
            }
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BODY:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).COL:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).COLGROUP:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HTML:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TBODY:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TD:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TFOOT:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TH:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).THEAD:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TR:
            break;
        default:
            $603fd1ed28de42fc$var$endTagInBody(p, token);
    }
}
// The "in column group" insertion mode
//------------------------------------------------------------------
function $603fd1ed28de42fc$var$startTagInColumnGroup(p, token) {
    switch(token.tagID){
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HTML:
            $603fd1ed28de42fc$var$startTagInBody(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).COL:
            p._appendElement(token, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML);
            token.ackSelfClosing = true;
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TEMPLATE:
            $603fd1ed28de42fc$var$startTagInHead(p, token);
            break;
        default:
            $603fd1ed28de42fc$var$tokenInColumnGroup(p, token);
    }
}
function $603fd1ed28de42fc$var$endTagInColumnGroup(p, token) {
    switch(token.tagID){
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).COLGROUP:
            if (p.openElements.currentTagId === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).COLGROUP) {
                p.openElements.pop();
                p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_TABLE;
            }
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TEMPLATE:
            $603fd1ed28de42fc$var$templateEndTagInHead(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).COL:
            break;
        default:
            $603fd1ed28de42fc$var$tokenInColumnGroup(p, token);
    }
}
function $603fd1ed28de42fc$var$tokenInColumnGroup(p, token) {
    if (p.openElements.currentTagId === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).COLGROUP) {
        p.openElements.pop();
        p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_TABLE;
        p._processToken(token);
    }
}
// The "in table body" insertion mode
//------------------------------------------------------------------
function $603fd1ed28de42fc$var$startTagInTableBody(p, token) {
    switch(token.tagID){
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TR:
            p.openElements.clearBackToTableBodyContext();
            p._insertElement(token, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML);
            p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_ROW;
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TH:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TD:
            p.openElements.clearBackToTableBodyContext();
            p._insertFakeElement((0, $0ddaebefe9b4fbd6$export$7e674a85a2656dce).TR, (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TR);
            p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_ROW;
            $603fd1ed28de42fc$var$startTagInRow(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).CAPTION:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).COL:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).COLGROUP:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TBODY:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TFOOT:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).THEAD:
            if (p.openElements.hasTableBodyContextInTableScope()) {
                p.openElements.clearBackToTableBodyContext();
                p.openElements.pop();
                p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_TABLE;
                $603fd1ed28de42fc$var$startTagInTable(p, token);
            }
            break;
        default:
            $603fd1ed28de42fc$var$startTagInTable(p, token);
    }
}
function $603fd1ed28de42fc$var$endTagInTableBody(p, token) {
    const tn = token.tagID;
    switch(token.tagID){
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TBODY:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TFOOT:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).THEAD:
            if (p.openElements.hasInTableScope(tn)) {
                p.openElements.clearBackToTableBodyContext();
                p.openElements.pop();
                p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_TABLE;
            }
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TABLE:
            if (p.openElements.hasTableBodyContextInTableScope()) {
                p.openElements.clearBackToTableBodyContext();
                p.openElements.pop();
                p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_TABLE;
                $603fd1ed28de42fc$var$endTagInTable(p, token);
            }
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BODY:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).CAPTION:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).COL:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).COLGROUP:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HTML:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TD:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TH:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TR:
            break;
        default:
            $603fd1ed28de42fc$var$endTagInTable(p, token);
    }
}
// The "in row" insertion mode
//------------------------------------------------------------------
function $603fd1ed28de42fc$var$startTagInRow(p, token) {
    switch(token.tagID){
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TH:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TD:
            p.openElements.clearBackToTableRowContext();
            p._insertElement(token, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML);
            p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_CELL;
            p.activeFormattingElements.insertMarker();
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).CAPTION:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).COL:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).COLGROUP:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TBODY:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TFOOT:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).THEAD:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TR:
            if (p.openElements.hasInTableScope((0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TR)) {
                p.openElements.clearBackToTableRowContext();
                p.openElements.pop();
                p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_TABLE_BODY;
                $603fd1ed28de42fc$var$startTagInTableBody(p, token);
            }
            break;
        default:
            $603fd1ed28de42fc$var$startTagInTable(p, token);
    }
}
function $603fd1ed28de42fc$var$endTagInRow(p, token) {
    switch(token.tagID){
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TR:
            if (p.openElements.hasInTableScope((0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TR)) {
                p.openElements.clearBackToTableRowContext();
                p.openElements.pop();
                p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_TABLE_BODY;
            }
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TABLE:
            if (p.openElements.hasInTableScope((0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TR)) {
                p.openElements.clearBackToTableRowContext();
                p.openElements.pop();
                p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_TABLE_BODY;
                $603fd1ed28de42fc$var$endTagInTableBody(p, token);
            }
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TBODY:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TFOOT:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).THEAD:
            if (p.openElements.hasInTableScope(token.tagID) || p.openElements.hasInTableScope((0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TR)) {
                p.openElements.clearBackToTableRowContext();
                p.openElements.pop();
                p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_TABLE_BODY;
                $603fd1ed28de42fc$var$endTagInTableBody(p, token);
            }
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BODY:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).CAPTION:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).COL:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).COLGROUP:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HTML:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TD:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TH:
            break;
        default:
            $603fd1ed28de42fc$var$endTagInTable(p, token);
    }
}
// The "in cell" insertion mode
//------------------------------------------------------------------
function $603fd1ed28de42fc$var$startTagInCell(p, token) {
    const tn = token.tagID;
    if ($603fd1ed28de42fc$var$TABLE_VOID_ELEMENTS.has(tn)) {
        if (p.openElements.hasInTableScope((0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TD) || p.openElements.hasInTableScope((0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TH)) {
            p._closeTableCell();
            $603fd1ed28de42fc$var$startTagInRow(p, token);
        }
    } else $603fd1ed28de42fc$var$startTagInBody(p, token);
}
function $603fd1ed28de42fc$var$endTagInCell(p, token) {
    const tn = token.tagID;
    switch(tn){
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TD:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TH:
            if (p.openElements.hasInTableScope(tn)) {
                p.openElements.generateImpliedEndTags();
                p.openElements.popUntilTagNamePopped(tn);
                p.activeFormattingElements.clearToLastMarker();
                p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_ROW;
            }
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TABLE:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TBODY:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TFOOT:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).THEAD:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TR:
            if (p.openElements.hasInTableScope(tn)) {
                p._closeTableCell();
                $603fd1ed28de42fc$var$endTagInRow(p, token);
            }
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BODY:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).CAPTION:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).COL:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).COLGROUP:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HTML:
            break;
        default:
            $603fd1ed28de42fc$var$endTagInBody(p, token);
    }
}
// The "in select" insertion mode
//------------------------------------------------------------------
function $603fd1ed28de42fc$var$startTagInSelect(p, token) {
    switch(token.tagID){
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HTML:
            $603fd1ed28de42fc$var$startTagInBody(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).OPTION:
            if (p.openElements.currentTagId === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).OPTION) p.openElements.pop();
            p._insertElement(token, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).OPTGROUP:
            if (p.openElements.currentTagId === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).OPTION) p.openElements.pop();
            if (p.openElements.currentTagId === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).OPTGROUP) p.openElements.pop();
            p._insertElement(token, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).INPUT:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).KEYGEN:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TEXTAREA:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).SELECT:
            if (p.openElements.hasInSelectScope((0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).SELECT)) {
                p.openElements.popUntilTagNamePopped((0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).SELECT);
                p._resetInsertionMode();
                if (token.tagID !== (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).SELECT) p._processStartTag(token);
            }
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).SCRIPT:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TEMPLATE:
            $603fd1ed28de42fc$var$startTagInHead(p, token);
            break;
        default:
    }
}
function $603fd1ed28de42fc$var$endTagInSelect(p, token) {
    switch(token.tagID){
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).OPTGROUP:
            if (p.openElements.stackTop > 0 && p.openElements.currentTagId === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).OPTION && p.openElements.tagIDs[p.openElements.stackTop - 1] === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).OPTGROUP) p.openElements.pop();
            if (p.openElements.currentTagId === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).OPTGROUP) p.openElements.pop();
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).OPTION:
            if (p.openElements.currentTagId === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).OPTION) p.openElements.pop();
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).SELECT:
            if (p.openElements.hasInSelectScope((0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).SELECT)) {
                p.openElements.popUntilTagNamePopped((0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).SELECT);
                p._resetInsertionMode();
            }
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TEMPLATE:
            $603fd1ed28de42fc$var$templateEndTagInHead(p, token);
            break;
        default:
    }
}
// The "in select in table" insertion mode
//------------------------------------------------------------------
function $603fd1ed28de42fc$var$startTagInSelectInTable(p, token) {
    const tn = token.tagID;
    if (tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).CAPTION || tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TABLE || tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TBODY || tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TFOOT || tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).THEAD || tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TR || tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TD || tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TH) {
        p.openElements.popUntilTagNamePopped((0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).SELECT);
        p._resetInsertionMode();
        p._processStartTag(token);
    } else $603fd1ed28de42fc$var$startTagInSelect(p, token);
}
function $603fd1ed28de42fc$var$endTagInSelectInTable(p, token) {
    const tn = token.tagID;
    if (tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).CAPTION || tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TABLE || tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TBODY || tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TFOOT || tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).THEAD || tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TR || tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TD || tn === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TH) {
        if (p.openElements.hasInTableScope(tn)) {
            p.openElements.popUntilTagNamePopped((0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).SELECT);
            p._resetInsertionMode();
            p.onEndTag(token);
        }
    } else $603fd1ed28de42fc$var$endTagInSelect(p, token);
}
// The "in template" insertion mode
//------------------------------------------------------------------
function $603fd1ed28de42fc$var$startTagInTemplate(p, token) {
    switch(token.tagID){
        // First, handle tags that can start without a mode change
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BASE:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BASEFONT:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BGSOUND:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).LINK:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).META:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).NOFRAMES:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).SCRIPT:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).STYLE:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TEMPLATE:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TITLE:
            $603fd1ed28de42fc$var$startTagInHead(p, token);
            break;
        // Re-process the token in the appropriate mode
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).CAPTION:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).COLGROUP:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TBODY:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TFOOT:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).THEAD:
            p.tmplInsertionModeStack[0] = $603fd1ed28de42fc$var$InsertionMode.IN_TABLE;
            p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_TABLE;
            $603fd1ed28de42fc$var$startTagInTable(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).COL:
            p.tmplInsertionModeStack[0] = $603fd1ed28de42fc$var$InsertionMode.IN_COLUMN_GROUP;
            p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_COLUMN_GROUP;
            $603fd1ed28de42fc$var$startTagInColumnGroup(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TR:
            p.tmplInsertionModeStack[0] = $603fd1ed28de42fc$var$InsertionMode.IN_TABLE_BODY;
            p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_TABLE_BODY;
            $603fd1ed28de42fc$var$startTagInTableBody(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TD:
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TH:
            p.tmplInsertionModeStack[0] = $603fd1ed28de42fc$var$InsertionMode.IN_ROW;
            p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_ROW;
            $603fd1ed28de42fc$var$startTagInRow(p, token);
            break;
        default:
            p.tmplInsertionModeStack[0] = $603fd1ed28de42fc$var$InsertionMode.IN_BODY;
            p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_BODY;
            $603fd1ed28de42fc$var$startTagInBody(p, token);
    }
}
function $603fd1ed28de42fc$var$endTagInTemplate(p, token) {
    if (token.tagID === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TEMPLATE) $603fd1ed28de42fc$var$templateEndTagInHead(p, token);
}
function $603fd1ed28de42fc$var$eofInTemplate(p, token) {
    if (p.openElements.tmplCount > 0) {
        p.openElements.popUntilTagNamePopped((0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).TEMPLATE);
        p.activeFormattingElements.clearToLastMarker();
        p.tmplInsertionModeStack.shift();
        p._resetInsertionMode();
        p.onEof(token);
    } else $603fd1ed28de42fc$var$stopParsing(p, token);
}
// The "after body" insertion mode
//------------------------------------------------------------------
function $603fd1ed28de42fc$var$startTagAfterBody(p, token) {
    if (token.tagID === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HTML) $603fd1ed28de42fc$var$startTagInBody(p, token);
    else $603fd1ed28de42fc$var$tokenAfterBody(p, token);
}
function $603fd1ed28de42fc$var$endTagAfterBody(p, token) {
    var _a;
    if (token.tagID === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HTML) {
        if (!p.fragmentContext) p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.AFTER_AFTER_BODY;
        //NOTE: <html> is never popped from the stack, so we need to updated
        //the end location explicitly.
        if (p.options.sourceCodeLocationInfo && p.openElements.tagIDs[0] === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HTML) {
            p._setEndLocation(p.openElements.items[0], token);
            // Update the body element, if it doesn't have an end tag
            const bodyElement = p.openElements.items[1];
            if (bodyElement && !((_a = p.treeAdapter.getNodeSourceCodeLocation(bodyElement)) === null || _a === void 0 ? void 0 : _a.endTag)) p._setEndLocation(bodyElement, token);
        }
    } else $603fd1ed28de42fc$var$tokenAfterBody(p, token);
}
function $603fd1ed28de42fc$var$tokenAfterBody(p, token) {
    p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_BODY;
    $603fd1ed28de42fc$var$modeInBody(p, token);
}
// The "in frameset" insertion mode
//------------------------------------------------------------------
function $603fd1ed28de42fc$var$startTagInFrameset(p, token) {
    switch(token.tagID){
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HTML:
            $603fd1ed28de42fc$var$startTagInBody(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).FRAMESET:
            p._insertElement(token, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).FRAME:
            p._appendElement(token, (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML);
            token.ackSelfClosing = true;
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).NOFRAMES:
            $603fd1ed28de42fc$var$startTagInHead(p, token);
            break;
        default:
    }
}
function $603fd1ed28de42fc$var$endTagInFrameset(p, token) {
    if (token.tagID === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).FRAMESET && !p.openElements.isRootHtmlElementCurrent()) {
        p.openElements.pop();
        if (!p.fragmentContext && p.openElements.currentTagId !== (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).FRAMESET) p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.AFTER_FRAMESET;
    }
}
// The "after frameset" insertion mode
//------------------------------------------------------------------
function $603fd1ed28de42fc$var$startTagAfterFrameset(p, token) {
    switch(token.tagID){
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HTML:
            $603fd1ed28de42fc$var$startTagInBody(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).NOFRAMES:
            $603fd1ed28de42fc$var$startTagInHead(p, token);
            break;
        default:
    }
}
function $603fd1ed28de42fc$var$endTagAfterFrameset(p, token) {
    if (token.tagID === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HTML) p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.AFTER_AFTER_FRAMESET;
}
// The "after after body" insertion mode
//------------------------------------------------------------------
function $603fd1ed28de42fc$var$startTagAfterAfterBody(p, token) {
    if (token.tagID === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HTML) $603fd1ed28de42fc$var$startTagInBody(p, token);
    else $603fd1ed28de42fc$var$tokenAfterAfterBody(p, token);
}
function $603fd1ed28de42fc$var$tokenAfterAfterBody(p, token) {
    p.insertionMode = $603fd1ed28de42fc$var$InsertionMode.IN_BODY;
    $603fd1ed28de42fc$var$modeInBody(p, token);
}
// The "after after frameset" insertion mode
//------------------------------------------------------------------
function $603fd1ed28de42fc$var$startTagAfterAfterFrameset(p, token) {
    switch(token.tagID){
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).HTML:
            $603fd1ed28de42fc$var$startTagInBody(p, token);
            break;
        case (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).NOFRAMES:
            $603fd1ed28de42fc$var$startTagInHead(p, token);
            break;
        default:
    }
}
// The rules for parsing tokens in foreign content
//------------------------------------------------------------------
function $603fd1ed28de42fc$var$nullCharacterInForeignContent(p, token) {
    token.chars = $6c7c9c6fba662a30$export$e8d20e7a50e6c279;
    p._insertCharacters(token);
}
function $603fd1ed28de42fc$var$characterInForeignContent(p, token) {
    p._insertCharacters(token);
    p.framesetOk = false;
}
function $603fd1ed28de42fc$var$popUntilHtmlOrIntegrationPoint(p) {
    while(p.treeAdapter.getNamespaceURI(p.openElements.current) !== (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML && !p._isIntegrationPoint(p.openElements.currentTagId, p.openElements.current))p.openElements.pop();
}
function $603fd1ed28de42fc$var$startTagInForeignContent(p, token) {
    if ($96fb900eda529a8a$export$3435eb4ab4d2ed2d(token)) {
        $603fd1ed28de42fc$var$popUntilHtmlOrIntegrationPoint(p);
        p._startTagOutsideForeignContent(token);
    } else {
        const current = p._getAdjustedCurrentElement();
        const currentNs = p.treeAdapter.getNamespaceURI(current);
        if (currentNs === (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).MATHML) $96fb900eda529a8a$export$c583cc5a9d633feb(token);
        else if (currentNs === (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).SVG) {
            $96fb900eda529a8a$export$95df78fe2e7f33e3(token);
            $96fb900eda529a8a$export$74ce06f755fb8f68(token);
        }
        $96fb900eda529a8a$export$a5192af02995cbdc(token);
        if (token.selfClosing) p._appendElement(token, currentNs);
        else p._insertElement(token, currentNs);
        token.ackSelfClosing = true;
    }
}
function $603fd1ed28de42fc$var$endTagInForeignContent(p, token) {
    if (token.tagID === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).P || token.tagID === (0, $0ddaebefe9b4fbd6$export$cb0999a53e0acaed).BR) {
        $603fd1ed28de42fc$var$popUntilHtmlOrIntegrationPoint(p);
        p._endTagOutsideForeignContent(token);
        return;
    }
    for(let i = p.openElements.stackTop; i > 0; i--){
        const element = p.openElements.items[i];
        if (p.treeAdapter.getNamespaceURI(element) === (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML) {
            p._endTagOutsideForeignContent(token);
            break;
        }
        const tagName = p.treeAdapter.getTagName(element);
        if (tagName.toLowerCase() === token.tagName) {
            //NOTE: update the token tag name for `_setEndLocation`.
            token.tagName = tagName;
            p.openElements.shortenToLength(i);
            break;
        }
    }
} //# sourceMappingURL=index.js.map




var $6ccac896d029b776$exports = {};
"use strict";
Object.defineProperty($6ccac896d029b776$exports, "__esModule", {
    value: true
});
$6ccac896d029b776$exports.escapeText = $6ccac896d029b776$exports.escapeAttribute = $6ccac896d029b776$exports.escapeUTF8 = $6ccac896d029b776$exports.escape = $6ccac896d029b776$exports.encodeXML = $6ccac896d029b776$exports.getCodePoint = $6ccac896d029b776$exports.xmlReplacer = void 0;
$6ccac896d029b776$exports.xmlReplacer = /["&'<>$\x80-\uFFFF]/g;
var $6ccac896d029b776$var$xmlCodeMap = new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        39,
        "&apos;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ]
]);
// For compatibility with node < 4, we wrap `codePointAt`
$6ccac896d029b776$exports.getCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
String.prototype.codePointAt != null ? function(str, index) {
    return str.codePointAt(index);
} : function(c, index) {
    return (c.charCodeAt(index) & 0xfc00) === 0xd800 ? (c.charCodeAt(index) - 0xd800) * 0x400 + c.charCodeAt(index + 1) - 0xdc00 + 0x10000 : c.charCodeAt(index);
};
/**
 * Encodes all non-ASCII characters, as well as characters not valid in XML
 * documents using XML entities.
 *
 * If a character has no equivalent entity, a
 * numeric hexadecimal reference (eg. `&#xfc;`) will be used.
 */ function $6ccac896d029b776$var$encodeXML(str) {
    var ret = "";
    var lastIdx = 0;
    var match;
    while((match = $6ccac896d029b776$exports.xmlReplacer.exec(str)) !== null){
        var i = match.index;
        var char = str.charCodeAt(i);
        var next = $6ccac896d029b776$var$xmlCodeMap.get(char);
        if (next !== undefined) {
            ret += str.substring(lastIdx, i) + next;
            lastIdx = i + 1;
        } else {
            ret += "".concat(str.substring(lastIdx, i), "&#x").concat((0, $6ccac896d029b776$exports.getCodePoint)(str, i).toString(16), ";");
            // Increase by 1 if we have a surrogate pair
            lastIdx = $6ccac896d029b776$exports.xmlReplacer.lastIndex += Number((char & 0xfc00) === 0xd800);
        }
    }
    return ret + str.substr(lastIdx);
}
$6ccac896d029b776$exports.encodeXML = $6ccac896d029b776$var$encodeXML;
/**
 * Encodes all non-ASCII characters, as well as characters not valid in XML
 * documents using numeric hexadecimal reference (eg. `&#xfc;`).
 *
 * Have a look at `escapeUTF8` if you want a more concise output at the expense
 * of reduced transportability.
 *
 * @param data String to escape.
 */ $6ccac896d029b776$exports.escape = $6ccac896d029b776$var$encodeXML;
/**
 * Creates a function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 *
 * @param regex Regular expression to match characters to escape.
 * @param map Map of characters to escape to their entities.
 *
 * @returns Function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 */ function $6ccac896d029b776$var$getEscaper(regex, map) {
    return function escape(data) {
        var match;
        var lastIdx = 0;
        var result = "";
        while(match = regex.exec(data)){
            if (lastIdx !== match.index) result += data.substring(lastIdx, match.index);
            // We know that this character will be in the map.
            result += map.get(match[0].charCodeAt(0));
            // Every match will be of length 1
            lastIdx = match.index + 1;
        }
        return result + data.substring(lastIdx);
    };
}
/**
 * Encodes all characters not valid in XML documents using XML entities.
 *
 * Note that the output will be character-set dependent.
 *
 * @param data String to escape.
 */ $6ccac896d029b776$exports.escapeUTF8 = $6ccac896d029b776$var$getEscaper(/[&<>'"]/g, $6ccac896d029b776$var$xmlCodeMap);
/**
 * Encodes all characters that have to be escaped in HTML attributes,
 * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
 *
 * @param data String to escape.
 */ $6ccac896d029b776$exports.escapeAttribute = $6ccac896d029b776$var$getEscaper(/["&\u00A0]/g, new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));
/**
 * Encodes all characters that have to be escaped in HTML text,
 * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
 *
 * @param data String to escape.
 */ $6ccac896d029b776$exports.escapeText = $6ccac896d029b776$var$getEscaper(/[&<>\u00A0]/g, new Map([
    [
        38,
        "&amp;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));



// Sets
const $6a92347b221b809d$var$VOID_ELEMENTS = new Set([
    (0, $0ddaebefe9b4fbd6$export$7e674a85a2656dce).AREA,
    (0, $0ddaebefe9b4fbd6$export$7e674a85a2656dce).BASE,
    (0, $0ddaebefe9b4fbd6$export$7e674a85a2656dce).BASEFONT,
    (0, $0ddaebefe9b4fbd6$export$7e674a85a2656dce).BGSOUND,
    (0, $0ddaebefe9b4fbd6$export$7e674a85a2656dce).BR,
    (0, $0ddaebefe9b4fbd6$export$7e674a85a2656dce).COL,
    (0, $0ddaebefe9b4fbd6$export$7e674a85a2656dce).EMBED,
    (0, $0ddaebefe9b4fbd6$export$7e674a85a2656dce).FRAME,
    (0, $0ddaebefe9b4fbd6$export$7e674a85a2656dce).HR,
    (0, $0ddaebefe9b4fbd6$export$7e674a85a2656dce).IMG,
    (0, $0ddaebefe9b4fbd6$export$7e674a85a2656dce).INPUT,
    (0, $0ddaebefe9b4fbd6$export$7e674a85a2656dce).KEYGEN,
    (0, $0ddaebefe9b4fbd6$export$7e674a85a2656dce).LINK,
    (0, $0ddaebefe9b4fbd6$export$7e674a85a2656dce).META,
    (0, $0ddaebefe9b4fbd6$export$7e674a85a2656dce).PARAM,
    (0, $0ddaebefe9b4fbd6$export$7e674a85a2656dce).SOURCE,
    (0, $0ddaebefe9b4fbd6$export$7e674a85a2656dce).TRACK,
    (0, $0ddaebefe9b4fbd6$export$7e674a85a2656dce).WBR
]);
function $6a92347b221b809d$var$isVoidElement(node, options) {
    return options.treeAdapter.isElementNode(node) && options.treeAdapter.getNamespaceURI(node) === (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML && $6a92347b221b809d$var$VOID_ELEMENTS.has(options.treeAdapter.getTagName(node));
}
const $6a92347b221b809d$var$defaultOpts = {
    treeAdapter: (0, $d477d1ad14c7d387$export$7ddbba828dfa4796),
    scriptingEnabled: true
};
function $6a92347b221b809d$export$dfdc1655ccc5b9cb(node, options) {
    const opts = {
        ...$6a92347b221b809d$var$defaultOpts,
        ...options
    };
    if ($6a92347b221b809d$var$isVoidElement(node, opts)) return '';
    return $6a92347b221b809d$var$serializeChildNodes(node, opts);
}
function $6a92347b221b809d$export$71e9c1f1ceb5a856(node, options) {
    const opts = {
        ...$6a92347b221b809d$var$defaultOpts,
        ...options
    };
    return $6a92347b221b809d$var$serializeNode(node, opts);
}
function $6a92347b221b809d$var$serializeChildNodes(parentNode, options) {
    let html = '';
    // Get container of the child nodes
    const container = options.treeAdapter.isElementNode(parentNode) && options.treeAdapter.getTagName(parentNode) === (0, $0ddaebefe9b4fbd6$export$7e674a85a2656dce).TEMPLATE && options.treeAdapter.getNamespaceURI(parentNode) === (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML ? options.treeAdapter.getTemplateContent(parentNode) : parentNode;
    const childNodes = options.treeAdapter.getChildNodes(container);
    if (childNodes) for (const currentNode of childNodes)html += $6a92347b221b809d$var$serializeNode(currentNode, options);
    return html;
}
function $6a92347b221b809d$var$serializeNode(node, options) {
    if (options.treeAdapter.isElementNode(node)) return $6a92347b221b809d$var$serializeElement(node, options);
    if (options.treeAdapter.isTextNode(node)) return $6a92347b221b809d$var$serializeTextNode(node, options);
    if (options.treeAdapter.isCommentNode(node)) return $6a92347b221b809d$var$serializeCommentNode(node, options);
    if (options.treeAdapter.isDocumentTypeNode(node)) return $6a92347b221b809d$var$serializeDocumentTypeNode(node, options);
    // Return an empty string for unknown nodes
    return '';
}
function $6a92347b221b809d$var$serializeElement(node, options) {
    const tn = options.treeAdapter.getTagName(node);
    return `<${tn}${$6a92347b221b809d$var$serializeAttributes(node, options)}>${$6a92347b221b809d$var$isVoidElement(node, options) ? '' : `${$6a92347b221b809d$var$serializeChildNodes(node, options)}</${tn}>`}`;
}
function $6a92347b221b809d$var$serializeAttributes(node, { treeAdapter: treeAdapter }) {
    let html = '';
    for (const attr of treeAdapter.getAttrList(node)){
        html += ' ';
        if (!attr.namespace) html += attr.name;
        else switch(attr.namespace){
            case (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).XML:
                html += `xml:${attr.name}`;
                break;
            case (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).XMLNS:
                if (attr.name !== 'xmlns') html += 'xmlns:';
                html += attr.name;
                break;
            case (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).XLINK:
                html += `xlink:${attr.name}`;
                break;
            default:
                html += `${attr.prefix}:${attr.name}`;
        }
        html += `="${(0, $6ccac896d029b776$exports.escapeAttribute)(attr.value)}"`;
    }
    return html;
}
function $6a92347b221b809d$var$serializeTextNode(node, options) {
    const { treeAdapter: treeAdapter } = options;
    const content = treeAdapter.getTextNodeContent(node);
    const parent = treeAdapter.getParentNode(node);
    const parentTn = parent && treeAdapter.isElementNode(parent) && treeAdapter.getTagName(parent);
    return parentTn && treeAdapter.getNamespaceURI(parent) === (0, $0ddaebefe9b4fbd6$export$fb4028874a74450).HTML && (0, $0ddaebefe9b4fbd6$export$4ce4f8c09f921aed)(parentTn, options.scriptingEnabled) ? content : (0, $6ccac896d029b776$exports.escapeText)(content);
}
function $6a92347b221b809d$var$serializeCommentNode(node, { treeAdapter: treeAdapter }) {
    return `<!--${treeAdapter.getCommentNodeContent(node)}-->`;
}
function $6a92347b221b809d$var$serializeDocumentTypeNode(node, { treeAdapter: treeAdapter }) {
    return `<!DOCTYPE ${treeAdapter.getDocumentTypeNodeName(node)}>`;
} //# sourceMappingURL=index.js.map







function $56ee2c4510d5e344$export$98e6a39c04603d36(html, options) {
    return (0, $603fd1ed28de42fc$export$7acfa6ed01010e37).parse(html, options);
}
function $56ee2c4510d5e344$export$e1152f5efcc82ad(fragmentContext, html, options) {
    if (typeof fragmentContext === 'string') {
        options = html;
        html = fragmentContext;
        fragmentContext = null;
    }
    const parser = (0, $603fd1ed28de42fc$export$7acfa6ed01010e37).getFragmentParser(fragmentContext, options);
    parser.tokenizer.write(html, true);
    return parser.getFragment();
} //# sourceMappingURL=index.js.map



parcelRequire("273yd");
var $k9MHs = parcelRequire("k9MHs");
function $9f783ae40eee12d1$var$createTextNode(value) {
    return new (0, $k9MHs.Text)(value);
}
function $9f783ae40eee12d1$var$enquoteDoctypeId(id) {
    const quote = id.includes('"') ? "'" : '"';
    return quote + id + quote;
}
function $9f783ae40eee12d1$export$28adbdf76da34d76(name, publicId, systemId) {
    let str = '!DOCTYPE ';
    if (name) str += name;
    if (publicId) str += ` PUBLIC ${$9f783ae40eee12d1$var$enquoteDoctypeId(publicId)}`;
    else if (systemId) str += ' SYSTEM';
    if (systemId) str += ` ${$9f783ae40eee12d1$var$enquoteDoctypeId(systemId)}`;
    return str;
}
const $9f783ae40eee12d1$export$e00c9c6684b0ace = {
    // Re-exports from domhandler
    isCommentNode: (0, $k9MHs.isComment),
    isElementNode: (0, $k9MHs.isTag),
    isTextNode: (0, $k9MHs.isText),
    //Node construction
    createDocument () {
        const node = new (0, $k9MHs.Document)([]);
        node['x-mode'] = (0, $0ddaebefe9b4fbd6$exports).DOCUMENT_MODE.NO_QUIRKS;
        return node;
    },
    createDocumentFragment () {
        return new (0, $k9MHs.Document)([]);
    },
    createElement (tagName, namespaceURI, attrs) {
        const attribs = Object.create(null);
        const attribsNamespace = Object.create(null);
        const attribsPrefix = Object.create(null);
        for(let i = 0; i < attrs.length; i++){
            const attrName = attrs[i].name;
            attribs[attrName] = attrs[i].value;
            attribsNamespace[attrName] = attrs[i].namespace;
            attribsPrefix[attrName] = attrs[i].prefix;
        }
        const node = new (0, $k9MHs.Element)(tagName, attribs, []);
        node.namespace = namespaceURI;
        node['x-attribsNamespace'] = attribsNamespace;
        node['x-attribsPrefix'] = attribsPrefix;
        return node;
    },
    createCommentNode (data) {
        return new (0, $k9MHs.Comment)(data);
    },
    //Tree mutation
    appendChild (parentNode, newNode) {
        const prev = parentNode.children[parentNode.children.length - 1];
        if (prev) {
            prev.next = newNode;
            newNode.prev = prev;
        }
        parentNode.children.push(newNode);
        newNode.parent = parentNode;
    },
    insertBefore (parentNode, newNode, referenceNode) {
        const insertionIdx = parentNode.children.indexOf(referenceNode);
        const { prev: prev } = referenceNode;
        if (prev) {
            prev.next = newNode;
            newNode.prev = prev;
        }
        referenceNode.prev = newNode;
        newNode.next = referenceNode;
        parentNode.children.splice(insertionIdx, 0, newNode);
        newNode.parent = parentNode;
    },
    setTemplateContent (templateElement, contentElement) {
        $9f783ae40eee12d1$export$e00c9c6684b0ace.appendChild(templateElement, contentElement);
    },
    getTemplateContent (templateElement) {
        return templateElement.children[0];
    },
    setDocumentType (document, name, publicId, systemId) {
        const data = $9f783ae40eee12d1$export$28adbdf76da34d76(name, publicId, systemId);
        let doctypeNode = document.children.find((node)=>(0, $k9MHs.isDirective)(node) && node.name === '!doctype');
        if (doctypeNode) doctypeNode.data = data !== null && data !== void 0 ? data : null;
        else {
            doctypeNode = new (0, $k9MHs.ProcessingInstruction)('!doctype', data);
            $9f783ae40eee12d1$export$e00c9c6684b0ace.appendChild(document, doctypeNode);
        }
        doctypeNode['x-name'] = name !== null && name !== void 0 ? name : undefined;
        doctypeNode['x-publicId'] = publicId !== null && publicId !== void 0 ? publicId : undefined;
        doctypeNode['x-systemId'] = systemId !== null && systemId !== void 0 ? systemId : undefined;
    },
    setDocumentMode (document, mode) {
        document['x-mode'] = mode;
    },
    getDocumentMode (document) {
        return document['x-mode'];
    },
    detachNode (node) {
        if (node.parent) {
            const idx = node.parent.children.indexOf(node);
            const { prev: prev, next: next } = node;
            node.prev = null;
            node.next = null;
            if (prev) prev.next = next;
            if (next) next.prev = prev;
            node.parent.children.splice(idx, 1);
            node.parent = null;
        }
    },
    insertText (parentNode, text) {
        const lastChild = parentNode.children[parentNode.children.length - 1];
        if (lastChild && (0, $k9MHs.isText)(lastChild)) lastChild.data += text;
        else $9f783ae40eee12d1$export$e00c9c6684b0ace.appendChild(parentNode, $9f783ae40eee12d1$var$createTextNode(text));
    },
    insertTextBefore (parentNode, text, referenceNode) {
        const prevNode = parentNode.children[parentNode.children.indexOf(referenceNode) - 1];
        if (prevNode && (0, $k9MHs.isText)(prevNode)) prevNode.data += text;
        else $9f783ae40eee12d1$export$e00c9c6684b0ace.insertBefore(parentNode, $9f783ae40eee12d1$var$createTextNode(text), referenceNode);
    },
    adoptAttributes (recipient, attrs) {
        for(let i = 0; i < attrs.length; i++){
            const attrName = attrs[i].name;
            if (typeof recipient.attribs[attrName] === 'undefined') {
                recipient.attribs[attrName] = attrs[i].value;
                recipient['x-attribsNamespace'][attrName] = attrs[i].namespace;
                recipient['x-attribsPrefix'][attrName] = attrs[i].prefix;
            }
        }
    },
    //Tree traversing
    getFirstChild (node) {
        return node.children[0];
    },
    getChildNodes (node) {
        return node.children;
    },
    getParentNode (node) {
        return node.parent;
    },
    getAttrList (element) {
        return element.attributes;
    },
    //Node data
    getTagName (element) {
        return element.name;
    },
    getNamespaceURI (element) {
        return element.namespace;
    },
    getTextNodeContent (textNode) {
        return textNode.data;
    },
    getCommentNodeContent (commentNode) {
        return commentNode.data;
    },
    getDocumentTypeNodeName (doctypeNode) {
        var _a;
        return (_a = doctypeNode['x-name']) !== null && _a !== void 0 ? _a : '';
    },
    getDocumentTypeNodePublicId (doctypeNode) {
        var _a;
        return (_a = doctypeNode['x-publicId']) !== null && _a !== void 0 ? _a : '';
    },
    getDocumentTypeNodeSystemId (doctypeNode) {
        var _a;
        return (_a = doctypeNode['x-systemId']) !== null && _a !== void 0 ? _a : '';
    },
    //Node types
    isDocumentTypeNode (node) {
        return (0, $k9MHs.isDirective)(node) && node.name === '!doctype';
    },
    // Source code location
    setNodeSourceCodeLocation (node, location) {
        if (location) {
            node.startIndex = location.startOffset;
            node.endIndex = location.endOffset;
        }
        node.sourceCodeLocation = location;
    },
    getNodeSourceCodeLocation (node) {
        return node.sourceCodeLocation;
    },
    updateNodeSourceCodeLocation (node, endLocation) {
        if (endLocation.endOffset != null) node.endIndex = endLocation.endOffset;
        node.sourceCodeLocation = {
            ...node.sourceCodeLocation,
            ...endLocation
        };
    }
}; //# sourceMappingURL=index.js.map


function $39a32800143300a9$export$2f1ddab8b648d7f6(content, options, isDocument, context) {
    const opts = {
        scriptingEnabled: typeof options.scriptingEnabled === 'boolean' ? options.scriptingEnabled : true,
        treeAdapter: (0, $9f783ae40eee12d1$export$e00c9c6684b0ace),
        sourceCodeLocationInfo: options.sourceCodeLocationInfo
    };
    return isDocument ? (0, $56ee2c4510d5e344$export$98e6a39c04603d36)(content, opts) : (0, $56ee2c4510d5e344$export$e1152f5efcc82ad)(context, content, opts);
}
const $39a32800143300a9$var$renderOpts = {
    treeAdapter: (0, $9f783ae40eee12d1$export$e00c9c6684b0ace)
};
function $39a32800143300a9$export$af75b43ff4abe814(dom) {
    /*
     * `dom-serializer` passes over the special "root" node and renders the
     * node's children in its place. To mimic this behavior with `parse5`, an
     * equivalent operation must be applied to the input array.
     */ const nodes = 'length' in dom ? dom : [
        dom
    ];
    for(let index = 0; index < nodes.length; index += 1){
        const node = nodes[index];
        if ((0, $k9MHs.isDocument)(node)) Array.prototype.splice.call(nodes, index, 1, ...node.children);
    }
    let result = '';
    for(let index = 0; index < nodes.length; index += 1){
        const node = nodes[index];
        result += (0, $6a92347b221b809d$export$71e9c1f1ceb5a856)(node, $39a32800143300a9$var$renderOpts);
    }
    return result;
}



var $iwhG6 = parcelRequire("iwhG6");

var $ac9b791c5e3389db$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["Tab"] = 9] = "Tab";
    CharCodes[CharCodes["NewLine"] = 10] = "NewLine";
    CharCodes[CharCodes["FormFeed"] = 12] = "FormFeed";
    CharCodes[CharCodes["CarriageReturn"] = 13] = "CarriageReturn";
    CharCodes[CharCodes["Space"] = 32] = "Space";
    CharCodes[CharCodes["ExclamationMark"] = 33] = "ExclamationMark";
    CharCodes[CharCodes["Number"] = 35] = "Number";
    CharCodes[CharCodes["Amp"] = 38] = "Amp";
    CharCodes[CharCodes["SingleQuote"] = 39] = "SingleQuote";
    CharCodes[CharCodes["DoubleQuote"] = 34] = "DoubleQuote";
    CharCodes[CharCodes["Dash"] = 45] = "Dash";
    CharCodes[CharCodes["Slash"] = 47] = "Slash";
    CharCodes[CharCodes["Zero"] = 48] = "Zero";
    CharCodes[CharCodes["Nine"] = 57] = "Nine";
    CharCodes[CharCodes["Semi"] = 59] = "Semi";
    CharCodes[CharCodes["Lt"] = 60] = "Lt";
    CharCodes[CharCodes["Eq"] = 61] = "Eq";
    CharCodes[CharCodes["Gt"] = 62] = "Gt";
    CharCodes[CharCodes["Questionmark"] = 63] = "Questionmark";
    CharCodes[CharCodes["UpperA"] = 65] = "UpperA";
    CharCodes[CharCodes["LowerA"] = 97] = "LowerA";
    CharCodes[CharCodes["UpperF"] = 70] = "UpperF";
    CharCodes[CharCodes["LowerF"] = 102] = "LowerF";
    CharCodes[CharCodes["UpperZ"] = 90] = "UpperZ";
    CharCodes[CharCodes["LowerZ"] = 122] = "LowerZ";
    CharCodes[CharCodes["LowerX"] = 120] = "LowerX";
    CharCodes[CharCodes["OpeningSquareBracket"] = 91] = "OpeningSquareBracket";
})($ac9b791c5e3389db$var$CharCodes || ($ac9b791c5e3389db$var$CharCodes = {}));
/** All the states the tokenizer can be in. */ var $ac9b791c5e3389db$var$State;
(function(State) {
    State[State["Text"] = 1] = "Text";
    State[State["BeforeTagName"] = 2] = "BeforeTagName";
    State[State["InTagName"] = 3] = "InTagName";
    State[State["InSelfClosingTag"] = 4] = "InSelfClosingTag";
    State[State["BeforeClosingTagName"] = 5] = "BeforeClosingTagName";
    State[State["InClosingTagName"] = 6] = "InClosingTagName";
    State[State["AfterClosingTagName"] = 7] = "AfterClosingTagName";
    // Attributes
    State[State["BeforeAttributeName"] = 8] = "BeforeAttributeName";
    State[State["InAttributeName"] = 9] = "InAttributeName";
    State[State["AfterAttributeName"] = 10] = "AfterAttributeName";
    State[State["BeforeAttributeValue"] = 11] = "BeforeAttributeValue";
    State[State["InAttributeValueDq"] = 12] = "InAttributeValueDq";
    State[State["InAttributeValueSq"] = 13] = "InAttributeValueSq";
    State[State["InAttributeValueNq"] = 14] = "InAttributeValueNq";
    // Declarations
    State[State["BeforeDeclaration"] = 15] = "BeforeDeclaration";
    State[State["InDeclaration"] = 16] = "InDeclaration";
    // Processing instructions
    State[State["InProcessingInstruction"] = 17] = "InProcessingInstruction";
    // Comments & CDATA
    State[State["BeforeComment"] = 18] = "BeforeComment";
    State[State["CDATASequence"] = 19] = "CDATASequence";
    State[State["InSpecialComment"] = 20] = "InSpecialComment";
    State[State["InCommentLike"] = 21] = "InCommentLike";
    // Special tags
    State[State["BeforeSpecialS"] = 22] = "BeforeSpecialS";
    State[State["SpecialStartSequence"] = 23] = "SpecialStartSequence";
    State[State["InSpecialTag"] = 24] = "InSpecialTag";
    State[State["BeforeEntity"] = 25] = "BeforeEntity";
    State[State["BeforeNumericEntity"] = 26] = "BeforeNumericEntity";
    State[State["InNamedEntity"] = 27] = "InNamedEntity";
    State[State["InNumericEntity"] = 28] = "InNumericEntity";
    State[State["InHexEntity"] = 29] = "InHexEntity";
})($ac9b791c5e3389db$var$State || ($ac9b791c5e3389db$var$State = {}));
function $ac9b791c5e3389db$var$isWhitespace(c) {
    return c === $ac9b791c5e3389db$var$CharCodes.Space || c === $ac9b791c5e3389db$var$CharCodes.NewLine || c === $ac9b791c5e3389db$var$CharCodes.Tab || c === $ac9b791c5e3389db$var$CharCodes.FormFeed || c === $ac9b791c5e3389db$var$CharCodes.CarriageReturn;
}
function $ac9b791c5e3389db$var$isEndOfTagSection(c) {
    return c === $ac9b791c5e3389db$var$CharCodes.Slash || c === $ac9b791c5e3389db$var$CharCodes.Gt || $ac9b791c5e3389db$var$isWhitespace(c);
}
function $ac9b791c5e3389db$var$isNumber(c) {
    return c >= $ac9b791c5e3389db$var$CharCodes.Zero && c <= $ac9b791c5e3389db$var$CharCodes.Nine;
}
function $ac9b791c5e3389db$var$isASCIIAlpha(c) {
    return c >= $ac9b791c5e3389db$var$CharCodes.LowerA && c <= $ac9b791c5e3389db$var$CharCodes.LowerZ || c >= $ac9b791c5e3389db$var$CharCodes.UpperA && c <= $ac9b791c5e3389db$var$CharCodes.UpperZ;
}
function $ac9b791c5e3389db$var$isHexDigit(c) {
    return c >= $ac9b791c5e3389db$var$CharCodes.UpperA && c <= $ac9b791c5e3389db$var$CharCodes.UpperF || c >= $ac9b791c5e3389db$var$CharCodes.LowerA && c <= $ac9b791c5e3389db$var$CharCodes.LowerF;
}
var $ac9b791c5e3389db$export$cbf5509cea2ad22;
(function(QuoteType) {
    QuoteType[QuoteType["NoValue"] = 0] = "NoValue";
    QuoteType[QuoteType["Unquoted"] = 1] = "Unquoted";
    QuoteType[QuoteType["Single"] = 2] = "Single";
    QuoteType[QuoteType["Double"] = 3] = "Double";
})($ac9b791c5e3389db$export$cbf5509cea2ad22 || ($ac9b791c5e3389db$export$cbf5509cea2ad22 = {}));
/**
 * Sequences used to match longer strings.
 *
 * We don't have `Script`, `Style`, or `Title` here. Instead, we re-use the *End
 * sequences with an increased offset.
 */ const $ac9b791c5e3389db$var$Sequences = {
    Cdata: new Uint8Array([
        0x43,
        0x44,
        0x41,
        0x54,
        0x41,
        0x5b
    ]),
    CdataEnd: new Uint8Array([
        0x5d,
        0x5d,
        0x3e
    ]),
    CommentEnd: new Uint8Array([
        0x2d,
        0x2d,
        0x3e
    ]),
    ScriptEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x73,
        0x63,
        0x72,
        0x69,
        0x70,
        0x74
    ]),
    StyleEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x73,
        0x74,
        0x79,
        0x6c,
        0x65
    ]),
    TitleEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x74,
        0x69,
        0x74,
        0x6c,
        0x65
    ])
};
class $ac9b791c5e3389db$export$2e2bcd8739ae039 {
    constructor({ xmlMode: xmlMode = false, decodeEntities: decodeEntities = true }, cbs){
        this.cbs = cbs;
        /** The current state the tokenizer is in. */ this.state = $ac9b791c5e3389db$var$State.Text;
        /** The read buffer. */ this.buffer = "";
        /** The beginning of the section that is currently being read. */ this.sectionStart = 0;
        /** The index within the buffer that we are currently looking at. */ this.index = 0;
        /** Some behavior, eg. when decoding entities, is done while we are in another state. This keeps track of the other state type. */ this.baseState = $ac9b791c5e3389db$var$State.Text;
        /** For special parsing behavior inside of script and style tags. */ this.isSpecial = false;
        /** Indicates whether the tokenizer has been paused. */ this.running = true;
        /** The offset of the current buffer. */ this.offset = 0;
        this.currentSequence = undefined;
        this.sequenceIndex = 0;
        this.trieIndex = 0;
        this.trieCurrent = 0;
        /** For named entities, the index of the value. For numeric entities, the code point. */ this.entityResult = 0;
        this.entityExcess = 0;
        this.xmlMode = xmlMode;
        this.decodeEntities = decodeEntities;
        this.entityTrie = xmlMode ? (0, $14589e7572d0431f$exports.xmlDecodeTree) : (0, $14589e7572d0431f$exports.htmlDecodeTree);
    }
    reset() {
        this.state = $ac9b791c5e3389db$var$State.Text;
        this.buffer = "";
        this.sectionStart = 0;
        this.index = 0;
        this.baseState = $ac9b791c5e3389db$var$State.Text;
        this.currentSequence = undefined;
        this.running = true;
        this.offset = 0;
    }
    write(chunk) {
        this.offset += this.buffer.length;
        this.buffer = chunk;
        this.parse();
    }
    end() {
        if (this.running) this.finish();
    }
    pause() {
        this.running = false;
    }
    resume() {
        this.running = true;
        if (this.index < this.buffer.length + this.offset) this.parse();
    }
    /**
     * The current index within all of the written data.
     */ getIndex() {
        return this.index;
    }
    /**
     * The start of the current section.
     */ getSectionStart() {
        return this.sectionStart;
    }
    stateText(c) {
        if (c === $ac9b791c5e3389db$var$CharCodes.Lt || !this.decodeEntities && this.fastForwardTo($ac9b791c5e3389db$var$CharCodes.Lt)) {
            if (this.index > this.sectionStart) this.cbs.ontext(this.sectionStart, this.index);
            this.state = $ac9b791c5e3389db$var$State.BeforeTagName;
            this.sectionStart = this.index;
        } else if (this.decodeEntities && c === $ac9b791c5e3389db$var$CharCodes.Amp) this.state = $ac9b791c5e3389db$var$State.BeforeEntity;
    }
    stateSpecialStartSequence(c) {
        const isEnd = this.sequenceIndex === this.currentSequence.length;
        const isMatch = isEnd ? $ac9b791c5e3389db$var$isEndOfTagSection(c) : (c | 0x20) === this.currentSequence[this.sequenceIndex];
        if (!isMatch) this.isSpecial = false;
        else if (!isEnd) {
            this.sequenceIndex++;
            return;
        }
        this.sequenceIndex = 0;
        this.state = $ac9b791c5e3389db$var$State.InTagName;
        this.stateInTagName(c);
    }
    /** Look for an end tag. For <title> tags, also decode entities. */ stateInSpecialTag(c) {
        if (this.sequenceIndex === this.currentSequence.length) {
            if (c === $ac9b791c5e3389db$var$CharCodes.Gt || $ac9b791c5e3389db$var$isWhitespace(c)) {
                const endOfText = this.index - this.currentSequence.length;
                if (this.sectionStart < endOfText) {
                    // Spoof the index so that reported locations match up.
                    const actualIndex = this.index;
                    this.index = endOfText;
                    this.cbs.ontext(this.sectionStart, endOfText);
                    this.index = actualIndex;
                }
                this.isSpecial = false;
                this.sectionStart = endOfText + 2; // Skip over the `</`
                this.stateInClosingTagName(c);
                return; // We are done; skip the rest of the function.
            }
            this.sequenceIndex = 0;
        }
        if ((c | 0x20) === this.currentSequence[this.sequenceIndex]) this.sequenceIndex += 1;
        else if (this.sequenceIndex === 0) {
            if (this.currentSequence === $ac9b791c5e3389db$var$Sequences.TitleEnd) // We have to parse entities in <title> tags.
            {
                if (this.decodeEntities && c === $ac9b791c5e3389db$var$CharCodes.Amp) this.state = $ac9b791c5e3389db$var$State.BeforeEntity;
            } else if (this.fastForwardTo($ac9b791c5e3389db$var$CharCodes.Lt)) // Outside of <title> tags, we can fast-forward.
            this.sequenceIndex = 1;
        } else // If we see a `<`, set the sequence index to 1; useful for eg. `<</script>`.
        this.sequenceIndex = Number(c === $ac9b791c5e3389db$var$CharCodes.Lt);
    }
    stateCDATASequence(c) {
        if (c === $ac9b791c5e3389db$var$Sequences.Cdata[this.sequenceIndex]) {
            if (++this.sequenceIndex === $ac9b791c5e3389db$var$Sequences.Cdata.length) {
                this.state = $ac9b791c5e3389db$var$State.InCommentLike;
                this.currentSequence = $ac9b791c5e3389db$var$Sequences.CdataEnd;
                this.sequenceIndex = 0;
                this.sectionStart = this.index + 1;
            }
        } else {
            this.sequenceIndex = 0;
            this.state = $ac9b791c5e3389db$var$State.InDeclaration;
            this.stateInDeclaration(c); // Reconsume the character
        }
    }
    /**
     * When we wait for one specific character, we can speed things up
     * by skipping through the buffer until we find it.
     *
     * @returns Whether the character was found.
     */ fastForwardTo(c) {
        while(++this.index < this.buffer.length + this.offset){
            if (this.buffer.charCodeAt(this.index - this.offset) === c) return true;
        }
        /*
         * We increment the index at the end of the `parse` loop,
         * so set it to `buffer.length - 1` here.
         *
         * TODO: Refactor `parse` to increment index before calling states.
         */ this.index = this.buffer.length + this.offset - 1;
        return false;
    }
    /**
     * Comments and CDATA end with `-->` and `]]>`.
     *
     * Their common qualities are:
     * - Their end sequences have a distinct character they start with.
     * - That character is then repeated, so we have to check multiple repeats.
     * - All characters but the start character of the sequence can be skipped.
     */ stateInCommentLike(c) {
        if (c === this.currentSequence[this.sequenceIndex]) {
            if (++this.sequenceIndex === this.currentSequence.length) {
                if (this.currentSequence === $ac9b791c5e3389db$var$Sequences.CdataEnd) this.cbs.oncdata(this.sectionStart, this.index, 2);
                else this.cbs.oncomment(this.sectionStart, this.index, 2);
                this.sequenceIndex = 0;
                this.sectionStart = this.index + 1;
                this.state = $ac9b791c5e3389db$var$State.Text;
            }
        } else if (this.sequenceIndex === 0) // Fast-forward to the first character of the sequence
        {
            if (this.fastForwardTo(this.currentSequence[0])) this.sequenceIndex = 1;
        } else if (c !== this.currentSequence[this.sequenceIndex - 1]) // Allow long sequences, eg. --->, ]]]>
        this.sequenceIndex = 0;
    }
    /**
     * HTML only allows ASCII alpha characters (a-z and A-Z) at the beginning of a tag name.
     *
     * XML allows a lot more characters here (@see https://www.w3.org/TR/REC-xml/#NT-NameStartChar).
     * We allow anything that wouldn't end the tag.
     */ isTagStartChar(c) {
        return this.xmlMode ? !$ac9b791c5e3389db$var$isEndOfTagSection(c) : $ac9b791c5e3389db$var$isASCIIAlpha(c);
    }
    startSpecial(sequence, offset) {
        this.isSpecial = true;
        this.currentSequence = sequence;
        this.sequenceIndex = offset;
        this.state = $ac9b791c5e3389db$var$State.SpecialStartSequence;
    }
    stateBeforeTagName(c) {
        if (c === $ac9b791c5e3389db$var$CharCodes.ExclamationMark) {
            this.state = $ac9b791c5e3389db$var$State.BeforeDeclaration;
            this.sectionStart = this.index + 1;
        } else if (c === $ac9b791c5e3389db$var$CharCodes.Questionmark) {
            this.state = $ac9b791c5e3389db$var$State.InProcessingInstruction;
            this.sectionStart = this.index + 1;
        } else if (this.isTagStartChar(c)) {
            const lower = c | 0x20;
            this.sectionStart = this.index;
            if (!this.xmlMode && lower === $ac9b791c5e3389db$var$Sequences.TitleEnd[2]) this.startSpecial($ac9b791c5e3389db$var$Sequences.TitleEnd, 3);
            else this.state = !this.xmlMode && lower === $ac9b791c5e3389db$var$Sequences.ScriptEnd[2] ? $ac9b791c5e3389db$var$State.BeforeSpecialS : $ac9b791c5e3389db$var$State.InTagName;
        } else if (c === $ac9b791c5e3389db$var$CharCodes.Slash) this.state = $ac9b791c5e3389db$var$State.BeforeClosingTagName;
        else {
            this.state = $ac9b791c5e3389db$var$State.Text;
            this.stateText(c);
        }
    }
    stateInTagName(c) {
        if ($ac9b791c5e3389db$var$isEndOfTagSection(c)) {
            this.cbs.onopentagname(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.state = $ac9b791c5e3389db$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        }
    }
    stateBeforeClosingTagName(c) {
        if ($ac9b791c5e3389db$var$isWhitespace(c)) ;
        else if (c === $ac9b791c5e3389db$var$CharCodes.Gt) this.state = $ac9b791c5e3389db$var$State.Text;
        else {
            this.state = this.isTagStartChar(c) ? $ac9b791c5e3389db$var$State.InClosingTagName : $ac9b791c5e3389db$var$State.InSpecialComment;
            this.sectionStart = this.index;
        }
    }
    stateInClosingTagName(c) {
        if (c === $ac9b791c5e3389db$var$CharCodes.Gt || $ac9b791c5e3389db$var$isWhitespace(c)) {
            this.cbs.onclosetag(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.state = $ac9b791c5e3389db$var$State.AfterClosingTagName;
            this.stateAfterClosingTagName(c);
        }
    }
    stateAfterClosingTagName(c) {
        // Skip everything until ">"
        if (c === $ac9b791c5e3389db$var$CharCodes.Gt || this.fastForwardTo($ac9b791c5e3389db$var$CharCodes.Gt)) {
            this.state = $ac9b791c5e3389db$var$State.Text;
            this.baseState = $ac9b791c5e3389db$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeAttributeName(c) {
        if (c === $ac9b791c5e3389db$var$CharCodes.Gt) {
            this.cbs.onopentagend(this.index);
            if (this.isSpecial) {
                this.state = $ac9b791c5e3389db$var$State.InSpecialTag;
                this.sequenceIndex = 0;
            } else this.state = $ac9b791c5e3389db$var$State.Text;
            this.baseState = this.state;
            this.sectionStart = this.index + 1;
        } else if (c === $ac9b791c5e3389db$var$CharCodes.Slash) this.state = $ac9b791c5e3389db$var$State.InSelfClosingTag;
        else if (!$ac9b791c5e3389db$var$isWhitespace(c)) {
            this.state = $ac9b791c5e3389db$var$State.InAttributeName;
            this.sectionStart = this.index;
        }
    }
    stateInSelfClosingTag(c) {
        if (c === $ac9b791c5e3389db$var$CharCodes.Gt) {
            this.cbs.onselfclosingtag(this.index);
            this.state = $ac9b791c5e3389db$var$State.Text;
            this.baseState = $ac9b791c5e3389db$var$State.Text;
            this.sectionStart = this.index + 1;
            this.isSpecial = false; // Reset special state, in case of self-closing special tags
        } else if (!$ac9b791c5e3389db$var$isWhitespace(c)) {
            this.state = $ac9b791c5e3389db$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        }
    }
    stateInAttributeName(c) {
        if (c === $ac9b791c5e3389db$var$CharCodes.Eq || $ac9b791c5e3389db$var$isEndOfTagSection(c)) {
            this.cbs.onattribname(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.state = $ac9b791c5e3389db$var$State.AfterAttributeName;
            this.stateAfterAttributeName(c);
        }
    }
    stateAfterAttributeName(c) {
        if (c === $ac9b791c5e3389db$var$CharCodes.Eq) this.state = $ac9b791c5e3389db$var$State.BeforeAttributeValue;
        else if (c === $ac9b791c5e3389db$var$CharCodes.Slash || c === $ac9b791c5e3389db$var$CharCodes.Gt) {
            this.cbs.onattribend($ac9b791c5e3389db$export$cbf5509cea2ad22.NoValue, this.index);
            this.state = $ac9b791c5e3389db$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        } else if (!$ac9b791c5e3389db$var$isWhitespace(c)) {
            this.cbs.onattribend($ac9b791c5e3389db$export$cbf5509cea2ad22.NoValue, this.index);
            this.state = $ac9b791c5e3389db$var$State.InAttributeName;
            this.sectionStart = this.index;
        }
    }
    stateBeforeAttributeValue(c) {
        if (c === $ac9b791c5e3389db$var$CharCodes.DoubleQuote) {
            this.state = $ac9b791c5e3389db$var$State.InAttributeValueDq;
            this.sectionStart = this.index + 1;
        } else if (c === $ac9b791c5e3389db$var$CharCodes.SingleQuote) {
            this.state = $ac9b791c5e3389db$var$State.InAttributeValueSq;
            this.sectionStart = this.index + 1;
        } else if (!$ac9b791c5e3389db$var$isWhitespace(c)) {
            this.sectionStart = this.index;
            this.state = $ac9b791c5e3389db$var$State.InAttributeValueNq;
            this.stateInAttributeValueNoQuotes(c); // Reconsume token
        }
    }
    handleInAttributeValue(c, quote) {
        if (c === quote || !this.decodeEntities && this.fastForwardTo(quote)) {
            this.cbs.onattribdata(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.cbs.onattribend(quote === $ac9b791c5e3389db$var$CharCodes.DoubleQuote ? $ac9b791c5e3389db$export$cbf5509cea2ad22.Double : $ac9b791c5e3389db$export$cbf5509cea2ad22.Single, this.index);
            this.state = $ac9b791c5e3389db$var$State.BeforeAttributeName;
        } else if (this.decodeEntities && c === $ac9b791c5e3389db$var$CharCodes.Amp) {
            this.baseState = this.state;
            this.state = $ac9b791c5e3389db$var$State.BeforeEntity;
        }
    }
    stateInAttributeValueDoubleQuotes(c) {
        this.handleInAttributeValue(c, $ac9b791c5e3389db$var$CharCodes.DoubleQuote);
    }
    stateInAttributeValueSingleQuotes(c) {
        this.handleInAttributeValue(c, $ac9b791c5e3389db$var$CharCodes.SingleQuote);
    }
    stateInAttributeValueNoQuotes(c) {
        if ($ac9b791c5e3389db$var$isWhitespace(c) || c === $ac9b791c5e3389db$var$CharCodes.Gt) {
            this.cbs.onattribdata(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.cbs.onattribend($ac9b791c5e3389db$export$cbf5509cea2ad22.Unquoted, this.index);
            this.state = $ac9b791c5e3389db$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        } else if (this.decodeEntities && c === $ac9b791c5e3389db$var$CharCodes.Amp) {
            this.baseState = this.state;
            this.state = $ac9b791c5e3389db$var$State.BeforeEntity;
        }
    }
    stateBeforeDeclaration(c) {
        if (c === $ac9b791c5e3389db$var$CharCodes.OpeningSquareBracket) {
            this.state = $ac9b791c5e3389db$var$State.CDATASequence;
            this.sequenceIndex = 0;
        } else this.state = c === $ac9b791c5e3389db$var$CharCodes.Dash ? $ac9b791c5e3389db$var$State.BeforeComment : $ac9b791c5e3389db$var$State.InDeclaration;
    }
    stateInDeclaration(c) {
        if (c === $ac9b791c5e3389db$var$CharCodes.Gt || this.fastForwardTo($ac9b791c5e3389db$var$CharCodes.Gt)) {
            this.cbs.ondeclaration(this.sectionStart, this.index);
            this.state = $ac9b791c5e3389db$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    }
    stateInProcessingInstruction(c) {
        if (c === $ac9b791c5e3389db$var$CharCodes.Gt || this.fastForwardTo($ac9b791c5e3389db$var$CharCodes.Gt)) {
            this.cbs.onprocessinginstruction(this.sectionStart, this.index);
            this.state = $ac9b791c5e3389db$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeComment(c) {
        if (c === $ac9b791c5e3389db$var$CharCodes.Dash) {
            this.state = $ac9b791c5e3389db$var$State.InCommentLike;
            this.currentSequence = $ac9b791c5e3389db$var$Sequences.CommentEnd;
            // Allow short comments (eg. <!-->)
            this.sequenceIndex = 2;
            this.sectionStart = this.index + 1;
        } else this.state = $ac9b791c5e3389db$var$State.InDeclaration;
    }
    stateInSpecialComment(c) {
        if (c === $ac9b791c5e3389db$var$CharCodes.Gt || this.fastForwardTo($ac9b791c5e3389db$var$CharCodes.Gt)) {
            this.cbs.oncomment(this.sectionStart, this.index, 0);
            this.state = $ac9b791c5e3389db$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeSpecialS(c) {
        const lower = c | 0x20;
        if (lower === $ac9b791c5e3389db$var$Sequences.ScriptEnd[3]) this.startSpecial($ac9b791c5e3389db$var$Sequences.ScriptEnd, 4);
        else if (lower === $ac9b791c5e3389db$var$Sequences.StyleEnd[3]) this.startSpecial($ac9b791c5e3389db$var$Sequences.StyleEnd, 4);
        else {
            this.state = $ac9b791c5e3389db$var$State.InTagName;
            this.stateInTagName(c); // Consume the token again
        }
    }
    stateBeforeEntity(c) {
        // Start excess with 1 to include the '&'
        this.entityExcess = 1;
        this.entityResult = 0;
        if (c === $ac9b791c5e3389db$var$CharCodes.Number) this.state = $ac9b791c5e3389db$var$State.BeforeNumericEntity;
        else if (c === $ac9b791c5e3389db$var$CharCodes.Amp) ;
        else {
            this.trieIndex = 0;
            this.trieCurrent = this.entityTrie[0];
            this.state = $ac9b791c5e3389db$var$State.InNamedEntity;
            this.stateInNamedEntity(c);
        }
    }
    stateInNamedEntity(c) {
        this.entityExcess += 1;
        this.trieIndex = (0, $14589e7572d0431f$exports.determineBranch)(this.entityTrie, this.trieCurrent, this.trieIndex + 1, c);
        if (this.trieIndex < 0) {
            this.emitNamedEntity();
            this.index--;
            return;
        }
        this.trieCurrent = this.entityTrie[this.trieIndex];
        const masked = this.trieCurrent & (0, $14589e7572d0431f$exports.BinTrieFlags).VALUE_LENGTH;
        // If the branch is a value, store it and continue
        if (masked) {
            // The mask is the number of bytes of the value, including the current byte.
            const valueLength = (masked >> 14) - 1;
            // If we have a legacy entity while parsing strictly, just skip the number of bytes
            if (!this.allowLegacyEntity() && c !== $ac9b791c5e3389db$var$CharCodes.Semi) this.trieIndex += valueLength;
            else {
                // Add 1 as we have already incremented the excess
                const entityStart = this.index - this.entityExcess + 1;
                if (entityStart > this.sectionStart) this.emitPartial(this.sectionStart, entityStart);
                // If this is a surrogate pair, consume the next two bytes
                this.entityResult = this.trieIndex;
                this.trieIndex += valueLength;
                this.entityExcess = 0;
                this.sectionStart = this.index + 1;
                if (valueLength === 0) this.emitNamedEntity();
            }
        }
    }
    emitNamedEntity() {
        this.state = this.baseState;
        if (this.entityResult === 0) return;
        const valueLength = (this.entityTrie[this.entityResult] & (0, $14589e7572d0431f$exports.BinTrieFlags).VALUE_LENGTH) >> 14;
        switch(valueLength){
            case 1:
                this.emitCodePoint(this.entityTrie[this.entityResult] & ~(0, $14589e7572d0431f$exports.BinTrieFlags).VALUE_LENGTH);
                break;
            case 2:
                this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
                break;
            case 3:
                this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
                this.emitCodePoint(this.entityTrie[this.entityResult + 2]);
        }
    }
    stateBeforeNumericEntity(c) {
        if ((c | 0x20) === $ac9b791c5e3389db$var$CharCodes.LowerX) {
            this.entityExcess++;
            this.state = $ac9b791c5e3389db$var$State.InHexEntity;
        } else {
            this.state = $ac9b791c5e3389db$var$State.InNumericEntity;
            this.stateInNumericEntity(c);
        }
    }
    emitNumericEntity(strict) {
        const entityStart = this.index - this.entityExcess - 1;
        const numberStart = entityStart + 2 + Number(this.state === $ac9b791c5e3389db$var$State.InHexEntity);
        if (numberStart !== this.index) {
            // Emit leading data if any
            if (entityStart > this.sectionStart) this.emitPartial(this.sectionStart, entityStart);
            this.sectionStart = this.index + Number(strict);
            this.emitCodePoint((0, $14589e7572d0431f$exports.replaceCodePoint)(this.entityResult));
        }
        this.state = this.baseState;
    }
    stateInNumericEntity(c) {
        if (c === $ac9b791c5e3389db$var$CharCodes.Semi) this.emitNumericEntity(true);
        else if ($ac9b791c5e3389db$var$isNumber(c)) {
            this.entityResult = this.entityResult * 10 + (c - $ac9b791c5e3389db$var$CharCodes.Zero);
            this.entityExcess++;
        } else {
            if (this.allowLegacyEntity()) this.emitNumericEntity(false);
            else this.state = this.baseState;
            this.index--;
        }
    }
    stateInHexEntity(c) {
        if (c === $ac9b791c5e3389db$var$CharCodes.Semi) this.emitNumericEntity(true);
        else if ($ac9b791c5e3389db$var$isNumber(c)) {
            this.entityResult = this.entityResult * 16 + (c - $ac9b791c5e3389db$var$CharCodes.Zero);
            this.entityExcess++;
        } else if ($ac9b791c5e3389db$var$isHexDigit(c)) {
            this.entityResult = this.entityResult * 16 + ((c | 0x20) - $ac9b791c5e3389db$var$CharCodes.LowerA + 10);
            this.entityExcess++;
        } else {
            if (this.allowLegacyEntity()) this.emitNumericEntity(false);
            else this.state = this.baseState;
            this.index--;
        }
    }
    allowLegacyEntity() {
        return !this.xmlMode && (this.baseState === $ac9b791c5e3389db$var$State.Text || this.baseState === $ac9b791c5e3389db$var$State.InSpecialTag);
    }
    /**
     * Remove data that has already been consumed from the buffer.
     */ cleanup() {
        // If we are inside of text or attributes, emit what we already have.
        if (this.running && this.sectionStart !== this.index) {
            if (this.state === $ac9b791c5e3389db$var$State.Text || this.state === $ac9b791c5e3389db$var$State.InSpecialTag && this.sequenceIndex === 0) {
                this.cbs.ontext(this.sectionStart, this.index);
                this.sectionStart = this.index;
            } else if (this.state === $ac9b791c5e3389db$var$State.InAttributeValueDq || this.state === $ac9b791c5e3389db$var$State.InAttributeValueSq || this.state === $ac9b791c5e3389db$var$State.InAttributeValueNq) {
                this.cbs.onattribdata(this.sectionStart, this.index);
                this.sectionStart = this.index;
            }
        }
    }
    shouldContinue() {
        return this.index < this.buffer.length + this.offset && this.running;
    }
    /**
     * Iterates through the buffer, calling the function corresponding to the current state.
     *
     * States that are more likely to be hit are higher up, as a performance improvement.
     */ parse() {
        while(this.shouldContinue()){
            const c = this.buffer.charCodeAt(this.index - this.offset);
            switch(this.state){
                case $ac9b791c5e3389db$var$State.Text:
                    this.stateText(c);
                    break;
                case $ac9b791c5e3389db$var$State.SpecialStartSequence:
                    this.stateSpecialStartSequence(c);
                    break;
                case $ac9b791c5e3389db$var$State.InSpecialTag:
                    this.stateInSpecialTag(c);
                    break;
                case $ac9b791c5e3389db$var$State.CDATASequence:
                    this.stateCDATASequence(c);
                    break;
                case $ac9b791c5e3389db$var$State.InAttributeValueDq:
                    this.stateInAttributeValueDoubleQuotes(c);
                    break;
                case $ac9b791c5e3389db$var$State.InAttributeName:
                    this.stateInAttributeName(c);
                    break;
                case $ac9b791c5e3389db$var$State.InCommentLike:
                    this.stateInCommentLike(c);
                    break;
                case $ac9b791c5e3389db$var$State.InSpecialComment:
                    this.stateInSpecialComment(c);
                    break;
                case $ac9b791c5e3389db$var$State.BeforeAttributeName:
                    this.stateBeforeAttributeName(c);
                    break;
                case $ac9b791c5e3389db$var$State.InTagName:
                    this.stateInTagName(c);
                    break;
                case $ac9b791c5e3389db$var$State.InClosingTagName:
                    this.stateInClosingTagName(c);
                    break;
                case $ac9b791c5e3389db$var$State.BeforeTagName:
                    this.stateBeforeTagName(c);
                    break;
                case $ac9b791c5e3389db$var$State.AfterAttributeName:
                    this.stateAfterAttributeName(c);
                    break;
                case $ac9b791c5e3389db$var$State.InAttributeValueSq:
                    this.stateInAttributeValueSingleQuotes(c);
                    break;
                case $ac9b791c5e3389db$var$State.BeforeAttributeValue:
                    this.stateBeforeAttributeValue(c);
                    break;
                case $ac9b791c5e3389db$var$State.BeforeClosingTagName:
                    this.stateBeforeClosingTagName(c);
                    break;
                case $ac9b791c5e3389db$var$State.AfterClosingTagName:
                    this.stateAfterClosingTagName(c);
                    break;
                case $ac9b791c5e3389db$var$State.BeforeSpecialS:
                    this.stateBeforeSpecialS(c);
                    break;
                case $ac9b791c5e3389db$var$State.InAttributeValueNq:
                    this.stateInAttributeValueNoQuotes(c);
                    break;
                case $ac9b791c5e3389db$var$State.InSelfClosingTag:
                    this.stateInSelfClosingTag(c);
                    break;
                case $ac9b791c5e3389db$var$State.InDeclaration:
                    this.stateInDeclaration(c);
                    break;
                case $ac9b791c5e3389db$var$State.BeforeDeclaration:
                    this.stateBeforeDeclaration(c);
                    break;
                case $ac9b791c5e3389db$var$State.BeforeComment:
                    this.stateBeforeComment(c);
                    break;
                case $ac9b791c5e3389db$var$State.InProcessingInstruction:
                    this.stateInProcessingInstruction(c);
                    break;
                case $ac9b791c5e3389db$var$State.InNamedEntity:
                    this.stateInNamedEntity(c);
                    break;
                case $ac9b791c5e3389db$var$State.BeforeEntity:
                    this.stateBeforeEntity(c);
                    break;
                case $ac9b791c5e3389db$var$State.InHexEntity:
                    this.stateInHexEntity(c);
                    break;
                case $ac9b791c5e3389db$var$State.InNumericEntity:
                    this.stateInNumericEntity(c);
                    break;
                default:
                    // `this._state === State.BeforeNumericEntity`
                    this.stateBeforeNumericEntity(c);
            }
            this.index++;
        }
        this.cleanup();
    }
    finish() {
        if (this.state === $ac9b791c5e3389db$var$State.InNamedEntity) this.emitNamedEntity();
        // If there is remaining data, emit it in a reasonable way
        if (this.sectionStart < this.index) this.handleTrailingData();
        this.cbs.onend();
    }
    /** Handle any trailing data. */ handleTrailingData() {
        const endIndex = this.buffer.length + this.offset;
        if (this.state === $ac9b791c5e3389db$var$State.InCommentLike) {
            if (this.currentSequence === $ac9b791c5e3389db$var$Sequences.CdataEnd) this.cbs.oncdata(this.sectionStart, endIndex, 0);
            else this.cbs.oncomment(this.sectionStart, endIndex, 0);
        } else if (this.state === $ac9b791c5e3389db$var$State.InNumericEntity && this.allowLegacyEntity()) this.emitNumericEntity(false);
        else if (this.state === $ac9b791c5e3389db$var$State.InHexEntity && this.allowLegacyEntity()) this.emitNumericEntity(false);
        else if (this.state === $ac9b791c5e3389db$var$State.InTagName || this.state === $ac9b791c5e3389db$var$State.BeforeAttributeName || this.state === $ac9b791c5e3389db$var$State.BeforeAttributeValue || this.state === $ac9b791c5e3389db$var$State.AfterAttributeName || this.state === $ac9b791c5e3389db$var$State.InAttributeName || this.state === $ac9b791c5e3389db$var$State.InAttributeValueSq || this.state === $ac9b791c5e3389db$var$State.InAttributeValueDq || this.state === $ac9b791c5e3389db$var$State.InAttributeValueNq || this.state === $ac9b791c5e3389db$var$State.InClosingTagName) ;
        else this.cbs.ontext(this.sectionStart, endIndex);
    }
    emitPartial(start, endIndex) {
        if (this.baseState !== $ac9b791c5e3389db$var$State.Text && this.baseState !== $ac9b791c5e3389db$var$State.InSpecialTag) this.cbs.onattribdata(start, endIndex);
        else this.cbs.ontext(start, endIndex);
    }
    emitCodePoint(cp) {
        if (this.baseState !== $ac9b791c5e3389db$var$State.Text && this.baseState !== $ac9b791c5e3389db$var$State.InSpecialTag) this.cbs.onattribentity(cp);
        else this.cbs.ontextentity(cp);
    }
}



const $065103589019dad1$var$formTags = new Set([
    "input",
    "option",
    "optgroup",
    "select",
    "button",
    "datalist",
    "textarea"
]);
const $065103589019dad1$var$pTag = new Set([
    "p"
]);
const $065103589019dad1$var$tableSectionTags = new Set([
    "thead",
    "tbody"
]);
const $065103589019dad1$var$ddtTags = new Set([
    "dd",
    "dt"
]);
const $065103589019dad1$var$rtpTags = new Set([
    "rt",
    "rp"
]);
const $065103589019dad1$var$openImpliesClose = new Map([
    [
        "tr",
        new Set([
            "tr",
            "th",
            "td"
        ])
    ],
    [
        "th",
        new Set([
            "th"
        ])
    ],
    [
        "td",
        new Set([
            "thead",
            "th",
            "td"
        ])
    ],
    [
        "body",
        new Set([
            "head",
            "link",
            "script"
        ])
    ],
    [
        "li",
        new Set([
            "li"
        ])
    ],
    [
        "p",
        $065103589019dad1$var$pTag
    ],
    [
        "h1",
        $065103589019dad1$var$pTag
    ],
    [
        "h2",
        $065103589019dad1$var$pTag
    ],
    [
        "h3",
        $065103589019dad1$var$pTag
    ],
    [
        "h4",
        $065103589019dad1$var$pTag
    ],
    [
        "h5",
        $065103589019dad1$var$pTag
    ],
    [
        "h6",
        $065103589019dad1$var$pTag
    ],
    [
        "select",
        $065103589019dad1$var$formTags
    ],
    [
        "input",
        $065103589019dad1$var$formTags
    ],
    [
        "output",
        $065103589019dad1$var$formTags
    ],
    [
        "button",
        $065103589019dad1$var$formTags
    ],
    [
        "datalist",
        $065103589019dad1$var$formTags
    ],
    [
        "textarea",
        $065103589019dad1$var$formTags
    ],
    [
        "option",
        new Set([
            "option"
        ])
    ],
    [
        "optgroup",
        new Set([
            "optgroup",
            "option"
        ])
    ],
    [
        "dd",
        $065103589019dad1$var$ddtTags
    ],
    [
        "dt",
        $065103589019dad1$var$ddtTags
    ],
    [
        "address",
        $065103589019dad1$var$pTag
    ],
    [
        "article",
        $065103589019dad1$var$pTag
    ],
    [
        "aside",
        $065103589019dad1$var$pTag
    ],
    [
        "blockquote",
        $065103589019dad1$var$pTag
    ],
    [
        "details",
        $065103589019dad1$var$pTag
    ],
    [
        "div",
        $065103589019dad1$var$pTag
    ],
    [
        "dl",
        $065103589019dad1$var$pTag
    ],
    [
        "fieldset",
        $065103589019dad1$var$pTag
    ],
    [
        "figcaption",
        $065103589019dad1$var$pTag
    ],
    [
        "figure",
        $065103589019dad1$var$pTag
    ],
    [
        "footer",
        $065103589019dad1$var$pTag
    ],
    [
        "form",
        $065103589019dad1$var$pTag
    ],
    [
        "header",
        $065103589019dad1$var$pTag
    ],
    [
        "hr",
        $065103589019dad1$var$pTag
    ],
    [
        "main",
        $065103589019dad1$var$pTag
    ],
    [
        "nav",
        $065103589019dad1$var$pTag
    ],
    [
        "ol",
        $065103589019dad1$var$pTag
    ],
    [
        "pre",
        $065103589019dad1$var$pTag
    ],
    [
        "section",
        $065103589019dad1$var$pTag
    ],
    [
        "table",
        $065103589019dad1$var$pTag
    ],
    [
        "ul",
        $065103589019dad1$var$pTag
    ],
    [
        "rt",
        $065103589019dad1$var$rtpTags
    ],
    [
        "rp",
        $065103589019dad1$var$rtpTags
    ],
    [
        "tbody",
        $065103589019dad1$var$tableSectionTags
    ],
    [
        "tfoot",
        $065103589019dad1$var$tableSectionTags
    ]
]);
const $065103589019dad1$var$voidElements = new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
]);
const $065103589019dad1$var$foreignContextElements = new Set([
    "math",
    "svg"
]);
const $065103589019dad1$var$htmlIntegrationElements = new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignobject",
    "desc",
    "title"
]);
const $065103589019dad1$var$reNameEnd = /\s|\//;
class $065103589019dad1$export$7acfa6ed01010e37 {
    constructor(cbs, options = {}){
        var _a, _b, _c, _d, _e;
        this.options = options;
        /** The start index of the last event. */ this.startIndex = 0;
        /** The end index of the last event. */ this.endIndex = 0;
        /**
         * Store the start index of the current open tag,
         * so we can update the start index for attributes.
         */ this.openTagStart = 0;
        this.tagname = "";
        this.attribname = "";
        this.attribvalue = "";
        this.attribs = null;
        this.stack = [];
        this.foreignContext = [];
        this.buffers = [];
        this.bufferOffset = 0;
        /** The index of the last written buffer. Used when resuming after a `pause()`. */ this.writeIndex = 0;
        /** Indicates whether the parser has finished running / `.end` has been called. */ this.ended = false;
        this.cbs = cbs !== null && cbs !== void 0 ? cbs : {};
        this.lowerCaseTagNames = (_a = options.lowerCaseTags) !== null && _a !== void 0 ? _a : !options.xmlMode;
        this.lowerCaseAttributeNames = (_b = options.lowerCaseAttributeNames) !== null && _b !== void 0 ? _b : !options.xmlMode;
        this.tokenizer = new ((_c = options.Tokenizer) !== null && _c !== void 0 ? _c : (0, $ac9b791c5e3389db$export$2e2bcd8739ae039))(this.options, this);
        (_e = (_d = this.cbs).onparserinit) === null || _e === void 0 || _e.call(_d, this);
    }
    // Tokenizer event handlers
    /** @internal */ ontext(start, endIndex) {
        var _a, _b;
        const data = this.getSlice(start, endIndex);
        this.endIndex = endIndex - 1;
        (_b = (_a = this.cbs).ontext) === null || _b === void 0 || _b.call(_a, data);
        this.startIndex = endIndex;
    }
    /** @internal */ ontextentity(cp) {
        var _a, _b;
        /*
         * Entities can be emitted on the character, or directly after.
         * We use the section start here to get accurate indices.
         */ const index = this.tokenizer.getSectionStart();
        this.endIndex = index - 1;
        (_b = (_a = this.cbs).ontext) === null || _b === void 0 || _b.call(_a, (0, $14589e7572d0431f$exports.fromCodePoint)(cp));
        this.startIndex = index;
    }
    isVoidElement(name) {
        return !this.options.xmlMode && $065103589019dad1$var$voidElements.has(name);
    }
    /** @internal */ onopentagname(start, endIndex) {
        this.endIndex = endIndex;
        let name = this.getSlice(start, endIndex);
        if (this.lowerCaseTagNames) name = name.toLowerCase();
        this.emitOpenTag(name);
    }
    emitOpenTag(name) {
        var _a, _b, _c, _d;
        this.openTagStart = this.startIndex;
        this.tagname = name;
        const impliesClose = !this.options.xmlMode && $065103589019dad1$var$openImpliesClose.get(name);
        if (impliesClose) while(this.stack.length > 0 && impliesClose.has(this.stack[this.stack.length - 1])){
            const element = this.stack.pop();
            (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 || _b.call(_a, element, true);
        }
        if (!this.isVoidElement(name)) {
            this.stack.push(name);
            if ($065103589019dad1$var$foreignContextElements.has(name)) this.foreignContext.push(true);
            else if ($065103589019dad1$var$htmlIntegrationElements.has(name)) this.foreignContext.push(false);
        }
        (_d = (_c = this.cbs).onopentagname) === null || _d === void 0 || _d.call(_c, name);
        if (this.cbs.onopentag) this.attribs = {};
    }
    endOpenTag(isImplied) {
        var _a, _b;
        this.startIndex = this.openTagStart;
        if (this.attribs) {
            (_b = (_a = this.cbs).onopentag) === null || _b === void 0 || _b.call(_a, this.tagname, this.attribs, isImplied);
            this.attribs = null;
        }
        if (this.cbs.onclosetag && this.isVoidElement(this.tagname)) this.cbs.onclosetag(this.tagname, true);
        this.tagname = "";
    }
    /** @internal */ onopentagend(endIndex) {
        this.endIndex = endIndex;
        this.endOpenTag(false);
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ onclosetag(start, endIndex) {
        var _a, _b, _c, _d, _e, _f;
        this.endIndex = endIndex;
        let name = this.getSlice(start, endIndex);
        if (this.lowerCaseTagNames) name = name.toLowerCase();
        if ($065103589019dad1$var$foreignContextElements.has(name) || $065103589019dad1$var$htmlIntegrationElements.has(name)) this.foreignContext.pop();
        if (!this.isVoidElement(name)) {
            const pos = this.stack.lastIndexOf(name);
            if (pos !== -1) {
                if (this.cbs.onclosetag) {
                    let count = this.stack.length - pos;
                    while(count--)// We know the stack has sufficient elements.
                    this.cbs.onclosetag(this.stack.pop(), count !== 0);
                } else this.stack.length = pos;
            } else if (!this.options.xmlMode && name === "p") {
                // Implicit open before close
                this.emitOpenTag("p");
                this.closeCurrentTag(true);
            }
        } else if (!this.options.xmlMode && name === "br") {
            // We can't use `emitOpenTag` for implicit open, as `br` would be implicitly closed.
            (_b = (_a = this.cbs).onopentagname) === null || _b === void 0 || _b.call(_a, "br");
            (_d = (_c = this.cbs).onopentag) === null || _d === void 0 || _d.call(_c, "br", {}, true);
            (_f = (_e = this.cbs).onclosetag) === null || _f === void 0 || _f.call(_e, "br", false);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ onselfclosingtag(endIndex) {
        this.endIndex = endIndex;
        if (this.options.xmlMode || this.options.recognizeSelfClosing || this.foreignContext[this.foreignContext.length - 1]) {
            this.closeCurrentTag(false);
            // Set `startIndex` for next node
            this.startIndex = endIndex + 1;
        } else // Ignore the fact that the tag is self-closing.
        this.onopentagend(endIndex);
    }
    closeCurrentTag(isOpenImplied) {
        var _a, _b;
        const name = this.tagname;
        this.endOpenTag(isOpenImplied);
        // Self-closing tags will be on the top of the stack
        if (this.stack[this.stack.length - 1] === name) {
            // If the opening tag isn't implied, the closing tag has to be implied.
            (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 || _b.call(_a, name, !isOpenImplied);
            this.stack.pop();
        }
    }
    /** @internal */ onattribname(start, endIndex) {
        this.startIndex = start;
        const name = this.getSlice(start, endIndex);
        this.attribname = this.lowerCaseAttributeNames ? name.toLowerCase() : name;
    }
    /** @internal */ onattribdata(start, endIndex) {
        this.attribvalue += this.getSlice(start, endIndex);
    }
    /** @internal */ onattribentity(cp) {
        this.attribvalue += (0, $14589e7572d0431f$exports.fromCodePoint)(cp);
    }
    /** @internal */ onattribend(quote, endIndex) {
        var _a, _b;
        this.endIndex = endIndex;
        (_b = (_a = this.cbs).onattribute) === null || _b === void 0 || _b.call(_a, this.attribname, this.attribvalue, quote === (0, $ac9b791c5e3389db$export$cbf5509cea2ad22).Double ? '"' : quote === (0, $ac9b791c5e3389db$export$cbf5509cea2ad22).Single ? "'" : quote === (0, $ac9b791c5e3389db$export$cbf5509cea2ad22).NoValue ? undefined : null);
        if (this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname)) this.attribs[this.attribname] = this.attribvalue;
        this.attribvalue = "";
    }
    getInstructionName(value) {
        const index = value.search($065103589019dad1$var$reNameEnd);
        let name = index < 0 ? value : value.substr(0, index);
        if (this.lowerCaseTagNames) name = name.toLowerCase();
        return name;
    }
    /** @internal */ ondeclaration(start, endIndex) {
        this.endIndex = endIndex;
        const value = this.getSlice(start, endIndex);
        if (this.cbs.onprocessinginstruction) {
            const name = this.getInstructionName(value);
            this.cbs.onprocessinginstruction(`!${name}`, `!${value}`);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ onprocessinginstruction(start, endIndex) {
        this.endIndex = endIndex;
        const value = this.getSlice(start, endIndex);
        if (this.cbs.onprocessinginstruction) {
            const name = this.getInstructionName(value);
            this.cbs.onprocessinginstruction(`?${name}`, `?${value}`);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ oncomment(start, endIndex, offset) {
        var _a, _b, _c, _d;
        this.endIndex = endIndex;
        (_b = (_a = this.cbs).oncomment) === null || _b === void 0 || _b.call(_a, this.getSlice(start, endIndex - offset));
        (_d = (_c = this.cbs).oncommentend) === null || _d === void 0 || _d.call(_c);
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ oncdata(start, endIndex, offset) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        this.endIndex = endIndex;
        const value = this.getSlice(start, endIndex - offset);
        if (this.options.xmlMode || this.options.recognizeCDATA) {
            (_b = (_a = this.cbs).oncdatastart) === null || _b === void 0 || _b.call(_a);
            (_d = (_c = this.cbs).ontext) === null || _d === void 0 || _d.call(_c, value);
            (_f = (_e = this.cbs).oncdataend) === null || _f === void 0 || _f.call(_e);
        } else {
            (_h = (_g = this.cbs).oncomment) === null || _h === void 0 || _h.call(_g, `[CDATA[${value}]]`);
            (_k = (_j = this.cbs).oncommentend) === null || _k === void 0 || _k.call(_j);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ onend() {
        var _a, _b;
        if (this.cbs.onclosetag) {
            // Set the end index for all remaining tags
            this.endIndex = this.startIndex;
            for(let index = this.stack.length; index > 0; this.cbs.onclosetag(this.stack[--index], true));
        }
        (_b = (_a = this.cbs).onend) === null || _b === void 0 || _b.call(_a);
    }
    /**
     * Resets the parser to a blank state, ready to parse a new HTML document
     */ reset() {
        var _a, _b, _c, _d;
        (_b = (_a = this.cbs).onreset) === null || _b === void 0 || _b.call(_a);
        this.tokenizer.reset();
        this.tagname = "";
        this.attribname = "";
        this.attribs = null;
        this.stack.length = 0;
        this.startIndex = 0;
        this.endIndex = 0;
        (_d = (_c = this.cbs).onparserinit) === null || _d === void 0 || _d.call(_c, this);
        this.buffers.length = 0;
        this.bufferOffset = 0;
        this.writeIndex = 0;
        this.ended = false;
    }
    /**
     * Resets the parser, then parses a complete document and
     * pushes it to the handler.
     *
     * @param data Document to parse.
     */ parseComplete(data) {
        this.reset();
        this.end(data);
    }
    getSlice(start, end) {
        while(start - this.bufferOffset >= this.buffers[0].length)this.shiftBuffer();
        let slice = this.buffers[0].slice(start - this.bufferOffset, end - this.bufferOffset);
        while(end - this.bufferOffset > this.buffers[0].length){
            this.shiftBuffer();
            slice += this.buffers[0].slice(0, end - this.bufferOffset);
        }
        return slice;
    }
    shiftBuffer() {
        this.bufferOffset += this.buffers[0].length;
        this.writeIndex--;
        this.buffers.shift();
    }
    /**
     * Parses a chunk of data and calls the corresponding callbacks.
     *
     * @param chunk Chunk to parse.
     */ write(chunk) {
        var _a, _b;
        if (this.ended) {
            (_b = (_a = this.cbs).onerror) === null || _b === void 0 || _b.call(_a, new Error(".write() after done!"));
            return;
        }
        this.buffers.push(chunk);
        if (this.tokenizer.running) {
            this.tokenizer.write(chunk);
            this.writeIndex++;
        }
    }
    /**
     * Parses the end of the buffer and clears the stack, calls onend.
     *
     * @param chunk Optional final chunk to parse.
     */ end(chunk) {
        var _a, _b;
        if (this.ended) {
            (_b = (_a = this.cbs).onerror) === null || _b === void 0 || _b.call(_a, new Error(".end() after done!"));
            return;
        }
        if (chunk) this.write(chunk);
        this.ended = true;
        this.tokenizer.end();
    }
    /**
     * Pauses parsing. The parser won't emit events until `resume` is called.
     */ pause() {
        this.tokenizer.pause();
    }
    /**
     * Resumes parsing after `pause` was called.
     */ resume() {
        this.tokenizer.resume();
        while(this.tokenizer.running && this.writeIndex < this.buffers.length)this.tokenizer.write(this.buffers[this.writeIndex++]);
        if (this.ended) this.tokenizer.end();
    }
    /**
     * Alias of `write`, for backwards compatibility.
     *
     * @param chunk Chunk to parse.
     * @deprecated
     */ parseChunk(chunk) {
        this.write(chunk);
    }
    /**
     * Alias of `end`, for backwards compatibility.
     *
     * @param chunk Optional final chunk to parse.
     * @deprecated
     */ done(chunk) {
        this.end(chunk);
    }
}



var $273yd = parcelRequire("273yd");


var $1RLFx = parcelRequire("1RLFx");
parcelRequire("a45mF");
var $iG8B0 = parcelRequire("iG8B0");
function $b03c501a52759e28$export$b6a9369736b19f4d(data, options) {
    const handler = new (0, $273yd.DomHandler)(undefined, options);
    new (0, $065103589019dad1$export$7acfa6ed01010e37)(handler, options).end(data);
    return handler.root;
}
function $b03c501a52759e28$export$d66b332881d9723f(data, options) {
    return $b03c501a52759e28$export$b6a9369736b19f4d(data, options).children;
}
function $b03c501a52759e28$export$2bbd0317573b00fc(callback, options, elementCallback) {
    const handler = new (0, $273yd.DomHandler)(callback, options, elementCallback);
    return new (0, $065103589019dad1$export$7acfa6ed01010e37)(handler, options);
}
const $b03c501a52759e28$var$parseFeedDefaultOptions = {
    xmlMode: true
};
function $b03c501a52759e28$export$5267abf679cd576b(feed, options = $b03c501a52759e28$var$parseFeedDefaultOptions) {
    return (0, $iG8B0.getFeed)($b03c501a52759e28$export$d66b332881d9723f(feed, options));
}



var $8iuUi = parcelRequire("8iuUi");
const $9e9ed16b241ccfb8$var$parse = (0, $dbuHA.getParse)((content, options, isDocument, context)=>options.xmlMode || options._useHtmlParser2 ? (0, $b03c501a52759e28$export$b6a9369736b19f4d)(content, options) : (0, $39a32800143300a9$export$2f1ddab8b648d7f6)(content, options, isDocument, context));
const $9e9ed16b241ccfb8$export$11e63f7b0f3d9900 = (0, $b5f679c4131ed3ad$export$8b469b2b7efa8d79)($9e9ed16b241ccfb8$var$parse, (dom, options)=>options.xmlMode || options._useHtmlParser2 ? (0, $iwhG6.default)(dom, options) : (0, $39a32800143300a9$export$af75b43ff4abe814)(dom));
var /**
 * The default cheerio instance.
 *
 * @deprecated Use the function returned by `load` instead.
 */ $9e9ed16b241ccfb8$export$2e2bcd8739ae039 = $9e9ed16b241ccfb8$export$11e63f7b0f3d9900([]);
const { contains: $9e9ed16b241ccfb8$export$2344b14b097df817 } = $8iuUi;
const { merge: $9e9ed16b241ccfb8$export$4950aa0f605343fb } = $8iuUi;
const { parseHTML: $9e9ed16b241ccfb8$export$8a49393be2d55148 } = $8iuUi;
const { root: $9e9ed16b241ccfb8$export$e8e78c978b129247 } = $8iuUi;


var $93ad9ff3780244a1$export$2e2bcd8739ae039 = {};
// default options
const $93ad9ff3780244a1$var$$13b04019e035f7c9$var$defaultOptions = {
    // remove all tags
    stripTags: false,
    // postfix of the string
    ellipsis: "...",
    // decode html entities
    decodeEntities: false,
    // whether truncate by words
    byWords: false,
    // // truncate by words, set to true keep words
    // // set to number then truncate by word count
    // length: 0
    excludes: "",
    reserveLastWord: false,
    trimTheOnlyWord: false,
    keepWhitespaces: false // even if set true, continuous whitespace will count as one
};
const $93ad9ff3780244a1$var$$13b04019e035f7c9$var$astralRange = /\ud83c[\udffb-\udfff](?=\ud83c[\udffb-\udfff])|(?:[^\ud800-\udfff][\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]?|[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?)*/g;
// helper method
const $93ad9ff3780244a1$var$$13b04019e035f7c9$var$helper = {
    setup (length, options) {
        switch(typeof length){
            case "object":
                options = length;
                break;
            case "number":
                if (typeof options === "object") options.length = length;
                else options = {
                    length: length
                };
        }
        const fullOptions = this.extend(options, $93ad9ff3780244a1$var$$13b04019e035f7c9$var$defaultOptions);
        // if (typeof fullOptions.length !== 'number') throw new TypeError('truncate-html: options.length should be a number')
        if (fullOptions.excludes) {
            if (!Array.isArray(fullOptions.excludes)) fullOptions.excludes = [
                fullOptions.excludes
            ];
            fullOptions.excludes = fullOptions.excludes.join(",");
        }
        this.options = fullOptions;
        this.limit = fullOptions.length;
        this.ellipsis = fullOptions.ellipsis;
        this.keepWhitespaces = fullOptions.keepWhitespaces;
        this.reserveLastWord = fullOptions.reserveLastWord;
        this.trimTheOnlyWord = fullOptions.trimTheOnlyWord;
    },
    // extend obj with dft
    extend (obj, dft) {
        if (obj == null) obj = {};
        for(const k in dft){
            const v = dft[k];
            if (obj[k] != null) continue;
            obj[k] = v;
        }
        return obj;
    },
    // test a char whether a whitespace char
    isBlank (char) {
        return char === " " || char === "\f" || char === "\n" || char === "\r" || char === "	" || char === "\v" || char === "\xa0" || char === "\u2028" || char === "\u2029";
    },
    /**
   * truncate text
   * @param  {String}  text        text to truncate
   * @param  {Boolean} isLastNode  is last dom node, help to decide whether add ellipsis
   * @return {String}
   */ truncate (text, isLastNode) {
        if (!this.keepWhitespaces) text = text.replace(/\s+/g, " ");
        const byWords = this.options.byWords;
        const match = text.match($93ad9ff3780244a1$var$$13b04019e035f7c9$var$astralRange);
        const astralSafeCharacterArray = match === null ? [] : match;
        const strLen = match === null ? 0 : astralSafeCharacterArray.length;
        let idx = 0;
        let count = 0;
        let prevIsBlank = byWords;
        let curIsBlank = false;
        while(idx < strLen){
            curIsBlank = this.isBlank(astralSafeCharacterArray[idx++]);
            // keep same then continue
            if (byWords && prevIsBlank === curIsBlank) continue;
            if (count === this.limit) {
                // reserve trailing whitespace, only when prev is blank too
                if (prevIsBlank && curIsBlank) {
                    prevIsBlank = curIsBlank;
                    continue;
                }
                // fix idx because current char belong to next words which exceed the limit
                --idx;
                break;
            }
            if (byWords) curIsBlank || ++count;
            else curIsBlank && prevIsBlank || ++count;
            prevIsBlank = curIsBlank;
        }
        this.limit -= count;
        if (this.limit) return text;
        else {
            let str;
            if (byWords) str = text.substr(0, idx);
            else str = this.substr(astralSafeCharacterArray, idx);
            if (str === text) return isLastNode ? text : text + this.ellipsis;
            else return str + this.ellipsis;
        }
    },
    // deal with cut string in the middle of a word
    substr (astralSafeCharacterArray, len) {
        // var boundary, cutted, result
        const cutted = astralSafeCharacterArray.slice(0, len).join("");
        if (!this.reserveLastWord || astralSafeCharacterArray.length === len) return cutted;
        const boundary = astralSafeCharacterArray.slice(len - 1, len + 1).join("");
        // if truncate at word boundary, just return
        if (/\W/.test(boundary)) return cutted;
        if (typeof this.reserveLastWord === "number" && this.reserveLastWord < 0) {
            const result = cutted.replace(/\w+$/, "");
            // if the cutted is not the first and the only word
            //   then return result, or return the whole word
            if (!(result.length === 0 && cutted.length === this.options.length)) return result;
            if (this.trimTheOnlyWord) return cutted;
        }
        // set max exceeded to 10 if this.reserveLastWord is true or < 0
        const maxExceeded = this.reserveLastWord !== true && this.reserveLastWord > 0 ? this.reserveLastWord : 10;
        const mtc = astralSafeCharacterArray.slice(len).join("").match(/(\w+)/);
        const exceeded = mtc ? mtc[1] : "";
        return cutted + exceeded.substr(0, maxExceeded);
    }
};
/** return true if elem is CheerioStatic */ function $93ad9ff3780244a1$var$$13b04019e035f7c9$var$isCheerioInstance(elem) {
    return elem && elem.contains && elem.html && elem.parseHTML && true;
}
/**
 * truncate html
 * @method truncate(html, [length], [options])
 * @param  {String}         html    html string to truncate
 * @param  {Object|number}  length how many letters(words if `byWords` is true) you want reserve
 * @param  {Object|null}    options
 * @return {String}
 */ const $93ad9ff3780244a1$var$$13b04019e035f7c9$var$truncate = function(html, length, options) {
    $93ad9ff3780244a1$var$$13b04019e035f7c9$var$helper.setup(length, options);
    if (!html || isNaN($93ad9ff3780244a1$var$$13b04019e035f7c9$var$helper.limit) || $93ad9ff3780244a1$var$$13b04019e035f7c9$var$helper.limit <= 0 || $93ad9ff3780244a1$var$$13b04019e035f7c9$var$helper.limit === Infinity) return html;
    // if (helper.limit)
    let $;
    // support provied cheerio
    if ($93ad9ff3780244a1$var$$13b04019e035f7c9$var$isCheerioInstance(html)) $ = html;
    else //   <p>Lorem ipsum <p>dolor sit => <div><p>Lorem ipsum <p>dolor sit</div>
    $ = (0, $9e9ed16b241ccfb8$export$2e2bcd8739ae039).load(`${html}`, {
        decodeEntities: $93ad9ff3780244a1$var$$13b04019e035f7c9$var$helper.options.decodeEntities
    }, false);
    const $html = $.root();
    // remove excludes elements
    $93ad9ff3780244a1$var$$13b04019e035f7c9$var$helper.options.excludes && $html.find($93ad9ff3780244a1$var$$13b04019e035f7c9$var$helper.options.excludes).remove();
    // strip tags and get pure text
    if ($93ad9ff3780244a1$var$$13b04019e035f7c9$var$helper.options.stripTags) return $93ad9ff3780244a1$var$$13b04019e035f7c9$var$helper.truncate($html.text());
    const travelChildren = function($ele, isParentLastNode = true) {
        const contents = $ele.contents();
        const lastIdx = contents.length - 1;
        return contents.each(function(idx) {
            switch(this.type){
                case "text":
                    if (!$93ad9ff3780244a1$var$$13b04019e035f7c9$var$helper.limit) {
                        $(this).remove();
                        return;
                    }
                    this.data = $93ad9ff3780244a1$var$$13b04019e035f7c9$var$helper.truncate($(this).text(), isParentLastNode && idx === lastIdx);
                    break;
                case "tag":
                    if (!$93ad9ff3780244a1$var$$13b04019e035f7c9$var$helper.limit) $(this).remove();
                    else return travelChildren($(this), isParentLastNode && idx === lastIdx);
                    break;
                default:
                    // for comments
                    return $(this).remove();
            }
        });
    };
    travelChildren($html);
    return $html.html();
};
$93ad9ff3780244a1$var$$13b04019e035f7c9$var$truncate.setup = (options = {})=>{
    return Object.assign($93ad9ff3780244a1$var$$13b04019e035f7c9$var$defaultOptions, options);
};
// fix parcel exporting issue
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
$93ad9ff3780244a1$export$2e2bcd8739ae039 = $93ad9ff3780244a1$var$$13b04019e035f7c9$var$truncate;


const $37f612f69a78df3a$var$Pitchfork = {
    init: function(settings) {
        this.input = settings.input;
        this.indexURL = settings.indexURL || "/search-index.json";
        this.resultsNode = settings.resultsNode;
        this.highlightedResultNode;
        this.loadTemplate();
        this.addListeners();
    },
    loadTemplate: function() {
        // Get the template then remove it
        if (this.resultsNode.children.length === 1 && this.resultsNode.children[0].nodeName === "SCRIPT") this.resultsTemplate = this.resultsNode.children[0].innerHTML;
        else this.resultsTemplate = this.resultsNode.innerHTML;
        this.resultsNode.innerHTML = "";
    },
    addListeners: function() {
        this.input.addEventListener("keydown", (e)=>{
            if (e.keyCode === 38 && e.metaKey) {
                // Cmd + up
                e.preventDefault();
                this.setNodeActive(this.resultsNode.firstElementChild);
            } else if (e.keyCode === 38) {
                // Up
                e.preventDefault();
                this.highlightPrevResult();
            } else if (e.keyCode === 40 && e.metaKey) {
                // Cmd + down
                e.preventDefault();
                this.setNodeActive(this.resultsNode.lastElementChild);
            } else if (e.keyCode === 40) {
                // Down
                e.preventDefault();
                this.highlightNextResult();
            } else if (e.keyCode === 27) // Escape
            this.hideResults();
            else if (e.keyCode === 13) // Enter
            this.selectHighlighted();
        });
        this.input.addEventListener("keyup", (e)=>{
            // Ignore all arrows (no change in text), escape and enter
            if ([
                37,
                38,
                39,
                40,
                27,
                13
            ].includes(e.keyCode)) return;
            this.onSearchInputChange(e);
        });
        this.input.addEventListener("focusout", (e)=>{
            // If a link was clicked, ignore this
            if (e.relatedTarget && e.relatedTarget.nodeName === "A") return;
            this.hideResults();
        });
        this.input.addEventListener("focusin", (e)=>{
            if (!this.index) this.loadIndex();
        });
    },
    loadIndex: function() {
        const pf = this;
        // TODO catch 404 or fetch error
        fetch(this.indexURL).then((response)=>response.json()).then((data)=>{
            pf.searchContent = data.pages;
            pf.index = (0, (/*@__PURE__*/$parcel$interopDefault($3581ee5e9a4ae8b2$exports))).Index.load(data.lunr);
        });
    },
    hideResults: function() {
        this.resultsNode.style.display = "none";
    },
    showResults: function() {
        this.resultsNode.style.display = "";
    },
    onSearchInputChange: function() {
        this.renderResults([]);
        // Empty search stops here
        if (!this.input.value) {
            this.hideResults();
            return;
        }
        this.showResults();
        const searchResults = this.index.search(this.input.value);
        if (searchResults.length < 1) {
            this.renderResults([]);
            this.highlightedResultNode = null;
            return;
        }
        this.renderResults([]);
        const truncateLength = parseInt(this.resultsNode.getAttribute("data-pitchfork-truncate") || 100);
        const highlightClass = this.resultsNode.getAttribute("data-pitchfork-highlight-class") || "highlight";
        const pf = this;
        const results = searchResults.map(function(res) {
            const url = res.ref;
            var contentData = pf.searchContent[url];
            const highlights = {};
            pf.index.fields.forEach((f)=>{
                let text = contentData[f];
                if (!text) return;
                const ranges = [];
                let startIndex = 99999;
                Object.values(res.matchData.metadata).forEach((matchMetadata)=>{
                    if (!matchMetadata || !matchMetadata[f] || !matchMetadata[f].position) return;
                    matchMetadata[f].position.forEach((position)=>{
                        startIndex = Math.min(position[0], startIndex);
                        ranges.push({
                            start: position[0],
                            length: position[1]
                        });
                    });
                });
                const el = document.createElement("div");
                el.innerHTML = text;
                const instance = new (0, (/*@__PURE__*/$parcel$interopDefault($2ab1c991cdb4f4ac$exports)))(el);
                instance.markRanges(ranges, {
                    className: highlightClass
                });
                let final = el.innerHTML;
                if (contentData[f].length > truncateLength) {
                    if (startIndex > truncateLength / 3) // Only trim the beginning if there is a lot
                    final = final.substr(startIndex);
                    final = (0, $93ad9ff3780244a1$export$2e2bcd8739ae039)(final, truncateLength);
                }
                highlights[f] = final;
            });
            return {
                url: url,
                highlights: highlights,
                ...contentData
            };
        });
        this.renderResults(results);
        this.setNodeActive(this.resultsNode.firstElementChild);
    },
    setNodeActive: function(node) {
        const activeClass = this.resultsNode.getAttribute("data-pitchfork-active-class") || "active";
        if (!activeClass) return;
        const activeClasses = activeClass.split(" ");
        // Remove the previous highlight
        if (this.highlightedResultNode) this.highlightedResultNode.classList.remove(...activeClasses);
        // Highlight the new one
        node.classList.add(...activeClasses);
        this.highlightedResultNode = node;
        (0, $29db0e804895ff35$export$2e2bcd8739ae039)(this.highlightedResultNode, {
            behavior: "smooth",
            scrollMode: "if-needed"
        });
    },
    highlightNextResult: function() {
        const n = this.highlightedResultNode.nextElementSibling;
        if (n) this.setNodeActive(n);
    },
    highlightPrevResult: function() {
        const n = this.highlightedResultNode.previousElementSibling;
        if (n) this.setNodeActive(n);
    },
    selectHighlighted: function() {
        if (this.highlightedResultNode) window.location = this.highlightedResultNode.href;
    },
    renderResults: function(results) {
        this.resultsNode.innerHTML = (0, (/*@__PURE__*/$parcel$interopDefault($49c217790058dcc8$exports))).render(this.resultsTemplate, {
            results: results
        });
    }
};
window.Pitchfork = $37f612f69a78df3a$var$Pitchfork;
window.addEventListener("DOMContentLoaded", (event)=>{
    const input = document.querySelector("[data-pitchfork-input]");
    if (input) {
        const index = document.querySelector("[data-pitchfork-index-url]"); // can be on search, results, script
        const results = document.querySelector("[data-pitchfork-results]");
        window.Pitchfork.init({
            input: input,
            indexURL: index ? index.getAttribute("data-pitchfork-index-url") : null,
            resultsNode: results
        });
    }
});


(()=>{
    class e {
        constructor(e, s){
            e.parentNode && "PRE" === e.parentNode.tagName ? this.containerNode = e.parentNode : this.containerNode = e, "CODE" === e.tagName ? this.codeNode = e : this.codeNode = e.querySelector("code"), this.instanceClass = s.instanceClass, this.copyButtonClass = s.copyButtonClass, this.renderCopyButton = s.renderCopyButton;
            const t = function(e) {
                let s, t = e.trim().split("\n")[0];
                if (t.startsWith("#") ? s = t.substring(1).trimStart() : t.startsWith("//") && (s = t.substring(2).trimStart()), s) {
                    let e = /^(\S+\.\S+)?\s*(\(([^\)]+)\))?/.exec(s);
                    if (e) return {
                        filename: e[1] || "",
                        displayName: e[3] || ""
                    };
                }
                return {
                    filename: "",
                    displayName: ""
                };
            }(this.codeNode.innerText || "");
            this.filename = t.filename, this.displayName = t.displayName;
        }
        getNavName() {
            return this.filename && this.displayName ? `${this.filename} (${this.displayName})` : this.filename ? this.filename : this.displayName ? this.displayName : "";
        }
        getRememberName() {
            return this.displayName ? this.displayName : this.filename;
        }
        hasNav() {
            return this.filename || this.displayName;
        }
        render() {
            this.hasNav() && (this.codeNode.innerHTML = this.codeNode.innerHTML.trimStart().substring(this.codeNode.innerHTML.trimStart().indexOf("\n") + 1)), this.containerNode.classList.add("codeplus-instance"), this.instanceClass && this.containerNode.classList.add(...this.instanceClass.split(" "));
            const e = document.createElement("button");
            e.innerHTML = "Copy", this.renderCopyButton(e, this, !1), e.className = "codeplus-copy-btn " + this.copyButtonClass, e.addEventListener("click", ()=>{
                this.copyToClipboard(), e.innerHTML = "Copied!", this.renderCopyButton(e, this, !0), e.style.display = "inline-block", setTimeout(()=>{
                    e.innerHTML = "Copy", this.renderCopyButton(e, this, !1), e.style.display = "";
                }, 1e3);
            }), this.containerNode.appendChild(e);
        }
        copyToClipboard() {
            const e = document.createElement("textarea");
            e.value = this.codeNode.innerText, document.body.appendChild(e), e.select(), document.execCommand("copy"), e.remove();
        }
    }
    class s {
        constructor(e, s){
            this.instances = e, this.tabs = [], this.groupClass = s.groupClass, this.navClass = s.navClass, this.tabClass = s.tabClass, this.activeTabClass = s.activeTabClass, this.inactiveTabClass = s.inactiveTabClass, this.renderTab = s.renderTab, this.rememberTabSelections = s.rememberTabSelections, this.onRememberTabSelection = s.onRememberTabSelection;
        }
        showTab(e, s) {
            if (this.instances.forEach((s, t)=>{
                t === e ? (s.containerNode.style.display = "block", this.tabs[t].classList.add(...this.activeTabClass.split(" ")), this.tabs[t].classList.remove(...this.inactiveTabClass.split(" "))) : (s.containerNode.style.display = "none", this.tabs[t].classList.remove(...this.activeTabClass.split(" ")), this.tabs[t].classList.add(...this.inactiveTabClass.split(" ")));
            }), s && this.rememberTabSelections && this.tabs.length > 1) {
                const s = this.instances[e].getRememberName();
                !function(e) {
                    const s = t();
                    -1 !== s.indexOf(e) && s.splice(s.indexOf(e), 1);
                    s.unshift(e), s.length > 5 && s.splice(5);
                    localStorage.setItem("codeplusRememberedTabs", s.join(","));
                }(s), this.onRememberTabSelection(s);
            }
        }
        render() {
            let e = document.createElement("div");
            e.className = "codeplus codeplus-group " + this.groupClass, this.instances[0].containerNode.parentNode.insertBefore(e, this.instances[0].containerNode);
            let s = document.createElement("div");
            s.className = "codeplus-instances";
            let t = document.createElement("div");
            t.className = "codeplus-nav " + this.navClass, this.tabs = [], this.instances.forEach((e, t)=>{
                const a = document.createElement("button");
                a.className = "codeplus-tab " + this.tabClass, e.hasNav() && (a.innerText = e.getNavName(), a.addEventListener("click", ()=>{
                    this.showTab(t, !0);
                }), this.renderTab(a, e), this.tabs.push(a)), 0 === t ? a.classList.add(...this.activeTabClass.split(" ")) : (a.classList.add(...this.inactiveTabClass.split(" ")), e.containerNode.style.display = "none"), s.appendChild(e.containerNode);
            }), this.tabs.length > 0 && (this.tabs.forEach((e)=>{
                t.appendChild(e);
            }), this.loadRememberedTab(), e.appendChild(t)), e.appendChild(s), this.instances.forEach((e)=>{
                e.render();
            });
        }
        loadRememberedTab() {
            const e = t();
            var s = !1;
            for (const t of e){
                for(let e = 0; e < this.instances.length; e++)this.instances[e].getRememberName() === t && (this.showTab(e), s = !0);
                if (s) break;
            }
        }
    }
    function t() {
        const e = localStorage.getItem("codeplusRememberedTabs");
        return e ? e.split(",") : [];
    }
    var a = class {
        constructor(s){
            this.debug = s.debug || !1, this.selector = s.selector || "pre > code", this.rememberTabSelections = s.rememberTabSelections || !1, this.instanceClass = s.instanceClass || "", this.groupClass = s.groupClass || "", this.navClass = s.navClass || "", this.tabClass = s.tabClass || "", this.activeTabClass = s.activeTabClass || "active", this.inactiveTabClass = s.inactiveTabClass || "inactive", this.copyButtonClass = s.copyButtonClass || "", this.renderTab = s.renderTab || (()=>{}), this.renderCopyButton = s.renderCopyButton || (()=>{}), this.domNodes = document.querySelectorAll(this.selector), this.debug && console.log("Codeplus DOM nodes selected", this.domNodes), this.groups = this.getGroups(Array.from(this.domNodes).map((s)=>new e(s, {
                    instanceClass: this.instanceClass,
                    copyButtonClass: this.copyButtonClass,
                    renderCopyButton: this.renderCopyButton
                })));
        }
        getGroups(e) {
            let t = [], a = [];
            for(let s = 0; s < e.length; s++)0 === a.length || e[s].hasNav() && e[s].containerNode.previousElementSibling === a[a.length - 1].containerNode || (t.push(a), a = []), a.push(e[s]);
            t.push(a);
            const i = {
                groupClass: this.groupClass,
                navClass: this.navClass,
                tabClass: this.tabClass,
                activeTabClass: this.activeTabClass,
                inactiveTabClass: this.inactiveTabClass,
                renderTab: this.renderTab,
                rememberTabSelections: this.rememberTabSelections,
                onRememberTabSelection: this.onRememberTabSelection.bind(this)
            }, n = t.map((e)=>new s(e, i));
            return this.debug && console.log("Codeplus groups", n), n;
        }
        render() {
            this.insertCSS(), this.groups.forEach((e)=>{
                e.render();
            });
        }
        insertCSS() {
            let e = document.createElement("style");
            e.innerHTML = "\n.codeplus-nav {\n    display: flex;\n}\n.codeplus-instance {\n    position: relative;\n}\n.codeplus-copy-btn {\n    position: absolute;\n    top: 0.5rem;\n    right: 0.5rem;\n}\n", document.head.appendChild(e);
        }
        onRememberTabSelection(e) {
            this.groups.forEach((s)=>{
                const t = s.instances.findIndex((s)=>s.getRememberName() === e);
                -1 !== t && s.showTab(t);
            });
        }
    };
    window.Codeplus = a;
})();


// import { Fancybox } from "@fancyapps/ui"
// import "@fancyapps/ui/dist/fancybox.css";
// Fancybox.bind(".content a > img", {
//     // options
// });
// Use / to jump to the search bar
document.addEventListener("keydown", (event)=>{
    if (event.target === document.body && event.key === "/") {
        document.querySelector("[data-pitchfork-input]").focus();
        event.preventDefault();
        return;
    }
});
// Highlight links to the current page
for (const activeContainer of document.querySelectorAll("[data-active-url]")){
    const activeClass = activeContainer.getAttribute("data-active-url");
    for (const link of activeContainer.querySelectorAll("a[href='" + window.location.pathname + "']"))link.classList.add(activeClass);
}
// Dynamically populate the "on this page" links
const $27eb59f274e5b230$var$otp = document.querySelector("[data-on-this-page]");
if ($27eb59f274e5b230$var$otp) {
    const headings = document.querySelectorAll(".content h2[id], .content h3[id]");
    if (headings.length > 0) {
        const linkClass = $27eb59f274e5b230$var$otp.getAttribute("data-on-this-page");
        for (const heading of headings){
            const headingID = heading.getAttribute("id");
            const link = document.createElement("a");
            link.href = "#" + headingID;
            link.innerHTML = heading.innerText;
            link.className = linkClass;
            if (heading.tagName !== "H2") link.classList.add("pl-1");
            $27eb59f274e5b230$var$otp.appendChild(link);
        }
        $27eb59f274e5b230$var$otp.style.display = "";
    }
}
// Toggle classes based on scroll position
for (const el of document.querySelectorAll("[data-scroll-class]"))el.addEventListener("scroll", (event)=>{
    const scrollClass = event.target.getAttribute("data-scroll-class").split(" ");
    let hasScrollClass = true;
    for (const s of scrollClass)hasScrollClass = hasScrollClass && event.target.classList.contains(s);
    if (event.target.scrollTop === 0 && hasScrollClass) event.target.classList.remove(...scrollClass);
    else if (!hasScrollClass) event.target.classList.add(...scrollClass);
});
// Mobile nav
const $27eb59f274e5b230$var$sidebarToggle = document.querySelector("[data-toggle-sidebar]");
const $27eb59f274e5b230$var$sidebar = document.querySelector("[data-sidebar]");
const $27eb59f274e5b230$var$sidebarToggleClass = $27eb59f274e5b230$var$sidebarToggle.getAttribute("data-toggle-sidebar");
document.addEventListener("click", (event)=>{
    // Hide the sidebar if we click anywhere else
    if (!event.target.matches("[data-sidebar] *") && !$27eb59f274e5b230$var$sidebar.classList.contains($27eb59f274e5b230$var$sidebarToggleClass)) $27eb59f274e5b230$var$sidebar.classList.add($27eb59f274e5b230$var$sidebarToggleClass);
});
$27eb59f274e5b230$var$sidebarToggle.addEventListener("click", (event)=>{
    if ($27eb59f274e5b230$var$sidebar.classList.contains($27eb59f274e5b230$var$sidebarToggleClass)) {
        $27eb59f274e5b230$var$sidebar.classList.remove($27eb59f274e5b230$var$sidebarToggleClass);
        event.stopPropagation();
    }
});
// Allow clicks on h1, h2, h3 (without an <a>) and highlight them
// if the url navigates straight to an anchor #hash
for (const heading of document.querySelectorAll("h1[id], h2[id], h3[id]")){
    heading.classList.add("anchored-heading");
    heading.addEventListener("click", (event)=>{
        event.preventDefault();
        const hash = event.target.getAttribute("id");
        window.history.pushState(null, null, "#" + hash);
        window.dispatchEvent(new HashChangeEvent("hashchange"));
    });
}
const $27eb59f274e5b230$var$hash = window.location.hash;
if ($27eb59f274e5b230$var$hash) {
    const link = document.querySelector(".anchored-heading[id='" + $27eb59f274e5b230$var$hash.substr(1) + "']");
    if (link) link.classList.add("active-anchored-heading");
}

})();
//# sourceMappingURL=app.js.map
